<p>The <strong>Nuclear Power Plant Explorer</strong> is an interactive map providing detailed information on the world's nuclear power plants. Use the year slider to track the evolution of the global fleet from 1954 to the present day, filter by plant status and capacity, and explore country and plant-level statistics, charts, and timelines.</p>

<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8" /><meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" /><meta http-equiv="Content-Security-Policy" content="default-src 'self' https:; base-uri 'self'; object-src 'none'; img-src 'self' data: blob: https:; style-src 'self' 'unsafe-inline' https://unpkg.com https://fonts.googleapis.com; font-src 'self' data: https://fonts.gstatic.com; script-src 'self' 'unsafe-inline' https://unpkg.com; connect-src 'self' https://wna-data-worker.world-nuclear.workers.dev https://basemaps.cartocdn.com https://*.basemaps.cartocdn.com https://server.arcgisonline.com https://ibasemaps-api.arcgis.com https://static-map-tiles-api.arcgis.com https://tiles.maps.eox.at https://tiles.openfreemap.org https://fonts.googleapis.com https://fonts.gstatic.com; worker-src 'self' blob:; child-src blob:; frame-src https:; form-action 'self'; frame-ancestors 'self'; upgrade-insecure-requests"><meta name="referrer" content="strict-origin-when-cross-origin" /><meta http-equiv="Permissions-Policy" content="geolocation=(), microphone=(), camera=(), payment=()" />
<link crossorigin="" href="https://unpkg.com" rel="preconnect" />
<link href="https://fonts.googleapis.com" rel="preconnect" />
<link crossorigin="" href="https://fonts.gstatic.com" rel="preconnect" />
<link crossorigin="" href="https://ibasemaps-api.arcgis.com" rel="preconnect" />
<link crossorigin="" href="https://static-map-tiles-api.arcgis.com" rel="preconnect" />
<title>Nuclear Power Plant Explorer | World Nuclear Association</title>
<link crossorigin="anonymous" href="https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl.css" integrity="sha384-uTttxo/aOKbdE5RlD/SPzSDoDmNvGlUYPjONi2MN/b7c9HPSvW07OIuyP7uL6jxK" referrerpolicy="no-referrer" rel="stylesheet" />
<link crossorigin="anonymous" href="https://fonts.googleapis.com/css2?family=Muli:wght@400;600;700;800;900&amp;display=swap" referrerpolicy="no-referrer" rel="stylesheet" />
<style type="text/css">/* Nuclear Power Plant Explorer v5.7.144 - Fix deep link filter params not applying to map */
/* v5.7.90 - Move Electricity chart to first position */
/* v5.7.108 - Consistent expanded chart modal sizing */
/* v5.7.109 - Fix expanded chart close button displaced by Annual/Cumulative toggle */
/* --- 1. Global Styles --- */
body { font-family: 'Muli', sans-serif; margin: 0; padding: 0; background: #f8f9fa; }

.reactor-link-hover:hover { background: #f0f4ff !important; }

/* --- 1. Layout Shell (Desktop Sidebar) --- */
#map-shell {
    position: relative;
    width: 100%;
    height: 660px;
    display: flex;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    opacity: 0;
    transition: opacity 0.35s ease;
}

#map-shell.map-ready {
    opacity: 1;
}

#map-wrapper.skip-overlay #map-shell {
    opacity: 1;
}

#map-wrapper.mobile-fs-pending #map-shell {
    opacity: 0 !important;
    transition: none !important;
}

#map-wrapper.mobile-fs-pending.fullscreen #map-shell {
    opacity: 1 !important;
    transition: opacity 0.3s ease !important;
}

/* v5.7.126: Pure CSS flash prevention – hide map shell on mobile until fullscreen.
   This eliminates the race between first browser paint and JS adding mobile-fs-pending. */
@media (max-width: 600px), (hover: none) and (pointer: coarse) and (max-width: 900px) {
    #map-wrapper:not(.fullscreen):not(.mobile-hold-active):not(.skip-overlay) #map-shell {
        opacity: 0 !important;
    }
    #map-wrapper.fullscreen #map-shell {
        opacity: 1 !important;
        transition: opacity 0.25s ease !important;
    }
}

/* v5.7.156: Mobile direct-init loading overlay — keeps hold screen visible as a
   high-z-index overlay during in-place initialization. Unlike mobile-hold-active
   (which uses display:none on #map-shell), this keeps the shell visible behind
   the overlay so Leaflet can measure container dimensions correctly. */
#map-wrapper.mobile-direct-loading .mobile-hold {
    display: flex !important;
    position: fixed !important;
    inset: 0 !important;
    z-index: 99999 !important;
    background: #ffffff !important;
    transition: opacity 0.4s ease !important;
}
#map-wrapper.mobile-direct-loading.mobile-init-reveal .mobile-hold {
    opacity: 0 !important;
    pointer-events: none !important;
}

#map-sidebar {
    width: 280px;
    flex: 0 0 280px;
    border-right: 1px solid #e9ecef;
    background: #fbfcfd;
    position: relative;
    display: none;
    flex-direction: column;
    overflow: hidden; /* scroll lives in .sidebar-scroll so the toggle stays pinned */
    padding: 0;
}

.sidebar-scroll{
    flex: 1 1 auto;
    padding: 16px calc(14px + var(--sidebar-scrollbar-width, 0px)) 70px; /* leave room for the bottom toggle */
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    scrollbar-gutter: stable;
    -webkit-overflow-scrolling: touch;
    min-height: 0;
}

#map-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    position: relative;
}
/* View mode moved into Settings drawer */
.view-mode-wrapper{display:none !important;}
#viewDropdownWrapper{display:none !important;}

/* ===== Slim desktop rail + overlay drawers (Filters / Settings) ===== */
.map-rail-layout{
    flex: 1;
    display: flex;
    min-height: 0;
}

.map-stage{
    position: relative;
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* Full-height slim rail (sits left of map + timeline slider) */
.map-side-rail{
    width: 52px;
    height: 100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    gap: 10px;
    padding: 18px 8px;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(8px);
    border-right: 1px solid rgba(0,0,0,0.08);
}
.map-side-rail .rail-btn{
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 12px;
    background: transparent;
    color: #2d3436;
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
}
.map-side-rail .rail-btn svg{
    width: 18px;
    height: 18px;
}
.map-side-rail .rail-btn.active{
    background: #eef2ff;
    color: #2d3436;
}
.map-side-rail .rail-btn:hover{
    background: rgba(87,119,169,0.12);
}

.map-drawer-backdrop{
    position:absolute;
    inset:0;
    z-index: 1600;
    background: transparent; /* click-to-dismiss surface */
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.12s ease;
}
.map-drawer-backdrop.active{
    opacity: 1;
    pointer-events: auto;
}

.map-drawer{
    position:absolute;
    left: 20px;
    top: 20px;
    width: 300px;
    max-width: calc(100% - 40px);
    max-height: calc(100% - 40px);
    z-index: 1606;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 14px 34px rgba(0,0,0,0.18);
    overflow:hidden;
    border: 1px solid rgba(0,0,0,0.06);

    /* animated open/close */
    display:flex;
    flex-direction:column;
    opacity: 0;
    transform: translateX(-8px);
    pointer-events: none;
    visibility: hidden;
    transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
}
.map-drawer.open{
    opacity: 1;
    transform: translateX(0);
    pointer-events: auto;
    visibility: visible;
}

/* Tour drawer needs higher z-index to appear above tour overlay dimming */
#tourDrawer.open {
    z-index: 10001;
}

.map-drawer-header{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding: 12px 12px;
    border-bottom: 1px solid #f1f3f5;
}
.map-drawer-title{
    font-size: 10px;
    font-weight: 900;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.12em;
}
.map-drawer-close{
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 12px;
    background: transparent;
    color: #2d3436;
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
}
.map-drawer-close svg{
    width: 18px;
    height: 18px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
}
.map-drawer-close:hover{ background: rgba(0,0,0,0.06); }

.map-drawer-body{
    padding: 12px 12px 14px 12px;
    overflow:auto;
}

.map-drawer-section-label{
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #8898aa;
    margin: 2px 0 10px 0;
}

.map-drawer-divider{
    height: 1px;
    background: #f1f3f5;
    margin: 12px 0;
}

.map-drawer #darkModeOption{ display:block !important; }
#themeDrawer #darkModeOption{ display:block !important; }

/* Ensure labels toggle is visible in the drawer */
.map-drawer .labels-toggle-row,
#viewModeDrawer .labels-toggle-row {
    display: flex !important;
}
.map-drawer .labels-toggle-switch,
#viewModeDrawer .labels-toggle-switch {
    display: inline-block !important;
    position: relative !important;
    width: 40px !important;
    height: 22px !important;
}
.map-drawer .labels-toggle-slider,
#viewModeDrawer .labels-toggle-slider {
    display: block !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background-color: #ccc !important;
    border-radius: 22px !important;
    cursor: pointer !important;
}
.map-drawer .labels-toggle-slider:before,
#viewModeDrawer .labels-toggle-slider:before {
    content: "" !important;
    position: absolute !important;
    height: 16px !important;
    width: 16px !important;
    left: 3px !important;
    bottom: 3px !important;
    background-color: white !important;
    border-radius: 50% !important;
    transition: 0.2s !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2) !important;
}
.map-drawer .labels-toggle-switch input:checked + .labels-toggle-slider,
#viewModeDrawer .labels-toggle-switch input:checked + .labels-toggle-slider {
    background-color: #5777a9 !important;
}
.map-drawer .labels-toggle-switch input:checked + .labels-toggle-slider:before,
#viewModeDrawer .labels-toggle-switch input:checked + .labels-toggle-slider:before {
    transform: translateX(18px) !important;
}

/* Ensure dark mode toggle is visible in the drawer */
.map-drawer .dm-toggle-switch,
#themeDrawer .dm-toggle-switch {
    display: inline-block !important;
    position: relative !important;
    width: 44px !important;
    height: 24px !important;
}
.map-drawer .dm-toggle-slider,
#themeDrawer .dm-toggle-slider {
    display: block !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background-color: #dfe6e9 !important;
    border-radius: 24px !important;
    cursor: pointer !important;
    transition: 0.3s !important;
}
.map-drawer .dm-toggle-slider:before,
#themeDrawer .dm-toggle-slider:before {
    content: "" !important;
    position: absolute !important;
    height: 18px !important;
    width: 18px !important;
    left: 3px !important;
    bottom: 3px !important;
    background-color: white !important;
    border-radius: 50% !important;
    transition: 0.3s !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2) !important;
}
.map-drawer .dm-toggle-switch input:checked + .dm-toggle-slider,
#themeDrawer .dm-toggle-switch input:checked + .dm-toggle-slider {
    background-color: #5777a9 !important;
}
.map-drawer .dm-toggle-switch input:checked + .dm-toggle-slider:before,
#themeDrawer .dm-toggle-switch input:checked + .dm-toggle-slider:before {
    transform: translateX(20px) !important;
}

/* Ensure appearance toggle row is visible */
.map-drawer .appearance-toggle-row,
#themeDrawer .appearance-toggle-row {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    padding: 8px 4px !important;
}
.map-drawer .appearance-label,
#themeDrawer .appearance-label {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #2d3436 !important;
    flex: 1 !important;
}
.map-drawer .appearance-icon,
#themeDrawer .appearance-icon {
    width: 18px !important;
    height: 18px !important;
    color: #636e72 !important;
}
[data-theme="dark"] .map-drawer .appearance-label,
[data-theme="dark"] #themeDrawer .appearance-label {
    color: #e9ecef !important;
}
[data-theme="dark"] .map-drawer .appearance-icon,
[data-theme="dark"] #themeDrawer .appearance-icon {
    color: #adb5bd !important;
}

/* Make moved sidebar chunks fit nicely in the drawer */
.map-drawer .sidebar-filters-group{
    padding: 0;
}
.map-drawer .filter-subsection{
    padding: 0;
    margin-bottom: 12px;
}
.map-drawer .filter-subsection:last-child{
    margin-bottom: 0;
}

/* Dark theme */
[data-theme="dark"] .map-side-rail{
    border-right: 1px solid rgba(255,255,255,0.08);
    background: rgba(33,37,41,0.86);
    box-shadow: none;
}
[data-theme="dark"] .map-side-rail .rail-btn{ color: #e9ecef; }
[data-theme="dark"] .map-side-rail .rail-btn.active{
    background: rgba(87,119,169,0.28);
    color: #fff;
}
[data-theme="dark"] .map-drawer{
    background: #1f2230;
    border: 1px solid rgba(255,255,255,0.08);
    box-shadow: 0 14px 34px rgba(0,0,0,0.55);
}
[data-theme="dark"] .map-drawer-header{ border-bottom: 1px solid rgba(255,255,255,0.08); }
[data-theme="dark"] .map-drawer-close:hover{ background: rgba(255,255,255,0.08); }
[data-theme="dark"] .map-drawer-divider{ background: rgba(255,255,255,0.10); }

/* Hide the rail on small screens (mobile uses the existing dropdown UI) */
@media (max-width: 600px){
    .map-side-rail, .map-drawer, .map-drawer-backdrop{ display:none !important; }
}


.sidebar-brand {
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f3f5;
}

.sidebar-title {
    font-size: 16px;
    font-weight: 900;
    color: #2d3436;
    letter-spacing: -0.3px;
    margin: 0;
}

.sidebar-subtitle {
    margin-top: 4px;
    font-size: 11px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.sidebar-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sidebar-section-title {
    font-size: 10px;
    font-weight: 900;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.12em;
}


#map-sidebar .sidebar-section-title{
    display: flex;
    align-items: center;
    padding-bottom: 6px;
    border-bottom: 1px solid #f1f3f5;
    margin-bottom: 6px;
}
#map-sidebar .sidebar-section.is-filters .sidebar-section-title{
    color: #6b7c93;
}
.sidebar-section-hint {
    margin-top: -4px;
    font-size: 11px;
    font-weight: 700;
    color: #636e72;
    opacity: 0.8;
}


.control-label { display: none; }

/* Mount targets should stretch */
#sidebarSearchMount,
#sidebarFiltersMount,
#sidebarViewMount {
    width: 100%;
}

/* When controls are mounted in the sidebar, restyle them for a clean panel UI */
#map-sidebar .search-wrapper {
    width: 100%;
    position: relative; /* anchor absolutely-positioned results dropdown */
}

#map-sidebar .search-input {
    width: 100%;
    border-radius: 12px;
    box-shadow: none;
    border: 1px solid #e9ecef;
    background: #f8f9fa;
}

#map-sidebar .search-input:focus {
    box-shadow: 0 0 0 3px rgba(0,123,255,0.25);
}

/* Desktop search overlay (top-left of the map) */
.search-overlay{
    position:absolute;
    top:20px;
    left:20px;
    right:auto; /* top-left inside the map */
    z-index:1100;
    pointer-events:auto;
    /* Limit height: map is 600px, top offset 20px, legend ~100px from bottom, 20px buffer */
    max-height: min(460px, calc(100vh - 240px));
}

#desktopSearchOverlay{
    display: flex !important;
    flex-direction: row !important;
    gap: 10px;
    align-items: flex-start;
    flex-wrap: nowrap !important;
}

/* Ensure search wrapper doesn't expand to push status bar */
#desktopSearchOverlay > .search-wrapper {
    flex: 0 0 auto;
}

/* Status bar stays inline with search */
#desktopSearchOverlay > .map-status-bar {
    flex: 0 0 auto;
    display: inline-flex !important;
}

/* Desktop fullscreen: make plant/country info overlays responsive to #map-shell height */
@media (min-width: 601px){
    #map-wrapper.fullscreen #countryInfoOverlay,
    #map-wrapper.fullscreen #plantInfoOverlay{
        top: 20px;
        bottom: 140px;
        max-height: none;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }
    #map-wrapper.fullscreen #countryInfoOverlay .country-info-overlay,
    #map-wrapper.fullscreen #plantInfoOverlay .plant-info-overlay{
        flex: 1 1 auto;
        min-height: 0;
        max-height: none;
    }


    /* Plant detail modal (used in fullscreen on desktop) */
    #map-wrapper.fullscreen #plantDetailModal.plant-detail-modal{
        top: 20px;
        bottom: 140px;
        max-height: none;
    }
    #map-wrapper.fullscreen #plantDetailModal.plant-detail-modal .plant-detail-dialog{
        height: 100%;
        max-height: none;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
    #map-wrapper.fullscreen #plantDetailModal.plant-detail-modal .plant-detail-content{
        flex: 1 1 auto;
        min-height: 0;
        overflow: auto;
    }

}

@media (max-width: 600px){
    .search-overlay{ display:none; }
}
@media (min-width: 601px){
    .search-overlay{ display:block; }
    #desktopSearchOverlay{ display:flex; }
}

/* Mirror a modern, slightly transparent search box */
.search-overlay .search-wrapper{
    background: rgba(255,255,255,0.82);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 14px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.14);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    overflow: visible; /* allow dropdown results to extend beyond pill */
}
.search-overlay .search-wrapper::before{
    content: "";
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    opacity: 0.75;
    background-repeat: no-repeat;
    background-size: 18px 18px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%23555' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cpath d='m21 21-4.3-4.3'/%3E%3C/svg%3E");
    pointer-events: none;
}
.search-overlay .search-input{
    width: 380px;
    max-width: min(420px, calc(100vw - 460px));
    padding: 12px 44px 12px 44px; /* room for icon + clear button */
    background: transparent;
    border: none;
    border-radius: 14px;
    box-shadow: none !important;
}
.search-overlay .search-input:focus{
    box-shadow: none !important;
}
.search-overlay .search-wrapper:focus-within{
    box-shadow: 0 10px 28px rgba(0,0,0,0.14), 0 0 0 3px rgba(0,0,0,0.08);
}
.search-overlay .search-results{
    background: rgba(255,255,255,0.95);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    z-index: 1200;
}
.search-overlay .search-clear-btn{
    background: rgba(0,0,0,0.08);
}
.search-overlay .search-clear-btn:hover{
    background: rgba(0,0,0,0.12);
}

/* Country Info Overlay - replaces search box when country is selected */
.country-info-overlay {
    display: none;
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 14px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.14);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    width: 380px;
    max-width: min(420px, calc(100vw - 120px));
    max-height: 420px; /* Fixed max to prevent legend overlap in 600px map */
    overflow: hidden;
    font-family: 'Muli', sans-serif;
    display: flex;
    flex-direction: column;
}

.country-info-overlay.visible {
    display: flex;
}

.country-info-body {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
}

.country-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
}

.country-info-back {
    background: rgba(0,0,0,0.06);
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease;
    flex-shrink: 0;
}

.country-info-back:hover {
    background: rgba(0,0,0,0.1);
}

.country-info-back svg {
    width: 18px;
    height: 18px;
    stroke: #555;
}

.country-info-title-wrap {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.country-info-name {
    font-size: 28px;
    font-weight: 700;
    color: #5777a9 !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.05;
    letter-spacing: -0.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.country-info-label {
    font-size: 11px;
    font-weight: 800;
    color: #2d3436;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    line-height: 1.1;
    opacity: 0.9;
}

.country-info-stats-header {
    font-size: 9px;
    font-weight: 800;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    padding: 8px 14px 0;
    background: rgba(0,0,0,0.02);
}

.country-info-stats {
    display: flex;
    padding: 0;
    background: rgba(0,0,0,0.02);
}

.country-info-stat {
    flex: 1;
    padding: 12px 8px;
    text-align: center;
    border-right: 1px solid rgba(0,0,0,0.06);
}

.country-info-stat:last-child {
    border-right: none;
}

.country-info-stat-value {
    font-size: 18px;
    font-weight: 800;
    line-height: 1;
}

.country-info-stat-value.green { color: #00b894; }
.country-info-stat-value.yellow { color: #fdcb6e; }
.country-info-stat-value.blue { color: #74b9ff; }
.country-info-stat-value.grey { color: #636e72; }

.country-info-stat-label {
    font-size: 9px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-top: 4px;
}

.country-info-capacity {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-top: 1px solid rgba(0,0,0,0.06);
    background: rgba(0,0,0,0.02);
}

.country-info-capacity-label {
    font-size: 9px;
    font-weight: 800;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

.country-info-capacity-value {
    font-size: 13px;
    font-weight: 800;
    color: #2d3436;
    margin-left: auto;
}

.country-info-plants-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background: none;
    border: none;
    border-top: 1px solid rgba(0,0,0,0.06);
    width: 100%;
    cursor: pointer;
    font-family: 'Muli', sans-serif;
    transition: background 0.15s ease;
}

.country-info-plants-toggle:hover {
    background: rgba(0,0,0,0.03);
}

.country-info-plants-toggle-text {
    font-size: 12px;
    font-weight: 700;
    color: #5777a9;
}

.country-info-plants-toggle svg {
    width: 16px;
    height: 16px;
    stroke: #5777a9;
    transition: transform 0.2s ease;
}

.country-info-plants-toggle.expanded svg {
    transform: rotate(180deg);
}

.country-info-plants-list {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease, padding 0.2s ease;
    background: #fff;
    padding: 0 14px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.country-info-plants-list.expanded {
    max-height: 220px;
    overflow-y: auto;
    padding: 12px 14px 14px;
}

.country-info-plant-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
    transition: all 0.15s ease;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    background: #f8f9fa;
}

.country-info-plant-item:hover {
    border-color: #5777a9;
    background: #f8f9ff;
}

.country-info-plant-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.country-info-plant-dot.green { background: #00b894; }
.country-info-plant-dot.yellow { background: #fdcb6e; }
.country-info-plant-dot.blue { background: #74b9ff; }
.country-info-plant-dot.grey { background: #636e72; }

.country-info-plant-name {
    flex: 1;
    font-size: 13px;
    font-weight: 700;
    color: #2d3436;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.country-info-plant-capacity {
    font-size: 12px;
    font-weight: 700;
    color: #636e72;
    flex-shrink: 0;
}


/* Country detail content (charts - visible in fullscreen) */
.country-detail-content {
    display: none;
    padding: 14px 16px 16px 16px;
}

#map-wrapper.fullscreen .country-detail-content {
    display: block;
}

/* Reactor Deployment Chart - diverging bar chart */
.reactor-deploy-chart {
    position: relative;
    width: 100%;
    background: #fff;
    border: 1px solid #eef2f6;
    border-radius: 12px;
    overflow: visible;
    margin-top: 8px;
    padding: 12px;
    box-sizing: border-box;
}

.reactor-deploy-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 8px;
}

.reactor-deploy-legend {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.reactor-deploy-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #636e72;
}

.reactor-deploy-legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 2px;
}

.reactor-deploy-legend-dot.connections {
    background: #00b894;
}

.reactor-deploy-legend-dot.shutdowns {
    background: #636e72;
}

.reactor-deploy-toggle {
    display: flex;
    background: #f1f3f5;
    border-radius: 6px;
    padding: 2px;
    gap: 2px;
}

.reactor-deploy-toggle-btn {
    padding: 4px 10px;
    font-size: 10px;
    font-weight: 700;
    color: #636e72;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.reactor-deploy-toggle-btn.active {
    background: #fff;
    color: #2d3436;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.reactor-deploy-toggle-btn:hover:not(.active) {
    color: #2d3436;
}

.reactor-deploy-container {
    position: relative;
    width: 100%;
    height: 200px;
}

.reactor-deploy-svg {
    width: 100%;
    height: 100%;
}

.reactor-deploy-bar {
    cursor: pointer;
    transition: opacity 0.15s ease;
}

.reactor-deploy-bar:hover {
    opacity: 0.85;
}

.reactor-deploy-bar.dimmed {
    opacity: 0.2;
}

.reactor-deploy-axis-line {
    stroke: #e9ecef;
    stroke-width: 1;
}

.reactor-deploy-zero-line {
    stroke: #dfe6e9;
    stroke-width: 2;
}

.reactor-deploy-grid-line {
    stroke: #f1f3f5;
    stroke-width: 1;
}

.reactor-deploy-axis-label {
    font-family: 'Muli', sans-serif;
    font-size: 10px;
    font-weight: 600;
    fill: #8898aa;
}

.reactor-deploy-tooltip {
    position: absolute;
    background: rgba(45, 52, 54, 0.95);
    color: #fff;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-family: 'Muli', sans-serif;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
    z-index: 1000;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.reactor-deploy-tooltip.visible {
    opacity: 1;
}

/* v5.7.81: Timeline sidebar deploy chart (mini diverging bar chart) */
.timeline-deploy-chart {
    width: 100%;
    height: 180px;
    position: relative;
    cursor: crosshair;
    overflow: hidden;
}
.timeline-deploy-chart .reactor-deploy-svg {
    width: 100%;
    height: 100%;
}
.timeline-deploy-chart .reactor-deploy-bar {
    cursor: crosshair;
}
.timeline-deploy-chart .deploy-highlight-line {
    stroke-dasharray: 3 3;
    pointer-events: none;
}
.timeline-deploy-chart .deploy-hover-line {
    pointer-events: none;
}

[data-theme="dark"] .timeline-deploy-chart .deploy-highlight-line {
    stroke: rgba(255,255,255,0.4);
}
[data-theme="dark"] .timeline-deploy-chart .deploy-hover-line {
    stroke: rgba(255,255,255,0.7);
}

/* Plant Info Overlay - replaces search box when plant is selected */
.plant-info-overlay {
    display: none;
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 14px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.14);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    width: 380px;
    max-width: min(420px, calc(100vw - 120px));
    max-height: 420px; /* Fixed max to prevent legend overlap in 600px map */
    overflow: hidden;
    font-family: 'Muli', sans-serif;
    display: flex;
    flex-direction: column;
}

.plant-info-overlay.visible {
    display: flex;
}

.plant-info-body {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
}

.plant-info-header {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
}

.plant-info-back {
    background: rgba(0,0,0,0.06);
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease;
    flex-shrink: 0;
}

.plant-info-back:hover {
    background: rgba(0,0,0,0.1);
}

.plant-info-back svg {
    width: 18px;
    height: 18px;
    stroke: #555;
}

.plant-info-title-wrap {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.plant-info-name {
    font-size: 28px;
    font-weight: 700;
    color: #5777a9 !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.05;
    letter-spacing: -0.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.plant-info-country {
    font-size: 11px;
    font-weight: 800;
    color: #2d3436;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    margin-top: 0;
    line-height: 1.1;
    cursor: pointer;
    opacity: 0.9;
    transition: color 0.15s ease, opacity 0.15s ease;
}

.plant-info-country:hover {
    color: #5777a9;
}

.plant-info-status-badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
}

.plant-info-status-badge.green {
    background: rgba(0, 184, 148, 0.15);
    color: #00b894;
}

.plant-info-status-badge.yellow {
    background: rgba(253, 203, 110, 0.3);
    color: #e17055;
}

.plant-info-status-badge.blue {
    background: rgba(116, 185, 255, 0.15);
    color: #74b9ff;
}

.plant-info-status-badge.grey {
    background: rgba(99, 110, 114, 0.15);
    color: #636e72;
}

.plant-info-stats {
    display: flex;
    padding: 0;
    background: rgba(0,0,0,0.02);
}

.plant-info-stat {
    flex: 1;
    padding: 12px 8px;
    text-align: center;
    border-right: 1px solid rgba(0,0,0,0.06);
}

.plant-info-stat:last-child {
    border-right: none;
}

.plant-info-stat-value {
    font-size: 18px;
    font-weight: 800;
    line-height: 1;
    color: #2d3436;
}

.plant-info-stat-label {
    font-size: 9px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-top: 4px;
}


/* Plant Info Reactors (Desktop overlay) */
.plant-info-reactors-toggle {
    width: 100%;
    border: none;
    background: #fff;
    padding: 10px 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 700;
    color: #2d3436;
    border-top: 1px solid rgba(0,0,0,0.06);
    border-bottom: 1px solid rgba(0,0,0,0.06);
}
.plant-info-reactors-toggle:hover { background: rgba(0,0,0,0.02); }
.plant-info-reactors-toggle svg {
    width: 16px;
    height: 16px;
    color: #8898aa;
    transition: transform 0.15s ease;
}
.plant-info-reactors-toggle.expanded svg { transform: rotate(180deg); }

.plant-info-reactors-list {
    max-height: 0;
    overflow: hidden;
    background: #fff;
    transition: max-height 0.2s ease;
}
.plant-info-reactors-list.expanded {
    max-height: 180px;
    min-height: 60px; /* Ensure single reactor items are fully visible */
    overflow-y: auto;
}

.plant-info-reactor-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-top: 1px solid rgba(0,0,0,0.04);
    text-decoration: none !important;
    color: inherit;
}
.plant-info-reactor-item:hover { background: rgba(87, 119, 169, 0.08); }
.plant-info-reactor-item:visited { color: inherit; }

/* Ensure theme link styles don't underline reactor rows */
.plant-info-reactor-link,
.plant-info-reactor-link:visited,
.plant-info-reactor-link:hover,
.plant-info-reactor-link:active,
.plant-info-reactor-link:focus {
    text-decoration: none !important;
}
.plant-info-reactor-link *,
.plant-info-reactor-link *:visited,
.plant-info-reactor-link *:hover,
.plant-info-reactor-link *:active,
.plant-info-reactor-link *:focus {
    text-decoration: none !important;
}

/* Mobile popups: reactor list links should not be underlined */
.plant-popup .reactor-section a,
.plant-popup .reactor-section a:visited,
.plant-popup .reactor-section a:hover,
.plant-popup .reactor-section a:active,
.plant-popup .reactor-section a:focus {
    text-decoration: none !important;
}
.plant-popup .reactor-section a * {
    text-decoration: none !important;
}

/* Plant hover tooltip (desktop) */
.plant-hover-tooltip { pointer-events: none; }
.plant-hover-tooltip .maplibregl-popup-content {
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(0,0,0,0.08);
    box-shadow: 0 10px 28px rgba(0,0,0,0.14);
    border-radius: 14px;
    padding: 10px 12px;
    color: #2d3436;
    font-family: 'Muli', sans-serif;
    pointer-events: none;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.plant-hover-tooltip.maplibregl-popup-anchor-bottom .maplibregl-popup-tip { border-top-color: rgba(255,255,255,0.92); }
.plant-hover-tooltip.maplibregl-popup-anchor-top .maplibregl-popup-tip { border-bottom-color: rgba(255,255,255,0.92); }
.plant-hover-tooltip.maplibregl-popup-anchor-left .maplibregl-popup-tip { border-right-color: rgba(255,255,255,0.92); }
.plant-hover-tooltip.maplibregl-popup-anchor-right .maplibregl-popup-tip { border-left-color: rgba(255,255,255,0.92); }

.plant-hover-tooltip .pht-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 2px;
}

.plant-hover-tooltip .pht-country {
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #5777a9;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.plant-hover-tooltip .pht-badge {
    font-size: 11px;
    font-weight: 800;
    padding: 3px 10px;
    border-radius: 999px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
    border: 1px solid rgba(0,0,0,0.06);
}

.plant-hover-tooltip .pht-badge.green { background: rgba(0,184,148,0.12); color: #00b894; }
.plant-hover-tooltip .pht-badge.yellow { background: rgba(253,203,110,0.18); color: #d18900; }
.plant-hover-tooltip .pht-badge.blue { background: rgba(116,185,255,0.15); color: #74b9ff; }
.plant-hover-tooltip .pht-badge.grey { background: rgba(99,110,114,0.14); color: #636e72; }

.plant-hover-tooltip .pht-name {
    font-size: 16px;
    font-weight: 900;
    line-height: 1.15;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.plant-hover-tooltip .pht-meta {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    font-size: 12px;
    font-weight: 700;
    color: #636e72;
}

.plant-hover-tooltip .pht-meta span {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
}

.plant-hover-tooltip .pht-meta b {
    font-weight: 900;
    color: #2d3436;
}


.plant-info-reactor-link { cursor: pointer; }
.plant-info-reactor-link:focus { outline: 2px solid rgba(87, 119, 169, 0.45); outline-offset: 2px; border-radius: 10px; }

.plant-info-reactor-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.plant-info-reactor-dot.green { background: #00b894; }
.plant-info-reactor-dot.yellow { background: #fdcb6e; }
.plant-info-reactor-dot.blue { background: #74b9ff; }
.plant-info-reactor-dot.grey { background: #636e72; }

.plant-info-reactor-info { flex: 1; min-width: 0; }
.plant-info-reactor-name {
    font-size: 13px;
    font-weight: 700;
    color: #2d3436 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.plant-info-reactor-details {
    font-size: 11px;
    font-weight: 600;
    color: #8898aa;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.plant-info-reactor-capacity { font-size: 12px; font-weight: 700; color: #8898aa; flex-shrink: 0; text-align: right; }
.plant-info-reactor-chevron { width: 14px; height: 14px; flex-shrink: 0; opacity: 0.6; color: #5777a9; }

/* Plant info (non-fullscreen) reactor link button */
.plant-info-reactor-linkout {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.06);
    background: #f8f9fa;
    color: #5777a9;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none !important;
    flex-shrink: 0;
    margin-left: 6px;
    transition: background 0.15s ease, color 0.15s ease;
}
.plant-info-reactor-linkout:hover {
    background: #5777a9;
    color: #ffffff;
}
.plant-info-reactor-linkout svg {
    width: 14px;
    height: 14px;
}

/* Plant detail (fullscreen) reactor list: expandable items */
.plant-detail-reactor-item {
    border-top: 1px solid rgba(0,0,0,0.04);
}
.plant-detail-reactor-head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
}
.plant-detail-reactor-item:hover .plant-detail-reactor-head {
    background: rgba(87, 119, 169, 0.08);
}
.plant-detail-reactor-head:focus {
    outline: 2px solid rgba(87, 119, 169, 0.45);
    outline-offset: -2px;
    border-radius: 10px;
}
.plant-detail-reactor-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}
.plant-detail-reactor-expand-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    opacity: 0.6;
    color: #5777a9;
    transition: transform 0.18s ease;
}
.plant-detail-reactor-item.expanded .plant-detail-reactor-expand-icon {
    transform: rotate(180deg);
}

.plant-detail-reactor-linkout {
    width: 30px;
    height: 30px;
    border-radius: 10px;
    border: 1px solid rgba(0,0,0,0.06);
    background: #f8f9fa;
    color: #5777a9;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none !important;
    flex-shrink: 0;
    transition: background 0.15s ease, color 0.15s ease;
}
.plant-detail-reactor-linkout:hover {
    background: #5777a9;
    color: #ffffff;
}
.plant-detail-reactor-linkout svg { width: 14px; height: 14px; }

.plant-detail-reactor-extra {
    display: none;
    padding: 0 14px 12px 14px;
}
.plant-detail-reactor-item.expanded .plant-detail-reactor-extra {
    display: block;
}

.plant-detail-reactor-extra-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 14px;
    padding-top: 2px;
}
.plant-detail-field-label {
    font-size: 9px;
    font-weight: 800;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}
.plant-detail-field-value {
    font-size: 12px;
    font-weight: 700;
    color: #2d3436;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 720px) {
    .plant-detail-reactor-extra-grid { grid-template-columns: 1fr; }
}


/* Sidebar map-controls group becomes a vertical stack */
#map-sidebar .map-controls-group {
    position: static;
    top: auto;
    right: auto;
    z-index: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: none;
    border-radius: 0;
}

/* Show view options as an always-visible list in the sidebar */
#map-sidebar #viewModeBtn {
    display: none;
}

#map-sidebar .view-mode-popup {
    position: static;
    top: auto;
    right: auto;
    display: block;
    opacity: 1;
    transform: none;
    padding: 0;
    background: transparent;
    box-shadow: none;
    min-width: 0;
}

#map-sidebar .view-mode-popup::after {
    display: none;
}

#map-sidebar .view-mode-option {
    border: 1px solid #e9ecef;
    background: #fff;
    border-radius: 10px;
    padding: 10px 12px;
    margin-top: 8px;
}

#map-sidebar .view-mode-option:first-child {
    margin-top: 0;
}

#map-sidebar .view-mode-option.active {
    background: rgba(87, 119, 169, 0.12);
    border-color: rgba(87, 119, 169, 0.35);
}

/* Filters panel should be readable in the sidebar */
#map-sidebar #filtersToggle {
    display: none;
}

#map-sidebar #filtersWrapper {
    display: block !important; /* Always show in sidebar; disabled outside Present via JS */
}

#map-sidebar #filtersPanel {
    position: static;
    display: block !important;
    max-height: none !important;
    opacity: 1 !important;
    padding: 0 !important;
    overflow: visible !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    background: transparent !important;
}

#map-sidebar #filtersPanel::before {
    display: none;
}

#map-sidebar #filtersWrapper.sidebar-disabled {
    opacity: 0.55;
    pointer-events: none;
    filter: grayscale(20%);
}

#map-sidebar .sidebar-display-options.sidebar-disabled,
#map-sidebar .sidebar-filters-group.sidebar-disabled {
    opacity: 0.55;
    pointer-events: none;
    filter: grayscale(20%);
}

/* Disabled state for filters/settings when not at Present year */
.filters-disabled {
    opacity: 0.55;
    pointer-events: none;
    filter: grayscale(20%);
}
.filters-disabled input,
.filters-disabled button,
.filters-disabled label {
    cursor: not-allowed;
}

/* Disabled state for theme button when dark mode not available */
.theme-disabled {
    opacity: 0.55;
    pointer-events: none;
    filter: grayscale(20%);
}
.theme-disabled input,
.theme-disabled button,
.theme-disabled label {
    cursor: not-allowed;
}



/* Sidebar Map View dropdown – compact, sidebar-native styling */
#map-sidebar .view-dropdown-wrapper {
    display: block !important;
}

#map-sidebar #viewDropdownToggle.dropdown-btn {
    width: 100%;
    height: 44px;
    justify-content: space-between;
    padding: 0 12px;
    border-radius: 10px;
    box-shadow: none;
    border: 1px solid #e9ecef;
    background: #fff;
    font-size: 13px;
    font-weight: 800;
    gap: 10px;
}

#map-sidebar #viewDropdownToggle.dropdown-btn:hover {
    background: #f8f9fa;
}

#map-sidebar #viewDropdownToggle.dropdown-btn:focus {
    box-shadow: 0 0 0 3px rgba(0,123,255,0.25);
}

#map-sidebar #viewDropdownToggle.dropdown-btn.active {
    background: #f8f9fa;
    color: #2d3436;
}

#map-sidebar #viewDropdownToggle .btn-text {
    flex: 1;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#map-sidebar #viewDropdownToggle svg:first-child {
    width: 18px;
    height: 18px;
    opacity: 0.85;
}

#map-sidebar #viewDropdownToggle .chevron {
    width: 16px;
    height: 16px;
    opacity: 0.7;
    margin-left: 0;
}

/* Panel */
#map-sidebar #viewDropdownPanel {
    position: static;
    min-width: 0;
    box-shadow: none;
    border: 0;
    border-radius: 10px;
    margin-top: 10px;
    padding: 0 !important;
    background: #fff;
    overflow: hidden;
}

#map-sidebar #viewDropdownPanel::before {
    display: none;
}

/* Remove the big dropdown padding/height in the sidebar */
#map-sidebar #viewDropdownPanel.expanded {
    border: 1px solid #e9ecef;
    max-height: 240px;
    opacity: 1;
    padding: 0 !important;
}

/* Compact option rows (instead of large cards) */
#map-sidebar #viewDropdownPanel .view-mode-option {
    margin: 0;
    border: 0;
    border-radius: 0;
    padding: 10px 12px;
    font-size: 12px;
    font-weight: 800;
    gap: 10px;
}

#map-sidebar #viewDropdownPanel .view-mode-option + .view-mode-option {
    border-top: 1px solid #f1f3f5;
}

#map-sidebar #viewDropdownPanel .view-mode-option svg {
    width: 16px;
    height: 16px;
    opacity: 0.75;
}

#map-sidebar #viewDropdownPanel .view-mode-option:hover {
    background: #f8f9fa;
}

#map-sidebar #viewDropdownPanel .view-mode-option.active {
    background: rgba(87, 119, 169, 0.12);
    color: #2d3436;
}

#map-sidebar #viewDropdownPanel .view-mode-option.active svg {
    opacity: 1;
}


@media (max-width: 600px) {
    /* No sidebar on mobile – keep the existing overlay control layout */
    #map-shell {
        display: block;
        height: 600px;
        border-radius: 12px;
    }
    #map-sidebar { display: none; }
    #map-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .view-dropdown-wrapper { display: none !important; }
    .year-slider-panel {
        border-radius: 0 0 12px 12px;
    }
}

#map { 
    width: 100%; 
    flex: 1;
    min-height: 0;
    z-index: 1; 
}
#globeContainer { 
    width: 100%; 
    flex: 1;
    min-height: 0;
    z-index: 1; 
    display: none;
    background: #000;
}
#globeContainer .maplibregl-canvas {
    outline: none;
}


/* Map canvas wrapper keeps legend pinned to the map area (not the timeline slider) */
.map-canvas{
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

/* Globe popup styling */
.globe-popup .maplibregl-popup-content {
    padding: 0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.12);
    border: 1px solid #e9ecef;
}

.globe-popup .maplibregl-popup-close-button {
    color: #636e72;
    font-size: 18px;
    padding: 6px 10px;
    right: 4px;
    top: 4px;
}

.globe-popup .maplibregl-popup-close-button:hover {
    background: rgba(0,0,0,0.05);
    border-radius: 4px;
}

/* --- 2. Controls --- */
.controls-ui {
    position: absolute; top: 20px; left: 20px; z-index: 1000;
    display: flex; gap: 10px; align-items: flex-start;
}

/* --- Status Bar (Year + Filter Chips) - positioned next to search bar --- */
.map-status-bar {
    display: inline-flex;
    align-items: center;
    gap: 0;

    border-radius: 14px;
    background: rgba(255, 255, 255, 0.82);
    border: 1px solid rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);

    font-family: 'Muli', sans-serif;
    pointer-events: auto;
    transition: background 0.25s ease, box-shadow 0.25s ease;
    overflow: hidden;
    flex-shrink: 0;
    max-width: calc(100vw - 160px); /* v5.7.137: prevent overlap with map controls */
}

/* Year section within the status bar */
.map-year-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 14px;

    background: transparent;
    border: none;
    box-shadow: none;

    font-family: 'Muli', sans-serif;
    pointer-events: none;
    transition: background 0.25s ease;
}

.map-year-badge-icon {
    width: 18px;
    height: 18px;
    color: #636e72;
    flex-shrink: 0;
    transition: color 0.25s ease;
}

.map-year-badge-label {
    font-size: 16px;
    font-weight: 600;
    font-family: 'Muli', sans-serif;
    color: #636e72;
    line-height: 1;
    transition: color 0.25s ease;
    white-space: nowrap;
    margin-right: 4px;
}

.map-year-badge-value {
    font-size: 15px;
    font-weight: 800;
    color: #2d3436;
    letter-spacing: -0.3px;
    line-height: 1;
    transition: color 0.25s ease;
    white-space: nowrap;
}

.map-year-badge-meta {
    display: none; /* Hidden in chip design */
}

/* Historical year state - accent the entire status bar */
.map-status-bar.past-year {
    background: rgba(87, 119, 169, 0.96);
    border-color: rgba(87, 119, 169, 0.2);
    box-shadow: 0 10px 28px rgba(87, 119, 169, 0.35);
}

.map-status-bar.past-year .map-year-badge-icon {
    color: rgba(255, 255, 255, 0.9);
}

.map-status-bar.past-year .map-year-badge-value {
    color: #ffffff;
}

.map-status-bar.past-year .map-year-badge-label {
    color: rgba(255, 255, 255, 0.8);
}

.map-status-bar.past-year .status-bar-filter-icon {
    color: rgba(255, 255, 255, 0.9);
}

.map-status-bar.past-year .status-bar-separator {
    background: rgba(255, 255, 255, 0.25);
}

.map-status-bar.past-year .filter-chip {
    background: rgba(255, 255, 255, 0.18);
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.2);
}

.map-status-bar.past-year .filter-chip:hover {
    background: rgba(255, 255, 255, 0.28);
}

.map-status-bar.past-year .filter-chip-dot {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
}

.map-status-bar.past-year .filter-chip-remove {
    color: rgba(255, 255, 255, 0.7);
}

.map-status-bar.past-year .filter-chip-remove:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.2);
}

/* v5.7.141: Compact filter summary styling for historical years */
.map-status-bar.past-year .filter-summary {
    background: rgba(255, 255, 255, 0.18);
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.2);
}

.map-status-bar.past-year .filter-summary-label {
    color: #ffffff;
}

.map-status-bar.past-year .filter-summary-clear {
    color: rgba(255, 255, 255, 0.7);
}

.map-status-bar.past-year .filter-summary-clear:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.2);
}

/* Present state - subtle and unobtrusive */
.map-status-bar.at-present {
    opacity: 0.92;
}

/* Separator between year and filters */
.status-bar-separator {
    width: 1px;
    height: 24px;
    background: rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
}

/* Filter icon in status bar */
.status-bar-filter-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: #636e72;
    flex-shrink: 0;
    margin-left: 8px;
    margin-right: 2px;
}

.status-bar-filter-icon svg {
    width: 16px;
    height: 16px;
}

/* Filter chips container */
.status-bar-filters {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 10px 8px 10px;
    flex-wrap: nowrap;
}

/* v5.7.137: Compact filter summary for embedded mode */
.filter-summary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px 5px 10px;
    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    color: #2d3436;
    white-space: nowrap;
}

.filter-summary-label {
    line-height: 1;
}

.filter-summary-clear {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: #636e72;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.filter-summary-clear:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #2d3436;
}

.filter-summary-clear svg {
    width: 12px;
    height: 12px;
}

/* Hide filters section when empty */
.status-bar-filters:empty {
    display: none;
}

.status-bar-filters:empty + .status-bar-separator {
    display: none;
}

/* Individual filter chip */
.filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px 5px 10px;

    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 20px;

    font-size: 12px;
    font-weight: 700;
    color: #2d3436;
    white-space: nowrap;

    cursor: default;
    transition: background 0.15s ease, border-color 0.15s ease;
    pointer-events: auto;
}

.filter-chip:hover {
    background: rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.12);
}

/* Colored dot for status filters */
.filter-chip-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.filter-chip-dot.green { background: #00b894; }
.filter-chip-dot.yellow { background: #fdcb6e; }
.filter-chip-dot.grey { background: #636e72; }

/* Filter chip label */
.filter-chip-label {
    line-height: 1;
}

/* Remove button on filter chip */
.filter-chip-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;

    background: transparent;
    border: none;
    border-radius: 50%;
    padding: 0;
    margin-left: 2px;

    color: #636e72;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.filter-chip-remove:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #2d3436;
}

.filter-chip-remove svg {
    width: 12px;
    height: 12px;
}


/* Mobile: hide desktop status bar, mobile indicator handles this */
@media (max-width: 600px) {
    .map-status-bar { display: none !important; }
}
.search-wrapper {
    position: relative;
}
/* Mobile/controls-ui search input styling */
.controls-ui .search-input {
    width: 380px; padding: 12px 40px 12px 16px; border: none; border-radius: 20px;
    background: white;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-size: 16px; outline: none;
    font-family: 'Muli', sans-serif; font-weight: 600; color: #333;
    transition: box-shadow 0.2s ease;
}
.controls-ui .search-input:focus {
    box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,123,255,0.3);
}
.search-input::placeholder {
    color: #adb5bd;
}
/* Base search input styles (common to all contexts) */
.search-input {
    font-size: 16px;
    outline: none;
    font-family: 'Muli', sans-serif;
    font-weight: 600;
    color: #333;
    background: transparent;
    border: none;
    box-shadow: none;
}
.search-input:focus {
    outline: none;
}
.search-clear-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: #e0e0e0;
    border: none;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background 0.2s ease;
}
.search-clear-btn:hover {
    background: #d0d0d0;
}
.search-clear-btn svg {
    width: 12px;
    height: 12px;
    stroke: #666;
}
.search-clear-btn.visible {
    display: flex;
}
.home-btn {
    background: white; color: #2d3436; border: none;
    border-radius: 50%; cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: all 0.2s ease;
    display: flex; align-items: center; justify-content: center;
    width: 44px; height: 44px;
    flex-shrink: 0;
}
.home-btn:hover { background: #f8f9fa; color: #5777a9; }
.home-btn:focus { outline: none; box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,123,255,0.3); }
.home-btn:active { transform: scale(0.98); }
.home-btn svg { width: 20px; height: 20px; }

/* Home button when docked into the top-right control stack (desktop sidebar layout) */
.home-btn.home-btn-group {
    width: 40px;
    height: 40px;
    border-radius: 8px 8px 0 0;
    box-shadow: none;
    border-bottom: 1px solid #e9ecef;
    background: #fff;
}
.home-btn.home-btn-group:hover { background: #f5f5f5; color: #2d3436; }
.home-btn.home-btn-group:focus { outline: none; background: #f0f0f0; box-shadow: none; }
.home-btn.home-btn-group:active { background: #e8e8e8; transform: none; }
.home-btn.home-btn-group svg { width: 18px; height: 18px; }

/* Mobile filter button (opens bottom sheet panel) */
.mobile-filter-btn {
    display: none; /* Hidden on desktop */
}

@media (max-width: 600px) {
    .mobile-filter-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background: white;
        color: #2d3436;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transition: all 0.2s ease;
        width: 44px;
        height: 44px;
        flex-shrink: 0;
    }
    
    .mobile-filter-btn:hover {
        background: #f8f9fa;
        color: #5777a9;
    }
    
    .mobile-filter-btn:focus {
        outline: none;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,123,255,0.3);
    }
    
    .mobile-filter-btn:active {
        transform: scale(0.98);
    }
    
    .mobile-filter-btn svg {
        width: 20px;
        height: 20px;
    }
    
    .mobile-filter-btn.has-filters {
        background: #5777a9;
        color: white;
    }
    
    .mobile-filter-btn.has-filters:hover {
        background: #4a6898;
        color: white;
    }
}

[data-theme="dark"] .mobile-filter-btn {
    background: #2d2d44;
    color: #e0e0e0;
}

[data-theme="dark"] .mobile-filter-btn:hover {
    background: #3d3d5c;
    color: #5777a9;
}

[data-theme="dark"] .mobile-filter-btn.has-filters {
    background: #5777a9;
    color: white;
}


.fullscreen-btn {
    background: white; color: #2d3436; border: none; padding: 10px;
    border-radius: 50%; cursor: pointer; font-weight: 700;
    font-family: 'Muli', sans-serif; box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: background 0.2s ease, transform 0.1s ease;
    display: flex; align-items: center; justify-content: center;
    width: 44px; height: 44px;
}
.fullscreen-btn:hover { background: #f8f9fa; }
.fullscreen-btn:focus { outline: none; box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,123,255,0.3); }
.fullscreen-btn:active { transform: scale(0.98); }
.fullscreen-btn svg { width: 20px; height: 20px; }

/* Map controls group (top right) */
.map-controls-group {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 0;
}

.map-control-btn {
    background: white;
    color: #2d3436;
    border: none;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    transition: background 0.15s ease;
    border-bottom: 1px solid #e9ecef;
}

.map-control-btn:first-child {
    border-radius: 8px 8px 0 0;
}

.map-control-btn:last-child {
    border-radius: 0 0 8px 8px;
    border-bottom: none;
}

.map-control-btn:only-child {
    border-radius: 8px;
}

/* Handle wrapper elements - remove default border-radius from buttons inside wrappers */
.view-mode-wrapper .map-control-btn,
.info-btn-wrapper .map-control-btn {
    border-radius: 0;
    border-bottom: 1px solid #e9ecef;
}

/* Handle the last wrapper's button getting bottom border-radius */
.view-mode-wrapper:last-child .map-control-btn,
.info-btn-wrapper:last-child .map-control-btn {
    border-radius: 0 0 8px 8px;
    border-bottom: none;
}

.map-controls-group {
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    border-radius: 8px;
    overflow: hidden; /* v5.7.126: clip children to container border-radius (fixes info button corners) */
}

/* Share Button */
.share-btn {
    background: white;
    color: #2d3436;
    border: none;
    border-radius: 0;
    cursor: pointer;
    box-shadow: none;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-bottom: 1px solid #e9ecef;
}
.share-btn:first-child {
    border-radius: 8px 8px 0 0;
}
.share-btn:hover {
    background: #f5f5f5;
    color: #5777a9;
}

/* Brief visual confirmation after copying */
.share-btn.copied {
    background: #2d3436;
    color: #ffffff;
}

.share-btn:active { background: #e8e8e8; }
.share-btn:focus { outline: none; background: #f0f0f0; }
.share-btn svg { width: 18px; height: 18px; }

/* Share Toast Notification */
.share-toast {
    position: fixed;
    /* Default position; JS will anchor this near the Share button when possible */
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(45, 52, 54, 0.95);
    color: white;
    padding: 12px 20px;
    border-radius: 12px;
    font-family: 'Muli', sans-serif;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.25);
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 10001;
    pointer-events: none;
}
.share-toast.visible {
    opacity: 1;
}
.share-toast.anchored {
    /* When anchored next to the Share button, don’t use centering transforms */
    transform: none;
}
.share-toast.error { background: rgba(214, 48, 49, 0.95); }
.share-toast svg { flex-shrink: 0; }

/* No Data Yet Message (for timeline) */
.no-data-yet-message {
    padding: 20px 16px;
    text-align: center;
    background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
    border-radius: 8px;
    margin: 12px;
    border: 1px dashed #dee2e6;
}
.no-data-yet-message .no-data-icon {
    width: 48px;
    height: 48px;
    margin: 0 auto 12px;
    background: #e9ecef;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #868e96;
}
.no-data-yet-message .no-data-icon svg {
    width: 24px;
    height: 24px;
}
.no-data-yet-message .no-data-title {
    font-size: 14px;
    font-weight: 700;
    color: #495057;
    margin-bottom: 6px;
}
.no-data-yet-message .no-data-text {
    font-size: 12px;
    color: #868e96;
    line-height: 1.4;
}
.no-data-yet-message .no-data-year {
    display: inline-block;
    background: #5777a9;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 11px;
    margin-top: 8px;
}

/* Plant info content wrapper for hiding/showing */
.plant-info-content {
    display: block;
}
.plant-info-content.hidden {
    display: none;
}

/* Country info content wrapper for hiding/showing */
.country-info-content {
    display: block;
}
.country-info-content.hidden {
    display: none;
}

/* Year Indicator - only visible on mobile, centered */
.mobile-year-indicator {
    position: absolute;
    top: 14px;
    left: 14px;
    transform: none;
    z-index: 1100;
    background: rgba(87, 119, 169, 0.92);
    border: 1px solid rgba(255, 255, 255, 0.14);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    padding: 10px 14px;
    border-radius: 18px;
    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.18);
    display: none;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    font-family: 'Muli', sans-serif;
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none;
    color: white;
}
.mobile-year-indicator .year-indicator-icon {
    display: none;
}

.mobile-year-indicator .year-indicator-label {
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1;
}

.mobile-year-indicator .year-indicator-value {
    font-size: 22px;
    font-weight: 900;
    color: #ffffff;
    line-height: 1.05;
    letter-spacing: -0.5px;
}

.mobile-year-indicator .year-indicator-meta{
    font-size: 11px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.15;
    margin-top: 2px;
    text-transform: none;
    letter-spacing: 0.01em;
}

/* Present state on mobile: combined label + last update */
.mobile-year-indicator.at-present .year-indicator-label{
    font-size: 14px;
    font-weight: 900;
    letter-spacing: 0.02em;
    text-transform: none;
    color: #ffffff;
}
.mobile-year-indicator.at-present .year-indicator-value{
    display: none;
}


@media (max-width: 600px) {
    /* v5.7.145: Hide year indicator on mobile (no slider available) */
    .mobile-year-indicator {
        display: none;
    }
}

.map-control-btn:hover {
    background: #f5f5f5;
}

.map-control-btn:focus {
    outline: none;
    background: #f0f0f0;
}

.map-control-btn:active {
    background: #e8e8e8;
}

.map-control-btn svg {
    width: 18px;
    height: 18px;
}

/* Info button wrapper */
.info-btn-wrapper {
    position: relative;
}

.info-btn-wrapper .map-control-btn {
    font-family: 'Muli', sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
}

/* Info modal (centered, dimmed background) */
.map-info-modal {
    position: absolute;
    inset: 0;
    z-index: 1300;
    display: none;
    align-items: center;
    justify-content: center;
}
.map-info-modal.open {
    display: flex;
}
.map-info-modal-backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.45);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
}
.map-info-modal-dialog {
    position: relative;
    width: min(960px, calc(100% - 48px));
    max-height: min(640px, calc(100% - 48px));
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.04);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.map-info-modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 24px 28px 0 28px;
    flex-shrink: 0;
}
.map-info-modal-title {
    font-family: 'Muli', sans-serif;
    font-size: 18px;
    font-weight: 800;
    color: #1a1a2e;
    line-height: 1.3;
    letter-spacing: -0.02em;
}
.map-info-modal-close {
    border: none;
    background: transparent;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    color: #8898aa;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.12s ease, color 0.12s ease;
    flex-shrink: 0;
    margin-left: 12px;
}
.map-info-modal-close:hover {
    background: rgba(0,0,0,0.06);
    color: #2d3436;
}
.map-info-modal-body {
    padding: 20px 28px 28px 28px;
    overflow-y: auto;
}
.map-info-modal-text {
    font-family: 'Muli', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #636e72;
    line-height: 1.7;
    margin-bottom: 14px;
}
.map-info-modal-text:last-child {
    margin-bottom: 0;
}
.map-info-modal-text a {
    color: #5777a9;
    text-decoration: none;
    font-weight: 600;
}
.map-info-modal-text a:hover {
    text-decoration: underline;
}

/* View mode selector popup */
.view-mode-wrapper {
    position: relative;
}

.view-mode-popup {
    position: absolute;
    top: 0;
    right: calc(100% + 10px);
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    padding: 8px;
    display: none;
    opacity: 0;
    transform: translateX(10px);
    transition: opacity 0.2s ease, transform 0.2s ease;
    min-width: 120px;
}

.view-mode-popup.visible {
    display: block;
}

.view-mode-popup.expanded {
    opacity: 1;
    transform: translateX(0);
}

/* Arrow pointing right */
.view-mode-popup::after {
    content: '';
    position: absolute;
    top: 12px;
    right: -6px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid white;
}

.view-mode-option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #2d3436;
    transition: background 0.15s ease;
    white-space: nowrap;
}

.view-mode-option:hover {
    background: #f5f5f5;
}

.view-mode-option.active {
    background: rgba(108, 122, 224, 0.1);
    color: #5777a9;
}

.view-mode-option svg {
    width: 16px;
    height: 16px;
    opacity: 0.7;
}

.view-mode-option.active svg {
    opacity: 1;
}


/* MapLibre control positioning */
#mapCanvas .maplibregl-ctrl-bottom-right {
    bottom: 10px;
}

.maplibregl-ctrl-attrib {
    font-size: 10px;
}

/* Keyboard users need a visible focus ring on the only focusable map element. */
#mapCanvas .maplibregl-canvas:focus-visible {
    outline: 2px solid #5777a9;
    outline-offset: -2px;
}

/* Keyboard route to individual plants (v5.7.183).
   Leaflet gave every marker tabindex=0 and Enter opened its popup; canvas markers cannot be
   focused, so this list replaces that route. It is screen-reader-only until something inside
   it takes focus, at which point it becomes visible so sighted keyboard users can see where
   they are. It is rebuilt from the same data the map draws, so it always matches what is on
   screen, and it is reachable in one Tab instead of walking 300-odd markers. */
.map-browse {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1200;
}
.map-browse-toggle {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
}
.map-browse:focus-within .map-browse-toggle {
    position: static;
    width: auto;
    height: auto;
    margin: 8px;
    padding: 8px 12px;
    overflow: visible;
    clip: auto;
    clip-path: none;
    white-space: normal;
    background: #fff;
    border: 1px solid #d7dce3;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    font-family: 'Muli', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #2d3436;
    cursor: pointer;
}
.map-browse-list {
    position: absolute;
    left: 8px;
    top: 52px;
    width: 320px;
    max-height: 60vh;
    overflow-y: auto;
    margin: 0;
    padding: 6px;
    list-style: none;
    background: #fff;
    border: 1px solid #d7dce3;
    border-radius: 10px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.18);
}
.map-browse-list button {
    display: block;
    width: 100%;
    padding: 6px 8px;
    border: 0;
    border-radius: 6px;
    background: none;
    text-align: left;
    font-family: 'Muli', sans-serif;
    font-size: 13px;
    color: #2d3436;
    cursor: pointer;
}
.map-browse-list button:hover,
.map-browse-list button:focus-visible {
    background: #eef2f8;
    outline: none;
}
[data-theme="dark"] .map-browse:focus-within .map-browse-toggle,
[data-theme="dark"] .map-browse-list {
    background: var(--bg-secondary);
    border-color: var(--border-color);
    color: var(--text-primary);
}
[data-theme="dark"] .map-browse-list button {
    color: var(--text-primary);
}
[data-theme="dark"] .map-browse-list button:hover,
[data-theme="dark"] .map-browse-list button:focus-visible {
    background: var(--bg-hover);
}

/* Shown in place of the map when WebGL is unavailable. */
.map-unsupported {
    position: absolute;
    inset: 0;
    z-index: 5;
    background: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 24px;
    text-align: center;
    font-family: 'Muli', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #2d3436;
}

/* Fullscreen mode styles */
#map-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
}

#map-wrapper.fullscreen {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    height: 100dvh !important;
    z-index: 999999 !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #f8f9fa !important;
    overflow: hidden !important;
    touch-action: none;
}

/* Prevent scrolling on body when fullscreen */
body.fullscreen-active {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
    height: 100% !important;
    touch-action: none !important;
}

html.fullscreen-active {
    overflow: hidden !important;
}

#map-wrapper.fullscreen #map-shell {
    flex: 1;
    height: auto !important;
    min-height: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
}

#map-wrapper.fullscreen #map-sidebar {
    height: 100%;
    border-radius: 0 !important;
}

/* Hide sidebar brand block in fullscreen (title already in top banner) */
#map-wrapper.fullscreen #map-sidebar .sidebar-brand {
    display: none;
}


/* Desktop (not fullscreen): hide redundant sidebar brand block (title already in top banner) */
@media (min-width: 901px) {
    #map-wrapper:not(.fullscreen) #map-sidebar .sidebar-brand {
        display: none;
    }
}

#map-wrapper.fullscreen #map-sidebar .sidebar-title {
    display: none;
}

#map-wrapper.fullscreen #map-sidebar .sidebar-subtitle {
    margin-top: 0;
}

#map-wrapper.fullscreen #map-container {
    flex: 1;
    min-height: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
}

/* In fullscreen, map container needs to account for the always-visible timeline sidebar */
#map-wrapper.fullscreen.timeline-charts-open #map-container {
    margin-right: var(--timeline-charts-sidebar-width);
    transition: margin-right 0.3s ease;
}

#map-wrapper.fullscreen #map,
#map-wrapper.fullscreen #globeContainer {
    width: 100% !important;
    flex: 1 !important;
    min-height: 0 !important;
}

#map-wrapper.fullscreen .year-slider-panel {
    border-radius: 0 !important;
    flex-shrink: 0;
    position: relative;
    z-index: 100;
    padding: 8px 16px;
    background: var(--slider-panel-bg, rgba(255, 255, 255, 0.97));
    border-top: 1px solid var(--slider-panel-border, #e9ecef);
}

/* Hide timeline slider on mobile even in fullscreen */
@media (max-width: 600px) {
    #map-wrapper.fullscreen .year-slider-panel {
        display: none !important;
    }
}

/* Slider panel fills the map container width (container already has margin-right for sidebar) */
#map-wrapper.fullscreen.timeline-charts-open .year-slider-panel {
    /* No extra margin needed - container handles sidebar offset */
}

#map-wrapper.fullscreen .year-slider-panel .timeline-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
}

.timeline-controls {
    display: contents;
}

/* Timeline expand button - only visible in fullscreen */
.timeline-expand-btn {
    display: none;
    background: #f1f3f5;
    color: #636e72;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s ease;
}

#map-wrapper.fullscreen .timeline-expand-btn {
    display: none; /* Hidden in fullscreen - sidebar always visible */
}

.timeline-expand-btn:hover {
    background: #e9ecef;
    color: #2d3436;
}

.timeline-expand-btn svg {
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
}

.timeline-expand-btn.expanded svg {
    transform: rotate(180deg); /* Points left when expanded */
}

/* In fullscreen mode, Timeline sidebar is always visible and non-collapsible */
#map-wrapper.fullscreen .timeline-charts-sidebar {
    display: flex;
    right: 0; /* Always expanded */
}

/* Hide expand button and close button in fullscreen */
#map-wrapper.fullscreen .timeline-expand-btn {
    display: none;
}

#map-wrapper.fullscreen .timeline-charts-close {
    display: flex;
}

/* Timeline charts sidebar sizing variables (used to keep map controls visible when charts are open) */
:root {
    --timeline-charts-sidebar-width: 300px;
    /* extra offset to ensure the sidebar (including shadow) is fully offscreen when hidden */
    --timeline-charts-sidebar-hide-extra: 20px;
}

/* Timeline Charts Right Sidebar */
.timeline-charts-sidebar {
    display: none;
    position: absolute;
    top: 0;
    right: calc(-1 * (var(--timeline-charts-sidebar-width) + var(--timeline-charts-sidebar-hide-extra)));
    width: var(--timeline-charts-sidebar-width);
    height: 100%;
    background: #fff;
    border-left: 1px solid #e9ecef;
    box-shadow: -4px 0 16px rgba(0,0,0,0.1);
    z-index: 1000;
    transition: right 0.3s ease;
    flex-direction: column;
}

#map-wrapper.fullscreen .timeline-charts-sidebar {
    display: flex;
    right: 0; /* Always expanded in fullscreen */
}

/* In fullscreen, sidebar is always expanded - no toggle needed */
#map-wrapper.fullscreen .timeline-charts-sidebar.expanded {
    right: 0;
}

/* v5.7.82: Close button visible in fullscreen (repurposed as collapse toggle) */
#map-wrapper.fullscreen .timeline-charts-close {
    display: flex;
}

/* === TIMELINE SIDEBAR - VIDEO PLAYER STYLE LAYOUT === */

.timeline-charts-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    border-bottom: 1px solid #e9ecef;
    flex-shrink: 0;
    background: #f5f7fb;
}

.timeline-header-content {
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.timeline-header-label {
    font-size: 12px;
    font-weight: 700;
    color: #5777a9;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.timeline-charts-close {
    background: none;
    border: none;
    padding: 6px;
    cursor: pointer;
    color: #adb5bd;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
}

.timeline-charts-close:hover {
    background: #f1f3f5;
    color: #636e72;
}

.timeline-charts-close svg {
    width: 16px;
    height: 16px;
}

/* Charts content - stacked visualization area */
.timeline-charts-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    overflow-y: auto;
    min-height: 0;
    background: #e8edf5;
}

/* Individual chart panel - minimal chrome */
/* v5.7.79: Card-style chart panels */
.timeline-chart-panel {
    flex: none;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 6px rgba(0,0,0,0.10);
    border: none;
    overflow: hidden;
    position: relative;
}

.timeline-chart-panel:last-child {
    border-bottom: none;
}

/* v5.7.79: Old vertical label — hidden (replaced by card header) */
.timeline-chart-label {
    display: none;
}

/* v5.7.79: Card header with title + expand button */
.timeline-chart-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px 12px 0 14px;
    flex-shrink: 0;
}
.timeline-chart-panel-titles {
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.timeline-chart-panel-title {
    font-size: 13px;
    font-weight: 800;
    color: #1a1a2e;
    line-height: 1.2;
}
.timeline-chart-panel-subtitle {
    font-size: 10px;
    font-weight: 500;
    color: #8898aa;
}

/* v5.7.79: Card body wrapping canvas */
.timeline-chart-panel-body {
    position: relative;
    flex: 1;
    min-height: 0;
    padding: 0 2px;
}

/* Chart canvas - fixed height */
.timeline-chart-canvas {
    width: 100%;
    height: 180px;
    display: block;
    cursor: crosshair;
}

/* Chart value - positioned in top right of chart body */
.timeline-chart-value {
    position: absolute;
    top: 2px;
    right: 10px;
    font-size: 10px;
    font-weight: 700;
    color: #2d3436;
    white-space: nowrap;
    background: rgba(255,255,255,0.9);
    padding: 2px 6px;
    border-radius: 3px;
    z-index: 2;
}

/* Year indicator badge attached to the chart crosshair (shown on hover) */
.chart-year-indicator{
    position: absolute;
    top: 4px;
    transform: translateX(-50%);
    padding: 2px 7px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 800;
    line-height: 1.4;
    background: rgba(45, 52, 54, 0.92);
    color: #fff;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.12s ease;
    z-index: 3;
    white-space: nowrap;
}
.chart-year-indicator.visible{ opacity: 1; }

[data-theme="dark"] .chart-year-indicator{
    background: rgba(255,255,255,0.92);
    color: #111;
}

/* v5.7.79: Expand button — static in card header, always visible */
.timeline-chart-expand {
    position: static;
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    padding: 0;
    border: none;
    border-radius: 5px;
    background: rgba(0,0,0,0.04);
    color: #8898aa;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: background 0.15s ease, color 0.15s ease;
}
.timeline-chart-expand svg {
    width: 12px;
    height: 12px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.timeline-chart-expand:hover {
    background: rgba(0,0,0,0.10);
    color: #2d3436;
}
[data-theme="dark"] .timeline-chart-expand {
    background: rgba(255,255,255,0.08);
    color: #636e72;
}
[data-theme="dark"] .timeline-chart-expand:hover {
    background: rgba(255,255,255,0.16);
    color: #fff;
}

/* ============================================================
   v5.7.78  Expanded chart modal  (Electricity Maps-inspired)
   ============================================================ */
.expanded-chart-modal {
    position: fixed;
    inset: 0;
    z-index: 1300;
    display: none;
    align-items: center;
    justify-content: center;
}
.expanded-chart-modal.open {
    display: flex;
}
.expanded-chart-backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.45);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
}
.expanded-chart-dialog {
    position: relative;
    width: min(960px, calc(100vw - 48px));
    height: min(640px, calc(100vh - 48px));
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.04);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.expanded-chart-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 24px 0 24px;
    flex-shrink: 0;
}
.expanded-chart-header-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
}
.expanded-chart-title {
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    font-family: 'Muli', sans-serif !important;
    font-size: 18px !important;
    font-weight: 800 !important;
    color: #1a1a2e !important;
    letter-spacing: -0.02em !important;
    line-height: 1.2 !important;
    text-transform: none !important;
    text-decoration: none !important;
    background: none !important;
}
.expanded-chart-subtitle {
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    font-family: 'Muli', sans-serif !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    color: #8898aa !important;
    letter-spacing: 0 !important;
    line-height: 1.4 !important;
    text-transform: none !important;
    text-decoration: none !important;
    background: none !important;
}
.expanded-chart-close {
    border: none;
    background: transparent;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    color: #8898aa;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.12s ease, color 0.12s ease;
    flex-shrink: 0;
    order: 2;
    margin-left: 12px;
}
.expanded-chart-close:hover {
    background: rgba(0,0,0,0.06);
    color: #2d3436;
}
.expanded-chart-body {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 12px 24px 0 24px;
    min-height: 0;
    position: relative;
}
.expanded-chart-canvas {
    width: 100%;
    flex: 1 1 0;
    min-height: 0;
    display: block;
    cursor: crosshair;
}
.expanded-chart-legend {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 18px;
    padding: 14px 24px 18px 24px;
    flex-shrink: 0;
}
.expanded-chart-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #636e72;
    letter-spacing: 0.01em;
}
.expanded-chart-legend-swatch {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    flex-shrink: 0;
}

/* Floating tooltip card (appears near hovered point) */
.expanded-chart-tooltip {
    position: fixed;
    z-index: 1400;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.12s ease;
    width: 280px;
}
.expanded-chart-tooltip.visible {
    opacity: 1;
}
.expanded-chart-tooltip.pinned {
    pointer-events: auto;
}
.expanded-chart-tooltip.pinned .expanded-chart-tooltip-card {
    max-height: 60vh;
    overflow-y: auto;
}
.expanded-chart-tooltip-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.14), 0 0 0 1px rgba(0,0,0,0.04);
    padding: 14px 16px;
    font-size: 12px;
    line-height: 1.6;
    color: #2d3436;
}
.expanded-chart-tooltip-year {
    font-size: 13px;
    font-weight: 800;
    color: #1a1a2e;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
}
.expanded-chart-tooltip-summary {
    margin-bottom: 6px;
}
.expanded-chart-tooltip-summary-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 1px 0;
}
.expanded-chart-tooltip-dot {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    flex-shrink: 0;
}
.expanded-chart-tooltip-label {
    color: #636e72;
    flex: 1;
}
.expanded-chart-tooltip-value {
    font-weight: 700;
    color: #1a1a2e;
    text-align: right;
}
.expanded-chart-tooltip-divider {
    height: 1px;
    background: rgba(0,0,0,0.06);
    margin: 8px 0;
}
.expanded-chart-tooltip-section-title {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #8898aa;
    margin-bottom: 4px;
}
.expanded-chart-tooltip-reactor {
    padding: 2px 0;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    cursor: pointer;
    border-radius: 4px;
    padding: 2px 4px;
    margin: 0 -4px;
}
.expanded-chart-tooltip-reactor:hover {
    background: rgba(87,119,169,0.08);
}
.expanded-chart-tooltip-reactor-name {
    font-weight: 600;
    color: #2d3436;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
}
.expanded-chart-tooltip-reactor-detail {
    color: #8898aa;
    font-size: 11px;
    white-space: nowrap;
    margin-left: 6px;
}
.expanded-chart-tooltip-more {
    color: #8898aa;
    font-style: italic;
    font-size: 11px;
    margin-top: 2px;
}

/* Dark mode */
[data-theme="dark"] .expanded-chart-dialog {
    background: #1e1e2e;
    box-shadow: 0 8px 30px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.06);
}
[data-theme="dark"] .expanded-chart-title {
    color: #f5f6fa !important;
}
[data-theme="dark"] .expanded-chart-subtitle {
    color: #636e72 !important;
}
[data-theme="dark"] .expanded-chart-close {
    color: #636e72;
}
[data-theme="dark"] .expanded-chart-close:hover {
    background: rgba(255,255,255,0.08);
    color: #f5f6fa;
}
[data-theme="dark"] .expanded-chart-legend-item {
    color: #8898aa;
}
[data-theme="dark"] .expanded-chart-tooltip-card {
    background: #2d2d44;
    box-shadow: 0 4px 20px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.06);
    color: #dfe6e9;
}
[data-theme="dark"] .expanded-chart-tooltip-year {
    color: #f5f6fa;
    border-bottom-color: rgba(255,255,255,0.08);
}
[data-theme="dark"] .expanded-chart-tooltip-label {
    color: #8898aa;
}
[data-theme="dark"] .expanded-chart-tooltip-value {
    color: #f5f6fa;
}
[data-theme="dark"] .expanded-chart-tooltip-divider {
    background: rgba(255,255,255,0.08);
}
[data-theme="dark"] .expanded-chart-tooltip-section-title {
    color: #636e72;
}
[data-theme="dark"] .expanded-chart-tooltip-reactor-name {
    color: #dfe6e9;
}
[data-theme="dark"] .expanded-chart-tooltip-reactor-detail {
    color: #636e72;
}

/* Mobile */
@media (max-width: 600px) {
    .expanded-chart-dialog {
        width: calc(100vw - 16px);
        height: min(480px, calc(100vh - 16px));
        border-radius: 10px;
    }
    .expanded-chart-header {
        padding: 16px 16px 0 16px;
    }
    .expanded-chart-body {
        padding: 8px 16px 0 16px;
    }
    .expanded-chart-legend {
        padding: 10px 16px 14px 16px;
        gap: 12px;
        flex-wrap: wrap;
    }
    .expanded-chart-tooltip {
        width: 240px;
    }
    .expanded-chart-fit .expanded-chart-dialog {
        max-height: min(480px, calc(100vh - 16px));
    }
    .map-info-modal-dialog {
        width: calc(100% - 16px);
        max-height: min(480px, calc(100% - 16px));
        border-radius: 10px;
    }
    .map-info-modal-header {
        padding: 18px 20px 0 20px;
    }
    .map-info-modal-body {
        padding: 16px 20px 22px 20px;
    }
}

/* ============================================================
   v5.7.80  Expand buttons for plant & country detail charts
   ============================================================ */

/* Expand button on detail chart sections */
.detail-chart-expand {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 4;
    width: 26px;
    height: 26px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: rgba(0,0,0,0.05);
    color: #8898aa;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease, color 0.15s ease;
}
.detail-chart-expand svg {
    width: 13px;
    height: 13px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.detail-chart-expand:hover {
    background: rgba(0,0,0,0.12);
    color: #2d3436;
}
[data-theme="dark"] .detail-chart-expand {
    background: rgba(255,255,255,0.08);
    color: #636e72;
}
[data-theme="dark"] .detail-chart-expand:hover {
    background: rgba(255,255,255,0.16);
    color: #fff;
}

/* Ensure detail-chart-wrap and reactor-deploy-chart are positioned for the absolute button */
.detail-chart-wrap {
    position: relative;
}
.reactor-deploy-chart {
    position: relative;
}

/* Section header with inline expand button for timeline & deploy sections */
.detail-section-header-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
}
.detail-section-header-row .detail-chart-expand {
    position: static;
    flex-shrink: 0;
    margin-top: 2px;
}

/* Generic custom content area inside expanded chart modal (for SVG charts) */
.expanded-chart-custom {
    width: 100%;
    flex: 1 1 0;
    min-height: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
}
.expanded-chart-custom .reactor-deploy-chart {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 12px;
    border: none;
    box-shadow: none;
}
.expanded-chart-custom .detail-timeline {
    width: 100%;
}
.expanded-chart-custom .reactor-deploy-container {
    height: auto;
}
.expanded-chart-custom .reactor-deploy-svg {
    width: 100%;
    height: auto;
}

/* v5.7.111: Fit-to-content mode for SVG charts (timeline, deployment) */
.expanded-chart-fit .expanded-chart-dialog {
    height: auto;
    max-height: min(640px, calc(100vh - 48px));
}
.expanded-chart-fit .expanded-chart-body {
    flex: 0 1 auto;
}
.expanded-chart-fit .expanded-chart-custom {
    flex: 0 1 auto;
}

/* Production toggle inside expanded modal header */
.expanded-chart-toggle {
    display: flex;
    background: #f1f3f5;
    border-radius: 6px;
    padding: 2px;
    gap: 2px;
    flex-shrink: 0;
    margin-left: 16px;
    align-self: center;
    order: 1;
}
.expanded-chart-toggle .production-toggle-btn {
    padding: 5px 14px;
    font-size: 12px;
    font-weight: 700;
    color: #636e72;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s ease;
    font-family: 'Muli', sans-serif;
}
.expanded-chart-toggle .production-toggle-btn.active {
    background: #fff;
    color: #2d3436;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}
.expanded-chart-toggle .production-toggle-btn:hover:not(.active) {
    color: #2d3436;
}

/* Dark mode for expanded toggle */
[data-theme="dark"] .expanded-chart-toggle {
    background: rgba(255,255,255,0.08);
}
[data-theme="dark"] .expanded-chart-toggle .production-toggle-btn {
    color: #8898aa;
}
[data-theme="dark"] .expanded-chart-toggle .production-toggle-btn.active {
    background: rgba(255,255,255,0.12);
    color: #f5f6fa;
    box-shadow: none;
}

/* Dark mode for expanded custom content */
[data-theme="dark"] .expanded-chart-custom .reactor-deploy-chart {
    background: transparent;
}
[data-theme="dark"] .expanded-chart-custom .detail-timeline {
    background: transparent;
}
[data-theme="dark"] .expanded-chart-custom .detail-chart-wrap {
    background: transparent !important;
}

/* Mobile adjustments for detail expand buttons */
@media (max-width: 600px) {
    .detail-chart-expand {
        width: 30px;
        height: 30px;
    }
    .detail-chart-expand svg {
        width: 14px;
        height: 14px;
    }
}

#map-wrapper.fullscreen .map-data-sources {
    display: none;
}

#map-wrapper.fullscreen .map-legend {
    bottom: 20px;
    left: 20px;
}

#map-wrapper.fullscreen .controls-ui {
    z-index: 1001;
}

#map-wrapper.fullscreen .map-controls-group {
    top: 20px;
    right: 20px;
}

/* Controls stay at right edge of map container (container already has margin-right for sidebar) */
#map-wrapper.fullscreen.timeline-charts-open .map-controls-group {
    right: 20px;
}



/* --- Fullscreen Header Bar (WNA Brand Style) --- */
.fullscreen-header {
    display: none;
    height: 80px;
    background: #ffffff;
    border-bottom: 1px solid #e9ecef;
    padding: 0 24px;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    position: relative;
    z-index: 1000;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

#map-wrapper.fullscreen .fullscreen-header {
    display: flex;
}

.fs-header-left {
    display: flex;
    align-items: center;
    gap: 20px;
}


.fs-header-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 10px;
}

.fs-header-exit-btn {
    display: none;
    appearance: none;
    border: 1px solid rgba(0,0,0,0.12);
    background: #ffffff;
    color: #2b3a4b;
    border-radius: 12px;
    padding: 10px 14px;
    font-weight: 900;
    cursor: pointer;
    align-items: center;
    gap: 8px;
}

.fs-header-exit-btn svg {
    width: 18px;
    height: 18px;
}

.fs-header-exit-btn:hover { opacity: 0.92; }

[data-theme="dark"] .fs-header-exit-btn {
    border-color: rgba(255,255,255,0.18);
    background: rgba(255,255,255,0.10);
    color: #f1f3f5;
}

@media (max-width: 600px), (hover: none) and (pointer: coarse) and (max-width: 900px) {
    .fs-header-exit-btn {
        display: inline-flex;
    }

    /* Mobile: the map runs only in fullscreen, so hide the fullscreen toggle control. */
    #fullscreenBtn {
        display: none !important;
    }
}

.fs-header-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    padding: 0;
    background: transparent;
    border-radius: 0;
}

.fs-header-logo img {
    height: 48px;
    width: auto;
    object-fit: contain;
}

/* Placeholder logo styling - matches WNA style */
.fs-header-logo-placeholder {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 32px;
    font-size: 14px;
    font-weight: 700;
    color: #269cd2;
    letter-spacing: 0.02em;
}

.fs-header-logo-placeholder::before {
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    background: rgba(255,255,255,0.9);
    border-radius: 50%;
    position: relative;
}

.fs-header-divider {
    width: 1px;
    height: 32px;
    background: #e9ecef;
}

.fs-header-title {
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.fs-header-title-main {
    font-size: 16px;
    font-weight: 800;
    color: #2d3436;
    letter-spacing: 0.01em;
    line-height: 1.2;
}

.fs-header-title-sub {
    font-size: 11px;
    font-weight: 700;
    color: #636e72;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.fs-header-right {
    display: flex;
    align-items: center;
    gap: 16px;
}

.fs-header-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    font-size: 11px;
    font-weight: 800;
    color: #2d3436;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    transition: background 0.2s ease;
}

.fs-header-badge:hover {
    background: #f1f3f5;
}

.fs-header-badge-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #8bc34a;
    box-shadow: 0 0 6px rgba(139,195,74,0.6);
    animation: fs-pulse 2s ease-in-out infinite;
}

@keyframes fs-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.6; transform: scale(0.85); }
}

.fs-header-exit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 9px 16px;
    background: #269cd2;
    border: none;
    border-radius: 6px;
    color: #ffffff;
    font-family: 'Muli', sans-serif;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.15s ease;
}

.fs-header-exit-btn:hover {
    background: #1f89bb;
}

.fs-header-exit-btn:active {
    background: #197aa6;
    transform: scale(0.98);
}

.fs-header-exit-btn svg {
    width: 14px;
    height: 14px;
    opacity: 0.9;
}

/* Adjust fullscreen layout to accommodate header */
#map-wrapper.fullscreen #map-shell {
    flex: 1;
    height: auto !important;
    min-height: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
}

/* Move overlays down to account for header */
#map-wrapper.fullscreen .search-overlay {
    top: 20px;
}

#map-wrapper.fullscreen .country-info-overlay,
#map-wrapper.fullscreen .plant-info-overlay {
    top: 20px;
    max-height: calc(100vh - 300px); /* Account for header(80px), top(20px), legend(~120px), slider(~60px), buffer */
}

#map-wrapper.fullscreen .country-info-overlay,
#map-wrapper.fullscreen .plant-info-overlay,
#map-wrapper.fullscreen .plant-detail-dialog,
#map-wrapper.fullscreen .search-overlay {
    width: 480px;
    max-width: min(520px, calc(100vw - 80px));
}

#map-wrapper.fullscreen .search-overlay {
    /* In fullscreen: viewport height minus header(80px), top offset(20px), legend(~100px), buffer */
    max-height: calc(100vh - 260px);
}

/* Fullscreen: keep the search input the same width as the fullscreen overlay
   so the focus ring doesn't look like a second, smaller search bar. */
#map-wrapper.fullscreen .search-overlay .search-wrapper {
    width: 100%;
}
#map-wrapper.fullscreen .search-overlay .search-input {
    width: 100%;
    max-width: 100%;
}


#map-wrapper.fullscreen .plant-detail-modal {
    top: 20px;
}

/* Mobile: compact header */
@media (max-width: 600px) {
    .fullscreen-header {
        height: 60px;
        padding: 0 12px;
    }
    
    .fs-header-title-main {
        font-size: 13px;
    }
    
    .fs-header-divider,
    .fs-header-badge,
    .fs-header-title-sub {
        display: none;
    }
    
    .fs-header-exit-btn {
        padding: 6px 10px;
        font-size: 10px;
    }
    
    .fs-header-exit-btn span {
        display: none;
    }
    
    #map-wrapper.fullscreen .map-controls-group,
    #map-wrapper.fullscreen .search-overlay,
    #map-wrapper.fullscreen .country-info-overlay,
    #map-wrapper.fullscreen .plant-info-overlay,
    #map-wrapper.fullscreen .plant-detail-modal {
        top: 76px;
    }
}

.search-results {
    position: absolute; top: 115%; left: 0; width: 100%;
    background: white; border-radius: 8px; box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    max-height: 260px; overflow-y: auto; display: none;
}
.result-item {
    padding: 12px 16px; border-bottom: 1px solid #f1f3f5; cursor: pointer;
    font-size: 14px; display: flex; justify-content: space-between; align-items: center;
    transition: background 0.15s ease;
    outline: none;
}
.result-item:hover, .result-item.highlighted { background: #f8f9fa; color: #007bff; }
.result-item:focus { background: #e3f2fd; outline: none; }
.result-item:last-child { border-bottom: none; }

/* No Results State */
.no-results {
    padding: 16px; text-align: center; color: #636e72;
    font-size: 14px; font-weight: 600;
}
.no-results-icon {
    font-size: 24px; margin-bottom: 8px; display: block;
}

/* Tags - v5.7.164: status-colored search result tags */
.search-tag { font-size: 10px; font-weight: 800; padding: 2px 6px; border-radius: 4px; }
.search-tag.tag-green { color: #00b894; background: rgba(0,184,148,0.12); }
.search-tag.tag-yellow { color: #d18900; background: rgba(253,203,110,0.22); }
.search-tag.tag-blue { color: #3d84c6; background: rgba(116,185,255,0.15); }
.search-tag.tag-grey { color: #636e72; background: rgba(99,110,114,0.12); }

/* --- 3. Year Slider Panel --- */
.year-slider-panel {
    position: relative;
    z-index: 100;
    background: var(--slider-panel-bg, rgba(255, 255, 255, 0.97));
    padding: 8px 16px;
    border-top: 1px solid var(--slider-panel-border, #e9ecef);
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 0 0 12px 0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    flex-shrink: 0;
}

.play-btn {
    background: #5777a9;
    color: white;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s ease;
}

.play-btn:hover {
    background: #5a67d8;
}

.play-btn.playing {
    background: #e17055;
}

.play-btn svg {
    width: 14px;
    height: 14px;
}

.speed-btn {
    background: #f0f0f0;
    color: #2d3436;
    border: none;
    height: 32px;
    padding: 0 10px;
    border-radius: 4px;
    cursor: pointer;
    font-family: 'Muli', sans-serif;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
    transition: all 0.15s ease;
}

.speed-btn:hover {
    background: #e0e0e0;
}

.slider-title {
    font-size: 12px;
    font-weight: 700;
    color: #636e72;
    white-space: nowrap;
    display: none;
}

.year-min-label,
.year-max-label {
    font-size: 13px;
    font-weight: 700;
    color: #636e72;
    flex-shrink: 0;
}

.slider-container {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.year-slider {
    -webkit-appearance: none;
    appearance: none;
    flex: 1;
    height: 6px;
    border-radius: 3px;
    background: #dfe6e9;
    outline: none;
    cursor: pointer;
    --slider-progress: 100%;
    background: linear-gradient(to right, 
        #5777a9 0%, 
        #5777a9 var(--slider-progress), 
        #dfe6e9 var(--slider-progress), 
        #dfe6e9 100%);
}

.year-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #5777a9;
    cursor: grab;
    border: 2px solid white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    transition: transform 0.1s ease;
}

.year-slider::-webkit-slider-thumb:hover {
    transform: scale(1.15);
}

.year-slider::-webkit-slider-thumb:active {
    cursor: grabbing;
}

.year-slider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #5777a9;
    cursor: grab;
    border: 2px solid white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.year-slider::-moz-range-progress {
    background: #5777a9;
    border-radius: 3px;
    height: 6px;
}

.year-slider::-moz-range-track {
    background: #dfe6e9;
    border-radius: 3px;
    height: 6px;
}

.slider-wrapper {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
}

.slider-wrapper .year-slider {
    flex: 1;
}

.current-year {
    font-size: 15px;
    font-weight: 800;
    color: #2d3436;
    min-width: 60px;
    text-align: center;
    flex-shrink: 0;
}

/* Stats - inline compact */
.slider-stats {
    display: flex;
    gap: 12px;
    flex-shrink: 0;
    border-left: 1px solid #e9ecef;
    padding-left: 12px;
    margin-left: 4px;
    align-items: center;
}

/* Hide reactor stats in fullscreen - info shown in timeline charts */
#map-wrapper.fullscreen .slider-stats {
    display: none;
}

.reactors-label {
    font-size: 11px;
    font-weight: 700;
    color: #636e72;
    margin-right: 2px;
}

.stat-chip {
    display: flex;
    align-items: center;
    gap: 5px;
}

.stat-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.stat-dot.operable { background: #00b894; }
.stat-dot.construction { background: #fdcb6e; }
.stat-dot.planned { background: #74b9ff; }
.stat-dot.shutdown { background: #636e72; }

.stat-info {
    display: flex;
    align-items: baseline;
    gap: 3px;
}

.stat-count {
    font-size: 13px;
    font-weight: 800;
    color: #2d3436;
}

.stat-type {
    font-size: 10px;
    font-weight: 600;
    color: #8898aa;
    text-transform: lowercase;
}

/* Hide elements not needed in compact view */
.year-markers,
.slider-header,
.year-display {
    display: none;
}

/* Responsive adjustments */
@media (max-width: 700px) {
    .slider-stats {
        display: none;
    }
    .year-slider-panel {
        padding: 10px 12px;
    }
}

/* Hide timeline slider on mobile - map fills the space */
@media (max-width: 600px) {
    .year-slider-panel {
        display: none !important;
    }
}

@media (max-width: 480px) {
    .slider-title {
        display: none;
    }
    .current-year {
        font-size: 14px;
        min-width: 38px;
    }
}

/* Data sources below slider */
.map-data-sources {
    padding: 12px 16px;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    font-family: 'Muli', sans-serif;
}
.map-data-sources p {
    margin: 0;
    font-size: 11px;
    line-height: 1.5;
    color: #636e72;
}
.map-data-sources .data-note {
    margin-bottom: 6px;
}
.map-data-sources a {
    color: #5777a9;
    text-decoration: none;
}
.map-data-sources a:hover {
    text-decoration: underline;
}

/* Mobile notice banner */
.mobile-notice {
    display: none;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #f0f4ff;
    border-bottom: 1px solid #d4dff7;
    font-family: 'Muli', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #5777a9;
}

.mobile-notice svg {
    flex-shrink: 0;
}

.mobile-notice span {
    flex: 1;
}

.mobile-notice-close {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    color: #5777a9;
    opacity: 0.7;
    transition: opacity 0.15s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mobile-notice-close:hover {
    opacity: 1;
}

@media (max-width: 600px) {
    .mobile-notice {
        display: flex;
    }
}

#map-wrapper.fullscreen .mobile-notice {
    display: none;
}


/* Desktop fullscreen prompt overlay - Fixed overlay obscuring the map */
.desktop-fs-overlay {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(30, 40, 55, 0.95);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 10000;
    align-items: center;
    justify-content: center;
    font-family: 'Muli', sans-serif;
}

.desktop-fs-overlay.active {
    display: flex;
}

.desktop-fs-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 36px 40px;
    max-width: 440px;
    width: 90%;
    text-align: center;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.1);
    animation: fsCardAppear 0.3s ease-out;
}

@keyframes fsCardAppear {
    from {
        opacity: 0;
        transform: scale(0.95) translateY(-10px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

.desktop-fs-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px auto;
    background: #f0f4ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2d6cdf;
}

.desktop-fs-icon svg {
    width: 28px;
    height: 28px;
}

.desktop-fs-title {
    font-size: 20px;
    font-weight: 900;
    color: #2b3a4b;
    margin-bottom: 10px;
}

.desktop-fs-text {
    font-size: 14px;
    font-weight: 600;
    color: #5777a9;
    line-height: 1.5;
    margin-bottom: 24px;
}

.desktop-fs-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.desktop-fs-btn-primary {
    appearance: none;
    border: none;
    border-radius: 10px;
    padding: 14px 24px;
    font-size: 15px;
    font-weight: 800;
    cursor: pointer;
    background: #2d6cdf;
    color: #ffffff;
    transition: opacity 0.15s, transform 0.15s;
}

.desktop-fs-btn-primary:hover {
    opacity: 0.92;
    transform: translateY(-1px);
}

.desktop-fs-btn-secondary {
    appearance: none;
    border: none;
    background: transparent;
    padding: 8px 16px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    color: #8898aa;
    transition: opacity 0.15s, color 0.15s;
    margin-top: 8px;
}

.desktop-fs-btn-secondary:hover {
    opacity: 0.85;
    color: #5777a9;
}

/* Hide overlay on mobile */
@media (max-width: 600px), (hover: none) and (pointer: coarse) and (max-width: 900px) {
    .desktop-fs-overlay {
        display: none !important;
    }
}

/* Dark mode support for overlay */
[data-theme="dark"] .desktop-fs-card {
    background: var(--bg-secondary);
}

[data-theme="dark"] .desktop-fs-icon {
    background: var(--accent-light);
    color: var(--accent-color);
}

[data-theme="dark"] .desktop-fs-title {
    color: var(--text-primary);
}

[data-theme="dark"] .desktop-fs-text {
    color: var(--accent-color);
}

[data-theme="dark"] .desktop-fs-btn-secondary {
    color: var(--accent-color);
}


/* Mobile holding frame (prevents auto-loading the map on mobile) */
.mobile-hold {
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 20px;
    background: #ffffff;
    font-family: 'Muli', sans-serif;
    min-height: 400px;
    border-radius: 12px;
}

.mobile-hold-card {
    max-width: 360px;
    width: 100%;
    text-align: center;
}

.mobile-hold-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px auto;
    background: #f0f4ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2d6cdf;
}

.mobile-hold-icon svg {
    width: 28px;
    height: 28px;
}

.mobile-hold-title {
    font-size: 20px;
    font-weight: 900;
    color: #2b3a4b;
    margin-bottom: 10px;
}

.mobile-hold-text {
    font-size: 14px;
    font-weight: 600;
    color: #5777a9;
    line-height: 1.5;
    margin: 0 0 24px 0;
}

.mobile-hold-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.mobile-load-btn {
    appearance: none;
    border: none;
    border-radius: 10px;
    padding: 14px 24px;
    font-size: 15px;
    font-weight: 800;
    cursor: pointer;
    background: #2d6cdf;
    color: #ffffff;
    transition: opacity 0.15s, transform 0.15s;
}

.mobile-load-btn:hover {
    opacity: 0.92;
    transform: translateY(-1px);
}

.mobile-hold-hint {
    font-size: 13px;
    font-weight: 600;
    color: #5777a9;
    opacity: 0.8;
}

@media (max-width: 600px), (hover: none) and (pointer: coarse) and (max-width: 900px) {
    #map-wrapper.mobile-hold-active .mobile-hold {
        display: flex;
    }
    #map-wrapper.mobile-hold-active #map-shell {
        display: none !important;
    }
    #map-wrapper.mobile-hold-active .mobile-notice {
        display: none !important;
    }
}

/* --- 4. Popup Styling --- */
.plant-popup .maplibregl-popup-content { 
    padding: 0; 
    border-radius: 12px; 
    overflow: hidden; 
    box-shadow: 0 4px 20px rgba(0,0,0,0.12); 
    border: 1px solid #e9ecef;
}
.plant-popup .plant-popup-inner { 
    margin: 0; 
    min-width: 280px; 
    font-family: 'Muli', sans-serif; 
}

/* Close button - subtle on light header */
.plant-popup .maplibregl-popup-close-button {
    color: #636e72;
    font-size: 20px !important;
    font-weight: 400 !important;
    width: 28px !important;
    height: 28px !important;
    line-height: 26px !important;
    text-align: center;
    padding: 0 !important;
    top: 10px !important;
    right: 10px !important;
    background: rgba(0,0,0,0.05) !important;
    border-radius: 50% !important;
    transition: background 0.2s ease !important;
    z-index: 10;
}
.plant-popup .maplibregl-popup-close-button:hover {
    background: rgba(0,0,0,0.1);
    color: #2d3436;
}

/* New Popup Header - Clean light style with accent */
.popup-header-new {
    background: #fff;
    padding: 16px 18px 14px;
    position: relative;
    border-bottom: 1px solid #e9ecef;
}
.popup-header-new::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: #5777a9;
}
.popup-country-new {
    font-size: 11px;
    font-weight: 800;
    color: #2d3436;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    margin: 0 0 2px 0;
}

.popup-title-new {
    font-size: 28px;
    font-weight: 700;
    color: #5777a9 !important;
    margin: 0 0 6px 0 !important;
    letter-spacing: -0.4px;
    line-height: 1.05;
}
.popup-subtitle-new {
    font-size: 11px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

/* Stats Row */
.stats-row {
    display: flex;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}
    .stat-item {
    flex: 1;
    padding: 10px 8px;
    text-align: center;
    border-right: 1px solid #e9ecef;
}
.stat-item:last-child {
    border-right: none;
}
.stat-value {
    font-size: 15px;
    font-weight: 800;
    color: #2d3436;
    display: block;
}
.stat-label {
    font-size: 9px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 2px;
    display: block;
}

/* Reactor Section */
.reactor-section {
    padding: 12px 16px 16px;
    background: #fff;
}
.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.section-title {
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #8898aa;
}
.click-hint {
    font-size: 10px;
    font-weight: 700;
    color: #5777a9;
    display: flex;
    align-items: center;
    gap: 4px;
    animation: pulse-hint 2s ease-in-out infinite;
}
@keyframes pulse-hint {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
}

/* CTA Banner for compact mode */
.cta-banner {
    background: #5777a9;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: white;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 0 0 11px 11px;
}
.cta-banner svg {
    width: 12px;
    height: 12px;
}

/* --- Option A: Card Layout (≤5 reactors) --- */
.reactor-grid-cards {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.reactor-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.15s ease;
    position: relative;
    cursor: pointer;
    border: 1px solid #e9ecef;
    background: #fff;
}
.reactor-card::after {
    content: '→';
    position: absolute;
    right: 10px;
    font-size: 13px;
    font-weight: 800;
    opacity: 0;
    transform: translateX(-8px);
    transition: all 0.15s ease;
    color: #5777a9;
}
.reactor-card:hover::after {
    opacity: 1;
    transform: translateX(0);
}
.reactor-card:hover {
    border-color: #5777a9;
    background: #f8f9ff;
}

/* Card status styles */
.reactor-card.operable {
    border-left: 3px solid #00b894;
}
.reactor-card.operable:hover {
    border-color: #00b894;
    border-left-color: #00b894;
    background: #f0fff4;
}
.reactor-card.operable::after { color: #00b894; }

.reactor-card.construction {
    border-left: 3px solid #fdcb6e;
}
.reactor-card.construction:hover {
    border-color: #fdcb6e;
    border-left-color: #fdcb6e;
    background: #fffdf0;
}
.reactor-card.construction::after { color: #e17055; }

.reactor-card.shutdown {
    border-left: 3px solid #636e72;
}
.reactor-card.shutdown:hover {
    border-color: #636e72;
    border-left-color: #636e72;
    background: #f8f9fa;
}
.reactor-card.shutdown::after { color: #636e72; }

/* Status Badge */
.status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    flex-shrink: 0;
}
.status-badge svg {
    width: 12px;
    height: 12px;
}
.status-badge.operable {
    background: #e6fff4;
    color: #00b894;
}
.status-badge.construction {
    background: #fff8e6;
    color: #e17055;
}
.status-badge.shutdown {
    background: #f0f0f0;
    color: #636e72;
}

.reactor-info {
    flex: 1;
    min-width: 0;
}
.reactor-name {
    font-size: 12px;
    font-weight: 700;
    color: #2d3436;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.reactor-status-label {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 1px;
}
.reactor-status-label.operable { color: #00b894; }
.reactor-status-label.construction { color: #e17055; }
.reactor-status-label.shutdown { color: #636e72; }

/* --- Option B: Button Grid (6+ reactors) --- */
.waffle-grid-new {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}
.waffle-btn {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: all 0.15s ease;
    position: relative;
    cursor: pointer;
}
.waffle-btn svg {
    width: 13px;
    height: 13px;
    transition: transform 0.15s ease;
}
.waffle-btn:hover {
    transform: scale(1.15);
    z-index: 10;
}
.waffle-btn:hover svg {
    transform: scale(1.1);
}

/* Button status styles */
.waffle-btn.operable {
    background: #00b894;
    color: white;
    box-shadow: 0 2px 6px rgba(0,184,148,0.4);
}
.waffle-btn.operable:hover {
    background: #00a884;
    box-shadow: 0 4px 12px rgba(0,184,148,0.5);
}

.waffle-btn.construction {
    background: #fdcb6e;
    color: #2d3436;
    box-shadow: 0 2px 6px rgba(253,203,110,0.4);
}
.waffle-btn.construction:hover {
    background: #fcc34d;
    box-shadow: 0 4px 12px rgba(253,203,110,0.5);
}

.waffle-btn.shutdown {
    background: #b2bec3;
    color: #2d3436;
    box-shadow: 0 2px 6px rgba(99,110,114,0.3);
}
.waffle-btn.shutdown:hover {
    background: #a0acb1;
    box-shadow: 0 4px 12px rgba(99,110,114,0.4);
}

/* Compact Legend */
.compact-legend {
    display: flex;
    gap: 12px;
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px dashed #dfe6e9;
}
.legend-chip {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 9px;
    font-weight: 700;
    color: #636e72;
}
.legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.legend-dot.operable { background: #00b894; }
.legend-dot.construction { background: #fdcb6e; }
.legend-dot.planned { background: #74b9ff; }
.legend-dot.shutdown { background: #636e72; }

.hover-pulse-ring { border-radius: 50%; pointer-events: none; animation: hover-ring-pulse 1s ease-in-out infinite; }
@keyframes hover-ring-pulse { 0%, 100% { box-shadow: 0 0 0 6px rgba(87,119,169,0.6), 0 0 20px rgba(87,119,169,0.5); } 50% { box-shadow: 0 0 0 12px rgba(87,119,169,0.3), 0 0 36px rgba(87,119,169,0.25); } }

/* --- 5. Map Legend Overlay --- */
.map-legend {
    position: absolute;
    bottom: 16px;
    left: 16px;
    z-index: 1000;
    background: white;
    padding: 8px 10px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    font-size: 11px;
    font-weight: 600;
    max-width: calc(100% - 32px);
    display: flex;
    align-items: center;
}

.map-legend-items{
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;      /* v5.7.145: Allow wrap so all items visible */
    row-gap: 6px;
}

.map-legend-title {
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #636e72;
    margin-bottom: 8px;
}

.map-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    color: #2d3436;
    white-space: nowrap;
}

.map-legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.map-legend-dot.green { background: #00b894; }
.map-legend-dot.yellow { background: #fdcb6e; }
.map-legend-dot.blue { background: #74b9ff; }
.map-legend-dot.grey { background: #636e72; }

/* --- 6. Cluster Styling (v5.7.147: uniform light blue) --- */

/* --- 7. Mobile Responsive Styles --- */
@media (max-width: 600px) {
    .controls-ui {
        top: calc(10px + env(safe-area-inset-top));
        left: 10px;
        right: calc(94px + env(safe-area-inset-right)); /* Leave space for map controls on right */
        flex-wrap: nowrap;
        align-items: center;
    }
    .search-wrapper {
        flex: 1 1 auto;
        min-width: 0;
    }
    /* Keep mobile icon buttons (filters/view) consistently sized & aligned */
    .controls-ui .dropdown-wrapper {
        flex: 0 0 40px;
    }
    .controls-ui .dropdown-btn {
        width: 40px;
        height: 40px;
        padding: 0;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .controls-ui .search-input {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        font-size: 16px;
        padding: 10px 36px 10px 14px;
    }
    .search-clear-btn {
        right: 8px;
        width: 20px;
        height: 20px;
    }
    .search-clear-btn svg {
        width: 10px;
        height: 10px;
    }
    .home-btn {
        width: 40px;
        height: 40px;
    }
    .home-btn svg {
        width: 18px;
        height: 18px;
    }
    .search-results {
        max-height: 200px;
    }
    .plant-popup .plant-popup-inner {
        min-width: 260px;
        max-width: 280px;
    }
    .popup-country-new {
        font-size: 10px;
    }
    .popup-title-new {
        font-size: 22px;
    }
    .popup-subtitle-new {
        font-size: 10px;
    }
    .stat-item {
        padding: 10px 8px;
    }
    .stat-value {
        font-size: 14px;
    }
    .reactor-section {
        padding: 12px 14px 14px;
    }
    .waffle-btn {
        width: 30px;
        height: 30px;
    }
    .map-legend {
        bottom: 16px;
        left: 10px;
        padding: 10px 12px;
        font-size: 11px;
        max-width: calc(100% - 20px);
    }

    /* v5.7.145: Smaller legend items on mobile for better fit */
    .map-legend-items {
        gap: 8px;
        row-gap: 4px;
    }
    .map-legend-item {
        font-size: 10px;
        gap: 4px;
    }
    .map-legend-dot {
        width: 8px;
        height: 8px;
    }

    .map-controls-group {
        top: calc(10px + env(safe-area-inset-top));
        right: calc(10px + env(safe-area-inset-right));
    }

    .map-control-btn,
    .share-btn {
        width: 36px;
        height: 36px;
    }

    .map-control-btn svg,
    .share-btn svg {
        width: 16px;
        height: 16px;
    }
    
    .view-mode-popup {
        right: calc(100% + 8px);
        padding: 6px;
    }
    
    .view-mode-option {
        padding: 8px 10px;
        font-size: 12px;
    }
    
    /* Mobile fullscreen fixes */
    #map-wrapper.fullscreen {
        height: 100% !important;
        height: 100dvh !important; /* Dynamic viewport height for mobile browsers */
    }
    
    #map-wrapper.fullscreen .map-legend {
        bottom: 16px;
        left: 10px;
        max-width: calc(100vw - 110px);
    }

    #map-wrapper.fullscreen .controls-ui {
        top: calc(10px + env(safe-area-inset-top));
        left: 10px;
        right: calc(94px + env(safe-area-inset-right));
    }
    
    #map-wrapper.fullscreen .map-controls-group {
        top: 10px;
        right: 10px;
    }
}

@media (max-width: 400px) {
    .controls-ui {
        gap: 6px;
    }
    .home-btn {
        width: 38px;
        height: 38px;
    }
}

/* Screen reader only */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

/* Dropdown Wrapper - contains toggle and panel */
.dropdown-wrapper {
    position: relative;
    display: none;
}

.dropdown-wrapper.visible {
    display: block;
}

/* Dropdown Button */
.dropdown-btn {
    display: flex;
    background: white;
    color: #2d3436;
    border: none;
    padding: 10px 14px;
    border-radius: 20px;
    cursor: pointer;
    font-weight: 700;
    font-family: 'Muli', sans-serif;
    font-size: 13px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: all 0.2s ease;
    align-items: center;
    gap: 6px;
    height: 44px;
}

.dropdown-btn:hover {
    background: #f8f9fa;
}

.dropdown-btn:focus {
    outline: none;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,123,255,0.3);
}

.dropdown-btn.active {
    background: #5777a9;
    color: white;
}

.dropdown-btn svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}

.dropdown-btn .btn-text {
    white-space: nowrap;
}

.dropdown-btn .chevron {
    width: 14px;
    height: 14px;
    transition: transform 0.2s ease;
    margin-left: 2px;
}

.dropdown-btn.active .chevron {
    transform: rotate(180deg);
}

/* Dropdown Panel */
.dropdown-panel {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 1001;
    background: white;
    padding: 0;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
    font-size: 13px;
    display: none;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: all 0.25s ease;
    min-width: 200px;
}

/* Connector arrow pointing up */
.dropdown-panel::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 20px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid white;
    filter: drop-shadow(0 -2px 2px rgba(0,0,0,0.05));
}

.dropdown-panel.visible {
    display: block;
}

.dropdown-panel.expanded {
    max-height: 400px;
    opacity: 1;
    padding: 16px 18px;
}

.dropdown-section-label {
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #8898aa;
    margin-bottom: 10px;
    margin-top: 4px;
}

.dropdown-section-label:first-child {
    margin-top: 0;
}

.dropdown-option {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    user-select: none;
    padding: 4px 0;
}

.dropdown-option:last-child {
    margin-bottom: 0;
}

.dropdown-option input[type="checkbox"],
.dropdown-option input[type="radio"] {
    width: 18px;
    height: 18px;
    margin: 0;
    cursor: pointer;
    accent-color: #5777a9;
    flex-shrink: 0;
}

.dropdown-option label {
    font-weight: 600;
    color: #2d3436;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    flex: 1;
}

.dropdown-option .option-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}

.dropdown-option .option-dot.green { background: #00b894; }
.dropdown-option .option-dot.yellow { background: #fdcb6e; }
.dropdown-option .option-dot.grey { background: #636e72; }

.dropdown-option .option-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    opacity: 0.7;
}

.dropdown-option input:checked + label .option-icon {
    opacity: 1;
    color: #5777a9;
}

/* View Mode Button Group - compact toggle buttons */
.view-mode-btn-group {
    display: flex;
    gap: 6px;
    width: 100%;
}

.view-mode-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 10px 6px;
    background: #f8f9fa;
    border: 2px solid #e9ecef;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'Muli', sans-serif;
}

.view-mode-btn:hover {
    background: #f0f2f5;
    border-color: #d0d5db;
}

.view-mode-btn.active {
    background: rgba(87, 119, 169, 0.1);
    border-color: #5777a9;
}

.view-mode-btn svg {
    width: 20px;
    height: 20px;
    stroke: #636e72;
    transition: stroke 0.2s ease;
}

.view-mode-btn.active svg {
    stroke: #5777a9;
}

.view-mode-btn-label {
    font-size: 10px;
    font-weight: 700;
    color: #636e72;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    transition: color 0.2s ease;
}

.view-mode-btn.active .view-mode-btn-label {
    color: #5777a9;
}

/* Labels Toggle Row (under view mode buttons) */
.labels-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0 6px 0;
    margin-top: 8px;
    border-top: 1px solid #f1f3f5;
}

.labels-toggle-row .labels-toggle-label {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    font-family: 'Muli', sans-serif;
}

.labels-toggle-row .labels-toggle-switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    flex-shrink: 0;
}

.labels-toggle-row .labels-toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.labels-toggle-row .labels-toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.2s;
    border-radius: 22px;
}

.labels-toggle-row .labels-toggle-slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.2s;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.labels-toggle-row .labels-toggle-switch input:checked + .labels-toggle-slider {
    background-color: #5777a9;
}

.labels-toggle-row .labels-toggle-switch input:checked + .labels-toggle-slider:before {
    transform: translateX(18px);
}

/* Disabled state for labels toggle */
.labels-toggle-row.disabled {
    opacity: 0.45;
    pointer-events: none;
}

.labels-toggle-row.disabled .labels-toggle-label {
    color: #adb5bd;
}

.labels-toggle-row.disabled .labels-toggle-slider {
    cursor: not-allowed;
    background-color: #e9ecef;
}

.labels-toggle-row.disabled .labels-toggle-switch input:checked + .labels-toggle-slider {
    background-color: #ced4da;
}

/* Dark mode for labels toggle */
[data-theme="dark"] .labels-toggle-row {
    border-top-color: #3d4750;
}

[data-theme="dark"] .labels-toggle-row .labels-toggle-label {
    color: #e9ecef;
}

[data-theme="dark"] .labels-toggle-row .labels-toggle-slider {
    background-color: #495057;
}

[data-theme="dark"] .labels-toggle-row .labels-toggle-switch input:checked + .labels-toggle-slider {
    background-color: #7c9fd4;
}

[data-theme="dark"] .labels-toggle-row.disabled {
    opacity: 0.4;
}

[data-theme="dark"] .labels-toggle-row.disabled .labels-toggle-label {
    color: #6c757d;
}

[data-theme="dark"] .labels-toggle-row.disabled .labels-toggle-slider {
    background-color: #3d4750;
}

[data-theme="dark"] .labels-toggle-row.disabled .labels-toggle-switch input:checked + .labels-toggle-slider {
    background-color: #5a6268;
}

/* Sidebar Display Options Group styling */
.sidebar-display-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 4px;
}

.sidebar-display-options .dropdown-option {
    margin-bottom: 0;
    padding: 6px 0;
}

/* Sidebar Filters Group styling */
.sidebar-filters-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sidebar-filters-group .dropdown-option {
    margin-bottom: 0;
    padding: 6px 0;
}

.filter-subsection-title {
    font-size: 10px;
    font-weight: 700;
    color: #636e72;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-top: 12px;
    margin-bottom: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid #f1f3f5;
}

.filter-subsection-title:first-child {
    margin-top: 0;
}



/* --- Sidebar checkbox rows: cleaner card-style options --- */
#map-sidebar .sidebar-display-options .dropdown-option,
#map-sidebar .sidebar-filters-group .dropdown-option {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 14px;
    padding: 10px 12px;
    gap: 12px;
    margin: 0;
    min-height: 44px;
    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

#map-sidebar .sidebar-display-options .dropdown-option:hover,
#map-sidebar .sidebar-filters-group .dropdown-option:hover {
    background: #f1f3f5;
    border-color: #d0d5db;
}

#map-sidebar .sidebar-display-options .dropdown-option.option-checked,
#map-sidebar .sidebar-filters-group .dropdown-option.option-checked {
    background: rgba(87, 119, 169, 0.10);
    border-color: rgba(87, 119, 169, 0.45);
    box-shadow: 0 0 0 3px rgba(87, 119, 169, 0.10) inset;
}

#map-sidebar .sidebar-display-options .dropdown-option label,
#map-sidebar .sidebar-filters-group .dropdown-option label {
    font-weight: 700;
}

#map-sidebar .sidebar-display-options .dropdown-option input[type="checkbox"],
#map-sidebar .sidebar-filters-group .dropdown-option input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: 2px solid #cbd5e1;
    background: #fff;
    display: grid;
    place-content: center;
    flex-shrink: 0;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

#map-sidebar .sidebar-display-options .dropdown-option input[type="checkbox"]::before,
#map-sidebar .sidebar-filters-group .dropdown-option input[type="checkbox"]::before {
    content: "";
    width: 10px;
    height: 6px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg) scale(0);
    transition: transform 0.12s ease;
}

#map-sidebar .sidebar-display-options .dropdown-option input[type="checkbox"]:checked,
#map-sidebar .sidebar-filters-group .dropdown-option input[type="checkbox"]:checked {
    background: #5777a9;
    border-color: #5777a9;
}

#map-sidebar .sidebar-display-options .dropdown-option input[type="checkbox"]:checked::before,
#map-sidebar .sidebar-filters-group .dropdown-option input[type="checkbox"]:checked::before {
    transform: rotate(-45deg) scale(1);
}

#map-sidebar .sidebar-display-options .dropdown-option input[type="checkbox"]:focus-visible,
#map-sidebar .sidebar-filters-group .dropdown-option input[type="checkbox"]:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(87, 119, 169, 0.25);
}

/* Filter sub-sections should read as nested *within* Filters */
#map-sidebar .sidebar-filters-group{
    gap: 12px; /* space between sub-groups */
}

#map-sidebar .filter-subsection{
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-left: 10px;
    border-left: 2px solid #eef1f4;
}

#map-sidebar .filter-subsection-title{
    margin: 0;
    font-size: 11px;
    font-weight: 900;
    color: #2d3436;
    text-transform: none;
    letter-spacing: 0.02em;
}

#map-sidebar .filter-subsection:first-child{
    margin-top: 0;
}
/* Radio option styling */
.dropdown-option.radio-option {
    padding: 6px 8px;
    margin-left: -8px;
    margin-right: -8px;
    border-radius: 6px;
    transition: background 0.15s ease;
}

.dropdown-option.radio-option:hover {
    background: #f8f9fa;
}

.dropdown-option.radio-option:has(input:checked) {
    background: rgba(108, 122, 224, 0.1);
}

.dropdown-option.radio-option:has(input:checked) label {
    color: #5777a9;
}

.dropdown-divider {
    height: 1px;
    background: #e9ecef;
    margin: 12px 0;
}

@media (max-width: 600px) {
    .dropdown-wrapper {
        position: relative;
    }
    
    .dropdown-panel {
        left: auto;
        right: 0;
        min-width: 180px;
        max-width: calc(100vw - 80px);
    }
    
    .dropdown-panel::before {
        left: auto;
        right: 12px;
    }
    
    .dropdown-panel.expanded {
        padding: 14px;
        max-height: 60vh;
        overflow-y: auto;
    }
    
    .dropdown-btn {
        padding: 10px 12px;
        font-size: 12px;
    }
    
    .dropdown-btn .chevron {
        display: none;
    }
    
    .dropdown-btn .btn-text {
        display: none;
    }
}

/* --- 10. Country Deep-Dive Panel --- */
.country-panel {
    position: absolute;
    top: 0;
    right: 0;
    width: 340px;
    height: 100%;
    background: white;
    box-shadow: -4px 0 20px rgba(0,0,0,0.15);
    z-index: 1001;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    font-family: 'Muli', sans-serif;
}

.country-panel.open {
    transform: translateX(0);
}

.country-panel-header {
    background: linear-gradient(135deg, #5777a9 0%, #4a6898 100%);
    color: white;
    padding: 20px;
    position: relative;
    flex-shrink: 0;
}

.country-panel-close {
    position: absolute;
    top: 12px;
    right: 12px;
    background: rgba(255,255,255,0.2);
    border: none;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.country-panel-close:hover {
    background: rgba(255,255,255,0.3);
}

.country-panel-close svg {
    width: 18px;
    height: 18px;
}

.country-panel-title {
    font-size: 24px;
    font-weight: 800;
    margin: 0 0 4px 0;
    padding-right: 40px;
}

.country-panel-subtitle {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.85;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.country-panel-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0;
}

.country-stats-header {
    font-size: 9px;
    font-weight: 800;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    padding: 10px 20px 0;
}

.country-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);  /* v5.7.145: 4 columns for single-line stats */
    gap: 1px;
    background: #e9ecef;
    border-bottom: 1px solid #e9ecef;
}

.country-stat-box {
    background: white;
    padding: 16px 12px;
    text-align: center;
}

.country-stat-value {
    font-size: 24px;
    font-weight: 800;
    color: #2d3436;
    line-height: 1;
}

.country-stat-value.green { color: #00b894; }
.country-stat-value.yellow { color: #e17055; }
.country-stat-value.blue { color: #74b9ff; }
.country-stat-value.grey { color: #636e72; }

.country-stat-label {
    font-size: 9px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 6px;
}

.country-section {
    padding: 16px 20px;
    border-bottom: 1px solid #f1f3f5;
}

.country-section:last-child {
    border-bottom: none;
}

.country-section-title {
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #8898aa;
    margin-bottom: 12px;
}

.country-capacity-bar {
    height: 8px;
    background: #f1f3f5;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
}

.country-capacity-fill {
    height: 100%;
    background: linear-gradient(90deg, #00b894 0%, #00cec9 100%);
    border-radius: 4px;
    transition: width 0.5s ease;
}

.country-capacity-label {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: #636e72;
    font-weight: 600;
}

.country-timeline {
    position: relative;
    padding-left: 20px;
}

.country-timeline-item {
    position: relative;
    padding-bottom: 16px;
    padding-left: 16px;
    border-left: 2px solid #e9ecef;
}

.country-timeline-item:last-child {
    padding-bottom: 0;
    border-left-color: transparent;
}

.country-timeline-item::before {
    content: '';
    position: absolute;
    left: -6px;
    top: 2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #5777a9;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.country-timeline-year {
    font-size: 11px;
    font-weight: 800;
    color: #5777a9;
    margin-bottom: 2px;
}

.country-timeline-event {
    font-size: 13px;
    font-weight: 600;
    color: #2d3436;
    line-height: 1.4;
}

.country-plant-list {
    max-height: 200px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.country-plant-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
    transition: all 0.15s ease;
    background: #f8f9fa;
    border-radius: 10px;
    border: 1px solid #e9ecef;
}

.country-plant-item:hover {
    border-color: #5777a9;
    background: #f8f9ff;
}

.country-plant-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.country-plant-dot.green { background: #00b894; }
.country-plant-dot.yellow { background: #fdcb6e; }
.country-plant-dot.grey { background: #636e72; }
.country-plant-dot.blue { background: #74b9ff; }

.country-plant-info {
    flex: 1;
    min-width: 0;
}

.country-plant-name {
    font-size: 13px;
    font-weight: 700;
    color: #2d3436;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.country-plant-reactors {
    font-size: 11px;
    color: #8898aa;
    font-weight: 600;
}

.country-plant-capacity {
    font-size: 12px;
    font-weight: 700;
    color: #636e72;
    flex-shrink: 0;
}


.country-highlight-stat {
    background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
    border-radius: 12px;
    padding: 16px;
    text-align: center;
    border: 1px solid #e9ecef;
    flex: 1;
}

.country-highlights-row {
    display: flex;
    gap: 12px;
}

.country-highlights-row .country-highlight-stat {
    padding: 12px;
}

.country-highlights-row .country-highlight-value {
    font-size: 28px;
}

.country-highlights-row .country-highlight-unit {
    font-size: 12px;
}

.country-highlights-row .country-highlight-label {
    font-size: 9px;
    margin-top: 6px;
}

.country-highlight-value {
    font-size: 36px;
    font-weight: 800;
    color: #2d3436;
    line-height: 1;
}

.country-highlight-unit {
    font-size: 14px;
    font-weight: 700;
    color: #8898aa;
    margin-left: 4px;
}

.country-highlight-label {
    font-size: 11px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 8px;
}

.country-compare-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}

.country-compare-row:last-child {
    margin-bottom: 0;
}

.country-compare-label {
    font-size: 12px;
    font-weight: 600;
    color: #636e72;
    width: 80px;
    flex-shrink: 0;
}

.country-compare-bar {
    flex: 1;
    height: 6px;
    background: #f1f3f5;
    border-radius: 3px;
    overflow: hidden;
}

.country-compare-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.5s ease;
}

.country-compare-fill.primary {
    background: #5777a9;
}

.country-compare-fill.secondary {
    background: #b2bec3;
}

.country-compare-value {
    font-size: 12px;
    font-weight: 700;
    color: #2d3436;
    width: 50px;
    text-align: right;
    flex-shrink: 0;
}

.country-empty-state {
    text-align: center;
    padding: 40px 20px;
    color: #8898aa;
}

.country-empty-state svg {
    width: 48px;
    height: 48px;
    margin-bottom: 12px;
    opacity: 0.5;
}

.country-empty-state p {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}

/* Country panel responsive */
@media (max-width: 600px) {
    /* Mobile: hide latest-year Output section in the country summary */
    .country-output-section { display: none !important; }

    .country-panel {
        /* Mobile half-screen panel with expand/collapse */
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: auto;
        width: 100%;
        height: 50vh;
        height: 50dvh;
        max-height: 100vh;
        max-height: 100dvh;

        transform: translateY(100%);
        border-radius: 18px 18px 0 0;
        z-index: 4000;
        box-shadow: 0 -10px 34px rgba(0,0,0,0.22);

        /* Prevent the sheet from "pulling" the page behind it on iOS */
        overscroll-behavior: contain;
        
        /* Smooth transitions for expand/collapse */
        transition: height 0.3s ease, border-radius 0.3s ease;
    }

    /* Expanded state - full screen */
    .country-panel.expanded {
        height: 100vh;
        height: 100dvh;
        border-radius: 0;
    }

    /* Collapsed state - peek, shows more map v5.7.172 */
    .country-panel.collapsed {
        height: 30vh;
        height: 30dvh;
    }

    /* Grab handle for drag interaction */
    .country-panel::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translateX(-50%);
        width: 44px;
        height: 5px;
        border-radius: 999px;
        background: rgba(0, 0, 0, 0.25);
        z-index: 2;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }

    /* Hide grab handle when fully expanded */
    .country-panel.expanded::before {
        opacity: 0;
    }

    .country-panel.open {
        transform: translateY(0);
    }

    /* Prevent content from being hidden behind iOS home indicator / Safari bars */
    .country-panel-content {
        padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
        -webkit-overflow-scrolling: touch;
    }

    /* --- Mobile: compact single-row header (title + close) --- */
    .country-panel-header {
        display: flex;
        align-items: center;
        gap: 12px;

        padding: 18px 14px 10px 14px;
        border-radius: 18px 18px 0 0;
        background: #fff;
        color: #2d3436;
        border-top: 6px solid #5777a9;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        cursor: grab;
        touch-action: none;
        user-select: none;
        transition: padding-top 0.3s ease, border-radius 0.3s ease;
    }

    .country-panel.expanded .country-panel-header {
        padding-top: calc(14px + env(safe-area-inset-top, 0px));
        border-radius: 0;
    }

    .country-panel-header:active {
        cursor: grabbing;
    }

    .country-panel-title {
        flex: 1 1 auto;
        order: 1;
        font-size: 18px;
        margin: 0;
        padding-right: 0;
        line-height: 1.15;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* Put the close button on the right, aligned with the title */
    .country-panel-close {
        position: static;
        top: auto;
        right: auto;
        order: 2;
        margin-left: auto;

        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: rgba(0,0,0,0.06);
        color: #2d3436;
    }

    .country-panel-close:hover {
        background: rgba(0,0,0,0.10);
    }

    /* Subtitle is redundant on small screens; hide to save vertical space */
    .country-panel-subtitle {
        display: none;
    }


    /* v5.7.145: 4-column grid with compact sizing for single-line stats */
    .country-stats-grid {
        grid-template-columns: repeat(4, 1fr);
    }
    .country-stat-box {
        padding: 12px 6px;
    }
    .country-stat-value {
        font-size: 18px;
    }
    .country-stat-label {
        font-size: 8px;
        letter-spacing: 0.3px;
    }
}

/* ==============================
   Mobile Plant Panel (bottom sheet)
   ============================== */
.plant-panel {
    position: absolute;
    top: 0;
    right: 0;
    width: 340px;
    height: 100%;
    background: white;
    box-shadow: -4px 0 20px rgba(0,0,0,0.15);
    z-index: 1001;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    font-family: 'Muli', sans-serif;
}

.plant-panel.open {
    transform: translateX(0);
}

.plant-panel-header {
    background: linear-gradient(135deg, #5777a9 0%, #4a6898 100%);
    color: white;
    padding: 20px;
    position: relative;
    flex-shrink: 0;
}

.plant-panel-close {
    position: absolute;
    top: 12px;
    right: 12px;
    background: rgba(255,255,255,0.2);
    border: none;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.plant-panel-close:hover {
    background: rgba(255,255,255,0.3);
}

.plant-panel-close svg {
    width: 18px;
    height: 18px;
}

.plant-panel-title {
    font-size: 24px;
    font-weight: 800;
    margin: 0 0 4px 0;
    padding-right: 40px;
    color: white !important;
}

.plant-panel-subtitle {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.85;
    text-transform: uppercase;
    letter-spacing: 1px;
    background: none;
    border: none;
    padding: 0;
    color: inherit;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
}

.plant-panel-status {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 8px;
    background: rgba(255,255,255,0.2);
}

.plant-panel-status.green {
    background: rgba(0, 184, 148, 0.3);
}

.plant-panel-status.yellow {
    background: rgba(253, 203, 110, 0.4);
}

.plant-panel-status.blue {
    background: rgba(116, 185, 255, 0.3);
}

.plant-panel-status.grey {
    background: rgba(255,255,255,0.2);
}

.plant-panel-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0;
}

.plant-stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1px;
    background: #e9ecef;
    border-bottom: 1px solid #e9ecef;
}

.plant-stat-box {
    background: white;
    padding: 16px 12px;
    text-align: center;
}

.plant-stat-value {
    font-size: 24px;
    font-weight: 800;
    color: #2d3436;
    line-height: 1;
}

.plant-stat-label {
    font-size: 9px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 6px;
}

.plant-section {
    padding: 16px 20px;
    border-bottom: 1px solid #f1f3f5;
}

.plant-section-title {
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #8898aa;
    margin-bottom: 12px;
}

.plant-reactor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* v5.7.128: Collapsible reactor list in mobile plant panel */
.plant-section-title.collapsible {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.plant-section-title.collapsible .section-toggle-icon {
    width: 16px;
    height: 16px;
    color: #8898aa;
    transition: transform 0.2s ease;
    flex-shrink: 0;
}
.plant-section.expanded .section-toggle-icon {
    transform: rotate(180deg);
}
.plant-reactor-list.collapsible {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}
.plant-section.expanded .plant-reactor-list.collapsible {
    max-height: 2000px;
}

/* v5.7.129: Collapsible plant list in mobile country panel */
.country-section-title.collapsible {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.country-section-title.collapsible .section-toggle-icon {
    width: 16px;
    height: 16px;
    color: #8898aa;
    transition: transform 0.2s ease;
    flex-shrink: 0;
}
.country-section.expanded .section-toggle-icon {
    transform: rotate(180deg);
}
.country-plant-list.collapsible {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}
.country-section.expanded .country-plant-list.collapsible {
    max-height: 5000px;
}

.plant-reactor-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: #f8f9fa;
    border-radius: 10px;
    border: 1px solid #e9ecef;
    text-decoration: none;
    color: inherit;
    transition: all 0.15s ease;
}

.plant-reactor-item:hover {
    border-color: #5777a9;
    background: #f8f9ff;
}

.plant-reactor-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.plant-reactor-dot.green { background: #00b894; }
.plant-reactor-dot.yellow { background: #fdcb6e; }
.plant-reactor-dot.grey { background: #636e72; }
.plant-reactor-dot.blue { background: #74b9ff; }

.plant-reactor-info {
    flex: 1;
    min-width: 0;
}

.plant-reactor-name {
    font-size: 13px;
    font-weight: 700;
    color: #2d3436;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.plant-reactor-details {
    font-size: 11px;
    font-weight: 600;
    color: #8898aa;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.plant-reactor-capacity {
    font-size: 12px;
    font-weight: 700;
    color: #636e72;
    flex-shrink: 0;
}

.plant-reactor-link {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    background: white;
    color: #5777a9;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none !important;
    flex-shrink: 0;
    transition: background 0.15s ease, color 0.15s ease;
}

.plant-reactor-link:hover {
    background: #5777a9;
    color: #ffffff;
}

.plant-reactor-link svg {
    width: 14px;
    height: 14px;
}

.plant-panel-country-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    margin: 16px 20px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
    color: #5777a9;
    cursor: pointer;
    transition: all 0.15s ease;
}

.plant-panel-country-link:hover {
    background: #5777a9;
    color: white;
    border-color: #5777a9;
}

.plant-panel-country-link svg {
    width: 16px;
    height: 16px;
}

/* Plant panel responsive - mobile half-screen with expand/collapse */
@media (max-width: 600px) {
    .plant-panel {
        /* Mobile half-screen panel with expand/collapse */
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: auto;
        width: 100%;
        height: 50vh;
        height: 50dvh;
        max-height: 100vh;
        max-height: 100dvh;
        transform: translateY(100%);
        border-radius: 18px 18px 0 0;
        z-index: 4000;
        box-shadow: 0 -10px 34px rgba(0,0,0,0.22);
        overscroll-behavior: contain;
        
        /* Smooth transitions for expand/collapse */
        transition: height 0.3s ease, border-radius 0.3s ease;
    }

    /* Expanded state - full screen */
    .plant-panel.expanded {
        height: 100vh;
        height: 100dvh;
        border-radius: 0;
    }

    /* Collapsed state - peek, shows more map v5.7.172 */
    .plant-panel.collapsed {
        height: 30vh;
        height: 30dvh;
    }

    /* Grab handle for drag interaction */
    .plant-panel::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translateX(-50%);
        width: 44px;
        height: 5px;
        border-radius: 999px;
        background: rgba(0, 0, 0, 0.25);
        z-index: 2;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }

    /* Hide grab handle when fully expanded */
    .plant-panel.expanded::before {
        opacity: 0;
    }

    .plant-panel.open {
        transform: translateY(0);
    }

    .plant-panel-content {
        padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
        -webkit-overflow-scrolling: touch;
    }

    .plant-panel-header {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px;
        padding: 18px 14px 10px 14px;
        border-radius: 18px 18px 0 0;
        background: #fff;
        color: #2d3436;
        border-top: 6px solid #5777a9;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        cursor: grab;
        touch-action: none;
        user-select: none;
        transition: padding-top 0.3s ease, border-radius 0.3s ease;
    }

    .plant-panel.expanded .plant-panel-header {
        padding-top: calc(14px + env(safe-area-inset-top, 0px));
        border-radius: 0;
    }

    .plant-panel-header:active {
        cursor: grabbing;
    }

    .plant-panel-title {
        flex: 1 1 0;
        min-width: 0;
        order: 1;
        font-size: 18px;
        margin: 0;
        padding-right: 0;
        line-height: 1.15;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #2d3436 !important;
    }

    .plant-panel-close {
        position: static;
        top: auto;
        right: auto;
        order: 3;
        margin-left: auto;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: rgba(0,0,0,0.06);
        color: #2d3436;
    }

    .plant-panel-close:hover {
        background: rgba(0,0,0,0.10);
    }

    .plant-panel-subtitle { /* v5.7.129: larger font, closer to plant name */
        display: block;
        order: 4;
        flex-basis: 100%;
        margin: 0;
        margin-top: -8px;
        font-size: 14px;
        font-weight: 700;
        text-transform: none;
        letter-spacing: 0;
        color: #5777a9;
        cursor: pointer;
        background: none;
        border: none;
        padding: 0;
        font-family: inherit;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .plant-panel-status {
        order: 2;
        flex-basis: auto;
        flex-shrink: 0;
        margin: 0;
        margin-left: 8px;
        width: fit-content;
        background: rgba(0,0,0,0.06);
        color: #2d3436;
        font-size: 9px;
        padding: 3px 8px;
    }

    .plant-panel-status.green {
        background: rgba(0, 184, 148, 0.15);
        color: #00b894;
    }

    .plant-panel-status.yellow {
        background: rgba(253, 203, 110, 0.3);
        color: #e17055;
    }

    .plant-panel-status.blue {
        background: rgba(116, 185, 255, 0.15);
        color: #74b9ff;
    }

    .plant-panel-status.grey {
        background: rgba(99, 110, 114, 0.15);
        color: #636e72;
    }

    .plant-stats-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .plant-stat-value {
        font-size: 20px;
    }

    .plant-panel-country-link {
        margin: 12px 14px;
    }

    .plant-section {
        padding: 14px;
    }
}

/* ==============================
   Mobile Filter Panel (bottom sheet)
   ============================== */
.filter-panel {
    display: none; /* Hidden on desktop */
}

@media (max-width: 600px) {
    .filter-panel {
        display: flex;
        flex-direction: column;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: auto;
        width: 100%;
        height: 50vh;
        height: 50dvh;
        max-height: 100vh;
        max-height: 100dvh;
        background: #fff;
        transform: translateY(100%);
        border-radius: 18px 18px 0 0;
        z-index: 4000;
        box-shadow: 0 -10px 34px rgba(0,0,0,0.22);
        overscroll-behavior: contain;
        transition: transform 0.3s ease, height 0.3s ease, border-radius 0.3s ease;
        font-family: 'Muli', sans-serif;
    }

    .filter-panel.expanded {
        height: 100vh;
        height: 100dvh;
        border-radius: 0;
    }

    /* Collapsed state - peek, shows more map v5.7.172 */
    .filter-panel.collapsed {
        height: 30vh;
        height: 30dvh;
    }

    .filter-panel::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translateX(-50%);
        width: 44px;
        height: 5px;
        border-radius: 999px;
        background: rgba(0, 0, 0, 0.25);
        z-index: 2;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }

    .filter-panel.expanded::before {
        opacity: 0;
    }

    .filter-panel.open {
        transform: translateY(0);
    }

    .filter-panel-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 18px 14px 10px 14px;
        border-radius: 18px 18px 0 0;
        background: #fff;
        color: #2d3436;
        border-top: 6px solid #5777a9;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        cursor: grab;
        touch-action: none;
        user-select: none;
        flex-shrink: 0;
        transition: padding-top 0.3s ease, border-radius 0.3s ease;
    }

    .filter-panel.expanded .filter-panel-header {
        padding-top: calc(14px + env(safe-area-inset-top, 0px));
        border-radius: 0;
    }

    .filter-panel-header:active {
        cursor: grabbing;
    }

    .filter-panel-title {
        flex: 1 1 auto;
        font-size: 18px;
        font-weight: 800;
        margin: 0;
        line-height: 1.15;
        color: #2d3436;
    }

    .filter-panel-close {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: rgba(0,0,0,0.06);
        border: none;
        color: #2d3436;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.2s;
        flex-shrink: 0;
    }

    .filter-panel-close:hover {
        background: rgba(0,0,0,0.10);
    }

    .filter-panel-close svg {
        width: 18px;
        height: 18px;
    }

    .filter-panel-content {
        flex: 1;
        overflow-y: auto;
        padding: 14px;
        padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
        -webkit-overflow-scrolling: touch;
    }

    .filter-section {
        margin-bottom: 20px;
    }

    .filter-section:last-child {
        margin-bottom: 0;
    }

    .filter-section-title {
        font-size: 11px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #8898aa;
        margin-bottom: 10px;
    }

    .filter-option {
        display: flex;
        align-items: center;
        padding: 12px 14px;
        background: #f8f9fa;
        border-radius: 10px;
        margin-bottom: 8px;
        cursor: pointer;
        transition: background 0.2s;
    }

    .filter-option:last-child {
        margin-bottom: 0;
    }

    .filter-option:hover {
        background: #f1f3f5;
    }

    .filter-option.checked {
        background: rgba(87, 119, 169, 0.1);
    }

    .filter-option input[type="checkbox"] {
        width: 20px;
        height: 20px;
        margin: 0;
        margin-right: 12px;
        accent-color: #5777a9;
        cursor: pointer;
    }

    .filter-option label {
        flex: 1;
        font-size: 14px;
        font-weight: 600;
        color: #2d3436;
        cursor: pointer;
        margin: 0;
    }

    /* Hide desktop filters dropdown on mobile when filter panel exists */
    .controls-ui .dropdown-wrapper#filtersWrapper {
        display: none;
    }
}

/* Dark mode for filter panel */
[data-theme="dark"] .filter-panel {
    background: #1a1a2e;
}

[data-theme="dark"] .filter-panel-header {
    background: #1a1a2e;
    color: #e0e0e0;
    border-bottom-color: rgba(255,255,255,0.1);
}

[data-theme="dark"] .filter-panel-title {
    color: #e0e0e0;
}

[data-theme="dark"] .filter-panel-close {
    background: rgba(255,255,255,0.1);
    color: #e0e0e0;
}

[data-theme="dark"] .filter-panel-close:hover {
    background: rgba(255,255,255,0.15);
}

[data-theme="dark"] .filter-panel::before {
    background: rgba(255, 255, 255, 0.3);
}

[data-theme="dark"] .filter-section-title {
    color: #8898aa;
}

[data-theme="dark"] .filter-option {
    background: rgba(255,255,255,0.05);
}

[data-theme="dark"] .filter-option:hover {
    background: rgba(255,255,255,0.08);
}

[data-theme="dark"] .filter-option.checked {
    background: rgba(87, 119, 169, 0.2);
}

[data-theme="dark"] .filter-option label {
    color: #e0e0e0;
}

/* v5.7.126: Mobile panel chart containers */
.mobile-chart-section {
    padding: 16px 14px 8px; /* v5.7.128: side padding to match .plant-section on mobile */
    border-top: 1px solid #e9ecef;
    margin-top: 12px;
}
.mobile-chart-section-title {
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #8898aa;
    margin: 0 0 8px 0;
}
.mobile-chart-wrap {
    position: relative;
    width: 100%;
}
.mobile-chart-canvas {
    width: 100%;
    height: 180px;
    display: block;
}
.mobile-chart-toggle {
    display: flex;
    gap: 4px;
    margin-bottom: 6px;
    background: #f1f3f5;
    border-radius: 6px;
    padding: 2px;
    width: fit-content;
}
.mobile-chart-subtitle {
    font-size: 10px;
    font-weight: 700;
    color: #8898aa;
    margin-bottom: 4px;
}
.mobile-chart-tooltip {
    position: absolute;
    top: -30px;
    background: rgba(45,52,54,0.95);
    color: #fff;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    pointer-events: none;
    display: none;
    z-index: 10;
    white-space: nowrap;
}
.mobile-timeline-container {
    position: relative;
    width: 100%;
    min-height: 60px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.mobile-deploy-container {
    position: relative;
    width: 100%;
    min-height: 120px;
}
.mobile-chart-empty {
    padding: 24px 16px;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: #8898aa;
}

/* v5.7.126: Dark mode for mobile charts */
[data-theme="dark"] .mobile-chart-section {
    border-top-color: rgba(255,255,255,0.08);
}
[data-theme="dark"] .mobile-chart-section-title {
    color: rgba(255,255,255,0.5);
}
[data-theme="dark"] .mobile-chart-subtitle {
    color: rgba(255,255,255,0.5);
}
[data-theme="dark"] .mobile-chart-toggle {
    background: rgba(255,255,255,0.08);
}
[data-theme="dark"] .mobile-chart-empty {
    color: rgba(255,255,255,0.4);
}

/* --- Hard override: keep plant names on-brand even if the host site/theme sets H3 colors --- */
#plantInfoBox h3#plantInfoName,
#plantInfoBox h3#plantInfoName *,
#plantInfoBox #plantInfoName {
    color: #5777a9 !important;
}
#plantInfoBox h3#plantInfoName {
    text-decoration: none !important;
}

/* --- Hard override: keep country names on-brand even if the host site/theme sets H3 colors --- */
#countryInfoBox h3#countryInfoName,
#countryInfoBox h3#countryInfoName *,
#countryInfoBox #countryInfoName {
    color: #5777a9 !important;
}
#countryInfoBox h3#countryInfoName {
    text-decoration: none !important;
}

/* --- Hard override: keep fullscreen plant detail title on-brand --- */
h3#plantDetailTitle,
h3#plantDetailTitle *,
#plantDetailTitle {
    color: #5777a9 !important;
}
h3#plantDetailTitle {
    text-decoration: none !important;
}

/* ------------------------------
   Plant detailed summary modal
------------------------------ */
body.modal-open {
    overflow: hidden;
}

.plant-info-actions {
    padding: 12px 0 0 0;
    display: none; /* Hidden - detailed view is automatic in fullscreen */
    border-top: 1px solid rgba(0,0,0,0.06);
    background: #fff;
}

/* Detailed summary CTA is now hidden - detailed view is automatic in fullscreen */


.plant-info-details-btn {
    width: 100%;
    border: none;
    border-radius: 0;
    padding: 12px 16px;
    background: #5777a9;
    color: #ffffff;
    cursor: pointer;
    font-family: 'Muli', sans-serif;
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.16);
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.plant-info-details-btn svg {
    position: absolute;
    right: 16px;
    width: 18px;
    height: 18px;
    opacity: 0.95;
}

.plant-info-details-btn:hover {
    background: #4f6fa2;
    transform: translateY(-1px);
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.16), 0 10px 22px rgba(0,0,0,0.16);
}

.plant-info-details-btn:active {
    transform: translateY(0);
    background: #486596;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.12);
}

.plant-info-details-btn:focus {
    outline: none;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.16), 0 0 0 3px rgba(87,119,169,0.35);
}

.popup-details-footer {
    padding: 12px 16px 16px 16px;
    border-top: 1px solid #f1f3f5;
    display: none; /* Only show on desktop when the map is fullscreen */
}

.popup-details-footer .plant-details-btn {
    width: 100%;
    border: none;
    border-radius: 14px;
    padding: 12px 14px;
    background: #5777a9;
    color: #ffffff;
    cursor: pointer;
    font-family: 'Muli', sans-serif;
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 8px 18px rgba(0,0,0,0.14);
    transition: transform 0.12s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.plant-details-btn .plant-details-btn-label {
    flex: 1;
    text-align: center;
    line-height: 1.1;
}

.plant-details-btn svg {
    flex: 0 0 auto;
    opacity: 0.95;
}

.popup-details-footer .plant-details-btn:hover,
.plant-info-actions .plant-details-btn:hover {
    background: #4c6e9e;
    box-shadow: 0 10px 22px rgba(0,0,0,0.16);
}

.popup-details-footer .plant-details-btn:active,
.plant-info-actions .plant-details-btn:active {
    transform: translateY(1px);
}

.popup-details-footer .plant-details-btn:focus,
.plant-info-actions .plant-details-btn:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(87,119,169,0.35), 0 10px 22px rgba(0,0,0,0.16);
}
.plant-detail-modal {
    position: absolute;
    top: 20px;
    left: 20px;
    right: auto;
    bottom: auto;
    z-index: 1200; /* above other overlays */
    display: none;
    pointer-events: auto;
}

.plant-detail-modal.open {
    display: block;
}

.plant-detail-backdrop {
    display: none; /* in-frame on desktop */
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.35);
}


.plant-detail-dialog {
    position: relative;
    width: 380px;
    max-width: min(420px, calc(100vw - 120px));
    max-height: calc(100vh - 40px);
    margin: 0; /* align top-left with the standard summary box */

    /* Match the basic summary styling for a clear visual connection */
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 14px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.14);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    overflow: hidden;
    display: flex;
    flex-direction: column;
}


.plant-detail-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 18px 12px 18px;
    border-bottom: 1px solid #eef2f6;
}

.plant-detail-country {
    font-size: 11px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #636e72;
    margin-bottom: 4px;
}

.plant-detail-title {
    margin: 0;
    font-size: 24px;
    font-weight: 900;
    color: #5777a9;
    line-height: 1.05;
}

.plant-detail-close {
    border: none;
    background: #f1f3f5;
    width: 36px;
    height: 36px;
    border-radius: 12px;
    cursor: pointer;
    font-size: 22px;
    line-height: 1;
    color: #636e72;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.plant-detail-close:hover {
    background: #e9ecef;
}

.plant-detail-close:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(87,119,169,0.25);
}

.plant-detail-tabs {
    display: flex;
    gap: 8px;
    padding: 10px 18px;
    background: #f8f9fa;
    border-bottom: 1px solid #eef2f6;
}

.plant-detail-tab {
    border: none;
    background: transparent;
    padding: 8px 10px;
    border-radius: 12px;
    cursor: pointer;
    font-family: 'Muli', sans-serif;
    font-weight: 900;
    font-size: 12px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #636e72;
}

.plant-detail-tab.active {
    background: #ffffff;
    color: #2d3436;
    box-shadow: 0 10px 24px rgba(0,0,0,0.10);
}

.plant-detail-content {
    padding: 14px 18px 18px 18px;
    overflow: auto;

    /* Allow the content (including charts) to shrink within the dialog and scroll as needed */
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
}

.plant-detail-panel {
    display: none;
}

.plant-detail-panel.active {
    display: block;
}

.plant-detail-panel + .plant-detail-panel {
    margin-top: 18px;
}

.detail-section + .detail-section {
    margin-top: 20px;
}

.detail-section-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
    gap: 12px;
}

.detail-section-title-wrap {
    flex: 1;
}

.detail-section-title-wrap .detail-section-title {
    margin-bottom: 4px;
}

.detail-section-title-wrap .detail-section-subtitle {
    margin-bottom: 0;
}

.detail-section-title {
    font-size: 13px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #2d3436;
    margin-bottom: 6px;
}

.detail-section-subtitle {
    font-size: 12px;
    font-weight: 600;
    color: #8898aa;
    margin-bottom: 10px;
}

.production-toggle {
    display: flex;
    background: #f1f3f5;
    border-radius: 6px;
    padding: 2px;
    gap: 2px;
    flex-shrink: 0;
}

.production-toggle-btn {
    padding: 4px 10px;
    font-size: 10px;
    font-weight: 700;
    color: #636e72;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.production-toggle-btn.active {
    background: #fff;
    color: #2d3436;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.production-toggle-btn:hover:not(.active) {
    color: #2d3436;
}

.detail-chart-wrap {
    border: 1px solid #eef2f6;
    border-radius: 14px;
    padding: 10px;
    background: #ffffff;
    position: relative;

}

.detail-chart-tooltip {
    position: absolute;
    z-index: 5;
    display: none;
    padding: 8px 10px;
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 12px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.14);
    color: #2d3436;
    font-family: 'Muli', sans-serif;
    font-size: 13px;
    line-height: 1.2;
    pointer-events: none;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    white-space: nowrap;
}

.detail-chart-tooltip strong {
    font-weight: 800;
}

.timeline-tooltip {
    position: absolute;
    z-index: 10;
    display: none;
    padding: 10px 12px;
    background: rgba(255,255,255,0.96);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 12px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.16);
    color: #2d3436;
    font-family: 'Muli', sans-serif;
    font-size: 13px;
    line-height: 1.4;
    pointer-events: none;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    white-space: nowrap;
    max-width: 280px;
}

.timeline-tooltip .tooltip-reactor-name {
    font-weight: 800;
    font-size: 14px;
    margin-bottom: 6px;
    color: #2d3436;
}

.timeline-tooltip .tooltip-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 2px 0;
}

.timeline-tooltip .tooltip-label {
    color: #636e72;
    font-weight: 600;
}

.timeline-tooltip .tooltip-value {
    font-weight: 700;
    color: #2d3436;
}

.timeline-tooltip.construction .tooltip-reactor-name {
    color: #e17a00;
}

.timeline-tooltip.operable .tooltip-reactor-name {
    color: #00a884;
}

.detail-timeline {
    border: 1px solid #eef2f6;
    border-radius: 14px;
    background: #ffffff;
    padding: 12px;
    overflow: visible;
    position: relative;
}

.detail-timeline svg {
    overflow: visible;
}

.timeline-segment {
    cursor: pointer;
    transition: opacity 0.15s ease;
}

.timeline-segment:hover {
    opacity: 1 !important;
}

.timeline-segment.dimmed {
    opacity: 0.35;
}

.timeline-segment line {
    transition: stroke-width 0.15s ease;
}

.timeline-segment:hover line {
    stroke-width: 8;
}


.detail-chart-canvas {
    width: 100%;
    height: 260px;
    display: block;
    max-width: 100%;
}

.detail-empty {
    margin-top: 10px;
    padding: 12px;
    border-radius: 12px;
    background: #f8f9fa;
    color: #636e72;
    font-size: 13px;
    font-weight: 600;
}

.detail-note {
    margin-top: 10px;
    color: #8898aa;
    font-size: 12px;
    font-weight: 600;
}

.detail-note code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    padding: 1px 6px;
    border-radius: 8px;
    background: #f1f3f5;
    color: #2d3436;
}


.timeline-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 700;
    color: #636e72;
}

.timeline-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
}

.timeline-legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.timeline-list {
    margin-top: 12px;
    padding: 10px 12px;
    border-radius: 12px;
    background: #f8f9fa;
}

.timeline-list-item {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px solid #e9ecef;
    font-size: 13px;
    color: #2d3436;
}

.timeline-list-item:last-child {
    border-bottom: none;
}

.timeline-list-item .reactor-name {
    font-weight: 800;
}

.timeline-list-item .reactor-dates {
    color: #636e72;
    font-weight: 700;
    white-space: nowrap;
}

@media (max-width: 600px) {
    .plant-detail-modal {
        position: fixed;
        inset: 0;
        top: 0;
        left: 0;
    }
    .plant-detail-backdrop {
        display: block;
    }
    .plant-detail-dialog {
        width: 100vw;
        height: 100vh;
        max-height: 100vh;
        margin: 0;
        border-radius: 0;
    }
    .plant-detail-content {
        padding: 14px 14px 18px 14px;
    }
    .detail-chart-canvas {
        height: 240px;
    }
}

/* ============================================================
   Fullscreen 4-panel grid layout (gutters, no overlay)
   Panels:
   Left  -> Filters / controls (#map-sidebar)
   Center-> Map (#map-container)
   Right -> Global statistics / charts (#timelineChartsSidebar)
   Bottom-> Timeline (#yearSliderPanel)
   ============================================================ */
:root {
    --fs-gutter: 14px;
    --fs-controls-width: 300px;
    --fs-stats-width: 340px;
}

#map-wrapper.fullscreen {
    background: #f2f4f7 !important;
}

/* Dark mode: Fullscreen wrapper background */
[data-theme="dark"] #map-wrapper.fullscreen {
    background: #1a1d21 !important;
}

/* Turn fullscreen into a deliberate grid with consistent gutters */
#map-wrapper.fullscreen #map-shell {
    display: grid !important;
    grid-template-columns: var(--fs-controls-width) 1fr var(--fs-stats-width);
    grid-template-rows: 1fr auto;
    grid-template-areas:
        "controls map stats"
        "timeline timeline timeline";
    gap: var(--fs-gutter);
    padding: var(--fs-gutter);
    background: transparent !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
    min-height: 0 !important;
}

/* Panel chrome (card-like) */
#map-wrapper.fullscreen #map-sidebar,
#map-wrapper.fullscreen #map-container,
#map-wrapper.fullscreen #timelineChartsSidebar,
#map-wrapper.fullscreen #yearSliderPanel {
    background: #fff !important;
    border: 1px solid #e9ecef !important;
    border-radius: 12px !important;
    box-shadow: none !important;
}

/* Dark mode: Panel chrome in fullscreen */
[data-theme="dark"] #map-wrapper.fullscreen #map-sidebar,
[data-theme="dark"] #map-wrapper.fullscreen #map-container,
[data-theme="dark"] #map-wrapper.fullscreen #timelineChartsSidebar,
[data-theme="dark"] #map-wrapper.fullscreen #yearSliderPanel {
    background: #22262b !important;
    border-color: #3d4750 !important;
}

/* Left controls */
#map-wrapper.fullscreen #map-sidebar {
    grid-area: controls;
    min-height: 0;
    min-width: 0;
    width: auto !important;
    flex: none !important;
    height: auto !important;
    overflow: auto;
    border-right: none !important; /* replace with full border above */
}

/* Center map */
#map-wrapper.fullscreen #map-container {
    grid-area: map;
    min-height: 0;
    min-width: 0;
    flex: none !important;
    height: auto !important;
    overflow: hidden !important;
    margin-right: 0 !important; /* override overlay compensation */
}

/* If the old overlay class is present, do not offset the map */
#map-wrapper.fullscreen.timeline-charts-open #map-container {
    margin-right: 0 !important;
}

/* Right global statistics */
#map-wrapper.fullscreen #timelineChartsSidebar {
    grid-area: stats;
    min-height: 0;
    min-width: 0;
    display: flex !important;
    position: static !important;
    top: auto !important;
    right: auto !important;
    width: auto !important;
    height: auto !important;
    z-index: auto !important;
    transition: opacity 0.2s ease !important;
    box-shadow: none !important;
    border-left: none !important;
    overflow: hidden;
}

/* Ensure chart area scrolls cleanly if content is taller than viewport */
#map-wrapper.fullscreen #timelineChartsSidebar .timeline-charts-content {
    overflow: auto;
}

/* Bottom timeline */
#map-wrapper.fullscreen #yearSliderPanel {
    grid-area: timeline;
    min-width: 0;
    position: static !important;
    z-index: 1;
    padding: 10px 16px !important;
    border-top: none !important;
    overflow: hidden;
}

/* In fullscreen the charts panel is always visible, so hide the "expand" affordance */
#map-wrapper.fullscreen #timelineExpandBtn {
    display: none !important;
}

/* v5.7.82: Close button visible in fullscreen grid (collapse toggle) */
#map-wrapper.fullscreen #timelineChartsClose {
    display: flex !important;
}



/* ============================================================
   Fullscreen: remove the left controls panel
   - Hide #map-sidebar
   - Let the map column expand to fill the space
   ============================================================ */
#map-wrapper.fullscreen #map-sidebar{
    display:none !important;
}

/* Re-define the fullscreen grid without the left controls column */
#map-wrapper.fullscreen #map-shell{
    grid-template-columns: 1fr var(--fs-stats-width) !important;
    grid-template-areas:
        "map stats"
        "timeline timeline" !important;
}

/* ============================================================
   v5.7.82: Collapsible statistics sidebar in fullscreen
   ============================================================ */

/* Fullscreen grid when stats sidebar is collapsed */
#map-wrapper.fullscreen.fs-stats-collapsed #map-shell {
    grid-template-columns: 1fr !important;
    grid-template-areas:
        "map"
        "timeline" !important;
}

/* Hide the sidebar when collapsed in fullscreen */
#map-wrapper.fullscreen.fs-stats-collapsed #timelineChartsSidebar {
    display: none !important;
}

/* Floating re-expand button (only visible when collapsed in fullscreen) */
.fs-stats-expand-btn {
    display: none;
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    z-index: 1001;
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 10px;
    width: 32px;
    height: 64px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    transition: background 0.15s ease, box-shadow 0.15s ease;
    padding: 0;
    flex-direction: column;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
}
.fs-stats-expand-btn:hover {
    background: rgba(255,255,255,1);
    box-shadow: 0 4px 14px rgba(0,0,0,0.14);
}
.fs-stats-expand-btn svg {
    width: 16px;
    height: 16px;
    color: #636e72;
}
.fs-stats-expand-btn:hover svg {
    color: #2d3436;
}

/* Only show re-expand button when collapsed in fullscreen */
#map-wrapper.fullscreen.fs-stats-collapsed .fs-stats-expand-btn {
    display: flex;
}

/* Dark mode: re-expand button */
[data-theme="dark"] .fs-stats-expand-btn {
    background: rgba(34,38,43,0.92);
    border-color: rgba(255,255,255,0.08);
    box-shadow: 0 2px 10px rgba(0,0,0,0.3);
}
[data-theme="dark"] .fs-stats-expand-btn:hover {
    background: rgba(45,49,55,0.95);
}
[data-theme="dark"] .fs-stats-expand-btn svg {
    color: #adb5bd;
}
[data-theme="dark"] .fs-stats-expand-btn:hover svg {
    color: #e9ecef;
}

/* ============================================================
   Mobile / small screens: Fullscreen should prioritise the map
   The desktop fullscreen grid uses fixed side panel widths which
   can collapse the map on narrow viewports (e.g., phones).
   On <=900px we switch fullscreen back to a simple vertical layout:
   Map (full width) + Timeline (bottom). Side panels are hidden.
   ============================================================ */
@media (max-width: 900px) {
    #map-wrapper.fullscreen #map-shell {
        display: flex !important;
        flex-direction: column !important;

        /* Neutralise grid settings from the desktop fullscreen layout */
        grid-template-columns: none !important;
        grid-template-rows: none !important;
        grid-template-areas: none !important;
        gap: 0 !important;
        padding: 0 !important;
    }

    /* Hide side panels in fullscreen on small screens */
    #map-wrapper.fullscreen #map-sidebar {
        display: none !important;
    }
    #map-wrapper.fullscreen #timelineChartsSidebar {
        display: none !important;
    }

    /* v5.7.82: Hide re-expand button on mobile */
    #map-wrapper.fullscreen .fs-stats-expand-btn {
        display: none !important;
    }

    /* Map occupies the full available space */
    #map-wrapper.fullscreen #map-container {
        flex: 1 1 auto !important;
        width: 100% !important;
        margin-right: 0 !important;
    }

    /* If the old "open charts" class is present, do not offset the map */
    #map-wrapper.fullscreen.timeline-charts-open #map-container {
        margin-right: 0 !important;
    }

    /* Timeline sits at the bottom, full width */
    #map-wrapper.fullscreen #yearSliderPanel {
        width: 100% !important;
        border-radius: 0 !important;
    }
}


/* ========================================
   DARK MODE STYLES
   ======================================== */

/* Appearance Section */
.sidebar-section.is-appearance {
    display: none;
    border-top: 1px solid #f1f3f5;
    padding-top: 12px;
    margin-top: 8px;
}

.appearance-option {
    padding: 4px 0;
}

.appearance-option.disabled{
    opacity: 0.55;
}
#map-wrapper.fullscreen .sidebar-section.is-appearance,
#map-wrapper:fullscreen .sidebar-section.is-appearance,
#map-wrapper:-webkit-full-screen .sidebar-section.is-appearance,
#map-wrapper.browser-fullscreen .sidebar-section.is-appearance {
    display: block;
}

/* Dark mode control is only available in fullscreen */
#darkModeOption { display: none; }

/* Show when using the map's fullscreen mode OR native element fullscreen OR browser fullscreen (F11 / OS fullscreen heuristic) */
#map-wrapper.fullscreen #darkModeOption,
#map-wrapper:fullscreen #darkModeOption,
#map-wrapper:-webkit-full-screen #darkModeOption,
#map-wrapper.browser-fullscreen #darkModeOption {
    display: block;
}

/* Mobile-only fullscreen dark mode button (shown in top-right controls) */
.dark-mode-btn { display: none; }
@media (max-width: 600px) {
    #map-wrapper.fullscreen .dark-mode-btn,
    #map-wrapper:fullscreen .dark-mode-btn,
    #map-wrapper:-webkit-full-screen .dark-mode-btn,
    #map-wrapper.browser-fullscreen .dark-mode-btn { display: flex; }
}
.appearance-toggle-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 4px;
    border-radius: 6px;
}

.appearance-icon {
    width: 18px;
    height: 18px;
    color: #636e72;
    flex-shrink: 0;
}

.appearance-label {
    font-size: 13px;
    font-weight: 500;
    color: #2d3436;
    flex: 1;
}

/* Toggle Switch */
.dm-toggle-switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex-shrink: 0;
}

.dm-toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.dm-toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #dfe6e9;
    transition: 0.3s;
    border-radius: 24px;
}

.dm-toggle-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.dm-toggle-switch input:checked + .dm-toggle-slider {
    background-color: #5777a9;
}

.dm-toggle-switch input:checked + .dm-toggle-slider:before {
    transform: translateX(20px);
}

.dm-toggle-switch input:focus + .dm-toggle-slider {
    box-shadow: 0 0 0 2px rgba(87, 119, 169, 0.2);
}

/* Ensure the dark mode switch stays visible even if host styles collide */
#darkModeOption .dm-toggle-switch {
    display: inline-block !important;
    width: 44px !important;
    height: 24px !important;
}
#darkModeOption .dm-toggle-slider {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
}

/* Dark mode styles for appearance section */
[data-theme="dark"] .sidebar-section.is-appearance {
    border-top-color: #3d4750;
}

[data-theme="dark"] .appearance-icon {
    color: #adb5bd;
}

[data-theme="dark"] .appearance-label {
    color: #e9ecef;
}

[data-theme="dark"] .dm-toggle-slider {
    background-color: #3d4750;
}

[data-theme="dark"] .dm-toggle-slider:before {
    background-color: #e9ecef;
}

[data-theme="dark"] .dm-toggle-switch input:checked + .dm-toggle-slider {
    background-color: #7c9fd4;
}

/* CSS Variables for theming */
:root {
    --bg-primary: #f8f9fa;
    --bg-secondary: #ffffff;
    --bg-tertiary: #fbfcfd;
    --bg-hover: #f1f3f5;
    --bg-active: rgba(87, 119, 169, 0.12);
    --text-primary: #2d3436;
    --text-secondary: #636e72;
    --text-muted: #8898aa;
    --border-color: #e9ecef;
    --border-light: #f1f3f5;
    --shadow-color: rgba(0, 0, 0, 0.1);
    --shadow-heavy: rgba(0, 0, 0, 0.15);
    --accent-color: #5777a9;
    --accent-light: rgba(87, 119, 169, 0.12);
    --overlay-bg: rgba(255, 255, 255, 0.92);
    --popup-bg: rgba(255, 255, 255, 0.95);
    --tooltip-bg: rgba(45, 52, 54, 0.95);
    --toast-bg: rgba(45, 52, 54, 0.95);
    --slider-panel-bg: rgba(255, 255, 255, 0.97);
    --slider-panel-border: #e9ecef;
}

[data-theme="dark"] {
    --bg-primary: #1a1d21;
    --bg-secondary: #22262b;
    --bg-tertiary: #2a2f35;
    --bg-hover: #3a4048;
    --bg-active: rgba(87, 119, 169, 0.25);
    --text-primary: #e9ecef;
    --text-secondary: #adb5bd;
    --text-muted: #868e96;
    --border-color: #3d4750;
    --border-light: #343a40;
    --shadow-color: rgba(0, 0, 0, 0.3);
    --shadow-heavy: rgba(0, 0, 0, 0.4);
    --accent-color: #7c9fd4;
    --accent-light: rgba(124, 159, 212, 0.2);
    --overlay-bg: rgba(34, 38, 43, 0.95);
    --popup-bg: rgba(34, 38, 43, 0.98);
    --tooltip-bg: rgba(248, 249, 250, 0.95);
    --toast-bg: rgba(248, 249, 250, 0.95);
    --slider-panel-bg: rgba(34, 38, 43, 0.97);
    --slider-panel-border: #3d4750;
}

/* Dark Mode: Body and Wrapper */
[data-theme="dark"] body {
    background: var(--bg-primary);
    color: var(--text-primary);
}

/* Dark Mode: Map Shell */
[data-theme="dark"] #map-shell {
    background: var(--bg-secondary);
    box-shadow: 0 10px 30px var(--shadow-color);
}

/* Dark Mode: Sidebar */
[data-theme="dark"] #map-sidebar {
    background: var(--bg-tertiary);
    border-right-color: var(--border-color);
}

[data-theme="dark"] .sidebar-scroll {
    background: var(--bg-tertiary);
}

[data-theme="dark"] .sidebar-brand {
    border-bottom-color: var(--border-light);
}

[data-theme="dark"] .sidebar-title {
    color: var(--text-primary);
}

[data-theme="dark"] .sidebar-subtitle,
[data-theme="dark"] .sidebar-section-title {
    color: var(--text-muted);
}

[data-theme="dark"] .sidebar-toggle-btn {
    background: var(--bg-tertiary);
    border-color: var(--border-color);
    color: var(--text-primary);
}

[data-theme="dark"] .sidebar-toggle-btn:hover {
    background: var(--bg-hover);
}

[data-theme="dark"] .sidebar-collapsed-btn {
    color: var(--text-secondary);
}

[data-theme="dark"] .sidebar-collapsed-btn:hover {
    background: var(--bg-hover);
    color: var(--text-primary);
}

/* Dark Mode: Map Controls Group */
[data-theme="dark"] .map-controls-group {
    box-shadow: 0 2px 8px var(--shadow-heavy);
}

[data-theme="dark"] .map-control-btn {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .map-control-btn:hover {
    background: var(--bg-hover);
}

[data-theme="dark"] .map-control-btn:focus {
    background: var(--bg-hover);
}

[data-theme="dark"] .share-btn {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .share-btn:hover {
    background: var(--bg-hover);
    color: var(--accent-color);
}

[data-theme="dark"] .share-btn.copied {
    background: var(--accent-color);
    color: #ffffff;
}

/* Dark Mode: Home Button */
[data-theme="dark"] .home-btn {
    background: var(--bg-secondary);
    color: var(--text-primary);
    box-shadow: 0 4px 12px var(--shadow-heavy);
}

[data-theme="dark"] .home-btn:hover {
    background: var(--bg-hover);
    color: var(--accent-color);
}

[data-theme="dark"] .home-btn.home-btn-group {
    background: var(--bg-secondary);
    border-bottom-color: var(--border-color);
}

/* Dark Mode: Search */
[data-theme="dark"] .search-input {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-color: var(--border-color);
}

[data-theme="dark"] .search-input::placeholder {
    color: var(--text-muted);
}

[data-theme="dark"] .controls-ui .search-input {
    background: var(--bg-secondary);
    box-shadow: 0 4px 12px var(--shadow-heavy);
}

[data-theme="dark"] .search-results {
    background: var(--bg-secondary);
    box-shadow: 0 8px 24px var(--shadow-heavy);
}

[data-theme="dark"] .result-item {
    border-bottom-color: var(--border-light);
    color: var(--text-primary);
}

[data-theme="dark"] .result-item:hover,
[data-theme="dark"] .result-item.highlighted {
    background: var(--bg-hover);
    color: var(--accent-color);
}

[data-theme="dark"] .search-clear-btn {
    background: var(--bg-hover);
}

[data-theme="dark"] .search-clear-btn:hover {
    background: var(--border-color);
}

[data-theme="dark"] .search-clear-btn svg {
    stroke: var(--text-secondary);
}

/* Dark Mode: Search Overlay */
[data-theme="dark"] .search-overlay .search-wrapper {
    background: var(--overlay-bg);
    border-color: var(--border-color);
    box-shadow: 0 10px 28px var(--shadow-heavy);
}

[data-theme="dark"] .search-overlay .search-input {
    background: transparent;
}

[data-theme="dark"] .search-overlay .search-results {
    background: var(--popup-bg);
}

[data-theme="dark"] .search-overlay .search-clear-btn {
    background: var(--bg-hover);
}

/* Dark Mode: Search Tags (v5.7.164) */
[data-theme="dark"] .search-tag.tag-green { color: #55efc4; background: rgba(0,184,148,0.18); }
[data-theme="dark"] .search-tag.tag-yellow { color: #fdcb6e; background: rgba(253,203,110,0.18); }
[data-theme="dark"] .search-tag.tag-blue { color: #74b9ff; background: rgba(116,185,255,0.18); }
[data-theme="dark"] .search-tag.tag-grey { color: #adb5bd; background: rgba(173,181,189,0.15); }

/* Dark Mode: Dropdowns and Filters */
[data-theme="dark"] .dropdown-btn {
    background: var(--bg-secondary);
    color: var(--text-primary);
    box-shadow: 0 4px 12px var(--shadow-heavy);
}

[data-theme="dark"] .dropdown-btn:hover {
    background: var(--bg-hover);
}

[data-theme="dark"] .dropdown-btn.active {
    background: var(--accent-color);
    color: #ffffff;
}

[data-theme="dark"] .dropdown-panel {
    background: var(--bg-secondary);
    box-shadow: 0 8px 24px var(--shadow-heavy);
}

[data-theme="dark"] .dropdown-panel::before {
    border-bottom-color: var(--bg-secondary);
}

[data-theme="dark"] .dropdown-section-label {
    color: var(--text-muted);
}

[data-theme="dark"] .dropdown-option label {
    color: var(--text-primary);
}

[data-theme="dark"] .dropdown-divider {
    background: var(--border-color);
}

/* Dark Mode: Sidebar Filters */
[data-theme="dark"] #map-sidebar .sidebar-display-options .dropdown-option,
[data-theme="dark"] #map-sidebar .sidebar-filters-group .dropdown-option {
    background: var(--bg-secondary);
    border-color: var(--border-color);
}

[data-theme="dark"] #map-sidebar .sidebar-display-options .dropdown-option:hover,
[data-theme="dark"] #map-sidebar .sidebar-filters-group .dropdown-option:hover {
    background: var(--bg-hover);
    border-color: var(--border-color);
}

[data-theme="dark"] #map-sidebar .sidebar-display-options .dropdown-option.option-checked,
[data-theme="dark"] #map-sidebar .sidebar-filters-group .dropdown-option.option-checked {
    background: var(--accent-light);
    border-color: var(--accent-color);
}

[data-theme="dark"] #map-sidebar .sidebar-display-options .dropdown-option input[type="checkbox"],
[data-theme="dark"] #map-sidebar .sidebar-filters-group .dropdown-option input[type="checkbox"] {
    border-color: var(--text-muted);
    background: var(--bg-tertiary);
}

[data-theme="dark"] #map-sidebar .filter-subsection {
    border-left-color: var(--border-color);
}

[data-theme="dark"] #map-sidebar .filter-subsection-title {
    color: var(--text-primary);
}

/* Dark Mode: View Mode Buttons */
[data-theme="dark"] .view-mode-btn-group .view-mode-btn {
    background: var(--bg-secondary);
    border-color: var(--border-color);
    color: var(--text-secondary);
}

[data-theme="dark"] .view-mode-btn-group .view-mode-btn:hover {
    background: var(--bg-hover);
    color: var(--text-primary);
}

[data-theme="dark"] .view-mode-btn-group .view-mode-btn.active {
    background: var(--accent-light);
    border-color: var(--accent-color);
    color: var(--accent-color);
}

/* Dark Mode: Year Slider Panel */
[data-theme="dark"] .year-slider-panel {
    background: var(--overlay-bg) !important;
    border-top-color: var(--border-color) !important;
    box-shadow: 0 -4px 12px rgba(0,0,0,0.3);
}

/* Ensure fullscreen slider is also dark - must override the hardcoded white background */
[data-theme="dark"] #map-wrapper.fullscreen .year-slider-panel {
    background: rgba(34, 38, 43, 0.97) !important;
    border-top-color: var(--border-color) !important;
}

[data-theme="dark"] #map-wrapper.fullscreen.timeline-charts-open .year-slider-panel {
    background: rgba(34, 38, 43, 0.97) !important;
}

[data-theme="dark"] .play-btn {
    background: var(--accent-color);
}

[data-theme="dark"] .play-btn:hover {
    background: #6b8cc5;
}

[data-theme="dark"] .speed-btn {
    background: var(--bg-hover);
    color: var(--text-primary);
}

[data-theme="dark"] .speed-btn:hover {
    background: var(--border-color);
}

[data-theme="dark"] .year-min-label,
[data-theme="dark"] .year-max-label {
    color: var(--text-secondary);
}

[data-theme="dark"] .slider-title {
    color: var(--text-secondary);
}

[data-theme="dark"] .year-slider {
    background: linear-gradient(to right, 
        var(--accent-color) 0%, 
        var(--accent-color) var(--slider-progress), 
        var(--border-color) var(--slider-progress), 
        var(--border-color) 100%) !important;
}

[data-theme="dark"] .year-slider::-webkit-slider-thumb {
    background: var(--accent-color);
    border-color: var(--bg-secondary);
}

[data-theme="dark"] .year-slider::-webkit-slider-runnable-track {
    background: transparent;
}

[data-theme="dark"] .year-slider::-moz-range-thumb {
    background: var(--accent-color);
    border-color: var(--bg-secondary);
}

[data-theme="dark"] .year-slider::-moz-range-track {
    background: var(--border-color);
}

[data-theme="dark"] .year-slider::-moz-range-progress {
    background: var(--accent-color);
}

[data-theme="dark"] .slider-container {
    background: transparent;
}

[data-theme="dark"] .slider-wrapper {
    background: transparent;
}

[data-theme="dark"] .slider-stats {
    border-left-color: var(--border-color);
}

[data-theme="dark"] .reactors-label {
    color: var(--text-secondary);
}

[data-theme="dark"] .stat-count {
    color: var(--text-primary);
}

[data-theme="dark"] .stat-type {
    color: var(--text-muted);
}

/* Dark Mode: Timeline Expand Button */
[data-theme="dark"] .timeline-expand-btn {
    background: var(--bg-hover);
    color: var(--text-secondary);
}

[data-theme="dark"] .timeline-expand-btn:hover {
    background: var(--border-color);
    color: var(--text-primary);
}

/* Dark Mode: Slider Year Row */
[data-theme="dark"] .slider-year-row {
    color: var(--text-secondary);
}

[data-theme="dark"] .slider-year-row .year-label-start,
[data-theme="dark"] .slider-year-row .year-label-end {
    color: var(--text-muted);
}

[data-theme="dark"] .slider-year-row .year-label-current {
    color: var(--accent-color);
}

/* Dark Mode: Map Legend */
[data-theme="dark"] .map-legend {
    background: var(--bg-secondary);
    box-shadow: 0 4px 12px var(--shadow-heavy);
}

[data-theme="dark"] .map-legend-title {
    color: var(--text-secondary);
}

[data-theme="dark"] .map-legend-item {
    color: var(--text-primary);
}

/* Dark Mode: Plant/Country Info Overlays */
[data-theme="dark"] .plant-info-overlay,
[data-theme="dark"] .country-info-overlay {
    background: var(--overlay-bg);
    border-color: var(--border-color);
}

[data-theme="dark"] .plant-info-body,
[data-theme="dark"] .country-info-body {
    background: var(--bg-secondary);
}

[data-theme="dark"] .plant-info-header,
[data-theme="dark"] .country-info-header {
    border-bottom-color: var(--border-light);
}

[data-theme="dark"] .plant-info-back,
[data-theme="dark"] .country-info-back {
    background: var(--bg-hover);
}

[data-theme="dark"] .plant-info-back:hover,
[data-theme="dark"] .country-info-back:hover {
    background: var(--border-color);
}

[data-theme="dark"] .plant-info-back svg,
[data-theme="dark"] .country-info-back svg {
    stroke: var(--text-secondary);
}

[data-theme="dark"] .plant-info-name,
[data-theme="dark"] .country-info-name {
    color: var(--accent-color) !important;
}

[data-theme="dark"] .plant-info-country,
[data-theme="dark"] .country-info-label {
    color: var(--text-primary);
}

[data-theme="dark"] .plant-info-stats,
[data-theme="dark"] .country-info-stats {
    background: var(--bg-tertiary);
}

[data-theme="dark"] .plant-info-stat,
[data-theme="dark"] .country-info-stat {
    border-right-color: var(--border-light);
}

[data-theme="dark"] .plant-info-stat-value,
[data-theme="dark"] .country-info-stat-value {
    color: var(--text-primary);
}

[data-theme="dark"] .plant-info-stat-label,
[data-theme="dark"] .country-info-stat-label {
    color: var(--text-muted);
}

[data-theme="dark"] .country-info-stats-header {
    color: var(--text-muted);
}

[data-theme="dark"] .plant-info-reactors-toggle,
[data-theme="dark"] .country-info-plants-toggle {
    background: var(--bg-secondary);
    border-top-color: var(--border-light);
    border-bottom-color: var(--border-light);
    color: var(--text-primary);
}

[data-theme="dark"] .plant-info-reactors-toggle:hover,
[data-theme="dark"] .country-info-plants-toggle:hover {
    background: var(--bg-hover);
}

[data-theme="dark"] .plant-info-reactors-list,
[data-theme="dark"] .country-info-plants-list {
    background: var(--bg-secondary);
}

[data-theme="dark"] .plant-info-reactor-item {
    border-top-color: var(--border-light);
}

[data-theme="dark"] .plant-info-reactor-item:hover {
    background: var(--accent-light);
}

[data-theme="dark"] .country-info-plant-item {
    background: var(--bg-primary);
    border-color: var(--border-color);
}

[data-theme="dark"] .country-info-plant-item:hover {
    background: var(--bg-hover);
    border-color: #5777a9;
}

[data-theme="dark"] .plant-info-reactor-name,
[data-theme="dark"] .country-info-plant-name {
    color: var(--text-primary) !important;
}

[data-theme="dark"] .plant-info-reactor-details,
[data-theme="dark"] .plant-info-reactor-capacity,
[data-theme="dark"] .country-info-plant-capacity {
    color: var(--text-muted);
}

/* Dark Mode: Country Detail Content (Charts) */
[data-theme="dark"] .country-detail-content {
    background: var(--bg-secondary) !important;
}

/* Fullscreen specific */
[data-theme="dark"] #map-wrapper.fullscreen .country-detail-content {
    background: var(--bg-secondary) !important;
}

[data-theme="dark"] .country-info-capacity {
    background: var(--bg-tertiary);
    border-top-color: var(--border-light);
}

[data-theme="dark"] .country-info-capacity-label {
    color: var(--text-muted);
}

[data-theme="dark"] .country-info-capacity-value {
    color: var(--text-primary);
}

/* Dark Mode: Detail Section backgrounds */
[data-theme="dark"] .detail-section {
    background: transparent;
}

/* Dark Mode: Reactor Deployment Chart */
[data-theme="dark"] .reactor-deploy-chart {
    background: var(--bg-secondary) !important;
    border-color: var(--border-color) !important;
}

/* Fullscreen specific - ensure charts in country overlay are dark */
[data-theme="dark"] #map-wrapper.fullscreen .reactor-deploy-chart,
[data-theme="dark"] .country-info-overlay .reactor-deploy-chart,
[data-theme="dark"] .country-detail-content .reactor-deploy-chart {
    background: var(--bg-secondary) !important;
    border-color: var(--border-color) !important;
}

[data-theme="dark"] .reactor-deploy-header {
    color: var(--text-primary);
}

[data-theme="dark"] .reactor-deploy-legend-item {
    color: var(--text-secondary);
}

[data-theme="dark"] .reactor-deploy-toggle {
    background: var(--bg-hover);
}

[data-theme="dark"] .reactor-deploy-toggle-btn {
    color: var(--text-secondary);
}

[data-theme="dark"] .reactor-deploy-toggle-btn.active {
    background: var(--bg-secondary);
    color: var(--text-primary);
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

[data-theme="dark"] .reactor-deploy-toggle-btn:hover:not(.active) {
    color: var(--text-primary);
}

[data-theme="dark"] .reactor-deploy-axis-line {
    stroke: var(--border-color);
}

[data-theme="dark"] .reactor-deploy-zero-line {
    stroke: var(--border-light);
}

[data-theme="dark"] .reactor-deploy-grid-line {
    stroke: var(--border-light);
}

[data-theme="dark"] .reactor-deploy-axis-label {
    fill: var(--text-muted);
}

[data-theme="dark"] .reactor-deploy-tooltip {
    background: var(--tooltip-bg);
    color: var(--bg-primary);
}

/* Dark Mode: Reactor Deploy Container and SVG */
[data-theme="dark"] .reactor-deploy-container {
    background: transparent;
}

[data-theme="dark"] .reactor-deploy-svg {
    background: transparent;
}

/* Dark Mode: Detail Section (shared by plant and country) */
[data-theme="dark"] .detail-section {
    color: var(--text-primary);
}

[data-theme="dark"] .detail-section-title {
    color: var(--text-primary);
}

[data-theme="dark"] .detail-section-subtitle {
    color: var(--text-muted);
}

/* Dark Mode: Production Toggle */
[data-theme="dark"] .production-toggle {
    background: var(--bg-hover);
}

[data-theme="dark"] .production-toggle-btn {
    color: var(--text-secondary);
}

[data-theme="dark"] .production-toggle-btn.active {
    background: var(--bg-secondary);
    color: var(--text-primary);
}

[data-theme="dark"] .production-toggle-btn:hover:not(.active) {
    color: var(--text-primary);
}

/* Dark Mode: Detail Chart Wrap */
[data-theme="dark"] .detail-chart-wrap {
    background: var(--bg-secondary) !important;
    border-color: var(--border-color) !important;
}

/* Fullscreen specific - ensure charts are dark */
[data-theme="dark"] #map-wrapper.fullscreen .detail-chart-wrap,
[data-theme="dark"] .country-info-overlay .detail-chart-wrap,
[data-theme="dark"] .country-detail-content .detail-chart-wrap,
[data-theme="dark"] .plant-info-overlay .detail-chart-wrap,
[data-theme="dark"] .plant-detail-dialog .detail-chart-wrap {
    background: var(--bg-secondary) !important;
    border-color: var(--border-color) !important;
}

[data-theme="dark"] .detail-chart-tooltip {
    background: var(--overlay-bg);
    border-color: var(--border-color);
    color: var(--text-primary);
}

/* Dark Mode: Detail Chart Canvas - ensure no white background */
[data-theme="dark"] .detail-chart-canvas {
    background: transparent !important;
}

/* Dark Mode: Timeline Charts Sidebar */
[data-theme="dark"] .timeline-charts-sidebar {
    background: var(--bg-secondary);
    border-left-color: var(--border-color);
}

[data-theme="dark"] .timeline-charts-header {
    background: var(--bg-secondary);
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .timeline-header-label {
    color: var(--accent-color);
}

[data-theme="dark"] .timeline-charts-close {
    color: var(--text-muted);
}

[data-theme="dark"] .timeline-charts-close:hover {
    background: var(--bg-hover);
    color: var(--text-secondary);
}

[data-theme="dark"] .timeline-charts-content {
    background: #252a32;
}

[data-theme="dark"] .timeline-chart-panel {
    background: var(--bg-secondary, #2d2d44);
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}

[data-theme="dark"] .timeline-chart-panel-title {
    color: var(--text-primary, #f5f6fa);
}

[data-theme="dark"] .timeline-chart-panel-subtitle {
    color: var(--text-muted, #636e72);
}

[data-theme="dark"] .timeline-chart-label {
    display: none;
}

[data-theme="dark"] .timeline-chart-value {
    background: var(--overlay-bg);
    color: var(--text-primary);
}

/* Dark Mode: Popups */
[data-theme="dark"] .plant-popup .maplibregl-popup-content {
    background: var(--bg-secondary);
    border-color: var(--border-color);
}

[data-theme="dark"] .plant-popup.maplibregl-popup-anchor-bottom .maplibregl-popup-tip { border-top-color: var(--bg-secondary); }
[data-theme="dark"] .plant-popup.maplibregl-popup-anchor-top .maplibregl-popup-tip { border-bottom-color: var(--bg-secondary); }
[data-theme="dark"] .plant-popup.maplibregl-popup-anchor-left .maplibregl-popup-tip { border-right-color: var(--bg-secondary); }
[data-theme="dark"] .plant-popup.maplibregl-popup-anchor-right .maplibregl-popup-tip { border-left-color: var(--bg-secondary); }

[data-theme="dark"] .plant-popup .maplibregl-popup-close-button {
    color: var(--text-secondary);
    background: var(--bg-hover);
}

[data-theme="dark"] .plant-popup .maplibregl-popup-close-button:hover {
    background: var(--border-color);
    color: var(--text-primary);
}

[data-theme="dark"] .popup-header-new {
    background: var(--bg-secondary);
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .popup-header-new::after {
    background: var(--accent-color);
}

[data-theme="dark"] .popup-country-new {
    color: var(--text-primary);
}

[data-theme="dark"] .popup-title-new {
    color: var(--accent-color) !important;
}

[data-theme="dark"] .popup-subtitle-new {
    color: var(--text-muted);
}

[data-theme="dark"] .stats-row {
    background: var(--bg-tertiary);
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .stat-item {
    border-right-color: var(--border-color);
}

[data-theme="dark"] .stat-value {
    color: var(--text-primary);
}

[data-theme="dark"] .stat-label {
    color: var(--text-muted);
}

[data-theme="dark"] .reactor-section {
    background: var(--bg-secondary);
}

[data-theme="dark"] .section-title {
    color: var(--text-muted);
}

[data-theme="dark"] .click-hint {
    color: var(--accent-color);
}

[data-theme="dark"] .reactor-card {
    background: var(--bg-secondary);
    border-color: var(--border-color);
}

[data-theme="dark"] .reactor-card:hover {
    border-color: var(--accent-color);
    background: var(--accent-light);
}

[data-theme="dark"] .reactor-name {
    color: var(--text-primary);
}

/* Dark Mode: Map Info Modal */
[data-theme="dark"] .map-info-modal-dialog {
    background: #1e1e2e;
    box-shadow: 0 8px 30px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.06);
}

[data-theme="dark"] .map-info-modal-title {
    color: #f5f6fa;
}

[data-theme="dark"] .map-info-modal-close {
    color: #636e72;
}

[data-theme="dark"] .map-info-modal-close:hover {
    background: rgba(255,255,255,0.08);
    color: #f5f6fa;
}

[data-theme="dark"] .map-info-modal-text {
    color: var(--text-secondary);
}

[data-theme="dark"] .map-info-modal-text a {
    color: var(--accent-color);
}

/* Dark Mode: View Mode Popup */
[data-theme="dark"] .view-mode-popup {
    background: var(--bg-secondary);
    box-shadow: 0 4px 16px var(--shadow-heavy);
}

[data-theme="dark"] .view-mode-popup::after {
    border-left-color: var(--bg-secondary);
}

[data-theme="dark"] .view-mode-option {
    color: var(--text-primary);
}

[data-theme="dark"] .view-mode-option:hover {
    background: var(--bg-hover);
}

[data-theme="dark"] .view-mode-option.active {
    background: var(--accent-light);
    color: var(--accent-color);
}

/* Dark Mode: Data Sources */
[data-theme="dark"] .map-data-sources {
    background: var(--bg-tertiary);
    border-top-color: var(--border-color);
}

[data-theme="dark"] .map-data-sources p {
    color: var(--text-secondary);
}

[data-theme="dark"] .map-data-sources a {
    color: var(--accent-color);
}

/* Dark Mode: Fullscreen Header */
[data-theme="dark"] .fullscreen-header {
    background: var(--bg-secondary);
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .fs-header-divider {
    background: var(--border-color);
}

[data-theme="dark"] .fs-header-title-main {
    color: var(--text-primary);
}

[data-theme="dark"] .fs-header-title-sub {
    color: var(--text-secondary);
}

[data-theme="dark"] .fs-header-badge {
    background: var(--bg-tertiary);
    border-color: var(--border-color);
    color: var(--text-primary);
}

[data-theme="dark"] .fs-header-badge:hover {
    background: var(--bg-hover);
}

/* Dark Mode: Status Bar */
[data-theme="dark"] .map-status-bar {
    background: var(--overlay-bg);
    border-color: var(--border-color);
}

[data-theme="dark"] .map-status-bar.at-present {
    opacity: 0.95;
}

[data-theme="dark"] .map-year-badge-icon {
    color: var(--text-secondary);
}

[data-theme="dark"] .map-year-badge-value {
    color: var(--text-primary);
}

[data-theme="dark"] .status-bar-separator {
    background: var(--border-color);
}

[data-theme="dark"] .filter-chip {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.12);
    color: var(--text-primary);
}

[data-theme="dark"] .filter-chip:hover {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.18);
}

[data-theme="dark"] .filter-chip-remove {
    color: var(--text-secondary);
}

[data-theme="dark"] .filter-chip-remove:hover {
    background: rgba(255, 255, 255, 0.12);
    color: var(--text-primary);
}

/* Dark Mode: Mobile Year Indicator */
[data-theme="dark"] .mobile-year-indicator {
    background: rgba(124, 159, 212, 0.92);
    border-color: rgba(255, 255, 255, 0.14);
}

/* Dark Mode: Notices */
[data-theme="dark"] .mobile-notice {
    background: var(--accent-light);
    border-bottom-color: var(--border-color);
    color: var(--accent-color);
}

/* Dark Mode: Toast */
[data-theme="dark"] .share-toast {
    background: var(--toast-bg);
    color: var(--bg-primary);
}

[data-theme="dark"] .share-toast.error {
    background: rgba(214, 48, 49, 0.95);
    color: #ffffff;
}

/* Dark Mode: Plant Hover Tooltip */
[data-theme="dark"] .plant-hover-tooltip .maplibregl-popup-content {
    background: var(--overlay-bg);
    border-color: var(--border-color);
    color: var(--text-primary);
}

[data-theme="dark"] .plant-hover-tooltip .pht-country {
    color: var(--accent-color);
}

[data-theme="dark"] .plant-hover-tooltip .pht-name {
    color: var(--text-primary);
}

[data-theme="dark"] .plant-hover-tooltip .pht-meta {
    color: var(--text-secondary);
}

[data-theme="dark"] .plant-hover-tooltip .pht-meta b {
    color: var(--text-primary);
}

[data-theme="dark"] .plant-hover-tooltip .pht-badge {
    border-color: var(--border-light);
}

/* Dark Mode: Plant Detail Modal */
[data-theme="dark"] .plant-detail-dialog {
    background: var(--overlay-bg);
    border-color: var(--border-color);
}

[data-theme="dark"] .plant-detail-header {
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .plant-detail-country {
    color: var(--text-secondary);
}

[data-theme="dark"] .plant-detail-title {
    color: var(--accent-color);
}

[data-theme="dark"] .plant-detail-close {
    background: var(--bg-hover);
    color: var(--text-secondary);
}

[data-theme="dark"] .plant-detail-close:hover {
    background: var(--border-color);
}

[data-theme="dark"] .plant-detail-tabs {
    background: var(--bg-tertiary);
    border-bottom-color: var(--border-color);
}

[data-theme="dark"] .plant-detail-tab {
    color: var(--text-secondary);
}

[data-theme="dark"] .plant-detail-tab.active {
    background: var(--bg-secondary);
    color: var(--text-primary);
}

[data-theme="dark"] .detail-section-title {
    color: var(--text-primary);
}

[data-theme="dark"] .detail-section-subtitle {
    color: var(--text-muted);
}

[data-theme="dark"] .detail-chart-wrap {
    background: var(--bg-secondary);
    border-color: var(--border-color);
}

[data-theme="dark"] .detail-timeline {
    background: var(--bg-secondary);
    border-color: var(--border-color);
}

[data-theme="dark"] .detail-empty {
    background: var(--bg-tertiary);
    color: var(--text-secondary);
}

[data-theme="dark"] .detail-note {
    color: var(--text-muted);
}

[data-theme="dark"] .detail-note code {
    background: var(--bg-hover);
    color: var(--text-primary);
}

/* Dark Mode: No-data messages */
[data-theme="dark"] .no-data-yet-message {
    background: linear-gradient(135deg, var(--bg-tertiary) 0%, var(--bg-secondary) 100%);
    border-color: var(--border-color);
}

[data-theme="dark"] .no-data-yet-message .no-data-icon {
    background: var(--bg-hover);
    color: var(--text-muted);
}

[data-theme="dark"] .no-data-yet-message .no-data-title {
    color: var(--text-primary);
}

[data-theme="dark"] .no-data-yet-message .no-data-text {
    color: var(--text-muted);
}

[data-theme="dark"] .no-data-yet-message .no-data-year {
    background: var(--accent-color);
}



/* Dark Mode: Country Panel */
[data-theme="dark"] .country-panel {
    background: var(--bg-secondary);
}

[data-theme="dark"] .country-panel-header {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-top: 6px solid #5777a9;
    border-bottom: 1px solid var(--border-color);
}

[data-theme="dark"] .country-panel::before {
    background: rgba(255,255,255,0.35);
}

[data-theme="dark"] .country-panel-close {
    background: rgba(255, 255, 255, 0.15);
}

[data-theme="dark"] .country-panel-close:hover {
    background: rgba(255, 255, 255, 0.25);
}

[data-theme="dark"] .country-stats-grid {
    background: var(--border-color);
}

[data-theme="dark"] .country-stat-box {
    background: var(--bg-secondary);
}

[data-theme="dark"] .country-stat-value {
    color: var(--text-primary);
}
[data-theme="dark"] .country-stat-value.green { color: #00b894; }
[data-theme="dark"] .country-stat-value.yellow { color: #e17055; }
[data-theme="dark"] .country-stat-value.blue { color: #74b9ff; }
[data-theme="dark"] .country-stat-value.grey { color: #8898aa; }

[data-theme="dark"] .country-stat-label {
    color: var(--text-muted);
}

[data-theme="dark"] .country-stats-header {
    color: var(--text-muted);
}

[data-theme="dark"] .country-section {
    border-bottom-color: var(--border-light);
}

[data-theme="dark"] .country-section-title {
    color: var(--text-muted);
}

[data-theme="dark"] .country-capacity-bar {
    background: var(--bg-hover);
}

[data-theme="dark"] .country-capacity-label {
    color: var(--text-secondary);
}

[data-theme="dark"] .country-plant-item {
    background: var(--bg-primary);
    border-color: var(--border-color);
}

[data-theme="dark"] .country-plant-item:hover {
    background: var(--bg-hover);
    border-color: #5777a9;
}

[data-theme="dark"] .country-plant-name {
    color: var(--text-primary);
}

[data-theme="dark"] .country-plant-reactors {
    color: var(--text-muted);
}

[data-theme="dark"] .country-plant-capacity {
    color: var(--text-secondary);
}

/* Dark Mode: Plant Panel (mobile bottom sheet) */
[data-theme="dark"] .plant-panel {
    background: var(--bg-secondary);
}

[data-theme="dark"] .plant-panel-header {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-top: 6px solid #5777a9;
    border-bottom: 1px solid var(--border-color);
}

[data-theme="dark"] .plant-panel::before {
    background: rgba(255,255,255,0.35);
}

[data-theme="dark"] .plant-panel-close {
    background: rgba(255, 255, 255, 0.15);
}

[data-theme="dark"] .plant-panel-close:hover {
    background: rgba(255, 255, 255, 0.25);
}

[data-theme="dark"] .plant-panel-title {
    color: var(--text-primary) !important;
}

[data-theme="dark"] .plant-panel-subtitle {
    color: var(--accent-color);
}

[data-theme="dark"] .plant-panel-status {
    background: rgba(255,255,255,0.15);
    color: var(--text-primary);
}

[data-theme="dark"] .plant-panel-status.green {
    background: rgba(0, 184, 148, 0.25);
    color: #00b894;
}

[data-theme="dark"] .plant-panel-status.yellow {
    background: rgba(253, 203, 110, 0.35);
    color: #fdcb6e;
}

[data-theme="dark"] .plant-panel-status.blue {
    background: rgba(116, 185, 255, 0.25);
    color: #74b9ff;
}

[data-theme="dark"] .plant-panel-status.grey {
    background: rgba(255,255,255,0.15);
    color: var(--text-muted);
}

[data-theme="dark"] .plant-stats-grid {
    background: var(--border-color);
}

[data-theme="dark"] .plant-stat-box {
    background: var(--bg-secondary);
}

[data-theme="dark"] .plant-stat-value {
    color: var(--text-primary);
}

[data-theme="dark"] .plant-stat-label {
    color: var(--text-muted);
}

[data-theme="dark"] .plant-section {
    border-bottom-color: var(--border-light);
}

[data-theme="dark"] .plant-section-title {
    color: var(--text-muted);
}
[data-theme="dark"] .plant-section-title.collapsible .section-toggle-icon {
    color: var(--text-muted);
}

[data-theme="dark"] .plant-reactor-item {
    background: var(--bg-primary);
    border-color: var(--border-color);
}

[data-theme="dark"] .plant-reactor-item:hover {
    background: var(--bg-hover);
    border-color: #5777a9;
}

[data-theme="dark"] .plant-reactor-name {
    color: var(--text-primary);
}

[data-theme="dark"] .plant-reactor-details {
    color: var(--text-muted);
}

[data-theme="dark"] .plant-reactor-capacity {
    color: var(--text-secondary);
}

[data-theme="dark"] .plant-reactor-link {
    background: var(--bg-secondary);
    border-color: var(--border-color);
    color: var(--accent-color);
}

[data-theme="dark"] .plant-reactor-link:hover {
    background: var(--accent-color);
    color: white;
}

[data-theme="dark"] .plant-panel-country-link {
    background: var(--bg-primary);
    border-color: var(--border-color);
    color: var(--accent-color);
}

[data-theme="dark"] .plant-panel-country-link:hover {
    background: var(--accent-color);
    color: white;
    border-color: var(--accent-color);
}

\* Dark Mode: Mobile Hold */
[data-theme="dark"] .mobile-hold {
    background: var(--bg-secondary);
}

[data-theme="dark"] .mobile-hold-icon {
    background: var(--accent-light);
    color: var(--accent-color);
}

[data-theme="dark"] .mobile-hold-title {
    color: var(--text-primary);
}

[data-theme="dark"] .mobile-hold-text {
    color: var(--accent-color);
}

[data-theme="dark"] .mobile-hold-hint {
    color: var(--accent-color);
}

/* Dark Mode: Cluster markers (v5.7.147: same color, adjusted text) */

/* Dark Mode: MapLibre controls */
[data-theme="dark"] .maplibregl-ctrl-attrib {
    background: var(--bg-secondary);
    color: var(--text-muted);
}

[data-theme="dark"] .maplibregl-ctrl-attrib a {
    color: var(--accent-color);
}

[data-theme="dark"] .maplibregl-ctrl-group {
    background: var(--bg-secondary);
}

[data-theme="dark"] .maplibregl-ctrl-group button + button {
    border-top-color: var(--border-color);
}

[data-theme="dark"] .maplibregl-ctrl-group button:hover {
    background: var(--bg-hover);
}

/* MapLibre's control icons are #333 data-URI SVGs. */
[data-theme="dark"] .maplibregl-ctrl-group button .maplibregl-ctrl-icon {
    filter: invert(1);
}

/* The 2D map's tiles are darkened by raster paint in applyMapTheme(), not by a CSS filter:
   markers now share the canvas with the tiles, so a filter would darken them too, and it
   would cost a full-viewport filter pass every frame. The globe keeps its filter until
   Phase 4 moves it onto the same mechanism. */

/* Dark Mode: Globe container */
[data-theme="dark"] #globeContainer {
    filter: brightness(0.75) contrast(1.1) saturate(0.85);
}

/* Dark Mode: Transition for smooth theme switching */
body,
#map-shell,
#map-sidebar,
.map-controls-group,
.map-control-btn,
.search-input,
.search-results,
.dropdown-panel,
.year-slider-panel,
.map-legend,
.plant-info-overlay,
.country-info-overlay,
.timeline-charts-sidebar,
.fullscreen-header {
    transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

/* Smooth transition for the globe's filter. The 2D map fades via the raster-*-transition
   entries in the shared RP paint block instead. */
#globeContainer {
    transition: filter 0.3s ease;
}


/* --- Mobile UX fixes for country panels (scroll + tap reliability) --- */
@media (max-width: 600px) {
    /* Avoid nested scroll areas inside the country panels; let the main panel scroll instead */
    .country-info-plants-list.expanded {
        max-height: 9999px;
        overflow: visible;
    }
    .country-plant-list:not(.collapsible) { /* v5.7.129: exclude collapsible variant */
        max-height: none;
        overflow: visible;
    }

    /* Make scrolling feel responsive (especially on iOS) */
    .country-info-overlay,
    .country-info-body,
    .country-panel-content {
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
        touch-action: pan-y;
    }

    /* Make plant cards reliably tappable */
    .country-info-plant-item,
    .country-plant-item {
        width: 100%;
        box-sizing: border-box;
        touch-action: pan-y;
        -webkit-tap-highlight-color: transparent;
    }
}

/* --- Desktop typography tuning (readability) --- */
@media (min-width: 901px) {
    /* Lift micro labels (9px -> 10px) */
    .stat-label,
    .country-info-stat-label,
    .plant-info-stat-label,
    .plant-detail-field-label,
    .reactor-status-label,
    .legend-chip,
    .country-stat-label,
    .plant-stat-label,
    .country-highlights-row .country-highlight-label,
    .timeline-chart-label {
        font-size: 10px;
    }

    /* Lift small UI text (10px -> 11px) */
    .map-drawer-title,
    .map-drawer-section-label,
    .section-title,
    .sidebar-section-title,
    .dropdown-section-label,
    .filter-subsection-title,
    .view-mode-btn-label,
    .map-legend-title,
    .stat-type,
    .reactor-deploy-toggle-btn,
    .reactor-deploy-axis-label,
    .production-toggle-btn,
    .timeline-axis-end,
    .timeline-chart-value,
    .timeline-legend-item,
    .chart-year-indicator,
    .plant-info-status-badge,
    .plant-panel-status,
    .country-section-title,
    .plant-section-title,
    .click-hint,
    .cta-banner,
    .maplibregl-ctrl-attrib {
        font-size: 11px;
    }

    /* Fullscreen header micro text: slightly larger */
    .fs-header-title-sub,
    .fs-header-badge,
    .fs-header-exit-btn {
        font-size: 12px;
    }
}
/* v5.7.130: Consistent heading sizes on mobile panels */
@media (max-width: 600px) {
    .country-stats-header,
    .mobile-chart-section-title {
        font-size: 10px;
    }
}
/* --- Plant detail: Recent news --- */
@media (max-width: 600px) {
  #plantRecentNewsSection { display: none; }
}

#plantRecentNewsSection .recent-news-list{
  list-style: none !important;
  padding: 0 !important;
  margin: 10px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

#plantRecentNewsSection .recent-news-item{
  list-style: none !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px 10px 26px !important;
  border-top: 1px solid rgba(0,0,0,0.04);
  line-height: 1.35;
  position: relative;
}

/* Remove any list bullets/chevrons (from external/global list styles) */
#plantRecentNewsSection .recent-news-item::marker{
  content: "" !important;
}
#plantRecentNewsSection .recent-news-item::before{
  content: "" !important;
  display: none !important;
}

#plantRecentNewsSection .recent-news-item:hover{
  background: rgba(87, 119, 169, 0.08);
}

#plantRecentNewsSection .recent-news-title{
  font-size: 12px;
  font-weight: 700;
  color: #2d3436;
  line-height: 1.35;
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
  padding-left: 6px;
}

#plantRecentNewsSection .recent-news-linkout{
  flex-shrink: 0;
}

/* Ensure headline inset is visible (some global list styles can override padding) */
#plantRecentNewsSection ul#plantRecentNewsList > li.recent-news-item{
  padding-left: 26px !important;
}
#plantRecentNewsSection ul#plantRecentNewsList > li.recent-news-item > .recent-news-title{
  margin-left: 2px !important;
}

/* Dark mode: make news titles readable + match divider/hover styling */
[data-theme="dark"] #plantRecentNewsSection .recent-news-title{
  color: var(--text-primary);
}
[data-theme="dark"] #plantRecentNewsSection .recent-news-item{
  border-top: 1px solid rgba(255,255,255,0.08);
}
[data-theme="dark"] #plantRecentNewsSection .recent-news-item:hover{
  background: rgba(87, 119, 169, 0.18);
}

/* ===== Tour Feature Styles ===== */
.tour-overlay {
    position: fixed;
    inset: 0;
    z-index: 10000;
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
}
.tour-overlay.active {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
}
/* Ensure tour elements appear above fullscreen map wrapper */
body.fullscreen-active .tour-overlay,
body.fullscreen-active .tour-welcome-modal {
    z-index: 9999999 !important;
}
/* Ensure tour drawer appears above tour overlay in fullscreen */
body.fullscreen-active #tourDrawer.open {
    z-index: 10000000 !important;
}
.tour-backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    transition: opacity 0.3s ease;
}
.tour-spotlight {
    position: absolute;
    border-radius: 8px;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.4);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
}
.tour-spotlight::after {
    content: '';
    position: absolute;
    inset: -4px;
    border: 2px solid rgba(87, 119, 169, 0.8);
    border-radius: 12px;
    animation: tour-pulse 2s ease-in-out infinite;
}
@keyframes tour-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(1.02); }
}
.tour-card {
    position: absolute;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    width: 320px;
    max-width: calc(100vw - 32px);
    padding: 20px;
    font-family: 'Muli', sans-serif;
    z-index: 10001;
    opacity: 0;
    transform: translateY(10px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: auto;
}
.tour-card.visible {
    opacity: 1;
    transform: translateY(0);
}
.tour-card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}
.tour-card-icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #5777a9 0%, #6b8cbe 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.tour-card-icon svg {
    width: 20px;
    height: 20px;
    stroke: #fff;
    fill: none;
    stroke-width: 2;
}
.tour-card-step {
    font-size: 11px;
    font-weight: 700;
    color: #8898aa;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}
.tour-card-title {
    font-size: 18px;
    font-weight: 800;
    color: #2d3436;
    margin: 0 0 8px 0;
    line-height: 1.2;
}
.tour-card-desc {
    font-size: 14px;
    color: #636e72;
    line-height: 1.5;
    margin: 0 0 16px 0;
}
.tour-card-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}
.tour-btn {
    padding: 10px 18px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    font-family: 'Muli', sans-serif;
    cursor: pointer;
    transition: all 0.15s ease;
    border: none;
}
.tour-btn-primary {
    background: linear-gradient(135deg, #5777a9 0%, #6b8cbe 100%);
    color: #fff;
}
.tour-btn-primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(87, 119, 169, 0.4);
}
.tour-btn-secondary {
    background: #f1f3f5;
    color: #636e72;
}
.tour-btn-secondary:hover {
    background: #e9ecef;
}
.tour-btn-skip {
    background: transparent;
    color: #8898aa;
    padding: 10px 12px;
    margin-left: auto;
}
.tour-btn-skip:hover {
    color: #636e72;
}
.tour-progress {
    display: flex;
    gap: 6px;
    margin-top: 16px;
    justify-content: center;
}
.tour-progress-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #e9ecef;
    transition: all 0.2s ease;
}
.tour-progress-dot.active {
    background: #5777a9;
    width: 20px;
    border-radius: 4px;
}
.tour-progress-dot.completed {
    background: #00b894;
}
/* Tour welcome modal (centered, no spotlight) */
.tour-welcome-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.95);
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.35);
    width: 380px;
    max-width: calc(100vw - 32px);
    padding: 32px;
    font-family: 'Muli', sans-serif;
    z-index: 10002;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: center;
}
.tour-welcome-modal.visible {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, -50%) scale(1);
}
.tour-welcome-icon {
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, #5777a9 0%, #6b8cbe 100%);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
}
.tour-welcome-icon svg {
    width: 32px;
    height: 32px;
    stroke: #fff;
    fill: none;
    stroke-width: 2;
}
.tour-welcome-title {
    font-size: 24px;
    font-weight: 800;
    color: #2d3436;
    margin: 0 0 12px 0;
}
.tour-welcome-desc {
    font-size: 15px;
    color: #636e72;
    line-height: 1.6;
    margin: 0 0 24px 0;
}
.tour-welcome-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.tour-welcome-actions .tour-btn {
    width: 100%;
    padding: 14px 20px;
    font-size: 14px;
}
/* Tour trigger button */
.tour-trigger-btn {
    display: none; /* Hidden - tour is accessed via rail button in fullscreen */
}

/* Rail tour button */
.rail-btn-tour {
    background: transparent;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #5777a9;
    transition: background 0.15s, color 0.15s;
}
.rail-btn-tour:hover {
    background: rgba(87, 119, 169, 0.1);
}
.rail-btn-tour svg {
    width: 20px;
    height: 20px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
}
[data-theme="dark"] .rail-btn-tour {
    color: var(--accent-color);
}
[data-theme="dark"] .rail-btn-tour:hover {
    background: rgba(124, 159, 212, 0.15);
}
.tour-trigger-btn:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 24px rgba(87, 119, 169, 0.5);
}
.tour-trigger-btn svg {
    width: 22px;
    height: 22px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
}
/* Hide tour trigger in fullscreen (use header button instead) */
#map-wrapper.fullscreen .tour-trigger-btn {
    display: none;
}
/* Tour button in fullscreen header */
.fs-header-tour-btn {
    background: transparent;
    border: none;
    color: #fff;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease;
    margin-right: 8px;
}
.fs-header-tour-btn:hover {
    background: rgba(255, 255, 255, 0.15);
}
.fs-header-tour-btn svg {
    width: 18px;
    height: 18px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
}
/* Mobile-specific tour styles */
@media (max-width: 600px) {
    .tour-card {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        max-width: 100%;
        border-radius: 20px 20px 0 0;
        padding: 24px 20px calc(24px + env(safe-area-inset-bottom, 0px));
        transform: translateY(100%);
    }
    .tour-card.visible {
        transform: translateY(0);
    }
    .tour-trigger-btn {
        bottom: calc(16px + env(safe-area-inset-bottom, 0px));
        right: 16px;
        width: 44px;
        height: 44px;
    }
    .tour-welcome-modal {
        width: calc(100vw - 32px);
        padding: 28px 24px;
    }
    .tour-spotlight::after {
        inset: -3px;
    }
}
/* Dark theme support */
[data-theme="dark"] .tour-card,
[data-theme="dark"] .tour-welcome-modal {
    background: #1f2230;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}
[data-theme="dark"] .tour-card-title,
[data-theme="dark"] .tour-welcome-title {
    color: #f8f9fa;
}
[data-theme="dark"] .tour-card-desc,
[data-theme="dark"] .tour-welcome-desc {
    color: #adb5bd;
}
[data-theme="dark"] .tour-btn-secondary {
    background: rgba(255, 255, 255, 0.1);
    color: #adb5bd;
}
[data-theme="dark"] .tour-btn-secondary:hover {
    background: rgba(255, 255, 255, 0.15);
}
[data-theme="dark"] .tour-progress-dot {
    background: rgba(255, 255, 255, 0.15);
}
[data-theme="dark"] .tour-backdrop {
    background: transparent;
}
/* Tour Nudge - gentle prompt to take the tour */
.tour-nudge {
    position: fixed;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(87, 119, 169, 0.15);
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-family: 'Muli', sans-serif;
    font-size: 13px;
    color: #2d3436;
    z-index: 8000;
    opacity: 0;
    visibility: hidden;
    transform: translateX(-10px);
    transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
    max-width: 260px;
    cursor: pointer;
    /* Position will be set by JavaScript */
}
.tour-nudge:hover {
    box-shadow: 0 6px 28px rgba(87, 119, 169, 0.25), 0 0 0 2px rgba(87, 119, 169, 0.3);
    transform: translateX(0) scale(1.02);
}
.tour-nudge.visible {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
}
.tour-nudge::before {
    content: '';
    position: absolute;
    left: -8px;
    bottom: 18px;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid #fff;
}

/* Highlight ring around tour button when nudge is visible */
.rail-btn-tour.nudge-highlight {
    position: relative;
}
.rail-btn-tour.nudge-highlight::after {
    content: '';
    position: absolute;
    inset: -6px;
    border: 2px solid #5777a9;
    border-radius: 14px;
    animation: nudge-pulse 1.5s ease-in-out infinite;
}
@keyframes nudge-pulse {
    0%, 100% { 
        opacity: 1; 
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(87, 119, 169, 0.4);
    }
    50% { 
        opacity: 0.7; 
        transform: scale(1.08);
        box-shadow: 0 0 0 8px rgba(87, 119, 169, 0);
    }
}
.tour-nudge-text {
    line-height: 1.4;
}
.tour-nudge-text strong {
    display: block;
    font-weight: 700;
    margin-bottom: 2px;
}
.tour-nudge-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.tour-nudge-cta {
    font-size: 12px;
    font-weight: 600;
    color: #5777a9;
    transition: color 0.15s;
}
.tour-nudge:hover .tour-nudge-cta {
    color: #3d5a80;
}
[data-theme="dark"] .tour-nudge-cta {
    color: #7c9fd4;
}
[data-theme="dark"] .tour-nudge:hover .tour-nudge-cta {
    color: #a8c5f0;
}
.tour-nudge-close {
    background: transparent;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #636e72;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s;
}
.tour-nudge-close:hover {
    background: rgba(0, 0, 0, 0.05);
    color: #2d3436;
}
.tour-nudge-close svg {
    width: 14px;
    height: 14px;
    stroke: currentColor;
    stroke-width: 2.5;
}
[data-theme="dark"] .tour-nudge {
    background: #2d3436;
    color: #e9ecef;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
}
[data-theme="dark"] .tour-nudge::before {
    border-right-color: #2d3436;
}
[data-theme="dark"] .tour-nudge-close {
    color: #adb5bd;
}
[data-theme="dark"] .tour-nudge-close:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
}
@media (max-width: 600px) {
    .tour-nudge {
        display: none !important;
    }
}

/* ===== Tour Enhancement Animations (v5.7.121) ===== */
/* Typing cursor blink on search input during demo */
.tour-typing-cursor {
    caret-color: #5777a9;
    animation: tour-cursor-blink 0.7s step-end infinite;
}
@keyframes tour-cursor-blink {
    0%, 100% { border-right: 2px solid #5777a9; }
    50% { border-right: 2px solid transparent; }
}
/* Result highlight flash before "clicking" */
.tour-result-flash {
    animation: tour-result-flash-anim 0.6s ease;
}
@keyframes tour-result-flash-anim {
    0% { background: transparent; }
    30% { background: rgba(87, 119, 169, 0.25); }
    100% { background: transparent; }
}
/* Spotlight retarget glow when moving mid-step */
.tour-spotlight.retarget {
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.tour-spotlight.retarget::after {
    animation: tour-retarget-glow 0.8s ease-out;
}
@keyframes tour-retarget-glow {
    0% { box-shadow: 0 0 0 0 rgba(87, 119, 169, 0.6); opacity: 0.4; }
    50% { box-shadow: 0 0 16px 4px rgba(87, 119, 169, 0.4); opacity: 1; }
    100% { box-shadow: none; opacity: 1; }
}
/* Step entrance bounce animation on card */
.tour-card.step-enter {
    animation: tour-step-enter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes tour-step-enter {
    0% { opacity: 0; transform: translateY(10px) scale(0.96); }
    100% { opacity: 1; transform: translateY(0) scale(1); }
}
/* Progress dot completion pop */
.tour-progress-dot.just-completed {
    animation: tour-dot-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes tour-dot-pop {
    0% { transform: scale(1); }
    50% { transform: scale(1.5); }
    100% { transform: scale(1); }
}
/* Disabled next button during interactive steps */
.tour-btn-primary.tour-btn-blocked {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
}
/* Tour demo cursor (v5.7.122) */
.tour-cursor {
    position: fixed;
    width: 28px;
    height: 28px;
    z-index: 10003;
    pointer-events: none;
    opacity: 0;
    transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                top 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                opacity 0.3s ease;
    filter: drop-shadow(1px 2px 3px rgba(0,0,0,0.3));
}
.tour-cursor.visible { opacity: 1; }
.tour-cursor.clicking { animation: tour-cursor-click 0.3s ease; }
@keyframes tour-cursor-click {
    0% { transform: scale(1); }
    50% { transform: scale(0.85); }
    100% { transform: scale(1); }
}
/* Click ripple effect at cursor point */
.tour-click-ripple {
    position: fixed;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(87, 119, 169, 0.4);
    z-index: 10002;
    pointer-events: none;
    animation: tour-ripple 0.5s ease-out forwards;
}
@keyframes tour-ripple {
    0% { transform: translate(-50%, -50%) scale(0.5); opacity: 1; }
    100% { transform: translate(-50%, -50%) scale(3); opacity: 0; }
}
/* Status bar highlight ring for timeline step */
.tour-status-highlight {
    outline: 2px solid rgba(87, 119, 169, 0.7);
    outline-offset: 3px;
    border-radius: 16px;
    animation: tour-pulse 2s ease-in-out infinite;
}

/* Dark mode variants for tour enhancements */
[data-theme="dark"] .tour-typing-cursor {
    caret-color: #7c9fd4;
}
[data-theme="dark"] .tour-typing-cursor {
    animation-name: tour-cursor-blink-dark;
}
@keyframes tour-cursor-blink-dark {
    0%, 100% { border-right: 2px solid #7c9fd4; }
    50% { border-right: 2px solid transparent; }
}
[data-theme="dark"] .tour-result-flash {
    animation-name: tour-result-flash-dark;
}
@keyframes tour-result-flash-dark {
    0% { background: transparent; }
    30% { background: rgba(124, 159, 212, 0.3); }
    100% { background: transparent; }
}
[data-theme="dark"] .tour-spotlight.retarget::after {
    animation-name: tour-retarget-glow-dark;
}
@keyframes tour-retarget-glow-dark {
    0% { box-shadow: 0 0 0 0 rgba(124, 159, 212, 0.6); opacity: 0.4; }
    50% { box-shadow: 0 0 16px 4px rgba(124, 159, 212, 0.4); opacity: 1; }
    100% { box-shadow: none; opacity: 1; }
}

[data-theme="dark"] .tour-spotlight {
    box-shadow: 0 0 0 3px rgba(87, 119, 169, 0.6), 0 0 20px rgba(87, 119, 169, 0.4);
}
/* Print: hide tour elements */
@media print {
    .tour-overlay,
    .tour-trigger-btn,
    .tour-welcome-modal {
        display: none !important;
    }
}

/* Tour Drawer Panel Styles */
.tour-drawer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 8px 4px;
}
.tour-drawer-icon {
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #eef2ff 0%, #e8efff 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
}
.tour-drawer-icon svg {
    width: 28px;
    height: 28px;
    stroke: #5777a9;
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.tour-drawer-title {
    font-size: 16px;
    font-weight: 800;
    color: #2d3436;
    margin: 0 0 8px 0;
    line-height: 1.2;
}
.tour-drawer-desc {
    font-size: 13px;
    font-weight: 500;
    color: #636e72;
    line-height: 1.5;
    margin: 0 0 16px 0;
}
.tour-drawer-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}
.tour-drawer-btn {
    padding: 12px 20px;
    border-radius: 10px;
    font-family: 'Muli', sans-serif;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.15s ease;
    border: none;
    width: 100%;
}
.tour-drawer-btn-primary {
    background: linear-gradient(135deg, #5777a9 0%, #4a6898 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(87, 119, 169, 0.3);
}
.tour-drawer-btn-primary:hover {
    background: linear-gradient(135deg, #4a6898 0%, #3d5a87 100%);
    box-shadow: 0 4px 12px rgba(87, 119, 169, 0.4);
    transform: translateY(-1px);
}
.tour-drawer-btn-secondary {
    background: #f1f3f5;
    color: #495057;
}
.tour-drawer-btn-secondary:hover {
    background: #e9ecef;
    color: #2d3436;
}
[data-theme="dark"] .tour-drawer-icon {
    background: linear-gradient(135deg, rgba(87, 119, 169, 0.2) 0%, rgba(87, 119, 169, 0.15) 100%);
}
[data-theme="dark"] .tour-drawer-icon svg {
    stroke: #7c9fd4;
}
[data-theme="dark"] .tour-drawer-title {
    color: #e9ecef;
}
[data-theme="dark"] .tour-drawer-desc {
    color: #adb5bd;
}
[data-theme="dark"] .tour-drawer-btn-secondary {
    background: #2d3436;
    color: #e9ecef;
}
[data-theme="dark"] .tour-drawer-btn-secondary:hover {
    background: #3d4750;
    color: #fff;
}

/* === Year Changes Dropdown (v5.7.83) === */
.year-changes-dropdown {
    flex: none;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 6px rgba(0,0,0,0.10);
    border: none;
    overflow: hidden;
}
.year-changes-dropdown-toggle {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px 16px;
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Muli', sans-serif;
    gap: 8px;
    transition: background 0.15s ease;
}
.year-changes-dropdown-toggle:hover {
    background: rgba(87, 119, 169, 0.05);
}
.year-changes-dropdown-label {
    display: flex;
    align-items: baseline;
    gap: 4px;
    flex: 1;
    min-width: 0;
}
.year-changes-dropdown-title {
    font-size: 13px;
    font-weight: 600;
    color: #2d3436;
    white-space: nowrap;
}
.year-changes-dropdown-year {
    font-size: 13px;
    font-weight: 700;
    color: #2d3436;
}
.year-changes-dropdown-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 20px;
    padding: 0 6px;
    border-radius: 10px;
    background: rgba(87, 119, 169, 0.12);
    color: #5777a9;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
}
.year-changes-dropdown-badge[data-count="0"] {
    background: rgba(0, 0, 0, 0.04);
    color: #b2bec3;
}
.year-changes-dropdown-chevron {
    width: 16px;
    height: 16px;
    color: #adb5bd;
    flex-shrink: 0;
    transition: transform 0.2s ease;
}
.year-changes-dropdown.expanded .year-changes-dropdown-chevron {
    transform: rotate(180deg);
}
.year-changes-dropdown-body {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.25s ease;
    padding: 0 10px;
}
.year-changes-dropdown.expanded .year-changes-dropdown-body {
    max-height: 300px;
    overflow-y: auto;
    padding: 4px 10px 10px 10px;
}
.year-changes-section {
    margin-bottom: 10px;
}
.year-changes-section:last-child {
    margin-bottom: 0;
}
.year-changes-section-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #636e72;
    margin-bottom: 4px;
}
.year-changes-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}
.year-changes-dot.green { background: #00b894; }
.year-changes-dot.yellow { background: #fdcb6e; }
.year-changes-dot.blue { background: #74b9ff; }
.year-changes-dot.grey { background: #636e72; }
.year-changes-item {
    display: flex;
    align-items: baseline;
    gap: 6px;
    padding: 5px 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;
    font-size: 12.5px;
    color: #2d3436;
    line-height: 1.35;
}
.year-changes-item:hover {
    background: rgba(87, 119, 169, 0.08);
}
.year-changes-item-reactor {
    font-weight: 600;
    white-space: nowrap;
}
.year-changes-item-plant {
    color: #636e72;
    font-size: 11.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.year-changes-item-country {
    color: #b2bec3;
    font-size: 11px;
    margin-left: auto;
    white-space: nowrap;
    flex-shrink: 0;
}
.year-changes-empty {
    text-align: center;
    padding: 18px 10px;
    color: #b2bec3;
    font-size: 12.5px;
    font-style: italic;
}


/* Dark mode - year changes dropdown (v5.7.83) */
[data-theme="dark"] .year-changes-dropdown {
    background: var(--bg-secondary, #2d2d44);
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}
[data-theme="dark"] .year-changes-dropdown-toggle:hover {
    background: rgba(255,255,255,0.04);
}
[data-theme="dark"] .year-changes-dropdown-title {
    color: #dfe6e9;
}
[data-theme="dark"] .year-changes-dropdown-year {
    color: #dfe6e9;
}
[data-theme="dark"] .year-changes-dropdown-badge {
    background: rgba(124, 159, 212, 0.15);
}
[data-theme="dark"] .year-changes-dropdown-badge[data-count="0"] {
    background: rgba(255, 255, 255, 0.04);
    color: #636e72;
}
[data-theme="dark"] .year-changes-dropdown-chevron {
    color: #636e72;
}
/* Dark mode - year changes items (kept) */
[data-theme="dark"] .year-changes-item {
    color: #dfe6e9;
}
[data-theme="dark"] .year-changes-item:hover {
    background: rgba(255, 255, 255, 0.06);
}
[data-theme="dark"] .year-changes-item-plant {
    color: #b2bec3;
}
[data-theme="dark"] .year-changes-item-country {
    color: #636e72;
}
[data-theme="dark"] .year-changes-empty {
    color: #636e72;
}

/* --- Capacity Range Slider --- */
.capacity-range-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 6px 0 2px;
}
.capacity-range-labels {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    color: #2d3436;
}
.capacity-range-value {
    font-size: 13px;
    font-weight: 800;
    color: #5777a9;
    min-width: 44px;
    flex: 1;
}
.capacity-range-value.min-val { text-align: left; }
.capacity-range-value.max-val { text-align: right; }
.capacity-range-separator {
    font-size: 11px;
    font-weight: 600;
    color: #8898aa;
}
.capacity-range-track-container {
    position: relative;
    height: 20px;
    margin: 4px 0 0;
}
.capacity-range-track {
    position: absolute;
    top: 7px; left: 0; right: 0;
    height: 6px;
    border-radius: 3px;
    pointer-events: none;
    --range-min-pct: 0%;
    --range-max-pct: 100%;
    background: linear-gradient(to right,
        #dfe6e9 0%, #dfe6e9 var(--range-min-pct),
        #5777a9 var(--range-min-pct), #5777a9 var(--range-max-pct),
        #dfe6e9 var(--range-max-pct), #dfe6e9 100%);
}
.capacity-range-input {
    -webkit-appearance: none;
    appearance: none;
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 20px;
    background: transparent;
    margin: 0; padding: 0;
    pointer-events: none;
    outline: none;
    z-index: 2;
}
.capacity-range-input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px; height: 18px;
    border-radius: 50%;
    background: #5777a9;
    cursor: grab;
    border: 2px solid white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    pointer-events: auto;
    transition: transform 0.1s ease;
    position: relative;
    z-index: 2;
    margin-top: -6px;
}
.capacity-range-input::-webkit-slider-thumb:hover {
    transform: scale(1.15);
}
.capacity-range-input::-webkit-slider-thumb:active {
    cursor: grabbing;
}
.capacity-range-input::-moz-range-thumb {
    width: 18px; height: 18px;
    border-radius: 50%;
    background: #5777a9;
    cursor: grab;
    border: 2px solid white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    pointer-events: auto;
}
.capacity-range-input::-webkit-slider-runnable-track {
    background: transparent;
    height: 6px;
}
.capacity-range-input::-moz-range-track {
    background: transparent;
    height: 6px;
    border: none;
}
.capacity-range-input.max-input { z-index: 3; }
.capacity-range-scale {
    display: flex;
    justify-content: space-between;
    font-size: 9px;
    font-weight: 600;
    color: #b2bec3;
    padding: 0 2px;
}

/* Dark mode */
[data-theme="dark"] .capacity-range-labels { color: var(--text-primary); }
[data-theme="dark"] .capacity-range-value { color: var(--accent-color); }
[data-theme="dark"] .capacity-range-separator { color: var(--text-muted); }
[data-theme="dark"] .capacity-range-track {
    background: linear-gradient(to right,
        var(--border-color) 0%, var(--border-color) var(--range-min-pct),
        var(--accent-color) var(--range-min-pct), var(--accent-color) var(--range-max-pct),
        var(--border-color) var(--range-max-pct), var(--border-color) 100%);
}
[data-theme="dark"] .capacity-range-input::-webkit-slider-thumb {
    background: var(--accent-color);
    border-color: var(--bg-secondary);
}
[data-theme="dark"] .capacity-range-input::-moz-range-thumb {
    background: var(--accent-color);
    border-color: var(--bg-secondary);
}
[data-theme="dark"] .capacity-range-scale { color: var(--text-muted); }

/* =========================================================================
   v5.7.164: Embed mode — stripped-down view for iframe embedding
   ========================================================================= */
#map-wrapper.embed-mode #map-sidebar,
#map-wrapper.embed-mode #mapSideRail,
#map-wrapper.embed-mode #controlsOverlay,
#map-wrapper.embed-mode #yearSliderPanel,
#map-wrapper.embed-mode #timelineChartsSidebar,
#map-wrapper.embed-mode #fsStatsExpandBtn,
#map-wrapper.embed-mode #mapControlsGroup,
#map-wrapper.embed-mode #mapStatusBar,
#map-wrapper.embed-mode #desktopSearchOverlay,
#map-wrapper.embed-mode #countryInfoOverlay,
#map-wrapper.embed-mode #plantInfoOverlay,
#map-wrapper.embed-mode #plantDetailModal,
#map-wrapper.embed-mode #countryPanel,
#map-wrapper.embed-mode #plantPanel,
#map-wrapper.embed-mode #filterPanel,
#map-wrapper.embed-mode #expandedChartModal,
#map-wrapper.embed-mode .mobile-hold-screen,
#map-wrapper.embed-mode #tourOverlay,
#map-wrapper.embed-mode #tourWelcomeModal,
#map-wrapper.embed-mode .map-drawer,
#map-wrapper.embed-mode #drawerBackdrop,
#map-wrapper.embed-mode #mobileYearIndicator,
#map-wrapper.embed-mode .desktop-fs-overlay,
#map-wrapper.embed-mode .fullscreen-header {
    display: none !important;
}
#map-wrapper.embed-mode { position: relative; width: 100%; height: 100%; }
#map-wrapper.embed-mode #map-container { width: 100%; height: 100%; }
#map-wrapper.embed-mode .map-rail-layout { padding-left: 0; }
#map-wrapper.embed-mode .map-stage { padding: 0; }
#map-wrapper.embed-mode #mapCanvas { top: 0; left: 0; right: 0; bottom: 0; }

/* Embed stats bar */
.embed-stats-bar {
    display: none;
    position: absolute; top: 10px; left: 10px; right: 10px;
    z-index: 1100;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.10);
    padding: 8px 14px;
    font-family: 'Muli', sans-serif;
    font-size: 12px;
    color: #2d3436;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}
#map-wrapper.embed-mode .embed-stats-bar { display: flex; }
.embed-stats-bar .embed-country-name {
    font-weight: 800;
    font-size: 13px;
    margin-right: 4px;
    white-space: nowrap;
}
.embed-stats-bar .embed-stat {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
}
.embed-stats-bar .embed-stat-dot {
    width: 8px; height: 8px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}
.embed-stats-bar .embed-stat-dot.operable { background: #00b894; }
.embed-stats-bar .embed-stat-dot.construction { background: #fdcb6e; }
.embed-stats-bar .embed-stat-dot.planned { background: #74b9ff; }
.embed-stats-bar .embed-stat-dot.shutdown { background: #636e72; }
.embed-stats-bar .embed-stat-value { font-weight: 700; }
.embed-stats-bar .embed-stat-label { color: #636e72; }
.embed-stats-bar .embed-capacity {
    font-weight: 700;
    white-space: nowrap;
    margin-left: auto;
}
.embed-stats-bar .embed-explore-link {
    color: #5777a9;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
}
.embed-stats-bar .embed-explore-link:hover { text-decoration: underline; }

/* Push legend below stats bar in embed mode */
#map-wrapper.embed-mode .map-legend { top: 58px; }

/* Dark mode support for embed stats bar */
[data-theme="dark"] .embed-stats-bar {
    background: rgba(26,29,33,0.92);
    border-color: rgba(255,255,255,0.08);
    color: #e0e0e0;
}
[data-theme="dark"] .embed-stats-bar .embed-stat-label { color: #999; }
[data-theme="dark"] .embed-stats-bar .embed-explore-link { color: #7c9fd4; }

/* v5.7.165: Data loader / error overlays */
#dataLoaderOverlay, #dataErrorOverlay {
    position: absolute; inset: 0; z-index: 9998;
    display: none; flex-direction: column; align-items: center; justify-content: center;
    background: rgba(248,249,250,0.96);
    font-family: 'Muli', sans-serif;
}
#dataLoaderOverlay .loader-text { font-size: 13px; color: #636e72; margin-bottom: 12px; }
/* One bar for the whole load, not one per phase.
   Animated with transform: scaleX(), never width. Width would relayout on every
   step and, more to the point, run on the main thread — so the bar would freeze
   during exactly the busy stretches it exists to narrate. A transform transition
   is composited, so it keeps gliding while the main thread builds the map, the
   way the old CSS spinner did. */
#dataLoaderOverlay .loader-track {
    width: 220px; height: 4px; border-radius: 2px;
    background: #dfe6e9; overflow: hidden;
}
#dataLoaderOverlay .loader-bar {
    width: 100%; height: 100%; border-radius: 2px; background: #5777a9;
    transform: scaleX(0); transform-origin: left center;
    transition: transform 400ms ease-out;
    will-change: transform;
}
@media (prefers-reduced-motion: reduce) {
    #dataLoaderOverlay .loader-bar { transition-duration: 1ms; }
}
#dataErrorOverlay { display: none; }
#dataErrorOverlay .error-icon { font-size: 32px; margin-bottom: 10px; }
#dataErrorOverlay .error-title { font-size: 15px; font-weight: 700; color: #2d3436; margin-bottom: 6px; }
#dataErrorOverlay .error-text { font-size: 12px; color: #636e72; margin-bottom: 16px; text-align: center; max-width: 280px; }
#dataErrorOverlay .error-retry-btn {
    padding: 8px 24px; border: none; border-radius: 8px; cursor: pointer;
    background: #5777a9; color: #fff; font-size: 13px; font-weight: 700;
    font-family: 'Muli', sans-serif;
}
#dataErrorOverlay .error-retry-btn:hover { background: #4a6a9a; }
[data-theme="dark"] #dataLoaderOverlay, [data-theme="dark"] #dataErrorOverlay { background: rgba(26,29,33,0.96); }
[data-theme="dark"] #dataLoaderOverlay .loader-text { color: #b2bec3; }
[data-theme="dark"] #dataLoaderOverlay .loader-track { background: #3a3f45; }
[data-theme="dark"] #dataErrorOverlay .error-title { color: #dfe6e9; }
[data-theme="dark"] #dataErrorOverlay .error-text { color: #b2bec3; }

</style>
</head>
<body>
<div id="map-wrapper"><!-- Fullscreen Header Bar -->
<header class="fullscreen-header" id="fullscreenHeader">
<div class="fs-header-left">
<div class="fs-header-logo"><!-- WNA Logo --><img alt="World Nuclear Association" src="data:image/png;base64,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" /></div>

<div class="fs-header-divider"></div>

<div class="fs-header-title">
<div class="fs-header-title-main">Nuclear Power Plant Explorer</div>

<div class="fs-header-title-sub">Interactive map</div>
</div>
</div>

<div class="fs-header-right"><button aria-label="Exit" class="fs-header-exit-btn" id="fsHeaderExitBtn" title="Exit" type="button"><svg fill="none" stroke="currentColor" stroke-width="2.5" viewbox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg> <span class="fs-header-exit-label">Exit</span></button></div>
</header>

<div class="mobile-notice" id="mobileNotice"><svg fill="none" height="16" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24" width="16"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4M12 8h.01"></path></svg> <span>For best experience and full functionality, view this map on a desktop device.</span><button aria-label="Dismiss notice" class="mobile-notice-close" id="mobileNoticeClose"><svg fill="none" height="14" stroke="currentColor" stroke-width="2.5" viewbox="0 0 24 24" width="14"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div>

<!-- Desktop fullscreen prompt overlay -->
<div class="desktop-fs-overlay" id="desktopFsOverlay" role="dialog" aria-labelledby="fsOverlayTitle" aria-modal="true">
<div class="desktop-fs-card">
<div class="desktop-fs-icon"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"></path></svg></div>
<div class="desktop-fs-title" id="fsOverlayTitle">View in Full Screen</div>
<p class="desktop-fs-text">This interactive map works best in full screen mode, giving you access to detailed charts, reactor information, and an enhanced browsing experience.</p>
<div class="desktop-fs-actions">
<button class="desktop-fs-btn-primary" id="fsOverlayLaunchBtn" type="button">Launch Full Screen</button>
<button class="desktop-fs-btn-secondary" id="fsOverlayDismissBtn" type="button">Continue without full screen</button>
</div>
</div>
</div>

<div aria-label="Mobile map notice" class="mobile-hold" id="mobileHold" role="dialog" aria-modal="true">
<div class="mobile-hold-card">
<div class="mobile-hold-icon"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg></div>
<div class="mobile-hold-title">Best Viewed on Desktop</div>
<p class="mobile-hold-text">This interactive map works best on a desktop device, giving you access to detailed charts, reactor information, and an enhanced browsing experience.</p>
<div class="mobile-hold-actions">
<button class="mobile-load-btn" id="mobileLoadMapBtn" type="button">Load Map Anyway</button>
<span class="mobile-hold-hint">Some features may be limited</span>
</div>
</div>
</div>

<!-- v5.7.165: Data loader / error overlays -->
<div id="dataLoaderOverlay" role="status" aria-live="polite"><div class="loader-text" id="dataLoaderText">Loading reactor data&hellip;</div><div class="loader-track" id="dataLoaderTrack"><div class="loader-bar" id="dataLoaderBar"></div></div></div>
<div id="dataErrorOverlay"><div class="error-icon">&#9888;</div><div class="error-title">Unable to load data</div><div class="error-text">The reactor database could not be reached. Please check your connection and try again.</div><button class="error-retry-btn" id="dataRetryBtn" type="button">Retry</button></div>

<div id="map-shell">
<aside aria-label="Map controls sidebar" id="map-sidebar">
<div class="sidebar-scroll">
<div class="sidebar-brand">
<div class="sidebar-title">Nuclear Power Plant Explorer</div>
</div>

<div class="sidebar-section">
<div class="sidebar-section-title">Display Options</div>

<div id="sidebarViewMount"><!-- View mode buttons will be injected here -->
<div class="view-mode-btn-group" id="viewModeBtnGroup"><button aria-label="Satellite view" class="view-mode-btn active" data-mode="satellite" title="Satellite view" type="button"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg> <span class="view-mode-btn-label">Satellite</span></button><button aria-label="Map view" class="view-mode-btn" data-mode="map" title="Map view" type="button"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M9 3L2 6v15l7-3m0-15l6 3m-6-3v15m6-12l7-3v15l-7 3m0-15v15"></path></svg> <span class="view-mode-btn-label">Map</span></button><button aria-label="3D Globe view" class="view-mode-btn" data-mode="globe" title="3D Globe view" type="button"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path><ellipse cx="12" cy="12" rx="10" ry="4"></ellipse></svg> <span class="view-mode-btn-label">3D Globe</span></button></div>
<div class="labels-toggle-row" id="labelsToggleRow"><span class="labels-toggle-label">Show labels</span><label class="labels-toggle-switch"><input type="checkbox" id="sidebarLabelsToggle" checked /><span class="labels-toggle-slider"></span></label></div>
</div>

<div class="sidebar-display-options" id="sidebarDisplayOptions">
<div class="dropdown-option"><input id="clusterView" type="checkbox" /> <label for="clusterView">Cluster plants</label></div>

<div class="dropdown-option"><input id="sizeByCapacity" type="checkbox" /> <label for="sizeByCapacity">Size by capacity</label></div>

<div class="dropdown-option"><input id="sizeByProduction" type="checkbox" /> <label for="sizeByProduction">Size by electricity production</label></div>
</div>
</div>

<div class="sidebar-section is-filters">
<div class="sidebar-section-title">Filters</div>

<div id="sidebarFiltersMount">
<div class="sidebar-filters-group" id="sidebarFiltersGroup">
<div class="filter-subsection">
<div class="filter-subsection-title">Status</div>

<div class="dropdown-option"><input id="showOperable" type="checkbox" /> <label for="showOperable">Operable</label></div>

<div class="dropdown-option"><input id="showConstruction" type="checkbox" /> <label for="showConstruction">Under Construction</label></div>

<div class="dropdown-option"><input id="showPlanned" type="checkbox" /> <label for="showPlanned">Planned</label></div>

<div class="dropdown-option"><input id="showShutdown" type="checkbox" /> <label for="showShutdown">Shutdown</label></div>
</div>

<div class="filter-subsection">
<div class="filter-subsection-title">Plant Size</div>
<div class="capacity-range-wrapper" id="capacityRangeDesktop">
    <div class="capacity-range-labels">
        <span class="capacity-range-value min-val" id="capMinLabel">0 GW</span>
        <span class="capacity-range-separator">to</span>
        <span class="capacity-range-value max-val" id="capMaxLabel">10 GW</span>
    </div>
    <div class="capacity-range-track-container">
        <div class="capacity-range-track" id="capTrack"></div>
        <input type="range" class="capacity-range-input min-input"
               id="capMinSlider" min="0" max="10" step="0.1" value="0"
               aria-label="Minimum plant capacity" />
        <input type="range" class="capacity-range-input max-input"
               id="capMaxSlider" min="0" max="10" step="0.1" value="10"
               aria-label="Maximum plant capacity" />
    </div>
    <div class="capacity-range-scale">
        <span>0</span><span>2</span><span>4</span><span>6</span><span>8</span><span>10 GW</span>
    </div>
</div>
</div>

<div class="filter-subsection">
<div class="filter-subsection-title">Plant Production</div>
<div class="capacity-range-wrapper" id="productionRangeDesktop">
    <div class="capacity-range-labels">
        <span class="capacity-range-value min-val" id="prodMinLabel">0 TWh</span>
        <span class="capacity-range-separator">to</span>
        <span class="capacity-range-value max-val" id="prodMaxLabel">50.0 TWh</span>
    </div>
    <div class="capacity-range-track-container">
        <div class="capacity-range-track" id="prodTrack"></div>
        <input type="range" class="capacity-range-input min-input"
               id="prodMinSlider" min="0" max="50" step="0.5" value="0"
               aria-label="Minimum plant production" />
        <input type="range" class="capacity-range-input max-input"
               id="prodMaxSlider" min="0" max="50" step="0.5" value="50"
               aria-label="Maximum plant production" />
    </div>
    <div class="capacity-range-scale">
        <span>0</span><span>10</span><span>20</span><span>30</span><span>40</span><span>50 TWh</span>
    </div>
</div>
</div>

</div>
</div>
</div>

<div class="sidebar-section is-appearance">
<div class="sidebar-section-title">Appearance</div>

<div class="appearance-option" id="darkModeOption">
<div class="appearance-toggle-row"><svg class="appearance-icon" fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path> </svg> <span class="appearance-label">Dark Mode</span> <label class="dm-toggle-switch"><input id="darkModeToggle" type="checkbox" /><span class="dm-toggle-slider"></span></label></div>
</div>
</div>
</div>
</aside>

<div id="map-container">
<div class="map-rail-layout" id="mapRailLayout"><!-- Slim rail (desktop) + overlay drawers for Filters / Settings -->
<div aria-label="Map quick controls" class="map-side-rail" id="mapSideRail"><button aria-controls="filtersDrawer" aria-expanded="false" aria-label="Filters" class="rail-btn" id="railFiltersBtn" title="Filters" type="button"><svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"> <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path> </svg></button><button aria-controls="viewModeDrawer" aria-expanded="false" aria-label="View Mode" class="rail-btn" id="railViewModeBtn" title="View Mode" type="button"><svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"> <path d="M12 2L2 7l10 5 10-5-10-5z"></path> <path d="M2 17l10 5 10-5"></path> <path d="M2 12l10 5 10-5"></path> </svg></button><button aria-controls="themeDrawer" aria-expanded="false" aria-label="Theme" class="rail-btn" id="railThemeBtn" title="Theme" type="button"><svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"> <circle cx="12" cy="12" r="5"></circle> <path d="M12 1v2"></path> <path d="M12 21v2"></path> <path d="M4.22 4.22l1.42 1.42"></path> <path d="M18.36 18.36l1.42 1.42"></path> <path d="M1 12h2"></path> <path d="M21 12h2"></path> <path d="M4.22 19.78l1.42-1.42"></path> <path d="M18.36 5.64l1.42-1.42"></path> </svg></button><button aria-controls="settingsDrawer" aria-expanded="false" aria-label="Settings" class="rail-btn" id="railSettingsBtn" title="Settings" type="button"><svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"> <path d="M4 21v-7"></path> <path d="M4 10V3"></path> <path d="M12 21v-9"></path> <path d="M12 8V3"></path> <path d="M20 21v-5"></path> <path d="M20 12V3"></path> <path d="M1 14h6"></path> <path d="M9 8h6"></path> <path d="M17 16h6"></path> </svg></button><button aria-controls="tourDrawer" aria-expanded="false" aria-label="Take a Tour" class="rail-btn rail-btn-tour" id="railTourBtn" title="Take a Tour" type="button"><svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg></button></div>

<div class="map-stage" id="mapStage">
<div aria-hidden="true" class="map-drawer-backdrop" id="drawerBackdrop"></div>

<!-- v5.7.164: Embed stats bar (visible only in embed mode) -->
<div class="embed-stats-bar" id="embedStatsBar">
<span class="embed-country-name" id="embedCountryName"></span>
<span class="embed-stat"><span class="embed-stat-dot operable"></span><span class="embed-stat-value" id="embedOperable">0</span><span class="embed-stat-label">Operable</span></span>
<span class="embed-stat"><span class="embed-stat-dot construction"></span><span class="embed-stat-value" id="embedConstruction">0</span><span class="embed-stat-label">Construction</span></span>
<span class="embed-stat"><span class="embed-stat-dot planned"></span><span class="embed-stat-value" id="embedPlanned">0</span><span class="embed-stat-label">Planned</span></span>
<span class="embed-stat"><span class="embed-stat-dot shutdown"></span><span class="embed-stat-value" id="embedShutdown">0</span><span class="embed-stat-label">Shutdown</span></span>
<span class="embed-capacity" id="embedCapacity"></span>
<a class="embed-explore-link" id="embedExploreLink" href="#" target="_blank" rel="noopener">Explore full map <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg></a>
</div>

<div aria-label="Filters" aria-modal="false" class="map-drawer" id="filtersDrawer" role="dialog">
<div class="map-drawer-header">
<div class="map-drawer-title">Filters</div>
<button aria-label="Close filters" class="map-drawer-close" id="filtersDrawerClose" title="Close" type="button"><svg aria-hidden="true" viewbox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div>

<div class="map-drawer-body">
<div id="filtersDrawerMount"></div>
</div>
</div>

<div aria-label="Settings" aria-modal="false" class="map-drawer" id="settingsDrawer" role="dialog">
<div class="map-drawer-header">
<div class="map-drawer-title">Settings</div>
<button aria-label="Close settings" class="map-drawer-close" id="settingsDrawerClose" title="Close" type="button"><svg aria-hidden="true" viewbox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div>

<div class="map-drawer-body">
<div class="map-drawer-section-label">Display options</div>

<div id="settingsDisplayMount"></div>
</div>
</div>

<div aria-label="View Mode" aria-modal="false" class="map-drawer" id="viewModeDrawer" role="dialog">
<div class="map-drawer-header">
<div class="map-drawer-title">View Mode</div>
<button aria-label="Close view mode" class="map-drawer-close" id="viewModeDrawerClose" title="Close" type="button"><svg aria-hidden="true" viewbox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div>

<div class="map-drawer-body">
<div id="viewModeDrawerMount"></div>
</div>
</div>

<div aria-label="Theme" aria-modal="false" class="map-drawer" id="themeDrawer" role="dialog">
<div class="map-drawer-header">
<div class="map-drawer-title">Theme</div>
<button aria-label="Close theme" class="map-drawer-close" id="themeDrawerClose" title="Close" type="button"><svg aria-hidden="true" viewbox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div>

<div class="map-drawer-body">
<div id="themeDrawerMount"></div>
</div>
</div>

<div aria-label="Take a Tour" aria-modal="false" class="map-drawer" id="tourDrawer" role="dialog">
<div class="map-drawer-header">
<div class="map-drawer-title">Take a Tour</div>
<button aria-label="Close tour" class="map-drawer-close" id="tourDrawerClose" title="Close" type="button"><svg aria-hidden="true" viewbox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div>

<div class="map-drawer-body">
<div class="tour-drawer-content">
    <div class="tour-drawer-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg>
    </div>
    <div class="tour-drawer-title">Welcome to the Explorer</div>
    <p class="tour-drawer-desc">Take a quick tour to learn how to search for plants, explore the timeline, filter results, and more.</p>
    <div class="tour-drawer-actions">
        <button class="tour-drawer-btn tour-drawer-btn-primary" id="tourDrawerStartBtn">Start Tour</button>
        <button class="tour-drawer-btn tour-drawer-btn-secondary" id="tourDrawerSkipBtn">Skip for now</button>
    </div>
</div>
</div>
</div>

<div aria-label="Search nuclear power plants" class="controls-ui" id="controlsOverlay" role="search">
<div class="search-wrapper"><label class="sr-only" for="searchInput">Search for plant, reactor or country</label> <input aria-autocomplete="list" aria-controls="searchResults" aria-expanded="false" aria-haspopup="listbox" autocomplete="off" class="search-input" id="searchInput" placeholder="Search countries, plants or reactors" role="combobox" type="text" /><button aria-label="Clear search" class="search-clear-btn" id="searchClearBtn" type="button"><svg fill="none" stroke="currentColor" stroke-width="2.5" viewbox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg></button>

<div aria-label="Search results" class="search-results" id="searchResults" role="listbox"></div>
</div>
<button aria-label="Reset to global view" class="home-btn" id="homeButton" title="Reset view"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg><span class="control-label">Reset view</span></button><!-- Filters Dropdown (desktop only) -->

<div class="dropdown-wrapper" id="filtersWrapper"><button aria-label="Toggle filters" class="dropdown-btn" id="filtersToggle" title="Filters"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path></svg> <span class="btn-text">Filters</span> <svg class="chevron" fill="none" stroke="currentColor" stroke-width="2.5" viewbox="0 0 24 24"><path d="M19 9l-7 7-7-7"></path></svg></button>

<div aria-label="Filter options" class="dropdown-panel" id="filtersPanel" role="region">
<div class="dropdown-section-label">Status</div>

<div class="dropdown-option"><input id="showOperableMobile" type="checkbox" /> <label for="showOperableMobile">Operable</label></div>

<div class="dropdown-option"><input id="showConstructionMobile" type="checkbox" /> <label for="showConstructionMobile">Under Construction</label></div>

<div class="dropdown-option"><input id="showPlannedMobile" type="checkbox" /> <label for="showPlannedMobile">Planned</label></div>

<div class="dropdown-option"><input id="showShutdownMobile" type="checkbox" /> <label for="showShutdownMobile">Shutdown</label></div>

<div class="dropdown-divider"></div>

<div class="dropdown-section-label">Plant Size</div>
<div class="capacity-range-wrapper" id="capacityRangeMobile" style="padding: 4px 12px 8px;">
    <div class="capacity-range-labels">
        <span class="capacity-range-value min-val" id="capMinLabelMobile">0 GW</span>
        <span class="capacity-range-separator">to</span>
        <span class="capacity-range-value max-val" id="capMaxLabelMobile">10 GW</span>
    </div>
    <div class="capacity-range-track-container">
        <div class="capacity-range-track" id="capTrackMobile"></div>
        <input type="range" class="capacity-range-input min-input"
               id="capMinSliderMobile" min="0" max="10" step="0.1" value="0"
               aria-label="Minimum plant capacity" />
        <input type="range" class="capacity-range-input max-input"
               id="capMaxSliderMobile" min="0" max="10" step="0.1" value="10"
               aria-label="Maximum plant capacity" />
    </div>
    <div class="capacity-range-scale">
        <span>0</span><span>2</span><span>4</span><span>6</span><span>8</span><span>10 GW</span>
    </div>
</div>

<div class="dropdown-section-label">Plant Production</div>
<div class="capacity-range-wrapper" id="productionRangeMobile" style="padding: 4px 12px 8px;">
    <div class="capacity-range-labels">
        <span class="capacity-range-value min-val" id="prodMinLabelMobile">0 TWh</span>
        <span class="capacity-range-separator">to</span>
        <span class="capacity-range-value max-val" id="prodMaxLabelMobile">50.0 TWh</span>
    </div>
    <div class="capacity-range-track-container">
        <div class="capacity-range-track" id="prodTrackMobile"></div>
        <input type="range" class="capacity-range-input min-input"
               id="prodMinSliderMobile" min="0" max="50" step="0.5" value="0"
               aria-label="Minimum plant production" />
        <input type="range" class="capacity-range-input max-input"
               id="prodMaxSliderMobile" min="0" max="50" step="0.5" value="50"
               aria-label="Maximum plant production" />
    </div>
    <div class="capacity-range-scale">
        <span>0</span><span>10</span><span>20</span><span>30</span><span>40</span><span>50 TWh</span>
    </div>
</div>


<div id="displayOptionsGroup">
<div class="dropdown-divider"></div>

<div class="dropdown-section-label">Display Options</div>

<div class="dropdown-option"><input id="clusterViewMobile" type="checkbox" /> <label for="clusterViewMobile">Cluster plants</label></div>

<div class="dropdown-option"><input id="sizeByCapacityMobile" type="checkbox" /> <label for="sizeByCapacityMobile">Size by capacity</label></div>

<div class="dropdown-option"><input id="sizeByProductionMobile" type="checkbox" /> <label for="sizeByProductionMobile">Size by electricity production</label></div>
</div>
</div>
</div>
</div>
<!-- Desktop Search (top left) -->

<div aria-label="Search" class="search-overlay" id="desktopSearchOverlay" role="search"></div>
<!-- Country Info Overlay (replaces search when country selected) -->

<div aria-label="Country information" class="search-overlay" id="countryInfoOverlay" style="display:none;">
<div class="country-info-overlay" id="countryInfoBox">
<div class="country-info-header"><button aria-label="Back to search" class="country-info-back" id="countryInfoBack" title="Back to search"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M19 12H5M12 19l-7-7 7-7"></path> </svg></button>

<div class="country-info-title-wrap">
<div class="country-info-label">Country</div>

<h3 class="country-info-name" id="countryInfoName">Country Name</h3>
</div>
</div>

<div class="country-info-body">
<div class="country-info-stats-header">Reactors</div>
<div class="country-info-stats" id="countryInfoStats">
<div class="country-info-stat">
<div class="country-info-stat-value green" id="countryInfoOperable">0</div>

<div class="country-info-stat-label">Operable</div>
</div>

<div class="country-info-stat">
<div class="country-info-stat-value yellow" id="countryInfoConstruction">0</div>

<div class="country-info-stat-label">Under Construction</div>
</div>

<div class="country-info-stat">
<div class="country-info-stat-value blue" id="countryInfoPlanned">0</div>

<div class="country-info-stat-label">Planned</div>
</div>

<div class="country-info-stat">
<div class="country-info-stat-value grey" id="countryInfoShutdown">0</div>

<div class="country-info-stat-label">Shutdown</div>
</div>
</div>

<div class="country-info-capacity"><span class="country-info-capacity-label">Total Capacity</span> <span class="country-info-capacity-value" id="countryInfoCapacity">0 GW</span></div>
<button aria-expanded="false" class="country-info-plants-toggle" id="countryInfoPlantsToggle"><span class="country-info-plants-toggle-text" id="countryInfoPlantsCount">View 0 plants</span> <svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M19 9l-7 7-7-7"></path> </svg></button>

<div class="country-info-plants-list" id="countryInfoPlantsList"></div>
<!-- Country charts (visible in fullscreen) -->

<div class="country-detail-content" id="countryDetailContent">
<div class="detail-section">
<div class="detail-section-header">
<div class="detail-section-title-wrap">
<div class="detail-section-title">Nuclear electricity generation</div>

<div class="detail-section-subtitle" id="countryProductionSubtitle">Annual (TWh)</div>
</div>

<div class="production-toggle" id="countryProductionToggle"><button class="production-toggle-btn active" data-mode="annual">Annual</button><button class="production-toggle-btn" data-mode="cumulative">Cumulative</button></div>
</div>

<div class="detail-chart-wrap"><canvas aria-label="Country electricity production chart" class="detail-chart-canvas" id="countryProductionChart"></canvas>
<button class="detail-chart-expand" data-expand-chart="countryProduction" aria-label="Expand chart" title="Expand chart"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>

<div class="detail-chart-tooltip" id="countryProductionTooltip"></div>
</div>

<div class="detail-empty" id="countryProductionEmpty" style="display:none;">Electricity production data is not available yet for this country.</div>
</div>

<div class="detail-section">
<div class="detail-section-header">
<div class="detail-section-title-wrap">
<div class="detail-section-title">Reactor deployment timeline</div>
<div class="detail-section-subtitle">Grid connections and permanent shutdowns by year</div>
</div>
<div class="reactor-deploy-toggle" id="countryDeployToggle">
<button class="reactor-deploy-toggle-btn active" data-mode="units">Units</button>
<button class="reactor-deploy-toggle-btn" data-mode="capacity">Capacity</button>
</div>
</div>
<div id="countryDeployChartWrap" style="position:relative;">
<div class="reactor-deploy-chart" id="countryReactorDeploy"></div>
<button class="detail-chart-expand" data-expand-chart="countryDeploy" aria-label="Expand chart" title="Expand chart"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>
</div>
<div class="detail-empty" id="countryDeployEmpty" style="display:none;">Reactor deployment data is not available yet for this country.</div>
</div>
</div>
</div>
</div>
</div>
<!-- Plant Info Overlay (replaces search when plant/reactor selected) -->

<div aria-label="Plant information" class="search-overlay" id="plantInfoOverlay" style="display:none;">
<div class="plant-info-overlay" id="plantInfoBox">
<div class="plant-info-header"><button aria-label="Back to search" class="plant-info-back" id="plantInfoBack" title="Back to search"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M19 12H5M12 19l-7-7 7-7"></path> </svg></button>

<div class="plant-info-title-wrap">
<div class="plant-info-country" id="plantInfoCountry">Country</div>

<h3 class="plant-info-name" id="plantInfoName">Plant Name</h3>
</div>

<div class="plant-info-status-badge" id="plantInfoStatusBadge">Operable</div>
</div>

<div class="plant-info-body">
<div class="plant-info-stats" id="plantInfoStats">
<div class="plant-info-stat">
<div class="plant-info-stat-value" id="plantInfoReactorCount">0</div>

<div class="plant-info-stat-label">Reactors</div>
</div>

<div class="plant-info-stat">
<div class="plant-info-stat-value" id="plantInfoCapacity">0</div>

<div class="plant-info-stat-label">Capacity (GW)</div>
</div>

<div class="plant-info-stat">
<div class="plant-info-stat-value" id="plantInfoFirstGrid">&mdash;</div>

<div class="plant-info-stat-label">First grid connection</div>
</div>
</div>

<div class="plant-info-actions" id="plantInfoActions"><button aria-label="View detailed summary" class="plant-info-details-btn" id="plantInfoMoreDetails" type="button"><span class="plant-details-btn-label">View detailed summary</span><svg aria-hidden="true" fill="none" height="16" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24" width="16"><polyline points="9 18 15 12 9 6"></polyline></svg></button></div>
<button aria-expanded="false" class="plant-info-reactors-toggle" id="plantInfoReactorsToggle"><span class="plant-info-reactors-toggle-text" id="plantInfoReactorsCount">View 0 reactors</span> <svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M19 9l-7 7-7-7"></path> </svg></button>

<div class="plant-info-reactors-list" id="plantInfoReactorsList"></div>
</div>
</div>
</div>
<!-- Plant Detailed Summary Modal -->

<div aria-hidden="true" class="plant-detail-modal" id="plantDetailModal">
<div class="plant-detail-backdrop" id="plantDetailBackdrop"></div>

<div aria-labelledby="plantDetailTitle" aria-modal="true" class="plant-detail-dialog" role="dialog">
<div class="plant-info-header"><button aria-label="Back to plant summary" class="plant-info-back" id="plantDetailBack" title="Back to summary"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M19 12H5M12 19l-7-7 7-7"></path> </svg></button>

<div class="plant-info-title-wrap">
<div class="plant-info-country" id="plantDetailCountry"></div>

<h3 class="plant-info-name" id="plantDetailTitle"></h3>
</div>

<div class="plant-info-status-badge" id="plantDetailStatusBadge"></div>
</div>

<div class="plant-info-stats">
<div class="plant-info-stat">
<div class="plant-info-stat-value" id="plantDetailReactorCount">0</div>

<div class="plant-info-stat-label">Reactors</div>
</div>

<div class="plant-info-stat">
<div class="plant-info-stat-value" id="plantDetailCapacity">0</div>

<div class="plant-info-stat-label">Capacity (GW)</div>
</div>

<div class="plant-info-stat">
<div class="plant-info-stat-value" id="plantDetailFirstGrid">&mdash;</div>

<div class="plant-info-stat-label">First grid connection</div>
</div>
</div>
<button aria-expanded="false" class="plant-info-reactors-toggle" id="plantDetailReactorsToggle"><span class="plant-info-reactors-toggle-text" id="plantDetailReactorsCount">View 0 reactors</span> <svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M19 9l-7 7-7-7"></path> </svg></button>

<div class="plant-info-reactors-list" id="plantDetailReactorsList"></div>

<div class="plant-detail-content">
<div class="plant-detail-panel active" data-panel="production">
<div class="detail-section">
<div class="detail-section-header">
<div class="detail-section-title-wrap">
<div class="detail-section-title">Plant electricity generation</div>

<div class="detail-section-subtitle" id="plantProductionSubtitle">Annual (TWh)</div>
</div>

<div class="production-toggle" id="plantProductionToggle"><button class="production-toggle-btn active" data-mode="annual">Annual</button><button class="production-toggle-btn" data-mode="cumulative">Cumulative</button></div>
</div>

<div class="detail-chart-wrap"><canvas aria-label="Plant electricity production chart" class="detail-chart-canvas" id="plantProductionChart"></canvas>
<button class="detail-chart-expand" data-expand-chart="plantProduction" aria-label="Expand chart" title="Expand chart"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>

<div class="detail-chart-tooltip" id="plantProductionTooltip"></div>
</div>

<div class="detail-empty" id="plantProductionEmpty" style="display:none;">Electricity production data is not available yet for this plant.</div>
</div>
</div>

<div class="plant-detail-panel active" data-panel="timeline">
<div class="detail-section">
<div class="detail-section-header-row">
<div class="detail-section-title-wrap">
<div class="detail-section-title">Plant timeline</div>
<div class="detail-section-subtitle" id="plantTimelineSubtitle">Each row shows construction (start &rarr; grid connection) in yellow and operation (grid connection &rarr; shutdown/present) in green.</div>
</div>
</div>
<div style="position:relative;">
<div class="detail-timeline" id="plantReactorTimeline"></div>
<button class="detail-chart-expand" data-expand-chart="plantTimeline" aria-label="Expand timeline" title="Expand timeline"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>
</div>
<div class="detail-empty" id="plantTimelineEmpty" style="display:none;">No reactor timeline data available for this plant.</div>
</div>

<div class="detail-section" id="plantRecentNewsSection">
<div class="detail-section-title">Recent news</div>

<div class="detail-section-subtitle">Recent World Nuclear News coverage</div>

<ul aria-label="Recent news links" class="recent-news-list" id="plantRecentNewsList" style="display:none;">
</ul>

<div class="detail-empty" id="plantRecentNewsEmpty" style="display:none;">No recent news is available for this plant yet.</div>
</div>
</div>
</div>
</div>
</div>
<!-- Map Controls (top right) -->

<div class="map-controls-group" id="mapControlsGroup"><button aria-label="Share this view" class="share-btn" id="shareButton" title="Share this view"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg></button><button aria-label="Toggle fullscreen" class="map-control-btn" id="fullscreenBtn" title="Toggle fullscreen"><svg fill="none" id="expandIcon" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M4 14h2v4h4v2H4v-6zm16-4h-2V6h-4V4h6v6zM4 10h2V6h4V4H4v6zm16 4h-2v4h-4v2h6v-6z"></path></svg> <svg fill="none" id="compressIcon" stroke="currentColor" stroke-width="2" style="display:none;" viewbox="0 0 24 24"><path d="M9 9H5V7h2V5h2v4zm6 0h4V7h-2V5h-2v4zM9 15H5v2h2v2h2v-4zm6 0h4v2h-2v2h-2v-4z"></path></svg><span class="control-label">Fullscreen</span></button><button aria-label="Toggle dark mode" aria-pressed="false" class="map-control-btn dark-mode-btn" id="darkModeBtn" title="Toggle dark mode"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg><span class="control-label">Dark mode</span></button>

<div class="view-mode-wrapper"><button aria-label="Change view mode" class="map-control-btn" id="viewModeBtn" title="Change view mode"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"></path></svg></button>

<div class="view-mode-popup" id="viewModePopup">
<div class="view-mode-option active" data-mode="satellite"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg> Satellite</div>

<div class="view-mode-option" data-mode="map"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M9 3L2 6v15l7-3m0-15l6 3m-6-3v15m6-12l7-3v15l-7 3m0-15v15"></path></svg> Map</div>

<div class="view-mode-option" data-mode="globe"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path><ellipse cx="12" cy="12" rx="10" ry="4"></ellipse></svg> 3D Globe</div>
</div>
</div>

<div class="info-btn-wrapper"><button aria-label="More information" class="map-control-btn" id="infoBtn" title="More information">i</button>
</div>
</div>
<!-- Status Bar: Year Indicator + Filter Chips (desktop) -->

<div aria-live="polite" class="map-status-bar at-present" id="mapStatusBar">
<div class="map-year-badge" id="mapYearBadge"><span class="map-year-badge-label">Current view</span><svg class="map-year-badge-icon" fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <circle cx="12" cy="12" r="10"></circle> <polyline points="12 6 12 12 16 14"></polyline> </svg> <span class="map-year-badge-value" id="mapYearBadgeValue">Present</span></div>
<div class="status-bar-separator" id="statusBarSeparator" style="display:none;"></div>
<div class="status-bar-filter-icon" id="statusBarFilterIcon" style="display:none;"><svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path></svg></div>
<div class="status-bar-filters" id="statusBarFilters"></div>
</div>
<!-- Map View Dropdown (used in desktop sidebar; hidden on mobile) -->

<div class="dropdown-wrapper visible view-dropdown-wrapper" id="viewDropdownWrapper"><button aria-label="Toggle map view options" class="dropdown-btn" id="viewDropdownToggle" type="button"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"></path></svg> <span class="btn-text" id="viewDropdownLabel">Satellite</span> <svg class="chevron" fill="none" stroke="currentColor" stroke-width="2.5" viewbox="0 0 24 24"><path d="M19 9l-7 7-7-7"></path></svg></button>

<div aria-label="Map view options" class="dropdown-panel visible" id="viewDropdownPanel" role="region">
<div class="view-mode-option active" data-mode="satellite"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg> Satellite</div>

<div class="view-mode-option" data-mode="map"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><path d="M9 3L2 6v15l7-3m0-15l6 3m-6-3v15m6-12l7-3v15l-7 3m0-15v15"></path></svg> Map</div>

<div class="view-mode-option" data-mode="globe"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path><ellipse cx="12" cy="12" rx="10" ry="4"></ellipse></svg> 3D Globe</div>
</div>
</div>
<!-- Map canvas (map/globe + overlays) -->

<div class="map-canvas" id="mapCanvas">
<!-- Map Legend -->
<div aria-label="Map legend" class="map-legend" role="region">
<div class="map-legend-items">
<div class="map-legend-item"><span class="map-legend-dot green"></span><span>Operable</span></div>

<div class="map-legend-item"><span class="map-legend-dot yellow"></span><span>Under Construction</span></div>

<div class="map-legend-item"><span class="map-legend-dot blue"></span><span>Planned</span></div>

<div class="map-legend-item"><span class="map-legend-dot grey"></span><span>Shutdown</span></div>
</div>
</div>
<!-- View Options Panel (visible only at Present) -->

<div aria-label="Interactive map of nuclear power plants" id="map" role="application"></div>
<div class="map-browse" id="mapBrowse">
<button aria-controls="mapBrowseList" aria-expanded="false" aria-live="polite" class="map-browse-toggle" id="mapBrowseToggle" type="button">Browse plants on the map</button>
<ul aria-label="Plants currently shown on the map" class="map-browse-list" hidden id="mapBrowseList"></ul>
</div>
<!-- Mobile Year Indicator (centered, only visible on mobile) -->

<div aria-live="polite" class="mobile-year-indicator at-present" id="mobileYearIndicator">
<div class="year-indicator-icon"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <circle cx="12" cy="12" r="10"></circle> <path d="M12 6v6l4 2"></path> </svg></div>

<div class="year-indicator-content">
<div class="year-indicator-label" id="mobileYearLabel">Current view: Present</div>

<div class="year-indicator-value" id="mobileYearValue">Present</div>

<div class="year-indicator-meta" id="mobileYearMeta">Last update: 04/01/2026</div>
</div>
</div>

<!-- Info modal -->
<div class="map-info-modal" id="mapInfoModal" aria-hidden="true">
<div class="map-info-modal-backdrop" id="mapInfoModalBackdrop"></div>
<div class="map-info-modal-dialog" role="dialog" aria-modal="true">
<div class="map-info-modal-header">
<div class="map-info-modal-title">Nuclear Power Plant Explorer</div>
<button class="map-info-modal-close" id="mapInfoModalClose" aria-label="Close">&times;</button>
</div>
<div class="map-info-modal-body">
<div class="map-info-modal-text">This interactive map shows the location of the world&#39;s nuclear power plants and reactors.</div>
<div class="map-info-modal-text">Users can search by country, plant or reactor name. Clicking on any site reveals key information including reactor status, capacity, and operating history.</div>
<div class="map-info-modal-text">In fullscreen mode on desktop, detailed profiles are available for both plants and countries, including historical electricity production charts and reactor deployment timelines.</div>
<div class="map-info-modal-text">The Global Statistics sidebar (visible in fullscreen) shows how nuclear electricity production, the reactor fleet, and construction activity have changed over time.</div>
<div class="map-info-modal-text">The timeline slider allows users to explore the evolution of the nuclear fleet from 1954 to the present day.</div>
<div class="map-info-modal-text">The left-hand sidebar provides display options and filters. Users can filter by reactor status (Operable, Under Construction, Planned, or Shutdown) and by plant capacity. The map can be viewed in Satellite, Map, or 3D Globe mode.</div>
<div class="map-info-modal-text">Users can navigate directly to <a href="https://world-nuclear.org/nuclear-reactor-database/summary" rel="noopener noreferrer" target="_blank">World Nuclear Association&#39;s Reactor Database</a> for detailed data about any specific reactor.</div>
<div class="map-info-modal-text">Data is sourced from <a href="https://world-nuclear.org/nuclear-reactor-database/summary" rel="noopener noreferrer" target="_blank">World Nuclear Association&#39;s Reactor Database</a> and <a href="https://pris.iaea.org" rel="noopener noreferrer" target="_blank">IAEA&#39;s Power Reactor Information System (PRIS)</a>.</div>
</div>
</div>
</div>

<!-- v5.7.78: Expanded chart modal -->
<div class="expanded-chart-modal" id="expandedChartModal" aria-hidden="true">
<div class="expanded-chart-backdrop" id="expandedChartBackdrop"></div>
<div class="expanded-chart-dialog" role="dialog" aria-modal="true">
<div class="expanded-chart-header">
<div class="expanded-chart-header-text">
<div class="expanded-chart-title" id="expandedChartTitle"></div>
<div class="expanded-chart-subtitle" id="expandedChartSubtitle"></div>
</div>
<button class="expanded-chart-close" id="expandedChartClose" aria-label="Close expanded chart">&times;</button>
<div class="expanded-chart-toggle" id="expandedChartToggle" style="display:none;">
<button class="production-toggle-btn active" data-mode="annual">Annual</button>
<button class="production-toggle-btn" data-mode="cumulative">Cumulative</button>
</div>
</div>
<div class="expanded-chart-body">
<canvas class="expanded-chart-canvas" id="expandedChartCanvas"></canvas>
<div class="expanded-chart-custom" id="expandedChartCustom" style="display:none;"></div>
</div>
<div class="expanded-chart-legend" id="expandedChartLegend"></div>
</div>
</div>
<!-- v5.7.78: Floating tooltip for expanded chart -->
<div class="expanded-chart-tooltip" id="expandedChartTooltip">
<div class="expanded-chart-tooltip-card" id="expandedChartTooltipCard"></div>
</div>


<div aria-label="3D globe view of nuclear power plants" id="globeContainer" role="application"></div>
</div>
<!-- Country Deep-Dive Panel -->

<div class="country-panel" id="countryPanel">
<div class="country-panel-header"><button aria-label="Close panel" class="country-panel-close" id="countryPanelClose"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M18 6L6 18M6 6l12 12"></path> </svg></button>

<h2 class="country-panel-title" id="countryPanelTitle">Country Name</h2>

<div class="country-panel-subtitle">Nuclear Power Profile</div>
</div>

<div class="country-panel-content" id="countryPanelContent"><!-- Content populated by JavaScript --></div>
</div>
<!-- Mobile Plant Panel (bottom sheet) -->

<div class="plant-panel" id="plantPanel">
<div class="plant-panel-header"><button aria-label="Close panel" class="plant-panel-close" id="plantPanelClose"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M18 6L6 18M6 6l12 12"></path> </svg></button>

<h2 class="plant-panel-title" id="plantPanelTitle">Plant Name</h2>

<button class="plant-panel-subtitle" id="plantPanelSubtitle" type="button">Nuclear Power Plant</button>

<div class="plant-panel-status" id="plantPanelStatus">Operable</div>
</div>

<div class="plant-panel-content" id="plantPanelContent"><!-- Content populated by JavaScript --></div>
</div>
<!-- Mobile Filter Panel (bottom sheet) -->

<div class="filter-panel" id="filterPanel">
<div class="filter-panel-header">
<h2 class="filter-panel-title">Filters</h2>
<button aria-label="Close filters" class="filter-panel-close" id="filterPanelClose"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M18 6L6 18M6 6l12 12"></path> </svg></button></div>

<div class="filter-panel-content" id="filterPanelContent">
<div class="filter-section">
<div class="filter-section-title">Status</div>

<div class="filter-option" data-filter="showOperable"><input id="filterShowOperable" type="checkbox" /> <label for="filterShowOperable">Operable</label></div>

<div class="filter-option" data-filter="showConstruction"><input id="filterShowConstruction" type="checkbox" /> <label for="filterShowConstruction">Under Construction</label></div>

<div class="filter-option" data-filter="showPlanned"><input id="filterShowPlanned" type="checkbox" /> <label for="filterShowPlanned">Planned</label></div>

<div class="filter-option" data-filter="showShutdown"><input id="filterShowShutdown" type="checkbox" /> <label for="filterShowShutdown">Shutdown</label></div>
</div>

<div class="filter-section">
<div class="filter-section-title">Plant Size</div>
<div class="capacity-range-wrapper" id="capacityRangeFilter" style="padding: 4px 14px 8px;">
    <div class="capacity-range-labels">
        <span class="capacity-range-value min-val" id="capMinLabelFilter">0 GW</span>
        <span class="capacity-range-separator">to</span>
        <span class="capacity-range-value max-val" id="capMaxLabelFilter">10 GW</span>
    </div>
    <div class="capacity-range-track-container">
        <div class="capacity-range-track" id="capTrackFilter"></div>
        <input type="range" class="capacity-range-input min-input"
               id="capMinSliderFilter" min="0" max="10" step="0.1" value="0"
               aria-label="Minimum plant capacity" />
        <input type="range" class="capacity-range-input max-input"
               id="capMaxSliderFilter" min="0" max="10" step="0.1" value="10"
               aria-label="Maximum plant capacity" />
    </div>
    <div class="capacity-range-scale">
        <span>0</span><span>2</span><span>4</span><span>6</span><span>8</span><span>10 GW</span>
    </div>
</div>
</div>

<div class="filter-section">
<div class="filter-section-title">Plant Production</div>
<div class="capacity-range-wrapper" id="productionRangeFilter" style="padding: 4px 14px 8px;">
    <div class="capacity-range-labels">
        <span class="capacity-range-value min-val" id="prodMinLabelFilter">0 TWh</span>
        <span class="capacity-range-separator">to</span>
        <span class="capacity-range-value max-val" id="prodMaxLabelFilter">50.0 TWh</span>
    </div>
    <div class="capacity-range-track-container">
        <div class="capacity-range-track" id="prodTrackFilter"></div>
        <input type="range" class="capacity-range-input min-input"
               id="prodMinSliderFilter" min="0" max="50" step="0.5" value="0"
               aria-label="Minimum plant production" />
        <input type="range" class="capacity-range-input max-input"
               id="prodMaxSliderFilter" min="0" max="50" step="0.5" value="50"
               aria-label="Maximum plant production" />
    </div>
    <div class="capacity-range-scale">
        <span>0</span><span>10</span><span>20</span><span>30</span><span>40</span><span>50 TWh</span>
    </div>
</div>
</div>


<div class="filter-section">
<div class="filter-section-title">Display Options</div>

<div class="filter-option" data-filter="clusterView"><input id="filterClusterView" type="checkbox" /> <label for="filterClusterView">Cluster plants</label></div>

<div class="filter-option" data-filter="sizeByCapacity"><input id="filterSizeByCapacity" type="checkbox" /> <label for="filterSizeByCapacity">Size by capacity</label></div>

<div class="filter-option" data-filter="sizeByProduction"><input id="filterSizeByProduction" type="checkbox" /> <label for="filterSizeByProduction">Size by electricity production</label></div>
</div>
</div>
</div>
<!-- Year Slider Panel (below map, inside map-container) -->

<div class="year-slider-panel" id="yearSliderPanel">
<div class="timeline-controls"><button aria-label="Play timeline animation" class="play-btn" id="playBtn" title="Play time-lapse"><svg fill="currentColor" id="playIcon" viewbox="0 0 24 24"> <path d="M8 5v14l11-7z"></path> </svg> <svg fill="currentColor" id="pauseIcon" style="display:none;" viewbox="0 0 24 24"> <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"></path> </svg></button><button aria-label="Change playback speed" class="speed-btn" id="speedBtn" title="Playback speed">1x</button>

<div class="slider-container"><span class="year-min-label">1954</span>

<div class="slider-wrapper"><input aria-label="Select year" class="year-slider" id="yearSlider" max="2026" min="1954" type="range" value="2026" /></div>
<span class="year-max-label">Present</span></div>

<div class="slider-stats"><span class="reactors-label">Reactors:</span>

<div class="stat-chip">
<div class="stat-dot operable"></div>

<div class="stat-info"><span class="stat-count" id="statOperable">0</span></div>
</div>

<div class="stat-chip">
<div class="stat-dot construction"></div>

<div class="stat-info"><span class="stat-count" id="statConstruction">0</span></div>
</div>

<div class="stat-chip">
<div class="stat-dot planned"></div>

<div class="stat-info"><span class="stat-count" id="statPlanned">0</span></div>
</div>

<div class="stat-chip">
<div class="stat-dot shutdown"></div>

<div class="stat-info"><span class="stat-count" id="statShutdown">0</span></div>
</div>
</div>
<button aria-label="Expand timeline charts" class="timeline-expand-btn" id="timelineExpandBtn" title="Show charts"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M9 18l6-6-6-6"></path> </svg></button></div>
</div>
</div>
<!-- Timeline Charts Right Sidebar -->

<div class="timeline-charts-sidebar" id="timelineChartsSidebar">
<div class="timeline-charts-header">
<div class="timeline-header-content">
<div class="timeline-header-label">Global statistics</div>
</div>
<button aria-label="Close charts" class="timeline-charts-close" id="timelineChartsClose"><svg fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24"> <path d="M18 6L6 18M6 6l12 12"></path> </svg></button></div>

<div class="timeline-charts-content">
<!-- Year Changes Dropdown (v5.7.83) -->
<div class="year-changes-dropdown" id="yearChangesDropdown" style="display:none;">
    <button class="year-changes-dropdown-toggle" id="yearChangesDropdownToggle"
            aria-expanded="false" aria-controls="yearChangesDropdownBody">
        <span class="year-changes-dropdown-label">
            <span class="year-changes-dropdown-title">Changes in </span>
            <span class="year-changes-dropdown-year" id="yearChangesYear"></span>
        </span>
        <span class="year-changes-dropdown-badge" id="yearChangesBadge">0</span>
        <svg class="year-changes-dropdown-chevron" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2">
            <path d="M6 9l6 6 6-6"></path>
        </svg>
    </button>
    <div class="year-changes-dropdown-body" id="yearChangesBody"
         role="region" aria-label="Year changes list"></div>
</div>
<div class="timeline-chart-panel" data-chart="electricity">
<div class="timeline-chart-panel-header">
<div class="timeline-chart-panel-titles"><div class="timeline-chart-panel-title">Electricity (TWh)</div><div class="timeline-chart-panel-subtitle">Worldwide generation</div></div>
<button class="timeline-chart-expand" aria-label="Expand chart" title="Expand chart"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>
</div>
<div class="timeline-chart-panel-body">
<canvas class="timeline-chart-canvas" id="electricityChartCanvas"></canvas>
<div class="timeline-chart-value" id="electricityChartValue">&mdash;</div>
</div>
</div>

<div class="timeline-chart-panel" data-chart="reactors">
<div class="timeline-chart-panel-header">
<div class="timeline-chart-panel-titles"><div class="timeline-chart-panel-title">Reactors</div><div class="timeline-chart-panel-subtitle">Global fleet over time</div></div>
<button class="timeline-chart-expand" aria-label="Expand chart" title="Expand chart"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>
</div>
<div class="timeline-chart-panel-body">
<canvas class="timeline-chart-canvas" id="reactorsChartCanvas"></canvas>
<div class="timeline-chart-value" id="reactorsChartValue">&mdash;</div>
</div>
</div>

<div class="timeline-chart-panel" data-chart="constructionStarts">
<div class="timeline-chart-panel-header">
<div class="timeline-chart-panel-titles"><div class="timeline-chart-panel-title">Construction Starts</div><div class="timeline-chart-panel-subtitle">New builds per year</div></div>
<button class="timeline-chart-expand" aria-label="Expand chart" title="Expand chart"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>
</div>
<div class="timeline-chart-panel-body">
<canvas class="timeline-chart-canvas" id="constructionStartsChartCanvas"></canvas>
<div class="timeline-chart-value" id="constructionStartsChartValue">&mdash;</div>
</div>
</div>

<div class="timeline-chart-panel" data-chart="gridConnections">
<div class="timeline-chart-panel-header">
<div class="timeline-chart-panel-titles"><div class="timeline-chart-panel-title">Reactor Deployment</div><div class="timeline-chart-panel-subtitle">Grid connections &amp; shutdowns per year</div></div>
<button class="timeline-chart-expand" aria-label="Expand chart" title="Expand chart"><svg viewBox="0 0 16 16"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4"/></svg></button>
</div>
<div class="timeline-chart-panel-body">
<div class="timeline-deploy-chart" id="timelineDeployChartContainer"></div>
<div class="timeline-chart-value" id="gridConnectionsChartValue">&mdash;</div>
</div>
</div>
</div>

</div>
<button class="fs-stats-expand-btn" id="fsStatsExpandBtn" aria-label="Show statistics panel" title="Show statistics"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"></path></svg></button>
</div>

<div class="map-data-sources">
<p class="data-note">Note: For detailed information on reactors and electricity production, consult <a href="https://world-nuclear.org/nuclear-reactor-database/summary" rel="noopener noreferrer" target="_blank">World Nuclear Association&#39;s Reactor Database</a>.</p>

<p class="data-attribution">Data sources: World Nuclear Association and <a href="https://pris.iaea.org/pris/home.aspx" rel="noopener noreferrer" target="_blank">IAEA Power Reactor Information Service (PRIS)</a></p>
</div>
</div>
</div>

<!-- Tour Feature HTML -->
<div class="tour-overlay" id="tourOverlay">
    <div class="tour-backdrop" id="tourBackdrop"></div>
    <div class="tour-spotlight" id="tourSpotlight"></div>
    <div class="tour-cursor" id="tourCursor"><svg viewBox="0 0 24 24" width="28" height="28" fill="none"><path d="M5.5 3.21V20.8l4.86-4.86h8.14L5.5 3.21z" fill="#2d3436" stroke="#fff" stroke-width="1.2" stroke-linejoin="round"/></svg></div>
    <div class="tour-card" id="tourCard">
        <div class="tour-card-header">
            <div class="tour-card-icon" id="tourCardIcon"></div>
            <span class="tour-card-step" id="tourCardStep"></span>
        </div>
        <h3 class="tour-card-title" id="tourCardTitle"></h3>
        <p class="tour-card-desc" id="tourCardDesc"></p>
        <div class="tour-card-actions">
            <button class="tour-btn tour-btn-primary" id="tourNextBtn">Next</button>
            <button class="tour-btn tour-btn-skip" id="tourSkipBtn">Skip</button>
        </div>
        <div class="tour-progress" id="tourProgress"></div>
    </div>
</div>

<div class="tour-welcome-modal" id="tourWelcomeModal">
    <div class="tour-welcome-icon">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4M12 8h.01"></path></svg>
    </div>
    <h2 class="tour-welcome-title">Welcome to the Nuclear Power Plant Explorer</h2>
    <p class="tour-welcome-desc">Take a quick tour to learn how to search for plants, explore the timeline, filter results, and more.</p>
    <div class="tour-welcome-actions">
        <button class="tour-btn tour-btn-primary" id="tourStartBtn">Start Tour</button>
        <button class="tour-btn tour-btn-secondary" id="tourSkipWelcomeBtn">Skip for now</button>
    </div>
</div>

<button class="tour-trigger-btn" id="tourTriggerBtn" aria-label="Take a tour" title="Take a tour">
    <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg>
</button>
<!-- Tour Nudge -->
<div class="tour-nudge" id="tourNudge" role="button" tabindex="0" aria-label="Click to start the tour">
    <div class="tour-nudge-content">
        <div class="tour-nudge-text">
            <strong>New here?</strong>
            Take a quick tour to learn the basics
        </div>
        <span class="tour-nudge-cta">Click to start &rarr;</span>
    </div>
    <button class="tour-nudge-close" id="tourNudgeClose" aria-label="Dismiss" title="Dismiss">
        <svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12"></path></svg>
    </button>
</div>

</div>

<script src="https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl.js" defer crossorigin="anonymous" integrity="sha384-5+cfbwT0iiub6VsQAdn6yz16nr6sDiQoHx6tm4O8OVYXHYOxcffFmCJBL0dgdvGp" referrerpolicy="no-referrer"></script>
<script>
'use strict';
window.addEventListener('DOMContentLoaded', () => {

// =============================================================================
// v5.7.156: Mobile gate — extracted outside IIFE for in-place initialization.
// When a mobile user taps "Load Map Anyway", the map now initialises directly
// in the current page instead of triggering window.location.reload(). This
// eliminates the flash of non-fullscreen content that occurred between reload
// and the deferred toggleFullscreen() call deep in the boot sequence.
// =============================================================================
const __mwEl = document.getElementById('map-wrapper');
const __isMobileVP = window.matchMedia('(max-width: 600px)').matches || window.matchMedia('(hover: none) and (pointer: coarse) and (max-width: 900px)').matches;
const __forceMobileLoad = sessionStorage.getItem('forceMobileMapLoad') === 'true';
let __mobileDirectInit = false;

// v5.7.156: Always intercept the mobile load button on mobile devices.
// Uses stopImmediatePropagation to prevent the legacy reload handler (inside
// the IIFE) from firing, ensuring a single consistent code path.
if (__isMobileVP) {
    const __loadBtn = document.getElementById('mobileLoadMapBtn');
    if (__loadBtn) {
        __loadBtn.addEventListener('click', function(e) {
            e.stopImmediatePropagation();

            // Re-entry: map already initialised — just toggle fullscreen back on
            if (window.__mapInitialized && typeof window.__toggleFullscreen === 'function') {
                sessionStorage.setItem('forceMobileMapLoad', 'true');
                if (__mwEl) {
                    __mwEl.classList.add('mobile-direct-loading');
                    __mwEl.classList.remove('mobile-hold-active');
                }
                window.__toggleFullscreen();
                requestAnimationFrame(function() {
                    requestAnimationFrame(function() {
                        if (__mwEl) __mwEl.classList.add('mobile-init-reveal');
                        setTimeout(function() {
                            if (__mwEl) {
                                __mwEl.classList.remove('mobile-direct-loading');
                                __mwEl.classList.remove('mobile-init-reveal');
                            }
                            __loadBtn.textContent = 'Load Map Anyway';
                        }, 450);
                    });
                });
                return;
            }

            // First-time: initialise map in-place without page reload
            __mobileDirectInit = true;
            sessionStorage.setItem('forceMobileMapLoad', 'true');
            __loadBtn.textContent = 'Loading map\u2026';
            __loadBtn.disabled = true;

            // Switch from mobile-hold-active (display:none on #map-shell) to
            // mobile-direct-loading (z-index overlay) so the shell stays visible
            // and Leaflet can measure its container dimensions correctly.
            if (__mwEl) {
                __mwEl.classList.remove('mobile-hold-active');
                __mwEl.classList.add('mobile-direct-loading');
                // Pre-apply fullscreen layout BEFORE init so Leaflet creates the
                // map at the correct viewport size.
                __mwEl.classList.add('fullscreen');
                document.body.classList.add('fullscreen-active');
                document.documentElement.classList.add('fullscreen-active');
            }

            // Give the browser a frame to paint the fullscreen CSS, then run init
            setTimeout(function() { __runMainInit(); }, 50);
        });
    }
}

// v5.7.164: Embed mode — bypass mobile hold screen and init immediately
const __isEmbed = new URLSearchParams(window.location.search).has('embed');
if (__isEmbed) {
    if (__mwEl) __mwEl.classList.add('embed-mode');
    __runMainInit();
} else if (__isMobileVP && !__forceMobileLoad) {
    // Mobile first visit without opt-in: show hold screen, defer initialisation
    if (__mwEl) __mwEl.classList.add('mobile-hold-active');
} else {
    // Desktop or mobile reload path: initialise immediately
    __runMainInit();
}

function __runMainInit() {
(async () => {
    const mapWrapperEl = document.getElementById('map-wrapper');
    const isMobileViewport = window.matchMedia('(max-width: 600px)').matches || window.matchMedia('(hover: none) and (pointer: coarse) and (max-width: 900px)').matches;
    const forceMobileLoad = sessionStorage.getItem('forceMobileMapLoad') === 'true';
    const mobileAutoFullscreen = sessionStorage.getItem('mobileAutoFullscreen') === 'true';

    // v5.7.164: Embed mode detection inside IIFE
    const isEmbedMode = new URLSearchParams(window.location.search).has('embed');
    if (isEmbedMode && mapWrapperEl) mapWrapperEl.classList.add('embed-mode');

    // v5.7.54: If mobile auto-fullscreen is pending (reload path), add class immediately to prevent flash
    if (isMobileViewport && forceMobileLoad && mobileAutoFullscreen && mapWrapperEl) {
        mapWrapperEl.classList.add('mobile-fs-pending');
        mapWrapperEl.classList.add('mobile-hold-active');
        const loadBtnEl = document.getElementById('mobileLoadMapBtn');
        if (loadBtnEl) loadBtnEl.textContent = 'Loading map\u2026';
    }

    // Legacy reload handler (intercepted by outer handler on mobile via stopImmediatePropagation)
    const loadBtn = document.getElementById('mobileLoadMapBtn');
    if (loadBtn) {
        loadBtn.addEventListener('click', () => {
            sessionStorage.setItem('forceMobileMapLoad', 'true');
            sessionStorage.setItem('mobileAutoFullscreen', 'true');
            window.location.reload();
        });
    }

    // On mobile, do not auto-load the map. Show a holding frame and let users opt in.
    if (isMobileViewport && !forceMobileLoad) {
        if (mapWrapperEl) mapWrapperEl.classList.add('mobile-hold-active');
        return;
    }

    if (mapWrapperEl && !mapWrapperEl.classList.contains('mobile-fs-pending')) mapWrapperEl.classList.remove('mobile-hold-active');

    // =============================================================================
    // --- 1. REACTOR DATA (fetched from Cloudflare Worker) --- v5.7.165
    // =============================================================================

    const DATA_URL = 'https://wna-data-worker.world-nuclear.workers.dev';
    const DATA_FETCH_TIMEOUT_MS = 30000;
    // Generous: it must never pre-empt a slow but healthy parse and map build.
    const LOADER_WATCHDOG_MS = 20000;
    // How long the overlay will wait for the map's style before revealing the
    // page anyway. Short, because a blank map the user can see beats a bar they
    // cannot dismiss; the map's own 8s watchdog still reports real failure.
    const LOADER_MAP_CAP_MS = 2500;

    const loaderOverlay = document.getElementById('dataLoaderOverlay');
    const errorOverlay = document.getElementById('dataErrorOverlay');
    const retryBtn = document.getElementById('dataRetryBtn');
    const loaderText = document.getElementById('dataLoaderText');
    const loaderTrack = document.getElementById('dataLoaderTrack');
    const loaderBar = document.getElementById('dataLoaderBar');

    // One bar spanning the whole load. Per-phase bars were the wrong shape: with
    // the data compressed, the download and parse finish before the eye catches
    // them, so all a viewer ever sees is the last phase — and a fresh indicator
    // starting at zero there is indistinguishable from one that is stuck.
    //
    // Milestones are weighted to match that reality, with most of the bar's
    // travel reserved for the map. Progress is monotonic by construction: a
    // request to go backwards is dropped rather than rewinding the bar, which
    // would read as a fault.
    const LOADER_STEPS = {
        start:     0.06,   // never begin at 0 — an empty bar reads as "not started"
        dataStart: 0.10,
        dataEnd:   0.55,
        parsed:    0.70,
        mapBuilt:  0.85,
        mapCreep:  0.97,   // eased toward, never arrived at, while the map builds
        done:      1
    };
    let loaderProgress = 0;

    function setLoaderPhase(label) {
        if (loaderText && label) loaderText.textContent = label;
    }

    // `ms` is the easing time, and doubles as the honest way to show unmeasurable
    // work: aim at the next milestone over roughly how long it ought to take, and
    // the bar keeps moving without ever claiming to have arrived.
    function setLoaderProgress(target, ms) {
        if (!loaderBar) return;
        const t = Math.max(0, Math.min(1, target));
        if (t <= loaderProgress) return;
        loaderProgress = t;
        loaderBar.style.transitionDuration = (ms == null ? 400 : ms) + 'ms';
        loaderBar.style.transform = 'scaleX(' + t + ')';
    }

    // Everything from the fetch to the map runs in one synchronous stretch, so
    // without yielding the browser never paints an intermediate phase — the text
    // would change three times between two frames and the user would see only the
    // last. Two frames: one to apply the style, one to let it composite.
    function paintFrame() {
        return new Promise(function(resolve) {
            let done = false;
            const finish = function() { if (!done) { done = true; resolve(); } };
            // rAF is throttled to nothing in a background tab, so the timer is
            // what guarantees the load still finishes when nobody is looking.
            setTimeout(finish, 250);
            if (typeof requestAnimationFrame !== 'function') { finish(); return; }
            requestAnimationFrame(function() { requestAnimationFrame(finish); });
        });
    }

    // The overlay now stays up until the map exists, which means an exception
    // anywhere in between would leave it covering the page forever — the exact
    // "stuck" impression this change is meant to remove. The watchdog is the
    // backstop: it never fires on a healthy load, because hideLoader clears it.
    let loaderWatchdog = null;
    let loaderMapCap = null;
    function hideLoader() {
        if (loaderWatchdog !== null) { clearTimeout(loaderWatchdog); loaderWatchdog = null; }
        if (loaderMapCap !== null) { clearTimeout(loaderMapCap); loaderMapCap = null; }
        if (loaderOverlay) loaderOverlay.style.display = 'none';
    }
    function armLoaderWatchdog() {
        if (loaderWatchdog !== null) clearTimeout(loaderWatchdog);
        loaderWatchdog = setTimeout(function() {
            console.warn('Explorer: initialisation did not finish; clearing the loading overlay.');
            loaderWatchdog = null;
            if (loaderOverlay) loaderOverlay.style.display = 'none';
        }, LOADER_WATCHDOG_MS);
    }

    async function fetchReactorData() {
        if (loaderOverlay) loaderOverlay.style.display = 'flex';
        if (errorOverlay) errorOverlay.style.display = 'none';
        setLoaderPhase('Loading reactor data…');
        setLoaderProgress(LOADER_STEPS.start, 200);
        // Aim at the end of the download segment over a plausible transfer time.
        // A measurable stream overtakes this immediately; an unmeasurable one
        // still advances instead of sitting at 6%.
        setLoaderProgress(LOADER_STEPS.dataEnd, 2500);
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), DATA_FETCH_TIMEOUT_MS);
        try {
            const response = await fetch(DATA_URL, { signal: controller.signal });
            // Cleared on headers, as before: the timeout guards reaching the
            // Worker, not the transfer, so a slow connection is never cut off
            // partway through a download it is still making progress on.
            clearTimeout(timeout);
            if (!response.ok) throw new Error('HTTP ' + response.status);
            const text = await readWithProgress(response);
            return text;
        } catch (err) {
            clearTimeout(timeout);
            hideLoader();
            if (errorOverlay) errorOverlay.style.display = 'flex';
            throw err;
        }
    }

    // Stream the body so the bar tracks real bytes rather than a guess.
    //
    // The denominator is X-Uncompressed-Bytes (R2's object size, sent by the data
    // Worker): the body is gzipped, so Content-Length is the compressed length
    // while this loop counts decompressed bytes, and a bar built on it would
    // report ~450% and finish four times over. Content-Length is the fallback for
    // an older Worker, which served the file uncompressed and where it was right.
    // Anything unreadable, absent or overshot drops to an indeterminate spinner
    // rather than showing a number known to be wrong.
    async function readWithProgress(response) {
        const headerTotal = Number(
            response.headers.get('X-Uncompressed-Bytes') || response.headers.get('Content-Length')
        );
        let total = Number.isFinite(headerTotal) && headerTotal > 0 ? headerTotal : 0;

        if (!response.body || typeof response.body.getReader !== 'function') {
            return await response.text();   // no streams: fall back to the old path
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let text = '';
        let received = 0;
        let lastPainted = -1;
        for (;;) {
            const chunk = await reader.read();
            if (chunk.done) break;
            received += chunk.value.length;
            text += decoder.decode(chunk.value, { stream: true });
            if (total && received > total) total = 0;   // denominator was wrong; stop trusting it
            // Repaint on whole percents only: a 660 KB file arrives in hundreds of
            // chunks and a style write per chunk costs more than the bar is worth.
            if (total) {
                const pct = Math.floor((received / total) * 100);
                if (pct !== lastPainted) {
                    lastPainted = pct;
                    const span = LOADER_STEPS.dataEnd - LOADER_STEPS.dataStart;
                    setLoaderProgress(LOADER_STEPS.dataStart + (received / total) * span, 120);
                }
            }
        }
        text += decoder.decode();
        return text;
    }

    let csvData;
    try {
        csvData = await fetchReactorData();
    } catch (err) {
        // Show error overlay and wait for retry
        await new Promise((resolve) => {
            const attemptRetry = async () => {
                try {
                    csvData = await fetchReactorData();
                    resolve();
                } catch (_) { /* stays on error overlay, user can retry again */ }
            };
            if (retryBtn) retryBtn.addEventListener('click', attemptRetry);
        });
    }

    // --- 2. Configuration ---
    const HOME_COORDS = [25, 0];                              // [lat, lng] - kept for the tour export
    const HOME_CENTER = [HOME_COORDS[1], HOME_COORDS[0]];     // [lng, lat] - MapLibre order
    const HOME_ZOOM = 1;                // MapLibre zoom (Leaflet 2): the world is 512px at z0
    const COUNTRY_MAX_ZOOM_2D = 7;      // was Leaflet 8
    const COUNTRY_MAX_ZOOM_GLOBE = 8;   // already MapLibre units; unchanged on purpose
    const REACTOR_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="12" height="12"><path fill="currentColor" d="M139.6 32C103.2 32 72 59.6 67.7 95.3L32.5 384H16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-16.5L444.3 95.3c-4.3-35.7-35.5-63.3-71.9-63.3h-232.8zM115.7 96h280.6l31.2 256H84.5l31.2-256z"/></svg>`;
    const EXTERNAL_LINK_SVG = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 3h6v6M10 14L21 3M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/></svg>`;
    
    // Year slider configuration
    const MIN_YEAR = 1954;  // First commercial nuclear plant (Obninsk)
    const MAX_YEAR = 2026;
    const ELECTRICITY_DATA_YEAR = 2025; // Last year with electricity generation data
    const CAPACITY_SLIDER_MIN = 0;     // GW
    const CAPACITY_SLIDER_MAX = 10;    // GW
    const CAPACITY_SLIDER_STEP = 0.1;  // 100 MW granularity
    const PRODUCTION_SLIDER_MIN = 0;     // TWh
    const PRODUCTION_SLIDER_MAX = 50;    // TWh
    const PRODUCTION_SLIDER_STEP = 0.5;  // 500 GWh granularity
    const DATA_LAST_UPDATE = "04/01/2026"; // DD/MM/YYYY (update when dataset changes)
    let currentSelectedYear = MAX_YEAR;
    let isPlaying = false;
    let playInterval = null;

    // --- 3. Mobile Detection ---
    function isMobileDevice() {
        return window.innerWidth <= 600 || 
               ('ontouchstart' in window) || 
               (navigator.maxTouchPoints > 0);
    }

    // --- 4. Robust CSV/TSV Parser ---
    function parseCSVToMatrix(text) {
        const rows = [];
        let currentRow = [];
        let currentVal = '';
        let inQuotes = false;
        
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const nextChar = text[i + 1];

            if (char === '"') {
                if (inQuotes && nextChar === '"') {
                    currentVal += '"'; i++;
                } else {
                    inQuotes = !inQuotes;
                }
            } else if (char === '\t' && !inQuotes) { 
                currentRow.push(currentVal.trim());
                currentVal = '';
            } else if ((char === '\n' || char === '\r') && !inQuotes) {
                if (currentVal || currentRow.length > 0) currentRow.push(currentVal.trim());
                if (currentRow.length > 0) rows.push(currentRow);
                currentRow = [];
                currentVal = '';
                if (char === '\r' && nextChar === '\n') i++;
            } else {
                currentVal += char;
            }
        }
        if (currentVal || currentRow.length > 0) currentRow.push(currentVal.trim());
        if (currentRow.length > 0) rows.push(currentRow);
        return rows;
    }

    // --- 5. Data Processor (with timeline data) ---
        function processData(rawCsv) {
        const dataMatrix = parseCSVToMatrix(rawCsv);
        const plantsMap = {};
        let headers = null;
        let headersNorm = null;
        let col = null;
        let yearCols = [];

        function norm(v) { return String(v || '').trim().toLowerCase(); }

        function buildHeaderIndex(headerRow) {
            headers = headerRow;
            headersNorm = headerRow.map(norm);

            function findIdx(possibleNames) {
                for (const n of possibleNames) {
                    const idx = n instanceof RegExp ? headersNorm.findIndex(h => n.test(h)) : headersNorm.indexOf(norm(n));
                    if (idx !== -1) return idx;
                }
                return -1;
            }

            // Column indices (robust to future CSV extensions)
            col = {
                rName: findIdx(['reactor name']),
                dName: findIdx(['display name']),
                pName: findIdx(['plant name', 'plant']),
                country: findIdx(['country']),
                status: findIdx(['status']),
                cap: findIdx(['gross capacity', 'capacity']),
                url: findIdx(['url', 'link']),
                lat: findIdx(['latitude', 'lat']),
                lon: findIdx(['longitude', 'lon', 'lng']),
                outputLatest: findIdx([/^(?:output|production|generation|electricity production)\s+\d{4}$/]),
                constructionStart: findIdx(['construction start', 'construction start date']),
                gridConnection: findIdx(['grid connection', 'grid connection date', 'first grid connection']),                shutdown: findIdx(['shutdown', 'shutdown date', 'permanent shutdown']),
                // Optional WNN links + headlines (up to 3)
                wnn1: findIdx(['wnn 1', 'wnn1', 'wnn link 1', 'wnn url 1', 'wnn article 1']),
                wnn2: findIdx(['wnn 2', 'wnn2', 'wnn link 2', 'wnn url 2', 'wnn article 2']),
                wnn3: findIdx(['wnn 3', 'wnn3', 'wnn link 3', 'wnn url 3', 'wnn article 3']),
                headline1: findIdx(['headline 1', 'headline1']),
                headline2: findIdx(['headline 2', 'headline2']),
                headline3: findIdx(['headline 3', 'headline3']),
                // Additional reactor metadata (optional)
                reactorType: findIdx(['type', 'reactor type', 'technology type', 'reactor technology', 'tech type']),
                model: findIdx(['model', 'reactor model']),
                technologyProvider: findIdx(['technology provider', 'technology vendor', 'vendor', 'designer']),
                operator: findIdx(['operator', 'operating company', 'utility', 'owner', 'licensee'])
            };

            // Fallbacks for the default file format used in this embed (TSV with known columns)
            if (col.rName === -1) col.rName = 0;
            if (col.dName === -1) col.dName = 1;
            if (col.pName === -1) col.pName = 2;
            if (col.country === -1) col.country = 3;
            if (col.status === -1) col.status = 4;
            if (col.cap === -1) col.cap = 5;
            if (col.url === -1) col.url = 6;
            if (col.lat === -1) col.lat = 7;
            if (col.lon === -1) col.lon = 8;
            if (col.outputLatest === -1) col.outputLatest = 9;
            if (col.constructionStart === -1) col.constructionStart = 10;
            if (col.gridConnection === -1) col.gridConnection = 11;
            if (col.shutdown === -1) col.shutdown = 12;

            // Year columns: any header that is exactly a 4-digit year (e.g., 2010, 2011 …)
            yearCols = [];
            if (headers && headers.length) {
                for (let c = 0; c < headers.length; c++) {
                    const h = String(headers[c] || '').trim();
                    if (/^\d{4}$/.test(h)) yearCols.push(c);
                }
            }
        }

        if (!dataMatrix || dataMatrix.length < 2) {
            console.error("CSV/TSV format incorrect: Not enough rows.");
            return [];
        }

        // NEW: Timeline columns - extract year from DD/MM/YYYY format or Excel serial date
        function extractYear(dateStr) {
            if (!dateStr || String(dateStr).trim() === '') return null;
            const s = String(dateStr).trim();
            // Handle DD/MM/YYYY format - year is the last part
            const parts = s.split('/');
            if (parts.length === 3) {
                const year = parseInt(parts[2], 10);
                return (year > 1900 && year < 2100) ? year : null;
            }
            // Try to parse as a number
            const num = parseInt(s, 10);
            if (!Number.isFinite(num)) return null;
            // If it's a valid year (1900-2100), return it directly
            if (num > 1900 && num < 2100) {
                return num;
            }
            // v5.7.133: Handle Excel serial dates (days since Jan 1, 1900)
            // Serial 1 = Jan 1, 1900; typical range 15000-50000 covers ~1940-2037
            if (num >= 1 && num <= 60000) {
                // Excel epoch: Dec 30, 1899 (accounts for Excel's 1900 leap year bug)
                const msPerDay = 86400000;
                const excelEpoch = new Date(1899, 11, 30).getTime();
                const date = new Date(excelEpoch + num * msPerDay);
                const year = date.getFullYear();
                return (year >= 1900 && year <= 2100) ? year : null;
            }
            return null;
        }

        function extractMonthYear(dateStr) {
            if (!dateStr || String(dateStr).trim() === '') return null;
            const s = String(dateStr).trim();
            // Handle DD/MM/YYYY format
            const parts = s.split('/');
            if (parts.length === 3) {
                const month = parts[1].padStart(2, '0');
                const year = parseInt(parts[2], 10);
                if (year > 1900 && year < 2100) {
                    return `${month}/${year}`;
                }
            }
            // Try to parse as a number
            const num = parseInt(s, 10);
            if (!Number.isFinite(num)) return null;
            // If it's a valid year (1900-2100), return as year only
            if (num > 1900 && num < 2100) {
                return String(num);
            }
            // v5.7.133: Handle Excel serial dates
            if (num >= 1 && num <= 60000) {
                const msPerDay = 86400000;
                const excelEpoch = new Date(1899, 11, 30).getTime();
                const date = new Date(excelEpoch + num * msPerDay);
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                if (year >= 1900 && year <= 2100) {
                    return `${month}/${year}`;
                }
            }
            return null;
        }

        for (let i = 0; i < dataMatrix.length; i++) {
            const row = dataMatrix[i];

            // Skip completely empty rows
            if (!row || row.length === 0 || row.every(cell => !cell || String(cell).trim() === "")) continue;

            // Detect header row wherever it appears (first cell "Reactor Name")
            const firstCell = row[0] ? String(row[0]).toLowerCase() : "";
            if (firstCell.includes("reactor") && firstCell.includes("name")) {
                buildHeaderIndex(row);
                continue;
            }

            // If we never saw a header row, fall back to the default index layout
            if (!col) buildHeaderIndex(row.map((_, idx) => String(idx)));

            const rName    = row[col.rName];
            const dName    = row[col.dName];
            const pName    = row[col.pName];
            const country  = row[col.country];
            const statusRaw= row[col.status];
            const cap      = row[col.cap];
            const url      = row[col.url];
            const lat      = row[col.lat];
            const lon      = row[col.lon];
            const elecGWh  = row[col.outputLatest];

            // Timeline years (numeric for calculations)
            const constructionStart = extractYear(row[col.constructionStart]);
            const gridConnection    = extractYear(row[col.gridConnection]);
            const shutdownDate      = extractYear(row[col.shutdown]);
            
            // Formatted dates for display (mm/yyyy)
            const constructionStartFormatted = extractMonthYear(row[col.constructionStart]);
            const gridConnectionFormatted    = extractMonthYear(row[col.gridConnection]);
            const shutdownDateFormatted      = extractMonthYear(row[col.shutdown]);

            // Optional reactor metadata (safe even if columns are absent)
            const reactorType = (col.reactorType !== -1 && row[col.reactorType] != null) ? String(row[col.reactorType]).trim() : '';
            const model = (col.model !== -1 && row[col.model] != null) ? String(row[col.model]).trim() : '';
            const technologyProvider = (col.technologyProvider !== -1 && row[col.technologyProvider] != null) ? String(row[col.technologyProvider]).trim() : '';            const operator = (col.operator !== -1 && row[col.operator] != null) ? String(row[col.operator]).trim() : '';

            // Optional WNN links/headlines (up to 3)
            const wnnUrls = [
                (col.wnn1 !== -1 && row[col.wnn1] != null) ? String(row[col.wnn1]).trim() : '',
                (col.wnn2 !== -1 && row[col.wnn2] != null) ? String(row[col.wnn2]).trim() : '',
                (col.wnn3 !== -1 && row[col.wnn3] != null) ? String(row[col.wnn3]).trim() : ''
            ];
            const wnnHeadlines = [
                (col.headline1 !== -1 && row[col.headline1] != null) ? String(row[col.headline1]).trim() : '',
                (col.headline2 !== -1 && row[col.headline2] != null) ? String(row[col.headline2]).trim() : '',
                (col.headline3 !== -1 && row[col.headline3] != null) ? String(row[col.headline3]).trim() : ''
            ];
            const wnnItems = [];
            for (let j = 0; j < 3; j++) {
                const u = wnnUrls[j];
                const h = wnnHeadlines[j];
                if ((u && u !== '0') || (h && h !== '0')) {
                    wnnItems.push({ url: u, headline: h });
                }
            }

            // OPTIONAL: Reactor-level electricity production by year (columns with headers like "2010", "2011", ... in GWh)
            let productionByYear = null;
            if (headers && yearCols && yearCols.length) {
                const series = {};
                yearCols.forEach(c => {
                    const year = parseInt(String(headers[c]).trim(), 10);
                    if (!Number.isFinite(year) || year < 1900 || year > 2100) return;
                    const rawVal = row[c] != null ? String(row[c]).replace(/,/g, '').trim() : '';
                    const val = parseFloat(rawVal);
                    if (Number.isFinite(val)) series[year] = val;
                });
                if (Object.keys(series).length > 0) productionByYear = series;
            }

            // Basic presence checks
            if (!pName) continue;

            // Parse numeric values and ensure valid coordinates
            const latNum  = parseFloat(lat);
            const lonNum  = parseFloat(lon);
            const capNum  = parseFloat(cap);
            const prodNum = parseFloat(elecGWh);

            if (!Number.isFinite(latNum) || !Number.isFinite(lonNum)) continue;

            let status = "shutdown";
            const s = statusRaw ? String(statusRaw).toLowerCase() : "";
            if (s.includes("operable") || s.includes("active")) status = "operable";
            else if (s.includes("construct") || s.includes("build")) status = "construction";
            else if (s.includes("plan")) status = "planned";

            if (!plantsMap[pName]) {
                plantsMap[pName] = {
                    name: pName,
                    country: country,
                    lat: latNum,
                    lon: lonNum,
                    url: url,
                    reactors: [],
                    totalCapacity: 0,
                    totalProduction: 0,
                    stats: { operable: 0, construction: 0, planned: 0, shutdown: 0 }
                };
            }

            const p = plantsMap[pName];
            p.reactors.push({
                name: rName,
                displayName: dName || rName,
                status: status,
                url: url,
                capacity: Number.isFinite(capNum) ? capNum : 0,
                production: Number.isFinite(prodNum) ? prodNum : 0,
                productionByYear: productionByYear,
                // Timeline data (numeric years for calculations)
                constructionStart: constructionStart,
                gridConnection: gridConnection,
                shutdownDate: shutdownDate,
                // Formatted dates for display (mm/yyyy)
                constructionStartFormatted: constructionStartFormatted,
                gridConnectionFormatted: gridConnectionFormatted,
                shutdownDateFormatted: shutdownDateFormatted,
                // Additional metadata
                type: reactorType, // Type: BWR, PWR, etc.
                model: model,
                technologyProvider: technologyProvider,
                operator: operator,
                wnnItems: wnnItems
            });

            if (Number.isFinite(capNum))  p.totalCapacity  += capNum;
            if (Number.isFinite(prodNum)) p.totalProduction += prodNum;
            p.stats[status]++;
        }

        return Object.values(plantsMap);
    }

    setLoaderPhase('Preparing reactor data…');
    setLoaderProgress(LOADER_STEPS.parsed, 500);
    armLoaderWatchdog();
    await paintFrame();
    const nuclearPlants = processData(csvData);
    
    // --- 6. Cache country list (optimization) ---
    const allCountries = [...new Set(nuclearPlants.map(p => p.country))].sort();
    
    // --- 6b. Generate Country Statistics ---
    function generateCountryStats(countryName, forYear, applyFilters = false) {
        // Use the provided year or fall back to current selected year
        const targetYear = forYear !== undefined ? forYear : currentSelectedYear;

        const countryPlants = nuclearPlants.filter(p => p.country === countryName);
        if (countryPlants.length === 0) return null;

        let totalReactors = 0;
        let operableReactors = 0;
        let constructionReactors = 0;
        let plannedReactors = 0;
        let shutdownReactors = 0;
        let totalCapacity = 0;
        let operableCapacity = 0;
        let plannedCapacity = 0;
        let totalProduction = 0;
        let firstConstructionYear = Infinity;
        let firstOperableYear = Infinity;
        let peakCapacityYear = null;
        let peakCapacity = 0;

        // Timeline events
        const timelineEvents = [];

        // Collect all reactor data and calculate stats for the target year
        const allReactors = [];
        const visiblePlants = []; // Plants that have at least one reactor visible in this year

        // Check if any filters are active (for display purposes)
        const noStatusFiltersActive = !viewOptions.showOperable && !viewOptions.showConstruction && !viewOptions.showPlanned && !viewOptions.showShutdown;
        const noSizeFiltersActive = (viewOptions.capacityMin <= CAPACITY_SLIDER_MIN && viewOptions.capacityMax >= CAPACITY_SLIDER_MAX) && (viewOptions.productionMin <= PRODUCTION_SLIDER_MIN && viewOptions.productionMax >= PRODUCTION_SLIDER_MAX);
        const hasActiveFilters = applyFilters && (!noStatusFiltersActive || !noSizeFiltersActive);

        countryPlants.forEach(plant => {
            // Use filtered or unfiltered plant status based on applyFilters parameter
            const plantStatus = applyFilters
                ? getFilteredPlantStatusForYear(plant, targetYear)
                : getPlantStatusForYear(plant, targetYear);

            if (plantStatus && plantStatus.activeReactors.length > 0) {
                visiblePlants.push(plant);

                // When applying filters, only count reactors from the filtered status
                if (applyFilters) {
                    plantStatus.activeReactors.forEach(reactor => {
                        allReactors.push({ ...reactor, plantName: plant.name });

                        if (reactor.yearStatus === 'operable') {
                            totalReactors++;
                            operableReactors++;
                            operableCapacity += reactor.capacity || 0;
                            totalCapacity += reactor.capacity || 0;
                            totalProduction += getReactorProductionForYear(reactor, targetYear);
                        } else if (reactor.yearStatus === 'construction') {
                            totalReactors++;
                            constructionReactors++;
                            totalCapacity += reactor.capacity || 0;
                        } else if (reactor.yearStatus === 'planned') {
                            totalReactors++;
                            plannedReactors++;
                            plannedCapacity += reactor.capacity || 0;
                            totalCapacity += reactor.capacity || 0;
                        } else if (reactor.yearStatus === 'shutdown') {
                            totalReactors++;
                            shutdownReactors++;
                            totalCapacity += reactor.capacity || 0;
                            // v5.7.177: Include production from reactors that shut down this year (partial-year production)
                            if (reactor.shutdownDate === targetYear) {
                                totalProduction += getReactorProductionForYear(reactor, targetYear);
                            }
                        }

                        if (reactor.constructionStart && reactor.constructionStart < firstConstructionYear) {
                            firstConstructionYear = reactor.constructionStart;
                        }
                        if (reactor.gridConnection && reactor.gridConnection < firstOperableYear) {
                            firstOperableYear = reactor.gridConnection;
                        }
                    });
                }
            }

            // When not applying filters, count all reactors (original behavior)
            if (!applyFilters) {
                plant.reactors.forEach(reactor => {
                    allReactors.push({ ...reactor, plantName: plant.name });

                    // Get status for the target year
                    const reactorYearStatus = getReactorStatusForYear(reactor, targetYear);

                    if (reactorYearStatus === 'operable') {
                        totalReactors++;
                        operableReactors++;
                        operableCapacity += reactor.capacity || 0;
                        totalCapacity += reactor.capacity || 0;
                        // Use year-specific production data
                        totalProduction += getReactorProductionForYear(reactor, targetYear);
                    } else if (reactorYearStatus === 'construction') {
                        totalReactors++;
                        constructionReactors++;
                        totalCapacity += reactor.capacity || 0;
                    } else if (reactorYearStatus === 'planned') {
                        totalReactors++;
                        plannedReactors++;
                        plannedCapacity += reactor.capacity || 0;
                        totalCapacity += reactor.capacity || 0;
                    } else if (reactorYearStatus === 'shutdown') {
                        totalReactors++;
                        shutdownReactors++;
                        totalCapacity += reactor.capacity || 0;
                        // v5.7.177: Include production from reactors that shut down this year (partial-year production)
                        if (reactor.shutdownDate === targetYear) {
                            totalProduction += getReactorProductionForYear(reactor, targetYear);
                        }
                    }
                    // else: reactor doesn't exist yet in this year - don't count it

                    if (reactor.constructionStart && reactor.constructionStart < firstConstructionYear) {
                        firstConstructionYear = reactor.constructionStart;
                    }
                    if (reactor.gridConnection && reactor.gridConnection < firstOperableYear) {
                        firstOperableYear = reactor.gridConnection;
                    }
                });
            }
        });
        
        // Find first reactor
        const firstReactor = allReactors.find(r => r.gridConnection === firstOperableYear);
        if (firstReactor && firstOperableYear !== Infinity) {
            timelineEvents.push({
                year: firstOperableYear,
                event: `First reactor: ${firstReactor.displayName || firstReactor.name} (${firstReactor.plantName})`
            });
        }
        
        // Calculate capacity by year to find peak
        const capacityByYear = {};
        for (let year = Math.min(firstConstructionYear, 1954); year <= MAX_YEAR; year++) {
            let yearCapacity = 0;
            allReactors.forEach(reactor => {
                const status = getReactorStatusForYear(reactor, year);
                if (status === 'operable') {
                    yearCapacity += reactor.capacity || 0;
                }
            });
            capacityByYear[year] = yearCapacity;
            if (yearCapacity > peakCapacity) {
                peakCapacity = yearCapacity;
                peakCapacityYear = year;
            }
        }
        
        // Add peak capacity event if different from current
        if (peakCapacityYear && peakCapacityYear !== MAX_YEAR && peakCapacity > operableCapacity) {
            timelineEvents.push({
                year: peakCapacityYear,
                event: `Peak capacity: ${(peakCapacity / 1000).toFixed(1)} GW`
            });
        }
        
        // Find first shutdown
        const firstShutdown = allReactors
            .filter(r => r.shutdownDate)
            .sort((a, b) => a.shutdownDate - b.shutdownDate)[0];
        if (firstShutdown) {
            timelineEvents.push({
                year: firstShutdown.shutdownDate,
                event: `First shutdown: ${firstShutdown.name}`
            });
        }
        
        // Find most recent grid connection
        const mostRecent = allReactors
            .filter(r => r.gridConnection)
            .sort((a, b) => b.gridConnection - a.gridConnection)[0];
        if (mostRecent && mostRecent.gridConnection > 2010) {
            timelineEvents.push({
                year: mostRecent.gridConnection,
                event: `Most recent: ${mostRecent.name}`
            });
        }
        
        // Sort timeline
        timelineEvents.sort((a, b) => a.year - b.year);
        
        // Calculate global comparison for the target year
        let globalTotalCapacity = 0;
        let globalTotalProduction = 0;
        nuclearPlants.forEach(p => {
            p.reactors.forEach(r => {
                const rStatus = getReactorStatusForYear(r, targetYear);
                if (rStatus === 'operable') {
                    globalTotalCapacity += r.capacity || 0;
                    if (targetYear === MAX_YEAR) {
                        globalTotalProduction += r.production || 0;
                    }
                }
            });
        });
        
        const capacityShare = globalTotalCapacity > 0 ? (operableCapacity / globalTotalCapacity * 100) : 0;
        const productionShare = globalTotalProduction > 0 ? (totalProduction / globalTotalProduction * 100) : 0;
        
        return {
            country: countryName,
            plants: visiblePlants.length > 0 ? visiblePlants : countryPlants,
            totalReactors,
            operableReactors,
            constructionReactors,
            plannedReactors,
            shutdownReactors,
            totalCapacity,
            operableCapacity,
            plannedCapacity,
            totalProduction,
            firstConstructionYear: firstConstructionYear === Infinity ? null : firstConstructionYear,
            firstOperableYear: firstOperableYear === Infinity ? null : firstOperableYear,
            peakCapacityYear,
            peakCapacity,
            timelineEvents,
            capacityShare,
            productionShare,
            globalTotalCapacity,
            globalTotalProduction,
            targetYear: targetYear
        };
    }
    
    // --- 6c. Country Panel Functions ---
    const countryPanel = document.getElementById('countryPanel');
    const countryPanelClose = document.getElementById('countryPanelClose');
    const countryPanelTitle = document.getElementById('countryPanelTitle');
    const countryPanelContent = document.getElementById('countryPanelContent');
    
    function openCountryPanel(countryName, forceOpen = false) {
        // Don't auto-open on mobile unless forced
        if (!forceOpen && window.innerWidth <= 600) {
            return;
        }
        
        const stats = generateCountryStats(countryName, currentSelectedYear);
        if (!stats) return;
        
        // Check if there's data for this year
        const hasDataForYear = stats.totalReactors > 0;
        
        countryPanelTitle.textContent = countryName;

        // Generate panel content
        let html = '';
        
        if (!hasDataForYear) {
            // No data for this year - show message
            const countryPlants = nuclearPlants.filter(p => p.country === countryName);
            const yearDisplay = currentSelectedYear === MAX_YEAR ? 'Present' : currentSelectedYear;

            // v5.7.166: Check if country has ONLY planned reactors
            const allPlanned = countryPlants.every(p => p.reactors.every(r => r.status === 'planned'));
            if (allPlanned && currentSelectedYear !== MAX_YEAR) {
                // Planned-only country at historical year — distinct message
                html = `
                    <div class="no-data-yet-message" style="margin: 20px 0;">
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No applicable results</div>
                        <div class="no-data-text">Historical planned reactor data are not available.</div>
                    </div>
                `;
            } else {
                let earliestYear = Infinity;
                countryPlants.forEach(plant => {
                    plant.reactors.forEach(r => {
                        if (r.constructionStart && r.constructionStart < earliestYear) {
                            earliestYear = r.constructionStart;
                        }
                    });
                });
                const earliestYearText = earliestYear !== Infinity ? earliestYear : 'N/A';

                html = `
                    <div class="no-data-yet-message" style="margin: 20px 0;">
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No nuclear activity in ${escapeHtml(yearDisplay)}</div>
                        <div class="no-data-text">${escapeHtml(countryName)} had no nuclear power plants under construction or operating in ${escapeHtml(yearDisplay)}.</div>
                        <div class="no-data-year">First nuclear activity: ${escapeHtml(earliestYearText)}</div>
                    </div>
                `;
            }
        } else {
            html = `
                <div class="country-stats-header">Reactors</div>
                <div class="country-stats-grid">
                    <div class="country-stat-box">
                        <div class="country-stat-value green">${stats.operableReactors}</div>
                        <div class="country-stat-label">Operable</div>
                    </div>
                    <div class="country-stat-box">
                        <div class="country-stat-value yellow">${stats.constructionReactors}</div>
                        <div class="country-stat-label">Construction</div>
                    </div>
                    <div class="country-stat-box">
                        <div class="country-stat-value blue">${stats.plannedReactors}</div>
                        <div class="country-stat-label">Planned</div>
                    </div>
                    <div class="country-stat-box">
                        <div class="country-stat-value grey">${stats.shutdownReactors}</div>
                        <div class="country-stat-label">Shutdown</div>
                    </div>
                </div>
            `;
        
            // Highlight stats row (TWh) - show for all years with year-specific data
            const yearLabel = currentSelectedYear === MAX_YEAR ? 'Output' : `${currentSelectedYear} Output`;
            if (stats.totalProduction > 0) {
                html += `
                    <div class="country-section country-output-section">
                        <div class="country-section-title">${yearLabel}</div>
                        <div class="country-highlights-row">
                            <div class="country-highlight-stat">
                                <div class="country-highlight-value">
                                    ${(stats.totalProduction / 1000).toFixed(1)}<span class="country-highlight-unit">TWh</span>
                                </div>
                                <div class="country-highlight-label">Electricity Generated</div>
                            </div>
                        </div>
                    </div>
                `;
            }
            
            // Plants list (v5.7.129: collapsible, default collapsed)
            html += `
                <div class="country-section" id="countryPanelPlantSection">
                    <div class="country-section-title collapsible">
                        <span>Power Plants (${stats.plants.length})</span>
                        <svg class="section-toggle-icon" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    </div>
                    <div class="country-plant-list collapsible">
            `;
            
            // Sort plants: by status (operable, construction, planned, shutdown) then alphabetically
            const sortedPlants = [...stats.plants].sort((a, b) => {
                // Determine primary status for each plant (year-aware)
                const getStatusPriority = (plant) => {
                    const plantStatus = getPlantStatusForYear(plant, currentSelectedYear);
                    if (!plantStatus) return 4;
                    const hasOperable = plantStatus.activeReactors.some(r => r.yearStatus === 'operable');
                    const hasConstruction = plantStatus.activeReactors.some(r => r.yearStatus === 'construction');
                    const hasPlanned = plantStatus.activeReactors.some(r => r.yearStatus === 'planned');
                    if (hasOperable) return 0;
                    if (hasConstruction) return 1;
                    if (hasPlanned) return 2;
                    return 3; // shutdown
                };
                
                const aPriority = getStatusPriority(a);
                const bPriority = getStatusPriority(b);
                
                if (aPriority !== bPriority) return aPriority - bPriority;
                
                // Alphabetically within same status
                return a.name.localeCompare(b.name);
            });
            
            sortedPlants.forEach(plant => {
                const plantStatus = getPlantStatusForYear(plant, currentSelectedYear);
                if (!plantStatus || plantStatus.activeReactors.length === 0) return;

                const dotClass = plantStatus.color === '#00b894' ? 'green' :
                                plantStatus.color === '#fdcb6e' ? 'yellow' :
                                plantStatus.color === '#74b9ff' ? 'blue' : 'grey';
                const reactorCount = plantStatus.activeReactors.length;
                // Calculate year-aware capacity
                const yearCapacity = plantStatus.activeReactors.reduce((sum, r) => sum + (r.capacity || 0), 0);
                const capacity = (yearCapacity / 1000).toFixed(1);

                html += `
                    <div class="country-plant-item" data-plant="${escapeHtmlAttr(plant.name)}">
                        <div class="country-plant-dot ${dotClass}"></div>
                        <div class="country-plant-info">
                            <div class="country-plant-name">${escapeHtml(plant.name)}</div>
                            <div class="country-plant-reactors">${reactorCount} reactor${reactorCount !== 1 ? 's' : ''}</div>
                        </div>
                        <div class="country-plant-capacity">${capacity} GW</div>
                    </div>
                `;
            });

            html += `</div></div>`;

            // v5.7.126: Add chart containers to country panel (rendered lazily on expand)
            html += `
                <div class="mobile-chart-section">
                    <div class="mobile-chart-section-title">Electricity Production</div>
                    <div class="mobile-chart-toggle" id="mobileCountryProductionToggle">
                        <button class="production-toggle-btn active" data-mode="annual" type="button">Annual</button>
                        <button class="production-toggle-btn" data-mode="cumulative" type="button">Cumulative</button>
                    </div>
                    <div class="mobile-chart-subtitle" id="mobileCountryProductionSubtitle">Annual (TWh)</div>
                    <div class="mobile-chart-wrap">
                        <canvas class="mobile-chart-canvas" id="mobileCountryProductionChart"></canvas>
                        <div class="mobile-chart-tooltip" id="mobileCountryProductionTooltip"></div>
                    </div>
                    <div class="mobile-chart-empty" id="mobileCountryProductionEmpty" style="display:none;">No production data available.</div>
                </div>
                <div class="mobile-chart-section">
                    <div class="mobile-chart-section-title">Reactor Deployment</div>
                    <div class="mobile-chart-toggle" id="mobileCountryDeployToggle">
                        <button class="production-toggle-btn active" data-mode="units" type="button">Units</button>
                        <button class="production-toggle-btn" data-mode="capacity" type="button">Capacity</button>
                    </div>
                    <div class="mobile-deploy-container" id="mobileCountryDeployChart"></div>
                </div>
            `;
        } // End of hasDataForYear else block

        countryPanelContent.innerHTML = html;

        // v5.7.126: Store stats for lazy chart rendering on expand
        if (hasDataForYear) {
            countryPanel._chartStats = stats;
            countryPanel._chartsRendered = false;
        }

        // v5.7.129: Collapsible plant list toggle
        const plantSection = countryPanelContent.querySelector('#countryPanelPlantSection');
        if (plantSection) {
            const sectionTitle = plantSection.querySelector('.country-section-title.collapsible');
            if (sectionTitle) {
                sectionTitle.addEventListener('click', () => {
                    plantSection.classList.toggle('expanded');
                });
            }
        }

        // Add click handlers for plants
        countryPanelContent.querySelectorAll('.country-plant-item').forEach(item => {
            item.addEventListener('click', () => {
                const plantName = item.dataset.plant;
                const plant = nuclearPlants.find(p => p.name === plantName);
                if (plant) {
                    zoomToPlant(plant);
                }
            });
        });

        // v5.7.172: Hover-focus handlers for plant list items
        countryPanelContent.querySelectorAll('.country-plant-item').forEach(item => {
            item.addEventListener('mouseenter', () => {
                if (item.dataset.plant) applyHoverFocus(item.dataset.plant);
            });
            item.addEventListener('mouseleave', () => { clearHoverFocus(); });
        });

        // Close plant panel and filter panel if open, then open country panel
        if (typeof closePlantPanel === 'function') closePlantPanel();
        if (typeof closeFilterPanel === 'function') closeFilterPanel();
        countryPanel.classList.remove('expanded'); // Reset to half-screen when opening
        countryPanel.classList.remove('collapsed'); // v5.7.172
        countryPanelContent.scrollTop = 0; // v5.7.128: always open scrolled to top
        countryPanel.classList.add('open');
        applySearchHighlight(plant => plant.country === countryName); // v5.7.130: dim markers outside country

        // v5.7.145: Render charts immediately when panel opens (not lazily on expand)
        if (countryPanel._chartStats && !countryPanel._chartsRendered) {
            countryPanel._chartsRendered = true;
            requestAnimationFrame(() => {
                renderMobileCountryProductionChart(countryPanel._chartStats);
                renderMobileCountryDeploy(countryPanel._chartStats);
            });
        }
    }

    function closeCountryPanel() {
        countryPanel.classList.remove('open');
        countryPanel.classList.remove('expanded');
        countryPanel.classList.remove('collapsed'); // v5.7.172
        countryPanel._chartsRendered = false; // v5.7.126: reset lazy chart flag
        clearHoverFocus(); // v5.7.172
        clearSearchHighlight(); // v5.7.129: restore all markers to coloured on close
    }
    
    countryPanelClose.addEventListener('click', closeCountryPanel);
    
    // --- Country Panel Drag/Swipe Handling ---
    (function initCountryPanelDrag() {
        const header = document.querySelector('.country-panel-header');
        if (!header || !countryPanel) return;
        
        let startY = 0;
        let startHeight = 0;
        let isDragging = false;
        
        function getCurrentHeight() {
            return countryPanel.getBoundingClientRect().height;
        }
        
        function onDragStart(e) {
            if (window.innerWidth > 600) return; // Only on mobile
            isDragging = true;
            startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
            startHeight = getCurrentHeight();
            countryPanel.style.transition = 'none';
        }
        
        function onDragMove(e) {
            if (!isDragging) return;
            e.preventDefault();
            
            const currentY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
            const deltaY = startY - currentY;
            const newHeight = Math.max(100, Math.min(window.innerHeight, startHeight + deltaY));
            
            countryPanel.style.height = newHeight + 'px';
            
            // Update border radius based on height
            if (newHeight >= window.innerHeight - 10) {
                countryPanel.style.borderRadius = '0';
            } else {
                countryPanel.style.borderRadius = '18px 18px 0 0';
            }
        }
        
        function onDragEnd(e) {
            if (!isDragging) return;
            isDragging = false;
            
            countryPanel.style.transition = '';
            countryPanel.style.height = '';
            countryPanel.style.borderRadius = '';
            
            const endY = e.type === 'touchend' ? e.changedTouches[0].clientY : e.clientY;
            const deltaY = startY - endY;
            const velocity = Math.abs(deltaY);
            
            const viewportHeight = window.innerHeight;
            const currentHeight = getCurrentHeight();
            const halfHeight = viewportHeight * 0.5;
            
            // Determine action based on drag direction and distance
            // v5.7.172: 3-stop snap — expanded ↔ half ↔ collapsed ↔ close
            if (deltaY > 50 || (deltaY > 0 && velocity > 30)) {
                // Dragged up
                if (countryPanel.classList.contains('collapsed')) {
                    countryPanel.classList.remove('collapsed');
                    // → half-screen
                } else {
                    countryPanel.classList.add('expanded');
                    // v5.7.126: Render charts lazily on first expand
                    if (countryPanel._chartStats && !countryPanel._chartsRendered) {
                        countryPanel._chartsRendered = true;
                        requestAnimationFrame(() => {
                            renderMobileCountryProductionChart(countryPanel._chartStats);
                            renderMobileCountryDeploy(countryPanel._chartStats);
                        });
                    }
                }
            } else if (deltaY < -50 || (deltaY < 0 && velocity > 30)) {
                // Dragged down
                if (countryPanel.classList.contains('expanded')) {
                    countryPanel.classList.remove('expanded');
                    // → half-screen
                } else if (!countryPanel.classList.contains('collapsed')) {
                    countryPanel.classList.add('collapsed');
                    // → collapsed (30vh)
                } else {
                    closeCountryPanel();
                }
            }
            // If small movement, stay in current state
        }
        
        header.addEventListener('touchstart', onDragStart, { passive: true });
        header.addEventListener('mousedown', onDragStart);
        
        document.addEventListener('touchmove', onDragMove, { passive: false });
        document.addEventListener('mousemove', onDragMove);
        
        document.addEventListener('touchend', onDragEnd);
        document.addEventListener('mouseup', onDragEnd);
    })();
    
    // --- 6c2. Mobile Plant Panel Functions (bottom sheet) ---
    const plantPanel = document.getElementById('plantPanel');
    const plantPanelClose = document.getElementById('plantPanelClose');
    const plantPanelTitle = document.getElementById('plantPanelTitle');
    const plantPanelStatus = document.getElementById('plantPanelStatus');
    const plantPanelContent = document.getElementById('plantPanelContent');
    const plantPanelSubtitle = document.getElementById('plantPanelSubtitle');

    let currentMobilePlantSelection = null;
    
    function openPlantPanel(plant, highlightReactorName = null) {
        if (!plant) return;
        
        const plantStatus = getPlantStatusForYear(plant, currentSelectedYear);
        const hasDataForYear = plantStatus && plantStatus.activeReactors && plantStatus.activeReactors.length > 0;
        
        currentMobilePlantSelection = plant;

        // v5.7.168: Check if plant has ONLY planned reactors (moved earlier for name display)
        const isPlannedOnly = plant.reactors.every(r => r.status === 'planned');

        // Update header
        plantPanelTitle.textContent = plant.name;

        // v5.7.127: Set country name as clickable subtitle
        if (plantPanelSubtitle) {
            plantPanelSubtitle.textContent = plant.country + ' \u203A';
            plantPanelSubtitle.onclick = function() {
                closePlantPanel();
                zoomToCountry(plant.country);
            };
        }

        // Update status badge
        if (!hasDataForYear) {
            plantPanelStatus.className = 'plant-panel-status grey';
            plantPanelStatus.textContent = (isPlannedOnly && currentSelectedYear !== MAX_YEAR) ? 'N/A' : 'Not Yet Built';
        } else {
            const statusClass = plantStatus.color === '#00b894' ? 'green' :
                               plantStatus.color === '#fdcb6e' ? 'yellow' :
                               plantStatus.color === '#74b9ff' ? 'blue' : 'grey';
            const statusText = plantStatus.color === '#00b894' ? 'Operable' :
                              plantStatus.color === '#fdcb6e' ? 'Under Construction' :
                              plantStatus.color === '#74b9ff' ? 'Planned' : 'Shutdown';
            plantPanelStatus.className = 'plant-panel-status ' + statusClass;
            plantPanelStatus.textContent = statusText;
        }
        
        // Generate panel content
        let html = '';
        
        if (!hasDataForYear) {
            const yearDisplay = currentSelectedYear === MAX_YEAR ? 'Present' : currentSelectedYear;

            // v5.7.166: Planned-only plant at historical year — distinct message
            if (isPlannedOnly && currentSelectedYear !== MAX_YEAR) {
                html = `
                    <div class="no-data-yet-message" style="margin: 20px 0;">
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No applicable results</div>
                        <div class="no-data-text">Historical planned reactor data are not available.</div>
                    </div>`;
            } else {
                // Find the earliest year this plant has data
                let earliestYear = Infinity;
                plant.reactors.forEach(r => {
                    if (r.constructionStart && r.constructionStart < earliestYear) {
                        earliestYear = r.constructionStart;
                    }
                });
                const earliestYearText = earliestYear !== Infinity ? earliestYear : 'N/A';

                html = `
                    <div class="no-data-yet-message" style="margin: 20px 0;">
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No data for ${yearDisplay}</div>
                        <div class="no-data-text">This plant's construction hadn't started yet in the selected year.</div>
                        <div class="no-data-year">First activity: ${earliestYearText}</div>
                    </div>`;
            }
            html += `
                <button class="plant-panel-country-link" data-country="${escapeHtmlAttr(plant.country)}">
                    <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path d="M3 21h18M3 7v1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7H3l2-4h14l2 4M5 21V10.85M19 21V10.85"></path>
                    </svg>
                    View ${escapeHtml(plant.country)}'s nuclear profile
                </button>
            `;
        } else {
            // Calculate capacity for visible reactors
            const visibleCapacity = plantStatus.activeReactors.reduce((sum, r) => sum + (r.capacity || 0), 0);
            const capGW = (visibleCapacity / 1000).toFixed(1);

            // Find earliest grid connection
            const gridYears = plant.reactors
                .map(r => r.gridConnection)
                .filter(y => y && y !== Infinity);
            const firstGrid = gridYears.length > 0 ? Math.min(...gridYears) : '—';
            
            html = `
                <div class="plant-stats-grid" role="group" aria-label="Plant statistics">
                    <div class="plant-stat-box">
                        <div class="plant-stat-value">${plantStatus.activeReactors.length}</div>
                        <div class="plant-stat-label">Reactors</div>
                    </div>
                    <div class="plant-stat-box">
                        <div class="plant-stat-value">${capGW}</div>
                        <div class="plant-stat-label">Capacity (GW)</div>
                    </div>
                    <div class="plant-stat-box">
                        <div class="plant-stat-value">${firstGrid}</div>
                        <div class="plant-stat-label">First grid connection</div>
                    </div>
                </div>
            `;
            
            // Reactors list
            html += `
                <div class="plant-section" id="plantPanelReactorSection">
                    <div class="plant-section-title collapsible">
                        <span>Reactors (${plantStatus.activeReactors.length})</span>
                        <svg class="section-toggle-icon" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    </div>
                    <div class="plant-reactor-list collapsible">
            `;
            
            plantStatus.activeReactors.forEach(reactor => {
                const dotClass = reactor.yearStatus === 'operable' ? 'green' :
                                reactor.yearStatus === 'construction' ? 'yellow' :
                                reactor.yearStatus === 'planned' ? 'blue' : 'grey';
                const capacity = reactor.capacity ? (reactor.capacity / 1000).toFixed(2) : '—';
                const details = [];
                if (reactor.type) details.push(escapeHtml(reactor.type));
                if (reactor.yearStatus === 'construction' && reactor.constructionStartFormatted) {
                    details.push('Construction: ' + escapeHtml(reactor.constructionStartFormatted));
                }
                if (reactor.gridConnectionFormatted) {
                    details.push('Grid: ' + escapeHtml(reactor.gridConnectionFormatted));
                }

                const isHighlighted = highlightReactorName && reactor.name === highlightReactorName;
                const highlightStyle = isHighlighted ? 'border-color: #5777a9; background: rgba(87, 119, 169, 0.08);' : '';

                const reactorLabelRaw = reactor.displayName || reactor.name || 'Reactor';
                const reactorLabel = escapeHtml(reactorLabelRaw);

                // External link button
                const safeUrl = sanitizeUrl(reactor.url);
                const linkOut = safeUrl
                    ? `<a class="plant-reactor-link" href="${safeUrl}" target="_blank" rel="noopener noreferrer" aria-label="Open ${escapeHtmlAttr(reactorLabelRaw)} details" title="View reactor details">
                        <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                            <polyline points="15 3 21 3 21 9"></polyline>
                            <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                    </a>`
                    : '';

                html += `
                    <div class="plant-reactor-item" style="${highlightStyle}">
                        <div class="plant-reactor-dot ${dotClass}"></div>
                        <div class="plant-reactor-info">
                            <div class="plant-reactor-name">${reactorLabel}</div>
                            ${details.length > 0 ? `<div class="plant-reactor-details">${details.join(' &bull; ')}</div>` : ''}
                        </div>
                        <div class="plant-reactor-capacity">${capacity} GW</div>
                        ${linkOut}
                    </div>
                `;
            });

            html += `</div></div>`;

            // v5.7.126: Add chart containers to plant panel (rendered lazily on expand)
            html += `
                <div class="mobile-chart-section">
                    <div class="mobile-chart-section-title">Electricity Production</div>
                    <div class="mobile-chart-toggle" id="mobilePlantProductionToggle">
                        <button class="production-toggle-btn active" data-mode="annual" type="button">Annual</button>
                        <button class="production-toggle-btn" data-mode="cumulative" type="button">Cumulative</button>
                    </div>
                    <div class="mobile-chart-subtitle" id="mobilePlantProductionSubtitle">Annual (TWh)</div>
                    <div class="mobile-chart-wrap">
                        <canvas class="mobile-chart-canvas" id="mobilePlantProductionChart"></canvas>
                        <div class="mobile-chart-tooltip" id="mobilePlantProductionTooltip"></div>
                    </div>
                    <div class="mobile-chart-empty" id="mobilePlantProductionEmpty" style="display:none;">No production data available.</div>
                </div>
                <div class="mobile-chart-section">
                    <div class="mobile-chart-section-title">Reactor Timeline</div>
                    <div class="mobile-timeline-container" id="mobilePlantTimeline"></div>
                </div>
            `;

            // Country link
            html += `
                <button class="plant-panel-country-link" data-country="${escapeHtmlAttr(plant.country)}">
                    <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path d="M3 21h18M3 7v1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7H3l2-4h14l2 4M5 21V10.85M19 21V10.85"></path>
                    </svg>
                    View ${escapeHtml(plant.country)}'s nuclear profile
                </button>
            `;
        }

        plantPanelContent.innerHTML = html;

        // v5.7.126: Store plant for lazy chart rendering on expand
        if (hasDataForYear) {
            plantPanel._chartPlant = plant;
            plantPanel._chartsRendered = false;
        }

        // v5.7.128: Collapsible reactor list toggle
        const reactorSection = plantPanelContent.querySelector('#plantPanelReactorSection');
        if (reactorSection) {
            const sectionTitle = reactorSection.querySelector('.plant-section-title.collapsible');
            if (sectionTitle) {
                sectionTitle.addEventListener('click', () => {
                    reactorSection.classList.toggle('expanded');
                });
            }
        }

        // Add click handler for country link
        const countryLink = plantPanelContent.querySelector('.plant-panel-country-link');
        if (countryLink) {
            countryLink.addEventListener('click', () => {
                const countryName = countryLink.dataset.country;
                closePlantPanel();
                // Navigate to country
                zoomToCountry(countryName);
            });
        }
        
        // Close country panel and filter panel if open, then open plant panel
        closeCountryPanel();
        if (typeof closeFilterPanel === 'function') closeFilterPanel();
        plantPanel.classList.remove('expanded'); // Reset to half-screen when opening
        plantPanel.classList.remove('collapsed'); // v5.7.172
        plantPanelContent.scrollTop = 0; // v5.7.128: always open scrolled to top
        plantPanel.classList.add('open');

        // v5.7.145: Render charts immediately when panel opens (not lazily on expand)
        if (plantPanel._chartPlant && !plantPanel._chartsRendered) {
            plantPanel._chartsRendered = true;
            requestAnimationFrame(() => {
                renderMobilePlantProductionChart(plantPanel._chartPlant);
                renderMobilePlantTimeline(plantPanel._chartPlant);
            });
        }
    }

    function closePlantPanel() {
        plantPanel.classList.remove('open');
        plantPanel.classList.remove('expanded');
        plantPanel.classList.remove('collapsed'); // v5.7.172
        plantPanel._chartsRendered = false; // v5.7.126: reset lazy chart flag
        currentMobilePlantSelection = null;
        clearSearchHighlight(); // v5.7.129: restore all markers to coloured on close
    }
    
    if (plantPanelClose) {
        plantPanelClose.addEventListener('click', closePlantPanel);
    }
    
    // --- Plant Panel Drag/Swipe Handling ---
    (function initPlantPanelDrag() {
        const header = document.querySelector('.plant-panel-header');
        if (!header || !plantPanel) return;
        
        let startY = 0;
        let startHeight = 0;
        let isDragging = false;
        
        function getCurrentHeight() {
            return plantPanel.getBoundingClientRect().height;
        }
        
        function onDragStart(e) {
            if (window.innerWidth > 600) return; // Only on mobile
            isDragging = true;
            startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
            startHeight = getCurrentHeight();
            plantPanel.style.transition = 'none';
        }
        
        function onDragMove(e) {
            if (!isDragging) return;
            e.preventDefault();
            
            const currentY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
            const deltaY = startY - currentY;
            const newHeight = Math.max(100, Math.min(window.innerHeight, startHeight + deltaY));
            
            plantPanel.style.height = newHeight + 'px';
            
            // Update border radius based on height
            if (newHeight >= window.innerHeight - 10) {
                plantPanel.style.borderRadius = '0';
            } else {
                plantPanel.style.borderRadius = '18px 18px 0 0';
            }
        }
        
        function onDragEnd(e) {
            if (!isDragging) return;
            isDragging = false;
            
            plantPanel.style.transition = '';
            plantPanel.style.height = '';
            plantPanel.style.borderRadius = '';
            
            const endY = e.type === 'touchend' ? e.changedTouches[0].clientY : e.clientY;
            const deltaY = startY - endY;
            const velocity = Math.abs(deltaY);
            
            const viewportHeight = window.innerHeight;
            const currentHeight = getCurrentHeight();
            const halfHeight = viewportHeight * 0.5;
            
            // Determine action based on drag direction and distance
            // v5.7.172: 3-stop snap — expanded ↔ half ↔ collapsed ↔ close
            if (deltaY > 50 || (deltaY > 0 && velocity > 30)) {
                // Dragged up
                if (plantPanel.classList.contains('collapsed')) {
                    plantPanel.classList.remove('collapsed');
                    // → half-screen
                } else {
                    plantPanel.classList.add('expanded');
                    // v5.7.126: Render charts lazily on first expand
                    if (plantPanel._chartPlant && !plantPanel._chartsRendered) {
                        plantPanel._chartsRendered = true;
                        requestAnimationFrame(() => {
                            renderMobilePlantProductionChart(plantPanel._chartPlant);
                            renderMobilePlantTimeline(plantPanel._chartPlant);
                        });
                    }
                }
            } else if (deltaY < -50 || (deltaY < 0 && velocity > 30)) {
                // Dragged down
                if (plantPanel.classList.contains('expanded')) {
                    plantPanel.classList.remove('expanded');
                    // → half-screen
                } else if (!plantPanel.classList.contains('collapsed')) {
                    plantPanel.classList.add('collapsed');
                    // → collapsed (30vh)
                } else {
                    closePlantPanel();
                }
            }
            // If small movement, stay in current state
        }
        
        header.addEventListener('touchstart', onDragStart, { passive: true });
        header.addEventListener('mousedown', onDragStart);
        
        document.addEventListener('touchmove', onDragMove, { passive: false });
        document.addEventListener('mousemove', onDragMove);
        
        document.addEventListener('touchend', onDragEnd);
        document.addEventListener('mouseup', onDragEnd);
    })();
    
    // Expose functions globally for use in other parts
    window.openPlantPanel = openPlantPanel;
    window.closePlantPanel = closePlantPanel;
    
    // --- 6c3. Mobile Filter Panel Functions (bottom sheet) ---
    const filterPanel = document.getElementById('filterPanel');
    const filterPanelClose = document.getElementById('filterPanelClose');
    const mobileFilterBtn = document.getElementById('mobileFilterBtn');
    
    function openFilterPanel() {
        if (!filterPanel) return;
        
        // Close other panels
        closeCountryPanel();
        closePlantPanel();
        
        // Sync filter checkboxes with current viewOptions state (if function exists)
        if (typeof window.syncFilterPanelState === 'function') {
            window.syncFilterPanelState();
        }
        
        filterPanel.classList.remove('expanded');
        filterPanel.classList.remove('collapsed'); // v5.7.172
        filterPanel.classList.add('open');
    }

    function closeFilterPanel() {
        if (!filterPanel) return;
        filterPanel.classList.remove('open');
        filterPanel.classList.remove('expanded');
        filterPanel.classList.remove('collapsed'); // v5.7.172
    }
    
    // Mobile filter button click handler
    if (mobileFilterBtn) {
        mobileFilterBtn.addEventListener('click', () => {
            if (filterPanel && filterPanel.classList.contains('open')) {
                closeFilterPanel();
            } else {
                openFilterPanel();
            }
        });
    }
    
    // Filter panel close button
    if (filterPanelClose) {
        filterPanelClose.addEventListener('click', closeFilterPanel);
    }
    
    // Filter panel drag/swipe handling
    (function initFilterPanelDrag() {
        const header = document.querySelector('.filter-panel-header');
        if (!header || !filterPanel) return;
        
        let startY = 0;
        let startHeight = 0;
        let isDragging = false;
        
        function getCurrentHeight() {
            return filterPanel.getBoundingClientRect().height;
        }
        
        function onDragStart(e) {
            if (window.innerWidth > 600) return;
            isDragging = true;
            startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
            startHeight = getCurrentHeight();
            filterPanel.style.transition = 'none';
        }
        
        function onDragMove(e) {
            if (!isDragging) return;
            e.preventDefault();
            
            const currentY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
            const deltaY = startY - currentY;
            const newHeight = Math.max(100, Math.min(window.innerHeight, startHeight + deltaY));
            
            filterPanel.style.height = newHeight + 'px';
            
            if (newHeight >= window.innerHeight - 10) {
                filterPanel.style.borderRadius = '0';
            } else {
                filterPanel.style.borderRadius = '18px 18px 0 0';
            }
        }
        
        function onDragEnd(e) {
            if (!isDragging) return;
            isDragging = false;
            
            filterPanel.style.transition = '';
            filterPanel.style.height = '';
            filterPanel.style.borderRadius = '';
            
            const endY = e.type === 'touchend' ? e.changedTouches[0].clientY : e.clientY;
            const deltaY = startY - endY;
            const velocity = Math.abs(deltaY);
            
            // v5.7.172: 3-stop snap — expanded ↔ half ↔ collapsed ↔ close
            if (deltaY > 50 || (deltaY > 0 && velocity > 30)) {
                // Dragged up
                if (filterPanel.classList.contains('collapsed')) {
                    filterPanel.classList.remove('collapsed');
                    // → half-screen
                } else {
                    filterPanel.classList.add('expanded');
                }
            } else if (deltaY < -50 || (deltaY < 0 && velocity > 30)) {
                // Dragged down
                if (filterPanel.classList.contains('expanded')) {
                    filterPanel.classList.remove('expanded');
                    // → half-screen
                } else if (!filterPanel.classList.contains('collapsed')) {
                    filterPanel.classList.add('collapsed');
                    // → collapsed (30vh)
                } else {
                    closeFilterPanel();
                }
            }
        }
        
        header.addEventListener('touchstart', onDragStart, { passive: true });
        header.addEventListener('mousedown', onDragStart);
        
        document.addEventListener('touchmove', (e) => {
            if (isDragging) onDragMove(e);
        }, { passive: false });
        document.addEventListener('mousemove', onDragMove);
        
        document.addEventListener('touchend', onDragEnd);
        document.addEventListener('mouseup', onDragEnd);
    })();
    
    // Expose functions globally
    window.openFilterPanel = openFilterPanel;
    window.closeFilterPanel = closeFilterPanel;

    // --- 6d. Country Info Overlay Functions (replaces search on desktop) ---
    const countryInfoOverlayEl = document.getElementById('countryInfoOverlay');
    const countryInfoBox = document.getElementById('countryInfoBox');
    const countryInfoBack = document.getElementById('countryInfoBack');
    const countryInfoName = document.getElementById('countryInfoName');
    const countryInfoOperable = document.getElementById('countryInfoOperable');
    const countryInfoConstruction = document.getElementById('countryInfoConstruction');
    const countryInfoPlanned = document.getElementById('countryInfoPlanned');
    const countryInfoShutdown = document.getElementById('countryInfoShutdown');
    const countryInfoCapacity = document.getElementById('countryInfoCapacity');
    const countryInfoPlantsToggle = document.getElementById('countryInfoPlantsToggle');
    const countryInfoPlantsCount = document.getElementById('countryInfoPlantsCount');
    const countryInfoPlantsList = document.getElementById('countryInfoPlantsList');
    
    // Country chart elements (fullscreen)
    const countryDetailContent = document.getElementById('countryDetailContent');
    const countryProductionChart = document.getElementById('countryProductionChart');
    const countryProductionEmpty = document.getElementById('countryProductionEmpty');
    const countryProductionTooltip = document.getElementById('countryProductionTooltip');
    const countryReactorDeploy = document.getElementById('countryReactorDeploy');
    const countryDeployEmpty = document.getElementById('countryDeployEmpty');
    const countryDeployChartWrap = document.getElementById('countryDeployChartWrap');

    let currentSelectedCountry = null;
    
    function showCountryInfoOverlay(countryName) {
        // Check BOTH unfiltered and filtered stats to determine reason for no data
        const unfilteredStats = generateCountryStats(countryName, currentSelectedYear, false);
        const filteredStats = generateCountryStats(countryName, currentSelectedYear, true);

        const hasUnfilteredData = unfilteredStats && unfilteredStats.totalReactors > 0;
        const hasFilteredData = filteredStats && filteredStats.totalReactors > 0;

        // Use filtered stats for display
        const stats = filteredStats;

        currentSelectedCountry = countryName;

        // Check if country has any data for this year (after filtering)
        const hasDataForYear = hasFilteredData;

        // Update header content (always show country name)
        countryInfoName.textContent = countryName;
        if (countryInfoName) countryInfoName.style.setProperty('color', '#5777a9', 'important');

        // Get or create the no-data message element
        let noDataMessage = countryInfoBox.querySelector('.no-data-yet-message');
        if (!noDataMessage) {
            noDataMessage = document.createElement('div');
            noDataMessage.className = 'no-data-yet-message';
            noDataMessage.id = 'countryNoDataMessage';
            // Insert after the header (before the stats-header/stats row)
            const countryInfoStatsHdr = countryInfoBox.querySelector('.country-info-stats-header') || countryInfoBox.querySelector('.country-info-stats');
            if (countryInfoStatsHdr) {
                countryInfoStatsHdr.parentNode.insertBefore(noDataMessage, countryInfoStatsHdr);
            }
        }

        // Get content elements that should be hidden when no data
        const countryInfoStats = countryInfoBox.querySelector('.country-info-stats');
        const countryInfoStatsHeader = countryInfoBox.querySelector('.country-info-stats-header');
        const countryInfoPlantsToggleEl = countryInfoBox.querySelector('.country-info-plants-toggle');
        const countryInfoPlantsListEl = countryInfoBox.querySelector('.country-info-plants-list');

        if (!hasDataForYear) {
            const yearDisplay = currentSelectedYear === MAX_YEAR ? 'Present' : currentSelectedYear;

            // Determine the reason for no data
            if (!hasUnfilteredData) {
                // v5.7.166: Check if country has ONLY planned reactors
                const countryPlants = nuclearPlants.filter(p => p.country === countryName);
                const allPlanned = countryPlants.every(p => p.reactors.every(r => r.status === 'planned'));
                if (allPlanned && currentSelectedYear !== MAX_YEAR) {
                    // Planned-only country at historical year — distinct message
                    noDataMessage.innerHTML = `
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No applicable results</div>
                        <div class="no-data-text">Historical planned reactor data are not available.</div>
                    `;
                    countryInfoPlantsCount.textContent = 'N/A';
                } else {
                    // Case 1: Country genuinely has no nuclear activity in this year
                    let earliestYear = Infinity;
                    countryPlants.forEach(plant => {
                        plant.reactors.forEach(r => {
                            if (r.constructionStart && r.constructionStart < earliestYear) {
                                earliestYear = r.constructionStart;
                            }
                        });
                    });
                    const earliestYearText = earliestYear !== Infinity ? earliestYear : 'N/A';

                    noDataMessage.innerHTML = `
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No nuclear activity in ${escapeHtml(yearDisplay)}</div>
                        <div class="no-data-text">${escapeHtml(countryName)} had no nuclear power plants under construction or operating in ${escapeHtml(yearDisplay)}.</div>
                        <div class="no-data-year">First nuclear activity: ${escapeHtml(earliestYearText)}</div>
                    `;
                    countryInfoPlantsCount.textContent = 'No plants yet';
                }
            } else {
                // Case 2: Country has plants but all are filtered out
                const activeFilters = getActiveFiltersDescription();
                const filtersText = activeFilters.length > 0 ? activeFilters.join(', ') : 'None';

                noDataMessage.innerHTML = `
                    <div class="no-data-icon">
                        <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
                        </svg>
                    </div>
                    <div class="no-data-title">No matching plants</div>
                    <div class="no-data-text">${escapeHtml(countryName)} has nuclear plants in ${escapeHtml(yearDisplay)}, but none match your current filters.</div>
                    <div class="no-data-year">Active filters: ${escapeHtml(filtersText)}</div>
                `;

                countryInfoPlantsCount.textContent = 'No matching plants';
            }

            noDataMessage.style.display = 'block';

            // Hide the stats and plants sections
            if (countryInfoStatsHeader) countryInfoStatsHeader.style.display = 'none';
            if (countryInfoStats) countryInfoStats.style.display = 'none';
            if (countryInfoPlantsToggleEl) countryInfoPlantsToggleEl.style.display = 'none';
            if (countryInfoPlantsListEl) countryInfoPlantsListEl.style.display = 'none';
            // v5.7.153: Hide chart content in fullscreen so stale charts don't persist
            var countryDetailContentEl = document.getElementById('countryDetailContent');
            if (countryDetailContentEl) countryDetailContentEl.style.display = 'none';

            // Update the stats to show zeros
            countryInfoOperable.textContent = '0';
            countryInfoConstruction.textContent = '0';
            countryInfoPlanned.textContent = '0';
            countryInfoShutdown.textContent = '0';
            countryInfoCapacity.textContent = '0 GW';

        } else {
            // Hide the no-data message
            noDataMessage.style.display = 'none';
            
            // Show the stats and plants sections
            if (countryInfoStatsHeader) countryInfoStatsHeader.style.display = '';
            if (countryInfoStats) countryInfoStats.style.display = '';
            if (countryInfoPlantsToggleEl) countryInfoPlantsToggleEl.style.display = '';
            if (countryInfoPlantsListEl) countryInfoPlantsListEl.style.display = '';
            // v5.7.153: Restore chart content visibility
            var countryDetailContentEl = document.getElementById('countryDetailContent');
            if (countryDetailContentEl) countryDetailContentEl.style.display = '';
            
            // Update stats
            countryInfoOperable.textContent = stats.operableReactors;
            countryInfoConstruction.textContent = stats.constructionReactors;
            countryInfoPlanned.textContent = stats.plannedReactors;
            countryInfoShutdown.textContent = stats.shutdownReactors;
            // Use operable capacity (year-aware) for the capacity display
            countryInfoCapacity.textContent = (stats.operableCapacity / 1000).toFixed(1) + ' GW';
            countryInfoPlantsCount.textContent = `View ${stats.plants.length} plant${stats.plants.length !== 1 ? 's' : ''}`;
            
            // Build plants list - sort by year-aware status (using filtered status)
            const sortedPlants = [...stats.plants].sort((a, b) => {
                const getStatusPriority = (plant) => {
                    const plantStatus = getFilteredPlantStatusForYear(plant, currentSelectedYear);
                    if (!plantStatus) return 4; // Plant doesn't pass filters
                    const hasOperable = plantStatus.activeReactors.some(r => r.yearStatus === 'operable');
                    const hasConstruction = plantStatus.activeReactors.some(r => r.yearStatus === 'construction');
                    const hasPlanned = plantStatus.activeReactors.some(r => r.yearStatus === 'planned');
                    if (hasOperable) return 0;
                    if (hasConstruction) return 1;
                    if (hasPlanned) return 2;
                    return 3;
                };
                const aPriority = getStatusPriority(a);
                const bPriority = getStatusPriority(b);
                if (aPriority !== bPriority) return aPriority - bPriority;
                return a.name.localeCompare(b.name);
            });

            let plantsHtml = '';
            sortedPlants.forEach(plant => {
                const plantStatus = getFilteredPlantStatusForYear(plant, currentSelectedYear);
                if (!plantStatus || plantStatus.activeReactors.length === 0) return;

                const dotClass = plantStatus.color === '#00b894' ? 'green' :
                                plantStatus.color === '#fdcb6e' ? 'yellow' :
                                plantStatus.color === '#74b9ff' ? 'blue' : 'grey';
                // Calculate capacity from active reactors only (year-aware)
                const yearCapacity = plantStatus.activeReactors.reduce((sum, r) => sum + (r.capacity || 0), 0);
                const capacity = (yearCapacity / 1000).toFixed(1);

                plantsHtml += `
                    <div class="country-info-plant-item" data-plant="${escapeHtmlAttr(plant.name)}">
                        <div class="country-info-plant-dot ${dotClass}"></div>
                        <div class="country-info-plant-name">${escapeHtml(plant.name)}</div>
                        <div class="country-info-plant-capacity">${capacity} GW</div>
                    </div>
                `;
            });
            countryInfoPlantsList.innerHTML = plantsHtml;
            
            // Add click handlers for plants
            countryInfoPlantsList.querySelectorAll('.country-info-plant-item').forEach(item => {
                item.addEventListener('click', () => {
                    const plantName = item.dataset.plant;
                    const plant = nuclearPlants.find(p => p.name === plantName);
                    if (plant) {
                        zoomToPlant(plant);
                    }
                });
            });

            // v5.7.172: Hover-focus handlers for plant list items
            countryInfoPlantsList.querySelectorAll('.country-info-plant-item').forEach(item => {
                item.addEventListener('mouseenter', () => {
                    if (item.dataset.plant) applyHoverFocus(item.dataset.plant);
                });
                item.addEventListener('mouseleave', () => { clearHoverFocus(); });
            });
        }
        
        // Reset plants list state
        countryInfoPlantsToggle.classList.remove('expanded');
        countryInfoPlantsToggle.setAttribute('aria-expanded', 'false');
        countryInfoPlantsList.classList.remove('expanded');
        
        // Show country info, hide search and plant info (get overlays dynamically)
        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        const plantInfoOverlay = document.getElementById('plantInfoOverlay');
        const plantInfoBoxEl = document.getElementById('plantInfoBox');
        if (desktopSearchOverlay) desktopSearchOverlay.style.display = 'none';
        if (plantInfoOverlay) plantInfoOverlay.style.display = 'none';
        if (plantInfoBoxEl) plantInfoBoxEl.classList.remove('visible');
        if (countryInfoOverlayEl) countryInfoOverlayEl.style.display = 'flex';
        if (countryInfoBox) countryInfoBox.classList.add('visible');
        
        // Render country charts in fullscreen mode (only if we have data)
        if (hasDataForYear) {
            const isInFullscreen = isInFullscreenNow();
            if (isInFullscreen) {
                setTimeout(() => {
                    // For charts, we need full country data (all plants) to show historical timeline
                    // But the chart functions will filter to currentSelectedYear
                    const allCountryPlants = nuclearPlants.filter(p => p.country === countryName);
                    const chartStats = {
                        ...stats,
                        plants: allCountryPlants
                    };
                    renderCountryProductionChart(chartStats);
                    renderCountryReactorDeploy(chartStats);
                }, 50);
            }
        }
    }
    
    function hideCountryInfoOverlay() {
        currentSelectedCountry = null;
        clearHoverFocus(); // v5.7.172

        // Hide country info, show search (get desktop search overlay dynamically)
        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        if (countryInfoBox) countryInfoBox.classList.remove('visible');
        if (countryInfoOverlayEl) countryInfoOverlayEl.style.display = 'none';
        if (desktopSearchOverlay) desktopSearchOverlay.style.display = '';

        // Clear any highlighting
        clearSearchHighlight();
    }

    // Plants toggle handler (can run immediately - no map dependencies)
    if (countryInfoPlantsToggle) {
        countryInfoPlantsToggle.addEventListener('click', () => {
            const isExpanded = countryInfoPlantsToggle.classList.toggle('expanded');
            countryInfoPlantsToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            countryInfoPlantsList.classList.toggle('expanded', isExpanded);
        });
    }
    
    // --- 6e. Plant Info Overlay Functions (replaces search on desktop when plant selected) ---
    const plantInfoOverlayEl = document.getElementById('plantInfoOverlay');
    const plantInfoBox = document.getElementById('plantInfoBox');
    const plantInfoBack = document.getElementById('plantInfoBack');
    const plantInfoName = document.getElementById('plantInfoName');
    const plantInfoCountry = document.getElementById('plantInfoCountry');
    const plantInfoStatusBadge = document.getElementById('plantInfoStatusBadge');
    const plantInfoReactorCount = document.getElementById('plantInfoReactorCount');
    const plantInfoCapacity = document.getElementById('plantInfoCapacity');
    const plantInfoFirstGrid = document.getElementById('plantInfoFirstGrid');
    const plantInfoReactorsToggle = document.getElementById('plantInfoReactorsToggle');
    const plantInfoReactorsCount = document.getElementById('plantInfoReactorsCount');
    const plantInfoReactorsList = document.getElementById('plantInfoReactorsList');
    const plantInfoMoreDetails = document.getElementById('plantInfoMoreDetails');
    
    const plantInfoReactorHint = document.getElementById('plantInfoReactorHint');
    let currentSelectedPlant = null;

    // --- Navigation History Stack (v5.7.77) ---
    // Allows back buttons to cycle through previously viewed panels
    // instead of always returning to search.
    const navHistory = [];
    const NAV_MAX_HISTORY = 50;

    function captureNavState() {
        // Capture the currently visible overlay/modal as a navigation state
        if (currentDetailPlant && plantDetailModal && plantDetailModal.classList.contains('open')) {
            return { type: 'plantDetail', plant: currentDetailPlant };
        }
        if (currentSelectedPlant && plantInfoBox && plantInfoBox.classList.contains('visible')) {
            return { type: 'plant', plant: currentSelectedPlant };
        }
        if (currentSelectedPlant && plantInfoOverlayEl && plantInfoOverlayEl.style.display === 'flex'
            && !(plantInfoBox && plantInfoBox.classList.contains('visible'))) {
            // Plant overlay container visible but box not yet flagged (edge case)
            return { type: 'plant', plant: currentSelectedPlant };
        }
        if (currentSelectedCountry && countryInfoBox && countryInfoBox.classList.contains('visible')) {
            return { type: 'country', countryName: currentSelectedCountry };
        }
        return { type: 'search' };
    }

    function navPush() {
        var state = captureNavState();
        // Avoid consecutive duplicate entries
        if (navHistory.length > 0) {
            var top = navHistory[navHistory.length - 1];
            if (top.type === state.type
                && top.countryName === state.countryName
                && top.plant === state.plant) {
                return;
            }
        }
        navHistory.push(state);
        if (navHistory.length > NAV_MAX_HISTORY) navHistory.shift();
        updateBackButtonLabels();
    }

    function navPop() {
        var state = navHistory.length > 0 ? navHistory.pop() : { type: 'search' };
        updateBackButtonLabels();
        return state;
    }

    function navClear() {
        navHistory.length = 0;
        updateBackButtonLabels();
    }

    function updateBackButtonLabels() {
        var prevState = navHistory.length > 0 ? navHistory[navHistory.length - 1] : null;
        var title = 'Back to search';
        if (prevState) {
            if (prevState.type === 'country') {
                title = 'Back to ' + prevState.countryName;
            } else if (prevState.type === 'plant') {
                title = 'Back to ' + prevState.plant.name;
            } else if (prevState.type === 'plantDetail') {
                title = 'Back to ' + prevState.plant.name + ' details';
            }
        }
        [countryInfoBack, plantInfoBack].forEach(function(btn) {
            if (btn) {
                btn.title = title;
                btn.setAttribute('aria-label', title);
            }
        });
        // plantDetailBack is declared later; update it if available
        var pdb = document.getElementById('plantDetailBack');
        if (pdb) {
            pdb.title = title;
            pdb.setAttribute('aria-label', title);
        }
    }

    function hideAllOverlaysQuietly() {
        // Hide all overlay UI without resetting state variables
        var dso = document.getElementById('desktopSearchOverlay');
        if (plantInfoBox) plantInfoBox.classList.remove('visible');
        if (plantInfoOverlayEl) plantInfoOverlayEl.style.display = 'none';
        if (countryInfoBox) countryInfoBox.classList.remove('visible');
        if (countryInfoOverlayEl) countryInfoOverlayEl.style.display = 'none';
        if (plantDetailModal) {
            plantDetailModal.classList.remove('open');
            plantDetailModal.setAttribute('aria-hidden', 'true');
        }
        // Show search bar as neutral default
        if (dso) dso.style.display = '';
    }

    function restoreNavState(state) {
        if (!state || state.type === 'search') {
            // Return to search
            hideAllOverlaysQuietly();
            currentSelectedCountry = null;
            currentSelectedPlant = null;
            currentDetailPlant = null;
            clearSearchHighlight();
        } else if (state.type === 'country') {
            // Close any plant detail modal quietly first
            if (plantDetailModal) {
                plantDetailModal.classList.remove('open');
                plantDetailModal.setAttribute('aria-hidden', 'true');
            }
            currentDetailPlant = null;
            currentSelectedPlant = null;

            // Reposition map to country bounds
            var cName = state.countryName;
            var countryPlants = nuclearPlants.filter(function(p) {
                return p.country === cName && getPlantStatusForYear(p, currentSelectedYear) !== null;
            });
            var countryMaxZoom = 8;
            if (isGlobeView && globeMap) {
                if (countryPlants.length > 0) {
                    var minLng = Infinity, maxLng = -Infinity, minLat = Infinity, maxLat = -Infinity;
                    countryPlants.forEach(function(p) {
                        minLng = Math.min(minLng, p.lon); maxLng = Math.max(maxLng, p.lon);
                        minLat = Math.min(minLat, p.lat); maxLat = Math.max(maxLat, p.lat);
                    });
                    globeMap.fitBounds([[minLng, minLat], [maxLng, maxLat]], { padding: 50, duration: 1500, maxZoom: countryMaxZoom });
                }
            } else {
                if (countryPlants.length > 0) {
                    flyToBoundsWithMobileOffset(plantsBounds(countryPlants), { duration: 1500, maxZoom: COUNTRY_MAX_ZOOM_2D });
                }
            }
            showCountryInfoOverlay(cName);
            applySearchHighlight(function(plant) { return plant.country === cName; });
        } else if (state.type === 'plant') {
            if (plantDetailModal) {
                plantDetailModal.classList.remove('open');
                plantDetailModal.setAttribute('aria-hidden', 'true');
            }
            currentDetailPlant = null;
            currentSelectedCountry = null;

            // Reposition map to plant location
            var plant = state.plant;
            if (isGlobeView && globeMap) {
                globeMap.flyTo({ center: [plant.lon, plant.lat], zoom: 12, duration: 1500 }); // v5.7.159: zoom closer (was 9)
            } else {
                var dest = [plant.lon, plant.lat];
                var isMobile = window.innerWidth <= 600;
                if (isMobile) {
                    var offsetY = getMobilePanelOffset();
                    flyToWithOffset(dest, 13, 0, -offsetY, { duration: 1500 });
                } else {
                    var offsetX = getDesktopOverlayOffsetX();
                    flyToWithOffset(dest, 13, offsetX, 0, { duration: 1500 });
                }
            }
            showPlantInfoOverlay(plant);
            applySearchHighlight(function(p) { return p.name === plant.name; });
        } else if (state.type === 'plantDetail') {
            currentSelectedCountry = null;
            openPlantDetailModal(state.plant);
        }
        updateBackButtonLabels();
    }

    function handleNavBack() {
        var prevState = navPop();
        restoreNavState(prevState);
    }
    // --- End Navigation History Stack ---

    function showPlantInfoOverlay(plant, highlightReactorName = null, showNoDataMessage = false) {
        if (!plant) return;

        // Check BOTH unfiltered and filtered status to determine reason for no data
        const unfilteredStatus = getPlantStatusForYear(plant, currentSelectedYear);
        const filteredStatus = getFilteredPlantStatusForYear(plant, currentSelectedYear);

        const hasUnfilteredData = unfilteredStatus && unfilteredStatus.activeReactors && unfilteredStatus.activeReactors.length > 0;
        const hasFilteredData = filteredStatus && filteredStatus.activeReactors && filteredStatus.activeReactors.length > 0;

        // Use filtered status for display
        const plantStatus = filteredStatus;
        const hasDataForYear = hasFilteredData;

        // If no status and not explicitly showing no-data message, return
        if (!plantStatus && !showNoDataMessage && !hasUnfilteredData) return;

        currentSelectedPlant = plant;

        // Check if we're in fullscreen mode on desktop - if so, show detailed view automatically
        const isDesktop = window.innerWidth > 600;
        const isInFullscreen = isInFullscreenNow();

        if (isDesktop && isInFullscreen && hasDataForYear) {
            // Show detailed view automatically in fullscreen (only if we have data)
            openPlantDetailModal(plant, highlightReactorName);
            return;
        }

        // v5.7.168: Check if plant has ONLY planned reactors
        const isPlannedOnly = plant.reactors.every(r => r.status === 'planned');

        // Update header content (always show plant name and country)
        plantInfoName.textContent = plant.name;
        if (plantInfoName) plantInfoName.style.setProperty('color', '#5777a9', 'important');
        plantInfoCountry.textContent = plant.country;

        // Get or create the no-data message element
        let noDataMessage = plantInfoBox.querySelector('.no-data-yet-message');
        if (!noDataMessage) {
            noDataMessage = document.createElement('div');
            noDataMessage.className = 'no-data-yet-message';
            noDataMessage.id = 'plantNoDataMessage';
            // Insert after the header
            const plantInfoStats = plantInfoBox.querySelector('.plant-info-stats');
            if (plantInfoStats) {
                plantInfoStats.parentNode.insertBefore(noDataMessage, plantInfoStats);
            }
        }

        // Get content elements that should be hidden when no data
        const plantInfoStats = plantInfoBox.querySelector('.plant-info-stats');
        const plantInfoReactorsToggleEl = plantInfoBox.querySelector('.plant-info-reactors-toggle');
        const plantInfoReactorsListEl = plantInfoBox.querySelector('.plant-info-reactors-list');
        const plantInfoMoreDetailsEl = document.getElementById('plantInfoMoreDetails');

        if (!hasDataForYear) {
            const yearDisplay = currentSelectedYear === MAX_YEAR ? 'Present' : currentSelectedYear;

            // Determine the reason for no data
            if (!hasUnfilteredData) {
                if (isPlannedOnly && currentSelectedYear !== MAX_YEAR) {
                    // Planned-only plant at historical year — distinct message
                    noDataMessage.innerHTML = `
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No applicable results</div>
                        <div class="no-data-text">Historical planned reactor data are not available.</div>
                    `;
                    plantInfoStatusBadge.className = 'plant-info-status-badge grey';
                    plantInfoStatusBadge.textContent = 'N/A';
                } else {
                    // Case 1: Plant genuinely doesn't exist in this year
                    let earliestYear = Infinity;
                    plant.reactors.forEach(r => {
                        if (r.constructionStart && r.constructionStart < earliestYear) {
                            earliestYear = r.constructionStart;
                        }
                    });
                    const earliestYearText = earliestYear !== Infinity ? earliestYear : 'N/A';

                    noDataMessage.innerHTML = `
                        <div class="no-data-icon">
                            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <div class="no-data-title">No data for ${yearDisplay}</div>
                        <div class="no-data-text">This plant's construction hadn't started yet in the selected year.</div>
                        <div class="no-data-year">First activity: ${earliestYearText}</div>
                    `;

                    // Update status badge to show "Not yet built"
                    plantInfoStatusBadge.className = 'plant-info-status-badge grey';
                    plantInfoStatusBadge.textContent = 'Not Yet Built';
                }
            } else {
                // Case 2: Plant exists but is filtered out by current filters
                const activeFilters = getActiveFiltersDescription();
                const filtersText = activeFilters.length > 0 ? activeFilters.join(', ') : 'None';

                noDataMessage.innerHTML = `
                    <div class="no-data-icon">
                        <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
                        </svg>
                    </div>
                    <div class="no-data-title">Plant filtered</div>
                    <div class="no-data-text">This plant does not match your current filter selection.</div>
                    <div class="no-data-year">Active filters: ${filtersText}</div>
                `;

                // Update status badge to show "Filtered"
                plantInfoStatusBadge.className = 'plant-info-status-badge grey';
                plantInfoStatusBadge.textContent = 'Filtered';
            }

            noDataMessage.style.display = 'block';

            // Hide the stats and reactors sections
            if (plantInfoStats) plantInfoStats.style.display = 'none';
            if (plantInfoReactorsToggleEl) plantInfoReactorsToggleEl.style.display = 'none';
            if (plantInfoReactorsListEl) plantInfoReactorsListEl.style.display = 'none';
            if (plantInfoMoreDetailsEl) plantInfoMoreDetailsEl.style.display = 'none';
            
        } else {
            // Hide the no-data message
            noDataMessage.style.display = 'none';
            
            // Show the stats and reactors sections
            if (plantInfoStats) plantInfoStats.style.display = '';
            if (plantInfoReactorsToggleEl) plantInfoReactorsToggleEl.style.display = '';
            if (plantInfoReactorsListEl) plantInfoReactorsListEl.style.display = '';
            if (plantInfoMoreDetailsEl) plantInfoMoreDetailsEl.style.display = '';
            
            // Status badge
            const statusClass = plantStatus.color === '#00b894' ? 'green' :
                               plantStatus.color === '#fdcb6e' ? 'yellow' :
                               plantStatus.color === '#74b9ff' ? 'blue' : 'grey';
            const statusText = plantStatus.color === '#00b894' ? 'Operable' :
                              plantStatus.color === '#fdcb6e' ? 'Construction' :
                              plantStatus.color === '#74b9ff' ? 'Planned' : 'Shutdown';
            plantInfoStatusBadge.className = 'plant-info-status-badge ' + statusClass;
            plantInfoStatusBadge.textContent = statusText;
            
            // Stats - calculate capacity for this year based on active reactors
            plantInfoReactorCount.textContent = plantStatus.activeReactors.length;
            // Calculate capacity from active reactors only (year-aware)
            const yearCapacity = plantStatus.activeReactors.reduce((sum, r) => sum + (r.capacity || 0), 0);
            plantInfoCapacity.textContent = (yearCapacity / 1000).toFixed(1);
            
            // Find earliest grid connection
            const gridYears = plant.reactors
                .map(r => r.gridConnection)
                .filter(y => y && y !== Infinity);
            plantInfoFirstGrid.textContent = gridYears.length > 0 ? Math.min(...gridYears) : '—';

            // Reactors toggle text
            plantInfoReactorsCount.textContent = `View ${plantStatus.activeReactors.length} reactor${plantStatus.activeReactors.length !== 1 ? 's' : ''}`;
            
            const hasClickableReactors = plantStatus.activeReactors.some(r => r.url);
            if (plantInfoReactorHint) {
                plantInfoReactorHint.classList.toggle('visible', hasClickableReactors);
            }
            
            // Build reactors list
            let reactorsHtml = '';
            plantStatus.activeReactors.forEach(reactor => {
                const dotClass = reactor.yearStatus === 'operable' ? 'green' :
                                reactor.yearStatus === 'construction' ? 'yellow' :
                                reactor.yearStatus === 'planned' ? 'blue' : 'grey';
                const capacity = reactor.capacity ? (reactor.capacity / 1000).toFixed(2) : '—';
                const details = [];
                if (reactor.type) details.push(escapeHtml(reactor.type));
                if (reactor.yearStatus === 'construction' && reactor.constructionStartFormatted) details.push('Construction start: ' + escapeHtml(reactor.constructionStartFormatted));
                if (reactor.gridConnectionFormatted) details.push('Grid connection: ' + escapeHtml(reactor.gridConnectionFormatted));

                const isHighlighted = highlightReactorName && reactor.name === highlightReactorName;

                const reactorLabelRaw = reactor.displayName || reactor.name || 'Reactor';
                const reactorLabel = escapeHtml(reactorLabelRaw);
                const wrapperStyle = isHighlighted ? 'style="background: rgba(87, 119, 169, 0.1);"' : '';

                // External link button (if URL available)
                const safeUrl = sanitizeUrl(reactor.url);
                const linkOut = safeUrl
                    ? `<a class="plant-info-reactor-linkout" href="${safeUrl}" target="_blank" rel="noopener noreferrer" aria-label="Open ${escapeHtmlAttr(reactorLabelRaw)} Reactor Database entry" title="Open Reactor Database entry">
                        <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                            <polyline points="15 3 21 3 21 9"></polyline>
                            <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                    </a>`
                    : '';

                reactorsHtml += `
                    <div class="plant-info-reactor-item" ${wrapperStyle}>
                        <div class="plant-info-reactor-dot ${dotClass}"></div>
                        <div class="plant-info-reactor-info">
                            <div class="plant-info-reactor-name">${reactorLabel}</div>
                            ${details.length > 0 ? `<div class="plant-info-reactor-details">${details.join(' &bull; ')}</div>` : ''}
                        </div>
                        <div class="plant-info-reactor-capacity">${capacity} GW</div>
                        ${linkOut}
                    </div>
                `;
            });
            plantInfoReactorsList.innerHTML = reactorsHtml;
            
            // If a reactor was searched, expand the reactors list
            const shouldExpandByDefault = !!highlightReactorName;

            if (shouldExpandByDefault) {
                plantInfoReactorsToggle.classList.add('expanded');
                plantInfoReactorsToggle.setAttribute('aria-expanded', 'true');
                plantInfoReactorsList.classList.add('expanded');
            } else {
                plantInfoReactorsToggle.classList.remove('expanded');
                plantInfoReactorsToggle.setAttribute('aria-expanded', 'false');
                plantInfoReactorsList.classList.remove('expanded');
            }
        }
        
        // Hide other overlays and show plant info
        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        if (desktopSearchOverlay) desktopSearchOverlay.style.display = 'none';
        if (countryInfoOverlayEl) countryInfoOverlayEl.style.display = 'none';
        if (countryInfoBox) countryInfoBox.classList.remove('visible');
        if (plantInfoOverlayEl) plantInfoOverlayEl.style.display = 'flex';
        if (plantInfoBox) plantInfoBox.classList.add('visible');
    }
    
    function hidePlantInfoOverlay() {
        currentSelectedPlant = null;

        if (plantInfoReactorHint) plantInfoReactorHint.classList.remove('visible');
        // Hide plant info, show search
        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        if (plantInfoBox) plantInfoBox.classList.remove('visible');
        if (plantInfoOverlayEl) plantInfoOverlayEl.style.display = 'none';
        if (desktopSearchOverlay) desktopSearchOverlay.style.display = '';

        // Clear any highlighting
        clearSearchHighlight();
    }

    // --- 6f. Refresh Info Boxes When Filters Change ---
    function refreshInfoBoxesForFilters() {
        // Refresh country info box if currently showing
        if (currentSelectedCountry && countryInfoBox && countryInfoBox.classList.contains('visible')) {
            showCountryInfoOverlay(currentSelectedCountry);
        }

        // Refresh plant info box if currently showing
        if (currentSelectedPlant && plantInfoBox && plantInfoBox.classList.contains('visible')) {
            showPlantInfoOverlay(currentSelectedPlant, null, true);
        }

        // v5.7.153: Refresh plant detail modal if open (fullscreen mode)
        var modalPlant = currentSelectedPlant || currentDetailPlant;
        if (plantDetailModal && plantDetailModal.classList.contains('open') && modalPlant) {
            openPlantDetailModal(modalPlant);
        }

        // v5.7.126: Refresh mobile panels if open (re-renders with current year/filters)
        if (countryPanel && countryPanel.classList.contains('open')) {
            const countryName = countryPanelTitle ? countryPanelTitle.textContent : null;
            if (countryName) openCountryPanel(countryName, true);
        }
        if (plantPanel && plantPanel.classList.contains('open') && currentMobilePlantSelection) {
            openPlantPanel(currentMobilePlantSelection);
        }
    }

    // Reactors toggle handler
    if (plantInfoReactorsToggle) {
        plantInfoReactorsToggle.addEventListener('click', () => {
            const isExpanded = plantInfoReactorsToggle.classList.toggle('expanded');
            plantInfoReactorsToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            plantInfoReactorsList.classList.toggle('expanded', isExpanded);
        });
    }
    
    // Country link handler (click to show country info and zoom to country)
    if (plantInfoCountry) {
        plantInfoCountry.addEventListener('click', () => {
            if (currentSelectedPlant) {
                const countryName = currentSelectedPlant.country;
                // v5.7.77: Don't call hidePlantInfoOverlay() here — it nulls
                // currentSelectedPlant before zoomToCountry can capture nav state.
                // zoomToCountry → showCountryInfoOverlay already hides the plant overlay UI.
                zoomToCountry(countryName);
            }
        });
    }
    


    // --- Plant Detailed Summary Modal Logic ---
    const plantDetailModal = document.getElementById('plantDetailModal');
    const plantDetailBackdrop = document.getElementById('plantDetailBackdrop');
    const plantDetailBack = document.getElementById('plantDetailBack');
    const plantDetailStatusBadge = document.getElementById('plantDetailStatusBadge');
    const plantDetailTitle = document.getElementById('plantDetailTitle');
    const plantDetailCountry = document.getElementById('plantDetailCountry');
    const plantDetailReactorCount = document.getElementById('plantDetailReactorCount');
    const plantDetailCapacity = document.getElementById('plantDetailCapacity');
    const plantDetailFirstGrid = document.getElementById('plantDetailFirstGrid');
    const plantDetailReactorsToggle = document.getElementById('plantDetailReactorsToggle');
    const plantDetailReactorsCount = document.getElementById('plantDetailReactorsCount');
    const plantDetailReactorsList = document.getElementById('plantDetailReactorsList');
    const plantProductionChart = document.getElementById('plantProductionChart');
    const plantProductionEmpty = document.getElementById('plantProductionEmpty');
    const plantReactorTimeline = document.getElementById('plantReactorTimeline');
    const plantTimelineEmpty = document.getElementById('plantTimelineEmpty');
    const plantRecentNewsList = document.getElementById('plantRecentNewsList');
    const plantRecentNewsEmpty = document.getElementById('plantRecentNewsEmpty');
    const plantDetailTabs = plantDetailModal ? plantDetailModal.querySelectorAll('.plant-detail-tab') : [];
    const plantDetailPanels = plantDetailModal ? plantDetailModal.querySelectorAll('.plant-detail-panel') : [];

    let currentDetailPlant = null;
    let detailResizeTimer = null;

    function populatePlantDetailSummary(plant, highlightReactorName = null) {
        if (!plant) return;

        // Use filtered plant status that respects active viewOptions filters
        const plantStatus = getFilteredPlantStatusForYear(plant, currentSelectedYear);
        if (!plantStatus) return;

        // Stats row (mirror the basic summary)
        if (plantDetailReactorCount) plantDetailReactorCount.textContent = plantStatus.activeReactors.length;
        // Calculate capacity from filtered active reactors
        const filteredCapacity = plantStatus.activeReactors.reduce((sum, r) => sum + (r.capacity || 0), 0);
        if (plantDetailCapacity) plantDetailCapacity.textContent = (filteredCapacity / 1000).toFixed(1);

        // Get grid years from filtered active reactors only
        const gridYears = plantStatus.activeReactors
            .map(r => r && r.gridConnection)
            .filter(y => y && y !== Infinity);
        if (plantDetailFirstGrid) plantDetailFirstGrid.textContent = gridYears.length > 0 ? Math.min(...gridYears) : '—';

        // Reactors dropdown (mirror the basic summary)
        if (plantDetailReactorsCount) {
            plantDetailReactorsCount.textContent = `View ${plantStatus.activeReactors.length} reactor${plantStatus.activeReactors.length !== 1 ? 's' : ''}`;
        }

        
        if (plantDetailReactorsList) {
            let reactorsHtml = '';

            const displayVal = (v) => (v != null && String(v).trim() !== '' ? String(v).trim() : '—');
            const displayDate = (formatted, year) => {
                if (formatted) return String(formatted);
                if (year && year !== Infinity) return String(year);
                return '—';
            };

            plantStatus.activeReactors.forEach((reactor, reactorIndex) => {
                const dotClass = reactor.yearStatus === 'operable' ? 'green' :
                                reactor.yearStatus === 'construction' ? 'yellow' :
                                reactor.yearStatus === 'planned' ? 'blue' : 'grey';
                const capacity = reactor.capacity ? (reactor.capacity / 1000).toFixed(2) : '—';

                const details = [];
                if (reactor.type) details.push(escapeHtmlAttr(reactor.type));
                if (reactor.yearStatus === 'construction' && reactor.constructionStartFormatted) details.push(`Construction start: ${reactor.constructionStartFormatted}`);
                if (reactor.gridConnectionFormatted) details.push(`Grid connection: ${reactor.gridConnectionFormatted}`);

                const reactorLabelRaw = reactor.displayName || reactor.name || 'Reactor';
                const reactorLabel = escapeHtmlAttr(reactorLabelRaw);

                const typeVal = escapeHtmlAttr(displayVal(reactor.type));
                const modelVal = escapeHtmlAttr(displayVal(reactor.model));
                const providerVal = escapeHtmlAttr(displayVal(reactor.technologyProvider));
                const operatorVal = escapeHtmlAttr(displayVal(reactor.operator));
                const constructionVal = escapeHtmlAttr(displayDate(reactor.constructionStartFormatted, reactor.constructionStart));
                const gridVal = escapeHtmlAttr(displayDate(reactor.gridConnectionFormatted, reactor.gridConnection));                const shutdownVal = escapeHtmlAttr(displayDate(reactor.shutdownDateFormatted, reactor.shutdownDate));

                // Optional WNN links/headlines (shown only if present)
                // v5.7.64: Use sanitizeUrl() to block javascript: and other dangerous protocols
                const wnnList = Array.isArray(reactor.wnnItems) ? reactor.wnnItems : [];
                const wnnLinksHtml = wnnList
                    .filter(item => item && (item.url || item.headline))
                    .map((item, idx) => {
                        const href = item.url ? sanitizeUrl(String(item.url).trim()) : '';
                        const label = escapeHtml(String(item.headline || item.url || `WNN ${idx + 1}`).trim());
                        return href
                            ? `<a href="${href}" target="_blank" rel="noopener noreferrer">${label}</a>`
                            : `<span>${label}</span>`;
                    })
                    .join('<br>');
                const wnnBlock = wnnLinksHtml
                    ? `
                                <div class="plant-detail-field">
                                    <div class="plant-detail-field-label">WNN coverage</div>
                                    <div class="plant-detail-field-value">${wnnLinksHtml}</div>
                                </div>`
                    : '';

                const safeUrl = sanitizeUrl(reactor.url);
                const linkOut = safeUrl
                    ? `<a class="plant-detail-reactor-linkout" href="${safeUrl}" target="_blank" rel="noopener noreferrer" aria-label="Open ${reactorLabel} Reactor Database entry" title="Open Reactor Database entry">
                        <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24">
                            <path d="M14 3h7v7"></path>
                            <path d="M10 14L21 3"></path>
                            <path d="M21 14v7h-7"></path>
                            <path d="M3 10v11h11"></path>
                        </svg>
                    </a>`
                    : '';

                const isHighlighted = highlightReactorName && reactor.name === highlightReactorName;
                const highlightStyle = isHighlighted ? ' style="background: rgba(87, 119, 169, 0.1);"' : '';

                reactorsHtml += `
                    <div class="plant-detail-reactor-item" data-reactor-index="${reactorIndex}"${highlightStyle}>
                        <div class="plant-detail-reactor-head">
                            <div class="plant-info-reactor-dot ${dotClass}"></div>
                            <div class="plant-info-reactor-info">
                                <div class="plant-info-reactor-name">${reactorLabel}</div>
                                ${details.length > 0 ? `<div class="plant-info-reactor-details">${details.join(' • ')}</div>` : ''}
                            </div>
                            <div class="plant-detail-reactor-right">
                                <div class="plant-info-reactor-capacity">${capacity} GW</div>
                                ${linkOut}
                            </div>
                        </div>
                    </div>
                `;
            });

            plantDetailReactorsList.innerHTML = reactorsHtml;
        }

        // Default: keep the reactor dropdown visible, but collapsed
        if (plantDetailReactorsToggle && plantDetailReactorsList) {
            plantDetailReactorsToggle.classList.remove('expanded');
            plantDetailReactorsToggle.setAttribute('aria-expanded', 'false');
            plantDetailReactorsList.classList.remove('expanded');
        }
}


    function canOpenPlantDetailModal() {
        const isDesktop = window.innerWidth > 600;
        const isInFullscreen = isInFullscreenNow();
        return isDesktop && !!isInFullscreen;
    }

    function openPlantDetailModal(plant, highlightReactorName = null) {
        if (!plantDetailModal || !plant) return;

        // Only offer detailed summaries on desktop when the map is fullscreen
        if (!canOpenPlantDetailModal()) return;

        currentDetailPlant = plant;

        // v5.7.153: Check BOTH unfiltered and filtered status to determine reason for no data
        const unfilteredStatus = getPlantStatusForYear(plant, currentSelectedYear);
        const filteredStatus = getFilteredPlantStatusForYear(plant, currentSelectedYear);
        const hasUnfilteredData = unfilteredStatus && unfilteredStatus.activeReactors && unfilteredStatus.activeReactors.length > 0;
        const hasFilteredData = filteredStatus && filteredStatus.activeReactors && filteredStatus.activeReactors.length > 0;
        const plantStatus = filteredStatus;

        // v5.7.168: Check if plant has ONLY planned reactors
        const isPlannedOnly = plant.reactors.every(r => r.status === 'planned');

        if (plantDetailTitle) {
            plantDetailTitle.textContent = plant.name || '';
            // Resist host-site theme styles (e.g., global H3 colors)
            plantDetailTitle.style.setProperty('color', '#5777a9', 'important');
        }
        if (plantDetailCountry) plantDetailCountry.textContent = plant.country || '';

        // v5.7.153: Get or create no-data message element inside the modal dialog
        const dialog = plantDetailModal.querySelector('.plant-detail-dialog');
        let modalNoDataMessage = dialog ? dialog.querySelector('.no-data-yet-message') : null;
        if (!modalNoDataMessage && dialog) {
            modalNoDataMessage = document.createElement('div');
            modalNoDataMessage.className = 'no-data-yet-message';
            modalNoDataMessage.id = 'plantDetailNoDataMessage';
            const modalStats = dialog.querySelector('.plant-info-stats');
            if (modalStats) {
                modalStats.parentNode.insertBefore(modalNoDataMessage, modalStats);
            }
        }

        // v5.7.153: Get content elements to hide/show based on data availability
        const modalStats = dialog ? dialog.querySelector('.plant-info-stats') : null;
        const modalReactorsToggle = dialog ? dialog.querySelector('.plant-info-reactors-toggle') : null;
        const modalReactorsList = dialog ? dialog.querySelector('.plant-info-reactors-list') : null;
        const modalContent = dialog ? dialog.querySelector('.plant-detail-content') : null;

        if (!hasFilteredData) {
            // v5.7.153: No data for this year/filter — show no-data message in modal
            const yearDisplay = currentSelectedYear === MAX_YEAR ? 'Present' : currentSelectedYear;

            if (!hasUnfilteredData) {
                if (isPlannedOnly && currentSelectedYear !== MAX_YEAR) {
                    // Planned-only plant at historical year — distinct message
                    if (modalNoDataMessage) modalNoDataMessage.innerHTML = '<div class="no-data-icon"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg></div>' +
                        '<div class="no-data-title">No applicable results</div>' +
                        '<div class="no-data-text">Historical planned reactor data are not available.</div>';
                    if (plantDetailStatusBadge) {
                        plantDetailStatusBadge.className = 'plant-info-status-badge grey';
                        plantDetailStatusBadge.textContent = 'N/A';
                    }
                } else {
                    // Case 1: Plant genuinely doesn't exist in this year
                    let earliestYear = Infinity;
                    plant.reactors.forEach(r => {
                        if (r.constructionStart && r.constructionStart < earliestYear) {
                            earliestYear = r.constructionStart;
                        }
                    });
                    const earliestYearText = earliestYear !== Infinity ? earliestYear : 'N/A';

                    if (modalNoDataMessage) modalNoDataMessage.innerHTML = '<div class="no-data-icon"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path></svg></div>' +
                        '<div class="no-data-title">No data for ' + yearDisplay + '</div>' +
                        '<div class="no-data-text">This plant\'s construction hadn\'t started yet in the selected year.</div>' +
                        '<div class="no-data-year">First activity: ' + earliestYearText + '</div>';

                    if (plantDetailStatusBadge) {
                        plantDetailStatusBadge.className = 'plant-info-status-badge grey';
                        plantDetailStatusBadge.textContent = 'Not Yet Built';
                    }
                }
            } else {
                // Case 2: Plant exists but is filtered out by current filters
                const activeFilters = getActiveFiltersDescription();
                const filtersText = activeFilters.length > 0 ? activeFilters.join(', ') : 'None';

                if (modalNoDataMessage) modalNoDataMessage.innerHTML = '<div class="no-data-icon"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path></svg></div>' +
                    '<div class="no-data-title">Plant filtered</div>' +
                    '<div class="no-data-text">This plant does not match your current filter selection.</div>' +
                    '<div class="no-data-year">Active filters: ' + filtersText + '</div>';

                if (plantDetailStatusBadge) {
                    plantDetailStatusBadge.className = 'plant-info-status-badge grey';
                    plantDetailStatusBadge.textContent = 'Filtered';
                }
            }

            if (modalNoDataMessage) modalNoDataMessage.style.display = 'block';
            if (modalStats) modalStats.style.display = 'none';
            if (modalReactorsToggle) modalReactorsToggle.style.display = 'none';
            if (modalReactorsList) modalReactorsList.style.display = 'none';
            if (modalContent) modalContent.style.display = 'none';

        } else {
            // Has data — hide no-data message and show normal content
            if (modalNoDataMessage) modalNoDataMessage.style.display = 'none';
            if (modalStats) modalStats.style.display = '';
            if (modalReactorsToggle) modalReactorsToggle.style.display = '';
            if (modalReactorsList) modalReactorsList.style.display = '';
            if (modalContent) modalContent.style.display = '';

            populatePlantDetailSummary(plant, highlightReactorName);

// v5.7.161: Expand reactor list when a reactor was searched; collapse otherwise
if (highlightReactorName) {
    if (plantDetailReactorsToggle) {
        plantDetailReactorsToggle.classList.add('expanded');
        plantDetailReactorsToggle.setAttribute('aria-expanded', 'true');
    }
    if (plantDetailReactorsList) {
        plantDetailReactorsList.classList.add('expanded');
    }
} else {
    if (plantDetailReactorsToggle) {
        plantDetailReactorsToggle.classList.remove('expanded');
        plantDetailReactorsToggle.setAttribute('aria-expanded', 'false');
    }
    if (plantDetailReactorsList) {
        plantDetailReactorsList.classList.remove('expanded');
    }
}

            // Match the basic summary header (status badge)
            if (plantDetailStatusBadge) {
                if (plantStatus && plantStatus.color) {
                    const statusClass = plantStatus.color === '#00b894' ? 'green' :
                        plantStatus.color === '#fdcb6e' ? 'yellow' :
                        plantStatus.color === '#74b9ff' ? 'blue' : 'grey';
                    const statusText = plantStatus.color === '#00b894' ? 'Operable' :
                        plantStatus.color === '#fdcb6e' ? 'Construction' :
                        plantStatus.color === '#74b9ff' ? 'Planned' : 'Shutdown';
                    plantDetailStatusBadge.className = 'plant-info-status-badge ' + statusClass;
                    plantDetailStatusBadge.textContent = statusText;
                } else {
                    plantDetailStatusBadge.className = 'plant-info-status-badge';
                    plantDetailStatusBadge.textContent = '';
                }
            }
        }

        // Load in-frame: hide the standard summary overlay and show the detailed panel in its place
        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        if (desktopSearchOverlay) desktopSearchOverlay.style.display = 'none';
        if (plantInfoBox) plantInfoBox.classList.remove('visible');
        if (plantInfoOverlayEl) plantInfoOverlayEl.style.display = 'none';
        if (countryInfoBox) countryInfoBox.classList.remove('visible');
        if (countryInfoOverlayEl) countryInfoOverlayEl.style.display = 'none';

        plantDetailModal.classList.add('open');
        plantDetailModal.setAttribute('aria-hidden', 'false');

        // Render charts only when we have data (deferred one frame to ensure layout sizes are correct)
        if (hasFilteredData) {
            requestAnimationFrame(() => {
                renderPlantProductionChart(plant);
                renderPlantReactorTimeline(plant);
                renderPlantRecentNews(plant);
            });
        }
    }

    function closePlantDetailModal() {
        if (!plantDetailModal) return;

        plantDetailModal.classList.remove('open');
        plantDetailModal.setAttribute('aria-hidden', 'true');
        const plantToRestore = currentDetailPlant || currentSelectedPlant;
        currentDetailPlant = null;

        // Restore the standard summary overlay on desktop (mobile uses popups / full-screen panel)
        const isDesktop = window.innerWidth > 600;
        if (!isDesktop) return;

        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        
        // Check if we're still in fullscreen - if so, don't show standard view
        const isInFullscreen = isInFullscreenNow();

        if (plantToRestore && !isInFullscreen) {
            // Re-populate and show the standard summary
            currentSelectedPlant = plantToRestore;
            const plantStatus = getPlantStatusForYear(plantToRestore, currentSelectedYear);
            if (plantStatus) {
                plantInfoName.textContent = plantToRestore.name;
                if (plantInfoName) plantInfoName.style.setProperty('color', '#5777a9', 'important');
                plantInfoCountry.textContent = plantToRestore.country;
                
                const statusClass = plantStatus.color === '#00b894' ? 'green' :
                                   plantStatus.color === '#fdcb6e' ? 'yellow' :
                                   plantStatus.color === '#74b9ff' ? 'blue' : 'grey';
                const statusText = plantStatus.color === '#00b894' ? 'Operable' :
                                  plantStatus.color === '#fdcb6e' ? 'Construction' :
                                  plantStatus.color === '#74b9ff' ? 'Planned' : 'Shutdown';
                plantInfoStatusBadge.className = 'plant-info-status-badge ' + statusClass;
                plantInfoStatusBadge.textContent = statusText;

                plantInfoReactorCount.textContent = plantStatus.activeReactors.length;
                plantInfoCapacity.textContent = (plantToRestore.totalCapacity / 1000).toFixed(1);
                
                const gridYears = plantToRestore.reactors
                    .map(r => r.gridConnection)
                    .filter(y => y && y !== Infinity);
                plantInfoFirstGrid.textContent = gridYears.length > 0 ? Math.min(...gridYears) : '—';
                
                plantInfoReactorsCount.textContent = `View ${plantStatus.activeReactors.length} reactor${plantStatus.activeReactors.length !== 1 ? 's' : ''}`;
            }
            
            if (plantInfoOverlayEl) plantInfoOverlayEl.style.display = 'flex';
            if (plantInfoBox) plantInfoBox.classList.add('visible');
            if (desktopSearchOverlay) desktopSearchOverlay.style.display = 'none';
        } else if (!isInFullscreen) {
            // Fall back to the search box if there is no selected plant
            if (plantInfoOverlayEl) plantInfoOverlayEl.style.display = 'none';
            if (desktopSearchOverlay) desktopSearchOverlay.style.display = '';
        } else {
            // In fullscreen, return to the search bar immediately
            if (plantInfoOverlayEl) plantInfoOverlayEl.style.display = 'none';
            if (plantInfoBox) plantInfoBox.classList.remove('visible');
            if (desktopSearchOverlay) desktopSearchOverlay.style.display = '';
            // v5.7.58: Clear marker highlighting when closing plant detail in fullscreen
            clearSearchHighlight();
            // v5.7.138: Clear plant selection when closing in fullscreen
            currentSelectedPlant = null;
        }
    }

    function setPlantDetailTab(tabName) {
        if (!plantDetailModal) return;

        plantDetailTabs.forEach(btn => {
            const isActive = btn.dataset.tab === tabName;
            btn.classList.toggle('active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        plantDetailPanels.forEach(panel => {
            const isActive = panel.dataset.panel === tabName;
            panel.classList.toggle('active', isActive);
        });

        // Re-render on tab switch (especially for responsive sizing)
        if (currentDetailPlant) {
            requestAnimationFrame(() => {
                if (tabName === 'production') renderPlantProductionChart(currentDetailPlant);
                if (tabName === 'timeline') {
                    renderPlantReactorTimeline(currentDetailPlant);
                    renderPlantRecentNews(currentDetailPlant);
                }
            });
        }
    }

    function getPlantProductionSeries(plant, maxDisplayYear) {
        const totals = {};
        if (!plant || !plant.reactors) return { years: [], values: [] };

        // Use provided max year or fall back to currentSelectedYear
        const cutoffYear = maxDisplayYear !== undefined ? maxDisplayYear : currentSelectedYear;

        plant.reactors.forEach(r => {
            if (!r || !r.productionByYear) return;
            Object.keys(r.productionByYear).forEach(k => {
                const year = parseInt(k, 10);
                const val = parseFloat(r.productionByYear[k]);
                // Only include years up to the cutoff year
                if (!Number.isFinite(year) || !Number.isFinite(val) || year > cutoffYear) return;
                totals[year] = (totals[year] || 0) + val; // assume GWh
            });
        });

        const years = Object.keys(totals).map(y => parseInt(y, 10)).filter(y => Number.isFinite(y)).sort((a, b) => a - b);
        const values = years.map(y => totals[y]);

        return { years, values };
    }

    let plantProductionMode = 'annual'; // 'annual' or 'cumulative'
    let plantProductionData = null;

    function renderPlantProductionChart(plant) {
        if (!plantProductionChart || !plantProductionEmpty) return;
        plantProductionData = plant;

        const series = getPlantProductionSeries(plant);
        const hasSeries = series.years && series.years.length >= 2 && series.values.some(v => Number.isFinite(v) && v !== 0);

        // Get references to subtitle, toggle, and chart wrapper for visibility control
        const plantProductionSubtitle = document.getElementById('plantProductionSubtitle');
        const plantProductionToggle = document.getElementById('plantProductionToggle');
        const plantChartWrap = plantProductionChart ? plantProductionChart.closest('.detail-chart-wrap') : null;

        if (!hasSeries) {
            plantProductionChart.style.display = 'none';
            plantProductionEmpty.style.display = 'block';
            // Hide subtitle, toggle, and chart wrapper when no production data
            if (plantProductionSubtitle) plantProductionSubtitle.style.display = 'none';
            if (plantProductionToggle) plantProductionToggle.style.display = 'none';
            if (plantChartWrap) plantChartWrap.style.display = 'none';
            return;
        }

        plantProductionEmpty.style.display = 'none';
        plantProductionChart.style.display = 'block';
        // Show subtitle, toggle, and chart wrapper when production data exists
        if (plantProductionSubtitle) plantProductionSubtitle.style.display = '';
        if (plantProductionToggle) plantProductionToggle.style.display = '';
        if (plantChartWrap) plantChartWrap.style.display = '';

        // Convert GWh -> TWh
        let valuesTWh = series.values.map(v => v / 1000);
        
        // Calculate cumulative if needed
        if (plantProductionMode === 'cumulative') {
            let cumulative = 0;
            valuesTWh = valuesTWh.map(v => {
                cumulative += v;
                return cumulative;
            });
        }
        
        // Update subtitle
        const subtitle = document.getElementById('plantProductionSubtitle');
        if (subtitle) {
            subtitle.textContent = plantProductionMode === 'annual'
                ? 'Annual (TWh)'
                : 'Cumulative (TWh)';
        }

        drawLineChartOnCanvas(plantProductionChart, series.years, valuesTWh, null);
        setupPlantProductionChartInteractivity(plantProductionChart, series.years, valuesTWh);
        setupPlantProductionToggle();
    }
    
    function setupPlantProductionToggle() {
        const toggle = document.getElementById('plantProductionToggle');
        if (!toggle) return;
        
        const btns = toggle.querySelectorAll('.production-toggle-btn');
        btns.forEach(btn => {
            // Update active state
            btn.classList.toggle('active', btn.dataset.mode === plantProductionMode);
            
            // Remove old listeners by cloning
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
            
            newBtn.addEventListener('click', () => {
                if (newBtn.dataset.mode === plantProductionMode) return;
                plantProductionMode = newBtn.dataset.mode;
                if (plantProductionData) {
                    renderPlantProductionChart(plantProductionData);
                }
            });
        });
    }

    function drawLineChartOnCanvas(canvas, years, values, hoverIndex = null) {
        if (!canvas || !years || years.length === 0) return;

        // Check if dark mode is active
        const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
        
        // Define colors based on theme
        const colors = isDarkMode ? {
            grid: '#3d4750',
            axis: '#4a5568',
            label: '#adb5bd',
            line: '#7c9fd4',
            point: '#7c9fd4',
            hoverLine: 'rgba(124, 159, 212, 0.28)',
            hoverPointFill: '#7c9fd4',
            hoverPointStroke: '#22262b'
        } : {
            grid: '#eef2f6',
            axis: '#e1e5ea',
            label: '#636e72',
            line: '#5777a9',
            point: '#5777a9',
            hoverLine: 'rgba(87, 119, 169, 0.28)',
            hoverPointFill: '#5777a9',
            hoverPointStroke: '#ffffff'
        };

        const dpr = window.devicePixelRatio || 1;
        const containerWidth = canvas.getBoundingClientRect().width || canvas.parentElement.getBoundingClientRect().width || 600;
        const width = Math.max(280, Math.floor(containerWidth));
        const height = (canvas.classList.contains('detail-chart-canvas') || canvas.classList.contains('expanded-chart-canvas')) ? (canvas.getBoundingClientRect().height || 260) : 260;

        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);
        canvas.style.width = width + 'px';
        canvas.style.height = Math.floor(height) + 'px';

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, width, height);

        const margin = { left: 48, right: 14, top: 12, bottom: 30 };
        const plotW = width - margin.left - margin.right;
        const plotH = height - margin.top - margin.bottom;

        const minY = Math.min(...values);
        const maxY = Math.max(...values);

        // Compute nice y-axis ticks
        const rawRange = (maxY - minY) === 0 ? 1 : (maxY - minY);
        const rawStep = rawRange / 4;
        const stepMag = Math.pow(10, Math.floor(Math.log10(rawStep)));
        const stepFrac = rawStep / stepMag;
        const niceStep = (stepFrac < 1.5 ? 1 : stepFrac < 3 ? 2 : stepFrac < 7 ? 5 : 10) * stepMag;

        const niceMin = Math.max(0, Math.floor(minY / niceStep) * niceStep);
        let niceMax = Math.ceil(maxY / niceStep) * niceStep;
        if (niceMax <= niceMin) niceMax = niceMin + niceStep;

        const y0 = niceMin;
        const y1 = niceMax;
        const numTicks = Math.round((y1 - y0) / niceStep);
        const yTicks = [];
        for (let i = 0; i <= numTicks; i++) yTicks.push(y0 + i * niceStep);

        const yDecimals = niceStep >= 1 ? 0 : niceStep >= 0.1 ? 1 : 2;

        const xAt = (i) => margin.left + (years.length === 1 ? 0 : (i / (years.length - 1)) * plotW);
        const yAt = (v) => margin.top + (1 - (v - y0) / (y1 - y0)) * plotH;

        // Grid (aligned to nice ticks)
        ctx.strokeStyle = colors.grid;
        ctx.lineWidth = 1;
        yTicks.forEach(t => {
            const gy = yAt(t);
            ctx.beginPath();
            ctx.moveTo(margin.left, gy);
            ctx.lineTo(margin.left + plotW, gy);
            ctx.stroke();
        });

        // Axes
        ctx.strokeStyle = colors.axis;
        ctx.beginPath();
        ctx.moveTo(margin.left, margin.top);
        ctx.lineTo(margin.left, margin.top + plotH);
        ctx.lineTo(margin.left + plotW, margin.top + plotH);
        ctx.stroke();

        // Y labels (nice ticks)
        ctx.fillStyle = colors.label;
        ctx.font = '11px Muli, sans-serif';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        yTicks.forEach(t => {
            const ly = yAt(t);
            ctx.fillText(t.toFixed(yDecimals), margin.left - 8, ly);
        });

        // X labels (start/mid/end)
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        const labelIdx = years.length <= 2 ? [0, years.length - 1] : [0, Math.floor((years.length - 1) / 2), years.length - 1];
        labelIdx.forEach(i => {
            const x = xAt(i);
            ctx.fillText(String(years[i]), x, margin.top + plotH + 8);
        });

        // Line
        ctx.strokeStyle = colors.line;
        ctx.lineWidth = 2;
        ctx.beginPath();
        years.forEach((_, i) => {
            const x = xAt(i);
            const y = yAt(values[i]);
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
        });
        ctx.stroke();

        const hoverIdx = (Number.isFinite(hoverIndex) ? hoverIndex : null);

        // Hover guide
        if (hoverIdx !== null && hoverIdx >= 0 && hoverIdx < years.length) {
            const hx = xAt(hoverIdx);
            ctx.save();
            ctx.strokeStyle = colors.hoverLine;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(hx, margin.top);
            ctx.lineTo(hx, margin.top + plotH);
            ctx.stroke();
            ctx.restore();
        }

        // Points
        ctx.fillStyle = colors.point;
        years.forEach((_, i) => {
            const x = xAt(i);
            const y = yAt(values[i]);

            const isHover = (hoverIdx === i);
            const r = isHover ? 5 : 3;

            ctx.save();
            if (hoverIdx !== null && !isHover) ctx.globalAlpha = 0.75;

            ctx.beginPath();
            ctx.arc(x, y, r, 0, Math.PI * 2);
            ctx.fill();

            if (isHover) {
                ctx.lineWidth = 2;
                ctx.strokeStyle = colors.hoverPointStroke;
                ctx.stroke();
            }

            ctx.restore();
        });
    }


    function setupPlantProductionChartInteractivity(canvas, years, values) {
        if (!canvas) return;

        // Only enable hover interactions on devices that actually support hover
        if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        const wrap = canvas.parentElement;
        if (!wrap) return;

        let tooltip = document.getElementById('plantProductionTooltip') || wrap.querySelector('.detail-chart-tooltip');
        if (!tooltip) {
            tooltip = document.createElement('div');
            tooltip.className = 'detail-chart-tooltip';
            wrap.appendChild(tooltip);
        }

        canvas._productionChartData = { years: years || [], values: values || [] };

        if (canvas._productionChartInteractiveAttached) return;
        canvas._productionChartInteractiveAttached = true;

        let rafPending = false;
        let lastEvt = null;

        function formatTWh(v) {
            if (!Number.isFinite(v)) return '—';
            const digits = v >= 10 ? 1 : (v >= 1 ? 2 : 3);
            return new Intl.NumberFormat('en-GB', { maximumFractionDigits: digits }).format(v);
        }

        function getLayout(dataYears, dataValues) {
            const rect = canvas.getBoundingClientRect();
            const containerWidth = rect.width || (wrap.getBoundingClientRect().width || 600);
            const width = Math.max(280, Math.floor(containerWidth));
            const height = (rect.height || 260);

            const margin = { left: 48, right: 14, top: 12, bottom: 30 };
            const plotW = width - margin.left - margin.right;
            const plotH = height - margin.top - margin.bottom;

            const minY = Math.min(...dataValues);
            const maxY = Math.max(...dataValues);
            const pad = (maxY - minY) === 0 ? 1 : (maxY - minY) * 0.08;
            const y0 = Math.max(0, minY - pad);
            const y1 = maxY + pad;

            const xAt = (i) => margin.left + (dataYears.length === 1 ? 0 : (i / (dataYears.length - 1)) * plotW);
            const yAt = (v) => margin.top + (1 - (v - y0) / (y1 - y0)) * plotH;

            return { rect, margin, plotW, plotH, xAt, yAt };
        }

        function hideTooltip() {
            tooltip.style.display = 'none';
        }

        function showTooltip(px, py, year, value) {
            tooltip.innerHTML = '<strong>' + escapeHtml(String(year)) + '</strong>' + ' • ' + escapeHtml(formatTWh(value)) + ' TWh';
            tooltip.style.display = 'block';

            // Position (keep inside chart wrap)
            const wrapRect = wrap.getBoundingClientRect();
            const tipRect = tooltip.getBoundingClientRect();

            let left = px + 12;
            let top = py - 12;

            const maxLeft = wrapRect.width - tipRect.width - 6;
            const maxTop = wrapRect.height - tipRect.height - 6;

            left = Math.max(6, Math.min(left, maxLeft));
            top = Math.max(6, Math.min(top, maxTop));

            tooltip.style.left = left + 'px';
            tooltip.style.top = top + 'px';
        }

        function scheduleRender() {
            if (rafPending) return;
            rafPending = true;

            requestAnimationFrame(() => {
                rafPending = false;

                const data = canvas._productionChartData || { years: [], values: [] };
                const yrs = data.years || [];
                const vals = data.values || [];
                if (!yrs.length || !vals.length) return;

                const layout = getLayout(yrs, vals);
                const rect = layout.rect;

                const mx = lastEvt ? (lastEvt.clientX - rect.left) : -999;
                const my = lastEvt ? (lastEvt.clientY - rect.top) : -999;

                // If outside plot area, clear hover
                if (mx < layout.margin.left || mx > (layout.margin.left + layout.plotW) || my < layout.margin.top || my > (layout.margin.top + layout.plotH)) {
                    canvas.style.cursor = 'default';
                    hideTooltip();
                    drawLineChartOnCanvas(canvas, yrs, vals, null);
                    return;
                }

                let idx = 0;
                if (yrs.length === 1) idx = 0;
                else {
                    const t = (mx - layout.margin.left) / layout.plotW;
                    idx = Math.round(t * (yrs.length - 1));
                    idx = Math.max(0, Math.min(idx, yrs.length - 1));
                }

                const px = layout.xAt(idx);
                const py = layout.yAt(vals[idx]);

                // v5.7.70: Show tooltip for any position within the plot area (matches country chart behavior)
                canvas.style.cursor = 'pointer';
                showTooltip(px, py, yrs[idx], vals[idx]);
                drawLineChartOnCanvas(canvas, yrs, vals, idx);
            });
        }

        canvas.addEventListener('pointermove', (ev) => {
            lastEvt = ev;
            scheduleRender();
        });

        canvas.addEventListener('pointerleave', () => {
            lastEvt = null;
            canvas.style.cursor = 'default';
            hideTooltip();
            const data = canvas._productionChartData || { years: [], values: [] };
            if (data.years && data.years.length) drawLineChartOnCanvas(canvas, data.years, data.values, null);
        });
    }

    

    // --- Plant detail: Recent news (WNN links + headlines) ---
    function getPlantRecentNewsItems(plant) {
        if (!plant || !plant.reactors || !Array.isArray(plant.reactors)) return [];

        // Prefer using the first reactor row that has any WNN/headline data (keeps WNN 1-3 ordering)
        for (let i = 0; i < plant.reactors.length; i++) {
            const r = plant.reactors[i];
            if (!r || !Array.isArray(r.wnnItems) || r.wnnItems.length === 0) continue;

            const cleaned = r.wnnItems
                .map(it => ({
                    url: it && it.url ? String(it.url).trim() : '',
                    headline: it && it.headline ? String(it.headline).trim() : ''
                }))
                .filter(it => (it.url && it.url !== '0') || (it.headline && it.headline !== '0'));

            if (cleaned.length) return cleaned.slice(0, 3);
        }

        // Fallback: aggregate across reactors, de-duplicate, then take up to 3
        const out = [];
        const seen = new Set();

        plant.reactors.forEach(r => {
            if (!r || !Array.isArray(r.wnnItems)) return;
            r.wnnItems.forEach(it => {
                const url = it && it.url ? String(it.url).trim() : '';
                const headline = it && it.headline ? String(it.headline).trim() : '';
                if ((!url || url === '0') && (!headline || headline === '0')) return;

                const key = (url && url !== '0') ? url : headline;
                if (seen.has(key)) return;
                seen.add(key);

                out.push({ url, headline });
            });
        });

        return out.slice(0, 3);
    }

    
    function cleanWnnHeadline(headline) {
        if (!headline) return '';
        return String(headline).replace(/\s*\(World Nuclear News\)\s*$/i, '').trim();
    }

function renderPlantRecentNews(plant) {
        if (!plantRecentNewsList || !plantRecentNewsEmpty) return;

        plantRecentNewsList.innerHTML = '';

        const items = getPlantRecentNewsItems(plant);

        if (!items || items.length === 0) {
            plantRecentNewsList.style.display = 'none';
            plantRecentNewsEmpty.style.display = 'block';
            return;
        }

        plantRecentNewsEmpty.style.display = 'none';
        plantRecentNewsList.style.display = 'flex';

        items.forEach(it => {
            const url = it && it.url ? String(it.url).trim() : '';
            const headline = it && it.headline ? String(it.headline).trim() : '';
            const displayHeadline = cleanWnnHeadline(headline);
            const label = displayHeadline || url || '';

            if (!label) return;

            const li = document.createElement('li');
            li.className = 'recent-news-item';

            const title = document.createElement('div');
            title.className = 'recent-news-title';
            title.textContent = label;
            li.appendChild(title);

            // Link-out button (matches Reactor Database link button styling)
            const safeNewsUrl = sanitizeUrl(url);
            if (safeNewsUrl) {
                const a = document.createElement('a');
                a.className = 'plant-detail-reactor-linkout recent-news-linkout';
                a.href = safeNewsUrl;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                a.setAttribute('aria-label', 'Open World Nuclear News story');
                a.title = 'Open World Nuclear News story';
                a.innerHTML = `
                        <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24">
                            <path d="M14 3h7v7"></path>
                            <path d="M10 14L21 3"></path>
                            <path d="M21 14v7h-7"></path>
                            <path d="M3 10v11h11"></path>
                        </svg>`;
                li.appendChild(a);
            }

            plantRecentNewsList.appendChild(li);
        });

        // If all items were blank, show empty state
        if (!plantRecentNewsList.children.length) {
            plantRecentNewsList.style.display = 'none';
            plantRecentNewsEmpty.style.display = 'block';
        }
    }

function renderPlantReactorTimeline(plant) {
        if (!plantReactorTimeline || !plantTimelineEmpty) return;

        // Get references to subtitle and chart wrapper for visibility control
        const plantTimelineSubtitle = document.getElementById('plantTimelineSubtitle');
        const plantTimelineWrap = plantReactorTimeline.closest('div[style*="position"]');

        if (!plant || !plant.reactors || plant.reactors.length === 0) {
            plantReactorTimeline.innerHTML = '';
            plantTimelineEmpty.textContent = 'No reactor timeline data available for this plant.';
            plantTimelineEmpty.style.display = 'block';
            if (plantTimelineSubtitle) plantTimelineSubtitle.style.display = 'none';
            if (plantTimelineWrap) plantTimelineWrap.style.display = 'none';
            return;
        }

        // Filter reactors to only show those that existed by the selected year
        const cutoffYear = currentSelectedYear;
        const reactorsForYear = plant.reactors.filter(r => {
            // Include reactor if construction had started by the cutoff year
            return r.constructionStart && r.constructionStart <= cutoffYear;
        });

        if (reactorsForYear.length === 0) {
            plantReactorTimeline.innerHTML = '';
            plantTimelineEmpty.textContent = 'No reactor timeline data available for this period.';
            plantTimelineEmpty.style.display = 'block';
            if (plantTimelineSubtitle) plantTimelineSubtitle.style.display = 'none';
            if (plantTimelineWrap) plantTimelineWrap.style.display = 'none';
            return;
        }

        // Has data - show chart wrapper, subtitle, hide empty message
        plantTimelineEmpty.style.display = 'none';
        if (plantTimelineSubtitle) plantTimelineSubtitle.style.display = '';
        if (plantTimelineWrap) plantTimelineWrap.style.display = '';

        const reactors = reactorsForYear.slice().sort((a, b) => {
            const ag = a.gridConnection || 9999;
            const bg = b.gridConnection || 9999;
            if (ag !== bg) return ag - bg;
            return String(a.name || '').localeCompare(String(b.name || ''));
        });

        const yearsAll = [];
        reactors.forEach(r => {
            if (r.constructionStart) yearsAll.push(r.constructionStart);
            if (r.gridConnection && r.gridConnection <= cutoffYear) yearsAll.push(r.gridConnection);
            if (r.shutdownDate && r.shutdownDate <= cutoffYear) yearsAll.push(r.shutdownDate);
        });

        const minYear = yearsAll.length ? Math.min(...yearsAll) : MIN_YEAR;
        const maxYearData = yearsAll.length ? Math.max(...yearsAll) : cutoffYear;
        // Cap the timeline at the selected year (don't show future)
        const maxYear = Math.min(Math.max(maxYearData, cutoffYear), cutoffYear + 2);

        const pad = 2;
        const xMin = Math.max(1900, minYear - pad);
        const xMax = Math.min(2100, maxYear + pad);

        // Layout (no left-side labels; reactor names appear on hover via SVG <title>)
        const containerWidth = plantReactorTimeline.getBoundingClientRect().width || 600;
        const labelW = 0;
        const rowH = 28;
        const topPad = 38;
        const leftPad = 10;
        const rightPad = 14;
        const width = Math.max(280, Math.floor(containerWidth));
        const plotW = width - labelW - leftPad - rightPad;
        const height = topPad + reactors.length * rowH + 24;

        const yearToX = (y) => leftPad + labelW + ((y - xMin) / (xMax - xMin)) * plotW;

        // Axis ticks — v5.7.181: finer labels for small ranges + vertical gridlines
        const range = xMax - xMin;
        const step = range <= 10 ? 1 : range <= 20 ? 2 : range <= 40 ? 5 : 10;
        const firstTick = Math.ceil(xMin / step) * step;

        const COLOR_OPERATING = '#00b894';
        const COLOR_CONSTRUCTION = '#fdcb6e';
        const COLOR_UNKNOWN = '#b2bec3';
        const COLOR_CURRENT_YEAR = '#5777a9';

        let svg = `<svg width="100%" height="${height}" viewBox="0 0 ${width} ${height}" role="img" aria-label="Reactor timeline">`;

        // Title axis line
        svg += `<line x1="${leftPad + labelW}" y1="${topPad - 10}" x2="${leftPad + labelW + plotW}" y2="${topPad - 10}"
                stroke="#e9ecef" stroke-width="2" />`;

        for (let y = firstTick; y <= xMax; y += step) {
            const x = yearToX(y);
            svg += `<line x1="${x}" y1="${topPad - 10}" x2="${x}" y2="${topPad + reactors.length * rowH}" stroke="#f0f2f5" stroke-width="1" />`;
            svg += `<line x1="${x}" y1="${topPad - 14}" x2="${x}" y2="${topPad - 6}" stroke="#dfe6e9" stroke-width="2" />`;
            svg += `<text x="${x}" y="${topPad - 18}" text-anchor="middle" font-family="Muli, sans-serif" font-size="11" font-weight="800" fill="#8898aa">${y}</text>`;
        }

        // Current year indicator line (if not at present)
        if (cutoffYear < MAX_YEAR && cutoffYear >= xMin && cutoffYear <= xMax) {
            const currentX = yearToX(cutoffYear);
            svg += `<line x1="${currentX}" y1="${topPad - 10}" x2="${currentX}" y2="${topPad + reactors.length * rowH + 10}" 
                    stroke="${COLOR_CURRENT_YEAR}" stroke-width="2" stroke-dasharray="4,3" opacity="0.8" />`;
            svg += `<text x="${currentX}" y="${topPad + reactors.length * rowH + 20}" text-anchor="middle" 
                    font-family="Muli, sans-serif" font-size="10" font-weight="700" fill="${COLOR_CURRENT_YEAR}">${cutoffYear}</text>`;
        }

        // Rows
        reactors.forEach((r, i) => {
            const y = topPad + i * rowH + 6;
            const name = escapeHtmlAttr(r.displayName || r.name || 'Reactor');

            const cStart = r.constructionStart || null;
            // Cap grid connection and shutdown at the cutoff year for display
            const gYear = (r.gridConnection && r.gridConnection <= cutoffYear) ? r.gridConnection : null;
            const hasShutdown = r.shutdownDate && r.shutdownDate <= cutoffYear;
            const endYear = hasShutdown ? r.shutdownDate : (gYear ? cutoffYear : (cStart ? cutoffYear : cutoffYear));
            const shutdownYear = hasShutdown ? r.shutdownDate : null;
            
            // Formatted dates for display
            const cStartFormatted = r.constructionStartFormatted || (cStart ? String(cStart) : '');
            const gYearFormatted = gYear ? (r.gridConnectionFormatted || String(gYear)) : '';
            const shutdownFormatted = shutdownYear ? (r.shutdownDateFormatted || String(shutdownYear)) : '';

            svg += `<g class="timeline-row" data-reactor-index="${i}">`;

            let drewAnything = false;

            // Construction segment (construction start -> grid connection, or -> present if no grid yet)
            if (cStart && (!gYear || cStart <= gYear)) {
                const x1 = yearToX(cStart);
                const x2 = yearToX(gYear ? gYear : endYear);
                
                // Create interactive group for construction segment
                svg += `<g class="timeline-segment construction-segment" 
                           data-reactor-name="${name}" 
                           data-construction-start="${escapeHtmlAttr(cStartFormatted)}" 
                           data-grid-connection="${escapeHtmlAttr(gYearFormatted)}"
                           data-segment-type="construction">`;
                svg += `<line x1="${x1}" y1="${y + 4}" x2="${x2}" y2="${y + 4}" stroke="${COLOR_CONSTRUCTION}" stroke-width="6" stroke-linecap="round" opacity="0.9" />`;
                svg += `</g>`;
                drewAnything = true;

                // Construction start marker (diamond shape)
                svg += `<polygon points="${x1},${y} ${x1 + 5},${y + 4} ${x1},${y + 8} ${x1 - 5},${y + 4}" fill="#ffffff" stroke="${COLOR_CONSTRUCTION}" stroke-width="2" />`;

                // If shutdown occurred before grid connection ever happened (and before cutoff), show shutdown marker
                if (!gYear && r.shutdownDate && r.shutdownDate <= cutoffYear) {
                    const xs = yearToX(r.shutdownDate);
                    svg += `<rect x="${xs - 4}" y="${y}" width="8" height="8" rx="2" fill="#ffffff" stroke="${COLOR_CONSTRUCTION}" stroke-width="2" />`;
                }
            }

            // Operating segment (grid connection -> shutdown/cutoff year)
            if (gYear) {
                const x1 = yearToX(gYear);
                const x2 = yearToX(endYear);

                // Create interactive group for operating segment
                svg += `<g class="timeline-segment operable-segment" 
                           data-reactor-name="${name}" 
                           data-grid-connection="${escapeHtmlAttr(gYearFormatted)}" 
                           data-shutdown="${escapeHtmlAttr(shutdownFormatted)}"
                           data-segment-type="operable">`;
                svg += `<line x1="${x1}" y1="${y + 4}" x2="${x2}" y2="${y + 4}" stroke="${COLOR_OPERATING}" stroke-width="6" stroke-linecap="round" opacity="0.9" />`;
                svg += `</g>`;
                drewAnything = true;

                // Grid marker
                svg += `<circle cx="${x1}" cy="${y + 4}" r="4" fill="#ffffff" stroke="${COLOR_OPERATING}" stroke-width="2" />`;

                // Shutdown marker (only if shutdownDate exists and is within cutoff)
                if (r.shutdownDate && r.shutdownDate <= cutoffYear) {
                    const xs = yearToX(r.shutdownDate);
                    svg += `<rect x="${xs - 4}" y="${y}" width="8" height="8" rx="2" fill="#ffffff" stroke="${COLOR_OPERATING}" stroke-width="2" />`;
                }
            }

            if (!drewAnything) {
                // No timeline data for this reactor
                svg += `<line x1="${leftPad + labelW}" y1="${y + 4}" x2="${leftPad + labelW + 22}" y2="${y + 4}" stroke="${COLOR_UNKNOWN}" stroke-width="4" stroke-linecap="round" opacity="0.6" />`;
            }

            svg += `</g>`;
        });

        svg += `</svg>`;

        // Build legend - include current year indicator if viewing historical data
        let legendItems = `
            <div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;transform:rotate(45deg);background:#ffffff;border:2px solid ${COLOR_CONSTRUCTION};"></span>Construction start</div>
            <div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#ffffff;border:2px solid ${COLOR_OPERATING};"></span>Grid connection</div>
            <div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;border-radius:3px;background:#ffffff;border:2px solid ${COLOR_OPERATING};"></span>Shutdown</div>
        `;
        
        if (cutoffYear < MAX_YEAR) {
            legendItems += `<div class="timeline-legend-item"><span style="display:inline-block;width:2px;height:12px;background:${COLOR_CURRENT_YEAR};border:none;"></span>Viewing: ${cutoffYear}</div>`;
        }

        const legend = `<div class="timeline-legend" aria-label="Timeline legend">${legendItems}</div>`;

        // Create tooltip element
        const tooltipHtml = `<div class="timeline-tooltip" id="timelineTooltip"></div>`;

        // No text list under the chart (the chart itself is the information)
        plantReactorTimeline.innerHTML = svg + legend + tooltipHtml;

        // Setup interactivity for timeline segments
        setupTimelineInteractivity(plantReactorTimeline);
    }

    function setupTimelineInteractivity(container) {
        if (!container) return;

        // Only enable hover interactions on devices that actually support hover
        if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        const tooltip = container.querySelector('#timelineTooltip');
        if (!tooltip) return;

        const segments = container.querySelectorAll('.timeline-segment');
        if (!segments.length) return;

        function showTooltip(segment, event) {
            const segmentType = segment.getAttribute('data-segment-type');
            const reactorName = escapeHtml(segment.getAttribute('data-reactor-name'));
            
            let tooltipContent = `<div class="tooltip-reactor-name">${reactorName}</div>`;
            
            if (segmentType === 'construction') {
                const constructionStart = escapeHtml(segment.getAttribute('data-construction-start'));
                const gridConnection = escapeHtml(segment.getAttribute('data-grid-connection'));

                tooltipContent += `<div class="tooltip-row"><span class="tooltip-label">Construction start</span><span class="tooltip-value">${constructionStart}</span></div>`;
                tooltipContent += `<div class="tooltip-row"><span class="tooltip-label">Grid connection</span><span class="tooltip-value">${gridConnection || '—'}</span></div>`;

                // v5.7.181: Calculate and display construction time in months
                const _rawCS = segment.getAttribute('data-construction-start') || '';
                const _rawGC = segment.getAttribute('data-grid-connection') || '';
                const _parseMY = function(s) {
                    if (!s || s === '—' || s === '\u2014') return null;
                    const p = s.split('/');
                    if (p.length === 2) return { m: parseInt(p[0], 10), y: parseInt(p[1], 10) };
                    const yr = parseInt(s, 10);
                    return (yr > 1900 && yr < 2100) ? { m: 1, y: yr } : null;
                };
                const _cStart = _parseMY(_rawCS);
                if (_cStart) {
                    const _cEnd = _parseMY(_rawGC);
                    let _months, _ongoing = false;
                    if (_cEnd) {
                        _months = (_cEnd.y - _cStart.y) * 12 + (_cEnd.m - _cStart.m);
                    } else {
                        const _now = new Date();
                        _months = (_now.getFullYear() - _cStart.y) * 12 + ((_now.getMonth() + 1) - _cStart.m);
                        _ongoing = true;
                    }
                    if (_months >= 0) {
                        const _mLabel = _months + ' month' + (_months !== 1 ? 's' : '') + (_ongoing ? ' (ongoing)' : '');
                        tooltipContent += `<div class="tooltip-row"><span class="tooltip-label">Construction time</span><span class="tooltip-value">${_mLabel}</span></div>`;
                    }
                }

                tooltip.className = 'timeline-tooltip construction';
            } else if (segmentType === 'operable') {
                const gridConnection = escapeHtml(segment.getAttribute('data-grid-connection'));
                const shutdown = escapeHtml(segment.getAttribute('data-shutdown'));
                
                tooltipContent += `<div class="tooltip-row"><span class="tooltip-label">Grid connection</span><span class="tooltip-value">${gridConnection}</span></div>`;
                tooltipContent += `<div class="tooltip-row"><span class="tooltip-label">Shutdown</span><span class="tooltip-value">${shutdown || '—'}</span></div>`;
                
                tooltip.className = 'timeline-tooltip operable';
            }
            
            tooltip.innerHTML = tooltipContent;
            tooltip.style.display = 'block';
            
            // Position tooltip near the mouse
            const containerRect = container.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            
            let left = event.clientX - containerRect.left + 12;
            let top = event.clientY - containerRect.top - tooltipRect.height - 8;
            
            // Keep tooltip inside container bounds
            const maxLeft = containerRect.width - tooltipRect.width - 10;
            const maxTop = containerRect.height - tooltipRect.height - 10;
            
            if (left > maxLeft) left = event.clientX - containerRect.left - tooltipRect.width - 12;
            if (top < 10) top = event.clientY - containerRect.top + 16;
            
            left = Math.max(10, Math.min(left, maxLeft));
            top = Math.max(10, Math.min(top, maxTop));
            
            tooltip.style.left = left + 'px';
            tooltip.style.top = top + 'px';

            // Dim other segments
            segments.forEach(s => {
                if (s !== segment) {
                    s.classList.add('dimmed');
                }
            });
        }

        function hideTooltip() {
            tooltip.style.display = 'none';
            
            // Remove dimming from all segments
            segments.forEach(s => {
                s.classList.remove('dimmed');
            });
        }

        function updateTooltipPosition(event) {
            if (tooltip.style.display !== 'block') return;
            
            const containerRect = container.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            
            let left = event.clientX - containerRect.left + 12;
            let top = event.clientY - containerRect.top - tooltipRect.height - 8;
            
            const maxLeft = containerRect.width - tooltipRect.width - 10;
            const maxTop = containerRect.height - tooltipRect.height - 10;
            
            if (left > maxLeft) left = event.clientX - containerRect.left - tooltipRect.width - 12;
            if (top < 10) top = event.clientY - containerRect.top + 16;
            
            left = Math.max(10, Math.min(left, maxLeft));
            top = Math.max(10, Math.min(top, maxTop));
            
            tooltip.style.left = left + 'px';
            tooltip.style.top = top + 'px';
        }

        segments.forEach(segment => {
            segment.addEventListener('mouseenter', (e) => {
                showTooltip(segment, e);
            });

            segment.addEventListener('mousemove', (e) => {
                updateTooltipPosition(e);
            });

            segment.addEventListener('mouseleave', () => {
                hideTooltip();
            });
        });

        // Also hide tooltip when leaving the container entirely
        container.addEventListener('mouseleave', () => {
            hideTooltip();
        });
    }

    // --- Country Charts (for fullscreen view) ---
    let countryProductionMode = 'annual'; // 'annual' or 'cumulative'
    let countryProductionData = null;
    
    function getCountryProductionSeries(stats, maxDisplayYear) {
        if (!stats || !stats.plants) return { years: [], values: [] };
        
        // Use provided max year or fall back to currentSelectedYear
        const cutoffYear = maxDisplayYear !== undefined ? maxDisplayYear : currentSelectedYear;
        
        const totals = {};
        stats.plants.forEach(plant => {
            if (!plant.reactors) return;
            plant.reactors.forEach(reactor => {
                if (reactor.productionByYear) {
                    Object.entries(reactor.productionByYear).forEach(([year, val]) => {
                        const y = parseInt(year, 10);
                        // Only include years up to the cutoff year
                        if (Number.isFinite(y) && Number.isFinite(val) && y <= cutoffYear) {
                            totals[y] = (totals[y] || 0) + val;
                        }
                    });
                }
            });
        });
        
        const years = Object.keys(totals).map(y => parseInt(y, 10)).sort((a, b) => a - b);
        const values = years.map(y => totals[y]);
        return { years, values };
    }

    function renderCountryProductionChart(stats) {
        if (!countryProductionChart || !countryProductionEmpty) return;
        countryProductionData = stats;

        const series = getCountryProductionSeries(stats);
        const hasSeries = series.years && series.years.length >= 2 && series.values.some(v => Number.isFinite(v) && v !== 0);

        // Get references to subtitle, toggle, and chart wrapper for visibility control
        const countryProductionSubtitle = document.getElementById('countryProductionSubtitle');
        const countryProductionToggle = document.getElementById('countryProductionToggle');
        const countryChartWrap = countryProductionChart ? countryProductionChart.closest('.detail-chart-wrap') : null;

        if (!hasSeries) {
            countryProductionChart.style.display = 'none';
            countryProductionEmpty.style.display = 'block';
            // Hide subtitle, toggle, and chart wrapper when no production data (v5.7.160)
            if (countryProductionSubtitle) countryProductionSubtitle.style.display = 'none';
            if (countryProductionToggle) countryProductionToggle.style.display = 'none';
            if (countryChartWrap) countryChartWrap.style.display = 'none';
            return;
        }

        countryProductionEmpty.style.display = 'none';
        countryProductionChart.style.display = 'block';
        // Show subtitle, toggle, and chart wrapper when production data exists (v5.7.160)
        if (countryProductionSubtitle) countryProductionSubtitle.style.display = '';
        if (countryProductionToggle) countryProductionToggle.style.display = '';
        if (countryChartWrap) countryChartWrap.style.display = '';

        // Convert GWh -> TWh
        let valuesTWh = series.values.map(v => v / 1000);
        
        // Calculate cumulative if needed
        if (countryProductionMode === 'cumulative') {
            let cumulative = 0;
            valuesTWh = valuesTWh.map(v => {
                cumulative += v;
                return cumulative;
            });
        }
        
        // Update subtitle
        const subtitle = document.getElementById('countryProductionSubtitle');
        if (subtitle) {
            subtitle.textContent = countryProductionMode === 'annual'
                ? 'Annual (TWh)'
                : 'Cumulative (TWh)';
        }

        drawLineChartOnCanvas(countryProductionChart, series.years, valuesTWh, null);
        setupCountryProductionChartInteractivity(countryProductionChart, series.years, valuesTWh);
        setupCountryProductionToggle();
    }
    
    function setupCountryProductionToggle() {
        const toggle = document.getElementById('countryProductionToggle');
        if (!toggle) return;
        
        const btns = toggle.querySelectorAll('.production-toggle-btn');
        btns.forEach(btn => {
            // Update active state
            btn.classList.toggle('active', btn.dataset.mode === countryProductionMode);
            
            // Remove old listeners by cloning
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
            
            newBtn.addEventListener('click', () => {
                if (newBtn.dataset.mode === countryProductionMode) return;
                countryProductionMode = newBtn.dataset.mode;
                if (countryProductionData) {
                    renderCountryProductionChart(countryProductionData);
                }
            });
        });
    }

    function setupCountryProductionChartInteractivity(canvas, years, values) {
        if (!canvas || !countryProductionTooltip) return;

        const wrap = canvas.parentElement;
        if (!wrap) return;

        // Store data on the canvas so it can be read dynamically
        canvas._countryProductionData = { years: years || [], values: values || [] };

        // Only attach listeners once
        if (canvas._countryProductionInteractiveAttached) return;
        canvas._countryProductionInteractiveAttached = true;

        const margin = { left: 48, right: 14, top: 12, bottom: 30 };

        function getHoverIndex(e, dataYears) {
            const rect = canvas.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const plotW = rect.width - margin.left - margin.right;
            const relX = x - margin.left;
            if (relX < 0 || relX > plotW) return null;
            const idx = Math.round((relX / plotW) * (dataYears.length - 1));
            return Math.max(0, Math.min(idx, dataYears.length - 1));
        }

        canvas.addEventListener('mousemove', (e) => {
            const data = canvas._countryProductionData || { years: [], values: [] };
            const yrs = data.years;
            const vals = data.values;
            if (!yrs.length || !vals.length) return;

            const idx = getHoverIndex(e, yrs);
            if (idx === null || !Number.isFinite(vals[idx])) {
                countryProductionTooltip.style.display = 'none';
                drawLineChartOnCanvas(canvas, yrs, vals, null);
                return;
            }
            drawLineChartOnCanvas(canvas, yrs, vals, idx);
            countryProductionTooltip.innerHTML = `<strong>${yrs[idx]}</strong><br>${vals[idx].toFixed(2)} TWh`;
            countryProductionTooltip.style.display = 'block';
            
            const rect = canvas.getBoundingClientRect();
            const plotW = rect.width - margin.left - margin.right;
            const xAt = margin.left + (idx / (yrs.length - 1)) * plotW;
            countryProductionTooltip.style.left = (xAt - countryProductionTooltip.offsetWidth / 2) + 'px';
            countryProductionTooltip.style.top = '-36px';
        });

        canvas.addEventListener('mouseleave', () => {
            const data = canvas._countryProductionData || { years: [], values: [] };
            countryProductionTooltip.style.display = 'none';
            drawLineChartOnCanvas(canvas, data.years, data.values, null);
        });
    }

    // Reactor Deployment Chart - diverging bar chart (connections up, shutdowns down)
    let currentDeployMode = 'units'; // 'units' or 'capacity'
    let currentDeployStats = null;

    function renderCountryReactorDeploy(stats) {
        if (!countryReactorDeploy) return;
        currentDeployStats = stats;

        // Get reference to deploy toggle for visibility control (v5.7.160)
        const deployToggle = document.getElementById('countryDeployToggle');

        if (!stats || !stats.plants || stats.plants.length === 0) {
            countryReactorDeploy.innerHTML = '';
            if (countryDeployEmpty) { countryDeployEmpty.textContent = 'Reactor deployment data is not available yet for this country.'; countryDeployEmpty.style.display = 'block'; }
            if (deployToggle) deployToggle.style.display = 'none';
            if (countryDeployChartWrap) countryDeployChartWrap.style.display = 'none';
            return;
        }

        // Use the current selected year as the cutoff
        const cutoffYear = currentSelectedYear;

        // Gather all reactors and organize by year (filtered by cutoff)
        const connectionsByYear = {};
        const shutdownsByYear = {};

        stats.plants.forEach(plant => {
            if (!plant.reactors) return;
            plant.reactors.forEach(reactor => {
                const gridYear = reactor.gridConnection;
                const shutdownYear = reactor.shutdownDate;
                const capacity = reactor.capacity || 0;
                const name = reactor.displayName || reactor.name || 'Unknown';
                const plantName = plant.name;

                // Only include grid connections up to the cutoff year
                if (gridYear && gridYear <= cutoffYear) {
                    if (!connectionsByYear[gridYear]) connectionsByYear[gridYear] = [];
                    connectionsByYear[gridYear].push({ name, plantName, capacity, year: gridYear });
                }

                // Only include shutdowns up to the cutoff year
                if (shutdownYear && shutdownYear <= cutoffYear) {
                    if (!shutdownsByYear[shutdownYear]) shutdownsByYear[shutdownYear] = [];
                    shutdownsByYear[shutdownYear].push({ name, plantName, capacity, year: shutdownYear });
                }
            });
        });

        // Find year range (capped at cutoff year)
        const allYears = [...Object.keys(connectionsByYear), ...Object.keys(shutdownsByYear)].map(Number);
        if (allYears.length === 0) {
            countryReactorDeploy.innerHTML = '';
            if (countryDeployEmpty) { countryDeployEmpty.textContent = 'No reactor deployment data available for this period.'; countryDeployEmpty.style.display = 'block'; }
            if (deployToggle) deployToggle.style.display = 'none';
            if (countryDeployChartWrap) countryDeployChartWrap.style.display = 'none';
            return;
        }

        // Show toggle and chart wrapper when data exists (v5.7.160)
        if (countryDeployEmpty) countryDeployEmpty.style.display = 'none';
        if (deployToggle) deployToggle.style.display = '';
        if (countryDeployChartWrap) countryDeployChartWrap.style.display = '';

        const minYear = Math.min(...allYears);
        const maxYear = Math.min(Math.max(...allYears), cutoffYear);

        // Build the chart
        renderDeployChart(connectionsByYear, shutdownsByYear, minYear, maxYear);
    }

    function renderDeployChart(connectionsByYear, shutdownsByYear, minYear, maxYear, targetContainer, deployMode) {
        const container = targetContainer || countryReactorDeploy; // v5.7.126: accept optional target
        const effectiveDeployMode = deployMode || currentDeployMode; // v5.7.126: accept optional mode
        const containerWidth = (container.getBoundingClientRect().width || 440) - 24; // Account for container padding
        
        // Calculate values based on mode
        const getYearValue = (reactors) => {
            if (!reactors) return 0;
            if (effectiveDeployMode === 'units') return reactors.length;
            return reactors.reduce((sum, r) => sum + (r.capacity || 0), 0) / 1000; // GW
        };

        // Find max values
        let maxConnection = 0;
        let maxShutdown = 0;
        
        for (let year = minYear; year <= maxYear; year++) {
            const connVal = getYearValue(connectionsByYear[year]);
            const shutVal = getYearValue(shutdownsByYear[year]);
            if (connVal > maxConnection) maxConnection = connVal;
            if (shutVal > maxShutdown) maxShutdown = shutVal;
        }

        const maxValue = Math.max(maxConnection, maxShutdown, 1);
        
        // Chart dimensions - increased padding for labels
        const chartHeight = 200;
        const paddingLeft = 45;
        const paddingRight = 15;
        const paddingTop = 20;
        const paddingBottom = 28;
        const chartWidth = containerWidth - paddingLeft - paddingRight;
        const plotHeight = chartHeight - paddingTop - paddingBottom;
        const zeroY = paddingTop + plotHeight / 2;

        const yearCount = maxYear - minYear + 1;
        const barWidth = Math.max(3, Math.min(12, (chartWidth / yearCount) - 2));
        const barGap = (chartWidth - barWidth * yearCount) / (yearCount + 1);

        // Calculate positions
        const yearToX = (year) => paddingLeft + barGap + (year - minYear) * (barWidth + barGap);
        const valueToHeight = (val) => (val / maxValue) * (plotHeight / 2 - 5);

        // Build SVG
        let svg = `<svg class="reactor-deploy-svg" viewBox="0 0 ${containerWidth} ${chartHeight}">`;
        
        // Grid lines
        const gridSteps = 4;
        for (let i = 0; i <= gridSteps; i++) {
            const y = paddingTop + (i / gridSteps) * plotHeight;
            svg += `<line x1="${paddingLeft}" y1="${y}" x2="${containerWidth - paddingRight}" y2="${y}" class="reactor-deploy-grid-line" />`;
        }

        // Zero line (thicker)
        svg += `<line x1="${paddingLeft}" y1="${zeroY}" x2="${containerWidth - paddingRight}" y2="${zeroY}" class="reactor-deploy-zero-line" />`;

        // Y-axis labels
        const yLabelUnit = effectiveDeployMode === 'units' ? '' : ' GW';
        const topVal = Math.ceil(maxValue);
        svg += `<text x="${paddingLeft - 8}" y="${paddingTop + 4}" class="reactor-deploy-axis-label" text-anchor="end">${topVal}${yLabelUnit}</text>`;
        svg += `<text x="${paddingLeft - 8}" y="${zeroY + 4}" class="reactor-deploy-axis-label" text-anchor="end">0</text>`;
        svg += `<text x="${paddingLeft - 8}" y="${paddingTop + plotHeight + 4}" class="reactor-deploy-axis-label" text-anchor="end">-${topVal}${yLabelUnit}</text>`;

        // Bars and x-axis labels
        const labelInterval = yearCount > 40 ? 10 : yearCount > 20 ? 5 : yearCount > 10 ? 2 : 1;
        
        for (let year = minYear; year <= maxYear; year++) {
            const x = yearToX(year);
            const connVal = getYearValue(connectionsByYear[year]);
            const shutVal = getYearValue(shutdownsByYear[year]);
            
            // Connection bar (goes up)
            if (connVal > 0) {
                const barHeight = valueToHeight(connVal);
                svg += `<rect class="reactor-deploy-bar connections" 
                              x="${x}" y="${zeroY - barHeight}" 
                              width="${barWidth}" height="${barHeight}" 
                              rx="2" fill="#00b894"
                              data-year="${year}" data-type="connections" />`;
            }
            
            // Shutdown bar (goes down)
            if (shutVal > 0) {
                const barHeight = valueToHeight(shutVal);
                svg += `<rect class="reactor-deploy-bar shutdowns" 
                              x="${x}" y="${zeroY}" 
                              width="${barWidth}" height="${barHeight}" 
                              rx="2" fill="#636e72"
                              data-year="${year}" data-type="shutdowns" />`;
            }

            // X-axis labels
            if ((year - minYear) % labelInterval === 0 || year === maxYear) {
                svg += `<text x="${x + barWidth/2}" y="${chartHeight - 5}" class="reactor-deploy-axis-label" text-anchor="middle">${year}</text>`;
            }
        }

        svg += '</svg>';

        // Build full HTML
        let html = `
            <div class="reactor-deploy-header">
                <div class="reactor-deploy-legend">
                    <div class="reactor-deploy-legend-item">
                        <div class="reactor-deploy-legend-dot connections"></div>
                        <span>Grid connections</span>
                    </div>
                    <div class="reactor-deploy-legend-item">
                        <div class="reactor-deploy-legend-dot shutdowns"></div>
                        <span>Permanent shutdowns</span>
                    </div>
                </div>
            </div>
            <div class="reactor-deploy-container">
                ${svg}
                <div class="reactor-deploy-tooltip" id="deployTooltip"></div>
            </div>
        `;

        container.innerHTML = html;

        // Setup interactivity
        setupDeployChartInteractivity(container, connectionsByYear, shutdownsByYear, minYear, maxYear);
    }

    function setupDeployChartInteractivity(container, connectionsByYear, shutdownsByYear, minYear, maxYear) {
        var bars = container.querySelectorAll('.reactor-deploy-bar');

        // Sync static toggle active state and wire click handlers
        var staticToggle = document.getElementById('countryDeployToggle');
        if (staticToggle) {
            var toggleBtns = staticToggle.querySelectorAll('.reactor-deploy-toggle-btn');
            toggleBtns.forEach(function(btn) {
                btn.classList.toggle('active', btn.dataset.mode === currentDeployMode);
                btn.onclick = function() {
                    var mode = btn.dataset.mode;
                    if (mode === currentDeployMode) return;
                    currentDeployMode = mode;
                    if (currentDeployStats) {
                        renderCountryReactorDeploy(currentDeployStats);
                    }
                };
            });
        }

        // Build detailed tooltip HTML matching global sidebar chart format
        function buildDeployTooltipHTML(year, showAll) {
            var connections = connectionsByYear[year] || [];
            var shutdowns = shutdownsByYear[year] || [];
            var MAX_ITEMS = showAll ? Infinity : 8;
            var h = '<div class="expanded-chart-tooltip-year">' + year + '</div>';
            h += '<div class="expanded-chart-tooltip-summary">';
            if (connections.length > 0) {
                var totalCapConn = connections.reduce(function(s, r) { return s + (r.capacity || 0); }, 0);
                var capStr = totalCapConn > 0 ? ' <small>(' + (totalCapConn / 1000).toFixed(1) + ' GW)</small>' : '';
                h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#00b894"></span><span class="expanded-chart-tooltip-label">Grid connections</span><span class="expanded-chart-tooltip-value">' + connections.length + capStr + '</span></div>';
            }
            if (shutdowns.length > 0) {
                var totalCapShut = shutdowns.reduce(function(s, r) { return s + (r.capacity || 0); }, 0);
                var capStr2 = totalCapShut > 0 ? ' <small>(' + (totalCapShut / 1000).toFixed(1) + ' GW)</small>' : '';
                h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#636e72"></span><span class="expanded-chart-tooltip-label">Shutdowns</span><span class="expanded-chart-tooltip-value">' + shutdowns.length + capStr2 + '</span></div>';
            }
            if (connections.length === 0 && shutdowns.length === 0) {
                h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#b2bec3"></span><span class="expanded-chart-tooltip-label">No events</span><span class="expanded-chart-tooltip-value">\u2014</span></div>';
            }
            h += '</div>';
            if (connections.length > 0) {
                h += '<div class="expanded-chart-tooltip-divider"></div>';
                h += '<div class="expanded-chart-tooltip-section-title">Connected to grid</div>';
                connections.slice(0, MAX_ITEMS).forEach(function(r) {
                    var detail = r.country ? escapeHtml(r.country) : escapeHtml(r.plantName || '');
                    h += '<div class="expanded-chart-tooltip-reactor" data-plant-name="' + escapeHtml(r.plantName || '') + '" data-reactor-name="' + escapeHtml(r.name) + '"><span class="expanded-chart-tooltip-reactor-name">' + escapeHtml(r.name) + '</span><span class="expanded-chart-tooltip-reactor-detail">' + detail + '</span></div>';
                });
                if (connections.length > MAX_ITEMS) h += '<div class="expanded-chart-tooltip-more">+ ' + (connections.length - MAX_ITEMS) + ' more</div>';
            }
            if (shutdowns.length > 0) {
                h += '<div class="expanded-chart-tooltip-divider"></div>';
                h += '<div class="expanded-chart-tooltip-section-title">Permanently shut down</div>';
                shutdowns.slice(0, MAX_ITEMS).forEach(function(r) {
                    var detail = r.country ? escapeHtml(r.country) : escapeHtml(r.plantName || '');
                    h += '<div class="expanded-chart-tooltip-reactor" data-plant-name="' + escapeHtml(r.plantName || '') + '" data-reactor-name="' + escapeHtml(r.name) + '"><span class="expanded-chart-tooltip-reactor-name">' + escapeHtml(r.name) + '</span><span class="expanded-chart-tooltip-reactor-detail">' + detail + '</span></div>';
                });
                if (shutdowns.length > MAX_ITEMS) h += '<div class="expanded-chart-tooltip-more">+ ' + (shutdowns.length - MAX_ITEMS) + ' more</div>';
            }
            return h;
        }

        function undimBars() { bars.forEach(function(b) { b.classList.remove('dimmed'); }); }

        // Bar hover — use floating expanded-chart tooltip
        bars.forEach(function(bar) {
            bar.addEventListener('mouseenter', function(e) {
                if (tooltipPinned) return;
                var year = parseInt(bar.dataset.year);
                expandedChartTooltipCard.innerHTML = buildDeployTooltipHTML(year);
                positionExpandedTooltip(e.clientX, e.clientY);
                bars.forEach(function(b) {
                    if (b.dataset.year !== bar.dataset.year) b.classList.add('dimmed');
                });
            });
            bar.addEventListener('mousemove', function(e) {
                if (tooltipPinned) return;
                positionExpandedTooltip(e.clientX, e.clientY);
            });
            bar.addEventListener('mouseleave', function() {
                if (tooltipPinned) return;
                hideExpandedTooltip();
                undimBars();
            });
            bar.addEventListener('click', function(e) {
                e.stopPropagation();
                var year = parseInt(bar.dataset.year);
                tooltipPinned = true;
                expandedChartTooltipCard.innerHTML = buildDeployTooltipHTML(year, true);
                expandedChartTooltip.classList.add('pinned');
                positionExpandedTooltip(e.clientX, e.clientY);
            });
        });

        // Click outside to dismiss pinned tooltip
        function onDocClick(e) {
            if (!tooltipPinned) return;
            if (expandedChartTooltip && expandedChartTooltip.contains(e.target)) return;
            if (container.contains(e.target)) return;
            hideExpandedTooltip();
            undimBars();
        }
        document.addEventListener('click', onDocClick, true);

        // Register cleanup so closing the modal or switching charts tidies up
        expandedChartHoverCleanup = function() {
            document.removeEventListener('click', onDocClick, true);
            hideExpandedTooltip();
            undimBars();
        };
    }

    // ===================================================================
    // v5.7.126: Mobile panel chart rendering functions
    // ===================================================================
    let mobilePlantProductionMode = 'annual';
    let mobileCountryProductionMode = 'annual';
    let mobileDeployMode = 'units';

    // --- Mobile Plant Production Chart ---
    function renderMobilePlantProductionChart(plant) {
        const canvas = document.getElementById('mobilePlantProductionChart');
        const emptyEl = document.getElementById('mobilePlantProductionEmpty');
        const subtitleEl = document.getElementById('mobilePlantProductionSubtitle');
        if (!canvas) return;

        const series = getPlantProductionSeries(plant);
        const hasSeries = series.years && series.years.length >= 2 && series.values.some(v => Number.isFinite(v) && v !== 0);

        const chartWrap = canvas.closest('.mobile-chart-wrap');
        const toggleEl = document.getElementById('mobilePlantProductionToggle');

        if (!hasSeries) {
            canvas.style.display = 'none';
            if (chartWrap) chartWrap.style.display = 'none';
            if (toggleEl) toggleEl.style.display = 'none';
            if (subtitleEl) subtitleEl.style.display = 'none';
            if (emptyEl) emptyEl.style.display = 'block';
            return;
        }

        canvas.style.display = 'block';
        if (chartWrap) chartWrap.style.display = '';
        if (toggleEl) toggleEl.style.display = '';
        if (subtitleEl) subtitleEl.style.display = '';
        if (emptyEl) emptyEl.style.display = 'none';

        let valuesTWh = series.values.map(v => v / 1000);
        if (mobilePlantProductionMode === 'cumulative') {
            let cum = 0;
            valuesTWh = valuesTWh.map(v => { cum += v; return cum; });
        }
        if (subtitleEl) {
            subtitleEl.textContent = mobilePlantProductionMode === 'annual' ? 'Annual (TWh)' : 'Cumulative (TWh)';
        }

        drawLineChartOnCanvas(canvas, series.years, valuesTWh, null);

        // Interactivity (touch-friendly)
        setupMobileChartInteractivity(canvas, series.years, valuesTWh, document.getElementById('mobilePlantProductionTooltip'));

        // Toggle buttons
        if (toggleEl) {
            toggleEl.querySelectorAll('.production-toggle-btn').forEach(btn => {
                btn.classList.toggle('active', btn.dataset.mode === mobilePlantProductionMode);
                const newBtn = btn.cloneNode(true);
                btn.parentNode.replaceChild(newBtn, btn);
                newBtn.addEventListener('click', () => {
                    if (newBtn.dataset.mode === mobilePlantProductionMode) return;
                    mobilePlantProductionMode = newBtn.dataset.mode;
                    renderMobilePlantProductionChart(plant);
                });
            });
        }
    }

    // --- Mobile Plant Reactor Timeline ---
    function renderMobilePlantTimeline(plant) {
        const container = document.getElementById('mobilePlantTimeline');
        if (!container) return;
        if (!plant || !plant.reactors || plant.reactors.length === 0) {
            container.innerHTML = '<div class="mobile-chart-empty">No reactor timeline data available.</div>';
            return;
        }

        const cutoffYear = currentSelectedYear;
        const reactorsForYear = plant.reactors.filter(r => r.constructionStart && r.constructionStart <= cutoffYear);
        if (reactorsForYear.length === 0) {
            container.innerHTML = '<div class="mobile-chart-empty">No reactor timeline data for this period.</div>';
            return;
        }

        const reactors = reactorsForYear.slice().sort((a, b) => {
            const ag = a.gridConnection || 9999;
            const bg = b.gridConnection || 9999;
            if (ag !== bg) return ag - bg;
            return String(a.name || '').localeCompare(String(b.name || ''));
        });

        const yearsAll = [];
        reactors.forEach(r => {
            if (r.constructionStart) yearsAll.push(r.constructionStart);
            if (r.gridConnection && r.gridConnection <= cutoffYear) yearsAll.push(r.gridConnection);
            if (r.shutdownDate && r.shutdownDate <= cutoffYear) yearsAll.push(r.shutdownDate);
        });

        const minYear = yearsAll.length ? Math.min(...yearsAll) : MIN_YEAR;
        const maxYearData = yearsAll.length ? Math.max(...yearsAll) : cutoffYear;
        const maxYear = Math.min(Math.max(maxYearData, cutoffYear), cutoffYear + 2);

        const pad = 2;
        const xMin = Math.max(1900, minYear - pad);
        const xMax = Math.min(2100, maxYear + pad);

        const containerWidth = container.getBoundingClientRect().width || 320;
        const rowH = 28;
        const topPad = 38;
        const labelW = Math.min(80, Math.floor(containerWidth * 0.22)); // v5.7.128: responsive label column
        const leftPad = labelW + 4;
        const rightPad = 14;
        const width = Math.max(280, Math.floor(containerWidth));
        const plotW = width - leftPad - rightPad;
        const height = topPad + reactors.length * rowH + 24;

        const yearToX = (y) => leftPad + ((y - xMin) / (xMax - xMin)) * plotW;

        // v5.7.181: finer labels for small ranges + vertical gridlines
        const range = xMax - xMin;
        const step = range <= 10 ? 1 : range <= 20 ? 2 : range <= 40 ? 5 : 10;
        const firstTick = Math.ceil(xMin / step) * step;

        const COLOR_OPERATING = '#00b894';
        const COLOR_CONSTRUCTION = '#fdcb6e';
        const COLOR_UNKNOWN = '#b2bec3';
        const COLOR_CURRENT_YEAR = '#5777a9';

        let svg = `<svg width="100%" height="${height}" viewBox="0 0 ${width} ${height}" role="img" aria-label="Reactor timeline">`;

        svg += `<line x1="${leftPad}" y1="${topPad - 10}" x2="${leftPad + plotW}" y2="${topPad - 10}" stroke="#e9ecef" stroke-width="2" />`;

        for (let y = firstTick; y <= xMax; y += step) {
            const x = yearToX(y);
            svg += `<line x1="${x}" y1="${topPad - 10}" x2="${x}" y2="${topPad + reactors.length * rowH}" stroke="#f0f2f5" stroke-width="1" />`;
            svg += `<line x1="${x}" y1="${topPad - 14}" x2="${x}" y2="${topPad - 6}" stroke="#dfe6e9" stroke-width="2" />`;
            svg += `<text x="${x}" y="${topPad - 18}" text-anchor="middle" font-family="Muli, sans-serif" font-size="11" font-weight="800" fill="#8898aa">${y}</text>`;
        }

        if (cutoffYear < MAX_YEAR && cutoffYear >= xMin && cutoffYear <= xMax) {
            const currentX = yearToX(cutoffYear);
            svg += `<line x1="${currentX}" y1="${topPad - 10}" x2="${currentX}" y2="${topPad + reactors.length * rowH + 10}" stroke="${COLOR_CURRENT_YEAR}" stroke-width="2" stroke-dasharray="4,3" opacity="0.8" />`;
            svg += `<text x="${currentX}" y="${topPad + reactors.length * rowH + 20}" text-anchor="middle" font-family="Muli, sans-serif" font-size="10" font-weight="700" fill="${COLOR_CURRENT_YEAR}">${cutoffYear}</text>`;
        }

        reactors.forEach((r, i) => {
            const y = topPad + i * rowH + 6;
            const name = escapeHtmlAttr(r.displayName || r.name || 'Reactor');
            const cStart = r.constructionStart || null;
            const gYear = (r.gridConnection && r.gridConnection <= cutoffYear) ? r.gridConnection : null;
            const hasShutdown = r.shutdownDate && r.shutdownDate <= cutoffYear;
            const endYear = hasShutdown ? r.shutdownDate : (gYear ? cutoffYear : cutoffYear);
            const shutdownYear = hasShutdown ? r.shutdownDate : null;
            const cStartFormatted = r.constructionStartFormatted || (cStart ? String(cStart) : '');
            const gYearFormatted = gYear ? (r.gridConnectionFormatted || String(gYear)) : '';
            const shutdownFormatted = shutdownYear ? (r.shutdownDateFormatted || String(shutdownYear)) : '';

            svg += `<g class="timeline-row" data-reactor-index="${i}">`;
            // v5.7.128: Reactor name label (responsive left column)
            const labelName = escapeHtml(r.displayName || r.name || '');
            const nameFontSize = containerWidth < 400 ? 9 : 10;
            svg += `<text x="${leftPad - 6}" y="${y + 8}" font-family="Muli, sans-serif" font-size="${nameFontSize}" font-weight="700" fill="#636e72" text-anchor="end">${labelName}</text>`;
            let drewAnything = false;

            if (cStart && (!gYear || cStart <= gYear)) {
                const x1 = yearToX(cStart);
                const x2 = yearToX(gYear ? gYear : endYear);
                svg += `<g class="timeline-segment construction-segment" data-reactor-name="${name}" data-construction-start="${escapeHtmlAttr(cStartFormatted)}" data-grid-connection="${escapeHtmlAttr(gYearFormatted)}" data-segment-type="construction">`;
                svg += `<line x1="${x1}" y1="${y + 4}" x2="${x2}" y2="${y + 4}" stroke="${COLOR_CONSTRUCTION}" stroke-width="6" stroke-linecap="round" opacity="0.9" />`;
                svg += `</g>`;
                drewAnything = true;
                svg += `<polygon points="${x1},${y} ${x1 + 5},${y + 4} ${x1},${y + 8} ${x1 - 5},${y + 4}" fill="#ffffff" stroke="${COLOR_CONSTRUCTION}" stroke-width="2" />`;
                if (!gYear && r.shutdownDate && r.shutdownDate <= cutoffYear) {
                    const xs = yearToX(r.shutdownDate);
                    svg += `<rect x="${xs - 4}" y="${y}" width="8" height="8" rx="2" fill="#ffffff" stroke="${COLOR_CONSTRUCTION}" stroke-width="2" />`;
                }
            }

            if (gYear) {
                const x1 = yearToX(gYear);
                const x2 = yearToX(endYear);
                svg += `<g class="timeline-segment operable-segment" data-reactor-name="${name}" data-grid-connection="${escapeHtmlAttr(gYearFormatted)}" data-shutdown="${escapeHtmlAttr(shutdownFormatted)}" data-segment-type="operable">`;
                svg += `<line x1="${x1}" y1="${y + 4}" x2="${x2}" y2="${y + 4}" stroke="${COLOR_OPERATING}" stroke-width="6" stroke-linecap="round" opacity="0.9" />`;
                svg += `</g>`;
                drewAnything = true;
                svg += `<circle cx="${x1}" cy="${y + 4}" r="4" fill="#ffffff" stroke="${COLOR_OPERATING}" stroke-width="2" />`;
                if (r.shutdownDate && r.shutdownDate <= cutoffYear) {
                    const xs = yearToX(r.shutdownDate);
                    svg += `<rect x="${xs - 4}" y="${y}" width="8" height="8" rx="2" fill="#ffffff" stroke="${COLOR_OPERATING}" stroke-width="2" />`;
                }
            }

            if (!drewAnything) {
                svg += `<line x1="${leftPad}" y1="${y + 4}" x2="${leftPad + 22}" y2="${y + 4}" stroke="${COLOR_UNKNOWN}" stroke-width="4" stroke-linecap="round" opacity="0.6" />`;
            }
            svg += `</g>`;
        });
        svg += `</svg>`;

        let legendItems = `
            <div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;transform:rotate(45deg);background:#ffffff;border:2px solid ${COLOR_CONSTRUCTION};"></span>Construction start</div>
            <div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#ffffff;border:2px solid ${COLOR_OPERATING};"></span>Grid connection</div>
            <div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;border-radius:3px;background:#ffffff;border:2px solid ${COLOR_OPERATING};"></span>Shutdown</div>
        `;
        if (cutoffYear < MAX_YEAR) {
            legendItems += `<div class="timeline-legend-item"><span style="display:inline-block;width:2px;height:12px;background:${COLOR_CURRENT_YEAR};border:none;"></span>Viewing: ${cutoffYear}</div>`;
        }
        const legend = `<div class="timeline-legend" aria-label="Timeline legend">${legendItems}</div>`;
        const tooltipHtml = `<div class="timeline-tooltip" id="mobileTimelineTooltip"></div>`;

        container.innerHTML = svg + legend + tooltipHtml;
        setupTimelineInteractivity(container);
    }

    // --- Mobile Country Production Chart ---
    function renderMobileCountryProductionChart(stats) {
        const canvas = document.getElementById('mobileCountryProductionChart');
        const emptyEl = document.getElementById('mobileCountryProductionEmpty');
        const subtitleEl = document.getElementById('mobileCountryProductionSubtitle');
        if (!canvas) return;

        const series = getCountryProductionSeries(stats);
        const hasSeries = series.years && series.years.length >= 2 && series.values.some(v => Number.isFinite(v) && v !== 0);

        const chartWrap = canvas.closest('.mobile-chart-wrap');
        const toggleEl = document.getElementById('mobileCountryProductionToggle');

        if (!hasSeries) {
            canvas.style.display = 'none';
            if (chartWrap) chartWrap.style.display = 'none';
            if (toggleEl) toggleEl.style.display = 'none';
            if (subtitleEl) subtitleEl.style.display = 'none';
            if (emptyEl) emptyEl.style.display = 'block';
            return;
        }

        canvas.style.display = 'block';
        if (chartWrap) chartWrap.style.display = '';
        if (toggleEl) toggleEl.style.display = '';
        if (subtitleEl) subtitleEl.style.display = '';
        if (emptyEl) emptyEl.style.display = 'none';

        let valuesTWh = series.values.map(v => v / 1000);
        if (mobileCountryProductionMode === 'cumulative') {
            let cum = 0;
            valuesTWh = valuesTWh.map(v => { cum += v; return cum; });
        }
        if (subtitleEl) {
            subtitleEl.textContent = mobileCountryProductionMode === 'annual' ? 'Annual (TWh)' : 'Cumulative (TWh)';
        }

        drawLineChartOnCanvas(canvas, series.years, valuesTWh, null);
        setupMobileChartInteractivity(canvas, series.years, valuesTWh, document.getElementById('mobileCountryProductionTooltip'));

        if (toggleEl) {
            toggleEl.querySelectorAll('.production-toggle-btn').forEach(btn => {
                btn.classList.toggle('active', btn.dataset.mode === mobileCountryProductionMode);
                const newBtn = btn.cloneNode(true);
                btn.parentNode.replaceChild(newBtn, btn);
                newBtn.addEventListener('click', () => {
                    if (newBtn.dataset.mode === mobileCountryProductionMode) return;
                    mobileCountryProductionMode = newBtn.dataset.mode;
                    renderMobileCountryProductionChart(stats);
                });
            });
        }
    }

    // --- Mobile Country Deployment Chart ---
    function renderMobileCountryDeploy(stats) {
        const container = document.getElementById('mobileCountryDeployChart');
        if (!container) return;

        if (!stats || !stats.plants || stats.plants.length === 0) {
            container.innerHTML = '<div class="mobile-chart-empty">No reactor deployment data available.</div>';
            return;
        }

        const cutoffYear = currentSelectedYear;
        const connectionsByYear = {};
        const shutdownsByYear = {};

        stats.plants.forEach(plant => {
            if (!plant.reactors) return;
            plant.reactors.forEach(reactor => {
                const gridYear = reactor.gridConnection;
                const shutdownYear = reactor.shutdownDate;
                const capacity = reactor.capacity || 0;
                const name = reactor.displayName || reactor.name || 'Unknown';
                const plantName = plant.name;

                if (gridYear && gridYear <= cutoffYear) {
                    if (!connectionsByYear[gridYear]) connectionsByYear[gridYear] = [];
                    connectionsByYear[gridYear].push({ name, plantName, capacity, year: gridYear });
                }
                if (shutdownYear && shutdownYear <= cutoffYear) {
                    if (!shutdownsByYear[shutdownYear]) shutdownsByYear[shutdownYear] = [];
                    shutdownsByYear[shutdownYear].push({ name, plantName, capacity, year: shutdownYear });
                }
            });
        });

        const allYears = [...Object.keys(connectionsByYear), ...Object.keys(shutdownsByYear)].map(Number);
        if (allYears.length === 0) {
            container.innerHTML = '<div class="mobile-chart-empty">No reactor deployment data for this period.</div>';
            return;
        }

        const minYear = Math.min(...allYears);
        const maxYear = Math.min(Math.max(...allYears), cutoffYear);

        renderDeployChart(connectionsByYear, shutdownsByYear, minYear, maxYear, container, mobileDeployMode);

        // Setup toggle for mobile deploy chart
        const toggleEl = document.getElementById('mobileCountryDeployToggle');
        if (toggleEl) {
            toggleEl.querySelectorAll('.production-toggle-btn').forEach(btn => {
                btn.classList.toggle('active', btn.dataset.mode === mobileDeployMode);
                const newBtn = btn.cloneNode(true);
                btn.parentNode.replaceChild(newBtn, btn);
                newBtn.addEventListener('click', () => {
                    if (newBtn.dataset.mode === mobileDeployMode) return;
                    mobileDeployMode = newBtn.dataset.mode;
                    renderMobileCountryDeploy(stats);
                });
            });
        }
    }

    // --- Shared: mobile chart touch/hover interactivity ---
    function setupMobileChartInteractivity(canvas, years, values, tooltipEl) {
        if (!canvas || !years || years.length === 0) return;

        const margin = { left: 48, right: 14, top: 12, bottom: 30 };

        function getHoverIndex(clientX) {
            const rect = canvas.getBoundingClientRect();
            const x = clientX - rect.left;
            const plotW = rect.width - margin.left - margin.right;
            const relX = x - margin.left;
            if (relX < 0 || relX > plotW) return null;
            const idx = Math.round((relX / plotW) * (years.length - 1));
            return Math.max(0, Math.min(idx, years.length - 1));
        }

        // Store data on canvas for re-reads
        canvas._mobileChartData = { years, values };

        if (canvas._mobileInteractiveAttached) return;
        canvas._mobileInteractiveAttached = true;

        function onPointer(clientX) {
            const data = canvas._mobileChartData || { years: [], values: [] };
            const yrs = data.years;
            const vals = data.values;
            if (!yrs.length) return;

            const idx = getHoverIndex(clientX);
            if (idx === null || !Number.isFinite(vals[idx])) {
                if (tooltipEl) tooltipEl.style.display = 'none';
                drawLineChartOnCanvas(canvas, yrs, vals, null);
                return;
            }
            drawLineChartOnCanvas(canvas, yrs, vals, idx);
            if (tooltipEl) {
                tooltipEl.innerHTML = `<strong>${yrs[idx]}</strong> ${vals[idx].toFixed(2)} TWh`;
                tooltipEl.style.display = 'block';
                const rect = canvas.getBoundingClientRect();
                const plotW = rect.width - margin.left - margin.right;
                const xAt = margin.left + (idx / (yrs.length - 1)) * plotW;
                tooltipEl.style.left = (xAt - tooltipEl.offsetWidth / 2) + 'px';
                tooltipEl.style.top = '-30px';
            }
        }

        canvas.addEventListener('mousemove', (e) => onPointer(e.clientX));
        canvas.addEventListener('touchmove', (e) => {
            if (e.touches.length === 1) {
                e.preventDefault();
                onPointer(e.touches[0].clientX);
            }
        }, { passive: false });

        canvas.addEventListener('mouseleave', () => {
            const data = canvas._mobileChartData || { years: [], values: [] };
            if (tooltipEl) tooltipEl.style.display = 'none';
            drawLineChartOnCanvas(canvas, data.years, data.values, null);
        });
        canvas.addEventListener('touchend', () => {
            const data = canvas._mobileChartData || { years: [], values: [] };
            if (tooltipEl) tooltipEl.style.display = 'none';
            drawLineChartOnCanvas(canvas, data.years, data.values, null);
        });
    }
    // ===================================================================
    // End v5.7.126 mobile chart functions
    // ===================================================================

    // Plant info overlay button -> open modal
    if (plantInfoMoreDetails) {
        plantInfoMoreDetails.addEventListener('click', (e) => {
            e.preventDefault();
            if (currentSelectedPlant) {
                navPush(); // v5.7.77: push plant info state before opening detail
                openPlantDetailModal(currentSelectedPlant);
            }
        });
    }

    // Popup CTA button (mobile + globe) -> open modal via event delegation
    document.addEventListener('click', (e) => {
        const btn = e.target.closest && e.target.closest('.plant-details-btn');
        if (!btn) return;
        const plantName = btn.getAttribute('data-plant-name');
        if (!plantName) return;

        // Find plant and open modal
        const plant = nuclearPlants.find(p => p.name === plantName);
        if (plant) {
            navPush(); // v5.7.77: push current state before opening detail
            openPlantDetailModal(plant);
        }
    });


    // Detailed view reactors toggle handler
    if (plantDetailReactorsToggle) {
        plantDetailReactorsToggle.addEventListener('click', () => {
            const isExpanded = plantDetailReactorsToggle.classList.toggle('expanded');
            plantDetailReactorsToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            if (plantDetailReactorsList) plantDetailReactorsList.classList.toggle('expanded', isExpanded);
        });
    }

    // Modal close handlers (v5.7.77: back button uses nav stack, backdrop still closes)
    if (plantDetailBack) {
        plantDetailBack.addEventListener('click', function() {
            if (navHistory.length > 0) {
                handleNavBack();
            } else {
                closePlantDetailModal();
            }
        });
    }
    if (plantDetailBackdrop) {
        plantDetailBackdrop.addEventListener('click', closePlantDetailModal);
    }

    // Country link handler (click to show country info from fullscreen plant detail)
    if (plantDetailCountry) {
        plantDetailCountry.addEventListener('click', () => {
            const plant = currentDetailPlant || currentSelectedPlant;
            if (plant) {
                const countryName = plant.country;
                // v5.7.77: Push nav state before closing the detail modal so
                // the back button can return to this plant's detailed view.
                navPush();
                closePlantDetailModal();
                zoomToCountry(countryName);
            }
        });
    }


    // ESC to close
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && plantDetailModal && plantDetailModal.classList.contains('open')) {
            closePlantDetailModal();
        }
    });

    // Re-render charts on resize while modal is open (debounced)
    window.addEventListener('resize', () => {
        if (!plantDetailModal || !plantDetailModal.classList.contains('open') || !currentDetailPlant) return;
        clearTimeout(detailResizeTimer);
        detailResizeTimer = setTimeout(() => {
            renderPlantProductionChart(currentDetailPlant);
            renderPlantReactorTimeline(currentDetailPlant);
            renderPlantRecentNews(currentDetailPlant);
        }, 120);
    });


    // --- 7. Initialize Map (v5.7.183: MapLibre GL JS replaces Leaflet 1.9.4) ---
    //
    // ZOOM CONVENTION. MapLibre's transform tile size is a constant 512, so
    //     MapLibre zoom = Leaflet zoom - 1
    // regardless of a raster source's own tileSize. Every zoom number below is a MapLibre
    // zoom. A source tileSize of 256 only changes which tile z is requested (map z + 1),
    // which is what keeps 256px raster imagery sharp instead of upscaled.

    // Map, globe and basemap state. Declared here, above the feature builder, so the builder
    // can read them on its very first render without a temporal-dead-zone guard.
    let isSatelliteView = true;
    let isGlobeView = false;
    let labelsEnabled = true;
    let currentHighlightFilter = null;      // search highlight; dims every non-matching plant
    let currentHoverFocusPlantName = null;  // plant-list row hover; lifts one plant
    let useClusterView = false;
    let mapLoaded = false;
    let styleReady = false;   // style.load has fired; NOT the same as isStyleLoaded()
    let mapAvailable = true;

    // --- Basemap credentials -------------------------------------------------------------
    // Both are client-side, referrer-restricted keys rather than secrets, but they are the
    // single point of failure for the basemap, so they live here and nowhere else. Each is
    // independently revertible by emptying its constant.
    //
    // CARTO: free key from https://carto.com/basemaps/apikey. Since the Basemap Terms of
    // 26/08/2026 the keyless Voyager raster tiles carry an "API KEY REQUIRED" watermark.
    // Empty string => fall back to the keyless Esri street standby.
    const CARTO_KEY = 'cb1_2sl3_1_e3c5b59dc289fb877e378490';
    //
    // Esri: ArcGIS Location Platform API key credential, Basemaps privileges only, referrers
    // world-nuclear.org and *.world-nuclear.org. Pay-as-you-go is deliberately OFF, so
    // exhausting the 2,000,000 tiles/month free tier stops the service rather than billing.
    // ROTATION DUE: 3 SEPTEMBER 2027, 23:59 GMT+1 - a lapsed key is a blank satellite view.
    // Credential item "Nuclear Power Plant Explorer - basemaps", ArcGIS item id
    // a0ee216e16cd4b00bd854daca81b3013, in the world-nuclear ArcGIS org. That item also has a
    // "Generate a secondary API key" button, which is how to rotate with zero downtime: mint
    // the second key, paste it here, then revoke the first.
    // Empty string => stay on the keyless legacy host, which is the one-line reversal.
    const ESRI_KEY = 'AAPTaVqno9pRA2G5-qRxeliw5TQ..hmste7_4COwWNDDUHzwGyEpPbqAyqh_1lZH7g9ZF5guDPOldEJjKzpT7S22Ar8CaEsjAtubaHTmrCZYioNeL1cxwClmeJv5tLR1OLy59G4Y-geeiXGlej63XldSJ4gQSlLz2UOnoo2-iXbDdAZESHumN-itHW4zYS6qXYJPK3F_5y3BIlAN1dyb_BCfN0cXYNl4dRAOWDrUlY-cFIWbWnKXunHgbNaNvMRrnM2NoQpdiyl7UiyBhMwhic1LtxWkSAT1_urP0cJWO';

    // Appending ?token= to server.arcgisonline.com does nothing: that host ignores tokens
    // entirely, so becoming licensed means changing the hostname. Tiles from the two hosts are
    // byte-identical (MD5-matched), so there is no visual difference either way.
    const ESRI_IMAGERY_URL = ESRI_KEY
        ? 'https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=' + ESRI_KEY
        : 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
    const ESRI_BOUNDARIES_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}';
    const ESRI_STREET_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';
    const RETINA = (window.devicePixelRatio > 1) ? '@2x' : '';
    const CARTO_STREETS_URL = 'https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}' + RETINA + '.png?key=' + CARTO_KEY;

    const ATTR_ESRI_IMAGERY = 'Powered by <a href="https://www.esri.com">Esri</a> | Esri, Vantor, Earthstar Geographics';
    const ATTR_ESRI_LABELS  = 'Esri, HERE, Garmin, &copy; OpenStreetMap contributors';
    const ATTR_ESRI_STREET  = 'Powered by <a href="https://www.esri.com">Esri</a> | Esri, HERE, Garmin, &copy; OpenStreetMap contributors';
    const ATTR_CARTO        = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>';

    // Shared raster paint. The three *-transition entries are what let applyMapTheme() fade
    // between the light and dark looks over 300ms, reproducing the old CSS filter transition.
    // raster-fade-duration 150 softens tile pop-in without the default 300ms cross-fade.
    const RP = {
        'raster-fade-duration': 150,
        'raster-brightness-max-transition': { duration: 300 },
        'raster-contrast-transition': { duration: 300 },
        'raster-saturation-transition': { duration: 300 }
    };

    function rasterSource(url, attribution, maxzoom) {
        return {
            type: 'raster',
            tiles: [url],
            tileSize: 256,
            maxzoom: maxzoom || 19,
            attribution: attribution
        };
    }

    // cartoAvailable flips to false after repeated source errors so the Esri street standby
    // takes over automatically rather than leaving Map mode blank.
    let cartoAvailable = !!CARTO_KEY;
    let cartoErrorTimes = [];

    // Every zoom-dependent expression below puts the zoom curve as the OUTERMOST node. This is
    // not a style preference: MapLibre rejects ['zoom'] nested inside '*', 'case', 'max' or
    // 'coalesce', and because these layers are concatenated into the ROOT style, one bad
    // expression makes Style._load bail and blanks the ENTIRE map, basemap included.
    function plantLayerDefs() {
        const NOT_CLUSTER = ['!', ['has', 'point_count']];
        const DIM_OPACITY = ['case', ['==', ['get', 'dim'], 1], 0.25, 1];
        // Image ids: 'p:'+variant plain, 'd:'+variant detail-with-count, 'gp:'/'gd:' grey.
        const PLAIN  = ['case', ['==', ['get', 'dim'], 1], ['concat', 'gp:', ['get', 'variant']], ['concat', 'p:', ['get', 'variant']]];
        const DETAIL = ['case', ['==', ['get', 'dim'], 1], ['concat', 'gd:', ['get', 'variant']], ['concat', 'd:', ['get', 'variant']]];

        return [
            {
                id: 'plants-shadow', type: 'circle', source: 'plants', filter: NOT_CLUSTER,
                layout: { 'circle-sort-key': ['get', 'sk'] },
                paint: {
                    'circle-color': 'rgba(0,0,0,0.3)',
                    'circle-blur': 0.6,
                    'circle-translate': [0, 4],
                    'circle-opacity': DIM_OPACITY,
                    // Integer stops: composite paint properties are sampled at the tile's
                    // integer zoom and zoom+1 and lerped in the shader, so a 3.5 stop would
                    // render as a 3->4 ramp anyway and the layers would disagree.
                    'circle-radius': ['interpolate', ['linear'], ['zoom'],
                        3, 0,
                        4, ['*', ['get', 'sizePx'], 0.5]]
                }
            },
            {
                // Year-change ring. Only CONSTANT paint values are animated per frame: updating
                // a data-driven paint property would trigger a source relayout in the worker,
                // so the radius stays static and the ring grows outward through stroke width.
                id: 'plants-pulse', type: 'circle', source: 'plants',
                filter: ['all', NOT_CLUSTER, ['==', ['get', 'chg'], 1]],
                paint: {
                    'circle-radius': ['+', ['*', ['get', 'sizePx'], 0.5], 2],
                    'circle-opacity': 0,
                    'circle-stroke-color': 'rgb(87,119,169)',
                    'circle-stroke-width': 0,
                    'circle-stroke-opacity': 0,
                    // Without these, every per-frame setPaintProperty starts a 300ms tween.
                    'circle-stroke-width-transition': { duration: 0 },
                    'circle-stroke-opacity-transition': { duration: 0 }
                }
            },
            {
                // ONE symbol per plant: pie, white centre disc and count are baked into a
                // single image. A separate count layer was rejected because layer order beats
                // sort order, so a lower marker's count would draw over a higher marker's pie.
                id: 'plants-pie', type: 'symbol', source: 'plants', filter: NOT_CLUSTER,
                layout: {
                    'icon-image': ['step', ['zoom'], PLAIN, 4, DETAIL],
                    'icon-size': ['interpolate', ['linear'], ['zoom'],
                        3, ['*', ['get', 'sizeScale'], 0.571],
                        4, ['get', 'sizeScale']],
                    'icon-overlap': 'always',
                    'icon-ignore-placement': true,
                    'icon-padding': 0,
                    // symbol-z-order stays at its default 'auto', which honours symbol-sort-key.
                    // Never set 'viewport-y': it ignores the sort key, so the hovered or
                    // highlighted plant would stop being lifted above its neighbours.
                    'symbol-sort-key': ['get', 'sk']
                },
                paint: { 'icon-opacity': DIM_OPACITY }
            },
            {
                // Transparent hit target: the ONLY pointer target. Symbol hit areas lag
                // interpolated icon-size at fractional zoom (upstream #128, wontfix), so
                // events are never bound to the symbol layer.
                id: 'plants-hit', type: 'circle', source: 'plants', filter: NOT_CLUSTER,
                layout: { 'circle-sort-key': ['get', 'sk'] },
                paint: {
                    'circle-opacity': 0,
                    'circle-stroke-width': 0,
                    // Floor of 14 keeps today's 28px touch target even where the pie draws 16px.
                    'circle-radius': ['interpolate', ['linear'], ['zoom'],
                        3, ['max', 14, ['*', ['get', 'sizePx'], 0.286]],
                        4, ['max', 14, ['*', ['get', 'sizePx'], 0.5]]]
                }
            },
            {
                id: 'clusters', type: 'symbol', source: 'plants', filter: ['has', 'point_count'],
                layout: {
                    'icon-image': ['concat', 'cl:', ['to-string', ['get', 'point_count']]],
                    'icon-overlap': 'always',
                    'icon-ignore-placement': true,
                    'icon-padding': 0
                }
            }
        ];
    }

    function buildRootStyle() {
        return {
            version: 8,
            sources: {
                'esri-imagery':    rasterSource(ESRI_IMAGERY_URL, ATTR_ESRI_IMAGERY, 19),
                'esri-boundaries': rasterSource(ESRI_BOUNDARIES_URL, ATTR_ESRI_LABELS, 19),
                'esri-street':     rasterSource(ESRI_STREET_URL, ATTR_ESRI_STREET, 19),
                'carto-streets':   rasterSource(CARTO_STREETS_URL, ATTR_CARTO, 19),
                'plants': {
                    type: 'geojson',
                    data: { type: 'FeatureCollection', features: [] },
                    promoteId: 'pid'
                }
            },
            layers: [
                { id: 'carto-streets', type: 'raster', source: 'carto-streets', layout: { visibility: 'none' }, paint: Object.assign({}, RP) },
                { id: 'esri-street', type: 'raster', source: 'esri-street', layout: { visibility: 'none' }, paint: Object.assign({}, RP) },
                { id: 'esri-imagery', type: 'raster', source: 'esri-imagery', layout: { visibility: 'visible' }, paint: Object.assign({}, RP) },
                { id: 'esri-boundaries', type: 'raster', source: 'esri-boundaries', layout: { visibility: 'visible' }, paint: Object.assign({}, RP) }
            ].concat(plantLayerDefs())
        };
    }

    // --- Map construction ----------------------------------------------------------------
    // Everything that touches the real map after construction sits inside the try, so the
    // WebGL-failure stub path never calls touchZoomRotate, keyboard or NavigationControl.
    let map;
    setLoaderPhase('Drawing the map…');
    setLoaderProgress(LOADER_STEPS.mapBuilt, 400);
    await paintFrame();
    try {
        if (typeof maplibregl === 'undefined') throw new Error('MapLibre GL JS not loaded');
        map = new maplibregl.Map({
            container: 'map',
            style: buildRootStyle(),
            center: HOME_CENTER,
            zoom: HOME_ZOOM,
            minZoom: HOME_ZOOM,
            maxZoom: 18,
            dragRotate: false,
            pitchWithRotate: false,
            touchPitch: false,
            maxPitch: 0,
            fadeDuration: 0,
            renderWorldCopies: true,
            // MapLibre GL JS is BSD-3-Clause and does not require an on-map credit, but the
            // Leaflet build carried one ("Leaflet" as the attribution prefix), so keep the
            // equivalent rather than quietly dropping the library credit.
            attributionControl: {
                compact: false,
                customAttribution: '<a href="https://maplibre.org/" target="_blank" rel="noopener">MapLibre</a>'
            },
            pixelRatio: Math.min(window.devicePixelRatio || 1, 2),
            canvasContextAttributes: { antialias: false, powerPreference: 'high-performance' }
        });
        map.touchZoomRotate.disableRotation();
        map.keyboard.disableRotation();
        // Added after the built-in attribution control, which the constructor creates first.
        // MapLibre prepends later controls in bottom corners, so the zoom buttons sit above
        // the credits, matching Leaflet's corner.
        map.addControl(new maplibregl.NavigationControl({ showCompass: false, visualizePitch: false }), 'bottom-right');
        map.on('error', function (e) { console.error('Map error', e && e.error); });
        // A root-style validation failure never fires 'load' and is not thrown by the
        // constructor, so the listener and this watchdog live OUTSIDE the load callback.
        // Without them a bad expression would leave a silent blank map.
        // MapLibre installs an inline style on the next ANIMATION FRAME, and a hidden or
        // backgrounded tab never gets one, so a page opened in a background tab legitimately
        // has no style until the user looks at it. The watchdog must not call that a failure:
        // ctrl-clicking a link to the Explorer is common, and reporting "failed to load"
        // there would be a false alarm over a perfectly good map.
        var loadWatchdog;
        function armLoadWatchdog() {
            clearTimeout(loadWatchdog);
            loadWatchdog = setTimeout(function () {
                if (mapLoaded || (map.isStyleLoaded && map.isStyleLoaded())) return;
                if (document.visibilityState === 'hidden') { armLoadWatchdog(); return; }
                showMapUnavailable('The map style failed to load');
            }, 8000);
        }
        armLoadWatchdog();
        map.once('style.load', function () {
            mapLoaded = true;
            clearTimeout(loadWatchdog);
            // Self-heal: clear a message the watchdog may already have shown.
            var stale = document.querySelector('#map .map-unsupported');
            if (stale) stale.remove();
            window.__mapUnavailable = false;
        });
    } catch (err) {
        console.error('Map initialisation failed', err);
        showMapUnavailable();
        mapAvailable = false;
        map = createMapStub();
    }

    // The overlay used to go the instant the constructor returned — before the
    // map had drawn a single pixel — so the bar completed against a blank panel
    // and the map then appeared underneath it. Waiting for style.load gives the
    // final and longest segment a real endpoint and reveals a map already drawn.
    //
    // A map that failed to build clears the overlay immediately either way, or it
    // would hide its own error message behind the bar.
    if (!mapAvailable) {
        setLoaderProgress(LOADER_STEPS.done, 150);
        hideLoader();
    } else {
        // Creep toward, but never reach, the end while the style loads.
        setLoaderProgress(LOADER_STEPS.mapCreep, LOADER_MAP_CAP_MS);
        const finishLoader = function () {
            if (loaderMapCap !== null) { clearTimeout(loaderMapCap); loaderMapCap = null; }
            setLoaderProgress(LOADER_STEPS.done, 150);
            // Let the fill actually arrive before the overlay goes; hiding on the
            // same frame throws away the one moment that says "finished".
            setTimeout(hideLoader, 170);
        };
        loaderMapCap = setTimeout(finishLoader, LOADER_MAP_CAP_MS);
        map.once('style.load', finishLoader);
    }

    // Run fn once the style is ready; safe to call before or after load.
    function whenStyleReady(fn) {
        if (!mapAvailable) return;
        if (styleReady) { fn(); return; }
        map.once('style.load', fn);
    }

    function showMapUnavailable(msg) {
        var el = document.getElementById('map');
        if (!el) return;
        window.__mapUnavailable = true;
        // Overlay the message rather than replacing the container's contents: wiping innerHTML
        // would destroy a live MapLibre canvas, so a spurious call could take out a map that
        // was actually working.
        if (el.querySelector('.map-unsupported')) return;
        var box = document.createElement('div');
        box.className = 'map-unsupported';
        box.textContent = msg || 'This map needs WebGL, which this browser or device does not support. Search, plant details and the charts below still work.';
        el.appendChild(box);
    }

    // Explicit no-op stub rather than a Proxy: a Proxy silently swallows typos and event
    // subscription errors, an explicit object fails loudly. Return values matter where
    // callers actually read them.
    function createMapStub() {
        var el = document.getElementById('map');
        var stub = {};
        var noop = function () { return stub; };
        ['resize', 'on', 'off', 'once', 'jumpTo', 'easeTo', 'flyTo', 'fitBounds', 'setMinZoom',
         'setMaxZoom', 'setPaintProperty', 'setLayoutProperty', 'setFilter', 'addImage',
         'updateImage', 'removeImage', 'addLayer', 'removeLayer', 'addSource', 'removeSource',
         'addControl', 'removeControl', 'triggerRepaint', 'remove', 'setCenter', 'setZoom',
         'panTo', 'stop'].forEach(function (k) { stub[k] = noop; });
        stub.getContainer = function () { return el; };           // updateMinZoomToPreventGrey reads clientHeight
        stub.getCenter = function () { return { lng: HOME_CENTER[0], lat: HOME_CENTER[1] }; };
        stub.getZoom = function () { return HOME_ZOOM; };
        stub.getCanvas = function () { return document.createElement('canvas'); };
        stub.getSource = function () { return null; };
        stub.getLayer = function () { return null; };
        stub.isStyleLoaded = function () { return false; };
        stub.hasImage = function () { return false; };
        stub.listImages = function () { return []; };
        stub.queryRenderedFeatures = function () { return []; };
        stub.getBounds = function () { return null; };
        return stub;
    }

    // The lowest zoom at which one copy of the world still covers the whole container.
    //
    // BOTH axes matter, and the horizontal one is not optional. Vertically this is the old
    // "prevent grey" rule. Horizontally it stops a second copy of the world - and of every
    // marker on it - appearing beside the first: MapLibre renders world copies, and unlike
    // Leaflet it draws the markers on each one. Leaflet avoided this by accident, because its
    // ceil(log2(h/256)) minimum always over-zoomed enough to fill a wide container; dropping
    // the ceil for a continuous minimum removed that accident, so the width term restores it
    // deliberately and without reintroducing an integer step.
    function worldCoverZoom() {
        var container = map.getContainer && map.getContainer();
        if (!container) return HOME_ZOOM;
        var h = container.clientHeight || 0;
        var w = container.clientWidth || 0;
        if (!h && !w) return HOME_ZOOM;
        return Math.max(
            HOME_ZOOM,
            h ? Math.log2(h / 512) : HOME_ZOOM,
            w ? Math.log2(w / 512) : HOME_ZOOM
        );
    }

    // Kept as its own name because the tour and the home button read it. MapLibre's mercator
    // transform already raises zoom rather than showing a grey band, so the floor is
    // belt-and-braces there: it keeps the zoom-out button greying out correctly and stops
    // goHome() targeting a zoom the transform would refuse (5.24.0 lacks the 6.0
    // flyTo/minZoom fix #7743).
    function getHomeZoom() {
        return worldCoverZoom();
    }

    function updateMinZoomToPreventGrey() {
        if (!(map.getContainer && map.getContainer())) return;
        map.setMinZoom(worldCoverZoom());
    }

    function goHome(ms) {
        map.flyTo({
            center: HOME_CENTER,
            zoom: getHomeZoom(),
            duration: (ms == null ? 1500 : ms),
            essential: true
        });
    }

    updateMinZoomToPreventGrey();
    window.addEventListener('resize', updateMinZoomToPreventGrey);
    map.on('resize', updateMinZoomToPreventGrey);
    
    // --- Basemap switching -----------------------------------------------------------------
    // Basemap choice is a visibility table over one composite style, which is what makes
    // dark mode a uniform raster paint change and lets attribution swap itself: MapLibre
    // credits only the sources whose layers are actually visible.
    const RASTER_LAYER_IDS = ['carto-streets', 'esri-street', 'esri-imagery', 'esri-boundaries'];

    function setLayerVisible(id, visible) {
        if (!mapAvailable || !map.getLayer(id)) return;
        try { map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none'); } catch (e) {}
    }

    function applyBasemap() {
        if (!mapAvailable || !styleReady) return;
        setLayerVisible('carto-streets', !isSatelliteView && cartoAvailable);
        setLayerVisible('esri-street', !isSatelliteView && !cartoAvailable);
        setLayerVisible('esri-imagery', isSatelliteView);
        setLayerVisible('esri-boundaries', isSatelliteView && labelsEnabled);
    }

    // Single entry point for the view-mode buttons and the ?view= deep link.
    function setViewMode(mode) {
        isSatelliteView = (mode !== 'map');
        if (typeof syncViewModeSelection === 'function') syncViewModeSelection(mode);
        applyBasemap();
    }

    // If CARTO fails repeatedly, fall through to the keyless Esri street standby rather than
    // leaving Map mode blank. No automatic retry: one switch, then stay there.
    function noteCartoError() {
        if (!cartoAvailable) return;
        const now = Date.now();
        cartoErrorTimes = cartoErrorTimes.filter(t => now - t < 30000);
        cartoErrorTimes.push(now);
        if (cartoErrorTimes.length >= 3) {
            console.warn('CARTO basemap failing; falling back to the Esri street standby.');
            cartoAvailable = false;
            applyBasemap();
        }
    }

    // --- Dark mode -------------------------------------------------------------------------
    // Markers now share the canvas with the tiles, so the old CSS filter on the tile pane
    // would darken them too, and would cost a full-viewport filter pass every frame. Raster
    // paint runs in the tile fragment shader for free and touches nothing but the tiles.
    function applyMapTheme() {
        whenStyleReady(function () {
            const dark = document.documentElement.getAttribute('data-theme') === 'dark';
            const bmax = dark ? 0.7 : 1;
            const contrast = dark ? 0.1 : 0;
            const sat = dark ? -0.2 : 0;
            RASTER_LAYER_IDS.forEach(function (id) {
                if (!map.getLayer(id)) return;
                try {
                    map.setPaintProperty(id, 'raster-brightness-max', bmax);
                    map.setPaintProperty(id, 'raster-contrast', contrast);
                    map.setPaintProperty(id, 'raster-saturation', sat);
                } catch (e) {}
            });
            // Cluster badges are images, so they need a redrawn dark variant.
            if (typeof refreshClusterBadges === 'function') refreshClusterBadges();
        });
    }

    // Catches both theme writers (setTheme and the fullscreen forced-light write) without
    // having to edit either of them.
    try {
        new MutationObserver(applyMapTheme).observe(document.documentElement, {
            attributes: true, attributeFilter: ['data-theme']
        });
    } catch (e) {}

    // --- Plant data path -------------------------------------------------------------------
    let lastPlantFC = { type: 'FeatureCollection', features: [] };
    let lastPlantDataPromise = Promise.resolve();

    function setPlantData(fc) {
        lastPlantFC = fc;
        // In globe view the 2D map is display:none. Today's code still rebuilds 334 hidden
        // Leaflet markers there; skipping the push is a straight saving, and the globe-exit
        // path re-pushes lastPlantFC.
        if (isGlobeView || !mapAvailable) return (lastPlantDataPromise = Promise.resolve());
        const s = map.getSource('plants');
        // setData(fc, true) resolves when the worker has finished re-tiling. The year pulse
        // awaits this one production promise rather than issuing a second setData, which
        // would enqueue a different update and time the wrong thing.
        lastPlantDataPromise = s ? Promise.resolve(s.setData(fc, true)) : Promise.resolve();
        if (typeof markMapBrowseListStale === 'function') markMapBrowseListStale(fc);
        return lastPlantDataPromise;
    }

    function refreshPlantLayer() {
        setPlantData(buildPlantFeatures(currentSelectedYear).fc);
    }

    function rebuildMarkerLayer() {
        if (mapAvailable) {
            const s = map.getSource('plants');
            // 5.24.0's setClusterOptions accepts only cluster, clusterRadius and
            // clusterMaxZoom, so clusterMinPoints stays at its default of 2.
            // clusterMaxZoom 6 reproduces Leaflet markercluster's disableClusteringAtZoom 8
            // exactly (its internal maxZoom is 7, so clusters exist at Leaflet z<=7 = ML z<=6).
            if (s && s.setClusterOptions) {
                try { s.setClusterOptions({ cluster: useClusterView, clusterRadius: 50, clusterMaxZoom: 6 }); } catch (e) {}
            }
        }
        updateMapForYear(currentSelectedYear);
    }

    // In size-by mode the pie must not shrink with zoom and the count stays hidden, so whole
    // expressions are swapped rather than edited in place.
    function applySizeByLayout() {
        // setLayoutProperty/setPaintProperty/setFilter throw "Style is not done loading"
        // before style.load, and updateMapForYear(MAX_YEAR) runs synchronously at boot.
        if (!mapAvailable || !styleReady || !map.getLayer('plants-pie')) return;
        const sizeBy = !!(viewOptions.sizeByCapacity || viewOptions.sizeByProduction);
        const PLAIN = ['case', ['==', ['get', 'dim'], 1], ['concat', 'gp:', ['get', 'variant']], ['concat', 'p:', ['get', 'variant']]];
        const DETAIL = ['case', ['==', ['get', 'dim'], 1], ['concat', 'gd:', ['get', 'variant']], ['concat', 'd:', ['get', 'variant']]];
        try {
            if (sizeBy) {
                map.setLayoutProperty('plants-pie', 'icon-size', ['get', 'sizeScale']);
                map.setLayoutProperty('plants-pie', 'icon-image', PLAIN);
                map.setPaintProperty('plants-shadow', 'circle-radius', ['*', ['get', 'sizePx'], 0.5]);
                map.setPaintProperty('plants-hit', 'circle-radius', ['max', 14, ['*', ['get', 'sizePx'], 0.5]]);
            } else {
                map.setLayoutProperty('plants-pie', 'icon-size', ['interpolate', ['linear'], ['zoom'],
                    3, ['*', ['get', 'sizeScale'], 0.571],
                    4, ['get', 'sizeScale']]);
                map.setLayoutProperty('plants-pie', 'icon-image', ['step', ['zoom'], PLAIN, 4, DETAIL]);
                map.setPaintProperty('plants-shadow', 'circle-radius', ['interpolate', ['linear'], ['zoom'],
                    3, 0,
                    4, ['*', ['get', 'sizePx'], 0.5]]);
                map.setPaintProperty('plants-hit', 'circle-radius', ['interpolate', ['linear'], ['zoom'],
                    3, ['max', 14, ['*', ['get', 'sizePx'], 0.286]],
                    4, ['max', 14, ['*', ['get', 'sizePx'], 0.5]]]);
            }
        } catch (e) {}
    }

    // One DOM marker reusing the existing .hover-pulse-ring element and keyframes. Only ever
    // one exists, and only while a list row is hovered, so exact CSS parity is free here.
    function ringMarker(plant, className) {
        if (!mapAvailable || typeof maplibregl === 'undefined') return null;
        const el = document.createElement('div');
        el.className = className;
        el.style.width = '48px';
        el.style.height = '48px';
        el.style.pointerEvents = 'none';
        return new maplibregl.Marker({ element: el, anchor: 'center' })
            .setLngLat([plant.lon, plant.lat])
            .addTo(map);
    }

    if (mapAvailable) {
        map.on('error', function (e) {
            if (e && e.sourceId === 'carto-streets') noteCartoError();
        });
        map.once('style.load', function () {
            styleReady = true;
            // Style-dependent state first, THEN the data push. setPlantData starts a worker
            // update, and anything gated on readiness after it would otherwise be skipped.
            applyBasemap();
            applyMapTheme();
            // FINDING 3: a cluster toggle flipped before style.load found no source and was
            // dropped, leaving the checkbox ticked and the map unclustered. Re-apply here.
            const src = map.getSource('plants');
            if (src && src.setClusterOptions) {
                try { src.setClusterOptions({ cluster: useClusterView, clusterRadius: 50, clusterMaxZoom: 6 }); } catch (e) {}
            }
            applySizeByLayout();
            // updateMapForYear(MAX_YEAR) runs before the style exists, so only lastPlantFC is
            // filled by then. Without this push the map would start empty until the next
            // slider move.
            if (typeof ensurePlantImages === 'function') ensurePlantImages(lastPlantFC);
            setPlantData(lastPlantFC);
            updateMinZoomToPreventGrey();
        });
    }

// --- Helper: pan/fly to a point while keeping it visible beside the left overlay (desktop) ---
function getDesktopOverlayOffsetX() {
    if (window.innerWidth <= 600) return 0;
    const box = document.getElementById('plantInfoBox') || document.querySelector('.search-overlay .search-wrapper');
    let w = box ? box.getBoundingClientRect().width : 0;
    if (!w && box) w = parseFloat(getComputedStyle(box).width) || 0;
    if (!w) w = 380;
    const mapW = (map.getContainer() && map.getContainer().clientWidth) || window.innerWidth;
    // Move the clicked point to the right by ~half the overlay width + padding, but clamp to avoid over-panning
    return Math.round(Math.min((w / 2) + 50, mapW * 0.35));
}


// Deleted with the Leaflet engine: constrainLatLngToBounds, panToWithOffset and
// panToWithOffsetXOnly. They had no remaining callers, and MapLibre constrains camera
// targets itself, so there is nothing to clamp against.

// Camera helpers take MAPLIBRE units and MILLISECONDS.
// Coordinate convention: [lng, lat], MapLibre order, with no reversal inside the helper.
// Every call site passes [plant.lon, plant.lat] explicitly.
function flyToWithOffset(target, zoom, offsetX, offsetY, options = {}) {
    // Prefer the object form at call sites: flyToWithOffset(plant, ...). The array form is
    // [lng, lat] - MapLibre order - and a transposed [lat, lng] is only detectable when the
    // longitude happens to exceed 90, so it fails silently for anywhere in Europe or Africa.
    const lngLat = Array.isArray(target) ? target : [target.lon, target.lat];
    if (!Number.isFinite(lngLat[0]) || !Number.isFinite(lngLat[1])) return;
    if (Math.abs(lngLat[1]) > 90 || Math.abs(lngLat[0]) > 180) {
        throw new Error('flyToWithOffset expects [lng, lat] or {lon, lat}, got ' + JSON.stringify(target));
    }
    map.flyTo({
        center: lngLat,
        zoom: (zoom == null ? map.getZoom() : zoom),
        offset: [offsetX || 0, offsetY || 0],   // same sign convention as the old project/subtract code
        essential: true,
        ...options                              // options.duration is in milliseconds
    });
}

// Calculate vertical offset for mobile panels (to center content in visible top half)
function getMobilePanelOffset() {
    const isMobile = window.innerWidth <= 600;
    if (!isMobile) return 0;

    // Panel takes up 50% of viewport height
    // We want to center the target in the TOP half, so offset by 25% of viewport
    // (moving the map center up means the target appears higher on screen)
    const viewportHeight = window.innerHeight;
    return viewportHeight * 0.25; // Offset by quarter of screen (half of the panel height)
}

// Bounds from plant coordinates rather than from rendered markers, so plants that have never
// been drawn are no longer silently dropped. LngLatBounds does not normalise corners, so it
// is always built with extend().
function plantsBounds(plants) {
    // The WebGL/library failure path installs a map stub, but this helper reached straight for
    // the global. Without the guard, picking a country (or loading a country embed) threw
    // ReferenceError and killed the interaction the stub exists to keep alive.
    if (typeof maplibregl === 'undefined') return null;
    const b = new maplibregl.LngLatBounds();
    plants.forEach(p => b.extend([p.lon, p.lat]));
    return b;
}

// Fit bounds with offset for info panels (mobile: extra bottom padding, desktop: extra left)
function flyToBoundsWithMobileOffset(bounds, options = {}) {
    const isMobile = window.innerWidth <= 600;
    const basePad = 40;
    const padding = { top: basePad, right: basePad, bottom: basePad, left: basePad };

    if (isMobile) {
        // Mobile: reserve vertical space for the bottom panel so markers sit in the visible top half.
        const panelOffset = (typeof getMobilePanelOffset === 'function')
            ? getMobilePanelOffset()
            : (window.innerHeight * 0.25);
        padding.bottom = basePad + Math.round(panelOffset * 2);
    } else {
        // Desktop: always reserve space for the left info overlay (even if it's about to open).
        const overlayEl = document.getElementById('countryInfoBox') || document.getElementById('plantInfoBox');
        let overlayWidth = 380;
        try {
            if (overlayEl) {
                // getBoundingClientRect() may be 0 if hidden; fall back to computed width.
                const rectW = overlayEl.getBoundingClientRect().width;
                if (rectW && rectW > 0) {
                    overlayWidth = rectW;
                } else {
                    const cssW = parseFloat(window.getComputedStyle(overlayEl).width);
                    if (cssW && cssW > 0) overlayWidth = cssW;
                }
            }
        } catch (e) {}
        // Add a little extra to clear the overlay shadow/padding.
        padding.left = basePad + Math.round(overlayWidth) + 30;
    }

    // MapLibre refuses a fit whose padding exceeds the container and silently does nothing,
    // so both axes are clamped. Today's mobile bottom padding is 40 + 50% of innerHeight,
    // which is exactly the case that would trip it.
    const el = map.getContainer();
    const H = el ? el.clientHeight : window.innerHeight;
    const W = el ? el.clientWidth : window.innerWidth;
    padding.bottom = Math.min(padding.bottom, Math.max(0, H - padding.top - 60));
    padding.left = Math.min(padding.left, Math.max(0, W - padding.right - 60));

    if (!bounds) return;
    map.fitBounds(bounds, {
        padding: padding,
        maxZoom: options.maxZoom,
        duration: options.duration ?? 1500,   // ?? so an intentional duration: 0 is honoured
        essential: true
    });
}

    
    // View options state
    let viewOptions = {
        showOperable: false,
        showConstruction: false,
        showPlanned: false,
        showShutdown: false,
        sizeByCapacity: false,
        sizeByProduction: false,
        // Plant size range filter (GW)
        capacityMin: 0,
        capacityMax: 10,
        // Plant production range filter (TWh) - v5.7.150
        productionMin: 0,
        productionMax: 50
    };

    // --- Capacity Range Slider helpers ---
    const CAPACITY_SLIDER_INSTANCES = [
        { min: 'capMinSlider',       max: 'capMaxSlider',       track: 'capTrack',       minLabel: 'capMinLabel',       maxLabel: 'capMaxLabel' },
        { min: 'capMinSliderMobile', max: 'capMaxSliderMobile', track: 'capTrackMobile', minLabel: 'capMinLabelMobile', maxLabel: 'capMaxLabelMobile' },
        { min: 'capMinSliderFilter', max: 'capMaxSliderFilter', track: 'capTrackFilter', minLabel: 'capMinLabelFilter', maxLabel: 'capMaxLabelFilter' }
    ];

    function formatCapacityGW(val) {
        const n = parseFloat(val);
        if (n >= 1) return n.toFixed(1) + ' GW';
        if (n > 0) return Math.round(n * 1000) + ' MW';
        return '0 GW';
    }

    function updateCapacitySliderUI(inst) {
        const minSlider = document.getElementById(inst.min);
        const maxSlider = document.getElementById(inst.max);
        const track     = document.getElementById(inst.track);
        const minLabel  = document.getElementById(inst.minLabel);
        const maxLabel  = document.getElementById(inst.maxLabel);
        if (!minSlider || !maxSlider) return;
        const min = parseFloat(minSlider.value);
        const max = parseFloat(maxSlider.value);
        const range = CAPACITY_SLIDER_MAX - CAPACITY_SLIDER_MIN;
        const minPct = ((min - CAPACITY_SLIDER_MIN) / range * 100).toFixed(2) + '%';
        const maxPct = ((max - CAPACITY_SLIDER_MIN) / range * 100).toFixed(2) + '%';
        if (track) {
            track.style.setProperty('--range-min-pct', minPct);
            track.style.setProperty('--range-max-pct', maxPct);
        }
        if (minLabel) minLabel.textContent = formatCapacityGW(min);
        if (maxLabel) maxLabel.textContent = formatCapacityGW(max);
        if (min >= max) {
            var midpoint = (CAPACITY_SLIDER_MAX + CAPACITY_SLIDER_MIN) / 2;
            minSlider.style.zIndex = (min >= midpoint) ? '4' : '';
        } else {
            minSlider.style.zIndex = '';
        }
    }

    function syncAllCapacitySliders() {
        CAPACITY_SLIDER_INSTANCES.forEach(inst => {
            const minEl = document.getElementById(inst.min);
            const maxEl = document.getElementById(inst.max);
            if (minEl) minEl.value = viewOptions.capacityMin;
            if (maxEl) maxEl.value = viewOptions.capacityMax;
            updateCapacitySliderUI(inst);
        });
    }

    function onCapacitySliderInput(idx, isMin) {
        const inst  = CAPACITY_SLIDER_INSTANCES[idx];
        const minEl = document.getElementById(inst.min);
        const maxEl = document.getElementById(inst.max);
        if (!minEl || !maxEl) return;
        let minVal = parseFloat(minEl.value);
        let maxVal = parseFloat(maxEl.value);
        if (isMin && minVal > maxVal) { minVal = maxVal; minEl.value = minVal; }
        if (!isMin && maxVal < minVal) { maxVal = minVal; maxEl.value = maxVal; }
        viewOptions.capacityMin = minVal;
        viewOptions.capacityMax = maxVal;
        syncAllCapacitySliders();
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
    }

    // --- Production Range Slider helpers (v5.7.150) ---
    const PRODUCTION_SLIDER_INSTANCES = [
        { min: 'prodMinSlider',       max: 'prodMaxSlider',       track: 'prodTrack',       minLabel: 'prodMinLabel',       maxLabel: 'prodMaxLabel' },
        { min: 'prodMinSliderMobile', max: 'prodMaxSliderMobile', track: 'prodTrackMobile', minLabel: 'prodMinLabelMobile', maxLabel: 'prodMaxLabelMobile' },
        { min: 'prodMinSliderFilter', max: 'prodMaxSliderFilter', track: 'prodTrackFilter', minLabel: 'prodMinLabelFilter', maxLabel: 'prodMaxLabelFilter' }
    ];

    function formatProductionTWh(val) {
        const n = parseFloat(val);
        if (n >= 1) return n.toFixed(1) + ' TWh';
        if (n > 0) return Math.round(n * 1000) + ' GWh';
        return '0 TWh';
    }

    function updateProductionSliderUI(inst) {
        const minSlider = document.getElementById(inst.min);
        const maxSlider = document.getElementById(inst.max);
        const track     = document.getElementById(inst.track);
        const minLabel  = document.getElementById(inst.minLabel);
        const maxLabel  = document.getElementById(inst.maxLabel);
        if (!minSlider || !maxSlider) return;
        const min = parseFloat(minSlider.value);
        const max = parseFloat(maxSlider.value);
        const range = PRODUCTION_SLIDER_MAX - PRODUCTION_SLIDER_MIN;
        const minPct = ((min - PRODUCTION_SLIDER_MIN) / range * 100).toFixed(2) + '%';
        const maxPct = ((max - PRODUCTION_SLIDER_MIN) / range * 100).toFixed(2) + '%';
        if (track) {
            track.style.setProperty('--range-min-pct', minPct);
            track.style.setProperty('--range-max-pct', maxPct);
        }
        if (minLabel) minLabel.textContent = formatProductionTWh(min);
        if (maxLabel) maxLabel.textContent = formatProductionTWh(max);
        if (min >= max) {
            var midpoint = (PRODUCTION_SLIDER_MAX + PRODUCTION_SLIDER_MIN) / 2;
            minSlider.style.zIndex = (min >= midpoint) ? '4' : '';
        } else {
            minSlider.style.zIndex = '';
        }
    }

    function syncAllProductionSliders() {
        PRODUCTION_SLIDER_INSTANCES.forEach(inst => {
            const minEl = document.getElementById(inst.min);
            const maxEl = document.getElementById(inst.max);
            if (minEl) minEl.value = viewOptions.productionMin;
            if (maxEl) maxEl.value = viewOptions.productionMax;
            updateProductionSliderUI(inst);
        });
    }

    function onProductionSliderInput(idx, isMin) {
        const inst  = PRODUCTION_SLIDER_INSTANCES[idx];
        const minEl = document.getElementById(inst.min);
        const maxEl = document.getElementById(inst.max);
        if (!minEl || !maxEl) return;
        let minVal = parseFloat(minEl.value);
        let maxVal = parseFloat(maxEl.value);
        if (isMin && minVal > maxVal) { minVal = maxVal; minEl.value = minVal; }
        if (!isMin && maxVal < minVal) { maxVal = minVal; maxEl.value = maxVal; }
        viewOptions.productionMin = minVal;
        viewOptions.productionMax = maxVal;
        syncAllProductionSliders();
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
    }

    // --- Filter Chip Rendering for Status Bar ---
    // v5.7.137: Added compact mode - shows "N filters active" when embedded (not fullscreen)
    function updateStatusBarFilters() {
        const filtersContainer = document.getElementById('statusBarFilters');
        const separator = document.getElementById('statusBarSeparator');
        if (!filtersContainer) return;

        // Clear existing chips
        filtersContainer.innerHTML = '';

        // v5.7.137: Detect compact mode (embedded, not fullscreen)
        const mapWrapper = document.getElementById('map-wrapper');
        const isCompact = mapWrapper && !mapWrapper.classList.contains('fullscreen');

        // Check if all filters within a category are selected (which means no effective filter)
        const allStatusSelected = viewOptions.showOperable && viewOptions.showConstruction && viewOptions.showPlanned && viewOptions.showShutdown;
        const capacityRangeActive = !(viewOptions.capacityMin <= CAPACITY_SLIDER_MIN && viewOptions.capacityMax >= CAPACITY_SLIDER_MAX);
        const productionRangeActive = !(viewOptions.productionMin <= PRODUCTION_SLIDER_MIN && viewOptions.productionMax >= PRODUCTION_SLIDER_MAX); // v5.7.150

        // Define filter chip configurations with category info
        const filterConfigs = [
            { key: 'showOperable', label: 'Operable', dotColor: 'green', category: 'status', checkboxIds: ['showOperable', 'showOperableMobile', 'filterShowOperable'] },
            { key: 'showConstruction', label: 'Under Construction', dotColor: 'yellow', category: 'status', checkboxIds: ['showConstruction', 'showConstructionMobile', 'filterShowConstruction'] },
            { key: 'showPlanned', label: 'Planned', dotColor: 'blue', category: 'status', checkboxIds: ['showPlanned', 'showPlannedMobile', 'filterShowPlanned'] },
            { key: 'showShutdown', label: 'Shutdown', dotColor: 'grey', category: 'status', checkboxIds: ['showShutdown', 'showShutdownMobile', 'filterShowShutdown'] }
        ];

        // v5.7.137: Count active filters first
        let activeFilterCount = 0;
        filterConfigs.forEach(config => {
            if (viewOptions[config.key] && !(config.category === 'status' && allStatusSelected)) {
                activeFilterCount++;
            }
        });
        if (capacityRangeActive) activeFilterCount++;
        if (productionRangeActive) activeFilterCount++; // v5.7.150

        let hasActiveFilters = activeFilterCount > 0;

        // v5.7.137: COMPACT MODE - show summary instead of individual chips
        if (isCompact && hasActiveFilters) {
            const summary = document.createElement('div');
            summary.className = 'filter-summary';

            const label = document.createElement('span');
            label.className = 'filter-summary-label';
            label.textContent = activeFilterCount + ' filter' + (activeFilterCount > 1 ? 's' : '') + ' active';
            summary.appendChild(label);

            const clearBtn = document.createElement('button');
            clearBtn.className = 'filter-summary-clear';
            clearBtn.type = 'button';
            clearBtn.setAttribute('aria-label', 'Clear all filters');
            clearBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
            clearBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                // Reset all status filters to show all
                viewOptions.showOperable = true;
                viewOptions.showConstruction = true;
                viewOptions.showPlanned = true;
                viewOptions.showShutdown = true;
                // Reset capacity range
                viewOptions.capacityMin = CAPACITY_SLIDER_MIN;
                viewOptions.capacityMax = CAPACITY_SLIDER_MAX;
                // Reset production range (v5.7.150)
                viewOptions.productionMin = PRODUCTION_SLIDER_MIN;
                viewOptions.productionMax = PRODUCTION_SLIDER_MAX;
                // Sync all checkboxes
                ['showOperable', 'showOperableMobile', 'filterShowOperable',
                 'showConstruction', 'showConstructionMobile', 'filterShowConstruction',
                 'showPlanned', 'showPlannedMobile', 'filterShowPlanned',
                 'showShutdown', 'showShutdownMobile', 'filterShowShutdown'].forEach(id => {
                    const cb = document.getElementById(id);
                    if (cb) cb.checked = true;
                });
                syncAllCapacitySliders();
                syncAllProductionSliders(); // v5.7.150

                updateMapForYear(currentSelectedYear);
                updateStatusBarFilters();
            });
            summary.appendChild(clearBtn);
            filtersContainer.appendChild(summary);
        } else if (!isCompact) {
            // FULL MODE - show individual chips (existing behavior)
            filterConfigs.forEach(config => {
                // Skip if filter is not active
                if (!viewOptions[config.key]) return;

                // Skip if all filters in this category are selected (no effective filtering)
                if (config.category === 'status' && allStatusSelected) return;

                const chip = document.createElement('div');
                chip.className = 'filter-chip';
                chip.setAttribute('data-filter-key', config.key);

                // Add colored dot for status filters
                if (config.dotColor) {
                    const dot = document.createElement('span');
                    dot.className = `filter-chip-dot ${config.dotColor}`;
                    chip.appendChild(dot);
                }

                // Add label
                const label = document.createElement('span');
                label.className = 'filter-chip-label';
                label.textContent = config.label;
                chip.appendChild(label);

                // Add remove button
                const removeBtn = document.createElement('button');
                removeBtn.className = 'filter-chip-remove';
                removeBtn.type = 'button';
                removeBtn.setAttribute('aria-label', `Remove ${config.label} filter`);
                removeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';

                // Click handler to remove filter
                removeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    viewOptions[config.key] = false;

                    // Uncheck all related checkboxes
                    config.checkboxIds.forEach(id => {
                        const checkbox = document.getElementById(id);
                        if (checkbox) checkbox.checked = false;
                    });

                    // Update the map
                    updateMapForYear(currentSelectedYear);

                    // Update the status bar
                    updateStatusBarFilters();
                });

                chip.appendChild(removeBtn);
                filtersContainer.appendChild(chip);
            });

            // Capacity range chip
            if (capacityRangeActive) {
                const chip = document.createElement('div');
                chip.className = 'filter-chip';
                chip.setAttribute('data-filter-key', 'capacityRange');
                const label = document.createElement('span');
                label.className = 'filter-chip-label';
                label.textContent = formatCapacityGW(viewOptions.capacityMin) + ' \u2013 ' + formatCapacityGW(viewOptions.capacityMax);
                chip.appendChild(label);
                const removeBtn = document.createElement('button');
                removeBtn.className = 'filter-chip-remove';
                removeBtn.type = 'button';
                removeBtn.setAttribute('aria-label', 'Remove capacity filter');
                removeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
                removeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    viewOptions.capacityMin = CAPACITY_SLIDER_MIN;
                    viewOptions.capacityMax = CAPACITY_SLIDER_MAX;
                    syncAllCapacitySliders();
                    updateMapForYear(currentSelectedYear);
                    updateStatusBarFilters();
                });
                chip.appendChild(removeBtn);
                filtersContainer.appendChild(chip);
            }

            // Production range chip (v5.7.150)
            if (productionRangeActive) {
                const chip = document.createElement('div');
                chip.className = 'filter-chip';
                chip.setAttribute('data-filter-key', 'productionRange');
                const label = document.createElement('span');
                label.className = 'filter-chip-label';
                label.textContent = formatProductionTWh(viewOptions.productionMin) + ' \u2013 ' + formatProductionTWh(viewOptions.productionMax);
                chip.appendChild(label);
                const removeBtn = document.createElement('button');
                removeBtn.className = 'filter-chip-remove';
                removeBtn.type = 'button';
                removeBtn.setAttribute('aria-label', 'Remove production filter');
                removeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
                removeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    viewOptions.productionMin = PRODUCTION_SLIDER_MIN;
                    viewOptions.productionMax = PRODUCTION_SLIDER_MAX;
                    syncAllProductionSliders();
                    updateMapForYear(currentSelectedYear);
                    updateStatusBarFilters();
                });
                chip.appendChild(removeBtn);
                filtersContainer.appendChild(chip);
            }

        }

        // Show/hide separator and filter icon based on whether there are active filters
        if (separator) {
            separator.style.display = hasActiveFilters ? '' : 'none';
        }

        const filterIcon = document.getElementById('statusBarFilterIcon');
        if (filterIcon) {
            filterIcon.style.display = hasActiveFilters ? '' : 'none';
        }

        // Refresh any open info boxes to reflect filter changes
        refreshInfoBoxesForFilters();
    }

    // Calculate max capacity for scaling
    let maxPlantCapacity = 0;
    let maxPlantProduction = 0;

    // --- 9. Get Reactor Status for a Given Year ---
    function getReactorStatusForYear(reactor, year) {
        const { constructionStart, gridConnection, shutdownDate } = reactor;

        // v5.7.134: Hide planned reactors for historical years (only show on present day)
        if (reactor.status === 'planned' && year !== MAX_YEAR) {
            return null;
        }

        // If we don't have timeline data, show based on current status
        if (!constructionStart && !gridConnection) {
            return reactor.status;
        }

        // Before construction started
        if (constructionStart && year < constructionStart) {
            // If reactor is planned, show as planned before construction starts
            if (reactor.status === 'planned') {
                return 'planned';
            }
            return null; // Don't show
        }

        // Under construction: started but not yet connected
        if (constructionStart && year >= constructionStart && (!gridConnection || year < gridConnection)) {
            return 'construction';
        }

        // After shutdown
        if (shutdownDate && year >= shutdownDate) {
            return 'shutdown';
        }

        // Permanent Shutdown with missing shutdown date — still treat as shutdown
        if (reactor.status === 'Permanent Shutdown') {
            return 'shutdown';
        }

        // Operable: connected and not yet shutdown
        if (gridConnection && year >= gridConnection) {
            return 'operable';
        }

        // If reactor is planned with no construction start date, show as planned
        if (reactor.status === 'planned') {
            return 'planned';
        }

        return null;
    }

    // --- 10. Get Plant Status for a Given Year ---
    function getPlantStatusForYear(plant, year) {
        let hasOperable = false;
        let hasConstruction = false;
        let hasPlanned = false;
        let hasShutdown = false;
        let hasAnyReactor = false;

        const activeReactors = [];

        plant.reactors.forEach(reactor => {
            const status = getReactorStatusForYear(reactor, year);
            if (status) {
                hasAnyReactor = true;
                activeReactors.push({ ...reactor, yearStatus: status });
                if (status === 'operable') hasOperable = true;
                else if (status === 'construction') hasConstruction = true;
                else if (status === 'planned') hasPlanned = true;
                else if (status === 'shutdown') hasShutdown = true;
            }
        });

        if (!hasAnyReactor) return null;

        // Determine plant color (priority: operable > construction > planned > shutdown)
        let color;
        if (hasOperable) {
            color = '#00b894'; // Green
        } else if (hasConstruction) {
            color = '#fdcb6e'; // Yellow
        } else if (hasPlanned) {
            color = '#74b9ff'; // Blue
        } else {
            color = '#636e72'; // Grey
        }

        return {
            color,
            activeReactors,
            stats: {
                operable: activeReactors.filter(r => r.yearStatus === 'operable').length,
                construction: activeReactors.filter(r => r.yearStatus === 'construction').length,
                planned: activeReactors.filter(r => r.yearStatus === 'planned').length,
                shutdown: activeReactors.filter(r => r.yearStatus === 'shutdown').length
            }
        };
    }

    // --- 10a1b. Generate Segmented Marker SVG (v5.7.145-markers: SVG arcs with proportional segments and count) ---
    // Creates a pie-chart style SVG marker. Segments are proportional to reactor count per status.
    // White center circle displays total reactor count. Single-status plants get a solid circle.
    function generateSegmentedMarkerSVG(plantStatus, size, plantName) {
        var activeReactors = plantStatus.activeReactors;
        if (!activeReactors || activeReactors.length === 0) return '';

        var cx = size / 2, cy = size / 2, r = size / 2 - 2;
        var total = activeReactors.length;

        // Count reactors by status
        var statusCounts = { operable: 0, construction: 0, planned: 0, shutdown: 0 };
        activeReactors.forEach(function(rx) { if (rx.yearStatus) statusCounts[rx.yearStatus]++; });

        var COLOR_OPERABLE = '#00b894';
        var COLOR_CONSTRUCTION = '#fdcb6e';
        var COLOR_PLANNED = '#74b9ff';
        var COLOR_SHUTDOWN = '#636e72';
        var colorMap = { operable: COLOR_OPERABLE, construction: COLOR_CONSTRUCTION, planned: COLOR_PLANNED, shutdown: COLOR_SHUTDOWN };

        // Build segment list for statuses with count > 0
        var segments = [];
        if (statusCounts.operable > 0) segments.push({ status: 'operable', count: statusCounts.operable });
        if (statusCounts.construction > 0) segments.push({ status: 'construction', count: statusCounts.construction });
        if (statusCounts.planned > 0) segments.push({ status: 'planned', count: statusCounts.planned });
        if (statusCounts.shutdown > 0) segments.push({ status: 'shutdown', count: statusCounts.shutdown });
        if (segments.length === 0) return '';

        // Font size scales with marker size
        var fontSize = Math.max(7, Math.min(13, Math.round(size * 0.35)));
        // Inner circle radius: 55% of outer radius
        var innerR = r * 0.55;

        var escapedName = escapeHtmlAttr(plantName || '');

        // Single status: solid circle with white center and count
        if (segments.length === 1) {
            return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" role="img" aria-label="' + escapedName + ' nuclear power plant">' +
                '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + colorMap[segments[0].status] + '" stroke="white" stroke-width="2"/>' +
                '<circle class="marker-detail" cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="white"/>' +
                '<text class="marker-detail" x="' + cx + '" y="' + cy + '" text-anchor="middle" dominant-baseline="central" fill="#2d3436" font-family="Muli,sans-serif" font-size="' + fontSize + '" font-weight="700">' + total + '</text>' +
                '</svg>';
        }

        // Multiple statuses: proportional arc segments
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" role="img" aria-label="' + escapedName + ' nuclear power plant">';
        var startAngle = -Math.PI / 2; // Start from 12 o'clock

        segments.forEach(function(seg) {
            var angle = (seg.count / total) * 2 * Math.PI;
            var endAngle = startAngle + angle;
            var largeArc = angle > Math.PI ? 1 : 0;
            var x1 = cx + r * Math.cos(startAngle), y1 = cy + r * Math.sin(startAngle);
            var x2 = cx + r * Math.cos(endAngle), y2 = cy + r * Math.sin(endAngle);
            svg += '<path d="M' + cx + ',' + cy + ' L' + x1 + ',' + y1 + ' A' + r + ',' + r + ' 0 ' + largeArc + ' 1 ' + x2 + ',' + y2 + ' Z" fill="' + colorMap[seg.status] + '" stroke="white" stroke-width="1"/>';
            startAngle = endAngle;
        });

        // White center circle with reactor count
        svg += '<circle class="marker-detail" cx="' + cx + '" cy="' + cy + '" r="' + innerR + '" fill="white"/>';
        svg += '<text class="marker-detail" x="' + cx + '" y="' + cy + '" text-anchor="middle" dominant-baseline="central" fill="#2d3436" font-family="Muli,sans-serif" font-size="' + fontSize + '" font-weight="700">' + total + '</text>';
        svg += '</svg>';

        return svg;
    }

    // --- 10a1c. Canvas marker image factory (v5.7.183) -------------------------------------
    //
    // Replaces the per-marker SVG divIcon with a small cache of canvas images that the GPU
    // scales. The icon is a pure function of the (operable, construction, planned, shutdown)
    // tuple, and there are ~111 distinct tuples across 1954-2026, so the cache is bounded by
    // variant count rather than plant count. Geometry is a direct port of
    // generateSegmentedMarkerSVG above; keep the two in step until that one is deleted.
    //
    // Masters are drawn at MK_MASTER_PX CSS px with pixelRatio MK_PR, and icon-size scales
    // them to the per-plant sizePx. Everything is expressed against the 28px reference the
    // SVG used, then multiplied by MK_REF_SCALE, so the numbers below match the SVG exactly.
    const MK_COLORS = { operable: '#00b894', construction: '#fdcb6e', planned: '#74b9ff', shutdown: '#636e72' };
    const MK_ORDER = ['operable', 'construction', 'planned', 'shutdown'];
    const MK_MASTER_PX = 42;          // a 42px master means size-by mode (max 42px) never upscales
    const MK_PR = 2;                  // device pixels per CSS pixel in the master bitmap
    const MK_REF = 28;                // the reference size the SVG geometry was written for
    const MK_REF_SCALE = MK_MASTER_PX / MK_REF;
    const MK_CLUSTER_PX = 40;

    // Reproduces CSS grayscale(70%): 30% of the original plus 70% of its luminance.
    function greyOf(hex) {
        const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
        const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        const mix = c => Math.round(0.3 * c + 0.7 * lum);
        const h = n => n.toString(16).padStart(2, '0');
        return '#' + h(mix(r)) + h(mix(g)) + h(mix(b));
    }
    const MK_GREY = {};
    MK_ORDER.forEach(k => { MK_GREY[k] = greyOf(MK_COLORS[k]); });

    // Every text-bearing image ever drawn, so they can be redrawn once Muli arrives.
    const mkTextImageIds = new Set();

    function mkCanvas(cssPx) {
        const c = document.createElement('canvas');
        c.width = cssPx * MK_PR;
        c.height = cssPx * MK_PR;
        const ctx = c.getContext('2d');
        ctx.scale(MK_PR, MK_PR);
        return { canvas: c, ctx: ctx };
    }

    // counts: {operable, construction, planned, shutdown}
    function drawPieVariant(counts, opts) {
        const grey = !!(opts && opts.grey), detail = !!(opts && opts.detail);
        const palette = grey ? MK_GREY : MK_COLORS;
        const total = MK_ORDER.reduce((a, k) => a + counts[k], 0);
        if (!total) return null;

        const S = MK_REF_SCALE;
        const cx = MK_MASTER_PX / 2, cy = MK_MASTER_PX / 2;
        const r = (MK_REF / 2 - 2) * S;            // SVG: size/2 - 2
        const innerR = r * 0.55;
        const o = mkCanvas(MK_MASTER_PX), ctx = o.ctx;

        const segs = MK_ORDER.filter(k => counts[k] > 0).map(k => ({ status: k, count: counts[k] }));

        if (segs.length === 1) {
            // Single status: solid circle, white stroke 2 at the 28px reference.
            ctx.beginPath();
            ctx.arc(cx, cy, r, 0, Math.PI * 2);
            ctx.fillStyle = palette[segs[0].status];
            ctx.fill();
            ctx.lineWidth = 2 * S;
            ctx.strokeStyle = '#ffffff';
            ctx.stroke();
        } else {
            // Proportional wedges from 12 o'clock, white stroke 1 at the reference.
            let start = -Math.PI / 2;
            segs.forEach(function (seg) {
                const end = start + (seg.count / total) * 2 * Math.PI;
                ctx.beginPath();
                ctx.moveTo(cx, cy);
                ctx.arc(cx, cy, r, start, end);
                ctx.closePath();
                ctx.fillStyle = palette[seg.status];
                ctx.fill();
                ctx.lineWidth = 1 * S;
                ctx.strokeStyle = '#ffffff';
                ctx.stroke();
                start = end;
            });
        }

        if (detail) {
            ctx.beginPath();
            ctx.arc(cx, cy, innerR, 0, Math.PI * 2);
            ctx.fillStyle = '#ffffff';
            ctx.fill();
            // The detail flavour is only ever used at the default 28px size (size-by mode uses
            // the plain flavour), so the reference font size is fixed rather than per-plant.
            const fontRef = Math.max(7, Math.min(13, Math.round(MK_REF * 0.35)));
            ctx.font = '700 ' + (fontRef * S) + 'px Muli, sans-serif';
            ctx.fillStyle = '#2d3436';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(String(total), cx, cy);
        }

        return ctx.getImageData(0, 0, o.canvas.width, o.canvas.height);
    }

    function drawClusterBadge(n, dark) {
        const P = MK_CLUSTER_PX;
        const o = mkCanvas(P), ctx = o.ctx;
        ctx.beginPath();
        ctx.arc(P / 2, P / 2, P / 2, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(124, 159, 212, 0.3)';
        ctx.fill();
        ctx.beginPath();
        ctx.arc(P / 2, P / 2, 15, 0, Math.PI * 2);   // inner disc is 30px wide
        ctx.fillStyle = 'rgba(124, 159, 212, 0.7)';
        ctx.fill();
        ctx.font = '700 12px Muli, sans-serif';
        ctx.fillStyle = dark ? '#e0e0e0' : '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(String(n), P / 2, P / 2);
        return ctx.getImageData(0, 0, o.canvas.width, o.canvas.height);
    }

    // Flavour and size both derive from the id, so the font-ready updateImage pass is always
    // the same dimensions as the image it replaces (MapLibre requires that).
    function renderImageForId(id) {
        const i = id.indexOf(':');
        if (i < 0) return null;
        const kind = id.slice(0, i), rest = id.slice(i + 1);
        if (kind === 'cl' || kind === 'cld') {
            return drawClusterBadge(rest, kind === 'cld');
        }
        if (kind !== 'p' && kind !== 'd' && kind !== 'gp' && kind !== 'gd') return null;
        const parts = rest.split(',').map(Number);
        if (parts.length !== 4 || parts.some(isNaN)) return null;
        const counts = { operable: parts[0], construction: parts[1], planned: parts[2], shutdown: parts[3] };
        return drawPieVariant(counts, { grey: kind.charAt(0) === 'g', detail: kind.charAt(kind.length - 1) === 'd' });
    }

    function ensureImage(id) {
        if (!mapAvailable || !id || map.hasImage(id)) return;
        const data = renderImageForId(id);
        if (!data) return;
        try {
            map.addImage(id, data, { pixelRatio: MK_PR });
            // 'd:'/'gd:' carry the count; clusters carry their number.
            if (/^(d|gd|cl|cld):/.test(id)) mkTextImageIds.add(id);
        } catch (e) {}
    }

    // Pre-warm the variants a feature collection references, so the first frame has them
    // rather than relying on styleimagemissing round trips.
    function ensurePlantImages(fc) {
        if (!mapAvailable || !fc || !fc.features) return;
        const seen = new Set();
        fc.features.forEach(function (f) {
            const v = f.properties && f.properties.variant;
            if (!v || seen.has(v)) return;
            seen.add(v);
            ensureImage('p:' + v);
            ensureImage('d:' + v);
            ensureImage('gp:' + v);
            ensureImage('gd:' + v);
        });
    }

    // Cluster counts are unbounded, so those are drawn on demand.
    if (mapAvailable) map.on('styleimagemissing', function (e) { ensureImage(e.id); });

    // Dark mode swaps the whole clusters layer to the 'cld:' image family rather than
    // redrawing in place.
    function refreshClusterBadges() {
        if (!mapAvailable || !styleReady || !map.getLayer('clusters')) return;
        const dark = document.documentElement.getAttribute('data-theme') === 'dark';
        try {
            map.setLayoutProperty('clusters', 'icon-image',
                ['concat', dark ? 'cld:' : 'cl:', ['to-string', ['get', 'point_count']]]);
        } catch (e) {}
    }

    // Canvas fillText uses whatever font is resolvable at draw time, so counts drawn before
    // Muli loads would be cached in a fallback face. Redraw them when it arrives. The 1.5s
    // timeout only unblocks first paint; it must not cancel the eventual correction, so the
    // font promise is chained independently as well.
    function redrawTextImages() {
        if (!mapAvailable || !mkTextImageIds.size) return;
        mkTextImageIds.forEach(function (id) {
            if (!map.hasImage(id)) return;
            const data = renderImageForId(id);
            if (data) { try { map.updateImage(id, data); } catch (e) {} }
        });
        if (map.triggerRepaint) map.triggerRepaint();
    }
    try {
        if (document.fonts && document.fonts.load) {
            const muli = document.fonts.load('700 13px Muli').then(function () { return document.fonts.ready; });
            Promise.race([muli, new Promise(function (r) { setTimeout(r, 1500); })]).then(redrawTextImages);
            muli.then(redrawTextImages).catch(function () {});
        }
    } catch (e) {}

    // --- 10a2. Get Filtered Plant Status for Year (respects viewOptions filters) ---
    function getFilteredPlantStatusForYear(plant, year) {
        const plantStatus = getPlantStatusForYear(plant, year);
        if (!plantStatus) return null;

        // Check if any status filters are active
        const noStatusFiltersActive = !viewOptions.showOperable && !viewOptions.showConstruction && !viewOptions.showPlanned && !viewOptions.showShutdown;

        // Check if capacity range filter is active
        const noCapacityFiltersActive = (viewOptions.capacityMin <= CAPACITY_SLIDER_MIN && viewOptions.capacityMax >= CAPACITY_SLIDER_MAX);
        // Check if production range filter is active (v5.7.150)
        const noProductionFiltersActive = (viewOptions.productionMin <= PRODUCTION_SLIDER_MIN && viewOptions.productionMax >= PRODUCTION_SLIDER_MAX);
        const noSizeFiltersActive = noCapacityFiltersActive && noProductionFiltersActive;

        // If no filters active, return original status
        if (noStatusFiltersActive && noSizeFiltersActive) {
            return plantStatus;
        }

        // Filter reactors based on active status filters
        let filteredReactors = plantStatus.activeReactors;

        if (!noStatusFiltersActive) {
            filteredReactors = filteredReactors.filter(reactor => {
                if (reactor.yearStatus === 'operable' && viewOptions.showOperable) return true;
                if (reactor.yearStatus === 'construction' && viewOptions.showConstruction) return true;
                if (reactor.yearStatus === 'planned' && viewOptions.showPlanned) return true;
                if (reactor.yearStatus === 'shutdown' && viewOptions.showShutdown) return true;
                return false;
            });
        }

        // If no reactors pass the status filter, return null
        if (filteredReactors.length === 0) return null;

        // Check plant size against capacity range filter
        if (!noCapacityFiltersActive) {
            const filteredCapacityGW = filteredReactors.reduce((sum, r) => sum + (r.capacity || 0), 0) / 1000;
            if (filteredCapacityGW < viewOptions.capacityMin || filteredCapacityGW > viewOptions.capacityMax) return null;
        }

        // Check plant production against production range filter (v5.7.150)
        if (!noProductionFiltersActive) {
            const filteredProductionTWh = filteredReactors
                .filter(r => r.yearStatus === 'operable')
                .reduce((sum, r) => sum + getReactorProductionForYear(r, year), 0) / 1000;
            if (filteredProductionTWh < viewOptions.productionMin || filteredProductionTWh > viewOptions.productionMax) return null;
        }

// Recalculate plant color based on filtered reactors (priority: operable > construction > planned > shutdown)
        const hasOperable = filteredReactors.some(r => r.yearStatus === 'operable');
        const hasConstruction = filteredReactors.some(r => r.yearStatus === 'construction');
        const hasPlanned = filteredReactors.some(r => r.yearStatus === 'planned');

        let color;
        if (hasOperable) {
            color = '#00b894'; // Green
        } else if (hasConstruction) {
            color = '#fdcb6e'; // Yellow
        } else if (hasPlanned) {
            color = '#74b9ff'; // Blue
        } else {
            color = '#636e72'; // Grey
        }

        return {
            color,
            activeReactors: filteredReactors,
            stats: {
                operable: filteredReactors.filter(r => r.yearStatus === 'operable').length,
                construction: filteredReactors.filter(r => r.yearStatus === 'construction').length,
                planned: filteredReactors.filter(r => r.yearStatus === 'planned').length,
                shutdown: filteredReactors.filter(r => r.yearStatus === 'shutdown').length
            }
        };
    }

    // --- 10a3. Get Human-Readable List of Active Filters ---
    function getActiveFiltersDescription() {
        const activeFilters = [];

        // Check status filters
        const noStatusFiltersActive = !viewOptions.showOperable && !viewOptions.showConstruction && !viewOptions.showPlanned && !viewOptions.showShutdown;
        if (!noStatusFiltersActive) {
            if (viewOptions.showOperable) activeFilters.push('Operable');
            if (viewOptions.showConstruction) activeFilters.push('Under Construction');
            if (viewOptions.showPlanned) activeFilters.push('Planned');
            if (viewOptions.showShutdown) activeFilters.push('Shutdown');
        }

        // Check capacity range filter
        const noCapacityFilterActive = (viewOptions.capacityMin <= CAPACITY_SLIDER_MIN && viewOptions.capacityMax >= CAPACITY_SLIDER_MAX);
        if (!noCapacityFilterActive) {
            activeFilters.push(formatCapacityGW(viewOptions.capacityMin) + ' \u2013 ' + formatCapacityGW(viewOptions.capacityMax));
        }

        // Check production range filter (v5.7.150)
        const noProductionFilterActive = (viewOptions.productionMin <= PRODUCTION_SLIDER_MIN && viewOptions.productionMax >= PRODUCTION_SLIDER_MAX);
        if (!noProductionFilterActive) {
            activeFilters.push(formatProductionTWh(viewOptions.productionMin) + ' \u2013 ' + formatProductionTWh(viewOptions.productionMax));
        }

        return activeFilters;
    }

    // --- 10b. Get Reactor Production for a Given Year ---
    function getReactorProductionForYear(reactor, year) {
        // Check if we have year-specific production data
        if (reactor.productionByYear && reactor.productionByYear[year] != null) {
            const val = reactor.productionByYear[year];
            return Number.isFinite(val) ? val : 0;
        }
        // Fallback: if requesting MAX_YEAR (present), use the static production field
        if (year === MAX_YEAR && reactor.production != null) {
            return Number.isFinite(reactor.production) ? reactor.production : 0;
        }
        return 0;
    }

    // --- 10c. Get Plant Production for a Given Year ---
    function getPlantProductionForYear(plant, plantStatus, year) {
        if (!plantStatus || !plantStatus.activeReactors) return 0;
        return plantStatus.activeReactors
            // v5.7.177: Include shutdown reactors that shut down THIS year (partial-year production)
            .filter(r => r.yearStatus === 'operable' || (r.yearStatus === 'shutdown' && r.shutdownDate === year))
            .reduce((sum, r) => sum + getReactorProductionForYear(r, year), 0);
    }

    // --- 10d. Get Plant Capacity for a Given Year (sum of active reactors) ---
    function getPlantCapacityForYear(plantStatus) {
        if (!plantStatus || !plantStatus.activeReactors) return 0;
        return plantStatus.activeReactors.reduce((sum, r) => sum + (r.capacity || 0), 0);
    }

    // --- 11. Generate Reactor HTML (Dynamic Layout) ---
    
    // --- Helper: safe HTML attribute escaping ---
    function escapeHtmlAttr(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    // --- Helper: safe HTML content escaping (for text content, not attributes) ---
    function escapeHtml(value) {
        if (value == null) return '';
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    // --- Helper: sanitize URLs to prevent javascript: protocol injection ---
    function sanitizeUrl(url) {
        if (!url) return '';
        const str = String(url).trim();
        // Only allow http and https protocols
        if (/^https?:\/\//i.test(str)) {
            return escapeHtmlAttr(str);
        }
        // Reject javascript:, data:, vbscript:, and other dangerous protocols
        return '';
    }

    // --- CTA: open detailed plant summary (used in mobile popups) ---
    function generatePlantDetailsCtaHTML(plant) {
        if (!plant) return '';
        const plantName = escapeHtmlAttr(plant.name || '');
        // v5.7.164: In embed mode, show "View in Explorer" link opening full app in new tab
        if (isEmbedMode) {
            const plantUrl = escapeHtmlAttr(window.location.pathname + '?plant=' + encodeURIComponent(plant.name || ''));
            return `
                <div class="popup-details-footer">
                    <a href="${plantUrl}" target="_blank" rel="noopener" class="plant-details-btn" style="text-decoration:none;color:inherit;display:flex;align-items:center;justify-content:center;gap:6px;" aria-label="View ${plantName} in Explorer">
                        <span class="plant-details-btn-label">View in Explorer</span>
                        <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="14" height="14">
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                    </a>
                </div>
            `;
        }
        return `
            <div class="popup-details-footer">
                <button type="button" class="plant-details-btn" data-plant-name="${plantName}" aria-label="View detailed summary for ${plantName}">
                    <span class="plant-details-btn-label">View detailed summary</span>
                    <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" viewbox="0 0 24 24" width="16" height="16">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            </div>
        `;
    }


function generatePlantHoverTooltipHTML(plant, plantStatus, year) {
    if (!plant || !plantStatus) return '';
    const displayYear = year || currentSelectedYear || MAX_YEAR;

    // Derive plant status for the currently selected year (getPlantStatusForYear provides stats, not a top-level status)
    let status = 'shutdown';
    if (plantStatus && plantStatus.stats) {
        if (plantStatus.stats.operable > 0) status = 'operable';
        else if (plantStatus.stats.construction > 0) status = 'construction';
        else if (plantStatus.stats.planned > 0) status = 'planned';
        else if (plantStatus.stats.shutdown > 0) status = 'shutdown';
    } else if (plantStatus && Array.isArray(plantStatus.activeReactors)) {
        const statuses = plantStatus.activeReactors
            .map(r => r.yearStatus || r.status)
            .filter(Boolean);
        if (statuses.includes('operable')) status = 'operable';
        else if (statuses.includes('construction')) status = 'construction';
        else if (statuses.includes('planned')) status = 'planned';
        else if (statuses.includes('shutdown')) status = 'shutdown';
    }
    const badgeClass = status === 'operable' ? 'green' : (status === 'construction' ? 'yellow' : (status === 'planned' ? 'blue' : 'grey'));
    const badgeText = status === 'operable' ? 'Operable' : (status === 'construction' ? 'Construction' : (status === 'planned' ? 'Planned' : 'Shutdown'));

    // Capacity for visible reactors (in GW) for the currently selected year
    const visibleCapacity = getPlantCapacityForYear(plantStatus);
    const capGW = (visibleCapacity / 1000).toFixed(1);

    // Production for selected year (TWh)
    const visibleProduction = getPlantProductionForYear(plant, plantStatus, displayYear);
    const outputTWh = visibleProduction > 0 ? (visibleProduction / 1000).toFixed(2) : null;

    const yearLabel = displayYear === MAX_YEAR ? '' : ` (${displayYear})`;
    const outputHTML = outputTWh ? `<span><b>${outputTWh}</b> TWh${yearLabel}</span>` : '';

    return `
        <div class="pht">
            <div class="pht-top">
                <div class="pht-country">${escapeHtml(plant.country || '')}</div>
                <div class="pht-badge ${badgeClass}">${badgeText}</div>
            </div>
            <div class="pht-name">${escapeHtml(plant.name || '')}</div>
            <div class="pht-meta">
                <span><b>${(plantStatus.activeReactors || []).length}</b> reactors</span>
                <span><b>${capGW}</b> GW</span>
                ${outputHTML}
            </div>
        </div>
    `;
}


function generateReactorHTML(plant, activeReactors, year) {
        if (!activeReactors || activeReactors.length === 0) {
            return '';
        }
        // year parameter available for future use (individual reactor production display)

        const reactorCount = activeReactors.length;
        
        // Check if any reactors have URLs (are clickable)
        const hasClickableReactors = activeReactors.some(r => r.url);

        // Show full list for up to 8 reactors, summary only for 9+
        if (reactorCount > 8) {
            // Compact summary view for many reactors
            const operableCount = activeReactors.filter(r => r.yearStatus === 'operable').length;
            const constructionCount = activeReactors.filter(r => r.yearStatus === 'construction').length;
            const plannedCount = activeReactors.filter(r => r.yearStatus === 'planned').length;
            const shutdownCount = activeReactors.filter(r => r.yearStatus === 'shutdown').length;

            let html = `
                <div class="reactor-section">
                    <div class="reactor-summary">
                        <div style="display: flex; gap: 16px; justify-content: center; padding: 8px 0; flex-wrap: wrap;">
                            ${operableCount > 0 ? `<span style="display: flex; align-items: center; gap: 6px;"><span style="width: 8px; height: 8px; border-radius: 50%; background: #00b894;"></span><span style="font-size: 13px; font-weight: 700; color: #2d3436;">${operableCount} operable</span></span>` : ''}
                            ${constructionCount > 0 ? `<span style="display: flex; align-items: center; gap: 6px;"><span style="width: 8px; height: 8px; border-radius: 50%; background: #fdcb6e;"></span><span style="font-size: 13px; font-weight: 700; color: #2d3436;">${constructionCount} construction</span></span>` : ''}
                            ${plannedCount > 0 ? `<span style="display: flex; align-items: center; gap: 6px;"><span style="width: 8px; height: 8px; border-radius: 50%; background: #74b9ff;"></span><span style="font-size: 13px; font-weight: 700; color: #2d3436;">${plannedCount} planned</span></span>` : ''}
                            ${shutdownCount > 0 ? `<span style="display: flex; align-items: center; gap: 6px;"><span style="width: 8px; height: 8px; border-radius: 50%; background: #636e72;"></span><span style="font-size: 13px; font-weight: 700; color: #2d3436;">${shutdownCount} shutdown</span></span>` : ''}
                        </div>
                    </div>
                </div>
            `;
            return html;

        } else {
            // Clean list view with clickable reactors
            let html = `
                <div class="reactor-section">
                    ${hasClickableReactors ? `<div style="font-size: 10px; font-weight: 600; color: #5777a9; text-transform: uppercase; letter-spacing: 0.5px; padding-bottom: 8px; display: flex; align-items: center; gap: 6px;">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                        Click reactor for database details
                    </div>` : ''}
                    <div class="reactor-list-clean">
            `;

            activeReactors.forEach((reactor) => {
                const statusColor = reactor.yearStatus === 'operable' ? '#00b894' :
                                   reactor.yearStatus === 'construction' ? '#fdcb6e' :
                                   reactor.yearStatus === 'planned' ? '#74b9ff' : '#636e72';
                const capMW = reactor.capacity ? `${reactor.capacity} MW` : '';
                const reactorName = escapeHtml(reactor.displayName || reactor.name || 'Reactor');
                const safeUrl = sanitizeUrl(reactor.url);

                if (safeUrl) {
                    html += `
                        <a href="${safeUrl}" target="_blank" rel="noopener noreferrer" class="reactor-link-hover" style="text-decoration: none; display: flex; align-items: center; gap: 10px; padding: 8px 4px; border-bottom: 1px solid #f1f3f5; transition: background 0.15s; border-radius: 4px; margin: 0 -4px;">
                            <span style="width: 8px; height: 8px; border-radius: 50%; background: ${statusColor}; flex-shrink: 0;"></span>
                            <span style="flex: 1; font-size: 13px; font-weight: 600; color: #2d3436;">${reactorName}</span>
                            <span style="font-size: 12px; color: #8898aa; font-weight: 600;">${capMW}</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#5777a9" stroke-width="2" style="flex-shrink: 0; opacity: 0.6;"><polyline points="9 18 15 12 9 6"></polyline></svg>
                        </a>
                    `;
                } else {
                    html += `
                        <div style="display: flex; align-items: center; gap: 10px; padding: 8px 0; border-bottom: 1px solid #f1f3f5;">
                            <span style="width: 8px; height: 8px; border-radius: 50%; background: ${statusColor}; flex-shrink: 0;"></span>
                            <span style="flex: 1; font-size: 13px; font-weight: 600; color: #2d3436;">${reactorName}</span>
                            <span style="font-size: 12px; color: #8898aa; font-weight: 600;">${capMW}</span>
                        </div>
                    `;
                }
            });

            html += `</div></div>`;
            return html;
        }
    }

    

// --- 12. Update Map for Selected Year ---
    // Plants whose reactors changed state in this year. Extracted from applyYearChangePulse so
    // the feature builder can bake it in as the `chg` property.
    function getYearChangedPlantNames(year) {
        const changedPlantNames = new Set();
        nuclearPlants.forEach(plant => {
            plant.reactors.forEach(reactor => {
                if (reactor.gridConnection === year || reactor.constructionStart === year || reactor.shutdownDate === year) {
                    changedPlantNames.add(plant.name);
                }
            });
        });
        return changedPlantNames;
    }

    // --- Phase 2: interaction on the GPU layers ---------------------------------------------
    //
    // Every pointer event binds to `plants-hit`, the transparent circle layer, never to the
    // symbol layer: symbol hit areas lag interpolated icon-size at fractional zoom (upstream
    // issue #128, closed wontfix), and the hit circle follows the same zoom ramp as the pie.

    // Gated at hover time rather than at build time, which also fixes the old staleness when
    // the window was resized across the 600px boundary after markers had been created.
    function hoverAllowed() {
        return window.innerWidth > 600 &&
            (!window.matchMedia || window.matchMedia('(pointer: fine)').matches);
    }

    let hoverPopup = null;
    let hoverPid = null;

    function getHoverPopup() {
        if (!hoverPopup) {
            hoverPopup = new maplibregl.Popup({
                closeButton: false,
                closeOnClick: false,
                focusAfterOpen: false,      // stops MapLibre pulling focus and scrolling the CMS page
                anchor: 'bottom',
                offset: 18,
                maxWidth: 'none',           // the default 240px would clip the nowrap plant name
                className: 'plant-hover-tooltip'
            });
            // NOT trackPointer(): with it, Popup.addTo() leaves the popup unpositioned until
            // the NEXT mousemove, so the first hover on a marker flashes in the map corner
            // before jumping to the cursor. Following the pointer with setLngLat on each move
            // is public API, positions correctly on the very first frame, and reproduces
            // Leaflet's sticky: true just as well.
        }
        return hoverPopup;
    }

    function hideHoverTooltip() {
        hoverPid = null;
        if (hoverPopup) hoverPopup.remove();
    }

    // Click popup. Embed mode only, as before.
    let currentPopup = null;

    function closePlantPopup() {
        if (currentPopup) {
            currentPopup.remove();
            currentPopup = null;
        }
    }

    function openPlantPopup(plant, plantStatus, sizePx) {
        closePlantPopup();
        if (!mapAvailable || typeof maplibregl === 'undefined') return;
        currentPopup = new maplibregl.Popup({
            closeButton: true,
            closeOnClick: true,
            focusAfterOpen: false,
            maxWidth: '320px',
            className: 'plant-popup',
            // Replaces the old popup-bottom CSS plus translate3d hack, which the very next
            // zoom event undid. An anchor survives the flight that follows the click.
            anchor: plant.lat > 55 ? 'top' : 'bottom',
            offset: Math.round((sizePx || 28) / 2) + 4
        })
            .setLngLat([plant.lon, plant.lat])
            .setHTML('<div class="plant-popup-inner">' + buildPlantPopupHTML(plant, plantStatus, currentSelectedYear) + '</div>')
            .addTo(map);
    }

    // Shared by the marker click and the keyboard browse list, so both routes behave the same.
    function handlePlantSelection(plant) {
        if (!plant) return;
        const dest = [plant.lon, plant.lat];
        const plantStatus = getPlantStatusForYear(plant, currentSelectedYear);

        if (isEmbedMode) {
            if (plantStatus) openPlantPopup(plant, plantStatus, 28);
            map.flyTo({ center: dest, zoom: Math.max(map.getZoom(), 9), duration: 1000, essential: true });
            return;
        }

        const isMobile = window.innerWidth <= 600;
        const targetZoom = Math.max(map.getZoom(), 13);

        if (isMobile) {
            // Offset vertically so the plant sits in the top half, above the bottom sheet.
            flyToWithOffset(dest, targetZoom, 0, -getMobilePanelOffset(), { duration: 2500 });
            if (typeof window.openPlantPanel === 'function') window.openPlantPanel(plant);
            applySearchHighlight(p => p.name === plant.name);
        } else {
            // Offset horizontally to clear the left info overlay.
            flyToWithOffset(dest, targetZoom, getDesktopOverlayOffsetX(), 0, { duration: 2500 });
            navPush();
            showPlantInfoOverlay(plant);
            applySearchHighlight(p => p.name === plant.name);
        }
    }

    function plantFromFeature(f) {
        if (!f || !f.properties) return null;
        return nuclearPlants[+f.properties.plantIndex] || null;
    }

    // --- Year-change pulse -------------------------------------------------------------------
    // Only CONSTANT paint values are animated: touching a data-driven paint property would
    // trigger a source relayout in the worker on every frame. The radius is the static,
    // data-driven sizePx/2 + 2, so the ring hugs each marker including the size-by modes, and
    // the animation grows it outward through stroke width instead.
    let pulseGen = 0;
    let pulseRaf = null;

    function stopYearPulse() {
        if (pulseRaf) { cancelAnimationFrame(pulseRaf); pulseRaf = null; }
        if (mapAvailable && map.getLayer && map.getLayer('plants-pulse')) {
            try {
                map.setPaintProperty('plants-pulse', 'circle-stroke-width', 0);
                map.setPaintProperty('plants-pulse', 'circle-stroke-opacity', 0);
            } catch (e) {}
        }
    }

    function startYearPulse(gen) {
        if (!mapAvailable || !styleReady || !map.getLayer('plants-pulse')) return;
        stopYearPulse();
        const t0 = performance.now();
        (function step() {
            if (gen !== pulseGen) return;                 // a newer tick has taken over
            const t = Math.min(1, (performance.now() - t0) / 1000);
            try {
                map.setPaintProperty('plants-pulse', 'circle-stroke-width', 10 * t);
                map.setPaintProperty('plants-pulse', 'circle-stroke-opacity', 0.6 * (1 - t));
            } catch (e) { return; }
            if (t < 1) { pulseRaf = requestAnimationFrame(step); }
            else { pulseRaf = null; stopYearPulse(); }
        })();
    }

    // --- Keyboard browse list ----------------------------------------------------------------
    // Leaflet gave every marker tabindex=0 and Enter opened its popup; canvas markers cannot.
    // This list is rebuilt from the same FeatureCollection the map draws, so it always matches
    // what is visible, including filters and the selected year, and it is reachable in one Tab
    // rather than by walking 300-odd markers in latitude order.
    let browseListFC = null;
    let browseListStale = true;

    // Cheap: only the count, which is announced via aria-live. Called on every data push.
    function markMapBrowseListStale(fc) {
        browseListFC = fc;
        browseListStale = true;
        const toggleEl = document.getElementById('mapBrowseToggle');
        const listEl = document.getElementById('mapBrowseList');
        const feats = (fc && fc.features) ? fc.features : [];
        if (toggleEl) toggleEl.textContent = 'Browse ' + feats.length + ' plants on the map';
        // Only pay for the rows if someone is actually looking at them.
        if (listEl && !listEl.hasAttribute('hidden')) rebuildMapBrowseList(fc);
    }

    // Expensive: ~334 rows. Only on open, or on a push while already open.
    function rebuildMapBrowseList(fc) {
        const listEl = document.getElementById('mapBrowseList');
        const toggleEl = document.getElementById('mapBrowseToggle');
        if (!listEl || !toggleEl) return;
        const feats = (fc && fc.features) ? fc.features : [];
        toggleEl.textContent = 'Browse ' + feats.length + ' plants on the map';
        browseListStale = false;
        // Alphabetical by country then plant: a predictable order to arrow through.
        const rows = feats.slice().sort((a, b) => {
            const ca = a.properties.country || '', cb = b.properties.country || '';
            if (ca !== cb) return ca.localeCompare(cb);
            return (a.properties.name || '').localeCompare(b.properties.name || '');
        });
        const frag = document.createDocumentFragment();
        rows.forEach(f => {
            const p = f.properties;
            const li = document.createElement('li');
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('data-pid', p.plantIndex);
            b.textContent = p.name + ', ' + p.country + ', ' + p.cnt + (p.cnt === 1 ? ' reactor' : ' reactors');
            li.appendChild(b);
            frag.appendChild(li);
        });
        listEl.textContent = '';
        listEl.appendChild(frag);
    }

    (function initMapBrowseList() {
        const listEl = document.getElementById('mapBrowseList');
        const toggleEl = document.getElementById('mapBrowseToggle');
        if (!listEl || !toggleEl) return;
        toggleEl.addEventListener('click', () => {
            const open = listEl.hasAttribute('hidden');
            if (open) {
                if (browseListStale) rebuildMapBrowseList(browseListFC || lastPlantFC);
                listEl.removeAttribute('hidden');
            } else { listEl.setAttribute('hidden', ''); }
            toggleEl.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (open) { const first = listEl.querySelector('button'); if (first) first.focus(); }
        });
        listEl.addEventListener('click', (e) => {
            const b = e.target.closest('button[data-pid]');
            if (!b) return;
            handlePlantSelection(nuclearPlants[+b.getAttribute('data-pid')]);
        });
    })();

    // --- Event wiring ------------------------------------------------------------------------
    if (mapAvailable) {
        whenStyleReady(function () {
            const canvas = () => map.getCanvas();

            map.on('mousemove', 'plants-hit', function (e) {
                canvas().style.cursor = 'pointer';
                if (!hoverAllowed() || !e.features || !e.features.length) return;
                const f = e.features[0];
                const plant = plantFromFeature(f);
                if (!plant) return;
                // mousemove rather than mouseenter, so overlapping plants swap correctly.
                const pop = getHoverPopup();
                if (hoverPid !== f.properties.pid) {
                    hoverPid = f.properties.pid;
                    const st = getPlantStatusForYear(plant, currentSelectedYear);
                    const html = st ? generatePlantHoverTooltipHTML(plant, st, currentSelectedYear) : '';
                    if (!html) { hideHoverTooltip(); return; }
                    pop.setLngLat(e.lngLat).setHTML(html).addTo(map);
                } else {
                    pop.setLngLat(e.lngLat);   // keep it under the cursor (sticky)
                }
            });
            map.on('mouseleave', 'plants-hit', function () {
                canvas().style.cursor = '';
                hideHoverTooltip();
            });
            map.on('mouseenter', 'clusters', function () { canvas().style.cursor = 'pointer'; });
            map.on('mouseleave', 'clusters', function () { canvas().style.cursor = ''; });

            map.on('click', 'plants-hit', function (e) {
                if (!e.features || !e.features.length) return;
                hideHoverTooltip();
                handlePlantSelection(plantFromFeature(e.features[0]));
            });

            // Cluster click: fit to the cluster's actual leaves, which is a closer match to
            // markercluster's zoomToBoundsOnClick than the expansion zoom.
            map.on('click', 'clusters', function (e) {
                const f = e.features && e.features[0];
                if (!f) return;
                const src = map.getSource('plants');
                const clusterId = f.properties.cluster_id;
                if (!src || !src.getClusterLeaves) return;
                Promise.resolve(src.getClusterLeaves(clusterId, Infinity, 0))
                    .then(function (leaves) {
                        if (!leaves || !leaves.length) throw new Error('no leaves');
                        const b = new maplibregl.LngLatBounds();
                        leaves.forEach(l => b.extend(l.geometry.coordinates));
                        map.fitBounds(b, { padding: 40, maxZoom: 7, duration: 800, essential: true });
                    })
                    .catch(function () {
                        Promise.resolve(src.getClusterExpansionZoom(clusterId)).then(function (z) {
                            map.easeTo({ center: f.geometry.coordinates, zoom: z, duration: 800, essential: true });
                        }).catch(function () {});
                    });
            });
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closePlantPopup();
        });
    }


    // Popup body. Declared at IIFE scope rather than inside updateMapForYear, because the
    // click handler that uses it lives inside map.once('load') and must be able to see it.
    // Built lazily on click now, instead of eagerly for all ~349 plants on every year tick.
    function buildPlantPopupHTML(plant, plantStatus, year) {
        const reactorHTML = generateReactorHTML(plant, plantStatus.activeReactors, year);
        const visibleCapacity = getPlantCapacityForYear(plantStatus);
        const visibleProduction = getPlantProductionForYear(plant, plantStatus, year);
        const outputTWh = (visibleProduction / 1000).toFixed(2);
        const capGW = (visibleCapacity / 1000).toFixed(1);
        return `
                <div class="popup-header-new">
                    <div class="popup-country-new">${escapeHtml(plant.country)}</div>
                    <div class="popup-title-new">${escapeHtml(plant.name)}</div>
                    <div class="popup-subtitle-new">${year === MAX_YEAR ? 'Present' : year}</div>
                </div>

                <div class="stats-row" role="group" aria-label="Plant statistics">
                    <div class="stat-item">
                        <span class="stat-value">${outputTWh > 0 ? outputTWh : '—'}</span>
                        <span class="stat-label">TWh Output${year !== MAX_YEAR ? ` (${year})` : ''}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-value">${capGW}</span>
                        <span class="stat-label">GW Capacity</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-value">${plantStatus.activeReactors.length}</span>
                        <span class="stat-label">Reactors</span>
                    </div>
                </div>
                ${reactorHTML}
                ${generatePlantDetailsCtaHTML(plant)}
            `;
    }

    // --- Feature builder (v5.7.183) --------------------------------------------------------
    // One pass over nuclearPlants producing the GeoJSON the map draws plus the stat totals.
    // Selection state (dim / sort key / year-changed) is BAKED INTO the features, so it
    // survives every rebuild structurally rather than being re-applied by a hook afterwards.
    // The filter and sizing arithmetic below is carried over unchanged from the old
    // per-marker loop; only the marker construction at the end is new.
    function buildPlantFeatures(year) {
        const totals = { operable: 0, construction: 0, planned: 0, shutdown: 0 };
        const changed = getYearChangedPlantNames(year);
        const dimmed = [], normal = [], lifted = [];

        // First pass: calculate max capacity if sizing by capacity (works for any year)
        if (viewOptions.sizeByCapacity) {
            maxPlantCapacity = 0;
            nuclearPlants.forEach(plant => {
                const plantStatus = getPlantStatusForYear(plant, year);
                if (plantStatus) {
                    const visibleCapacity = getPlantCapacityForYear(plantStatus);
                    if (visibleCapacity > maxPlantCapacity) {
                        maxPlantCapacity = visibleCapacity;
                    }
                }
            });
        }

        // First pass: calculate max electricity production for selected year if sizing by production
        if (viewOptions.sizeByProduction) {
            maxPlantProduction = 0;
            nuclearPlants.forEach(plant => {
                const plantStatus = getPlantStatusForYear(plant, year);
                if (plantStatus) {
                    const visibleProduction = getPlantProductionForYear(plant, plantStatus, year);
                    if (visibleProduction > maxPlantProduction) {
                        maxPlantProduction = visibleProduction;
                    }
                }
            });
        }

        nuclearPlants.forEach((plant, idx) => {
            const plantStatus = getPlantStatusForYear(plant, year);

            // Skip plants with no reactors in this year
            if (!plantStatus) return;

            // Totals come from the UNFILTERED status, exactly as before.
            totals.operable += plantStatus.stats.operable;
            totals.construction += plantStatus.stats.construction;
            totals.planned += plantStatus.stats.planned;
            totals.shutdown += plantStatus.stats.shutdown;

            // Apply view filters (now works for any year, not just Present)
            const plantHasOperable = plantStatus.stats.operable > 0;
            const plantHasConstruction = plantStatus.stats.construction > 0;
            const plantHasPlanned = plantStatus.stats.planned > 0;
            const plantHasShutdown = plantStatus.stats.shutdown > 0;

            // Calculate plant capacity in GW for size filtering
            const plantCapacityGW = getPlantCapacityForYear(plantStatus) / 1000;

            // Check status filters
            const noStatusFiltersActive = !viewOptions.showOperable && !viewOptions.showConstruction && !viewOptions.showPlanned && !viewOptions.showShutdown;
            let passesStatusFilter = noStatusFiltersActive;
            if (!noStatusFiltersActive) {
                passesStatusFilter =
                    (plantHasOperable && viewOptions.showOperable) ||
                    (plantHasConstruction && viewOptions.showConstruction) ||
                    (plantHasPlanned && viewOptions.showPlanned) ||
                    (plantHasShutdown && viewOptions.showShutdown && !plantHasOperable && !plantHasConstruction && !plantHasPlanned);
            }

            // Check capacity range filter
            const noCapacityFiltersActive = (viewOptions.capacityMin <= CAPACITY_SLIDER_MIN && viewOptions.capacityMax >= CAPACITY_SLIDER_MAX);
            let passesSizeFilter = noCapacityFiltersActive;
            if (!noCapacityFiltersActive) {
                passesSizeFilter = plantCapacityGW >= viewOptions.capacityMin && plantCapacityGW <= viewOptions.capacityMax;
            }

            // Check production range filter (v5.7.150)
            const noProductionFiltersActive = (viewOptions.productionMin <= PRODUCTION_SLIDER_MIN && viewOptions.productionMax >= PRODUCTION_SLIDER_MAX);
            let passesProductionFilter = noProductionFiltersActive;
            if (!noProductionFiltersActive) {
                const plantProductionTWh = getPlantProductionForYear(plant, plantStatus, year) / 1000;
                passesProductionFilter = plantProductionTWh >= viewOptions.productionMin && plantProductionTWh <= viewOptions.productionMax;
            }

            // Plant must pass ALL active filter categories
            if (!passesStatusFilter || !passesSizeFilter || !passesProductionFilter) return;

            // Marker size (v5.7.145-markers: 28px default, 14-42px in the size-by modes)
            let markerSize = 28;
            if (viewOptions.sizeByProduction && maxPlantProduction > 0) {
                const visibleProduction = getPlantProductionForYear(plant, plantStatus, year);
                const sizeRatio = Math.sqrt(visibleProduction / maxPlantProduction);
                markerSize = Math.max(14, Math.min(42, 14 + sizeRatio * 28));
            } else if (viewOptions.sizeByCapacity && maxPlantCapacity > 0) {
                const visibleCapacity = getPlantCapacityForYear(plantStatus);
                const sizeRatio = Math.sqrt(visibleCapacity / maxPlantCapacity);
                markerSize = Math.max(14, Math.min(42, 14 + sizeRatio * 28));
            }

            const s = plantStatus.stats;
            const variant = s.operable + ',' + s.construction + ',' + s.planned + ',' + s.shutdown;
            const isHl = currentHighlightFilter ? !!currentHighlightFilter(plant) : false;
            const isHover = currentHoverFocusPlantName === plant.name;
            const chg = changed.has(plant.name) ? 1 : 0;
            const dim = (currentHighlightFilter && !isHl && !isHover) ? 1 : 0;
            const tier = isHover ? 4 : (chg ? 3 : (isHl ? 2 : (dim ? 0 : 1)));
            // Latitude tiebreaker keeps Leaflet's southern-over-northern stacking within a tier.
            const sk = tier * 1000 + Math.round((90 - plant.lat) * 5);

            // Globe-only visuals, reproducing the globe's own sizing and highlight rules.
            // Phase 4 consumes these; they are harmless before that.
            let gRadius = 12;
            if (viewOptions.sizeByProduction && maxPlantProduction > 0) {
                gRadius = 8 + Math.sqrt(getPlantProductionForYear(plant, plantStatus, year) / maxPlantProduction) * 20;
            } else if (viewOptions.sizeByCapacity && maxPlantCapacity > 0) {
                gRadius = 8 + Math.sqrt(getPlantCapacityForYear(plantStatus) / maxPlantCapacity) * 20;
            }
            if (isHl) gRadius *= 1.2;
            const gColor = (currentHighlightFilter && !isHl) ? '#9e9e9e' : plantStatus.color;
            const gOpacity = currentHighlightFilter ? (isHl ? 1 : 0.25) : 0.9;

            const f = {
                type: 'Feature',
                id: idx,
                geometry: { type: 'Point', coordinates: [plant.lon, plant.lat] },
                properties: {
                    pid: idx, plantIndex: idx, name: plant.name, country: plant.country,
                    variant: variant, cnt: plantStatus.activeReactors.length,
                    sizePx: markerSize, sizeScale: markerSize / MK_MASTER_PX,
                    dim: dim, sk: sk, chg: chg,
                    gRadius: gRadius, gColor: gColor, gOpacity: gOpacity
                }
            };
            // Feature order is a second, cheaper ordering on top of the sort key.
            (dim ? dimmed : (tier >= 2 ? lifted : normal)).push(f);
        });

        return {
            fc: { type: 'FeatureCollection', features: dimmed.concat(normal, lifted) },
            totals: totals
        };
    }

    function updateMapForYear(year) {
        currentSelectedYear = year;

        applySizeByLayout();

        // Show/hide dropdowns based on year
        const filtersWrapper = document.getElementById('filtersWrapper');
        const filtersPanel = document.getElementById('filtersPanel');
        const filtersToggle = document.getElementById('filtersToggle');
        const viewModePopup = document.getElementById('viewModePopup');
        const viewDropdownWrapper = document.getElementById('viewDropdownWrapper');
        const viewDropdownPanel = document.getElementById('viewDropdownPanel');
        const viewDropdownToggle = document.getElementById('viewDropdownToggle');
        
        // Filters now work for all years - keep them visible
        filtersWrapper.classList.add('visible');
        filtersPanel.classList.add('visible');

// Desktop sidebar UX: filters now work for all years - keep them enabled
const isMobileViewport = window.matchMedia('(max-width: 600px)').matches || window.matchMedia('(hover: none) and (pointer: coarse) and (max-width: 900px)').matches;
if (!isMobileViewport) {
    const sidebarFiltersGroupEl = document.getElementById('sidebarFiltersGroup');
    const sidebarDisplayOptionsEl = document.getElementById('sidebarDisplayOptions');
    if (filtersWrapper) filtersWrapper.classList.remove('sidebar-disabled');
    if (sidebarFiltersGroupEl) sidebarFiltersGroupEl.classList.remove('sidebar-disabled');
    if (sidebarDisplayOptionsEl) sidebarDisplayOptionsEl.classList.remove('sidebar-disabled');
}

// Filters and settings now work for all years - keep them enabled
const filtersDrawerBody = document.querySelector('#filtersDrawer .map-drawer-body');
const settingsDrawerBody = document.querySelector('#settingsDrawer .map-drawer-body');
const settingsDisplayMount = document.getElementById('settingsDisplayMount');
const filterPanelContent = document.getElementById('filterPanelContent');
const displayOptionsGroup = document.getElementById('displayOptionsGroup');
const railFiltersBtn = document.getElementById('railFiltersBtn');
const railSettingsBtn = document.getElementById('railSettingsBtn');

// Enable all filter/settings controls for any year
if (filtersDrawerBody) filtersDrawerBody.classList.remove('filters-disabled');
if (settingsDrawerBody) settingsDrawerBody.classList.remove('filters-disabled');
if (settingsDisplayMount) settingsDisplayMount.classList.remove('filters-disabled');
if (filterPanelContent) filterPanelContent.classList.remove('filters-disabled');
if (filtersPanel) filtersPanel.classList.remove('filters-disabled');
if (displayOptionsGroup) displayOptionsGroup.classList.remove('filters-disabled');
if (railFiltersBtn) {
    railFiltersBtn.classList.remove('filters-disabled');
    railFiltersBtn.disabled = false;
    railFiltersBtn.title = 'Filters';
}
if (railSettingsBtn) {
    railSettingsBtn.classList.remove('filters-disabled');
    railSettingsBtn.disabled = false;
    railSettingsBtn.title = 'Settings';
}
        closePlantPopup();

        const built = buildPlantFeatures(year);
        ensurePlantImages(built.fc);
        setPlantData(built.fc);
        applySizeByLayout();

        // Update stats display
        document.getElementById('statOperable').textContent = built.totals.operable;
        document.getElementById('statConstruction').textContent = built.totals.construction;
        document.getElementById('statPlanned').textContent = built.totals.planned;
        document.getElementById('statShutdown').textContent = built.totals.shutdown;
        
        // Update slider tooltip
        updateSliderTooltip(year);
        
        // Update globe markers if in globe view
        if (isGlobeView && typeof updateGlobeMarkers === 'function') {
            updateGlobeMarkers();
        }
        
        // Refresh any open info panels to show data for the new year
        if (typeof refreshOpenInfoPanelsForYearChange === 'function') {
            refreshOpenInfoPanelsForYearChange();
        }
    }
    
    // Function to update slider tooltip position and text
    function updateSliderTooltip(year) {
        const slider = document.getElementById('yearSlider');
        const sidebarYearLabel = document.getElementById('sidebarYearLabel');
        const mobileYearIndicator = document.getElementById('mobileYearIndicator');
        const mobileYearLabel = document.getElementById('mobileYearLabel');
        const mobileYearValue = document.getElementById('mobileYearValue');
        const mobileYearMeta = document.getElementById('mobileYearMeta');
        const mapYearBadge = document.getElementById('mapYearBadge');
        const mapYearBadgeValue = document.getElementById('mapYearBadgeValue');

        // Calculate progress percentage
        const percent = (year - MIN_YEAR) / (MAX_YEAR - MIN_YEAR);
        const progressPercent = (percent * 100).toFixed(2) + '%';

        // Update slider progress track (two-tone fill)
        if (slider) {
            slider.style.setProperty('--slider-progress', progressPercent);
        }

        // Update sidebar year label if present
        if (sidebarYearLabel) {
            sidebarYearLabel.textContent = year === MAX_YEAR ? 'Present' : year;
        }

        // Update mobile year indicator (mobile-only UI)
        if (mobileYearIndicator && mobileYearValue) {
            const isAtPresent = (year === MAX_YEAR);

            if (isAtPresent) {
                mobileYearIndicator.classList.add('at-present');
                mobileYearIndicator.classList.remove('past-year');

                if (mobileYearLabel) mobileYearLabel.textContent = 'Current view: Present';
                mobileYearValue.textContent = 'Present';

                if (mobileYearMeta) {
                    mobileYearMeta.textContent = `Last update: ${DATA_LAST_UPDATE}`;
                    mobileYearMeta.style.display = '';
                }
            } else {
                mobileYearIndicator.classList.remove('at-present');
                mobileYearIndicator.classList.add('past-year');

                if (mobileYearLabel) mobileYearLabel.textContent = 'Current view';

                const displayYear = String(year);
                if (mobileYearValue.textContent !== displayYear) {
                    mobileYearValue.textContent = displayYear;
                }

                if (mobileYearMeta) {
                    mobileYearMeta.textContent = '';
                    mobileYearMeta.style.display = 'none';
                }
            }
        }

        // Prominent desktop status bar (always visible on the map)
        const mapStatusBar = document.getElementById('mapStatusBar');
        if (mapYearBadge && mapYearBadgeValue) {
            const isAtPresent = (year === MAX_YEAR);

            if (isAtPresent) {
                if (mapStatusBar) {
                    mapStatusBar.classList.add('at-present');
                    mapStatusBar.classList.remove('past-year');
                }
                mapYearBadgeValue.textContent = 'Present';
            } else {
                if (mapStatusBar) {
                    mapStatusBar.classList.remove('at-present');
                    mapStatusBar.classList.add('past-year');
                }
                mapYearBadgeValue.textContent = String(year);
            }
        }

    }


    
    // Initial render
    updateMapForYear(MAX_YEAR);
    
    // Position tooltip initially
    setTimeout(() => updateSliderTooltip(MAX_YEAR), 100);
// --- 13. Year Slider Event Handlers ---
    const yearSlider = document.getElementById('yearSlider');
    const playBtn = document.getElementById('playBtn');
    const playIcon = document.getElementById('playIcon');
    const pauseIcon = document.getElementById('pauseIcon');
    const speedBtn = document.getElementById('speedBtn');
    
    // Speed settings: [label, interval in ms]
    const speeds = [
        { label: '0.5x', interval: 400 },
        { label: '1x', interval: 200 },
        { label: '2x', interval: 100 }
    ];
    let currentSpeedIndex = 1; // Start at 1x
    
    yearSlider.addEventListener('input', (e) => {
        const year = parseInt(e.target.value);
        updateMapForYear(year);
    });
    
    // Update tooltip on window resize
    window.addEventListener('resize', () => {
        updateSliderTooltip(parseInt(yearSlider.value));
    });
    
    // Speed button cycles through speeds
    speedBtn.addEventListener('click', () => {
        currentSpeedIndex = (currentSpeedIndex + 1) % speeds.length;
        speedBtn.textContent = speeds[currentSpeedIndex].label;
        
        // If currently playing, restart interval with new speed
        if (isPlaying) {
            clearInterval(playInterval);
            playInterval = setInterval(() => {
                const currentYear = parseInt(yearSlider.value);
                if (currentYear >= MAX_YEAR) {
                    isPlaying = false;
                    clearInterval(playInterval);
                    playIcon.style.display = 'block';
                    pauseIcon.style.display = 'none';
                    playBtn.classList.remove('playing');
                    renderYearChangesDropdown(parseInt(yearSlider.value));
                } else {
                    yearSlider.value = currentYear + 1;
                    updateMapForYear(currentYear + 1);
                }
            }, speeds[currentSpeedIndex].interval);
        }
    });

    // Play/Pause animation
    playBtn.addEventListener('click', () => {
        if (isPlaying) {
            // Pause
            isPlaying = false;
            clearInterval(playInterval);
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
            playBtn.classList.remove('playing');
            renderYearChangesDropdown(parseInt(yearSlider.value));
        } else {
            // Play
            isPlaying = true;
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'block';
            playBtn.classList.add('playing');
            
            // If at the end, restart
            if (parseInt(yearSlider.value) >= MAX_YEAR) {
                yearSlider.value = MIN_YEAR;
                updateMapForYear(MIN_YEAR);
            }
            
            playInterval = setInterval(() => {
                const currentYear = parseInt(yearSlider.value);
                if (currentYear >= MAX_YEAR) {
                    // Stop at end
                    isPlaying = false;
                    clearInterval(playInterval);
                    playIcon.style.display = 'block';
                    pauseIcon.style.display = 'none';
                    playBtn.classList.remove('playing');
                    renderYearChangesDropdown(parseInt(yearSlider.value));
                } else {
                    yearSlider.value = currentYear + 1;
                    updateMapForYear(currentYear + 1);
                }
            }, speeds[currentSpeedIndex].interval);
        }
    });

    // --- Timeline Charts (3 panels: Reactors, Capacity, Electricity) ---
    const timelineExpandBtn = document.getElementById('timelineExpandBtn');
    const timelineChartsSidebar = document.getElementById('timelineChartsSidebar');
    const timelineChartsClose = document.getElementById('timelineChartsClose');
    const reactorsChartCanvas = document.getElementById('reactorsChartCanvas');
    const electricityChartCanvas = document.getElementById('electricityChartCanvas');
    const reactorsChartValue = document.getElementById('reactorsChartValue');
    const electricityChartValue = document.getElementById('electricityChartValue');
    const constructionStartsChartCanvas = document.getElementById('constructionStartsChartCanvas');
    const constructionStartsChartValue = document.getElementById('constructionStartsChartValue');
    const gridConnectionsChartCanvas = null; // v5.7.81: Replaced by SVG deploy chart
    const gridConnectionsChartValue = document.getElementById('gridConnectionsChartValue');
    const timelineDeployContainer = document.getElementById('timelineDeployChartContainer');

    // v5.7.82: Collapsible stats sidebar in fullscreen
    const fsStatsExpandBtn = document.getElementById('fsStatsExpandBtn');
    let fsStatsCollapsed = false;
    let fsStatsToggleTimeout = null;

    let timelineData = null;
    let timelineChartsRendered = false;

const yearSliderPanel = document.getElementById('yearSliderPanel');
const yearSliderHomeParent = yearSliderPanel ? yearSliderPanel.parentElement : null;
const yearSliderHomeNextSibling = yearSliderPanel ? yearSliderPanel.nextSibling : null;

// Fullscreen grid docking (re-parents panels so fullscreen feels designed, not layered)
const fullscreenGridShellEl = document.getElementById('map-shell');

// Remember original location for the right-side charts panel so we can restore on exit
const timelineChartsHomeParent = timelineChartsSidebar ? timelineChartsSidebar.parentElement : null;
const timelineChartsHomeNextSibling = timelineChartsSidebar ? timelineChartsSidebar.nextSibling : null;

function dockTimelineChartsToFullscreenGrid() {
    if (!timelineChartsSidebar || !fullscreenGridShellEl) return;
    if (timelineChartsSidebar.parentElement !== fullscreenGridShellEl) {
        fullscreenGridShellEl.appendChild(timelineChartsSidebar);
    }
}

function restoreTimelineChartsFromFullscreenGrid() {
    if (!timelineChartsSidebar || !timelineChartsHomeParent) return;
    if (timelineChartsSidebar.parentElement !== timelineChartsHomeParent) {
        if (timelineChartsHomeNextSibling && timelineChartsHomeNextSibling.parentNode === timelineChartsHomeParent) {
            timelineChartsHomeParent.insertBefore(timelineChartsSidebar, timelineChartsHomeNextSibling);
        } else {
            timelineChartsHomeParent.appendChild(timelineChartsSidebar);
        }
    }
}

function dockYearSliderToFullscreenGrid() {
    if (!yearSliderPanel || !fullscreenGridShellEl) return;
    if (yearSliderPanel.parentElement !== fullscreenGridShellEl) {
        fullscreenGridShellEl.appendChild(yearSliderPanel);
    }
    yearSliderPanel.classList.add('mounted-in-fullscreen-grid');
}

function restoreYearSliderFromFullscreenGrid() {
    if (!yearSliderPanel || !yearSliderHomeParent) return;
    if (yearSliderPanel.parentElement !== yearSliderHomeParent) {
        if (yearSliderHomeNextSibling && yearSliderHomeNextSibling.parentNode === yearSliderHomeParent) {
            yearSliderHomeParent.insertBefore(yearSliderPanel, yearSliderHomeNextSibling);
        } else {
            yearSliderHomeParent.appendChild(yearSliderPanel);
        }
    }
    yearSliderPanel.classList.remove('mounted-in-fullscreen-grid');
}


function isInFullscreenNow() {
    // Use our CSS state as the source of truth.
    // Relying on document.fullscreenElement here can cause a race during exit
    // (native fullscreen may still be active for a tick after we remove our classes).
    return document.body.classList.contains('fullscreen-active') ||
        document.documentElement.classList.contains('fullscreen-active') ||
        (typeof mapWrapper !== 'undefined' && mapWrapper && mapWrapper.classList.contains('fullscreen'));
}

function setYearSliderDock() {
    if (!yearSliderPanel || !yearSliderHomeParent) return;

    if (yearSliderPanel.parentElement !== yearSliderHomeParent) {
        if (yearSliderHomeNextSibling && yearSliderHomeNextSibling.parentNode === yearSliderHomeParent) {
            yearSliderHomeParent.insertBefore(yearSliderPanel, yearSliderHomeNextSibling);
        } else {
            yearSliderHomeParent.appendChild(yearSliderPanel);
        }
    }
}

function syncYearSliderDock() {
    // Default: slider lives under the map (standard layout)
    // Fullscreen: slider becomes its own bottom panel in the 4-panel grid
    if (isInFullscreenNow()) {
        dockYearSliderToFullscreenGrid();
    } else {
        restoreYearSliderFromFullscreenGrid();
        setYearSliderDock();
    }
}

// Ensure we start in the correct dock position (e.g. if fullscreen state is restored).
setTimeout(syncYearSliderDock, 0);


    // Calculate all timeline data for all years
    function calculateTimelineData() {
        const data = {
            reactors: { operable: {}, construction: {}, shutdown: {} },
            capacity: { operable: {}, construction: {}, shutdown: {} },
            electricity: {},
            constructionStarts: {},
            gridConnections: {},
            shutdowns: {},
            gridConnectionDetails: {},
            shutdownDetails: {}
        };
        
        for (let year = MIN_YEAR; year <= MAX_YEAR; year++) {
            let reactorsOperable = 0, reactorsConstruction = 0, reactorsShutdown = 0;
            let capacityOperable = 0, capacityConstruction = 0, capacityShutdown = 0;
            let electricityTotal = 0;
            
            nuclearPlants.forEach(plant => {
                if (!plant.reactors) return;
                plant.reactors.forEach(reactor => {
                    // v5.7.132: Skip planned reactors - they have no dates or production data
                    if (reactor.status === 'planned') return;

                    const constructionStart = reactor.constructionStart;
                    const gridYear = reactor.gridConnection;
                    const shutdownYear = reactor.shutdownDate;
                    const capacity = reactor.capacity || 0;

                    // Under construction: construction started but not yet grid connected
                    if (constructionStart && constructionStart <= year) {
                        if (!gridYear || gridYear > year) {
                            reactorsConstruction++;
                            capacityConstruction += capacity;
                        }
                    }
                    
                    // Operable: grid connected and not yet shutdown
                    if (gridYear && gridYear <= year) {
                        if (!shutdownYear || shutdownYear > year) {
                            reactorsOperable++;
                            capacityOperable += capacity;
                        }
                        // v5.7.177: Include electricity from any reactor that was grid-connected during this year,
                        // even if it shut down mid-year (production is a flow variable, not point-in-time)
                        if (!shutdownYear || shutdownYear >= year) {
                            if (reactor.productionByYear && reactor.productionByYear[year]) {
                                electricityTotal += reactor.productionByYear[year];
                            }
                        }
                    }
                    
                    // Shutdown: has been shutdown
                    if (shutdownYear && shutdownYear <= year) {
                        reactorsShutdown++;
                        capacityShutdown += capacity;
                    }

                    // Count construction starts (reactors that started construction this exact year)
                    if (constructionStart && constructionStart === year) {
                        if (!data.constructionStarts[year]) data.constructionStarts[year] = 0;
                        data.constructionStarts[year]++;
                    }

                    // Count grid connections (reactors that connected to grid this exact year)
                    if (gridYear && gridYear === year) {
                        if (!data.gridConnections[year]) data.gridConnections[year] = 0;
                        data.gridConnections[year]++;
                        if (!data.gridConnectionDetails[year]) data.gridConnectionDetails[year] = [];
                        data.gridConnectionDetails[year].push({
                            name: reactor.displayName || reactor.name,
                            plantName: plant.name,
                            country: plant.country,
                            capacity: capacity
                        });
                    }

                    // Count permanent shutdowns (reactors shut down this exact year)
                    if (shutdownYear && shutdownYear === year) {
                        if (!data.shutdowns[year]) data.shutdowns[year] = 0;
                        data.shutdowns[year]++;
                        if (!data.shutdownDetails[year]) data.shutdownDetails[year] = [];
                        data.shutdownDetails[year].push({
                            name: reactor.displayName || reactor.name,
                            plantName: plant.name,
                            country: plant.country,
                            capacity: capacity
                        });
                    }
                });
            });
            
            data.reactors.operable[year] = reactorsOperable;
            data.reactors.construction[year] = reactorsConstruction;
            data.reactors.shutdown[year] = reactorsShutdown;
            data.capacity.operable[year] = capacityOperable / 1000; // GW
            data.capacity.construction[year] = capacityConstruction / 1000;
            data.capacity.shutdown[year] = capacityShutdown / 1000;
            data.electricity[year] = year <= ELECTRICITY_DATA_YEAR ? (electricityTotal >= 500 ? electricityTotal / 1000 : null) : null; // TWh, null = no data (< 0.5 TWh treated as no data)
            if (!data.constructionStarts[year]) data.constructionStarts[year] = 0;
        }
        return data;
    }

    // Store chart metadata for hover interactions
    const chartMetadata = new Map();

    // Generic function to render a mini line chart
    function renderMiniChart(canvas, datasets, highlightYear, valueEl, formatValue, hoverYear = null) {
        if (!canvas) return;

        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;

        // If the canvas isn't visible yet (e.g., during fullscreen transitions),
        // skip this paint and let the caller retry once layout has settled.
        if (!width || !height) return;

        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);

        // Keep CSS sizing fluid; avoid locking pixel dimensions which can "squash" after layout changes.
        canvas.style.width = '100%';
        canvas.style.height = '100%';

        const ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, width, height);

        // v5.7.79: Wider margins to fit Y-axis labels (right) and X-axis labels (bottom)
        const margin = { left: 6, right: 34, top: 8, bottom: 22 };
        const plotWidth = width - margin.left - margin.right;
        const plotHeight = height - margin.top - margin.bottom;

        // Get years from first dataset
        const firstData = datasets[0].data;
        const years = Object.keys(firstData).map(y => parseInt(y)).sort((a, b) => a - b);
        const minYear = Math.min(...years);
        const maxYear = Math.max(...years);

        // Find max value across all datasets (skip null = no-data entries)
        let maxValue = 0;
        datasets.forEach(ds => {
            years.forEach(year => {
                const val = ds.data[year];
                if (val != null && val > maxValue) maxValue = val;
            });
        });
        maxValue = maxValue * 1.1 || 1;

        // Scale functions
        const xScale = (year) => margin.left + ((year - minYear) / (maxYear - minYear)) * plotWidth;
        const yScale = (val) => margin.top + (1 - val / maxValue) * plotHeight;
        const xToYear = (x) => Math.round(minYear + ((x - margin.left) / plotWidth) * (maxYear - minYear));

        // Store metadata for hover interactions
        chartMetadata.set(canvas, {
            margin, plotWidth, plotHeight, minYear, maxYear, maxValue,
            xScale, yScale, xToYear, datasets, formatValue, valueEl
        });

        const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

        // v5.7.79: Draw grid lines + axis labels
        const gridColor = isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';
        const textColor = isDarkMode ? '#636e72' : '#b2bec3';
        ctx.strokeStyle = gridColor;
        ctx.lineWidth = 1;
        // 3 horizontal grid lines
        for (let i = 0; i <= 2; i++) {
            const gy = margin.top + (i / 2) * plotHeight;
            ctx.beginPath();
            ctx.moveTo(margin.left, gy);
            ctx.lineTo(width - margin.right, gy);
            ctx.stroke();
        }
        // Y-axis labels (right side): top, middle, 0
        ctx.fillStyle = textColor;
        ctx.font = '500 8px "Muli", sans-serif';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        for (let i = 0; i <= 2; i++) {
            const val = maxValue * (1 - i / 2);
            let lbl;
            if (i === 2) { lbl = '0'; }
            else if (maxValue >= 1000) { lbl = Math.round(val / 1000) + 'k'; }
            else if (maxValue >= 10) { lbl = Math.round(val).toString(); }
            else { lbl = val.toFixed(1); }
            ctx.fillText(lbl, width - margin.right + 4, margin.top + (i / 2) * plotHeight);
        }
        // X-axis labels (decades)
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        const decStart = Math.ceil(minYear / 10) * 10;
        for (let d = decStart; d <= maxYear; d += 20) {
            const dx = xScale(d);
            ctx.fillText(String(d), dx, margin.top + plotHeight + 4);
        }

        // Determine which year to highlight (hover takes precedence)
        const activeYear = hoverYear !== null ? hoverYear : highlightYear;
        
        // The cutoff year for greyscale (use the current selected year from timeline)
        const cutoffYear = currentSelectedYear;
        
        // Helper to convert color to greyscale
        const toGreyscale = (color) => {
            // For our known colors, return appropriate grey
            if (color === '#00b894') return '#a0a0a0'; // green -> grey
            if (color === '#fdcb6e') return '#c0c0c0'; // yellow -> lighter grey  
            if (color === '#636e72') return '#d0d0d0'; // grey -> even lighter
            if (color === '#5777a9') return '#b0b0b0'; // blue -> grey
            return '#b0b0b0'; // default grey
        };

        // Split years into past (up to cutoff) and future (after cutoff)
        const pastYears = years.filter(y => y <= cutoffYear);
        const futureYears = years.filter(y => y >= cutoffYear); // Include cutoffYear in both for continuity

        // Draw area fill under lines - FUTURE (greyscale, draw first so it's behind)
        if (futureYears.length > 1 && cutoffYear < maxYear) {
            datasets.forEach(ds => {
                const validFuture = futureYears.filter(y => ds.data[y] != null);
                if (validFuture.length === 0) return;
                ctx.beginPath();
                ctx.fillStyle = toGreyscale(ds.color) + '10'; // Very subtle grey fill
                validFuture.forEach((year, i) => {
                    const val = ds.data[year];
                    const x = xScale(year);
                    const y = yScale(val);
                    if (i === 0) {
                        ctx.moveTo(x, margin.top + plotHeight);
                        ctx.lineTo(x, y);
                    } else {
                        ctx.lineTo(x, y);
                    }
                });
                ctx.lineTo(xScale(validFuture[validFuture.length - 1]), margin.top + plotHeight);
                ctx.closePath();
                ctx.fill();
            });
        }

        // Draw area fill under lines - PAST (colored)
        if (pastYears.length > 0) {
            datasets.forEach(ds => {
                const validPast = pastYears.filter(y => ds.data[y] != null);
                if (validPast.length === 0) return;
                ctx.beginPath();
                ctx.fillStyle = ds.color + '15'; // 15 = ~8% opacity
                validPast.forEach((year, i) => {
                    const val = ds.data[year];
                    const x = xScale(year);
                    const y = yScale(val);
                    if (i === 0) {
                        ctx.moveTo(x, margin.top + plotHeight);
                        ctx.lineTo(x, y);
                    } else {
                        ctx.lineTo(x, y);
                    }
                });
                ctx.lineTo(xScale(validPast[validPast.length - 1]), margin.top + plotHeight);
                ctx.closePath();
                ctx.fill();
            });
        }

        // Draw each line - FUTURE (greyscale, dashed)
        if (futureYears.length > 1 && cutoffYear < maxYear) {
            datasets.forEach(ds => {
                const validFuture = futureYears.filter(y => ds.data[y] != null);
                if (validFuture.length === 0) return;
                ctx.beginPath();
                ctx.strokeStyle = toGreyscale(ds.color);
                ctx.lineWidth = 1.5;
                ctx.lineJoin = 'round';
                ctx.lineCap = 'round';
                ctx.setLineDash([4, 3]); // Dashed line for future
                validFuture.forEach((year, i) => {
                    const val = ds.data[year];
                    if (i === 0) {
                        ctx.moveTo(xScale(year), yScale(val));
                    } else {
                        ctx.lineTo(xScale(year), yScale(val));
                    }
                });
                ctx.stroke();
                ctx.setLineDash([]); // Reset dash
            });
        }

        // Draw each line - PAST (colored, solid)
        if (pastYears.length > 0) {
            datasets.forEach(ds => {
                const validPast = pastYears.filter(y => ds.data[y] != null);
                if (validPast.length === 0) return;
                ctx.beginPath();
                ctx.strokeStyle = ds.color;
                ctx.lineWidth = 2;
                ctx.lineJoin = 'round';
                ctx.lineCap = 'round';
                validPast.forEach((year, i) => {
                    const val = ds.data[year];
                    if (i === 0) {
                        ctx.moveTo(xScale(year), yScale(val));
                    } else {
                        ctx.lineTo(xScale(year), yScale(val));
                    }
                });
                ctx.stroke();
            });
        }

        // Draw vertical highlight line and points
        if (activeYear !== null && activeYear >= minYear && activeYear <= maxYear) {
            const x = xScale(activeYear);
            const isInFuture = activeYear > cutoffYear;

            // Vertical line - more prominent if hovering
            const isHovering = hoverYear !== null;
            const vLineColor = isDarkMode
                ? (isHovering ? 'rgba(255, 255, 255, 0.80)' : 'rgba(255, 255, 255, 0.45)')
                : (isHovering ? 'rgba(45, 52, 54, 0.80)' : 'rgba(45, 52, 54, 0.40)');
            ctx.strokeStyle = vLineColor;
            ctx.lineWidth = isHovering ? 1.5 : 1;
            ctx.setLineDash(isHovering ? [] : [3, 3]);
            ctx.beginPath();
            ctx.moveTo(x, margin.top);
            ctx.lineTo(x, margin.top + plotHeight);
            ctx.stroke();
            ctx.setLineDash([]);

            // Draw points on each line (skip datasets with null/no-data for this year)
            datasets.forEach(ds => {
                const val = ds.data[activeYear];
                if (val == null) return; // No data for this year
                const y = yScale(val);
                const pointColor = isInFuture ? toGreyscale(ds.color) : ds.color;

                // Outer ring (white)
                ctx.beginPath();
                ctx.arc(x, y, isHovering ? 6 : 4, 0, Math.PI * 2);
                ctx.fillStyle = '#fff';
                ctx.fill();

                // Inner circle (colored or grey)
                ctx.beginPath();
                ctx.arc(x, y, isHovering ? 4 : 3, 0, Math.PI * 2);
                ctx.fillStyle = pointColor;
                ctx.fill();
            });

            // Update value display
            if (valueEl && formatValue) {
                valueEl.innerHTML = formatValue(datasets, activeYear);
            }
        }
    }

    // v5.7.173: Bar chart renderer for construction starts (discrete event data)
    function renderMiniBarChart(canvas, datasets, highlightYear, valueEl, formatValue, hoverYear = null) {
        if (!canvas) return;

        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;
        if (!width || !height) return;

        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);
        canvas.style.width = '100%';
        canvas.style.height = '100%';

        const ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, width, height);

        const margin = { left: 6, right: 34, top: 8, bottom: 22 };
        const plotWidth = width - margin.left - margin.right;
        const plotHeight = height - margin.top - margin.bottom;

        const firstData = datasets[0].data;
        const color = datasets[0].color;
        const years = Object.keys(firstData).map(y => parseInt(y)).sort((a, b) => a - b);
        const minYear = Math.min(...years);
        const maxYear = Math.max(...years);
        const yearCount = maxYear - minYear + 1;

        let maxValue = 0;
        years.forEach(year => {
            const val = firstData[year];
            if (val != null && val > maxValue) maxValue = val;
        });
        maxValue = maxValue * 1.1 || 1;

        // Bar geometry
        const barWidth = Math.max(1.2, Math.min(6, (plotWidth / yearCount) - 0.5));
        const totalBarSpace = barWidth * yearCount;
        const barGap = (plotWidth - totalBarSpace) / (yearCount + 1);

        // xScale returns bar center for crosshair/year-pill alignment
        const xScale = (year) => margin.left + barGap + (year - minYear) * (barWidth + barGap) + barWidth / 2;
        const yScale = (val) => margin.top + (1 - val / maxValue) * plotHeight;
        const xToYear = (x) => {
            const rawYear = minYear + (x - margin.left - barGap) / (barWidth + barGap);
            return Math.round(Math.max(minYear, Math.min(maxYear, rawYear)));
        };

        chartMetadata.set(canvas, {
            margin, plotWidth, plotHeight, minYear, maxYear, maxValue,
            xScale, yScale, xToYear, datasets, formatValue, valueEl
        });

        const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

        // Grid lines + axis labels (same as renderMiniChart)
        const gridColor = isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';
        const textColor = isDarkMode ? '#636e72' : '#b2bec3';
        ctx.strokeStyle = gridColor;
        ctx.lineWidth = 1;
        for (let i = 0; i <= 2; i++) {
            const gy = margin.top + (i / 2) * plotHeight;
            ctx.beginPath();
            ctx.moveTo(margin.left, gy);
            ctx.lineTo(width - margin.right, gy);
            ctx.stroke();
        }
        ctx.fillStyle = textColor;
        ctx.font = '500 8px "Muli", sans-serif';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        for (let i = 0; i <= 2; i++) {
            const val = maxValue * (1 - i / 2);
            let lbl;
            if (i === 2) { lbl = '0'; }
            else if (maxValue >= 1000) { lbl = Math.round(val / 1000) + 'k'; }
            else if (maxValue >= 10) { lbl = Math.round(val).toString(); }
            else { lbl = val.toFixed(1); }
            ctx.fillText(lbl, width - margin.right + 4, margin.top + (i / 2) * plotHeight);
        }
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        const decStart = Math.ceil(minYear / 10) * 10;
        for (let d = decStart; d <= maxYear; d += 20) {
            const dx = xScale(d);
            ctx.fillText(String(d), dx, margin.top + plotHeight + 4);
        }

        const activeYear = hoverYear !== null ? hoverYear : highlightYear;
        const cutoffYear = currentSelectedYear;
        const greyColor = '#b0b0b0';
        const baseline = margin.top + plotHeight;

        // Draw bars
        for (let year = minYear; year <= maxYear; year++) {
            const val = firstData[year] || 0;
            if (val <= 0) continue;

            const barX = margin.left + barGap + (year - minYear) * (barWidth + barGap);
            const barH = (val / maxValue) * plotHeight;
            const barY = baseline - barH;
            const isFuture = year > cutoffYear;
            const isHighlighted = activeYear !== null && year === activeYear;

            ctx.globalAlpha = isFuture ? 0.3 : 1.0;
            ctx.fillStyle = isFuture ? greyColor : color;

            if (barWidth >= 3) {
                const r = Math.min(1.5, barWidth / 3);
                ctx.beginPath();
                ctx.moveTo(barX, baseline);
                ctx.lineTo(barX, barY + r);
                ctx.quadraticCurveTo(barX, barY, barX + r, barY);
                ctx.lineTo(barX + barWidth - r, barY);
                ctx.quadraticCurveTo(barX + barWidth, barY, barX + barWidth, barY + r);
                ctx.lineTo(barX + barWidth, baseline);
                ctx.closePath();
                ctx.fill();
            } else {
                ctx.fillRect(barX, barY, barWidth, barH);
            }

            ctx.globalAlpha = 1.0;

            if (isHighlighted) {
                ctx.strokeStyle = isDarkMode ? 'rgba(255,255,255,0.8)' : 'rgba(45,52,54,0.6)';
                ctx.lineWidth = 1.5;
                ctx.strokeRect(barX - 0.5, barY - 0.5, barWidth + 1, barH + 1);
            }
        }

        // Vertical highlight line and value display
        if (activeYear !== null && activeYear >= minYear && activeYear <= maxYear) {
            const x = xScale(activeYear);
            const isHovering = hoverYear !== null;
            const vLineColor = isDarkMode
                ? (isHovering ? 'rgba(255, 255, 255, 0.80)' : 'rgba(255, 255, 255, 0.45)')
                : (isHovering ? 'rgba(45, 52, 54, 0.80)' : 'rgba(45, 52, 54, 0.40)');
            ctx.strokeStyle = vLineColor;
            ctx.lineWidth = isHovering ? 1.5 : 1;
            ctx.setLineDash(isHovering ? [] : [3, 3]);
            ctx.beginPath();
            ctx.moveTo(x, margin.top);
            ctx.lineTo(x, margin.top + plotHeight);
            ctx.stroke();
            ctx.setLineDash([]);

            if (valueEl && formatValue) {
                valueEl.innerHTML = formatValue(datasets, activeYear);
            }
        }
    }

    // Chart hover tooltip element
    let chartTooltip = null;

    function createChartTooltip() {
        if (chartTooltip) return chartTooltip;
        chartTooltip = document.createElement('div');
        chartTooltip.className = 'chart-hover-tooltip';
        chartTooltip.style.cssText = `
            position: fixed;
            background: rgba(45, 52, 54, 0.95);
            color: #fff;
            padding: 8px 12px;
            border-radius: 6px;
            font-size: 12px;
            font-family: 'Muli', sans-serif;
            font-weight: 600;
            pointer-events: none;
            opacity: 0;
            transition: opacity 0.15s ease;
            z-index: 10000;
            white-space: nowrap;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        `;
        document.body.appendChild(chartTooltip);
        return chartTooltip;
    }

    function showChartTooltip(x, y, content) {
        const tooltip = createChartTooltip();
        tooltip.innerHTML = content;
        tooltip.style.opacity = '1';
        
        // Position tooltip above cursor
        const tooltipRect = tooltip.getBoundingClientRect();
        const offsetX = -tooltipRect.width / 2;
        const offsetY = -tooltipRect.height - 12;
        
        tooltip.style.left = (x + offsetX) + 'px';
        tooltip.style.top = (y + offsetY) + 'px';
    }

    function hideChartTooltip() {
        if (chartTooltip) {
            chartTooltip.style.opacity = '0';
        }
    }

    // Year indicator badge attached to the vertical crosshair line (one per chart panel)
    function ensureChartYearIndicator(canvas) {
        if (!canvas) return null;
        if (canvas._yearIndicator) return canvas._yearIndicator;

        const panel = canvas.closest('.timeline-chart-panel-body') || canvas.closest('.timeline-chart-panel');
        if (!panel) return null;

        const el = document.createElement('div');
        el.className = 'chart-year-indicator';
        panel.appendChild(el);

        canvas._yearIndicator = el;
        return el;
    }

    function setYearIndicatorForCanvas(canvas, year) {
        if (!canvas) return;
        const meta = chartMetadata.get(canvas);
        const el = ensureChartYearIndicator(canvas);
        if (!meta || !el || year === null || year === undefined) {
            if (el) el.classList.remove('visible');
            return;
        }

        // Match the map's "Present" convention for the last year
        const label = (typeof MAX_YEAR !== 'undefined' && year === MAX_YEAR) ? 'Present' : String(year);
        el.textContent = label;

        // x position within the canvas (in CSS pixels)
        const x = meta.xScale(year);

        // Convert to panel-local coordinates
        const baseLeft = canvas.offsetLeft + x;

        el.style.left = baseLeft + 'px';
        el.classList.add('visible');

        // Clamp so the pill never clips outside the plot area
        requestAnimationFrame(() => {
            const w = el.getBoundingClientRect().width || 0;
            const min = canvas.offsetLeft + meta.margin.left + (w / 2);
            const max = canvas.offsetLeft + meta.margin.left + meta.plotWidth - (w / 2);
            const clamped = Math.max(min, Math.min(max, baseLeft));
            el.style.left = clamped + 'px';
        });
    }

    function showChartYearIndicators(year) {
        setYearIndicatorForCanvas(reactorsChartCanvas, year);
        setYearIndicatorForCanvas(electricityChartCanvas, year);
        setYearIndicatorForCanvas(constructionStartsChartCanvas, year);
        setDeployYearIndicator(year); // v5.7.81: deploy chart uses SVG, not canvas
    }

    function hideChartYearIndicators() {
        [reactorsChartCanvas, electricityChartCanvas, constructionStartsChartCanvas].forEach(c => {
            if (c && c._yearIndicator) c._yearIndicator.classList.remove('visible');
        });
        hideDeployYearIndicator(); // v5.7.81
    }

    // Track current hover state for each chart
    const chartHoverState = new Map();

    function setupChartHoverInteractions(canvas, datasets, formatValue) {
        if (!canvas) return;

        canvas.style.cursor = 'crosshair';

        canvas.addEventListener('mousemove', (e) => {
            const meta = chartMetadata.get(canvas);
            if (!meta) return;

            const rect = canvas.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            // Check if within plot area
            if (x < meta.margin.left || x > meta.margin.left + meta.plotWidth) {
                hideChartTooltip();
                hideChartYearIndicators();
                if (chartHoverState.get(canvas)) {
                    chartHoverState.set(canvas, null);
                    renderTimelineChartsWithHover(parseInt(yearSlider.value), null);
                }
                return;
            }

            // Calculate which year we're hovering over
            const hoverYear = meta.xToYear(x);
            const clampedYear = Math.max(meta.minYear, Math.min(meta.maxYear, hoverYear));

            // Update hover state and re-render all charts with this hover year
            chartHoverState.set(canvas, clampedYear);
            renderTimelineChartsWithHover(parseInt(yearSlider.value), clampedYear);

            // Show the year pill on the crosshair line
            showChartYearIndicators(clampedYear);

            // Show tooltip
            const tooltipContent = `<strong>${escapeHtml(String(clampedYear))}</strong><br>${formatValue(datasets, clampedYear)}`;
            showChartTooltip(e.clientX, e.clientY, tooltipContent);
        });

        canvas.addEventListener('mouseleave', () => {
            hideChartTooltip();
            hideChartYearIndicators();
            chartHoverState.set(canvas, null);
            renderTimelineChartsWithHover(parseInt(yearSlider.value), null);
        });

        // Click to set the year
        canvas.addEventListener('click', (e) => {
            const meta = chartMetadata.get(canvas);
            if (!meta) return;

            const rect = canvas.getBoundingClientRect();
            const x = e.clientX - rect.left;

            if (x < meta.margin.left || x > meta.margin.left + meta.plotWidth) return;

            const clickedYear = meta.xToYear(x);
            const clampedYear = Math.max(meta.minYear, Math.min(meta.maxYear, clickedYear));

            // Update slider and map
            yearSlider.value = clampedYear;
            updateMapForYear(clampedYear);
        });
    }

    // v5.7.81: Year indicator helpers for the deploy chart (SVG container, not canvas)
    function ensureDeployYearIndicator() {
        if (!timelineDeployContainer) return null;
        if (timelineDeployContainer._yearIndicator) return timelineDeployContainer._yearIndicator;

        var panel = timelineDeployContainer.closest('.timeline-chart-panel-body') || timelineDeployContainer.closest('.timeline-chart-panel');
        if (!panel) return null;

        var el = document.createElement('div');
        el.className = 'chart-year-indicator';
        panel.appendChild(el);

        timelineDeployContainer._yearIndicator = el;
        return el;
    }

    function setDeployYearIndicator(year) {
        if (!timelineDeployContainer) return;
        var meta = timelineDeployContainer._deployMeta;
        var el = ensureDeployYearIndicator();
        if (!meta || !el || year === null || year === undefined) {
            if (el) el.classList.remove('visible');
            return;
        }

        var label = (typeof MAX_YEAR !== 'undefined' && year === MAX_YEAR) ? 'Present' : String(year);
        el.textContent = label;

        // x position within the container
        var x = meta.yearToX(year) + meta.barWidth / 2;
        var baseLeft = timelineDeployContainer.offsetLeft + x;

        el.style.left = baseLeft + 'px';
        el.classList.add('visible');

        // Clamp so the pill never clips outside the plot area
        requestAnimationFrame(function() {
            var w = el.getBoundingClientRect().width || 0;
            var minPos = timelineDeployContainer.offsetLeft + meta.paddingLeft + (w / 2);
            var maxPos = timelineDeployContainer.offsetLeft + meta.paddingLeft + meta.chartWidth - (w / 2);
            var clamped = Math.max(minPos, Math.min(maxPos, baseLeft));
            el.style.left = clamped + 'px';
        });
    }

    function hideDeployYearIndicator() {
        if (timelineDeployContainer && timelineDeployContainer._yearIndicator) {
            timelineDeployContainer._yearIndicator.classList.remove('visible');
        }
    }

    // v5.7.81: Hover interactivity for the timeline deploy chart
    function setupDeployChartHoverForTimeline() {
        if (!timelineDeployContainer) return;

        timelineDeployContainer.addEventListener('mousemove', function(e) {
            var meta = timelineDeployContainer._deployMeta;
            if (!meta) return;

            var rect = timelineDeployContainer.getBoundingClientRect();
            var x = e.clientX - rect.left;

            // Check if within plot area
            if (x < meta.paddingLeft || x > meta.paddingLeft + meta.chartWidth) {
                hideChartTooltip();
                hideChartYearIndicators();
                renderTimelineChartsWithHover(parseInt(yearSlider.value), null);
                return;
            }

            var hoveredYear = meta.xToYear(x);
            hoveredYear = Math.max(meta.minYear, Math.min(meta.maxYear, hoveredYear));

            // Show year indicators on all charts
            showChartYearIndicators(hoveredYear);

            // Build tooltip content
            var connCount = (timelineData.gridConnections[hoveredYear] || 0);
            var shutCount = (timelineData.shutdowns[hoveredYear] || 0);
            var tooltipContent = '<strong>' + escapeHtml(String(hoveredYear)) + '</strong><br>' +
                '<span style="color:#00b894">\u25CF</span> ' + escapeHtml(String(connCount)) + ' grid connections<br>' +
                '<span style="color:#636e72">\u25CF</span> ' + escapeHtml(String(shutCount)) + ' shutdowns';

            showChartTooltip(e.clientX, e.clientY, tooltipContent);

            // Re-render all charts with hover highlight
            renderTimelineChartsWithHover(parseInt(yearSlider.value), hoveredYear);
        });

        timelineDeployContainer.addEventListener('mouseleave', function() {
            hideChartTooltip();
            hideChartYearIndicators();
            renderTimelineChartsWithHover(parseInt(yearSlider.value), null);
        });

        timelineDeployContainer.addEventListener('click', function(e) {
            var meta = timelineDeployContainer._deployMeta;
            if (!meta) return;

            var rect = timelineDeployContainer.getBoundingClientRect();
            var x = e.clientX - rect.left;

            if (x < meta.paddingLeft || x > meta.paddingLeft + meta.chartWidth) return;

            var clickedYear = meta.xToYear(x);
            var clampedYear = Math.max(meta.minYear, Math.min(meta.maxYear, clickedYear));

            yearSlider.value = clampedYear;
            updateMapForYear(clampedYear);
        });
    }

    // v5.7.81: Render the mini diverging bar chart (grid connections up, shutdowns down)
    function renderTimelineDeployChart(highlightYear, hoverYear) {
        if (!timelineDeployContainer || !timelineData) return;

        var containerRect = timelineDeployContainer.getBoundingClientRect();
        var containerWidth = containerRect.width || 220;
        var containerHeight = containerRect.height || 180;
        if (!containerWidth || !containerHeight) return;

        var connections = timelineData.gridConnections;
        var shutdownsData = timelineData.shutdowns;

        var years = Object.keys(connections).concat(Object.keys(shutdownsData)).map(Number);
        // Also include all years in range
        for (var y = MIN_YEAR; y <= MAX_YEAR; y++) years.push(y);
        years = Array.from(new Set(years)).sort(function(a, b) { return a - b; });
        if (years.length === 0) return;

        var minYear = years[0];
        var maxYear = years[years.length - 1];

        var maxConnection = 0, maxShutdown = 0;
        for (var yi = 0; yi < years.length; yi++) {
            var yr = years[yi];
            var cv = connections[yr] || 0;
            var sv = shutdownsData[yr] || 0;
            if (cv > maxConnection) maxConnection = cv;
            if (sv > maxShutdown) maxShutdown = sv;
        }
        var maxValue = Math.max(maxConnection, maxShutdown, 1);

        var paddingLeft = 6;
        var paddingRight = 34;
        var paddingTop = 8;
        var paddingBottom = 22;
        var chartWidth = containerWidth - paddingLeft - paddingRight;
        var plotHeight = containerHeight - paddingTop - paddingBottom;
        var zeroY = paddingTop + plotHeight / 2;

        var yearCount = maxYear - minYear + 1;
        var barWidth = Math.max(1.5, Math.min(6, (chartWidth / yearCount) - 1));
        var barGap = (chartWidth - barWidth * yearCount) / (yearCount + 1);

        var yearToX = function(year) { return paddingLeft + barGap + (year - minYear) * (barWidth + barGap); };
        var xToYear = function(x) {
            var rawYear = minYear + (x - paddingLeft - barGap) / (barWidth + barGap);
            return Math.round(Math.max(minYear, Math.min(maxYear, rawYear)));
        };
        var valueToHeight = function(val) { return (val / maxValue) * (plotHeight / 2 - 4); };

        var isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

        // Build SVG
        var svg = '<svg class="reactor-deploy-svg" viewBox="0 0 ' + containerWidth + ' ' + containerHeight + '">';

        // Grid lines
        var gridSteps = 4;
        for (var gi = 0; gi <= gridSteps; gi++) {
            var gy = paddingTop + (gi / gridSteps) * plotHeight;
            svg += '<line x1="' + paddingLeft + '" y1="' + gy + '" x2="' + (containerWidth - paddingRight) + '" y2="' + gy + '" class="reactor-deploy-grid-line" />';
        }

        // Zero line
        svg += '<line x1="' + paddingLeft + '" y1="' + zeroY + '" x2="' + (containerWidth - paddingRight) + '" y2="' + zeroY + '" class="reactor-deploy-zero-line" />';

        // Y-axis labels (right side, matching canvas charts above)
        var topVal = Math.ceil(maxValue);
        var yLabelX = containerWidth - paddingRight + 4;
        svg += '<text x="' + yLabelX + '" y="' + (paddingTop + 4) + '" class="reactor-deploy-axis-label" text-anchor="start" style="font-size:8px">' + topVal + '</text>';
        svg += '<text x="' + yLabelX + '" y="' + (zeroY + 3) + '" class="reactor-deploy-axis-label" text-anchor="start" style="font-size:8px">0</text>';
        svg += '<text x="' + yLabelX + '" y="' + (paddingTop + plotHeight + 4) + '" class="reactor-deploy-axis-label" text-anchor="start" style="font-size:8px">' + topVal + '</text>';

        // Bars
        // Cutoff year for greyscale future (matching canvas charts above)
        var cutoffYear = currentSelectedYear;

        for (var year = minYear; year <= maxYear; year++) {
            var x = yearToX(year);
            var connVal = connections[year] || 0;
            var shutVal = shutdownsData[year] || 0;

            var isFuture = year > cutoffYear;
            var dimOpacity = isFuture ? ' opacity="0.3"' : '';

            // Use greyscale colors for bars after the selected year
            var connColor = isFuture ? '#a0a0a0' : '#00b894';
            var shutColor = isFuture ? '#d0d0d0' : '#636e72';

            if (connVal > 0) {
                var bH = valueToHeight(connVal);
                svg += '<rect class="reactor-deploy-bar connections" x="' + x + '" y="' + (zeroY - bH) + '" width="' + barWidth + '" height="' + bH + '" rx="1" fill="' + connColor + '"' + dimOpacity + ' data-year="' + year + '" data-type="connections" />';
            }
            if (shutVal > 0) {
                var sbH = valueToHeight(shutVal);
                svg += '<rect class="reactor-deploy-bar shutdowns" x="' + x + '" y="' + zeroY + '" width="' + barWidth + '" height="' + sbH + '" rx="1" fill="' + shutColor + '"' + dimOpacity + ' data-year="' + year + '" data-type="shutdowns" />';
            }
        }

        // X-axis labels (decades, matching canvas charts: 1960, 1980, 2000, 2020)
        var decStart = Math.ceil(minYear / 10) * 10;
        for (var d = decStart; d <= maxYear; d += 20) {
            var dx = yearToX(d) + barWidth / 2;
            svg += '<text x="' + dx + '" y="' + (containerHeight - 4) + '" class="reactor-deploy-axis-label" text-anchor="middle" style="font-size:8px">' + d + '</text>';
        }

        // Highlight line (dashed) for slider year
        if (highlightYear != null && highlightYear >= minYear && highlightYear <= maxYear) {
            var hlX = yearToX(highlightYear) + barWidth / 2;
            var hlColor = isDarkMode ? 'rgba(255,255,255,0.35)' : 'rgba(45,52,54,0.35)';
            svg += '<line class="deploy-highlight-line" x1="' + hlX + '" y1="' + paddingTop + '" x2="' + hlX + '" y2="' + (paddingTop + plotHeight) + '" stroke="' + hlColor + '" stroke-width="1" />';
        }

        // Hover line (solid) for hovered year
        if (hoverYear != null && hoverYear >= minYear && hoverYear <= maxYear) {
            var hvX = yearToX(hoverYear) + barWidth / 2;
            var hvColor = isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(45,52,54,0.7)';
            svg += '<line class="deploy-hover-line" x1="' + hvX + '" y1="' + paddingTop + '" x2="' + hvX + '" y2="' + (paddingTop + plotHeight) + '" stroke="' + hvColor + '" stroke-width="1.5" />';
        }

        svg += '</svg>';
        timelineDeployContainer.innerHTML = svg;

        // Store metadata for hover calculations
        timelineDeployContainer._deployMeta = {
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
            chartWidth: chartWidth,
            plotHeight: plotHeight,
            zeroY: zeroY,
            minYear: minYear,
            maxYear: maxYear,
            barWidth: barWidth,
            barGap: barGap,
            yearToX: yearToX,
            xToYear: xToYear,
            containerWidth: containerWidth,
            containerHeight: containerHeight
        };

        // Update value display
        var activeYear = (hoverYear != null) ? hoverYear : highlightYear;
        if (activeYear != null && gridConnectionsChartValue) {
            var connCount = connections[activeYear] || 0;
            var shutCount = shutdownsData[activeYear] || 0;
            gridConnectionsChartValue.innerHTML = '<span style="color:#00b894">' + connCount + '</span> · <span style="color:#636e72">' + shutCount + '</span>';
        }
    }

    // Render charts with optional hover highlight
    function renderTimelineChartsWithHover(highlightYear, hoverYear) {
        if (!timelineData) return;

        renderMiniChart(
            reactorsChartCanvas,
            [
                { data: timelineData.reactors.operable, color: '#00b894' },
                { data: timelineData.reactors.construction, color: '#fdcb6e' }
            ],
            highlightYear,
            reactorsChartValue,
            (ds, year) => {
                const op = ds[0].data[year] || 0;
                const con = ds[1].data[year] || 0;
                return `<span style="color:#00b894">${op}</span> · <span style="color:#fdcb6e">${con}</span>`;
            },
            hoverYear
        );

        renderMiniChart(
            electricityChartCanvas,
            [
                { data: timelineData.electricity, color: '#5777a9' }
            ],
            highlightYear,
            electricityChartValue,
            (ds, year) => {
                const val = ds[0].data[year];
                if (val == null) return `<span style="color:#b2bec3;font-style:italic">NO DATA</span>`;
                return `<span style="color:#5777a9">${val.toFixed(0)}</span>`;
            },            hoverYear
        );

        // Construction Starts chart (v5.7.173: bar chart for discrete event data)
        renderMiniBarChart(
            constructionStartsChartCanvas,
            [
                { data: timelineData.constructionStarts, color: '#e17055' }
            ],
            highlightYear,
            constructionStartsChartValue,
            (ds, year) => {
                const val = ds[0].data[year] || 0;
                return '<span style="color:#e17055">' + val + '</span>';
            },
            hoverYear
        );

        // v5.7.81: Reactor Deployment chart (diverging bar chart)
        renderTimelineDeployChart(highlightYear, hoverYear);
    }

    // Render all four timeline charts
    function renderTimelineCharts(highlightYear = null) {
        if (!timelineData) return;

        // Use the hover-aware rendering
        renderTimelineChartsWithHover(highlightYear, null);

        // Setup hover interactions (only once)
        if (!reactorsChartCanvas._hoverSetup) {
            setupChartHoverInteractions(reactorsChartCanvas, [
                { data: timelineData.reactors.operable, color: '#00b894' },
                { data: timelineData.reactors.construction, color: '#fdcb6e' }
            ], (ds, year) => {
                const op = ds[0].data[year] || 0;
                const con = ds[1].data[year] || 0;
                return `<span style="color:#00b894">&#9679;</span> ${op} Operable<br><span style="color:#fdcb6e">&#9679;</span> ${con} Construction`;
            });
            reactorsChartCanvas._hoverSetup = true;
        }


        if (!electricityChartCanvas._hoverSetup) {
            setupChartHoverInteractions(electricityChartCanvas, [
                { data: timelineData.electricity, color: '#5777a9' }
            ], (ds, year) => {
                const val = ds[0].data[year];
                if (val == null) return `<span style="color:#b2bec3">&#9679;</span> <em>NO DATA</em>`;
                return `<span style="color:#5777a9">&#9679;</span> ${val.toFixed(1)} TWh`;
            });
            electricityChartCanvas._hoverSetup = true;
        }

        if (!constructionStartsChartCanvas._hoverSetup) {
            setupChartHoverInteractions(constructionStartsChartCanvas, [
                { data: timelineData.constructionStarts, color: '#e17055' }
            ], (ds, year) => {
                const val = ds[0].data[year] || 0;
                return '<span style="color:#e17055">&#9679;</span> ' + val + ' construction starts';
            });
            constructionStartsChartCanvas._hoverSetup = true;
        }

        // v5.7.81: Deploy chart hover setup
        if (timelineDeployContainer && !timelineDeployContainer._hoverSetup) {
            setupDeployChartHoverForTimeline();
            timelineDeployContainer._hoverSetup = true;
        }
    }

    // ================================================================
    // v5.7.78  Expanded Chart Modal  (professional floating tooltip)
    // ================================================================

    var expandedChartDetails = null;

    function buildExpandedChartDetails() {
        if (expandedChartDetails) return expandedChartDetails;
        var details = { gridConnections: {}, constructionStarts: {}, shutdowns: {}, reactors: {}, capacity: {}, electricity: {} };
        for (var year = MIN_YEAR; year <= MAX_YEAR; year++) {
            details.gridConnections[year] = [];
            details.constructionStarts[year] = [];
            details.shutdowns[year] = [];
            var opCount = 0, conCount = 0, shutCount = 0, opCap = 0, conCap = 0, shutCap = 0;
            nuclearPlants.forEach(function(plant) {
                if (!plant.reactors) return;
                plant.reactors.forEach(function(reactor) {
                    // v5.7.132: Skip planned reactors - they have no dates or production data
                    if (reactor.status === 'planned') return;

                    var cs = reactor.constructionStart, gc = reactor.gridConnection, sd = reactor.shutdownDate;
                    var cap = reactor.capacity || 0;
                    var entry = { reactorName: reactor.displayName || reactor.name, plantName: plant.name, country: plant.country, capacity: cap, type: reactor.type || '' };
                    if (gc && gc === year) details.gridConnections[year].push(entry);
                    if (cs && cs === year) details.constructionStarts[year].push(entry);
                    if (sd && sd === year) details.shutdowns[year].push(entry);
                    if (cs && cs <= year && (!gc || gc > year)) { conCount++; conCap += cap; }
                    if (gc && gc <= year && (!sd || sd > year)) { opCount++; opCap += cap; }
                    if (sd && sd <= year) { shutCount++; shutCap += cap; }
                });
            });
            details.reactors[year] = { operable: opCount, construction: conCount, shutdown: shutCount };
            details.capacity[year] = { operable: opCap / 1000, construction: conCap / 1000, shutdown: shutCap / 1000 };
            details.electricity[year] = timelineData ? timelineData.electricity[year] : null;
        }
        expandedChartDetails = details;
        return details;
    }

    var expandedChartConfig = {
        reactors: {
            title: 'Reactors',
            subtitle: 'Global reactor fleet over time',
            datasets: function() {
                return [
                    { data: timelineData.reactors.operable, color: '#00b894', label: 'Operable' },
                    { data: timelineData.reactors.construction, color: '#fdcb6e', label: 'Under Construction' }
                ];
            }
        },
        electricity: {
            title: 'Nuclear Electricity Generation',
            subtitle: 'Worldwide output in terawatt-hours',
            datasets: function() {
                return [{ data: timelineData.electricity, color: '#5777a9', label: 'Electricity (TWh)' }];
            }
        },
        constructionStarts: {
            title: 'Construction Starts',
            subtitle: 'New reactor construction begins per year',
            renderType: 'default-bar',
            datasets: function() {
                return [{ data: timelineData.constructionStarts, color: '#e17055', label: 'Construction Starts' }];
            }
        },
        gridConnections: {
            title: 'Global Reactor Deployment',
            subtitle: 'Grid connections and permanent shutdowns by year',
            renderType: 'custom-svg',
            hasToggle: false,
            datasets: function() {
                return [
                    { data: {}, color: '#00b894', label: 'Grid Connections' },
                    { data: {}, color: '#636e72', label: 'Permanent Shutdowns' }
                ];
            },
            customRender: function(container) {
                renderExpandedGlobalDeploy(container);
            }
        }
    };

    var currentExpandedChartType = null;
    var expandedChartHoverCleanup = null;
    var expandedChartModal = document.getElementById('expandedChartModal');
    var expandedChartCanvas = document.getElementById('expandedChartCanvas');
    var expandedChartTitleEl = document.getElementById('expandedChartTitle');
    var expandedChartSubtitle = document.getElementById('expandedChartSubtitle');
    var expandedChartLegend = document.getElementById('expandedChartLegend');
    var expandedChartClose = document.getElementById('expandedChartClose');
    var expandedChartBackdrop = document.getElementById('expandedChartBackdrop');
    var expandedChartTooltip = document.getElementById('expandedChartTooltip');
    var expandedChartTooltipCard = document.getElementById('expandedChartTooltipCard');
    var expandedChartCustom = document.getElementById('expandedChartCustom');
    var expandedChartToggle = document.getElementById('expandedChartToggle');

    /* ---- Professional chart renderer ---- */
    function renderExpandedChart(chartType, hoverYear) {
        var config = expandedChartConfig[chartType];
        if (!config || !timelineData) return;
        var canvas = expandedChartCanvas;
        if (!canvas) return;
        var dpr = window.devicePixelRatio || 1;
        var rect = canvas.getBoundingClientRect();
        var w = rect.width, h = rect.height;
        if (!w || !h) return;
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        var ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, w, h);

        var margin = { left: 54, right: 20, top: 20, bottom: 36 };
        var pw = w - margin.left - margin.right;
        var ph = h - margin.top - margin.bottom;
        var datasets = config.datasets();
        var firstData = datasets[0].data;
        var years = Object.keys(firstData).map(Number).sort(function(a, b) { return a - b; });
        var minYr = years[0], maxYr = years[years.length - 1];
        var maxVal = 0;
        datasets.forEach(function(ds) { years.forEach(function(yr) { var v = ds.data[yr]; if (v != null && v > maxVal) maxVal = v; }); });
        maxVal = maxVal * 1.08 || 1;

        var xS = function(yr) { return margin.left + ((yr - minYr) / (maxYr - minYr)) * pw; };
        var yS = function(v) { return margin.top + (1 - v / maxVal) * ph; };
        var xToYr = function(x) { return Math.round(minYr + ((x - margin.left) / pw) * (maxYr - minYr)); };

        chartMetadata.set(canvas, { margin: margin, plotWidth: pw, plotHeight: ph, minYear: minYr, maxYear: maxYr, maxValue: maxVal, xScale: xS, yScale: yS, xToYear: xToYr, datasets: datasets });

        var dark = document.documentElement.getAttribute('data-theme') === 'dark';
        var gridC = dark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.06)';
        var axisC = dark ? '#636e72' : '#b2bec3';
        var textC = dark ? '#8898aa' : '#8898aa';

        // Nice Y grid — compute tick values
        var niceStep = (function(raw) {
            var mag = Math.pow(10, Math.floor(Math.log10(raw)));
            var res = raw / mag;
            if (res <= 1) return 1 * mag;
            if (res <= 2) return 2 * mag;
            if (res <= 5) return 5 * mag;
            return 10 * mag;
        })(maxVal / 5);

        ctx.font = '500 10px "Muli", sans-serif';

        // Horizontal grid lines + Y labels
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        for (var tick = 0; tick <= maxVal; tick += niceStep) {
            var ty = yS(tick);
            if (ty < margin.top - 2) break;
            ctx.strokeStyle = gridC;
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(margin.left, ty); ctx.lineTo(w - margin.right, ty); ctx.stroke();
            var lbl;
            if (niceStep >= 1000) lbl = (tick / 1000) + 'k';
            else if (tick === Math.round(tick)) lbl = tick.toString();
            else lbl = tick.toFixed(1);
            ctx.fillStyle = textC;
            ctx.fillText(lbl, margin.left - 8, ty);
        }

        // Vertical grid lines + X labels (decades)
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        var decStart = Math.ceil(minYr / 10) * 10;
        for (var d = decStart; d <= maxYr; d += 10) {
            var dx = xS(d);
            ctx.strokeStyle = gridC;
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(dx, margin.top); ctx.lineTo(dx, margin.top + ph); ctx.stroke();
            ctx.fillStyle = textC;
            ctx.fillText(String(d), dx, margin.top + ph + 10);
        }

        // Baseline
        ctx.strokeStyle = dark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.10)';
        ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(margin.left, margin.top + ph); ctx.lineTo(w - margin.right, margin.top + ph); ctx.stroke();

        var cutoff = currentSelectedYear;
        var toGrey = function(c) {
            if (c === '#00b894') return '#a8a8a8'; if (c === '#fdcb6e') return '#c0c0c0';
            if (c === '#636e72') return '#d0d0d0'; if (c === '#5777a9') return '#b0b0b0';
            if (c === '#e17055') return '#bbbbbb'; return '#b0b0b0';
        };
        var past = years.filter(function(y) { return y <= cutoff; });
        var future = years.filter(function(y) { return y >= cutoff; });

        // Draw area fills
        function drawArea(yrs, ds, fillColor) {
            var valid = yrs.filter(function(y) { return ds.data[y] != null; });
            if (valid.length < 2) return;
            ctx.beginPath();
            ctx.fillStyle = fillColor;
            ctx.moveTo(xS(valid[0]), margin.top + ph);
            valid.forEach(function(y) { ctx.lineTo(xS(y), yS(ds.data[y])); });
            ctx.lineTo(xS(valid[valid.length - 1]), margin.top + ph);
            ctx.closePath(); ctx.fill();
        }
        // Draw line
        function drawLine(yrs, ds, strokeColor, lw, dash) {
            var valid = yrs.filter(function(y) { return ds.data[y] != null; });
            if (valid.length < 2) return;
            ctx.beginPath(); ctx.strokeStyle = strokeColor; ctx.lineWidth = lw;
            if (dash) ctx.setLineDash(dash); else ctx.setLineDash([]);
            valid.forEach(function(y, i) { var px = xS(y), py = yS(ds.data[y]); if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py); });
            ctx.stroke(); ctx.setLineDash([]);
        }

        // Future areas + lines
        if (future.length > 1 && cutoff < maxYr) {
            datasets.forEach(function(ds) { drawArea(future, ds, toGrey(ds.color) + '0D'); });
            datasets.forEach(function(ds) { drawLine(future, ds, toGrey(ds.color), 1.5, [5, 4]); });
        }
        // Past areas + lines
        datasets.forEach(function(ds) { drawArea(past, ds, ds.color + '1A'); });
        datasets.forEach(function(ds) { drawLine(past, ds, ds.color, 2.2, null); });

        // Current year marker line
        if (cutoff >= minYr && cutoff <= maxYr) {
            var cx = xS(cutoff);
            ctx.strokeStyle = dark ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.15)';
            ctx.lineWidth = 1; ctx.setLineDash([4, 4]);
            ctx.beginPath(); ctx.moveTo(cx, margin.top); ctx.lineTo(cx, margin.top + ph); ctx.stroke(); ctx.setLineDash([]);
        }

        // Hover crosshair + dots
        var activeYear = hoverYear != null ? hoverYear : null;
        if (activeYear != null && activeYear >= minYr && activeYear <= maxYr) {
            var hx = xS(activeYear);
            // Solid crosshair
            ctx.strokeStyle = dark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.18)';
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(hx, margin.top); ctx.lineTo(hx, margin.top + ph); ctx.stroke();
            // Dots
            datasets.forEach(function(ds) {
                var val = ds.data[activeYear];
                if (val == null) return;
                var py = yS(val);
                // Outer ring
                ctx.beginPath(); ctx.arc(hx, py, 6, 0, Math.PI * 2);
                ctx.fillStyle = dark ? 'rgba(30,30,46,0.9)' : 'rgba(255,255,255,0.95)';
                ctx.fill();
                ctx.strokeStyle = ds.color; ctx.lineWidth = 2;
                ctx.beginPath(); ctx.arc(hx, py, 6, 0, Math.PI * 2); ctx.stroke();
                // Inner dot
                ctx.beginPath(); ctx.arc(hx, py, 3, 0, Math.PI * 2);
                ctx.fillStyle = ds.color; ctx.fill();
            });
        }
    }

    // v5.7.173: Bar chart renderer for expanded construction starts chart
    function renderExpandedBarChart(chartType, hoverYear) {
        var config = expandedChartConfig[chartType];
        if (!config || !timelineData) return;
        var canvas = expandedChartCanvas;
        if (!canvas) return;
        var dpr = window.devicePixelRatio || 1;
        var rect = canvas.getBoundingClientRect();
        var w = rect.width, h = rect.height;
        if (!w || !h) return;
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        var ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, w, h);

        var margin = { left: 54, right: 20, top: 20, bottom: 36 };
        var pw = w - margin.left - margin.right;
        var ph = h - margin.top - margin.bottom;
        var datasets = config.datasets();
        var firstData = datasets[0].data;
        var dsColor = datasets[0].color;
        var years = Object.keys(firstData).map(Number).sort(function(a, b) { return a - b; });
        var minYr = years[0], maxYr = years[years.length - 1];
        var yearCount = maxYr - minYr + 1;
        var maxVal = 0;
        years.forEach(function(yr) { var v = firstData[yr]; if (v != null && v > maxVal) maxVal = v; });
        maxVal = maxVal * 1.08 || 1;

        // Bar geometry
        var barWidth = Math.max(3, Math.min(14, (pw / yearCount) - 1.5));
        var totalBarSpace = barWidth * yearCount;
        var barGap = (pw - totalBarSpace) / (yearCount + 1);

        var xS = function(yr) { return margin.left + barGap + (yr - minYr) * (barWidth + barGap) + barWidth / 2; };
        var yS = function(v) { return margin.top + (1 - v / maxVal) * ph; };
        var xToYr = function(x) {
            var rawYear = minYr + (x - margin.left - barGap) / (barWidth + barGap);
            return Math.round(Math.max(minYr, Math.min(maxYr, rawYear)));
        };

        chartMetadata.set(canvas, { margin: margin, plotWidth: pw, plotHeight: ph, minYear: minYr, maxYear: maxYr, maxValue: maxVal, xScale: xS, yScale: yS, xToYear: xToYr, datasets: datasets });

        var dark = document.documentElement.getAttribute('data-theme') === 'dark';
        var gridC = dark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.06)';
        var textC = dark ? '#8898aa' : '#8898aa';

        // Nice Y grid ticks
        var niceStep = (function(raw) {
            var mag = Math.pow(10, Math.floor(Math.log10(raw)));
            var res = raw / mag;
            if (res <= 1) return 1 * mag;
            if (res <= 2) return 2 * mag;
            if (res <= 5) return 5 * mag;
            return 10 * mag;
        })(maxVal / 5);

        ctx.font = '500 10px "Muli", sans-serif';

        // Horizontal grid lines + Y labels
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        for (var tick = 0; tick <= maxVal; tick += niceStep) {
            var ty = yS(tick);
            if (ty < margin.top - 2) break;
            ctx.strokeStyle = gridC;
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(margin.left, ty); ctx.lineTo(w - margin.right, ty); ctx.stroke();
            var lbl;
            if (niceStep >= 1000) lbl = (tick / 1000) + 'k';
            else if (tick === Math.round(tick)) lbl = tick.toString();
            else lbl = tick.toFixed(1);
            ctx.fillStyle = textC;
            ctx.fillText(lbl, margin.left - 8, ty);
        }

        // Vertical grid lines + X labels (decades)
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        var decStart = Math.ceil(minYr / 10) * 10;
        for (var d = decStart; d <= maxYr; d += 10) {
            var dx = xS(d);
            ctx.strokeStyle = gridC;
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(dx, margin.top); ctx.lineTo(dx, margin.top + ph); ctx.stroke();
            ctx.fillStyle = textC;
            ctx.fillText(String(d), dx, margin.top + ph + 10);
        }

        // Baseline
        ctx.strokeStyle = dark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.10)';
        ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(margin.left, margin.top + ph); ctx.lineTo(w - margin.right, margin.top + ph); ctx.stroke();

        // Draw bars
        var cutoff = currentSelectedYear;
        var greyColor = '#bbbbbb';
        var baseline = margin.top + ph;

        for (var year = minYr; year <= maxYr; year++) {
            var val = firstData[year] || 0;
            if (val <= 0) continue;

            var barX = margin.left + barGap + (year - minYr) * (barWidth + barGap);
            var barH = (val / maxVal) * ph;
            var barY = baseline - barH;
            var isFuture = year > cutoff;
            var isHovered = hoverYear != null && year === hoverYear;

            ctx.globalAlpha = isFuture ? 0.3 : 1.0;
            ctx.fillStyle = isFuture ? greyColor : dsColor;

            var r = Math.min(2, barWidth / 3);
            ctx.beginPath();
            ctx.moveTo(barX, baseline);
            ctx.lineTo(barX, barY + r);
            ctx.quadraticCurveTo(barX, barY, barX + r, barY);
            ctx.lineTo(barX + barWidth - r, barY);
            ctx.quadraticCurveTo(barX + barWidth, barY, barX + barWidth, barY + r);
            ctx.lineTo(barX + barWidth, baseline);
            ctx.closePath();
            ctx.fill();

            ctx.globalAlpha = 1.0;

            if (isHovered) {
                ctx.strokeStyle = dark ? 'rgba(255,255,255,0.7)' : 'rgba(45,52,54,0.5)';
                ctx.lineWidth = 1.5;
                ctx.beginPath();
                ctx.moveTo(barX, baseline);
                ctx.lineTo(barX, barY + r);
                ctx.quadraticCurveTo(barX, barY, barX + r, barY);
                ctx.lineTo(barX + barWidth - r, barY);
                ctx.quadraticCurveTo(barX + barWidth, barY, barX + barWidth, barY + r);
                ctx.lineTo(barX + barWidth, baseline);
                ctx.stroke();
            }
        }

        // Current year marker line (dashed)
        if (cutoff >= minYr && cutoff <= maxYr) {
            var cx = xS(cutoff);
            ctx.strokeStyle = dark ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.15)';
            ctx.lineWidth = 1; ctx.setLineDash([4, 4]);
            ctx.beginPath(); ctx.moveTo(cx, margin.top); ctx.lineTo(cx, margin.top + ph); ctx.stroke(); ctx.setLineDash([]);
        }

        // Hover crosshair line (solid)
        if (hoverYear != null && hoverYear >= minYr && hoverYear <= maxYr) {
            var hx = xS(hoverYear);
            ctx.strokeStyle = dark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.18)';
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(hx, margin.top); ctx.lineTo(hx, margin.top + ph); ctx.stroke();
        }
    }

    /* ---- Build floating tooltip HTML ---- */
    function buildTooltipHTML(chartType, year, showAll) {
        var d = buildExpandedChartDetails();
        var yl = (year === MAX_YEAR) ? 'Present (' + year + ')' : String(year);
        var h = '<div class="expanded-chart-tooltip-year">' + yl + '</div>';
        var MAX_ITEMS = showAll ? Infinity : 8;

        if (chartType === 'reactors') {
            var r = d.reactors[year] || {operable:0,construction:0,shutdown:0};
            var c = d.capacity[year] || {operable:0,construction:0,shutdown:0};
            h += '<div class="expanded-chart-tooltip-summary">';
            h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#00b894"></span><span class="expanded-chart-tooltip-label">Operable</span><span class="expanded-chart-tooltip-value">' + r.operable + ' <small>(' + c.operable.toFixed(1) + ' GW)</small></span></div>';
            h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#fdcb6e"></span><span class="expanded-chart-tooltip-label">Under Construction</span><span class="expanded-chart-tooltip-value">' + r.construction + ' <small>(' + c.construction.toFixed(1) + ' GW)</small></span></div>';
            h += '</div>';
            var gc = d.gridConnections[year] || [];
            var sd = d.shutdowns[year] || [];
            if (gc.length > 0) {
                h += '<div class="expanded-chart-tooltip-divider"></div>';
                h += '<div class="expanded-chart-tooltip-section-title">Connected to grid</div>';
                gc.slice(0, MAX_ITEMS).forEach(function(e) {
                    h += '<div class="expanded-chart-tooltip-reactor" data-plant-name="' + escapeHtml(e.plantName) + '" data-reactor-name="' + escapeHtml(e.reactorName) + '"><span class="expanded-chart-tooltip-reactor-name">' + escapeHtml(e.reactorName) + '</span><span class="expanded-chart-tooltip-reactor-detail">' + escapeHtml(e.country) + '</span></div>';
                });
                if (gc.length > MAX_ITEMS) h += '<div class="expanded-chart-tooltip-more">+ ' + (gc.length - MAX_ITEMS) + ' more</div>';
            }
            if (sd.length > 0) {
                h += '<div class="expanded-chart-tooltip-divider"></div>';
                h += '<div class="expanded-chart-tooltip-section-title">Permanently shut down</div>';
                sd.slice(0, MAX_ITEMS).forEach(function(e) {
                    h += '<div class="expanded-chart-tooltip-reactor" data-plant-name="' + escapeHtml(e.plantName) + '" data-reactor-name="' + escapeHtml(e.reactorName) + '"><span class="expanded-chart-tooltip-reactor-name">' + escapeHtml(e.reactorName) + '</span><span class="expanded-chart-tooltip-reactor-detail">' + escapeHtml(e.country) + '</span></div>';
                });
                if (sd.length > MAX_ITEMS) h += '<div class="expanded-chart-tooltip-more">+ ' + (sd.length - MAX_ITEMS) + ' more</div>';
            }
        } else if (chartType === 'electricity') {
            var val = d.electricity[year];
            h += '<div class="expanded-chart-tooltip-summary">';
            if (val == null) {
                h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#b2bec3"></span><span class="expanded-chart-tooltip-label">No data available</span><span class="expanded-chart-tooltip-value">\u2014</span></div>';
            } else {
                h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#5777a9"></span><span class="expanded-chart-tooltip-label">Nuclear electricity</span><span class="expanded-chart-tooltip-value">' + val.toFixed(1) + ' TWh</span></div>';
            }
            h += '</div>';
        } else if (chartType === 'constructionStarts') {
            var cs = d.constructionStarts[year] || [];
            h += '<div class="expanded-chart-tooltip-summary">';
            h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#e17055"></span><span class="expanded-chart-tooltip-label">Construction starts</span><span class="expanded-chart-tooltip-value">' + cs.length + '</span></div>';
            h += '</div>';
            if (cs.length > 0) {
                h += '<div class="expanded-chart-tooltip-divider"></div>';
                h += '<div class="expanded-chart-tooltip-section-title">Reactors</div>';
                cs.slice(0, MAX_ITEMS).forEach(function(e) {
                    h += '<div class="expanded-chart-tooltip-reactor" data-plant-name="' + escapeHtml(e.plantName) + '" data-reactor-name="' + escapeHtml(e.reactorName) + '"><span class="expanded-chart-tooltip-reactor-name">' + escapeHtml(e.reactorName) + '</span><span class="expanded-chart-tooltip-reactor-detail">' + escapeHtml(e.country) + '</span></div>';
                });
                if (cs.length > MAX_ITEMS) h += '<div class="expanded-chart-tooltip-more">+ ' + (cs.length - MAX_ITEMS) + ' more</div>';
            }
        } else if (chartType === 'gridConnections') {
            var gc2 = d.gridConnections[year] || [];
            h += '<div class="expanded-chart-tooltip-summary">';
            h += '<div class="expanded-chart-tooltip-summary-row"><span class="expanded-chart-tooltip-dot" style="background:#00b894"></span><span class="expanded-chart-tooltip-label">Grid connections</span><span class="expanded-chart-tooltip-value">' + gc2.length + '</span></div>';
            h += '</div>';
            if (gc2.length > 0) {
                h += '<div class="expanded-chart-tooltip-divider"></div>';
                h += '<div class="expanded-chart-tooltip-section-title">Reactors</div>';
                gc2.slice(0, MAX_ITEMS).forEach(function(e) {
                    h += '<div class="expanded-chart-tooltip-reactor" data-plant-name="' + escapeHtml(e.plantName) + '" data-reactor-name="' + escapeHtml(e.reactorName) + '"><span class="expanded-chart-tooltip-reactor-name">' + escapeHtml(e.reactorName) + '</span><span class="expanded-chart-tooltip-reactor-detail">' + escapeHtml(e.country) + '</span></div>';
                });
                if (gc2.length > MAX_ITEMS) h += '<div class="expanded-chart-tooltip-more">+ ' + (gc2.length - MAX_ITEMS) + ' more</div>';
            }
        }
        return h;
    }

    /* ---- Position tooltip near hovered point ---- */
    function positionExpandedTooltip(clientX, clientY) {
        if (!expandedChartTooltip) return;
        var tt = expandedChartTooltip;
        var card = expandedChartTooltipCard;
        // Render offscreen first to measure
        tt.style.left = '-9999px';
        tt.style.top = '-9999px';
        tt.classList.add('visible');
        var ttRect = card.getBoundingClientRect();
        var ttW = ttRect.width || 280;
        var ttH = ttRect.height || 200;
        var pad = 16;
        // Prefer right side of cursor; fall back to left if it would overflow
        var left = clientX + pad;
        if (left + ttW > window.innerWidth - pad) {
            left = clientX - ttW - pad;
        }
        // Vertically centre on cursor, clamp to viewport
        var top = clientY - ttH / 2;
        top = Math.max(pad, Math.min(window.innerHeight - ttH - pad, top));
        tt.style.left = left + 'px';
        tt.style.top = top + 'px';
    }

    var tooltipPinned = false;

    function hideExpandedTooltip() {
        if (expandedChartTooltip) {
            expandedChartTooltip.classList.remove('visible');
            expandedChartTooltip.classList.remove('pinned');
        }
        tooltipPinned = false;
    }

    // v5.7.173: Dispatch to correct renderer based on chart config
    function renderExpandedChartDispatch(chartType, hoverYear) {
        var config = expandedChartConfig[chartType];
        if (config && config.renderType === 'default-bar') {
            renderExpandedBarChart(chartType, hoverYear);
        } else {
            renderExpandedChart(chartType, hoverYear);
        }
    }

    /* ---- Hover interaction ---- */
    function setupExpandedChartHover() {
        var canvas = expandedChartCanvas;
        if (!canvas || !currentExpandedChartType) return;
        if (expandedChartHoverCleanup) { expandedChartHoverCleanup(); expandedChartHoverCleanup = null; }
        var chartType = currentExpandedChartType;

        function onMove(e) {
            if (tooltipPinned) return;
            var meta = chartMetadata.get(canvas);
            if (!meta) return;
            var rect = canvas.getBoundingClientRect();
            var x = e.clientX - rect.left;
            if (x < meta.margin.left || x > meta.margin.left + meta.plotWidth) {
                hideExpandedTooltip();
                renderExpandedChartDispatch(chartType, null);
                return;
            }
            var yr = Math.max(meta.minYear, Math.min(meta.maxYear, meta.xToYear(x)));
            renderExpandedChartDispatch(chartType, yr);
            // Tooltip
            expandedChartTooltipCard.innerHTML = buildTooltipHTML(chartType, yr);
            positionExpandedTooltip(e.clientX, e.clientY);
        }
        function onLeave() {
            if (tooltipPinned) return;
            hideExpandedTooltip();
            renderExpandedChartDispatch(chartType, null);
        }
        function onClick(e) {
            var meta = chartMetadata.get(canvas);
            if (!meta) return;
            var rect = canvas.getBoundingClientRect();
            var x = e.clientX - rect.left;
            if (x < meta.margin.left || x > meta.margin.left + meta.plotWidth) return;
            var yr = Math.max(meta.minYear, Math.min(meta.maxYear, meta.xToYear(x)));
            yearSlider.value = yr;
            updateMapForYear(yr);
            renderExpandedChartDispatch(chartType, yr);
            tooltipPinned = true;
            expandedChartTooltipCard.innerHTML = buildTooltipHTML(chartType, yr, true);
            expandedChartTooltip.classList.add('pinned');
            positionExpandedTooltip(e.clientX, e.clientY);
        }
        function onDocClick(e) {
            if (!tooltipPinned) return;
            if (expandedChartTooltip && expandedChartTooltip.contains(e.target)) return;
            if (canvas.contains(e.target)) return;
            hideExpandedTooltip();
            renderExpandedChartDispatch(chartType, null);
        }
        canvas.addEventListener('mousemove', onMove);
        canvas.addEventListener('mouseleave', onLeave);
        canvas.addEventListener('click', onClick);
        document.addEventListener('click', onDocClick, true);
        expandedChartHoverCleanup = function() {
            canvas.removeEventListener('mousemove', onMove);
            canvas.removeEventListener('mouseleave', onLeave);
            canvas.removeEventListener('click', onClick);
            document.removeEventListener('click', onDocClick, true);
            tooltipPinned = false;
        };
    }

    /* ---- Open / Close ---- */
    function openExpandedChart(chartType) {
        var config = expandedChartConfig[chartType];
        if (!config) return;
        var renderType = config.renderType || 'default';

        // For default (global timeline) charts, require timelineData
        if ((renderType === 'default' || renderType === 'default-bar') && !timelineData) return;

        currentExpandedChartType = chartType;

        // Title & subtitle support both strings and functions
        var titleText = typeof config.title === 'function' ? config.title() : config.title;
        var subtitleText = typeof config.subtitle === 'function' ? config.subtitle() : config.subtitle;
        if (expandedChartTitleEl) expandedChartTitleEl.textContent = titleText;
        if (expandedChartSubtitle) expandedChartSubtitle.textContent = subtitleText;

        // Legend
        var ds = config.datasets ? config.datasets() : [];
        var legendHTML = '';
        ds.forEach(function(d) {
            legendHTML += '<div class="expanded-chart-legend-item"><span class="expanded-chart-legend-swatch" style="background:' + d.color + '"></span>' + d.label + '</div>';
        });
        if (expandedChartLegend) expandedChartLegend.innerHTML = legendHTML;

        // Toggle (Annual/Cumulative) for production charts
        if (expandedChartToggle) {
            if (config.hasToggle) {
                expandedChartToggle.style.display = 'flex';
                wireExpandedToggle(chartType);
            } else {
                expandedChartToggle.style.display = 'none';
            }
        }

        hideExpandedTooltip();
        expandedChartModal.classList.add('open');
        expandedChartModal.setAttribute('aria-hidden', 'false');

        if (renderType === 'canvas-custom') {
            // Production line charts — use drawLineChartOnCanvas on the expanded canvas
            expandedChartModal.classList.remove('expanded-chart-fit');
            if (expandedChartLegend) expandedChartLegend.style.display = '';
            if (expandedChartCanvas) expandedChartCanvas.style.display = '';
            if (expandedChartCustom) expandedChartCustom.style.display = 'none';
            requestAnimationFrame(function() { requestAnimationFrame(function() {
                renderExpandedProductionChart(chartType);
                setupExpandedProductionHover(chartType);
            }); });
        } else if (renderType === 'custom-svg') {
            // SVG charts (timeline, deploy) — fit dialog to content; hide outer legend (charts provide their own)
            expandedChartModal.classList.add('expanded-chart-fit');
            if (expandedChartLegend) expandedChartLegend.style.display = 'none';
            if (expandedChartCanvas) expandedChartCanvas.style.display = 'none';
            if (expandedChartCustom) { expandedChartCustom.style.display = 'flex'; expandedChartCustom.innerHTML = ''; }
            requestAnimationFrame(function() { requestAnimationFrame(function() {
                if (config.customRender) config.customRender(expandedChartCustom);
            }); });
        } else if (renderType === 'default-bar') {
            // v5.7.173: Bar chart variant for discrete event data (construction starts)
            expandedChartModal.classList.remove('expanded-chart-fit');
            if (expandedChartLegend) expandedChartLegend.style.display = '';
            if (expandedChartCanvas) expandedChartCanvas.style.display = '';
            if (expandedChartCustom) expandedChartCustom.style.display = 'none';
            buildExpandedChartDetails();
            requestAnimationFrame(function() { requestAnimationFrame(function() {
                renderExpandedBarChart(chartType, null);
                setupExpandedChartHover();
            }); });
        } else {
            // Default: global timeline charts (original behavior)
            expandedChartModal.classList.remove('expanded-chart-fit');
            if (expandedChartLegend) expandedChartLegend.style.display = '';
            if (expandedChartCanvas) expandedChartCanvas.style.display = '';
            if (expandedChartCustom) expandedChartCustom.style.display = 'none';
            buildExpandedChartDetails();
            requestAnimationFrame(function() { requestAnimationFrame(function() {
                renderExpandedChart(chartType, null);
                setupExpandedChartHover();
            }); });
        }
    }
    function closeExpandedChart() {
        expandedChartModal.classList.remove('open');
        expandedChartModal.classList.remove('expanded-chart-fit');
        expandedChartModal.setAttribute('aria-hidden', 'true');
        hideExpandedTooltip();
        if (expandedChartHoverCleanup) { expandedChartHoverCleanup(); expandedChartHoverCleanup = null; }
        currentExpandedChartType = null;
        // Clean up custom content
        if (expandedChartCustom) { expandedChartCustom.innerHTML = ''; expandedChartCustom.style.display = 'none'; }
        if (expandedChartCanvas) expandedChartCanvas.style.display = '';
        if (expandedChartToggle) expandedChartToggle.style.display = 'none';
    }

    // Wire expand buttons
    document.querySelectorAll('.timeline-chart-expand').forEach(function(btn) {
        var panel = btn.closest('.timeline-chart-panel');
        if (!panel) return;
        var ct = panel.getAttribute('data-chart');
        btn.addEventListener('click', function(e) { e.stopPropagation(); openExpandedChart(ct); });
    });
    if (expandedChartClose) expandedChartClose.addEventListener('click', closeExpandedChart);
    if (expandedChartBackdrop) expandedChartBackdrop.addEventListener('click', closeExpandedChart);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && expandedChartModal && expandedChartModal.classList.contains('open')) {
            closeExpandedChart();
        }
    });

    // Click on a reactor in the tooltip to navigate to it on the map
    if (expandedChartTooltipCard) {
        expandedChartTooltipCard.addEventListener('click', function(e) {
            var row = e.target.closest('.expanded-chart-tooltip-reactor');
            if (!row) return;
            var plantName = row.getAttribute('data-plant-name');
            var reactorName = row.getAttribute('data-reactor-name');
            if (!plantName) return;
            var plant = nuclearPlants.find(function(p) { return p.name === plantName; });
            if (!plant) return;
            closeExpandedChart();
            zoomToPlant(plant, reactorName || null);
        });
    }

    // --- End Expanded Chart Modal ---

    // ============================================================
    // v5.7.80  Expandable charts for plant & country detail panels
    // ============================================================

    // --- Config entries for plant & country charts ---

    expandedChartConfig.plantProduction = {
        title: function() {
            return (plantProductionData ? escapeHtml(plantProductionData.name) : 'Plant') + ' electricity generation';
        },
        subtitle: function() {
            return plantProductionMode === 'annual'
                ? 'Annual (TWh)'
                : 'Cumulative (TWh)';
        },
        renderType: 'canvas-custom',
        hasToggle: true,
        toggleMode: function() { return plantProductionMode; },
        setToggleMode: function(m) { plantProductionMode = m; },
        datasets: function() {
            return [{ data: {}, color: '#5777a9', label: 'Electricity (TWh)' }];
        },
        getCanvasData: function() {
            if (!plantProductionData) return null;
            var series = getPlantProductionSeries(plantProductionData);
            if (!series.years || !series.years.length) return null;
            var vals = series.values.map(function(v) { return v / 1000; });
            if (plantProductionMode === 'cumulative') {
                var cum = 0;
                vals = vals.map(function(v) { cum += v; return cum; });
            }
            return { years: series.years, values: vals };
        }
    };

    expandedChartConfig.countryProduction = {
        title: function() {
            return (countryProductionData && countryProductionData.country
                ? escapeHtml(countryProductionData.country) : 'Country') + ' Nuclear electricity generation';
        },
        subtitle: function() {
            return countryProductionMode === 'annual'
                ? 'Annual (TWh)'
                : 'Cumulative (TWh)';
        },
        renderType: 'canvas-custom',
        hasToggle: true,
        toggleMode: function() { return countryProductionMode; },
        setToggleMode: function(m) { countryProductionMode = m; },
        datasets: function() {
            return [{ data: {}, color: '#5777a9', label: 'Electricity (TWh)' }];
        },
        getCanvasData: function() {
            if (!countryProductionData) return null;
            var series = getCountryProductionSeries(countryProductionData);
            if (!series.years || !series.years.length) return null;
            var vals = series.values.map(function(v) { return v / 1000; });
            if (countryProductionMode === 'cumulative') {
                var cum = 0;
                vals = vals.map(function(v) { cum += v; return cum; });
            }
            return { years: series.years, values: vals };
        }
    };

    expandedChartConfig.plantTimeline = {
        title: function() {
            return (plantProductionData ? escapeHtml(plantProductionData.name) : 'Plant') + ' \u2014 Reactor Timeline';
        },
        subtitle: 'Construction (yellow) and operation (green) periods for each reactor',
        renderType: 'custom-svg',
        hasToggle: false,
        datasets: function() {
            return [
                { data: {}, color: '#fdcb6e', label: 'Construction' },
                { data: {}, color: '#00b894', label: 'Operable' }
            ];
        },
        customRender: function(container) {
            renderExpandedPlantTimeline(container, plantProductionData);
        }
    };

    expandedChartConfig.countryDeploy = {
        title: function() {
            return (currentDeployStats && currentDeployStats.country
                ? escapeHtml(currentDeployStats.country) : 'Country') + ' \u2014 Reactor Deployment';
        },
        subtitle: 'Grid connections (up) and permanent shutdowns (down) by year',
        renderType: 'custom-svg',
        hasToggle: false,
        datasets: function() {
            return [
                { data: {}, color: '#00b894', label: 'Grid Connections' },
                { data: {}, color: '#636e72', label: 'Shutdowns' }
            ];
        },
        customRender: function(container) {
            renderExpandedCountryDeploy(container, currentDeployStats);
        }
    };

    // --- Render expanded production chart (canvas line chart) ---

    function renderExpandedProductionChart(chartType) {
        var config = expandedChartConfig[chartType];
        if (!config || !config.getCanvasData || !expandedChartCanvas) return;
        var data = config.getCanvasData();
        if (!data || !data.years || !data.years.length) return;

        // Let CSS flex sizing determine the canvas dimensions
        expandedChartCanvas.style.width = '';
        expandedChartCanvas.style.height = '';

        drawLineChartOnCanvas(expandedChartCanvas, data.years, data.values, null);
    }

    // --- Hover interactivity for expanded production charts ---

    function setupExpandedProductionHover(chartType) {
        var canvas = expandedChartCanvas;
        if (!canvas) return;
        if (expandedChartHoverCleanup) { expandedChartHoverCleanup(); expandedChartHoverCleanup = null; }

        var config = expandedChartConfig[chartType];
        if (!config || !config.getCanvasData) return;

        var margin = { left: 48, right: 14, top: 12, bottom: 30 };

        function getHoverIndex(e) {
            var data = config.getCanvasData();
            if (!data || !data.years.length) return null;
            var rect = canvas.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var plotW = rect.width - margin.left - margin.right;
            var relX = x - margin.left;
            if (relX < 0 || relX > plotW) return null;
            var idx = Math.round((relX / plotW) * (data.years.length - 1));
            return Math.max(0, Math.min(data.years.length - 1, idx));
        }

        function onMove(e) {
            var data = config.getCanvasData();
            if (!data) return;
            var idx = getHoverIndex(e);
            if (idx === null) {
                hideExpandedTooltip();
                drawLineChartOnCanvas(canvas, data.years, data.values, null);
                return;
            }
            drawLineChartOnCanvas(canvas, data.years, data.values, idx);
            // Build tooltip
            var year = data.years[idx];
            var val = data.values[idx];
            var valStr = val !== null && val !== undefined ? val.toFixed(2) + ' TWh' : '\u2014';
            var html = '<div class="expanded-chart-tooltip-year">' + year + '</div>';
            html += '<div class="expanded-chart-tooltip-summary"><div class="expanded-chart-tooltip-summary-row">';
            html += '<span class="expanded-chart-tooltip-dot" style="background:#5777a9"></span>';
            html += '<span class="expanded-chart-tooltip-label">Electricity</span>';
            html += '<span class="expanded-chart-tooltip-value">' + valStr + '</span>';
            html += '</div></div>';
            if (expandedChartTooltipCard) expandedChartTooltipCard.innerHTML = html;
            if (expandedChartTooltip) expandedChartTooltip.classList.add('visible');
            positionExpandedTooltip(e.clientX, e.clientY);
        }

        function onLeave() {
            hideExpandedTooltip();
            var data = config.getCanvasData();
            if (data) drawLineChartOnCanvas(canvas, data.years, data.values, null);
        }

        canvas.addEventListener('mousemove', onMove);
        canvas.addEventListener('mouseleave', onLeave);
        expandedChartHoverCleanup = function() {
            canvas.removeEventListener('mousemove', onMove);
            canvas.removeEventListener('mouseleave', onLeave);
        };
    }

    // --- Wire production toggle inside expanded modal ---

    function wireExpandedToggle(chartType) {
        if (!expandedChartToggle) return;
        var config = expandedChartConfig[chartType];
        if (!config || !config.hasToggle) return;

        var btns = expandedChartToggle.querySelectorAll('.production-toggle-btn');
        btns.forEach(function(btn) {
            var currentMode = config.toggleMode ? config.toggleMode() : 'annual';
            btn.classList.toggle('active', btn.dataset.mode === currentMode);

            // Clone to remove old listeners
            var newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);

            newBtn.addEventListener('click', function() {
                var mode = newBtn.dataset.mode;
                var curMode = config.toggleMode ? config.toggleMode() : 'annual';
                if (mode === curMode) return;
                if (config.setToggleMode) config.setToggleMode(mode);

                // Update button active states
                expandedChartToggle.querySelectorAll('.production-toggle-btn').forEach(function(b) {
                    b.classList.toggle('active', b.dataset.mode === mode);
                });

                // Update subtitle
                var subtitleText = typeof config.subtitle === 'function' ? config.subtitle() : config.subtitle;
                if (expandedChartSubtitle) expandedChartSubtitle.textContent = subtitleText;

                // Re-render
                renderExpandedProductionChart(chartType);
                setupExpandedProductionHover(chartType);
            });
        });
    }

    // --- Render expanded plant timeline (SVG) ---

    function renderExpandedPlantTimeline(container, plant) {
        if (!container || !plant || !plant.reactors || plant.reactors.length === 0) {
            container.innerHTML = '<div class="detail-empty">No reactor timeline data available.</div>';
            return;
        }

        var cutoffYear = currentSelectedYear;
        var reactorsForYear = plant.reactors.filter(function(r) {
            return r.constructionStart && r.constructionStart <= cutoffYear;
        });

        if (reactorsForYear.length === 0) {
            container.innerHTML = '<div class="detail-empty">No reactor timeline data available for this period.</div>';
            return;
        }

        var reactors = reactorsForYear.slice().sort(function(a, b) {
            var ag = a.gridConnection || 9999;
            var bg = b.gridConnection || 9999;
            if (ag !== bg) return ag - bg;
            return String(a.name || '').localeCompare(String(b.name || ''));
        });

        var yearsAll = [];
        reactors.forEach(function(r) {
            if (r.constructionStart) yearsAll.push(r.constructionStart);
            if (r.gridConnection && r.gridConnection <= cutoffYear) yearsAll.push(r.gridConnection);
            if (r.shutdownDate && r.shutdownDate <= cutoffYear) yearsAll.push(r.shutdownDate);
        });

        var minYr = yearsAll.length ? Math.min.apply(null, yearsAll) : MIN_YEAR;
        var maxYrData = yearsAll.length ? Math.max.apply(null, yearsAll) : cutoffYear;
        var maxYr = Math.min(Math.max(maxYrData, cutoffYear), cutoffYear + 2);
        var pad = 2;
        var xMin = Math.max(1900, minYr - pad);
        var xMax = Math.min(2100, maxYr + pad);

        // Expanded layout: use wider dimensions
        var containerWidth = container.getBoundingClientRect().width || 900;
        var rowH = 36;
        var topPad = 44;
        var labelW = 140;
        var leftPad = labelW + 8;
        var rightPad = 16;
        var width = Math.max(400, Math.floor(containerWidth));
        var plotW = width - leftPad - rightPad;
        var height = topPad + reactors.length * rowH + 30;

        var yearToX = function(y) { return leftPad + ((y - xMin) / (xMax - xMin)) * plotW; };

        // v5.7.181: finer labels for small ranges + vertical gridlines
        var range = xMax - xMin;
        var step = range <= 10 ? 1 : range <= 20 ? 2 : range <= 40 ? 5 : 10;
        var firstTick = Math.ceil(xMin / step) * step;

        var COLOR_OPERATING = '#00b894';
        var COLOR_CONSTRUCTION = '#fdcb6e';
        var COLOR_CURRENT_YEAR = '#5777a9';

        var svg = '<svg width="100%" height="' + height + '" viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="Reactor timeline">';

        svg += '<line x1="' + leftPad + '" y1="' + (topPad - 10) + '" x2="' + (leftPad + plotW) + '" y2="' + (topPad - 10) + '" stroke="#e9ecef" stroke-width="2" />';

        for (var y = firstTick; y <= xMax; y += step) {
            var x = yearToX(y);
            svg += '<line x1="' + x + '" y1="' + (topPad - 10) + '" x2="' + x + '" y2="' + (topPad + reactors.length * rowH) + '" stroke="#f0f2f5" stroke-width="1" />';
            svg += '<line x1="' + x + '" y1="' + (topPad - 14) + '" x2="' + x + '" y2="' + (topPad - 6) + '" stroke="#dfe6e9" stroke-width="2" />';
            svg += '<text x="' + x + '" y="' + (topPad - 20) + '" text-anchor="middle" font-family="Muli, sans-serif" font-size="12" font-weight="800" fill="#8898aa">' + y + '</text>';
        }

        if (cutoffYear < MAX_YEAR && cutoffYear >= xMin && cutoffYear <= xMax) {
            var currentX = yearToX(cutoffYear);
            svg += '<line x1="' + currentX + '" y1="' + (topPad - 10) + '" x2="' + currentX + '" y2="' + (topPad + reactors.length * rowH + 10) + '" stroke="' + COLOR_CURRENT_YEAR + '" stroke-width="2" stroke-dasharray="4,3" opacity="0.8" />';
            svg += '<text x="' + currentX + '" y="' + (topPad + reactors.length * rowH + 24) + '" text-anchor="middle" font-family="Muli, sans-serif" font-size="11" font-weight="700" fill="' + COLOR_CURRENT_YEAR + '">' + cutoffYear + '</text>';
        }

        reactors.forEach(function(r, i) {
            var ry = topPad + i * rowH + 8;
            var name = escapeHtmlAttr(r.displayName || r.name || 'Reactor');
            var cStart = r.constructionStart || null;
            var gYear = (r.gridConnection && r.gridConnection <= cutoffYear) ? r.gridConnection : null;
            var hasShutdown = r.shutdownDate && r.shutdownDate <= cutoffYear;
            var endYear = hasShutdown ? r.shutdownDate : cutoffYear;
            var barH = 20;
            var capacityStr = r.capacity ? ' (' + r.capacity + ' MW)' : '';

            // Formatted dates for display (MM/YYYY)
            var cStartFormatted = r.constructionStartFormatted || (cStart ? String(cStart) : '');
            var gYearFormatted = gYear ? (r.gridConnectionFormatted || String(gYear)) : '';
            var shutdownFormatted = hasShutdown ? (r.shutdownDateFormatted || String(r.shutdownDate)) : '';

            // Reactor name label on the left (inside reserved label column)
            svg += '<text x="' + (leftPad - 10) + '" y="' + (ry + barH / 2 + 4) + '" font-family="Muli, sans-serif" font-size="11" font-weight="700" fill="#636e72" text-anchor="end">' + escapeHtml(r.displayName || r.name || '') + '</text>';

            var barMidY = ry + barH / 2;

            if (cStart) {
                var connEnd = gYear || Math.min(cStart + 8, cutoffYear);
                var cx1 = yearToX(cStart);
                var cx2 = yearToX(connEnd);
                var cw = Math.max(4, cx2 - cx1);
                svg += '<rect class="timeline-segment" x="' + cx1 + '" y="' + ry + '" width="' + cw + '" height="' + barH + '" rx="4" fill="' + COLOR_CONSTRUCTION + '" opacity="0.9"';
                svg += ' data-segment-type="construction" data-reactor-name="' + name + capacityStr + '"';
                svg += ' data-construction-start="' + escapeHtmlAttr(cStartFormatted) + '" data-grid-connection="' + escapeHtmlAttr(gYearFormatted || '\u2014') + '" />';

                // Construction start marker (diamond)
                svg += '<polygon points="' + cx1 + ',' + (barMidY - 6) + ' ' + (cx1 + 6) + ',' + barMidY + ' ' + cx1 + ',' + (barMidY + 6) + ' ' + (cx1 - 6) + ',' + barMidY + '" fill="#ffffff" stroke="' + COLOR_CONSTRUCTION + '" stroke-width="2" />';

                // Shutdown marker if shutdown occurred before grid connection
                if (!gYear && r.shutdownDate && r.shutdownDate <= cutoffYear) {
                    var xs = yearToX(r.shutdownDate);
                    svg += '<rect x="' + (xs - 5) + '" y="' + (barMidY - 5) + '" width="10" height="10" rx="2" fill="#ffffff" stroke="' + COLOR_CONSTRUCTION + '" stroke-width="2" />';
                }
            }

            if (gYear) {
                var ox1 = yearToX(gYear);
                var ox2 = yearToX(endYear);
                var ow = Math.max(4, ox2 - ox1);
                svg += '<rect class="timeline-segment" x="' + ox1 + '" y="' + ry + '" width="' + ow + '" height="' + barH + '" rx="4" fill="' + COLOR_OPERATING + '" opacity="0.9"';
                svg += ' data-segment-type="operable" data-reactor-name="' + name + capacityStr + '"';
                svg += ' data-grid-connection="' + escapeHtmlAttr(gYearFormatted) + '" data-shutdown="' + escapeHtmlAttr(shutdownFormatted || '\u2014') + '" />';

                // Grid connection marker (circle)
                svg += '<circle cx="' + ox1 + '" cy="' + barMidY + '" r="5" fill="#ffffff" stroke="' + COLOR_OPERATING + '" stroke-width="2" />';

                // Shutdown marker
                if (hasShutdown) {
                    var xs2 = yearToX(r.shutdownDate);
                    svg += '<rect x="' + (xs2 - 5) + '" y="' + (barMidY - 5) + '" width="10" height="10" rx="2" fill="#ffffff" stroke="' + COLOR_OPERATING + '" stroke-width="2" />';
                }
            }
        });

        svg += '</svg>';

        // Build legend matching non-expanded version
        var legendItems = '<div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;transform:rotate(45deg);background:#ffffff;border:2px solid ' + COLOR_CONSTRUCTION + ';"></span>Construction start</div>';
        legendItems += '<div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#ffffff;border:2px solid ' + COLOR_OPERATING + ';"></span>Grid connection</div>';
        legendItems += '<div class="timeline-legend-item"><span style="display:inline-block;width:10px;height:10px;border-radius:3px;background:#ffffff;border:2px solid ' + COLOR_OPERATING + ';"></span>Shutdown</div>';
        if (cutoffYear < MAX_YEAR) {
            legendItems += '<div class="timeline-legend-item"><span style="display:inline-block;width:2px;height:12px;background:' + COLOR_CURRENT_YEAR + ';border:none;"></span>Viewing: ' + cutoffYear + '</div>';
        }
        svg += '<div class="timeline-legend" aria-label="Timeline legend">' + legendItems + '</div>';

        svg += '<div id="timelineTooltip" class="timeline-tooltip" style="display:none;position:absolute;"></div>';

        var wrapper = document.createElement('div');
        wrapper.className = 'detail-timeline';
        wrapper.style.position = 'relative';
        wrapper.style.width = '100%';
        wrapper.innerHTML = svg;
        container.innerHTML = '';
        container.appendChild(wrapper);

        setupTimelineInteractivity(wrapper);
    }

    // --- Render expanded country deployment chart (SVG) ---

    function renderExpandedCountryDeploy(container, stats) {
        if (!container) return;
        if (!stats || !stats.plants || stats.plants.length === 0) {
            container.innerHTML = '<div class="detail-empty" style="padding:40px 20px;text-align:center;">No reactor data available.</div>';
            return;
        }

        var cutoffYear = currentSelectedYear;
        var connectionsByYear = {};
        var shutdownsByYear = {};

        stats.plants.forEach(function(plant) {
            if (!plant.reactors) return;
            plant.reactors.forEach(function(reactor) {
                var gridYear = reactor.gridConnection;
                var shutdownYear = reactor.shutdownDate;
                var capacity = reactor.capacity || 0;
                var name = reactor.displayName || reactor.name || 'Unknown';
                var plantName = plant.name;

                if (gridYear && gridYear <= cutoffYear) {
                    if (!connectionsByYear[gridYear]) connectionsByYear[gridYear] = [];
                    connectionsByYear[gridYear].push({ name: name, plantName: plantName, capacity: capacity, year: gridYear });
                }

                if (shutdownYear && shutdownYear <= cutoffYear) {
                    if (!shutdownsByYear[shutdownYear]) shutdownsByYear[shutdownYear] = [];
                    shutdownsByYear[shutdownYear].push({ name: name, plantName: plantName, capacity: capacity, year: shutdownYear });
                }
            });
        });

        var allYears = Object.keys(connectionsByYear).concat(Object.keys(shutdownsByYear)).map(Number);
        if (allYears.length === 0) {
            container.innerHTML = '<div class="detail-empty" style="padding:40px 20px;text-align:center;">No reactor timeline data available for this period.</div>';
            return;
        }

        var minYear = Math.min.apply(null, allYears);
        var maxYear = Math.min(Math.max.apply(null, allYears), cutoffYear);

        // Use wider dimensions for expanded view
        var containerWidth = (container.getBoundingClientRect().width || 900) - 24;
        var getYearValue = function(reactors) {
            if (!reactors) return 0;
            if (currentDeployMode === 'units') return reactors.length;
            return reactors.reduce(function(sum, r) { return sum + (r.capacity || 0); }, 0) / 1000;
        };

        var maxConnection = 0, maxShutdown = 0;
        for (var yr = minYear; yr <= maxYear; yr++) {
            var connVal = getYearValue(connectionsByYear[yr]);
            var shutVal = getYearValue(shutdownsByYear[yr]);
            if (connVal > maxConnection) maxConnection = connVal;
            if (shutVal > maxShutdown) maxShutdown = shutVal;
        }
        var maxValue = Math.max(maxConnection, maxShutdown, 1);

        var chartHeight = 300;
        var paddingLeft = 50;
        var paddingRight = 18;
        var paddingTop = 24;
        var paddingBottom = 32;
        var chartWidth = containerWidth - paddingLeft - paddingRight;
        var plotHeight = chartHeight - paddingTop - paddingBottom;
        var zeroY = paddingTop + plotHeight / 2;

        var yearCount = maxYear - minYear + 1;
        var barWidth = Math.max(3, Math.min(14, (chartWidth / yearCount) - 2));
        var barGap = (chartWidth - barWidth * yearCount) / (yearCount + 1);

        var yearToX = function(year) { return paddingLeft + barGap + (year - minYear) * (barWidth + barGap); };
        var xToYear = function(x) { return Math.round((x - paddingLeft - barGap) / (barWidth + barGap) + minYear); }; // v5.7.135
        var valueToHeight = function(val) { return (val / maxValue) * (plotHeight / 2 - 5); };

        var svgStr = '<svg class="reactor-deploy-svg" viewBox="0 0 ' + containerWidth + ' ' + chartHeight + '">';

        var gridSteps = 4;
        for (var gi = 0; gi <= gridSteps; gi++) {
            var gy = paddingTop + (gi / gridSteps) * plotHeight;
            svgStr += '<line x1="' + paddingLeft + '" y1="' + gy + '" x2="' + (containerWidth - paddingRight) + '" y2="' + gy + '" class="reactor-deploy-grid-line" />';
        }

        svgStr += '<line x1="' + paddingLeft + '" y1="' + zeroY + '" x2="' + (containerWidth - paddingRight) + '" y2="' + zeroY + '" class="reactor-deploy-zero-line" />';

        var yLabelUnit = currentDeployMode === 'units' ? '' : ' GW';
        var topVal = Math.ceil(maxValue);
        svgStr += '<text x="' + (paddingLeft - 8) + '" y="' + (paddingTop + 4) + '" class="reactor-deploy-axis-label" text-anchor="end">' + topVal + yLabelUnit + '</text>';
        svgStr += '<text x="' + (paddingLeft - 8) + '" y="' + (zeroY + 4) + '" class="reactor-deploy-axis-label" text-anchor="end">0</text>';
        svgStr += '<text x="' + (paddingLeft - 8) + '" y="' + (paddingTop + plotHeight + 4) + '" class="reactor-deploy-axis-label" text-anchor="end">' + topVal + yLabelUnit + '</text>';

        var labelInterval = yearCount <= 20 ? 1 : yearCount <= 40 ? 2 : yearCount <= 80 ? 5 : 10;

        for (var year = minYear; year <= maxYear; year++) {
            var x = yearToX(year);
            var cVal = getYearValue(connectionsByYear[year]);
            var sVal = getYearValue(shutdownsByYear[year]);

            // v5.7.136: Greyscale for future years (matching mini chart)
            var isFuture = year > cutoffYear;
            var dimOpacity = isFuture ? ' opacity="0.3"' : '';
            var connColor = isFuture ? '#a0a0a0' : '#00b894';
            var shutColor = isFuture ? '#d0d0d0' : '#636e72';

            if (cVal > 0) {
                var bH = valueToHeight(cVal);
                svgStr += '<rect class="reactor-deploy-bar connections" x="' + x + '" y="' + (zeroY - bH) + '" width="' + barWidth + '" height="' + bH + '" rx="2" fill="' + connColor + '"' + dimOpacity + ' data-year="' + year + '" data-type="connections" />';
            }
            if (sVal > 0) {
                var sbH = valueToHeight(sVal);
                svgStr += '<rect class="reactor-deploy-bar shutdowns" x="' + x + '" y="' + zeroY + '" width="' + barWidth + '" height="' + sbH + '" rx="2" fill="' + shutColor + '"' + dimOpacity + ' data-year="' + year + '" data-type="shutdowns" />';
            }

            if ((year - minYear) % labelInterval === 0 || year === maxYear) {
                svgStr += '<text x="' + (x + barWidth / 2) + '" y="' + (chartHeight - 5) + '" class="reactor-deploy-axis-label" text-anchor="middle">' + year + '</text>';
            }
        }

        // v5.7.136: Add vertical year indicator line (matching mini chart behavior)
        var isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
        if (cutoffYear >= minYear && cutoffYear <= maxYear) {
            var hlX = yearToX(cutoffYear) + barWidth / 2;
            var hlColor = isDarkMode ? 'rgba(255,255,255,0.35)' : 'rgba(45,52,54,0.35)';
            svgStr += '<line class="deploy-highlight-line" x1="' + hlX + '" y1="' + paddingTop + '" x2="' + hlX + '" y2="' + (paddingTop + plotHeight) + '" stroke="' + hlColor + '" stroke-width="1" stroke-dasharray="3 3" />';
        }

        svgStr += '</svg>';

        var html = '<div class="reactor-deploy-chart" style="border:none;box-shadow:none;margin:0;">';
        html += '<div class="reactor-deploy-header">';
        html += '<div class="reactor-deploy-legend">';
        html += '<div class="reactor-deploy-legend-item"><div class="reactor-deploy-legend-dot connections"></div><span>Grid connections</span></div>';
        html += '<div class="reactor-deploy-legend-item"><div class="reactor-deploy-legend-dot shutdowns"></div><span>Permanent shutdowns</span></div>';
        html += '</div>';
        html += '<div class="reactor-deploy-toggle">';
        html += '<button class="reactor-deploy-toggle-btn ' + (currentDeployMode === 'units' ? 'active' : '') + '" data-mode="units">Units</button>';
        html += '<button class="reactor-deploy-toggle-btn ' + (currentDeployMode === 'capacity' ? 'active' : '') + '" data-mode="capacity">Capacity</button>';
        html += '</div>';
        html += '</div>';
        html += '<div class="reactor-deploy-container">' + svgStr + '<div class="reactor-deploy-tooltip" id="deployTooltip"></div></div>';
        html += '</div>';

        container.innerHTML = html;

        // Wire toggle buttons for the expanded view
        var deployContainer = container.querySelector('.reactor-deploy-chart');
        if (deployContainer) {
            var deployToggleBtns = deployContainer.querySelectorAll('.reactor-deploy-toggle-btn');
            deployToggleBtns.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var mode = btn.dataset.mode;
                    if (mode === currentDeployMode) return;
                    currentDeployMode = mode;
                    // Re-render inside the expanded modal
                    renderExpandedCountryDeploy(container, stats);
                });
            });

            setupDeployChartInteractivity(deployContainer, connectionsByYear, shutdownsByYear, minYear, maxYear);

            // v5.7.135: Store metadata and add click-to-change-year handler
            var svgContainer = deployContainer.querySelector('.reactor-deploy-container');
            if (svgContainer) {
                svgContainer._deployMeta = {
                    paddingLeft: paddingLeft,
                    paddingRight: paddingRight,
                    paddingTop: paddingTop,
                    paddingBottom: paddingBottom,
                    chartWidth: chartWidth,
                    plotHeight: plotHeight,
                    zeroY: zeroY,
                    minYear: minYear,
                    maxYear: maxYear,
                    barWidth: barWidth,
                    barGap: barGap,
                    yearToX: yearToX,
                    xToYear: xToYear,
                    containerWidth: containerWidth,
                    chartHeight: chartHeight
                };

            }
        }
    }

    // v5.7.81: Render expanded global reactor deployment chart (SVG diverging bar)
    var globalDeployMode = 'units'; // Independent from country chart's currentDeployMode

    function renderExpandedGlobalDeploy(container) {
        if (!container || !timelineData) {
            if (container) container.innerHTML = '<div class="detail-empty" style="padding:40px 20px;text-align:center;">No timeline data available.</div>';
            return;
        }

        var connectionsByYear = timelineData.gridConnectionDetails || {};
        var shutdownsByYear = timelineData.shutdownDetails || {};

        var allYears = Object.keys(connectionsByYear).concat(Object.keys(shutdownsByYear)).map(Number);
        if (allYears.length === 0) {
            container.innerHTML = '<div class="detail-empty" style="padding:40px 20px;text-align:center;">No reactor deployment data available.</div>';
            return;
        }

        var minYear = Math.min.apply(null, allYears);
        var maxYear = Math.max.apply(null, allYears);

        var containerWidth = (container.getBoundingClientRect().width || 900) - 24;
        var getYearValue = function(reactors) {
            if (!reactors) return 0;
            if (globalDeployMode === 'units') return reactors.length;
            return reactors.reduce(function(sum, r) { return sum + (r.capacity || 0); }, 0) / 1000;
        };

        var maxConnection = 0, maxShutdown = 0;
        for (var yr = minYear; yr <= maxYear; yr++) {
            var connVal = getYearValue(connectionsByYear[yr]);
            var shutVal = getYearValue(shutdownsByYear[yr]);
            if (connVal > maxConnection) maxConnection = connVal;
            if (shutVal > maxShutdown) maxShutdown = shutVal;
        }
        var maxValue = Math.max(maxConnection, maxShutdown, 1);

        var chartHeight = 300;
        var paddingLeft = 50;
        var paddingRight = 18;
        var paddingTop = 24;
        var paddingBottom = 32;
        var chartWidth = containerWidth - paddingLeft - paddingRight;
        var plotHeight = chartHeight - paddingTop - paddingBottom;
        var zeroY = paddingTop + plotHeight / 2;

        var yearCount = maxYear - minYear + 1;
        var barWidth = Math.max(3, Math.min(14, (chartWidth / yearCount) - 2));
        var barGap = (chartWidth - barWidth * yearCount) / (yearCount + 1);

        var yearToX = function(year) { return paddingLeft + barGap + (year - minYear) * (barWidth + barGap); };
        var xToYear = function(x) { return Math.round((x - paddingLeft - barGap) / (barWidth + barGap) + minYear); }; // v5.7.135
        var valueToHeight = function(val) { return (val / maxValue) * (plotHeight / 2 - 5); };

        var svgStr = '<svg class="reactor-deploy-svg" viewBox="0 0 ' + containerWidth + ' ' + chartHeight + '">';

        var gridSteps = 4;
        for (var gi = 0; gi <= gridSteps; gi++) {
            var gy = paddingTop + (gi / gridSteps) * plotHeight;
            svgStr += '<line x1="' + paddingLeft + '" y1="' + gy + '" x2="' + (containerWidth - paddingRight) + '" y2="' + gy + '" class="reactor-deploy-grid-line" />';
        }

        svgStr += '<line x1="' + paddingLeft + '" y1="' + zeroY + '" x2="' + (containerWidth - paddingRight) + '" y2="' + zeroY + '" class="reactor-deploy-zero-line" />';

        var yLabelUnit = globalDeployMode === 'units' ? '' : ' GW';
        var topVal = Math.ceil(maxValue);
        svgStr += '<text x="' + (paddingLeft - 8) + '" y="' + (paddingTop + 4) + '" class="reactor-deploy-axis-label" text-anchor="end">' + topVal + yLabelUnit + '</text>';
        svgStr += '<text x="' + (paddingLeft - 8) + '" y="' + (zeroY + 4) + '" class="reactor-deploy-axis-label" text-anchor="end">0</text>';
        svgStr += '<text x="' + (paddingLeft - 8) + '" y="' + (paddingTop + plotHeight + 4) + '" class="reactor-deploy-axis-label" text-anchor="end">' + topVal + yLabelUnit + '</text>';

        var labelInterval = yearCount <= 20 ? 1 : yearCount <= 40 ? 2 : yearCount <= 80 ? 5 : 10;

        for (var year = minYear; year <= maxYear; year++) {
            var x = yearToX(year);
            var cVal = getYearValue(connectionsByYear[year]);
            var sVal = getYearValue(shutdownsByYear[year]);

            // v5.7.136: Greyscale for future years (matching mini chart)
            var isFuture = year > currentSelectedYear;
            var dimOpacity = isFuture ? ' opacity="0.3"' : '';
            var connColor = isFuture ? '#a0a0a0' : '#00b894';
            var shutColor = isFuture ? '#d0d0d0' : '#636e72';

            if (cVal > 0) {
                var bH = valueToHeight(cVal);
                svgStr += '<rect class="reactor-deploy-bar connections" x="' + x + '" y="' + (zeroY - bH) + '" width="' + barWidth + '" height="' + bH + '" rx="2" fill="' + connColor + '"' + dimOpacity + ' data-year="' + year + '" data-type="connections" />';
            }
            if (sVal > 0) {
                var sbH = valueToHeight(sVal);
                svgStr += '<rect class="reactor-deploy-bar shutdowns" x="' + x + '" y="' + zeroY + '" width="' + barWidth + '" height="' + sbH + '" rx="2" fill="' + shutColor + '"' + dimOpacity + ' data-year="' + year + '" data-type="shutdowns" />';
            }

            if ((year - minYear) % labelInterval === 0 || year === maxYear) {
                svgStr += '<text x="' + (x + barWidth / 2) + '" y="' + (chartHeight - 5) + '" class="reactor-deploy-axis-label" text-anchor="middle">' + year + '</text>';
            }
        }

        // v5.7.136: Add vertical year indicator line (matching mini chart behavior)
        var isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
        if (currentSelectedYear >= minYear && currentSelectedYear <= maxYear) {
            var hlX = yearToX(currentSelectedYear) + barWidth / 2;
            var hlColor = isDarkMode ? 'rgba(255,255,255,0.35)' : 'rgba(45,52,54,0.35)';
            svgStr += '<line class="deploy-highlight-line" x1="' + hlX + '" y1="' + paddingTop + '" x2="' + hlX + '" y2="' + (paddingTop + plotHeight) + '" stroke="' + hlColor + '" stroke-width="1" stroke-dasharray="3 3" />';
        }

        svgStr += '</svg>';

        var html = '<div class="reactor-deploy-chart" style="border:none;box-shadow:none;margin:0;">';
        html += '<div class="reactor-deploy-header">';
        html += '<div class="reactor-deploy-legend">';
        html += '<div class="reactor-deploy-legend-item"><div class="reactor-deploy-legend-dot connections"></div><span>Grid connections</span></div>';
        html += '<div class="reactor-deploy-legend-item"><div class="reactor-deploy-legend-dot shutdowns"></div><span>Permanent shutdowns</span></div>';
        html += '</div>';
        html += '<div class="reactor-deploy-toggle">';
        html += '<button class="reactor-deploy-toggle-btn ' + (globalDeployMode === 'units' ? 'active' : '') + '" data-mode="units">Units</button>';
        html += '<button class="reactor-deploy-toggle-btn ' + (globalDeployMode === 'capacity' ? 'active' : '') + '" data-mode="capacity">Capacity</button>';
        html += '</div>';
        html += '</div>';
        html += '<div class="reactor-deploy-container">' + svgStr + '<div class="reactor-deploy-tooltip" id="deployTooltip"></div></div>';
        html += '</div>';

        container.innerHTML = html;

        // Wire toggle buttons
        var deployContainer = container.querySelector('.reactor-deploy-chart');
        if (deployContainer) {
            var deployToggleBtns = deployContainer.querySelectorAll('.reactor-deploy-toggle-btn');
            deployToggleBtns.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var mode = btn.dataset.mode;
                    if (mode === globalDeployMode) return;
                    globalDeployMode = mode;
                    renderExpandedGlobalDeploy(container);
                });
            });

            setupDeployChartInteractivity(deployContainer, connectionsByYear, shutdownsByYear, minYear, maxYear);

            // v5.7.135: Store metadata and add click-to-change-year handler
            var svgContainer = deployContainer.querySelector('.reactor-deploy-container');
            if (svgContainer) {
                svgContainer._deployMeta = {
                    paddingLeft: paddingLeft,
                    paddingRight: paddingRight,
                    paddingTop: paddingTop,
                    paddingBottom: paddingBottom,
                    chartWidth: chartWidth,
                    plotHeight: plotHeight,
                    zeroY: zeroY,
                    minYear: minYear,
                    maxYear: maxYear,
                    barWidth: barWidth,
                    barGap: barGap,
                    yearToX: yearToX,
                    xToYear: xToYear,
                    containerWidth: containerWidth,
                    chartHeight: chartHeight
                };

                // v5.7.136: Use capturing phase to update year BEFORE bar's tooltip handler runs
                var svgEl = svgContainer.querySelector('svg');
                if (svgEl) {
                    svgEl.addEventListener('click', function(e) {
                        var meta = svgContainer._deployMeta;
                        if (!meta) return;

                        // Calculate year from click position
                        var rect = svgContainer.getBoundingClientRect();
                        var x = e.clientX - rect.left;
                        if (x < meta.paddingLeft || x > meta.paddingLeft + meta.chartWidth) return;

                        var clickedYear = meta.xToYear(x);
                        var clampedYear = Math.max(meta.minYear, Math.min(meta.maxYear, clickedYear));

                        // Update year slider and map
                        yearSlider.value = clampedYear;
                        updateMapForYear(clampedYear);

                        // Re-render chart to update greyscale and year line position
                        renderExpandedGlobalDeploy(container);
                    }, true); // CAPTURING phase - runs before bar's bubbling handlers
                }
            }
        }
    }

    // --- Wire detail chart expand buttons ---

    document.querySelectorAll('.detail-chart-expand').forEach(function(btn) {
        var chartType = btn.getAttribute('data-expand-chart');
        if (!chartType) return;
        btn.addEventListener('click', function(e) {
            e.stopPropagation();
            openExpandedChart(chartType);
        });
    });

    // --- End v5.7.80 Expandable detail charts ---


    // Robust re-render helper: fullscreen transitions can briefly report zero/incorrect sizes.
    // If we paint during that window, canvases can get "locked" to tiny pixel dimensions and appear squashed.
    let timelineChartsRenderRaf = null;
    let timelineChartsRenderAttempts = 0;
    const MAX_TIMELINE_CHART_RENDER_ATTEMPTS = 24;

    function requestTimelineChartsRender() {
        if (!timelineChartsRendered || !timelineData) return;
        if (!timelineChartsSidebar || !yearSlider) return;

        // If the sidebar isn't visible yet, don't spin.
        const sidebarRect = timelineChartsSidebar.getBoundingClientRect();
        if (!sidebarRect.width || !sidebarRect.height) return;

        if (timelineChartsRenderRaf) cancelAnimationFrame(timelineChartsRenderRaf);
        timelineChartsRenderAttempts = 0;

        const attempt = () => {
            timelineChartsRenderAttempts++;

            const canvases = [reactorsChartCanvas, electricityChartCanvas, constructionStartsChartCanvas].filter(Boolean);
            const ready = canvases.every(c => {
                const r = c.getBoundingClientRect();
                return r.width > 80 && r.height > 40;
            }) && (!timelineDeployContainer || (function() {
                var dr = timelineDeployContainer.getBoundingClientRect();
                return dr.width > 80 && dr.height > 40;
            })());

            if (!ready) {
                if (timelineChartsRenderAttempts < MAX_TIMELINE_CHART_RENDER_ATTEMPTS) {
                    timelineChartsRenderRaf = requestAnimationFrame(attempt);
                } else {
                    timelineChartsRenderRaf = null;
                }
                return;
            }

            timelineChartsRenderRaf = null;
            renderTimelineCharts(parseInt(yearSlider.value));
        };

        timelineChartsRenderRaf = requestAnimationFrame(attempt);
    }

    // Re-render charts when their container resizes (covers exiting/re-entering fullscreen without reload)
    let timelineChartsResizeObserver = null;
    function initTimelineChartsResizeObserver() {
        if (timelineChartsResizeObserver || typeof ResizeObserver === 'undefined') return;
        if (!timelineChartsSidebar) return;

        timelineChartsResizeObserver = new ResizeObserver(() => {
            // Only re-render when charts are meant to be visible.
            if (!timelineChartsRendered || !timelineData) return;
            if (isInFullscreenNow() && fsStatsCollapsed) return; // v5.7.82: skip if collapsed in fullscreen
            if (!isInFullscreenNow() && !timelineChartsSidebar.classList.contains('expanded')) return;
            requestTimelineChartsRender();
        });

        try {
            timelineChartsResizeObserver.observe(timelineChartsSidebar);
            const contentEl = timelineChartsSidebar.querySelector('.timeline-charts-content');
            if (contentEl) timelineChartsResizeObserver.observe(contentEl);
        } catch (e) {}
    }
    setTimeout(initTimelineChartsResizeObserver, 0);

    // Toggle timeline charts sidebar
    function toggleTimelineCharts(show) {
        // Allow toggling in fullscreen mode (slider is now at bottom of map, not in sidebar)
        const isExpanded = show !== undefined ? show : !timelineChartsSidebar.classList.contains('expanded');
        
        timelineChartsSidebar.classList.toggle('expanded', isExpanded);
        timelineExpandBtn.classList.toggle('expanded', isExpanded);
        timelineExpandBtn.title = isExpanded ? 'Hide charts' : 'Show charts';
        timelineExpandBtn.setAttribute('aria-label', isExpanded ? 'Collapse timeline charts' : 'Expand timeline charts');

        
        // Keep the top-right map controls visible (move them left when the charts sidebar is open)
        if (mapWrapperEl) mapWrapperEl.classList.toggle('timeline-charts-open', isExpanded);

        // Dock/undock the year slider when the charts sidebar opens/closes
        syncYearSliderDock();


if (isExpanded && !timelineChartsRendered) {
            // Calculate data on first expand
            timelineData = calculateTimelineData();
            timelineChartsRendered = true;
            // Render after sidebar animation
            setTimeout(() => {
                requestTimelineChartsRender();
            }, 350);
        } else if (isExpanded) {
            requestTimelineChartsRender();
        }
    }

    // v5.7.82: Toggle the statistics sidebar visibility in fullscreen mode
    function toggleFullscreenStats(collapse) {
        if (!mapWrapperEl || !isInFullscreenNow()) return;
        clearTimeout(fsStatsToggleTimeout);

        const shouldCollapse = collapse !== undefined ? collapse : !fsStatsCollapsed;
        fsStatsCollapsed = shouldCollapse;

        if (shouldCollapse) {
            // Fade out sidebar
            timelineChartsSidebar.style.opacity = '0';
            timelineChartsSidebar.style.pointerEvents = 'none';
            mapWrapperEl.classList.remove('timeline-charts-open');

            fsStatsToggleTimeout = setTimeout(() => {
                mapWrapperEl.classList.add('fs-stats-collapsed');
                setTimeout(() => {
                    try { map.resize(); } catch (e) {}
                }, 50);
            }, 200);
        } else {
            // Expand sidebar
            mapWrapperEl.classList.remove('fs-stats-collapsed');
            timelineChartsSidebar.style.opacity = '0';
            timelineChartsSidebar.style.pointerEvents = '';

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    timelineChartsSidebar.style.opacity = '';
                    mapWrapperEl.classList.add('timeline-charts-open');
                    if (timelineChartsRendered) {
                        requestTimelineChartsRender();
                    }
                    setTimeout(() => {
                        try { map.resize(); } catch (e) {}
                    }, 250);
                });
            });
        }

        // Update close button tooltip
        if (timelineChartsClose) {
            timelineChartsClose.title = shouldCollapse ? 'Show statistics' : 'Hide statistics';
            timelineChartsClose.setAttribute('aria-label',
                shouldCollapse ? 'Show statistics panel' : 'Hide statistics panel');
        }

        // Persist preference
        try { localStorage.setItem('npp-fs-stats-collapsed', shouldCollapse ? 'true' : 'false'); } catch (e) {}
    }

    // Sync Timeline Data state when entering/exiting fullscreen.
    // v5.7.82: Respects saved collapse preference
    function syncTimelineChartsForFullscreen() {
        if (!timelineChartsSidebar || !mapWrapperEl) return;

        if (isInFullscreenNow()) {
            dockTimelineChartsToFullscreenGrid();

            // v5.7.82: Check saved preference for collapsed state
            let preferCollapsed = false;
            try { preferCollapsed = localStorage.getItem('npp-fs-stats-collapsed') === 'true'; } catch (e) {}

            timelineChartsSidebar.classList.add('expanded');
            if (timelineExpandBtn) timelineExpandBtn.classList.add('expanded');
            mapWrapperEl.classList.add('timeline-charts-open');
            syncYearSliderDock();

            if (!timelineChartsRendered) {
                timelineData = calculateTimelineData();
                timelineChartsRendered = true;
            }

            if (preferCollapsed) {
                // Enter fullscreen with sidebar collapsed
                fsStatsCollapsed = true;
                mapWrapperEl.classList.add('fs-stats-collapsed');
                mapWrapperEl.classList.remove('timeline-charts-open');
                timelineChartsSidebar.style.opacity = '0';
                timelineChartsSidebar.style.pointerEvents = 'none';
                setTimeout(() => {
                    try { map.resize(); } catch (e) {}
                }, 50);
            } else {
                // Enter fullscreen with sidebar visible (default)
                fsStatsCollapsed = false;
                mapWrapperEl.classList.remove('fs-stats-collapsed');
                setTimeout(() => {
                    if (timelineChartsSidebar && isInFullscreenNow()) {
                        requestTimelineChartsRender();
                        try { map.resize(); } catch (e) {}
                    }
                }, 50);
            }
        } else {
            restoreTimelineChartsFromFullscreenGrid();
            // v5.7.82: Clean up fullscreen-specific collapsed state
            fsStatsCollapsed = false;
            clearTimeout(fsStatsToggleTimeout);
            mapWrapperEl.classList.remove('fs-stats-collapsed');
            timelineChartsSidebar.style.opacity = '';
            timelineChartsSidebar.style.pointerEvents = '';

            timelineChartsSidebar.classList.remove('expanded');
            if (timelineExpandBtn) timelineExpandBtn.classList.remove('expanded');
            mapWrapperEl.classList.remove('timeline-charts-open');
            syncYearSliderDock();

            setTimeout(() => {
                try { map.resize(); } catch (e) {}
            }, 50);
        }
    }

    // Initial sync (in case fullscreen state is restored)
    setTimeout(syncTimelineChartsForFullscreen, 0);

    // Expand button only works outside fullscreen (hidden in fullscreen via CSS)
if (timelineExpandBtn) {
        timelineExpandBtn.addEventListener('click', () => toggleTimelineCharts());
    }

    // v5.7.82: Close button toggles collapse in fullscreen, or closes in normal mode
    if (timelineChartsClose) {
        timelineChartsClose.addEventListener('click', () => {
            if (isInFullscreenNow()) {
                toggleFullscreenStats();
            } else {
                toggleTimelineCharts(false);
            }
        });
    }

    // v5.7.82: Re-expand button (only functional in fullscreen when collapsed)
    if (fsStatsExpandBtn) {
        fsStatsExpandBtn.addEventListener('click', () => {
            if (isInFullscreenNow() && fsStatsCollapsed) {
                toggleFullscreenStats(false);
            }
        });
    }

    // Update timeline charts when year changes
    const originalUpdateMapForYear = updateMapForYear;
    updateMapForYear = function(year) {
        originalUpdateMapForYear(year);
        if (timelineChartsRendered && timelineChartsSidebar.classList.contains('expanded') && !(isInFullscreenNow() && fsStatsCollapsed)) {
            renderTimelineCharts(year);
        }
    };

    // --- Year Changes Dropdown (v5.7.83) ---
    const yearChangesDropdown = document.getElementById('yearChangesDropdown');
    const yearChangesDropdownToggle = document.getElementById('yearChangesDropdownToggle');
    const yearChangesYear = document.getElementById('yearChangesYear');
    const yearChangesBadge = document.getElementById('yearChangesBadge');
    const yearChangesBody = document.getElementById('yearChangesBody');
    let yearChangesDropdownExpanded = false;

    function toggleYearChangesDropdown(forceState) {
        if (!yearChangesDropdown) return;
        const shouldExpand = forceState !== undefined ? forceState : !yearChangesDropdownExpanded;
        yearChangesDropdownExpanded = shouldExpand;
        yearChangesDropdown.classList.toggle('expanded', shouldExpand);
        if (yearChangesDropdownToggle) {
            yearChangesDropdownToggle.setAttribute('aria-expanded', String(shouldExpand));
        }
    }

    function computeYearChanges(year) {
        const gridConnections = [];
        const constructionStarts = [];
        const shutdowns = [];
        nuclearPlants.forEach(plant => {
            plant.reactors.forEach(reactor => {
                if (reactor.gridConnection === year) {
                    gridConnections.push({ plant, reactor, country: plant.country });
                }
                if (reactor.constructionStart === year) {
                    constructionStarts.push({ plant, reactor, country: plant.country });
                }
                if (reactor.shutdownDate === year) {
                    shutdowns.push({ plant, reactor, country: plant.country });
                }
            });
        });
        return { gridConnections, constructionStarts, shutdowns };
    }

    // v5.7.137: Show displayName and country (removed plant name)
    function buildChangeItemHTML(item) {
        const plantName = escapeHtmlAttr(item.plant.name);
        const displayName = escapeHtml(item.reactor.displayName || item.reactor.name);
        const displayCountry = escapeHtml(item.country);
        return '<div class="year-changes-item" data-plant="' + plantName + '" tabindex="0">' +
            '<span class="year-changes-item-reactor">' + displayName + '</span>' +
            '<span class="year-changes-item-country">' + displayCountry + '</span>' +
            '</div>';
    }

    function renderYearChangesDropdown(year) {
        if (!yearChangesDropdown) return;
        if (year > MAX_YEAR) {
            yearChangesDropdown.style.display = 'none';
            return;
        }
        yearChangesDropdown.style.display = '';

        const changes = computeYearChanges(year);
        const total = changes.gridConnections.length + changes.constructionStarts.length + changes.shutdowns.length;

        yearChangesYear.textContent = year;
        yearChangesBadge.textContent = total;
        yearChangesBadge.setAttribute('data-count', String(total));

        if (total === 0) {
            yearChangesBody.innerHTML = '<div class="year-changes-empty">No status changes this year</div>';
            toggleYearChangesDropdown(false);
            return;
        }

        let html = '';

        if (changes.gridConnections.length > 0) {
            html += '<div class="year-changes-section">';
            html += '<div class="year-changes-section-label"><span class="year-changes-dot green"></span>Connected to grid (' + changes.gridConnections.length + ')</div>';
            changes.gridConnections.forEach(item => { html += buildChangeItemHTML(item); });
            html += '</div>';
        }

        if (changes.constructionStarts.length > 0) {
            html += '<div class="year-changes-section">';
            html += '<div class="year-changes-section-label"><span class="year-changes-dot yellow"></span>Construction started (' + changes.constructionStarts.length + ')</div>';
            changes.constructionStarts.forEach(item => { html += buildChangeItemHTML(item); });
            html += '</div>';
        }

        if (changes.shutdowns.length > 0) {
            html += '<div class="year-changes-section">';
            html += '<div class="year-changes-section-label"><span class="year-changes-dot grey"></span>Permanently shut down (' + changes.shutdowns.length + ')</div>';
            changes.shutdowns.forEach(item => { html += buildChangeItemHTML(item); });
            html += '</div>';
        }

        yearChangesBody.innerHTML = html;

        // Attach click handlers to change items
        yearChangesBody.querySelectorAll('.year-changes-item').forEach(el => {
            el.addEventListener('click', () => {
                const plantName = el.getAttribute('data-plant');
                const plant = nuclearPlants.find(p => p.name === plantName);
                if (!plant) return;
                const isMobile = window.innerWidth <= 600;
                if (isMobile) {
                    if (typeof window.openPlantPanel === 'function') {
                        window.openPlantPanel(plant);
                    }
                    applySearchHighlight(p => p.name === plant.name);
                } else {
                    // Offset right to clear the plant info overlay this handler is about to
                    // open, the same as every other desktop route to that overlay
                    // (zoomToPlant, the marker click, back-navigation). Passing 0 here centred
                    // the plant in the CONTAINER, which puts it at the left edge of the space
                    // actually left visible beside the panel. Pre-existing behaviour carried
                    // over from the Leaflet build, not introduced by the migration.
                    flyToWithOffset(plant, 7, getDesktopOverlayOffsetX(), 0);
                    navPush(); // v5.7.77: push current state before navigating
                    showPlantInfoOverlay(plant);
                    applySearchHighlight(p => p.name === plant.name);
                }
            });
            el.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    el.click();
                }
            });
        });

        // v5.7.152: Do not force-open — respect user's manual toggle state
    }

    function applyYearChangePulse(year) {
        const changedPlantNames = new Set();
        nuclearPlants.forEach(plant => {
            plant.reactors.forEach(reactor => {
                if (reactor.gridConnection === year || reactor.constructionStart === year || reactor.shutdownDate === year) {
                    changedPlantNames.add(plant.name);
                }
            });
        });
        if (changedPlantNames.size === 0) { stopYearPulse(); return; }
        // 'chg' is baked into every feature by buildPlantFeatures and the plants-pulse layer
        // is filtered on it, so the ring only has to be animated. Start it from the COMPLETION
        // of this tick's data push (the promise setData(fc, true) returns), otherwise the ring
        // would animate the previous year's features while the worker is still re-tiling.
        const gen = ++pulseGen;
        lastPlantDataPromise.then(function () {
            if (gen === pulseGen) startYearPulse(gen);
        });
    }

    // Wrap updateMapForYear to trigger year changes dropdown and pulse (v5.7.83)
    const updateMapForYearBeforeChanges = updateMapForYear;
    updateMapForYear = function(year) {
        updateMapForYearBeforeChanges(year);
        if (isPlaying) {
            toggleYearChangesDropdown(false);
            // Still update year label and badge during playback
            if (yearChangesDropdown && year <= MAX_YEAR) {
                yearChangesDropdown.style.display = '';
                yearChangesYear.textContent = year;
                const changes = computeYearChanges(year);
                const total = changes.gridConnections.length + changes.constructionStarts.length + changes.shutdowns.length;
                yearChangesBadge.textContent = total;
                yearChangesBadge.setAttribute('data-count', String(total));
            } else if (yearChangesDropdown) {
                yearChangesDropdown.style.display = 'none';
            }
        } else {
            renderYearChangesDropdown(year);
        }
        applyYearChangePulse(year);
    };

    if (yearChangesDropdownToggle) {
        yearChangesDropdownToggle.addEventListener('click', () => toggleYearChangesDropdown());
    }
    // v5.7.164: Populate year changes dropdown on initial load
    renderYearChangesDropdown(currentSelectedYear);

    // Resize handler for timeline charts
    window.addEventListener('resize', () => {
        if (timelineChartsRendered && timelineChartsSidebar.classList.contains('expanded')) {
            requestTimelineChartsRender();
        }
    });

    // --- 14. Dropdown and View Mode Event Handlers ---
    
    // Keep view-mode UI (mobile popup + desktop sidebar button group + legacy dropdown) in sync
    function syncViewModeSelection(mode) {
        const labels = { satellite: 'Satellite', map: 'Map', globe: '3D Globe' };

        // Sync view-mode-option elements (legacy dropdown and mobile popup)
        document.querySelectorAll('.view-mode-option').forEach(opt => {
            opt.classList.toggle('active', opt.dataset.mode === mode);
        });

        // Sync new sidebar button group
        document.querySelectorAll('.view-mode-btn').forEach(btn => {
            btn.classList.toggle('active', btn.dataset.mode === mode);
        });

        const labelEl = document.getElementById('viewDropdownLabel');
        if (labelEl) labelEl.textContent = labels[mode] || 'Map view';

        // Update labels toggle enabled/disabled state
        // Labels are available for Satellite and Globe, but not for Map mode
        const labelsToggleRow = document.getElementById('labelsToggleRow');
        const sidebarLabelsToggle = document.getElementById('sidebarLabelsToggle');
        if (labelsToggleRow && sidebarLabelsToggle) {
            const labelsAvailable = (mode === 'satellite' || mode === 'globe');
            labelsToggleRow.classList.toggle('disabled', !labelsAvailable);
            sidebarLabelsToggle.disabled = !labelsAvailable;
            // Sync checkbox state with current labels preference
            sidebarLabelsToggle.checked = labelsEnabled;
        }
    }

// Filters dropdown toggle
    document.getElementById('filtersToggle').addEventListener('click', (e) => {
        e.stopPropagation();
        const panel = document.getElementById('filtersPanel');
        const toggle = document.getElementById('filtersToggle');
        
        panel.classList.toggle('expanded');
        toggle.classList.toggle('active');
        
        // Close view mode popup
        const viewModePopup = document.getElementById('viewModePopup');
        viewModePopup.classList.remove('visible');
        viewModePopup.classList.remove('expanded');
    });
    
    
    // Sidebar Map View dropdown toggle (desktop)
    const viewDropdownToggle = document.getElementById('viewDropdownToggle');
    if (viewDropdownToggle) {
        viewDropdownToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            const panel = document.getElementById('viewDropdownPanel');
            const toggle = document.getElementById('viewDropdownToggle');
            if (!panel || !toggle) return;

            panel.classList.toggle('expanded');
            toggle.classList.toggle('active');

            // Close filters dropdown (mobile overlay)
            const filtersPanel = document.getElementById('filtersPanel');
            const filtersToggle = document.getElementById('filtersToggle');
            if (filtersPanel) filtersPanel.classList.remove('expanded');
            if (filtersToggle) filtersToggle.classList.remove('active');

            // Close view mode popup (mobile)
            const viewModePopup = document.getElementById('viewModePopup');
            if (viewModePopup) {
                viewModePopup.classList.remove('visible');
                viewModePopup.classList.remove('expanded');
            }
        });
    }

// View Mode button toggle
    document.getElementById('viewModeBtn').addEventListener('click', (e) => {
        e.stopPropagation();
        const popup = document.getElementById('viewModePopup');
        // Close info modal if open
        var infoModal = document.getElementById('mapInfoModal');
        if (infoModal && infoModal.classList.contains('open')) {
            infoModal.classList.remove('open');
            infoModal.setAttribute('aria-hidden', 'true');
        }
        
        // Close filters dropdown
        const filtersPanel = document.getElementById('filtersPanel');
        const filtersToggle = document.getElementById('filtersToggle');
        filtersPanel.classList.remove('expanded');
        filtersToggle.classList.remove('active');
        
        popup.classList.toggle('visible');
        // Slight delay for animation
        setTimeout(() => {
            popup.classList.toggle('expanded');
        }, 10);
    });

    // Info button opens modal
    const infoBtn = document.getElementById('infoBtn');
    if (infoBtn) {
        infoBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const modal = document.getElementById('mapInfoModal');
            if (modal) {
                modal.classList.add('open');
                modal.setAttribute('aria-hidden', 'false');
            }
        });
    }

    // Info modal close handlers
    function closeInfoModal() {
        const modal = document.getElementById('mapInfoModal');
        if (modal) {
            modal.classList.remove('open');
            modal.setAttribute('aria-hidden', 'true');
        }
    }
    const mapInfoModalClose = document.getElementById('mapInfoModalClose');
    const mapInfoModalBackdrop = document.getElementById('mapInfoModalBackdrop');
    if (mapInfoModalClose) mapInfoModalClose.addEventListener('click', closeInfoModal);
    if (mapInfoModalBackdrop) mapInfoModalBackdrop.addEventListener('click', closeInfoModal);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            var infoModal = document.getElementById('mapInfoModal');
            if (infoModal && infoModal.classList.contains('open')) {
                closeInfoModal();
            }
        }
    });
    
    // Close dropdowns/popups when clicking outside
    document.addEventListener('click', (e) => {
        const filtersWrapper = document.getElementById('filtersWrapper');
        const filtersPanel = document.getElementById('filtersPanel');
        const filtersToggle = document.getElementById('filtersToggle');
        const viewModeWrapper = document.querySelector('.view-mode-wrapper');
        const viewModePopup = document.getElementById('viewModePopup');
        
        if (filtersWrapper && !filtersWrapper.contains(e.target)) {
            filtersPanel.classList.remove('expanded');
            filtersToggle.classList.remove('active');
        }
        if (viewModeWrapper && !viewModeWrapper.contains(e.target)) {
            viewModePopup.classList.remove('expanded');
            setTimeout(() => viewModePopup.classList.remove('visible'), 200);
        }

        if (viewDropdownWrapper && !viewDropdownWrapper.contains(e.target)) {
            if (viewDropdownPanel) viewDropdownPanel.classList.remove('expanded');
            if (viewDropdownToggle) viewDropdownToggle.classList.remove('active');
        }
    });
    
    // View Mode options click handlers (for legacy dropdown and mobile popup)
    document.querySelectorAll('.view-mode-option').forEach(option => {
        option.addEventListener('click', (e) => {
            const mode = option.dataset.mode;
            
            e.stopPropagation();
            syncViewModeSelection(mode);
            
            if (mode === 'satellite') {
                // Switch to satellite view
                if (isGlobeView) {
                    toggleGlobeView();
                }
                if (!isSatelliteView) {
                    toggleSatelliteView();
                }
            } else if (mode === 'map') {
                // Switch to map view
                if (isGlobeView) {
                    toggleGlobeView();
                }
                if (isSatelliteView) {
                    toggleSatelliteView();
                }
            } else if (mode === 'globe') {
                // Switch to globe view
                if (!isGlobeView) {
                    toggleGlobeView();
                }
            }
            
            // Close any open view selectors
            const viewModePopup = document.getElementById('viewModePopup');
            if (viewModePopup) {
                viewModePopup.classList.remove('expanded');
                setTimeout(() => viewModePopup.classList.remove('visible'), 200);
            }
            const viewDropdownPanel = document.getElementById('viewDropdownPanel');
            const viewDropdownToggle = document.getElementById('viewDropdownToggle');
            if (viewDropdownPanel) viewDropdownPanel.classList.remove('expanded');
            if (viewDropdownToggle) viewDropdownToggle.classList.remove('active');
        });
    });
    
    // New sidebar view mode button group click handlers
    document.querySelectorAll('.view-mode-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const mode = btn.dataset.mode;
            
            e.stopPropagation();
            syncViewModeSelection(mode);
            
            if (mode === 'satellite') {
                if (isGlobeView) {
                    toggleGlobeView();
                }
                if (!isSatelliteView) {
                    toggleSatelliteView();
                }
            } else if (mode === 'map') {
                if (isGlobeView) {
                    toggleGlobeView();
                }
                if (isSatelliteView) {
                    toggleSatelliteView();
                }
            } else if (mode === 'globe') {
                if (!isGlobeView) {
                    toggleGlobeView();
                }
            }
        });
    });

    // Sidebar labels toggle event handler
    const sidebarLabelsToggle = document.getElementById('sidebarLabelsToggle');
    if (sidebarLabelsToggle) {
        sidebarLabelsToggle.addEventListener('change', function(e) {
            toggleMapLabels(this.checked);
        });
    }

    // --- Sidebar option-row styling sync (desktop sidebar) ---
    // We style sidebar options like "cards" and add a .option-checked class to the row when checked.
    function refreshSidebarOptionRowClasses() {
        const sidebar = document.getElementById('map-sidebar');
        if (!sidebar) return;
        const rows = sidebar.querySelectorAll('.sidebar-display-options .dropdown-option, .sidebar-filters-group .dropdown-option');
        rows.forEach(row => {
            const input = row.querySelector('input[type="checkbox"]');
            if (!input) return;
            row.classList.toggle('option-checked', !!input.checked);
        });
    }

    // Delegate to keep the UI in sync on user clicks
    const sidebarForOptionSync = document.getElementById('map-sidebar');
    if (sidebarForOptionSync) {
        sidebarForOptionSync.addEventListener('change', (e) => {
            const t = e.target;
            if (!t || t.tagName !== 'INPUT' || t.type !== 'checkbox') return;

            const row = t.closest('.dropdown-option');
            if (!row) return;

            // Only apply to the desktop sidebar groups (not the mobile dropdown)
            if (!row.closest('.sidebar-display-options') && !row.closest('.sidebar-filters-group')) return;

            row.classList.toggle('option-checked', t.checked);
        });
    }

    // Initial paint
    refreshSidebarOptionRowClasses();


    
    // Desktop sidebar filter handlers
    document.getElementById('showOperable').addEventListener('change', (e) => {
        viewOptions.showOperable = e.target.checked;
        // Sync mobile checkbox
        const mobileCheckbox = document.getElementById('showOperableMobile');
        if (mobileCheckbox) mobileCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
    });

    document.getElementById('showConstruction').addEventListener('change', (e) => {
        viewOptions.showConstruction = e.target.checked;
        // Sync mobile checkbox
        const mobileCheckbox = document.getElementById('showConstructionMobile');
        if (mobileCheckbox) mobileCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
    });

    document.getElementById('showPlanned').addEventListener('change', (e) => {
        viewOptions.showPlanned = e.target.checked;
        // Sync mobile checkbox
        const mobileCheckbox = document.getElementById('showPlannedMobile');
        if (mobileCheckbox) mobileCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
    });

    document.getElementById('showShutdown').addEventListener('change', (e) => {
        viewOptions.showShutdown = e.target.checked;
        // Sync mobile checkbox
        const mobileCheckbox = document.getElementById('showShutdownMobile');
        if (mobileCheckbox) mobileCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
    });

    document.getElementById('clusterView').addEventListener('change', (e) => {
        useClusterView = e.target.checked;
        var mobileCheckbox = document.getElementById('clusterViewMobile');
        var filterCheckbox = document.getElementById('filterClusterView');
        if (mobileCheckbox) mobileCheckbox.checked = e.target.checked;
        if (filterCheckbox) filterCheckbox.checked = e.target.checked;
        rebuildMarkerLayer();
    });

    document.getElementById('sizeByCapacity').addEventListener('change', (e) => {
        viewOptions.sizeByCapacity = e.target.checked;

        // Mutually exclusive sizing modes
        if (e.target.checked) {
            viewOptions.sizeByProduction = false;
            const prodDesktop = document.getElementById('sizeByProduction');
            const prodMobile = document.getElementById('sizeByProductionMobile');
            if (prodDesktop) prodDesktop.checked = false;
            if (prodMobile) prodMobile.checked = false;
        }

        // Sync mobile checkbox
        const mobileCheckbox = document.getElementById('sizeByCapacityMobile');
        if (mobileCheckbox) mobileCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        refreshSidebarOptionRowClasses();

    });

    document.getElementById('sizeByProduction').addEventListener('change', (e) => {
        viewOptions.sizeByProduction = e.target.checked;

        // Mutually exclusive sizing modes
        if (e.target.checked) {
            viewOptions.sizeByCapacity = false;
            const capDesktop = document.getElementById('sizeByCapacity');
            const capMobile = document.getElementById('sizeByCapacityMobile');
            if (capDesktop) capDesktop.checked = false;
            if (capMobile) capMobile.checked = false;
        }

        // Sync mobile checkbox
        const mobileCheckbox = document.getElementById('sizeByProductionMobile');
        if (mobileCheckbox) mobileCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        refreshSidebarOptionRowClasses();

    });


    // Mobile filter handlers (sync back to desktop)
    document.getElementById('showOperableMobile').addEventListener('change', (e) => {
        viewOptions.showOperable = e.target.checked;
        // Sync desktop checkbox
        const desktopCheckbox = document.getElementById('showOperable');
        if (desktopCheckbox) desktopCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
        refreshSidebarOptionRowClasses();

    });

    document.getElementById('showConstructionMobile').addEventListener('change', (e) => {
        viewOptions.showConstruction = e.target.checked;
        // Sync desktop checkbox
        const desktopCheckbox = document.getElementById('showConstruction');
        if (desktopCheckbox) desktopCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
        refreshSidebarOptionRowClasses();

    });

    document.getElementById('showPlannedMobile').addEventListener('change', (e) => {
        viewOptions.showPlanned = e.target.checked;
        // Sync desktop checkbox
        const desktopCheckbox = document.getElementById('showPlanned');
        if (desktopCheckbox) desktopCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
        refreshSidebarOptionRowClasses();

    });

    document.getElementById('showShutdownMobile').addEventListener('change', (e) => {
        viewOptions.showShutdown = e.target.checked;
        // Sync desktop checkbox
        const desktopCheckbox = document.getElementById('showShutdown');
        if (desktopCheckbox) desktopCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        updateStatusBarFilters();
        refreshSidebarOptionRowClasses();

    });

    document.getElementById('clusterViewMobile').addEventListener('change', (e) => {
        useClusterView = e.target.checked;
        var desktopCheckbox = document.getElementById('clusterView');
        var filterCheckbox = document.getElementById('filterClusterView');
        if (desktopCheckbox) desktopCheckbox.checked = e.target.checked;
        if (filterCheckbox) filterCheckbox.checked = e.target.checked;
        rebuildMarkerLayer();
        refreshSidebarOptionRowClasses();
    });
    
    document.getElementById('sizeByCapacityMobile').addEventListener('change', (e) => {
        viewOptions.sizeByCapacity = e.target.checked;

        // Mutually exclusive sizing modes
        if (e.target.checked) {
            viewOptions.sizeByProduction = false;
            const prodDesktop = document.getElementById('sizeByProduction');
            const prodMobile = document.getElementById('sizeByProductionMobile');
            if (prodDesktop) prodDesktop.checked = false;
            if (prodMobile) prodMobile.checked = false;
        }

        // Sync desktop checkbox
        const desktopCheckbox = document.getElementById('sizeByCapacity');
        if (desktopCheckbox) desktopCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        refreshSidebarOptionRowClasses();

    });

    document.getElementById('sizeByProductionMobile').addEventListener('change', (e) => {
        viewOptions.sizeByProduction = e.target.checked;

        // Mutually exclusive sizing modes
        if (e.target.checked) {
            viewOptions.sizeByCapacity = false;
            const capDesktop = document.getElementById('sizeByCapacity');
            const capMobile = document.getElementById('sizeByCapacityMobile');
            if (capDesktop) capDesktop.checked = false;
            if (capMobile) capMobile.checked = false;
        }

        // Sync desktop checkbox
        const desktopCheckbox = document.getElementById('sizeByProduction');
        if (desktopCheckbox) desktopCheckbox.checked = e.target.checked;
        updateMapForYear(currentSelectedYear);
        refreshSidebarOptionRowClasses();

    });


    // --- Capacity Range Slider event listeners ---
    CAPACITY_SLIDER_INSTANCES.forEach((inst, idx) => {
        const minEl = document.getElementById(inst.min);
        const maxEl = document.getElementById(inst.max);
        if (minEl) minEl.addEventListener('input', () => onCapacitySliderInput(idx, true));
        if (maxEl) maxEl.addEventListener('input', () => onCapacitySliderInput(idx, false));
    });
    syncAllCapacitySliders();

    // v5.7.150: Production range slider event listeners
    PRODUCTION_SLIDER_INSTANCES.forEach((inst, idx) => {
        const minEl = document.getElementById(inst.min);
        const maxEl = document.getElementById(inst.max);
        if (minEl) minEl.addEventListener('input', () => onProductionSliderInput(idx, true));
        if (maxEl) maxEl.addEventListener('input', () => onProductionSliderInput(idx, false));
    });
    syncAllProductionSliders();


    // --- Mobile Filter Panel State Sync and Handlers ---
    function syncFilterPanelState() {
        const filterShowOperable = document.getElementById('filterShowOperable');
        const filterShowConstruction = document.getElementById('filterShowConstruction');
        const filterShowPlanned = document.getElementById('filterShowPlanned');
        const filterShowShutdown = document.getElementById('filterShowShutdown');
        const filterClusterView = document.getElementById('filterClusterView');
        const filterSizeByCapacity = document.getElementById('filterSizeByCapacity');
        const filterSizeByProduction = document.getElementById('filterSizeByProduction');

        if (filterShowOperable) filterShowOperable.checked = viewOptions.showOperable;
        if (filterShowConstruction) filterShowConstruction.checked = viewOptions.showConstruction;
        if (filterShowPlanned) filterShowPlanned.checked = viewOptions.showPlanned;
        if (filterShowShutdown) filterShowShutdown.checked = viewOptions.showShutdown;
        syncAllCapacitySliders();
        syncAllProductionSliders(); // v5.7.150
        if (filterClusterView) filterClusterView.checked = useClusterView;
        if (filterSizeByCapacity) filterSizeByCapacity.checked = viewOptions.sizeByCapacity;
        if (filterSizeByProduction) filterSizeByProduction.checked = viewOptions.sizeByProduction;
        
        document.querySelectorAll('.filter-option').forEach(opt => {
            const checkbox = opt.querySelector('input[type="checkbox"]');
            if (checkbox) {
                opt.classList.toggle('checked', checkbox.checked);
            }
        });
        
        updateMobileFilterBtnState();
    }
    
    function updateMobileFilterBtnState() {
        const mobileFilterBtn = document.getElementById('mobileFilterBtn');
        if (!mobileFilterBtn) return;
        
        const capacityRangeActive = !(viewOptions.capacityMin <= CAPACITY_SLIDER_MIN && viewOptions.capacityMax >= CAPACITY_SLIDER_MAX);
        const productionRangeActive = !(viewOptions.productionMin <= PRODUCTION_SLIDER_MIN && viewOptions.productionMax >= PRODUCTION_SLIDER_MAX); // v5.7.150
        const hasActiveFilters = viewOptions.showOperable || viewOptions.showConstruction ||
            viewOptions.showShutdown || capacityRangeActive || productionRangeActive ||
            viewOptions.sizeByCapacity || viewOptions.sizeByProduction;
        
        mobileFilterBtn.classList.toggle('has-filters', hasActiveFilters);
    }
    
    // Expose sync functions globally
    window.syncFilterPanelState = syncFilterPanelState;
    window.updateMobileFilterBtnState = updateMobileFilterBtnState;
    
    // Filter option click handlers
    document.querySelectorAll('.filter-option').forEach(opt => {
        const checkbox = opt.querySelector('input[type="checkbox"]');
        if (!checkbox) return;
        
        opt.addEventListener('click', (e) => {
            if (e.target !== checkbox) {
                checkbox.checked = !checkbox.checked;
            }
            
            opt.classList.toggle('checked', checkbox.checked);
            
            const filterId = checkbox.id;
            
            if (filterId === 'filterShowOperable') {
                viewOptions.showOperable = checkbox.checked;
                const el = document.getElementById('showOperable');
                const elM = document.getElementById('showOperableMobile');
                if (el) el.checked = checkbox.checked;
                if (elM) elM.checked = checkbox.checked;
            } else if (filterId === 'filterShowConstruction') {
                viewOptions.showConstruction = checkbox.checked;
                const el = document.getElementById('showConstruction');
                const elM = document.getElementById('showConstructionMobile');
                if (el) el.checked = checkbox.checked;
                if (elM) elM.checked = checkbox.checked;
            } else if (filterId === 'filterShowPlanned') {
                viewOptions.showPlanned = checkbox.checked;
                const el = document.getElementById('showPlanned');
                const elM = document.getElementById('showPlannedMobile');
                if (el) el.checked = checkbox.checked;
                if (elM) elM.checked = checkbox.checked;
            } else if (filterId === 'filterShowShutdown') {
                viewOptions.showShutdown = checkbox.checked;
                const el = document.getElementById('showShutdown');
                const elM = document.getElementById('showShutdownMobile');
                if (el) el.checked = checkbox.checked;
                if (elM) elM.checked = checkbox.checked;
            } else if (filterId === 'filterClusterView') {
                useClusterView = checkbox.checked;
                var el = document.getElementById('clusterView');
                var elM = document.getElementById('clusterViewMobile');
                if (el) el.checked = checkbox.checked;
                if (elM) elM.checked = checkbox.checked;
                rebuildMarkerLayer();
            } else if (filterId === 'filterSizeByCapacity') {
                viewOptions.sizeByCapacity = checkbox.checked;
                if (checkbox.checked) {
                    viewOptions.sizeByProduction = false;
                    const filterProd = document.getElementById('filterSizeByProduction');
                    const elProd = document.getElementById('sizeByProduction');
                    const elProdM = document.getElementById('sizeByProductionMobile');
                    if (filterProd) filterProd.checked = false;
                    if (elProd) elProd.checked = false;
                    if (elProdM) elProdM.checked = false;
                    document.querySelector('.filter-option[data-filter="sizeByProduction"]')?.classList.remove('checked');
                }
                const el = document.getElementById('sizeByCapacity');
                const elM = document.getElementById('sizeByCapacityMobile');
                if (el) el.checked = checkbox.checked;
                if (elM) elM.checked = checkbox.checked;
            } else if (filterId === 'filterSizeByProduction') {
                viewOptions.sizeByProduction = checkbox.checked;
                if (checkbox.checked) {
                    viewOptions.sizeByCapacity = false;
                    const filterCap = document.getElementById('filterSizeByCapacity');
                    const elCap = document.getElementById('sizeByCapacity');
                    const elCapM = document.getElementById('sizeByCapacityMobile');
                    if (filterCap) filterCap.checked = false;
                    if (elCap) elCap.checked = false;
                    if (elCapM) elCapM.checked = false;
                    document.querySelector('.filter-option[data-filter="sizeByCapacity"]')?.classList.remove('checked');
                }
                const el = document.getElementById('sizeByProduction');
                const elM = document.getElementById('sizeByProductionMobile');
                if (el) el.checked = checkbox.checked;
                if (elM) elM.checked = checkbox.checked;
            }

            // Update map for current year (filters now work for all years)
            updateMapForYear(currentSelectedYear);
            updateStatusBarFilters();
            updateMobileFilterBtnState();
            refreshSidebarOptionRowClasses();
        });
    });

    // // --- 15. Cache DOM References ---
    const searchInput = document.getElementById('searchInput');
    const resultsBox = document.getElementById('searchResults');
    const homeButton = document.getElementById('homeButton');
    const searchClearBtn = document.getElementById('searchClearBtn');
    
    // --- 15. Search State ---
    let highlightedIndex = -1;
    let currentResults = [];
    let debounceTimer = null;
    // currentHighlightFilter is declared with the other map state, above the feature builder.

    // --- 16. Utility Functions ---
    function updateAriaExpanded(isExpanded) {
        searchInput.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
    
    function updateClearButtonVisibility() {
        if (searchInput.value.length > 0) {
            searchClearBtn.classList.add('visible');
        } else {
            searchClearBtn.classList.remove('visible');
        }
    }
    
    function clearSearch() {
        searchInput.value = '';
        resultsBox.style.display = 'none';
        updateAriaExpanded(false);
        updateClearButtonVisibility();
        
        // Clear search highlighting (dim state is baked into the features)
        currentHighlightFilter = null;
        refreshPlantLayer();

        
        // Update globe markers if in globe view
        if (isGlobeView && globeMap) {
            updateGlobeMarkers();
        }
    }

    function clearHighlight() {
        const items = resultsBox.querySelectorAll('.result-item');
        items.forEach(item => item.classList.remove('highlighted'));
        highlightedIndex = -1;
    }

    function highlightItem(index) {
        const items = resultsBox.querySelectorAll('.result-item');
        clearHighlight();
        if (index >= 0 && index < items.length) {
            highlightedIndex = index;
            items[index].classList.add('highlighted');
            items[index].scrollIntoView({ block: 'nearest' });
        }
    }

    // --- 17. Render Search Results with DocumentFragment ---
    function renderResults(matchedCountries, matchedPlants, matchedReactors) {
        resultsBox.replaceChildren();
        currentResults = [];

        if (matchedCountries.length === 0 && matchedPlants.length === 0 && matchedReactors.length === 0) {
            const noResultsDiv = document.createElement('div');
            noResultsDiv.className = 'no-results';
            noResultsDiv.setAttribute('role', 'status');
            noResultsDiv.setAttribute('aria-live', 'polite');
            const noResultsIcon = document.createElement('span');
            noResultsIcon.className = 'no-results-icon';
            noResultsIcon.setAttribute('aria-hidden', 'true');
            noResultsIcon.textContent = '🔍';
            noResultsDiv.append(noResultsIcon, document.createTextNode(' No results found'));
            resultsBox.appendChild(noResultsDiv);
            resultsBox.style.display = 'block';
            updateAriaExpanded(true);
            return;
        }

        const fragment = document.createDocumentFragment();

        matchedCountries.forEach(({ country: c, status }) => {
            const div = document.createElement('div');
            div.className = 'result-item';
            div.setAttribute('role', 'option');
            div.setAttribute('tabindex', '-1');
            const nameSpan = document.createElement('span');
            nameSpan.textContent = c;
            const tagSpan = document.createElement('span');
            const tagClass = status === 'operable' ? 'tag-green' : status === 'construction' ? 'tag-yellow' : status === 'planned' ? 'tag-blue' : 'tag-grey';
            tagSpan.className = 'search-tag ' + tagClass;
            tagSpan.textContent = 'COUNTRY';
            div.append(nameSpan, document.createTextNode(' '), tagSpan);
            div.addEventListener('click', () => zoomToCountry(c));
            fragment.appendChild(div);
            currentResults.push({ type: 'country', data: c });
        });

        matchedPlants.forEach(({ plant: p, status }) => {
            const div = document.createElement('div');
            div.className = 'result-item';
            div.setAttribute('role', 'option');
            div.setAttribute('tabindex', '-1');
            const nameSpan = document.createElement('span');
            nameSpan.textContent = p.name;
            const tagSpan = document.createElement('span');
            const tagClass = status === 'operable' ? 'tag-green' : status === 'construction' ? 'tag-yellow' : status === 'planned' ? 'tag-blue' : 'tag-grey';
            tagSpan.className = 'search-tag ' + tagClass;
            tagSpan.textContent = 'PLANT';
            div.append(nameSpan, document.createTextNode(' '), tagSpan);
            div.addEventListener('click', () => zoomToPlant(p, null));
            fragment.appendChild(div);
            currentResults.push({ type: 'plant', data: p });
        });

        matchedReactors.forEach(r => {
            const div = document.createElement('div');
            div.className = 'result-item';
            div.setAttribute('role', 'option');
            div.setAttribute('tabindex', '-1');
            const nameSpan = document.createElement('span');
            nameSpan.textContent = r.reactorName;
            const tagSpan = document.createElement('span');
            const tagClass = r.status === 'operable' ? 'tag-green' : r.status === 'construction' ? 'tag-yellow' : r.status === 'planned' ? 'tag-blue' : 'tag-grey';
            tagSpan.className = 'search-tag ' + tagClass;
            tagSpan.textContent = 'REACTOR';
            div.append(nameSpan, document.createTextNode(' '), tagSpan);
            div.addEventListener('click', () => zoomToPlant(r.plant, r.reactorId || r.reactorName));
            fragment.appendChild(div);
            currentResults.push({ type: 'reactor', data: r });
        });

        resultsBox.appendChild(fragment);
        resultsBox.style.display = 'block';
        updateAriaExpanded(true);
        highlightedIndex = -1;
    }

    // --- 18. Debounced Search Handler ---
    function handleSearch() {
        const term = searchInput.value.toLowerCase().trim();
        
        if (term.length < 2) { 
            resultsBox.style.display = 'none';
            updateAriaExpanded(false);
            currentResults = [];
            return;
        }

        // Filter plants visible in current year
        const visiblePlants = nuclearPlants.filter(p => getPlantStatusForYear(p, currentSelectedYear) !== null);
        
        const matchedPlants = visiblePlants.filter(p => p.name.toLowerCase().includes(term)).map(p => {
            const ps = getPlantStatusForYear(p, currentSelectedYear);
            const st = ps.stats.operable > 0 ? 'operable' : ps.stats.construction > 0 ? 'construction' : ps.stats.planned > 0 ? 'planned' : 'shutdown';
            return { plant: p, status: st };
        });
        const countrySet = [...new Set(visiblePlants.map(p => p.country))].filter(c => c.toLowerCase().includes(term));
        const matchedCountries = countrySet.map(c => {
            const cPlants = visiblePlants.filter(p => p.country === c);
            let hasOp = false, hasCon = false, hasPl = false;
            cPlants.forEach(p => {
                const ps = getPlantStatusForYear(p, currentSelectedYear);
                if (ps) { if (ps.stats.operable > 0) hasOp = true; if (ps.stats.construction > 0) hasCon = true; if (ps.stats.planned > 0) hasPl = true; }
            });
            const status = hasOp ? 'operable' : hasCon ? 'construction' : hasPl ? 'planned' : 'shutdown';
            return { country: c, status };
        });
        
        // Search reactors - create flat list with parent plant reference
        const matchedReactors = [];
        visiblePlants.forEach(plant => {
            plant.reactors.forEach(reactor => {
                const status = getReactorStatusForYear(reactor, currentSelectedYear);
                const searchName = (reactor.name || '').toLowerCase();
                const searchDisplayName = (reactor.displayName || '').toLowerCase();
                if (status && (searchName.includes(term) || searchDisplayName.includes(term))) {
                    matchedReactors.push({
                        reactorName: reactor.displayName || reactor.name,
                        reactorId: reactor.name, // Keep original name for internal lookup
                        plant: plant,
                        status: status
                    });
                }
            });
        });

        renderResults(matchedCountries, matchedPlants, matchedReactors);
    }

    // --- 19. Event Listeners ---
    homeButton.addEventListener('click', () => {
        navClear();
        clearSearch();
        closeCountryPanel(); // Close country panel on home reset
        closePlantPanel(); // Close plant panel on home reset
        if (typeof closeFilterPanel === 'function') closeFilterPanel(); // Close filter panel on home reset
        hideCountryInfoOverlay(); // Hide country info overlay on home reset
        hidePlantInfoOverlay(); // Hide plant info overlay on home reset
        closePlantDetailModal(); // Close plant detail modal on home reset

        if (isGlobeView && globeMap) {
            // Reset globe view to initial position
            globeMap.flyTo({
                center: [0, 20],
                zoom: 2,
                pitch: 0,
                bearing: 0,
                duration: 1500
            });
            // Close any open popups on the globe
            const popups = document.querySelectorAll('.maplibregl-popup');
            popups.forEach(popup => popup.remove());
        } else {
            // Calculate appropriate zoom level to avoid grey areas
            let resetZoom = HOME_ZOOM;
            
            // Check if in fullscreen and calculate minimum zoom to fill height
            if (isInFullscreenNow()) {
                const container = map.getContainer();
                const height = container.offsetHeight;
                // World is 256px at zoom 0, doubles each level
                // Need zoom where world height >= container height
                const minZoomForHeight = Math.ceil(Math.log2(height / 256));
                resetZoom = Math.max(HOME_ZOOM, minZoomForHeight);
            }
            
            goHome(1500);
            closePlantPopup();
        }
    });

    // Country info overlay back button handler (v5.7.77: uses nav stack)
    if (countryInfoBack) {
        countryInfoBack.addEventListener('click', (e) => {
            e.preventDefault();
            if (navHistory.length > 0) {
                handleNavBack();
            } else {
                hideCountryInfoOverlay();
            }
            // Keep current field of view (do not reset/zoom the map)
        });
    }

    // Plant info overlay back button handler (v5.7.77: uses nav stack)
    if (plantInfoBack) {
        plantInfoBack.addEventListener('click', (e) => {
            e.preventDefault();
            if (navHistory.length > 0) {
                handleNavBack();
            } else {
                hidePlantInfoOverlay();
            }
            // Keep current field of view (do not reset/zoom the map)
        });
    }

    searchInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(handleSearch, 150);
        updateClearButtonVisibility();
    });
    
    // Clear button click handler
    searchClearBtn.addEventListener('click', () => {
        clearSearch();
        searchInput.focus();
    });

    // --- 20. Keyboard Navigation ---
    searchInput.addEventListener('keydown', (e) => {
        const items = resultsBox.querySelectorAll('.result-item');
        
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (resultsBox.style.display === 'block' && items.length > 0) {
                highlightItem(Math.min(highlightedIndex + 1, items.length - 1));
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (resultsBox.style.display === 'block' && items.length > 0) {
                highlightItem(Math.max(highlightedIndex - 1, 0));
            }
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (highlightedIndex >= 0 && currentResults[highlightedIndex]) {
                const result = currentResults[highlightedIndex];
                if (result.type === 'country') {
                    zoomToCountry(result.data);
                } else if (result.type === 'reactor') {
                    zoomToPlant(result.data.plant, result.data.reactorId || result.data.reactorName);
                } else {
                    zoomToPlant(result.data, null);
                }
            }
        } else if (e.key === 'Escape') {
            resultsBox.style.display = 'none';
            updateAriaExpanded(false);
            searchInput.blur();
        }
    });

    // --- 21. Zoom Functions ---
    
    function clearSearchHighlight() {
        currentHighlightFilter = null;
        clearHoverFocus(); // v5.7.172

        refreshPlantLayer();

        
        // Clear globe highlighting by updating markers
        if (isGlobeView && globeMap) {
            updateGlobeMarkers();
        }
    }
    
    function applySearchHighlight(filterFn) {
        currentHighlightFilter = filterFn;
        
        refreshPlantLayer();

        
        // Apply to globe markers
        if (isGlobeView && globeMap) {
            updateGlobeMarkers();
        }
    }

    // v5.7.180: Hover-focus for plant list hover highlighting (temp overlay marker approach)
    // currentHoverFocusPlantName is declared with the other map state, above the builder.
    let hoverPulseMarker = null;

    function applyHoverFocus(plantName) {
        // Tear the old ring down WITHOUT a rebuild: the single refresh below already covers
        // the previous plant losing its lift and the new one gaining it. Calling
        // clearHoverFocus() here meant two full feature rebuilds per row transition.
        if (hoverPulseMarker) { hoverPulseMarker.remove(); hoverPulseMarker = null; }
        const plant = nuclearPlants.find(p => p.name === plantName);
        currentHoverFocusPlantName = plant ? plantName : null;
        if (!plant) { refreshPlantLayer(); return; }
        // The builder bakes sk = 4 and dim = 0 for this plant, which un-dims it and lifts it
        // above its neighbours in the same pass.
        refreshPlantLayer();
        if (isGlobeView) return;
        hoverPulseMarker = ringMarker(plant, 'hover-pulse-ring');
    }

    function clearHoverFocus() {
        if (!currentHoverFocusPlantName) return;
        currentHoverFocusPlantName = null;
        refreshPlantLayer();
        if (hoverPulseMarker) {
            hoverPulseMarker.remove();
            hoverPulseMarker = null;
        }
    }

    function zoomToPlant(p, highlightReactorName = null) {
        navPush(); // v5.7.77: push current state before navigating
        resultsBox.style.display = 'none';
        updateAriaExpanded(false);
        searchInput.value = p.name;
        
        // Highlight only this plant
        applySearchHighlight(plant => plant.name === p.name);
        
        const isMobile = window.innerWidth <= 600;
        
        if (isGlobeView && globeMap) {
            // Zoom globe to plant location
            globeMap.flyTo({
                center: [p.lon, p.lat],
                zoom: 12, // v5.7.159: zoom closer (was 9)
                duration: 1500
            });
            
            // Show popup on globe after animation (or plant info overlay on desktop)
            setTimeout(() => {
                const plantStatus = getPlantStatusForYear(p, currentSelectedYear);
                if (plantStatus || !plantStatus) {
                    if (!isMobile) {
                        showPlantInfoOverlay(p, highlightReactorName);
                    } else {
                        // Show plant panel on mobile instead of globe popup
                        if (typeof window.openPlantPanel === 'function') {
                            window.openPlantPanel(p, highlightReactorName);
                        }
                    }
                }
            }, 1500);
        } else {
            // Find the marker for this plant and zoom to it (2D map)
            {
                const dest = [p.lon, p.lat];
                
                if (isMobile) {
                    // On mobile, offset the map so plant appears in top half above the panel
                    const offsetY = getMobilePanelOffset();
                    flyToWithOffset(dest, 13, 0, -offsetY, { duration: 1500 });

                    // Show plant panel on mobile
                    setTimeout(() => {
                        if (typeof window.openPlantPanel === 'function') {
                            window.openPlantPanel(p, highlightReactorName);
                        }
                    }, 500);
                } else {
                    // Desktop: offset horizontally to account for left info overlay
                    const offsetX = getDesktopOverlayOffsetX();
                    flyToWithOffset(dest, 13, offsetX, 0, { duration: 1500 });
                    // Show plant info overlay on desktop
                    setTimeout(() => showPlantInfoOverlay(p, highlightReactorName), 500);
                }
            }
        }
    }

    function zoomToCountry(c) {
        navPush(); // v5.7.77: push current state before navigating
        resultsBox.style.display = 'none';
        updateAriaExpanded(false);
        searchInput.value = c;

        // Highlight only plants in this country
        applySearchHighlight(plant => plant.country === c);

        const countryPlants = nuclearPlants.filter(p =>
            p.country === c && getPlantStatusForYear(p, currentSelectedYear) !== null
        );

        const isMobile = window.innerWidth <= 600;

        // Maximum zoom level to prevent zooming beyond satellite imagery resolution
        // This is especially important for countries with only one or few plants close together
        const countryMaxZoom = 8;

        if (isGlobeView && globeMap) {
            // Calculate bounds for country plants on globe
            if (countryPlants.length > 0) {
                let minLng = Infinity, maxLng = -Infinity;
                let minLat = Infinity, maxLat = -Infinity;

                countryPlants.forEach(p => {
                    minLng = Math.min(minLng, p.lon);
                    maxLng = Math.max(maxLng, p.lon);
                    minLat = Math.min(minLat, p.lat);
                    maxLat = Math.max(maxLat, p.lat);
                });

                // Fly to fit bounds on globe with max zoom limit
                globeMap.fitBounds(
                    [[minLng, minLat], [maxLng, maxLat]],
                    { padding: 50, duration: 1500, maxZoom: countryMaxZoom }
                );
            }
        } else {
            // 2D map zoom to country
            if (countryPlants.length > 0) {
                // Bounds from plant coordinates, so plants that never had a marker are no
                // longer silently dropped from the fit.
                flyToBoundsWithMobileOffset(plantsBounds(countryPlants), { duration: 1500, maxZoom: COUNTRY_MAX_ZOOM_2D });
            }
        }
        
        // On desktop, show the country info overlay instead of the slide-in panel
        if (!isMobile) {
            showCountryInfoOverlay(c);
        } else {
            // On mobile, open the country deep-dive panel
            openCountryPanel(c, true);
        }
    }

    // --- 22. Close Results on Map Click ---
    map.on('click', () => { 
        resultsBox.style.display = 'none';
        updateAriaExpanded(false);
    });

    // --- 23. Close Results on Outside Click ---
    document.addEventListener('click', (e) => {
        if (!searchInput.contains(e.target) && !resultsBox.contains(e.target)) {
            resultsBox.style.display = 'none';
            updateAriaExpanded(false);
        }
    });

    // --- 24. View Mode Toggle Functions ---
    function toggleSatelliteView() {
        setViewMode(isSatelliteView ? 'map' : 'satellite');
    }

    // --- 24a. Toggle Map Labels ---
    function toggleMapLabels(enabled) {
        labelsEnabled = enabled;
        if (!isGlobeView) {
            applyBasemap();
        }
        // For globe view (MapLibre)
        if (isGlobeView && globeMap) {
            try {
                globeMap.setLayoutProperty('boundaries-layer', 'visibility', enabled ? 'visible' : 'none');
            } catch (e) {
                // Layer may not exist yet
            }
        }
    }

    // --- 25. Globe View Functionality (MapLibre GL JS) ---
    const mapElement = document.getElementById('map');
    const globeContainer = document.getElementById('globeContainer');
    
    // Globe variables (isGlobeView declared earlier)
    let globeMap = null;
    let preGlobeCamera = null;
    // False until the globe camera has actually been synced from the 2D map. Guards the exit
    // path: leaving the globe BEFORE that first sync must restore the stored 2D camera, not
    // copy the globe default [0,20] z2 back. Reachable by switching to the globe and straight
    // back before it finishes loading.
    let globeSynced = false;
    let globeInitialized = false;

    function initGlobe() {
        if (globeInitialized) return true;
        
        try {
            if (typeof maplibregl === 'undefined') {
                console.error('MapLibre GL JS not loaded');
                return false;
            }
            
            globeMap = new maplibregl.Map({
                container: 'globeContainer',
                style: {
                    version: 8,
                    projection: {
                        type: 'globe'
                    },
                    sky: {
                        'sky-color': '#199EF3',
                        'sky-horizon-blend': 0.5,
                        'horizon-color': '#ffffff',
                        'horizon-fog-blend': 0.5,
                        'fog-color': '#0000ff',
                        'fog-ground-blend': 0.5,
                        'atmosphere-blend': ['interpolate', ['linear'], ['zoom'], 0, 1, 10, 1, 12, 0]
                    },
                    sources: {
                        'satellite': {
                            type: 'raster',
                            tiles: ['https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg'],
                            tileSize: 256,
                            attribution: '&copy; EOX Sentinel-2 cloudless'
                        },
                        'boundaries': {
                            type: 'raster',
                            tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}'],
                            tileSize: 256,
                            attribution: '&copy; Esri'
                        }
                    },
                    layers: [
                        {
                            id: 'satellite-layer',
                            type: 'raster',
                            source: 'satellite',
                            minzoom: 0,
                            maxzoom: 19
                        },
                        {
                            id: 'boundaries-layer',
                            type: 'raster',
                            source: 'boundaries',
                            minzoom: 0,
                            maxzoom: 19
                        }
                    ]
                },
                center: [0, 20],
                zoom: 2,
                minZoom: 2,
                maxPitch: 85
            });
            
            // Add sources and layers after style loads
            globeMap.on('style.load', () => {
                // Add plant markers source
                globeMap.addSource('plants', {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: []
                    }
                });
                
                // Add circles layer for plant markers
                globeMap.addLayer({
                    id: 'plant-markers',
                    type: 'circle',
                    source: 'plants',
                    paint: {
                        'circle-radius': ['get', 'radius'],
                        'circle-color': ['get', 'color'],
                        'circle-stroke-color': '#ffffff',
                        'circle-stroke-width': 2,
                        'circle-opacity': ['get', 'opacity'],
                        'circle-stroke-opacity': ['get', 'opacity']
                    }
                });

                // Apply current labels preference when globe initializes
                try {
                    globeMap.setLayoutProperty('boundaries-layer', 'visibility', labelsEnabled ? 'visible' : 'none');
                } catch (e) {
                    // Layer may not exist
                }

                // Track dragging state for cursor management
                let isGlobeDragging = false;
                let isHoveringMarker = false;
                let mouseDownPos = null;
                
                // Helper function to check if mouse is over a marker with expanded hit area
                function checkMarkerHover(point) {
                    // Query with a tolerance/buffer for easier clicking
                    const tolerance = 8;
                    const bbox = [
                        [point.x - tolerance, point.y - tolerance],
                        [point.x + tolerance, point.y + tolerance]
                    ];
                    const features = globeMap.queryRenderedFeatures(bbox, {
                        layers: ['plant-markers']
                    });
                    return features.length > 0 ? features : null;
                }
                
                // Update cursor based on state
                function updateGlobeCursor() {
                    const canvas = globeMap.getCanvas();
                    if (isGlobeDragging) {
                        canvas.style.cursor = 'grabbing';
                    } else if (isHoveringMarker) {
                        canvas.style.cursor = 'pointer';
                    } else {
                        canvas.style.cursor = 'grab';
                    }
                }
                
                // Track mouse down position for drag vs click detection
                globeMap.on('mousedown', (e) => {
                    mouseDownPos = { x: e.point.x, y: e.point.y };
                });
                
                // Track mouse up
                globeMap.on('mouseup', (e) => {
                    // Small delay to let click event fire first
                    setTimeout(() => {
                        isGlobeDragging = false;
                        const features = checkMarkerHover(e.point);
                        isHoveringMarker = !!features;
                        updateGlobeCursor();
                    }, 10);
                });
                
                // Handle drag start/end events from MapLibre
                globeMap.on('dragstart', () => {
                    isGlobeDragging = true;
                    updateGlobeCursor();
                });
                
                globeMap.on('dragend', () => {
                    isGlobeDragging = false;
                    updateGlobeCursor();
                });
                
                // Handle mouse leave
                globeMap.on('mouseout', () => {
                    isGlobeDragging = false;
                    isHoveringMarker = false;
                    mouseDownPos = null;
                    updateGlobeCursor();
                });
                
                // Add click handler for the whole map, then check for markers
                // This is more reliable than layer-specific click handlers
                globeMap.on('click', (e) => {
                    // Check if this was a drag gesture
                    if (mouseDownPos) {
                        const distance = Math.sqrt(
                            Math.pow(e.point.x - mouseDownPos.x, 2) + 
                            Math.pow(e.point.y - mouseDownPos.y, 2)
                        );
                        // If moved more than 10px, treat as drag and don't show popup
                        if (distance > 10) {
                            return;
                        }
                    }
                    
                    // Query for markers at click location with tolerance
                    const tolerance = 10;
                    const bbox = [
                        [e.point.x - tolerance, e.point.y - tolerance],
                        [e.point.x + tolerance, e.point.y + tolerance]
                    ];
                    
                    const features = globeMap.queryRenderedFeatures(bbox, {
                        layers: ['plant-markers']
                    });
                    
                    if (features.length > 0) {
                        const feature = features[0];
                        const props = feature.properties || {};

                        // Resolve the clicked plant from the main dataset (prefer plantIndex for reliability)
                        let plant = null;
                        const plantIndex = props.plantIndex !== undefined ? parseInt(props.plantIndex, 10) : NaN;
                        if (!isNaN(plantIndex) && nuclearPlants[plantIndex]) {
                            plant = nuclearPlants[plantIndex];
                        } else if (props.name) {
                            plant = nuclearPlants.find(p => p.name === props.name && (!props.country || p.country === props.country));
                        }
                        if (!plant) return;

                        const isMobile = window.innerWidth <= 600;

                        // Clear any existing globe popups (mobile) so behavior matches Leaflet
                        const existingPopups = document.querySelectorAll('.maplibregl-popup');
                        existingPopups.forEach(popup => popup.remove());

                        // Zoom in on the plant (match 2D marker click behavior)
                        const currentZoom = globeMap.getZoom();
                        const targetZoom = Math.max(currentZoom, 8);
                        globeMap.flyTo({
                            center: [plant.lon, plant.lat],
                            zoom: targetZoom,
                            duration: 1500
                        });

                        // Match 2D behavior:
                        // - Desktop: show plant info overlay (replaces the search box)
                        // - Mobile: show plant panel (bottom sheet)
                        // Show after the flyTo animation completes
                        setTimeout(() => {
                            if (!isMobile) {
                                showPlantInfoOverlay(plant);
                                applySearchHighlight(p => p.name === plant.name);
                            } else {
                                // Mobile: show plant panel instead of popup
                                if (typeof window.openPlantPanel === 'function') {
                                    window.openPlantPanel(plant);
                                    applySearchHighlight(p => p.name === plant.name);
                                }
                            }
                        }, 500);
                    }
                });
                
                // Set default cursor to grab
                globeMap.getCanvas().style.cursor = 'grab';
                
                // Use mousemove for cursor detection - only when not dragging
                globeMap.on('mousemove', (e) => {
                    // Skip cursor updates while dragging
                    if (isGlobeDragging) return;
                    
                    const features = checkMarkerHover(e.point);
                    isHoveringMarker = !!features;
                    updateGlobeCursor();
                });
                
                // Initial marker update
                updateGlobeMarkers();
            });
            
            // Add navigation controls
            globeMap.addControl(new maplibregl.NavigationControl(), 'bottom-right');
            
            globeInitialized = true;
            return true;
            
        } catch (e) {
            console.error('Failed to initialize globe:', e);
            return false;
        }
    }
    
    function updateGlobeMarkers() {
        if (!globeMap || !globeMap.getSource('plants')) return;
        
        const features = [];
        
        nuclearPlants.forEach(plant => {
            const plantStatus = getPlantStatusForYear(plant, currentSelectedYear);
            if (!plantStatus) return;
            
            // Apply view filters when at Present
            // Apply view filters (now works for any year, not just Present)
            const plantHasOperable = plantStatus.stats.operable > 0;
            const plantHasConstruction = plantStatus.stats.construction > 0;
            const plantHasShutdown = plantStatus.stats.shutdown > 0;

            // Calculate plant capacity in GW for size filtering
            const plantCapacityGW = getPlantCapacityForYear(plantStatus) / 1000;

            // Check status filters
            const noStatusFiltersActive = !viewOptions.showOperable && !viewOptions.showConstruction && !viewOptions.showShutdown;
            let passesStatusFilter = noStatusFiltersActive;
            if (!noStatusFiltersActive) {
                passesStatusFilter =
                    (plantHasOperable && viewOptions.showOperable) ||
                    (plantHasConstruction && viewOptions.showConstruction) ||
                    (plantHasShutdown && viewOptions.showShutdown && !plantHasOperable && !plantHasConstruction);
            }

            // Check capacity range filter
            const noCapacityFiltersActive = (viewOptions.capacityMin <= CAPACITY_SLIDER_MIN && viewOptions.capacityMax >= CAPACITY_SLIDER_MAX);
            let passesSizeFilter = noCapacityFiltersActive;
            if (!noCapacityFiltersActive) {
                passesSizeFilter = plantCapacityGW >= viewOptions.capacityMin && plantCapacityGW <= viewOptions.capacityMax;
            }

            // Check production range filter (v5.7.150)
            const noProductionFiltersActive = (viewOptions.productionMin <= PRODUCTION_SLIDER_MIN && viewOptions.productionMax >= PRODUCTION_SLIDER_MAX);
            let passesProductionFilter = noProductionFiltersActive;
            if (!noProductionFiltersActive) {
                const plantProductionTWh = getPlantProductionForYear(plant, plantStatus, currentSelectedYear) / 1000;
                passesProductionFilter = plantProductionTWh >= viewOptions.productionMin && plantProductionTWh <= viewOptions.productionMax;
            }

            // Plant must pass ALL active filter categories
            if (!passesStatusFilter || !passesSizeFilter || !passesProductionFilter) return;

            // Calculate stats for popup (using year-specific production)
            const visibleCapacity = getPlantCapacityForYear(plantStatus);
            const visibleProduction = getPlantProductionForYear(plant, plantStatus, currentSelectedYear);
            const operableCount = plantStatus.stats.operable;
            const constructionCount = plantStatus.stats.construction;
            const shutdownCount = plantStatus.stats.shutdown;

            // Serialize reactor info for popup
            const reactorInfo = plantStatus.activeReactors.map(r => ({
                name: r.name,
                status: r.yearStatus,
                capacity: r.capacity || 0,
                url: r.url || ''
            }));

            // Calculate marker radius (v5.7.145-markers: scaled up proportionally with 2D marker increase)
            let radius = 12;
            if (viewOptions.sizeByProduction && maxPlantProduction > 0) {
                const sizeRatio = Math.sqrt(visibleProduction / maxPlantProduction);
                radius = 8 + sizeRatio * 20;
            } else if (viewOptions.sizeByCapacity && maxPlantCapacity > 0) {
                const sizeRatio = Math.sqrt(visibleCapacity / maxPlantCapacity);
                radius = 8 + sizeRatio * 20;
            }

            // Determine if this marker should be dimmed based on search highlight
            let markerColor = plantStatus.color;
            let opacity = 0.9;
            if (currentHighlightFilter) {
                if (currentHighlightFilter(plant)) {
                    radius = radius * 1.2;
                    opacity = 1;
                } else {
                    opacity = 0.25;
                    markerColor = '#9e9e9e';
                }
            }
            
            features.push({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [plant.lon, plant.lat]
                },
                properties: {
                    name: plant.name,
                    country: plant.country,
                    reactors: plantStatus.activeReactors.length,
                    color: markerColor,
                    radius: radius,
                    opacity: opacity,
                    capacity: visibleCapacity,
                    production: visibleProduction,
                    operableCount: operableCount,
                    constructionCount: constructionCount,
                    shutdownCount: shutdownCount,
                    reactorInfo: JSON.stringify(reactorInfo),
                    plantIndex: nuclearPlants.indexOf(plant)
                }
            });
        });
        
        globeMap.getSource('plants').setData({
            type: 'FeatureCollection',
            features: features
        });
    }
    
    function resizeGlobe() {
        if (globeMap) {
            globeMap.resize();
        }
    }
    
    function toggleGlobeView() {
        isGlobeView = !isGlobeView;
        
        const clusterCheckbox = document.getElementById('clusterView');
        const clusterCheckboxMobile = document.getElementById('clusterViewMobile');
        
        if (isGlobeView) {
            // Get current 2D map position before switching
            const currentCenter = map.getCenter();
            const currentZoom = map.getZoom();
            // Stored so an untouched globe returns the 2D camera exactly. The globe keeps
            // minZoom 2 while 2D home is 1, so entry can clamp and the raw round trip drifts.
            preGlobeCamera = { center: currentCenter, zoom: currentZoom, globeZoom: Math.max(2, currentZoom) };
            
            // Initialize globe if needed
            if (!globeInitialized) {
                // Show container first so it has dimensions
                mapElement.style.display = 'none';
                globeContainer.style.display = 'block';
                
                if (!initGlobe()) {
                    isGlobeView = false;
                    // Restore previous selection
                    const globeOption = document.querySelector('.view-mode-option[data-mode="globe"]');
                    const satelliteOption = document.querySelector('.view-mode-option[data-mode="satellite"]');
                    const mapOption = document.querySelector('.view-mode-option[data-mode="map"]');
                    syncViewModeSelection(isSatelliteView ? 'satellite' : 'map');
                    globeContainer.style.display = 'none';
                    mapElement.style.display = 'block';
                    alert('Unable to initialize 3D globe. Your browser may not support WebGL.');
                    return;
                }
                
                // Set initial globe position to match 2D map (after globe loads)
                globeMap.once('load', () => {
                    const globeZoom = Math.max(2, currentZoom); // globe keeps its own minimum of 2
                    globeMap.jumpTo({
                        center: [currentCenter.lng, currentCenter.lat],
                        zoom: globeZoom
                    });
                    globeSynced = true;
                });
            } else {
                // Just show/hide
                mapElement.style.display = 'none';
                globeContainer.style.display = 'block';
                
                // Sync globe position to match 2D map
                const globeZoom = Math.max(2, currentZoom); // globe keeps its own minimum of 2
                globeMap.jumpTo({
                    center: [currentCenter.lng, currentCenter.lat],
                    zoom: globeZoom
                });
                globeSynced = true;
                
                updateGlobeMarkers();
                resizeGlobe();
            }
            
            // Disable cluster checkbox in globe view (clustering not supported)
            if (clusterCheckbox) {
                clusterCheckbox.disabled = true;
                clusterCheckbox.parentElement.style.opacity = '0.5';
            }
            if (clusterCheckboxMobile) {
                clusterCheckboxMobile.disabled = true;
                clusterCheckboxMobile.parentElement.style.opacity = '0.5';
            }

            // Apply current labels preference to globe view
            if (globeMap) {
                try {
                    globeMap.setLayoutProperty('boundaries-layer', 'visibility', labelsEnabled ? 'visible' : 'none');
                } catch (e) {
                    // Layer may not be ready yet - will be applied on style.load
                }
            }

        } else {
            // Get current globe position before switching
            const globeCenter = globeMap.getCenter();
            const globeZoom = globeMap.getZoom();
            // Captured NOW, with the camera it describes. Read inside the timeout instead, the
            // globe's own load handler could set it true during the 100ms wait, making these
            // stale default coordinates look like a deliberate move.
            const globeWasSynced = globeSynced;
            
            // Switch back to map view
            globeContainer.style.display = 'none';
            mapElement.style.display = 'block';
            
            // Re-enable cluster checkbox
            if (clusterCheckbox) {
                clusterCheckbox.disabled = false;
                clusterCheckbox.parentElement.style.opacity = '1';
            }
            if (clusterCheckboxMobile) {
                clusterCheckboxMobile.disabled = false;
                clusterCheckboxMobile.parentElement.style.opacity = '1';
            }
            
            // Refresh map and sync position from globe
            setTimeout(() => {
                map.resize();
                setPlantData(lastPlantFC);   // the 2D source was not updated while hidden
                const untouched = !!preGlobeCamera && (!globeWasSynced || (
                    Math.abs(globeZoom - preGlobeCamera.globeZoom) < 0.01 &&
                    Math.abs(globeCenter.lng - preGlobeCamera.center.lng) < 0.01 &&
                    Math.abs(globeCenter.lat - preGlobeCamera.center.lat) < 0.01));
                globeSynced = false;
                map.jumpTo(untouched
                    ? { center: preGlobeCamera.center, zoom: preGlobeCamera.zoom }
                    : { center: [globeCenter.lng, globeCenter.lat], zoom: globeZoom });
            }, 100);
        }
    }

    // --- 26. Fullscreen Functionality ---
    const fullscreenBtn = document.getElementById('fullscreenBtn');
    const expandIcon = document.getElementById('expandIcon');
    const compressIcon = document.getElementById('compressIcon');
    const mapWrapper = document.getElementById('map-wrapper');
    let isFullscreen = false;
    let previousCenter = null;
    let previousZoom = null;

    function isDesktopViewport() {
        return window.matchMedia ? window.matchMedia('(min-width: 901px)').matches : (window.innerWidth > 900);
    }

    // On desktop, dark mode can be toggled from Settings (rail) too.
    function enforceDesktopLightWhenNotFullscreen() {
        if (!isDesktopViewport()) return;
        const inFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement ||
            (mapWrapper && (mapWrapper.classList.contains('fullscreen') || mapWrapper.classList.contains('browser-fullscreen'))));
        if (inFullscreen) return;

        // Force light mode on desktop when not in fullscreen (do not overwrite saved preference)
        if (window.__WNATheme && typeof window.__WNATheme.setTheme === 'function') {
            window.__WNATheme.setTheme('light', { persist: false });
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }
        if (window.__WNATheme && typeof window.__WNATheme.updateDarkModeAvailability === 'function') {
            window.__WNATheme.updateDarkModeAvailability();
        }
    }

    // When entering fullscreen on desktop, default to light mode (dark mode OFF).
    // Users can manually enable dark mode if desired.
    function restoreDesktopThemeForFullscreen() {
        if (!isDesktopViewport()) return;
        const inFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement ||
            (mapWrapper && (mapWrapper.classList.contains('fullscreen') || mapWrapper.classList.contains('browser-fullscreen'))));
        if (inFullscreen && window.__WNATheme && typeof window.__WNATheme.setTheme === 'function') {
            // Always default to light mode when entering fullscreen
            window.__WNATheme.setTheme('light', { persist: false });
            if (typeof window.__WNATheme.updateDarkModeAvailability === 'function') {
                window.__WNATheme.updateDarkModeAvailability();
            }
            }
    }

    function fitMapToContainer() {
        // Handle globe view
        if (isGlobeView) {
            resizeGlobe();
            return;
        }

        map.resize();
        updateMinZoomToPreventGrey();
    }

    
    function refreshOpenInfoPanelsForFullscreenChange() {
        // Re-render any visible plant/country info panels so layout matches fullscreen state
        const isDesktop = window.innerWidth > 600;
        if (!isDesktop) return;

        const plantInfoBoxEl = document.getElementById('plantInfoBox');
        const countryInfoBoxEl = document.getElementById('countryInfoBox');

        const plantModalOpen = !!(plantDetailModal && plantDetailModal.classList.contains('open'));
        const plantSummaryOpen = !!(plantInfoBoxEl && plantInfoBoxEl.classList.contains('visible'));
        const countrySummaryOpen = !!(countryInfoBoxEl && countryInfoBoxEl.classList.contains('visible'));

        // Preserve country plant list expanded state across re-render
        const countryPlantsListEl = document.getElementById('countryInfoPlantsList');
        const countryPlantsToggleEl = document.getElementById('countryInfoPlantsToggle');
        const countryListWasExpanded = !!(countryPlantsListEl && countryPlantsListEl.classList.contains('expanded'));

        // Prefer whichever panel is actually open/visible right now
        if ((plantModalOpen || plantSummaryOpen) && typeof currentSelectedPlant !== 'undefined' && currentSelectedPlant) {
            // If we exited fullscreen while the detailed modal was open, close it first
            if (plantModalOpen && typeof canOpenPlantDetailModal === 'function' && !canOpenPlantDetailModal()) {
                if (typeof closePlantDetailModal === 'function') closePlantDetailModal();
            }
            if (typeof showPlantInfoOverlay === 'function') {
                showPlantInfoOverlay(currentSelectedPlant);
            }
            return;
        }

        if (countrySummaryOpen && typeof currentSelectedCountry !== 'undefined' && currentSelectedCountry) {
            if (typeof showCountryInfoOverlay === 'function') {
                showCountryInfoOverlay(currentSelectedCountry);
            }

            // Restore expanded state if it was expanded
            if (countryListWasExpanded && countryPlantsListEl && countryPlantsToggleEl) {
                countryPlantsToggleEl.classList.add('expanded');
                countryPlantsToggleEl.setAttribute('aria-expanded', 'true');
                countryPlantsListEl.classList.add('expanded');
            }
        }
    }

    // Refresh open info panels when the timeline year changes
    function refreshOpenInfoPanelsForYearChange() {
        const plantInfoBoxEl = document.getElementById('plantInfoBox');
        const countryInfoBoxEl = document.getElementById('countryInfoBox');

        const plantModalOpen = !!(plantDetailModal && plantDetailModal.classList.contains('open'));
        const plantSummaryOpen = !!(plantInfoBoxEl && plantInfoBoxEl.classList.contains('visible'));
        const countrySummaryOpen = !!(countryInfoBoxEl && countryInfoBoxEl.classList.contains('visible'));

        // Preserve expanded states across re-render
        const countryPlantsListEl = document.getElementById('countryInfoPlantsList');
        const countryPlantsToggleEl = document.getElementById('countryInfoPlantsToggle');
        const countryListWasExpanded = !!(countryPlantsListEl && countryPlantsListEl.classList.contains('expanded'));

        const plantReactorsListEl = document.getElementById('plantInfoReactorsList');
        const plantReactorsToggleEl = document.getElementById('plantInfoReactorsToggle');
        const plantListWasExpanded = !!(plantReactorsListEl && plantReactorsListEl.classList.contains('expanded'));

        // Refresh plant info if open
        if ((plantModalOpen || plantSummaryOpen) && typeof currentSelectedPlant !== 'undefined' && currentSelectedPlant) {
            // Check if plant still has reactors visible in this year (using filtered status)
            const plantStatus = getFilteredPlantStatusForYear(currentSelectedPlant, currentSelectedYear);
            const hasDataForYear = plantStatus && plantStatus.activeReactors && plantStatus.activeReactors.length > 0;
            
            if (hasDataForYear) {
                // Plant exists in this year - refresh the display
                if (plantModalOpen && typeof openPlantDetailModal === 'function') {
                    openPlantDetailModal(currentSelectedPlant);
                } else if (typeof showPlantInfoOverlay === 'function') {
                    showPlantInfoOverlay(currentSelectedPlant, null, false);
                    // Restore expanded state
                    if (plantListWasExpanded && plantReactorsListEl && plantReactorsToggleEl) {
                        plantReactorsToggleEl.classList.add('expanded');
                        plantReactorsToggleEl.setAttribute('aria-expanded', 'true');
                        plantReactorsListEl.classList.add('expanded');
                    }
                }
            } else {
                // v5.7.153: Plant doesn't exist in this year — show no-data message in-place
                if (plantModalOpen && typeof openPlantDetailModal === 'function') {
                    // Keep modal open; openPlantDetailModal now handles the no-data case
                    openPlantDetailModal(currentSelectedPlant);
                } else if (typeof showPlantInfoOverlay === 'function') {
                    showPlantInfoOverlay(currentSelectedPlant, null, true);
                }
            }
            return;
        }

        // Refresh country info if open
        if (countrySummaryOpen && typeof currentSelectedCountry !== 'undefined' && currentSelectedCountry) {
            // Refresh the display - showCountryInfoOverlay now handles no-data case
            if (typeof showCountryInfoOverlay === 'function') {
                showCountryInfoOverlay(currentSelectedCountry);
            }

            // Restore expanded state (only if there's data)
            const stats = generateCountryStats(currentSelectedCountry, currentSelectedYear);
            if (stats && stats.totalReactors > 0 && countryListWasExpanded && countryPlantsListEl && countryPlantsToggleEl) {
                countryPlantsToggleEl.classList.add('expanded');
                countryPlantsToggleEl.setAttribute('aria-expanded', 'true');
                countryPlantsListEl.classList.add('expanded');
            }
        }
    }

function toggleFullscreen() {
        if (!isFullscreen) {
            // Store current view before entering fullscreen
            previousCenter = map.getCenter();
            previousZoom = map.getZoom();
            
            // Store scroll position to restore later
            const scrollY = window.scrollY;
            mapWrapper.dataset.scrollY = scrollY;
            
            // Enter fullscreen
            isFullscreen = true;
            mapWrapper.classList.add('fullscreen');
            document.body.classList.add('fullscreen-active');
            document.documentElement.classList.add('fullscreen-active');
            // Mobile: ensure the map shell is visible once fullscreen is entered.
            if (isMobileViewport) {
                mapWrapper.classList.remove('mobile-hold-active');
            }
            restoreDesktopThemeForFullscreen();
            syncYearSliderDock();
            syncTimelineChartsForFullscreen();
            try { if (typeof applyResponsiveControlLayout === 'function') applyResponsiveControlLayout(); } catch (e) {}
            expandIcon.style.display = 'none';
            compressIcon.style.display = 'block';
            fullscreenBtn.setAttribute('aria-label', 'Exit fullscreen');
            
            // Try native fullscreen API (but don't rely on it for mobile)
            if (mapWrapper.requestFullscreen) {
                mapWrapper.requestFullscreen().catch(() => {});
            } else if (mapWrapper.webkitRequestFullscreen) {
                mapWrapper.webkitRequestFullscreen();
            } else if (mapWrapper.msRequestFullscreen) {
                mapWrapper.msRequestFullscreen();
            }
            
            // Fit map after transition
            setTimeout(() => {
                fitMapToContainer();
                refreshOpenInfoPanelsForFullscreenChange();
                // v5.7.141: Update status bar filter display for fullscreen mode (detailed chips)
                if (typeof updateStatusBarFilters === 'function') updateStatusBarFilters();
            }, 100);
} else {
            // Exit fullscreen
            // FIX: Capture current map position BEFORE exiting so we maintain the user's
            // current view, not the view from when they entered fullscreen
            const exitCenter = map.getCenter();
            const exitZoom = map.getZoom();

            isFullscreen = false;
            mapWrapper.classList.remove('fullscreen');
            document.body.classList.remove('fullscreen-active');
            document.documentElement.classList.remove('fullscreen-active');
            enforceDesktopLightWhenNotFullscreen();
            syncYearSliderDock();
            syncTimelineChartsForFullscreen();
            try { if (typeof applyResponsiveControlLayout === 'function') applyResponsiveControlLayout(); } catch (e) {}
            expandIcon.style.display = 'block';
            compressIcon.style.display = 'none';
            fullscreenBtn.setAttribute('aria-label', 'Toggle fullscreen');


            // Mobile: the map only operates in fullscreen. When leaving fullscreen, return to the opt-in screen.
            if (isMobileViewport) {
                sessionStorage.removeItem('forceMobileMapLoad');
                sessionStorage.removeItem('mobileAutoFullscreen');
                mapWrapper.classList.add('mobile-hold-active');
                const lb = document.getElementById('mobileLoadMapBtn');
                if (lb) { lb.textContent = 'Load Map Anyway'; lb.disabled = false; } // v5.7.156: re-enable for in-place re-entry

                // Reset dark mode to OFF (light) when exiting on mobile
                if (window.__WNATheme && typeof window.__WNATheme.setTheme === 'function') {
                    window.__WNATheme.setTheme('light', { persist: false });
                }
            }

            // Close detailed modal and revert to standard view if a plant is selected
            if (plantDetailModal && plantDetailModal.classList.contains('open')) {
                closePlantDetailModal();
            }

            // v5.7.179: Hide chart tooltips that may linger after timeline sidebar is hidden
            hideChartTooltip();
            hideChartYearIndicators();

            // v5.7.179: Close expanded chart modal + its tooltip if open
            if (expandedChartModal && expandedChartModal.classList.contains('open')) {
                closeExpandedChart();
            }

            // Restore scroll position
            const scrollY = parseInt(mapWrapper.dataset.scrollY || '0', 10);
            
            // Exit native fullscreen
            if (document.exitFullscreen) {
                document.exitFullscreen().catch(() => {});
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            
            // Restore current view (captured above) and scroll position after transition
            setTimeout(() => {
                map.resize();
                // exitCenter/exitZoom are the position when exiting, not when entering.
                // Note the zoom truthiness test is gone: it would be falsy at zoom 0.
                if (exitCenter) {
                    map.jumpTo({ center: [exitCenter.lng, exitCenter.lat], zoom: exitZoom });
                }
                window.scrollTo(0, scrollY);
                refreshOpenInfoPanelsForFullscreenChange();
                // v5.7.141: Update status bar filter display for embedded mode (compact summary)
                if (typeof updateStatusBarFilters === 'function') updateStatusBarFilters();
            }, 100);
}
    }

    fullscreenBtn.addEventListener('click', toggleFullscreen);

    // v5.7.156: Expose for mobile in-place re-entry (outer gate calls these on button click)
    window.__toggleFullscreen = toggleFullscreen;
    window.__mapInitialized = true;

    // Mobile: the map should only run in fullscreen. If the user opted in to load the map,
    // automatically enter fullscreen layout on load.
    const mobileForceFullscreen = isMobileViewport && sessionStorage.getItem('forceMobileMapLoad') === 'true';
    if (mobileForceFullscreen && !isFullscreen) {
        if (__mobileDirectInit) {
            // v5.7.156: Direct-init path — fullscreen CSS was pre-applied by the outer
            // button handler. toggleFullscreen() reconciles internal state (isFullscreen,
            // icon swap, syncs, etc.) and its redundant classList.add('fullscreen') is harmless.
            try {
                toggleFullscreen();
            } catch (e) {
                console.warn('Mobile fullscreen toggle failed:', e);
            }
            // Reveal the map by fading out the loading overlay
            requestAnimationFrame(() => {
                if (mapWrapper) mapWrapper.classList.add('mobile-init-reveal');
                setTimeout(() => {
                    if (mapWrapper) {
                        mapWrapper.classList.remove('mobile-direct-loading');
                        mapWrapper.classList.remove('mobile-init-reveal');
                    }
                    const lb = document.getElementById('mobileLoadMapBtn');
                    if (lb) { lb.disabled = false; lb.textContent = 'Load Map Anyway'; }
                }, 450);
            });
        } else {
            // Reload path: enter fullscreen synchronously, then clean up
            try {
                toggleFullscreen();
            } catch (e) {
                console.warn('Mobile fullscreen toggle failed:', e);
            }
            sessionStorage.removeItem('mobileAutoFullscreen');
            if (mapWrapper) mapWrapper.classList.remove('mobile-hold-active');

            // Remove the pending class after a brief moment to allow CSS transition
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (mapWrapper) {
                        mapWrapper.classList.remove('mobile-fs-pending');
                    }
                });
            });
        }
    }


    // Heuristic: detect browser-level fullscreen (e.g., F11) and expose fullscreen-only controls there too.
    function syncBrowserFullscreenHeuristic() {
        if (!mapWrapper) return;

        // Native element fullscreen already covered by the `.fullscreen` class + :fullscreen CSS,
        // but keep the heuristic for browser fullscreen where Fullscreen API isn't used.
        const sw = (window.screen && screen.width) ? screen.width : window.innerWidth;
        const sh = (window.screen && screen.height) ? screen.height : window.innerHeight;

        const wDiff = Math.abs(window.innerWidth - sw);
        const hDiff = Math.abs(window.innerHeight - sh);

        const displayModeFullscreen = !!(window.matchMedia && (
            window.matchMedia('(display-mode: fullscreen)').matches ||
            window.matchMedia('(display-mode: standalone)').matches
        ));

        // Tight threshold to avoid false positives from mobile browser chrome showing/hiding.
        const browserFullscreen = displayModeFullscreen || (wDiff < 3 && hDiff < 3);

        mapWrapper.classList.toggle('browser-fullscreen', browserFullscreen);

        if (browserFullscreen) {
            restoreDesktopThemeForFullscreen();
        } else {
            enforceDesktopLightWhenNotFullscreen();
        }
    }

    syncBrowserFullscreenHeuristic();
    window.addEventListener('resize', syncBrowserFullscreenHeuristic);
    window.addEventListener('orientationchange', syncBrowserFullscreenHeuristic);
    document.addEventListener('fullscreenchange', syncBrowserFullscreenHeuristic);
    document.addEventListener('webkitfullscreenchange', syncBrowserFullscreenHeuristic);

    // v5.7.184: clear the timeline chart hover overlays on any native fullscreen change.
    //
    // The chart tooltip and the year-indicator pills are body-level position:fixed elements,
    // so hiding the timeline sidebar underneath the cursor never fires the canvas mouseleave
    // that would dismiss them - they just stay on screen, floating over the page at
    // z-index 10000. The Fullscreen button's own exit path has cleared them since v5.7.179,
    // but Escape and F11 go through these native handlers instead and did not, which is how a
    // stray "2021 / 2653.4 TWh" card ended up parked over the map controls. Pre-existing:
    // the same gap is in the pre-MapLibre build. Clearing on every native fullscreen change
    // covers both directions and is idempotent.
    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (ev) {
        document.addEventListener(ev, function () {
            if (typeof hideChartTooltip === 'function') hideChartTooltip();
            if (typeof hideChartYearIndicators === 'function') hideChartYearIndicators();
        });
    });

    // v5.7.141: Dynamically update status bar filter display on window resize
    // This ensures the filter summary (compact) vs chips (detailed) switches correctly
    // when the user resizes the browser window or changes orientation
    let statusBarResizeTimer = null;
    window.addEventListener('resize', () => {
        clearTimeout(statusBarResizeTimer);
        statusBarResizeTimer = setTimeout(() => {
            if (typeof updateStatusBarFilters === 'function') updateStatusBarFilters();
        }, 150);
    });

    // Fullscreen header exit button handler
    const fsHeaderExitBtn = document.getElementById('fsHeaderExitBtn');
    if (fsHeaderExitBtn) {
        fsHeaderExitBtn.addEventListener('click', () => {
            if (isFullscreen) {
                toggleFullscreen();
            }
        });
    }

    // Handle native fullscreen exit (e.g., pressing Escape)
    document.addEventListener('fullscreenchange', () => {
        if (!document.fullscreenElement && isFullscreen) {
            isFullscreen = false;
            mapWrapper.classList.remove('fullscreen');
            document.body.classList.remove('fullscreen-active');
            document.documentElement.classList.remove('fullscreen-active');
            enforceDesktopLightWhenNotFullscreen();
            syncYearSliderDock();
            syncTimelineChartsForFullscreen();
            expandIcon.style.display = 'block';
            compressIcon.style.display = 'none';
            fullscreenBtn.setAttribute('aria-label', 'Toggle fullscreen');

            // Mobile: return to the opt-in screen when native fullscreen exits.
            if (isMobileViewport) {
                sessionStorage.removeItem('forceMobileMapLoad');
                sessionStorage.removeItem('mobileAutoFullscreen');
                mapWrapper.classList.add('mobile-hold-active');
                const lb2 = document.getElementById('mobileLoadMapBtn');
                if (lb2) { lb2.textContent = 'Load Map Anyway'; lb2.disabled = false; } // v5.7.156

                // Reset dark mode to OFF (light) when exiting on mobile
                if (window.__WNATheme && typeof window.__WNATheme.setTheme === 'function') {
                    window.__WNATheme.setTheme('light', { persist: false });
                }
            }

            // Close detailed modal and revert to standard view
            if (plantDetailModal && plantDetailModal.classList.contains('open')) {
                closePlantDetailModal();
            }
            // Close expanded chart if open
            if (expandedChartModal && expandedChartModal.classList.contains('open')) {
                closeExpandedChart();
            }

            const scrollY = parseInt(mapWrapper.dataset.scrollY || '0', 10);
            setTimeout(() => {
                const nativeExitCenter = map.getCenter();
                const nativeExitZoom = map.getZoom();
                map.resize();
                if (nativeExitCenter) {
                    map.jumpTo({ center: [nativeExitCenter.lng, nativeExitCenter.lat], zoom: nativeExitZoom });
                }
                window.scrollTo(0, scrollY);
                refreshOpenInfoPanelsForFullscreenChange();
                // v5.7.141: Update filter display for embedded mode after native fullscreen exit
                if (typeof updateStatusBarFilters === 'function') updateStatusBarFilters();
            }, 100);
        }
    });

    // Also handle webkit prefix
    document.addEventListener('webkitfullscreenchange', () => {
        if (!document.webkitFullscreenElement && isFullscreen) {
            isFullscreen = false;
            mapWrapper.classList.remove('fullscreen');
            document.body.classList.remove('fullscreen-active');
            document.documentElement.classList.remove('fullscreen-active');
            enforceDesktopLightWhenNotFullscreen();
            syncYearSliderDock();
            syncTimelineChartsForFullscreen();
            expandIcon.style.display = 'block';
            compressIcon.style.display = 'none';
            fullscreenBtn.setAttribute('aria-label', 'Toggle fullscreen');

            // Mobile: return to the opt-in screen when native fullscreen exits.
            if (isMobileViewport) {
                sessionStorage.removeItem('forceMobileMapLoad');
                sessionStorage.removeItem('mobileAutoFullscreen');
                mapWrapper.classList.add('mobile-hold-active');
                const lb3 = document.getElementById('mobileLoadMapBtn');
                if (lb3) { lb3.textContent = 'Load Map Anyway'; lb3.disabled = false; } // v5.7.156

                // Reset dark mode to OFF (light) when exiting on mobile
                if (window.__WNATheme && typeof window.__WNATheme.setTheme === 'function') {
                    window.__WNATheme.setTheme('light', { persist: false });
                }
            }


            // Close detailed modal and revert to standard view
            if (plantDetailModal && plantDetailModal.classList.contains('open')) {
                closePlantDetailModal();
            }
            // Close expanded chart if open
            if (expandedChartModal && expandedChartModal.classList.contains('open')) {
                closeExpandedChart();
            }

            const scrollY = parseInt(mapWrapper.dataset.scrollY || '0', 10);
            setTimeout(() => {
                const nativeExitCenter = map.getCenter();
                const nativeExitZoom = map.getZoom();
                map.resize();
                if (nativeExitCenter) {
                    map.jumpTo({ center: [nativeExitCenter.lng, nativeExitCenter.lat], zoom: nativeExitZoom });
                }
                window.scrollTo(0, scrollY);
                refreshOpenInfoPanelsForFullscreenChange();
                // v5.7.141: Update filter display for embedded mode after webkit fullscreen exit
                if (typeof updateStatusBarFilters === 'function') updateStatusBarFilters();
            }, 100);
        }
    });

    // Handle Escape key for CSS-only fullscreen fallback
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isFullscreen && !document.fullscreenElement) {
            toggleFullscreen();
        }
    });

    

// --- 27. Responsive Desktop Sidebar Mount ---
// Moves the existing controls into a permanent left sidebar on desktop,
// while preserving the current overlay layout on mobile.
const controlsOverlay = document.getElementById('controlsOverlay');
const sidebarSearchMount = document.getElementById('sidebarSearchMount');
const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
const sidebarFiltersMount = document.getElementById('sidebarFiltersMount');
const sidebarViewMount = document.getElementById('sidebarViewMount');
const sidebarDisplayOptions = document.getElementById('sidebarDisplayOptions');
const sidebarFiltersGroup = document.getElementById('sidebarFiltersGroup');

const mapControlsGroupEl = document.getElementById('mapControlsGroup');
const filtersWrapperEl = document.getElementById('filtersWrapper');
const homeButtonEl = document.getElementById('homeButton');
const searchWrapperEl = document.querySelector('.search-wrapper');
const viewModeWrapperEl = document.querySelector('.view-mode-wrapper');
const viewDropdownWrapperEl = document.getElementById('viewDropdownWrapper');
const viewModeBtnGroupEl = document.getElementById('viewModeBtnGroup');
const mapContainerEl = document.getElementById('map-container');
const displayOptionsGroupEl = document.getElementById('displayOptionsGroup');

function applyResponsiveControlLayout() {
    try { if (typeof window.closeMapRailDrawers === 'function') window.closeMapRailDrawers(); } catch (e) {}

const isMobile = window.matchMedia('(max-width: 600px)').matches;
    const countryInfoOverlay = document.getElementById('countryInfoOverlay');
    const plantInfoOverlay = document.getElementById('plantInfoOverlay');

    if (isMobile) {
        // Mobile: keep the existing overlay controls layout
        if (controlsOverlay) controlsOverlay.style.display = 'flex';
        
        // Hide the info overlays on mobile (use popups/panels instead)
        if (countryInfoOverlay) countryInfoOverlay.style.display = 'none';
        if (plantInfoOverlay) plantInfoOverlay.style.display = 'none';

        if (controlsOverlay && searchWrapperEl) controlsOverlay.appendChild(searchWrapperEl);
        if (controlsOverlay && homeButtonEl) {
            controlsOverlay.appendChild(homeButtonEl);
            homeButtonEl.classList.remove('home-btn-group');
        }
        if (filtersWrapperEl) filtersWrapperEl.style.display = '';
        if (controlsOverlay && filtersWrapperEl) controlsOverlay.appendChild(filtersWrapperEl);

        // Keep Display Options in the Filters panel on mobile
        const filtersPanelEl = document.getElementById('filtersPanel');
        if (filtersPanelEl && displayOptionsGroupEl) filtersPanelEl.appendChild(displayOptionsGroupEl);

        // Keep top-right map controls on the map
        if (mapControlsGroupEl && viewModeWrapperEl) {
            mapControlsGroupEl.appendChild(viewModeWrapperEl);
            viewModeWrapperEl.style.display = '';
        }
        // Keep the sidebar map-view dropdown out of the mobile overlay
        if (controlsOverlay && viewDropdownWrapperEl) controlsOverlay.appendChild(viewDropdownWrapperEl);
        if (mapContainerEl && mapControlsGroupEl) mapContainerEl.appendChild(mapControlsGroupEl);

        if (filtersWrapperEl) filtersWrapperEl.classList.remove('sidebar-disabled');
        
        // View mode now lives in the Settings drawer (rail)
        if (viewModeBtnGroupEl) viewModeBtnGroupEl.style.display = '';
        if (viewModeWrapperEl) viewModeWrapperEl.style.display = 'none';
        if (viewDropdownWrapperEl) viewDropdownWrapperEl.style.display = 'none';
    } else {
        // Desktop: sidebar removed — keep compact controls on-map
        if (controlsOverlay) controlsOverlay.style.display = 'none';

        if (desktopSearchOverlay && searchWrapperEl) desktopSearchOverlay.appendChild(searchWrapperEl);

        // Move status bar (year + filters) to desktop search overlay (right of search bar)
        const mapStatusBar = document.getElementById('mapStatusBar');
        if (desktopSearchOverlay && mapStatusBar) {
            desktopSearchOverlay.appendChild(mapStatusBar);
        }

        // Filters now live in the left rail drawer on desktop (keep legacy dropdown for mobile only)
        if (filtersWrapperEl) filtersWrapperEl.style.display = 'none';

        // Hide the legacy view dropdown on desktop (use button group instead)
        if (viewDropdownWrapperEl) viewDropdownWrapperEl.style.display = 'none';

        // View mode now lives in the Settings drawer (rail)
        if (viewModeBtnGroupEl) viewModeBtnGroupEl.style.display = '';
        if (viewModeWrapperEl) viewModeWrapperEl.style.display = 'none';

        // Move Reset View into the top-right stack (with Fullscreen)
        if (mapControlsGroupEl && homeButtonEl) {
            mapControlsGroupEl.insertBefore(homeButtonEl, mapControlsGroupEl.firstChild);
            homeButtonEl.classList.add('home-btn-group');
        }

        // Ensure the top-right control stack stays on the map (not in the sidebar)
        if (mapContainerEl && mapControlsGroupEl) mapContainerEl.appendChild(mapControlsGroupEl);

        // Filters now work for all years - keep them enabled
        if (filtersWrapperEl) {
            filtersWrapperEl.classList.remove('sidebar-disabled');
        }
        if (sidebarFiltersGroup) {
            sidebarFiltersGroup.classList.remove('sidebar-disabled');
        }
    }

    // Resize maps after DOM/layout changes (Leaflet + MapLibre globe)
    setTimeout(() => {
        try { map.resize(); } catch (e) {}
        try { if (typeof resizeGlobe === 'function') resizeGlobe(); } catch (e) {}
    }, 60);
}

const sidebarMq = window.matchMedia('(max-width: 600px)');
if (sidebarMq.addEventListener) {
    sidebarMq.addEventListener('change', applyResponsiveControlLayout);
} else if (sidebarMq.addListener) {
    sidebarMq.addListener(applyResponsiveControlLayout);
}

// Apply on load
applyResponsiveControlLayout();

/* ===== Rail / Drawer behavior (desktop) ===== */
(function initMapRailDrawers(){
    const backdrop = document.getElementById('drawerBackdrop');
    const rail = document.getElementById('mapSideRail');

    const filtersBtn = document.getElementById('railFiltersBtn');
    const settingsBtn = document.getElementById('railSettingsBtn');
    const viewModeBtn = document.getElementById('railViewModeBtn');
    const themeBtn = document.getElementById('railThemeBtn');
    const tourBtn = document.getElementById('railTourBtn');

    const filtersDrawer = document.getElementById('filtersDrawer');
    const settingsDrawer = document.getElementById('settingsDrawer');
    const viewModeDrawer = document.getElementById('viewModeDrawer');
    const themeDrawer = document.getElementById('themeDrawer');
    const tourDrawer = document.getElementById('tourDrawer');

    const filtersClose = document.getElementById('filtersDrawerClose');
    const settingsClose = document.getElementById('settingsDrawerClose');
    const viewModeClose = document.getElementById('viewModeDrawerClose');
    const themeClose = document.getElementById('themeDrawerClose');
    const tourClose = document.getElementById('tourDrawerClose');

    // Mount existing (desktop) controls into the drawers so IDs & listeners keep working
    const filtersMount = document.getElementById('filtersDrawerMount');
    const settingsDisplayMount = document.getElementById('settingsDisplayMount');
    const viewModeDrawerMount = document.getElementById('viewModeDrawerMount');
    const themeDrawerMount = document.getElementById('themeDrawerMount');


    const sidebarFiltersGroup = document.getElementById('sidebarFiltersGroup');
    const sidebarDisplayOptions = document.getElementById('sidebarDisplayOptions');
    const darkModeOption = document.getElementById('darkModeOption');
    const viewModeBtnGroup = document.getElementById('viewModeBtnGroup');

    if (filtersMount && sidebarFiltersGroup && !filtersMount.contains(sidebarFiltersGroup)) {
        filtersMount.appendChild(sidebarFiltersGroup);
    }
    if (settingsDisplayMount && sidebarDisplayOptions && !settingsDisplayMount.contains(sidebarDisplayOptions)) {
        settingsDisplayMount.appendChild(sidebarDisplayOptions);
    }
    if (themeDrawerMount && darkModeOption && !themeDrawerMount.contains(darkModeOption)) {
        themeDrawerMount.appendChild(darkModeOption);
    }

    if (viewModeDrawerMount && viewModeBtnGroup && !viewModeDrawerMount.contains(viewModeBtnGroup)) {
        viewModeDrawerMount.appendChild(viewModeBtnGroup);
        // Ensure the group is visible (it used to be hidden by responsive layout)
        viewModeBtnGroup.style.display = '';

        // Also move the labels toggle row to the drawer
        const labelsToggleRow = document.getElementById('labelsToggleRow');
        if (labelsToggleRow && !viewModeDrawerMount.contains(labelsToggleRow)) {
            viewModeDrawerMount.appendChild(labelsToggleRow);
        }
    }

    function closeDrawers(){
        if (filtersDrawer) filtersDrawer.classList.remove('open');
        if (settingsDrawer) settingsDrawer.classList.remove('open');
        if (viewModeDrawer) viewModeDrawer.classList.remove('open');
        if (themeDrawer) themeDrawer.classList.remove('open');
        if (tourDrawer) tourDrawer.classList.remove('open');
        if (backdrop) backdrop.classList.remove('active');

        // Also remove tour overlay dimming (shown when tour drawer opened via showTourWelcome)
        const tourOverlay = document.getElementById('tourOverlay');
        if (tourOverlay) tourOverlay.classList.remove('active');

        if (filtersBtn){
            filtersBtn.classList.remove('active');
            filtersBtn.setAttribute('aria-expanded', 'false');
        }
        if (settingsBtn){
            settingsBtn.classList.remove('active');
            settingsBtn.setAttribute('aria-expanded', 'false');
        }
        if (viewModeBtn){
            viewModeBtn.classList.remove('active');
            viewModeBtn.setAttribute('aria-expanded', 'false');
        }
        if (themeBtn){
            themeBtn.classList.remove('active');
            themeBtn.setAttribute('aria-expanded', 'false');
        }
        if (tourBtn){
            tourBtn.classList.remove('active');
            tourBtn.setAttribute('aria-expanded', 'false');
        }
    }

    function openDrawer(which){
        closeDrawers();
        if (backdrop) backdrop.classList.add('active');

        if (which === 'filters' && filtersDrawer){
            filtersDrawer.classList.add('open');
            if (filtersBtn){
                filtersBtn.classList.add('active');
                filtersBtn.setAttribute('aria-expanded', 'true');
            }
        }
        if (which === 'settings' && settingsDrawer){
            settingsDrawer.classList.add('open');
            if (settingsBtn){
                settingsBtn.classList.add('active');
                settingsBtn.setAttribute('aria-expanded', 'true');
            }
        }
        if (which === 'viewMode' && viewModeDrawer){
            viewModeDrawer.classList.add('open');
            if (viewModeBtn){
                viewModeBtn.classList.add('active');
                viewModeBtn.setAttribute('aria-expanded', 'true');
            }
        }
        if (which === 'theme' && themeDrawer){
            themeDrawer.classList.add('open');
            if (themeBtn){
                themeBtn.classList.add('active');
                themeBtn.setAttribute('aria-expanded', 'true');
            }
        }
        if (which === 'tour' && tourDrawer){
            tourDrawer.classList.add('open');
            if (tourBtn){
                tourBtn.classList.add('active');
                tourBtn.setAttribute('aria-expanded', 'true');
            }
        }
    }

    function toggleDrawer(which){
        let isOpen = false;
        if (which === 'filters') isOpen = filtersDrawer && filtersDrawer.classList.contains('open');
        else if (which === 'settings') isOpen = settingsDrawer && settingsDrawer.classList.contains('open');
        else if (which === 'viewMode') isOpen = viewModeDrawer && viewModeDrawer.classList.contains('open');
        else if (which === 'theme') isOpen = themeDrawer && themeDrawer.classList.contains('open');
        else if (which === 'tour') isOpen = tourDrawer && tourDrawer.classList.contains('open');

        if (isOpen) closeDrawers();
        else openDrawer(which);
    }

    // Button handlers
    if (filtersBtn) filtersBtn.addEventListener('click', (e) => { e.stopPropagation(); toggleDrawer('filters'); });
    if (settingsBtn) settingsBtn.addEventListener('click', (e) => { e.stopPropagation(); toggleDrawer('settings'); });
    if (viewModeBtn) viewModeBtn.addEventListener('click', (e) => { e.stopPropagation(); toggleDrawer('viewMode'); });
    if (themeBtn) themeBtn.addEventListener('click', (e) => { e.stopPropagation(); toggleDrawer('theme'); });
    if (tourBtn) tourBtn.addEventListener('click', (e) => { e.stopPropagation(); toggleDrawer('tour'); });

    if (filtersClose) filtersClose.addEventListener('click', (e) => { e.stopPropagation(); closeDrawers(); });
    if (settingsClose) settingsClose.addEventListener('click', (e) => { e.stopPropagation(); closeDrawers(); });
    if (viewModeClose) viewModeClose.addEventListener('click', (e) => { e.stopPropagation(); closeDrawers(); });
    if (themeClose) themeClose.addEventListener('click', (e) => { e.stopPropagation(); closeDrawers(); });
    if (tourClose) tourClose.addEventListener('click', (e) => { e.stopPropagation(); closeDrawers(); });

    // Click outside (on the map) closes
    if (backdrop) backdrop.addEventListener('click', closeDrawers);

    // Prevent clicks inside drawers/rail from bubbling to backdrop logic
    [filtersDrawer, settingsDrawer, viewModeDrawer, themeDrawer, tourDrawer, rail].forEach((el) => {
        if (!el) return;
        el.addEventListener('click', (e) => e.stopPropagation());
    });

    // ESC closes
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDrawers();
    });

    // Expose for other code paths if needed
    window.closeMapRailDrawers = closeDrawers;
})();

const mapShellEl = document.getElementById('map-shell');



const sidebarEl = document.getElementById('map-sidebar');
const sidebarScrollEl = sidebarEl ? sidebarEl.querySelector('.sidebar-scroll') : null;

function updateSidebarScrollbarWidth() {
    if (!sidebarEl || !sidebarScrollEl) return;
    // Measure the *actual* scrollbar width of the scroll container (varies by OS/browser).
    const sbw = Math.max(0, sidebarScrollEl.offsetWidth - sidebarScrollEl.clientWidth);
    sidebarEl.style.setProperty('--sidebar-scrollbar-width', `${sbw}px`);
}


// Always ensure sidebar is expanded on load
if (mapShellEl) {
    mapShellEl.classList.remove('sidebar-collapsed');
    // Clear any stored preference
    try { localStorage.removeItem('sidebarCollapsed'); } catch (e) {}
}

window.addEventListener('resize', updateSidebarScrollbarWidth);
setTimeout(updateSidebarScrollbarWidth, 0);

// --- Mobile Notice Banner ---
    const mobileNotice = document.getElementById('mobileNotice');
    const mobileNoticeClose = document.getElementById('mobileNoticeClose');
    
    // Check if already dismissed this session
    if (sessionStorage.getItem('mobileNoticeDismissed')) {
        mobileNotice.style.display = 'none';
    }
    
    mobileNoticeClose.addEventListener('click', () => {
        mobileNotice.style.display = 'none';
        sessionStorage.setItem('mobileNoticeDismissed', 'true');
    });

    
    // --- Tour Nudge ---
    const tourNudge = document.getElementById('tourNudge');
    const tourNudgeClose = document.getElementById('tourNudgeClose');
    let nudgeTimeout = null;

    function showTourNudge() {
        // Don't show if tour already completed
        if (localStorage.getItem('npp-tour-completed')) return;
        // Don't show if nudge already dismissed this session
        if (sessionStorage.getItem('tourNudgeDismissed')) return;
        // Don't show if nudge element doesn't exist
        if (!tourNudge) return;

        const tourBtn = document.getElementById('railTourBtn');
        if (!tourBtn) return;

        // Position the nudge next to the tour button
        function positionNudge() {
            const btnRect = tourBtn.getBoundingClientRect();
            // Position to the right of the button, vertically centered
            tourNudge.style.left = (btnRect.right + 12) + 'px';
            tourNudge.style.top = (btnRect.top + (btnRect.height / 2) - (tourNudge.offsetHeight / 2)) + 'px';
        }

        // Show with slight delay for smooth appearance
        setTimeout(() => {
            positionNudge();
            tourNudge.classList.add('visible');
            // Add highlight to tour button
            if (tourBtn) tourBtn.classList.add('nudge-highlight');
            // Auto-dismiss after 10 seconds
            nudgeTimeout = setTimeout(hideTourNudge, 10000);
            // Reposition on window resize
            window.addEventListener('resize', positionNudge);
        }, 500);
    }

    function hideTourNudge() {
        if (tourNudge) {
            tourNudge.classList.remove('visible');
        }
        // Remove highlight from tour button
        const tourBtn = document.getElementById('railTourBtn');
        if (tourBtn) tourBtn.classList.remove('nudge-highlight');
        if (nudgeTimeout) {
            clearTimeout(nudgeTimeout);
            nudgeTimeout = null;
        }
    }

    // Close button
    if (tourNudgeClose) {
        tourNudgeClose.addEventListener('click', () => {
            hideTourNudge();
            sessionStorage.setItem('tourNudgeDismissed', 'true');
        });
    }

    // Also hide if user clicks the nudge itself (to start tour)
    if (tourNudge) {
        tourNudge.addEventListener('click', (e) => {
            if (e.target !== tourNudgeClose && !tourNudgeClose.contains(e.target)) {
                hideTourNudge();
                sessionStorage.setItem('tourNudgeDismissed', 'true');
                // Trigger the tour
                const railTourBtn = document.getElementById('railTourBtn');
                if (railTourBtn) railTourBtn.click();
            }
        });
    }

    // --- Global function to show tour welcome (called after fullscreen choice) ---
    window.showTourWelcome = function() {
        // Don't show if tour already completed
        if (localStorage.getItem('npp-tour-completed')) return;

        const tourOverlay = document.getElementById('tourOverlay');
        const tourDrawer = document.getElementById('tourDrawer');

        if (!tourOverlay || !tourDrawer) return;

        // Close any open info panels
        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        const countryInfoOverlay = document.getElementById('countryInfoOverlay');
        const countryInfoBox = document.getElementById('countryInfoBox');
        const plantInfoOverlay = document.getElementById('plantInfoOverlay');
        const plantInfoBox = document.getElementById('plantInfoBox');

        if (countryInfoOverlay) countryInfoOverlay.style.display = 'none';
        if (countryInfoBox) countryInfoBox.classList.remove('visible');
        if (plantInfoOverlay) plantInfoOverlay.style.display = 'none';
        if (plantInfoBox) plantInfoBox.classList.remove('visible');
        if (desktopSearchOverlay) desktopSearchOverlay.style.display = '';

        // Close any other open drawers first
        if (typeof window.closeMapRailDrawers === 'function') {
            window.closeMapRailDrawers();
        }

        // Show the dimmed overlay and open the tour drawer
        tourOverlay.classList.add('active');
        tourDrawer.classList.add('open');

        // Update rail button state if it exists
        const railTourBtn = document.getElementById('railTourBtn');
        if (railTourBtn) {
            railTourBtn.classList.add('active');
            railTourBtn.setAttribute('aria-expanded', 'true');
        }
    };

    // --- Desktop Fullscreen Prompt Overlay (v5.7.53 - Overlay Loading Fix) ---
    const desktopFsOverlay = document.getElementById('desktopFsOverlay');
    const fsOverlayLaunchBtn = document.getElementById('fsOverlayLaunchBtn');
    const fsOverlayDismissBtn = document.getElementById('fsOverlayDismissBtn');
    const mapShellOverlayEl = document.getElementById('map-shell');
    const mapWrapperOverlayEl = document.getElementById('map-wrapper');

    // v5.7.53: Function to reveal the map after overlay decision is made
    function revealMap() {
        if (mapShellOverlayEl) {
            mapShellOverlayEl.classList.add('map-ready');
        }
    }

    // v5.7.53: Check if we should skip showing the overlay
    function shouldSkipOverlay() {
        if (isEmbedMode) return true; // v5.7.164: Skip overlay in embed mode
        const isMobileViewport = window.matchMedia('(max-width: 600px)').matches ||
                                 window.matchMedia('(hover: none) and (pointer: coarse) and (max-width: 900px)').matches;
        if (isMobileViewport) return true;
        if (sessionStorage.getItem('desktopFsOverlayDismissed')) return true;
        if (isInFullscreenNow()) return true;
        if (!desktopFsOverlay) return true;
        return false;
    }

    function showDesktopFsOverlay() {
        // v5.7.53: Check skip conditions first
        if (shouldSkipOverlay()) {
            // Mark wrapper so CSS knows to show map immediately
            if (mapWrapperOverlayEl) {
                mapWrapperOverlayEl.classList.add('skip-overlay');
            }
            revealMap();
            return false; // Didn't show overlay
        }

        // Show the overlay immediately (no delay)
        desktopFsOverlay.classList.add('active');

        // v5.7.53: Reveal map behind the overlay after overlay is painted
        // Using double requestAnimationFrame ensures the overlay renders first
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                revealMap();
            });
        });

        return true; // Showed overlay
    }

    function hideDesktopFsOverlay() {
        if (desktopFsOverlay) {
            desktopFsOverlay.classList.remove('active');
        }
        // v5.7.53: Ensure map is visible when overlay hides
        revealMap();
    }

    // v5.7.53: Show overlay IMMEDIATELY on page load (no setTimeout delay!)
    const overlayWasShown = showDesktopFsOverlay();

    // Fallback: If fullscreen overlay was previously dismissed but tour hasn't been completed,
    // show the tour welcome modal directly (for returning visitors who haven't taken the tour)
    // v5.7.53: Only run this if we didn't show the overlay
    if (!overlayWasShown && !isEmbedMode) { // v5.7.164: Skip tour in embed mode
        setTimeout(() => {
            const isMobileViewport = window.matchMedia('(max-width: 600px)').matches ||
                                     window.matchMedia('(hover: none) and (pointer: coarse) and (max-width: 900px)').matches;
            const fsOverlayDismissedBefore = sessionStorage.getItem('desktopFsOverlayDismissed');
            const tourNotCompleted = !localStorage.getItem('npp-tour-completed');

            // If on desktop, fullscreen overlay won't show (already dismissed), and tour not done
            if (!isMobileViewport && fsOverlayDismissedBefore && tourNotCompleted) {
                if (typeof window.showTourWelcome === 'function') {
                    window.showTourWelcome();
                }
            }
        }, 500);
    }

    // Launch fullscreen button
    if (fsOverlayLaunchBtn) {
        fsOverlayLaunchBtn.addEventListener('click', () => {
            hideDesktopFsOverlay();
            sessionStorage.setItem('desktopFsOverlayDismissed', 'true');
            if (!isFullscreen) {
                toggleFullscreen();
                // Show tour welcome modal after entering fullscreen (give time for transition)
                setTimeout(() => {
                    if (typeof window.showTourWelcome === 'function') {
                        window.showTourWelcome();
                    }
                }, 1200);
            }
        });
    }

    // Dismiss button
    if (fsOverlayDismissBtn) {
        fsOverlayDismissBtn.addEventListener('click', () => {
            hideDesktopFsOverlay();
            sessionStorage.setItem('desktopFsOverlayDismissed', 'true');
            // Show tour welcome modal after user dismisses fullscreen prompt
            setTimeout(() => {
                if (typeof window.showTourWelcome === 'function') {
                    window.showTourWelcome();
                }
            }, 600);
        });
    }

    // REMOVED: Click-outside-to-dismiss and Escape key dismiss
    // The overlay now requires explicit user action (Launch or Dismiss button)
    // to encourage users to enter fullscreen mode

    // Hide overlay if fullscreen is entered by other means
    document.addEventListener('fullscreenchange', () => {
        if (isInFullscreenNow()) {
            hideDesktopFsOverlay();
            sessionStorage.setItem('desktopFsOverlayDismissed', 'true');
        }
    });
    document.addEventListener('webkitfullscreenchange', () => {
        if (isInFullscreenNow()) {
            hideDesktopFsOverlay();
            sessionStorage.setItem('desktopFsOverlayDismissed', 'true');
        }
    });

// --- 28. Deep Linking Module ---
// Enables shareable URLs: ?plant=Vogtle&year=2020&view=globe&country=France

(function initDeepLinkingModule() {
    'use strict';

    const DEEP_LINK_CONFIG = {
        URL_UPDATE_DELAY: 500,
        TRACK_MAP_POSITION: false,
        FLY_DURATION: 1500
    };

    let urlUpdateTimeout = null;
    let isProcessingDeepLink = false;
    let deepLinkProcessed = false;

    // --- URL Utilities ---
    function getUrlParams() {
        return new URLSearchParams(window.location.search);
    }

    function updateUrl(params, replace) {
        const url = new URL(window.location.href);
        // v5.7.138: Added filter params; v5.7.139: Removed cluster, sizeby
        const managedParams = ['plant', 'country', 'year', 'view', 'lat', 'lng', 'zoom', 'status', 'fullscreen', 'reactor',
            'operable', 'construction', 'planned', 'shutdown', 'capmin', 'capmax'];
        managedParams.forEach(function(p) { url.searchParams.delete(p); });
        
        Object.keys(params).forEach(function(key) {
            var value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                url.searchParams.set(key, value);
            }
        });
        
        var method = replace ? 'replaceState' : 'pushState';
        try {
            window.history[method]({ deepLink: params }, '', url.toString());
        } catch (e) {
            console.warn('[DeepLink] Could not update URL:', e);
        }
    }

    function debouncedUrlUpdate(params) {
        if (urlUpdateTimeout) clearTimeout(urlUpdateTimeout);
        urlUpdateTimeout = setTimeout(function() { updateUrl(params, true); }, DEEP_LINK_CONFIG.URL_UPDATE_DELAY);
    }

    function getCurrentState() {
        var state = {};
        
        if (typeof currentSelectedYear !== 'undefined' && currentSelectedYear !== MAX_YEAR) {
            state.year = currentSelectedYear;
        }
        // v5.7.138: Check both desktop and mobile plant selections
        if (typeof currentSelectedPlant !== 'undefined' && currentSelectedPlant) {
            state.plant = currentSelectedPlant.name;
        } else if (typeof currentMobilePlantSelection !== 'undefined' && currentMobilePlantSelection) {
            state.plant = currentMobilePlantSelection.name;
        }
        // v5.7.138: Check both desktop variable and mobile panel title for country
        if (typeof currentSelectedCountry !== 'undefined' && currentSelectedCountry) {
            state.country = currentSelectedCountry;
        } else {
            var countryPanelEl = document.getElementById('countryPanel');
            var countryTitleEl = countryPanelEl ? countryPanelEl.querySelector('.country-panel-title') : null;
            if (countryPanelEl && countryPanelEl.classList.contains('open') && countryTitleEl && countryTitleEl.textContent) {
                state.country = countryTitleEl.textContent;
            }
        }
        if (typeof isGlobeView !== 'undefined' && isGlobeView) {
            state.view = 'globe';
        } else if (typeof isSatelliteView !== 'undefined' && !isSatelliteView) {
            state.view = 'map';
        }
        // v5.7.71: Removed fullscreen from share URL - users should not receive fullscreen links

        // v5.7.138: Capture filter state (only include non-default values)
        // v5.7.139: Removed cluster and sizeby params
        if (typeof viewOptions !== 'undefined') {
            if (viewOptions.showOperable) state.operable = '1';
            if (viewOptions.showConstruction) state.construction = '1';
            if (viewOptions.showPlanned) state.planned = '1';
            if (viewOptions.showShutdown) state.shutdown = '1';
            if (viewOptions.capacityMin > 0) state.capmin = viewOptions.capacityMin;
            if (viewOptions.capacityMax < 10) state.capmax = viewOptions.capacityMax;
            // v5.7.150: Production range
            if (viewOptions.productionMin > 0) state.prodmin = viewOptions.productionMin;
            if (viewOptions.productionMax < 50) state.prodmax = viewOptions.productionMax;
        }

        return state;
    }

    function findPlantByName(name) {
        if (!name || typeof nuclearPlants === 'undefined') return null;
        var searchName = name.toLowerCase().trim();
        var plant = nuclearPlants.find(function(p) { return p.name && p.name.toLowerCase() === searchName; });
        if (!plant) {
            plant = nuclearPlants.find(function(p) { return p.name && p.name.toLowerCase().indexOf(searchName) !== -1; });
        }
        return plant || null;
    }

    // --- Deep Link Processing ---
    function processDeepLink() {
        if (deepLinkProcessed || isProcessingDeepLink) return;
        
        var params = getUrlParams();
        // v5.7.138: Added filter params to hasParams check
        // v5.7.164: Added embed param
        var hasParams = params.has('plant') || params.has('country') ||
                       params.has('year') || params.has('view') ||
                       params.has('lat') || params.has('fullscreen') ||
                       params.has('operable') || params.has('construction') ||
                       params.has('planned') || params.has('shutdown') ||
                       params.has('capmin') || params.has('capmax') ||
                       params.has('embed');

        if (!hasParams) {
            deepLinkProcessed = true;
            return;
        }

        isProcessingDeepLink = true;

        var actions = [];

        // v5.7.138: Parse and apply filter params FIRST (before year/plant/country)
        // v5.7.139: Removed cluster, sizeby
        var hasFilterParams = params.has('operable') || params.has('construction') ||
                              params.has('planned') || params.has('shutdown') ||
                              params.has('capmin') || params.has('capmax');

        if (hasFilterParams) {
            actions.push(function() {
                // Helper to sync filter checkbox across all 3 locations
                function syncCheckbox(baseId, checked) {
                    var el1 = document.getElementById(baseId);
                    var el2 = document.getElementById(baseId + 'Mobile');
                    var el3 = document.getElementById('filter' + baseId.charAt(0).toUpperCase() + baseId.slice(1));
                    if (el1) el1.checked = checked;
                    if (el2) el2.checked = checked;
                    if (el3) el3.checked = checked;
                }

                // Status filters
                if (params.get('operable') === '1') {
                    viewOptions.showOperable = true;
                    syncCheckbox('showOperable', true);
                }
                if (params.get('construction') === '1') {
                    viewOptions.showConstruction = true;
                    syncCheckbox('showConstruction', true);
                }
                if (params.get('planned') === '1') {
                    viewOptions.showPlanned = true;
                    syncCheckbox('showPlanned', true);
                }
                if (params.get('shutdown') === '1') {
                    viewOptions.showShutdown = true;
                    syncCheckbox('showShutdown', true);
                }

                // Capacity range (v5.7.142: add bounds checking for security hardening)
                var capmin = params.get('capmin');
                var capmax = params.get('capmax');
                if (capmin) viewOptions.capacityMin = Math.max(0, Math.min(10, parseFloat(capmin)));
                if (capmax) viewOptions.capacityMax = Math.max(0, Math.min(10, parseFloat(capmax)));
                // Sync capacity sliders if they exist
                if (typeof syncAllCapacitySliders === 'function') {
                    syncAllCapacitySliders();
                }

                // Production range (v5.7.150)
                var prodmin = params.get('prodmin');
                var prodmax = params.get('prodmax');
                if (prodmin) viewOptions.productionMin = Math.max(0, Math.min(50, parseFloat(prodmin)));
                if (prodmax) viewOptions.productionMax = Math.max(0, Math.min(50, parseFloat(prodmax)));
                if (typeof syncAllProductionSliders === 'function') {
                    syncAllProductionSliders();
                }

                // Update status bar to show active filters
                if (typeof updateStatusBarFilters === 'function') {
                    updateStatusBarFilters();
                }

                // v5.7.144: Re-render map with applied filters
                if (typeof updateMapForYear === 'function' && typeof currentSelectedYear !== 'undefined') {
                    updateMapForYear(currentSelectedYear);
                }
            });
        }
        
        // Year
        var yearParam = params.get('year');
        if (yearParam) {
            var year = parseInt(yearParam, 10);
            if (year >= MIN_YEAR && year <= MAX_YEAR) {
                actions.push(function() {
                    if (typeof yearSlider !== 'undefined') yearSlider.value = year;
                    if (typeof updateMapForYear === 'function') updateMapForYear(year);
                });
            }
        }
        
        // View mode
        var viewParam = params.get('view')?.substring(0, 20) || null;
        if (viewParam) {
            actions.push(function() {
                // v5.7.182: switchToGlobeView / switchToMapView never existed, so ?view= was a
                // silent no-op for globe and left the boundaries overlay on for map. Route through
                // the real toggles instead.
                switch (viewParam.toLowerCase()) {
                    case 'globe':
                        if (!isGlobeView && typeof toggleGlobeView === 'function') {
                            syncViewModeSelection('globe');
                            toggleGlobeView();
                        }
                        break;
                    case 'map':
                        if (isGlobeView) toggleGlobeView();
                        if (isSatelliteView) toggleSatelliteView();
                        syncViewModeSelection('map');
                        break;
                    case 'satellite':
                        if (isGlobeView) toggleGlobeView();
                        if (!isSatelliteView) toggleSatelliteView();
                        syncViewModeSelection('satellite');
                        break;
                }
            });
        }
        
        // Fullscreen
        if (params.get('fullscreen') === '1') {
            actions.push(function() {
                if (typeof toggleFullscreen === 'function' && typeof isFullscreen !== 'undefined' && !isFullscreen) {
                    setTimeout(toggleFullscreen, 100);
                }
            });
        }
        
        // Plant
        var plantParam = params.get('plant')?.substring(0, 200) || null;
        var reactorParam = params.get('reactor')?.substring(0, 200) || null;
        if (plantParam) {
            actions.push(function() {
                var plant = findPlantByName(decodeURIComponent(plantParam));
                if (plant && typeof zoomToPlant === 'function') {
                    var reactorName = reactorParam ? decodeURIComponent(reactorParam) : null;
                    zoomToPlant(plant, reactorName);
                } else {
                    console.warn('[DeepLink] Plant not found:', plantParam);
                }
            });
        }
        
        // Country (if no plant)
        var countryParam = params.get('country')?.substring(0, 100) || null;
        if (countryParam && !plantParam) {
            actions.push(function() {
                if (typeof zoomToCountry === 'function') {
                    var decodedCountry = decodeURIComponent(countryParam);
                    var matchedCountry = allCountries.find(function(c) { return c.toLowerCase() === decodedCountry.toLowerCase(); });
                    if (matchedCountry) zoomToCountry(matchedCountry);
                }
            });
        }
        
        // Map position (if no plant/country)
        var latParam = params.get('lat');
        var lngParam = params.get('lng');
        var zoomParam = params.get('zoom');
        if (latParam && lngParam && !plantParam && !countryParam) {
            actions.push(function() {
                var lat = parseFloat(latParam);
                var lng = parseFloat(lngParam);
                // The URL contract stays in LEAFLET units so existing shared links keep
                // working; it is converted here on read. parseFloat, not parseInt, so
                // fractional zooms in a link survive.
                var zoom = zoomParam ? parseFloat(zoomParam) : 6;
                if (!isNaN(lat) && !isNaN(lng) && typeof map !== 'undefined') {
                    map.flyTo({ center: [lng, lat], zoom: zoom - 1, duration: 1500, essential: true });
                }
            });
        }
        
        // v5.7.140: Helper to clear URL params after deep link loads
        function clearUrlParams() {
            // v5.7.164: Never clear params in embed mode (they define the embed state)
            if (new URLSearchParams(window.location.search).has('embed')) return;
            setTimeout(function() {
                try {
                    var cleanUrl = window.location.pathname;
                    window.history.replaceState({}, '', cleanUrl);
                } catch (e) {
                    console.warn('[DeepLink] Could not clear URL params:', e);
                }
            }, 100);
        }

        // Execute actions with delays
        var delay = 500;
        actions.forEach(function(action, index) {
            setTimeout(function() {
                try { action(); } catch (e) { console.error('[DeepLink] Error:', e); }
                if (index === actions.length - 1) {
                    isProcessingDeepLink = false;
                    deepLinkProcessed = true;
                    clearUrlParams(); // v5.7.140: Clear params to prevent misleading URLs
                }
            }, delay);
            delay += 300;
        });

        if (actions.length === 0) {
            isProcessingDeepLink = false;
            deepLinkProcessed = true;
            clearUrlParams(); // v5.7.140: Clear params even if no actions
        }
    }

    // --- State Listeners ---
    function setupStateListeners() {
        // v5.7.139: Removed year slider URL update - URL only changes via share button

        window.addEventListener('popstate', function(event) {
            if (event.state && event.state.deepLink) {
                deepLinkProcessed = false;
                processDeepLink();
            }
        });
    }

    // --- Public API ---
    // Expose chart drawing function for theme changes
    window.drawLineChartOnCanvas = drawLineChartOnCanvas;
    
    window.generatePlantUrl = function(plant, year) {
        var url = new URL(window.location.href);
        url.search = '';
        if (plant && plant.name) url.searchParams.set('plant', plant.name);
        if (year && year !== MAX_YEAR) url.searchParams.set('year', year);
        return url.toString();
    };

    window.generateCountryUrl = function(countryName, year) {
        var url = new URL(window.location.href);
        url.search = '';
        if (countryName) url.searchParams.set('country', countryName);
        if (year && year !== MAX_YEAR) url.searchParams.set('year', year);
        return url.toString();
    };

    window.generateShareUrl = function() {
        var url = new URL(window.location.href);
        var state = getCurrentState();
        url.search = '';
        Object.keys(state).forEach(function(key) {
            var value = state[key];
            if (value !== null && value !== undefined && value !== '') {
                url.searchParams.set(key, value);
            }
        });
        return url.toString();
    };

    window.copyShareUrl = function() {
        var url = window.generateShareUrl();
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(url).then(function() {
                return true;
            }).catch(function() {
                return fallbackCopy(url);
            });
        } else {
            return Promise.resolve(fallbackCopy(url));
        }
        
        function fallbackCopy(text) {
            var textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.cssText = 'position:fixed;opacity:0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                document.body.removeChild(textarea);
                return true;
            } catch (e) {
                document.body.removeChild(textarea);
                return false;
            }
        }
    };

    window.updateDeepLinkUrl = function() {
        if (!isProcessingDeepLink) updateUrl(getCurrentState(), true);
    };

    window.initDeepLinking = function() {
        processDeepLink();
        setupStateListeners();
    };

    // Auto-initialize after a delay to ensure map is ready
    setTimeout(function() {
        if (typeof nuclearPlants !== 'undefined' && nuclearPlants.length > 0) {
            window.initDeepLinking();
        }
    }, 1000);

})();

// --- v5.7.164: Embed Mode Initialization ---
if (isEmbedMode) {
    setTimeout(function() {
        try {
            var embedParams = new URLSearchParams(window.location.search);
            var embedCountry = embedParams.get('country');
            var embedYear = embedParams.has('year') ? parseInt(embedParams.get('year'), 10) : MAX_YEAR;
            if (isNaN(embedYear) || embedYear < MIN_YEAR || embedYear > MAX_YEAR) embedYear = MAX_YEAR;

            // Set year if not default
            if (embedYear !== currentSelectedYear) {
                updateMapForYear(embedYear);
                var slider = document.getElementById('yearSlider');
                if (slider) slider.value = embedYear;
            }

            var statsBar = document.getElementById('embedStatsBar');
            var countryNameEl = document.getElementById('embedCountryName');
            var operableEl = document.getElementById('embedOperable');
            var constructionEl = document.getElementById('embedConstruction');
            var plannedEl = document.getElementById('embedPlanned');
            var shutdownEl = document.getElementById('embedShutdown');
            var capacityEl = document.getElementById('embedCapacity');
            var exploreLinkEl = document.getElementById('embedExploreLink');

            if (embedCountry) {
                // Country-specific embed
                var stats = generateCountryStats(embedCountry, embedYear, false);
                if (countryNameEl) countryNameEl.textContent = embedCountry;
                if (operableEl) operableEl.textContent = stats.operableReactors || 0;
                if (constructionEl) constructionEl.textContent = stats.constructionReactors || 0;
                if (plannedEl) plannedEl.textContent = stats.plannedReactors || 0;
                if (shutdownEl) shutdownEl.textContent = stats.shutdownReactors || 0;
                var capGW = ((stats.operableCapacity || 0) / 1000).toFixed(1);
                if (capacityEl) capacityEl.textContent = capGW + ' GW';
                if (exploreLinkEl) {
                    var exploreUrl = window.location.pathname + '?country=' + encodeURIComponent(embedCountry);
                    exploreLinkEl.href = exploreUrl;
                }

                // Zoom to country bounds
                var countryPlants = nuclearPlants.filter(function(p) {
                    return p.country === embedCountry && getPlantStatusForYear(p, embedYear) !== null;
                });
                if (countryPlants.length > 0) {
                    map.fitBounds(plantsBounds(countryPlants), { padding: 40, maxZoom: COUNTRY_MAX_ZOOM_2D, duration: 0 });
                }
            } else {
                // Global embed — show worldwide stats
                if (countryNameEl) countryNameEl.textContent = 'Global';
                var totalOperable = 0, totalConstruction = 0, totalPlanned = 0, totalShutdown = 0, totalCap = 0;
                nuclearPlants.forEach(function(plant) {
                    var ps = getPlantStatusForYear(plant, embedYear);
                    if (ps) {
                        totalOperable += (ps.stats && ps.stats.operable) || 0;
                        totalConstruction += (ps.stats && ps.stats.construction) || 0;
                        totalPlanned += (ps.stats && ps.stats.planned) || 0;
                        totalShutdown += (ps.stats && ps.stats.shutdown) || 0;
                        // Sum capacity of operable reactors
                        if (ps.activeReactors) {
                            ps.activeReactors.forEach(function(r) {
                                if (r.status === 'Operable') totalCap += (r.capacity || 0);
                            });
                        }
                    }
                });
                if (operableEl) operableEl.textContent = totalOperable;
                if (constructionEl) constructionEl.textContent = totalConstruction;
                if (plannedEl) plannedEl.textContent = totalPlanned;
                if (shutdownEl) shutdownEl.textContent = totalShutdown;
                if (capacityEl) capacityEl.textContent = (totalCap / 1000).toFixed(1) + ' GW';
                if (exploreLinkEl) exploreLinkEl.href = window.location.pathname;
            }
        } catch (e) {
            console.error('[Embed] Init error:', e);
        }
    }, 1200);
}

// --- Share Button Handler ---
(function initShareButton() {
    function showShareToast(message, isError) {
        var existing = document.querySelector('.share-toast');
        if (existing) existing.remove();
        
        var toast = document.createElement('div');
        toast.className = 'share-toast' + (isError ? ' error' : '');
        toast.innerHTML = 
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            (isError 
                ? '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>'
                : '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>') +
            '</svg>' +
            '<span>' + message + '</span>';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');

        // In native fullscreen, only the fullscreen element subtree is rendered.
        // Append the toast inside it so the message is visible in fullscreen too.
        var toastHost = document.fullscreenElement || document.body;
        toastHost.appendChild(toast);

        // Try to anchor the toast near the Share button so it’s always in-view.
        // Fallback to the default CSS position (top-center) if the button isn’t found.
        var anchor = document.getElementById('shareButton');
        if (anchor && toast.style) {
            // Anchor the toast adjacent to the Share button (no slide-in animation)
            toast.classList.add('anchored');

            var rect = anchor.getBoundingClientRect();

            // Force a layout read so width/height are available for clamping.
            var toastRect = toast.getBoundingClientRect();

            var margin = 12;
            var gap = 10;

            // Vertically center next to the button
            var top = rect.top + (rect.height / 2) - (toastRect.height / 2);
            top = Math.max(margin, Math.min(window.innerHeight - margin - toastRect.height, top));

            // Prefer to the right of the button; if not enough room, place to the left.
            var left = rect.right + gap;
            if (left + toastRect.width + margin > window.innerWidth) {
                left = rect.left - gap - toastRect.width;
            }
            left = Math.max(margin, Math.min(window.innerWidth - margin - toastRect.width, left));

            toast.style.top = top + 'px';
            toast.style.left = left + 'px';
            toast.style.right = 'auto';
            toast.style.bottom = 'auto';
        }

        requestAnimationFrame(function() { toast.classList.add('visible'); });
        setTimeout(function() {
            toast.classList.remove('visible');
            setTimeout(function() { toast.remove(); }, 300);
        }, 2500);
    }

    function isLikelyMobileShare() {
        // Prefer the native share sheet on mobile/tablet; desktop share sheets can be slow
        return window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    }

    var shareBtn = document.getElementById('shareButton');
    if (shareBtn) {
        shareBtn.addEventListener('click', function() {
            var url = window.generateShareUrl ? window.generateShareUrl() : window.location.href;
            
            // Try native share API first (mobile)
            if (navigator.share && isLikelyMobileShare()) {
                navigator.share({
                    title: 'Nuclear Power Plants Map',
                    text: 'Check out this view of nuclear power plants around the world',
                    url: url
                }).catch(function(err) {
                    if (err.name !== 'AbortError') {
                        // Fall through to clipboard
                        copyToClipboard();
                    }
                });
                return;
            }
            
            // Fallback to clipboard
            copyToClipboard();
            
            function copyToClipboard() {
                var copyPromise = window.copyShareUrl ? window.copyShareUrl() : Promise.resolve(false);
                if (copyPromise && typeof copyPromise.then === 'function') {
                    copyPromise.then(function(success) {
                        showShareToast(success ? 'Link copied to clipboard!' : 'Failed to copy link', !success);
                        if (success) {
                            shareBtn.classList.add('copied');
                            setTimeout(function(){ shareBtn.classList.remove('copied'); }, 1200);
                        }
                    });
                } else {
                    showShareToast(copyPromise ? 'Link copied to clipboard!' : 'Failed to copy link', !copyPromise);
                    if (copyPromise) {
                        shareBtn.classList.add('copied');
                        setTimeout(function(){ shareBtn.classList.remove('copied'); }, 1200);
                    }
                }
            }
        });
    }
})();

// --- Dark Mode Toggle ---
(function initDarkMode() {
    const toggle = document.getElementById('darkModeToggle');
    const html = document.documentElement;
    const btn = document.getElementById('darkModeBtn');
    
    // Check for saved preference (explicit default is Light mode)
    function getPreferredTheme() {
        // Default view on all devices: Dark mode OFF (Light).
        // Only use Dark if the user has explicitly chosen it before.
        let saved = null;
        try { saved = localStorage.getItem('theme'); } catch (e) {}
        if (saved === 'dark' || saved === 'light') return saved;
        return 'light';
    }


    // Apply theme
    function setTheme(theme, options) {
        options = options || {};
        const persist = options.persist !== false;
        html.setAttribute('data-theme', theme);
        if (persist) {
            localStorage.setItem('theme', theme);
        }

        // Update toggle checkbox state
        if (toggle) {
            toggle.checked = theme === 'dark';
        }
        

        // Update fullscreen (mobile) button state
        if (btn) {
            btn.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
            btn.classList.toggle('active', theme === 'dark');
            btn.title = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
        }
        // Redraw any visible charts with new theme colors
        setTimeout(function() {
            // Trigger redraw of production charts
            const countryProductionChart = document.getElementById('countryProductionChart');
            const plantProductionChart = document.getElementById('plantProductionChart');
            
            if (countryProductionChart && countryProductionChart._productionChartData) {
                const data = countryProductionChart._productionChartData;
                if (typeof drawLineChartOnCanvas === 'function') {
                    drawLineChartOnCanvas(countryProductionChart, data.years, data.values, null);
                }
            }
            
            if (plantProductionChart && plantProductionChart._productionChartData) {
                const data = plantProductionChart._productionChartData;
                if (typeof drawLineChartOnCanvas === 'function') {
                    drawLineChartOnCanvas(plantProductionChart, data.years, data.values, null);
                }
            }
            
            // Dispatch a custom event that other components can listen to
            window.dispatchEvent(new CustomEvent('themechange', { detail: { theme: theme } }));
        }, 50);
    }
    
    // Initialize theme
    const initialTheme = getPreferredTheme();
    const mapWrapper = document.getElementById('map-wrapper');

    function isDesktopViewport() {
        return window.matchMedia ? window.matchMedia('(min-width: 901px)').matches : (window.innerWidth > 900);
    }

    function isMapFullscreen() {
        return !!(
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement ||
            (mapWrapper && (mapWrapper.classList.contains('fullscreen') || mapWrapper.classList.contains('browser-fullscreen')))
        );
    }

    function desktopDarkAllowed() {
        // Desktop: dark mode is only available while in fullscreen.
        return !(isDesktopViewport() && !isMapFullscreen());
    }

    function updateDarkModeControlState() {
        const desktopLocked = (isDesktopViewport() && !isMapFullscreen());
        const option = document.getElementById('darkModeOption');
        const railThemeBtn = document.getElementById('railThemeBtn');
        const themeDrawer = document.getElementById('themeDrawer');
        const themeDrawerBody = themeDrawer ? themeDrawer.querySelector('.map-drawer-body') : null;

        if (toggle) {
            toggle.disabled = desktopLocked;
            toggle.setAttribute('aria-disabled', desktopLocked ? 'true' : 'false');
            if (desktopLocked) {
                toggle.checked = false;
            } else {
                toggle.checked = (html.getAttribute('data-theme') === 'dark');
            }
        }
        if (option) {
            option.classList.toggle('disabled', desktopLocked);
            option.title = desktopLocked ? 'Dark mode is available in fullscreen on desktop.' : '';
        }
        if (btn) {
            // The "Dark mode" map control is primarily for fullscreen/mobile; keep it inert when locked.
            btn.disabled = desktopLocked;
            btn.style.opacity = desktopLocked ? '0.45' : '';
            btn.style.pointerEvents = desktopLocked ? 'none' : '';
        }
        
        // Handle rail theme button disable state
        if (railThemeBtn) {
            if (desktopLocked) {
                railThemeBtn.classList.add('theme-disabled');
                railThemeBtn.disabled = true;
                railThemeBtn.title = 'Theme (available in fullscreen only)';
                // Close the theme drawer if it's open when becoming disabled
                if (themeDrawer && themeDrawer.classList.contains('open')) {
                    if (typeof window.closeMapRailDrawers === 'function') {
                        window.closeMapRailDrawers();
                    }
                }
            } else {
                railThemeBtn.classList.remove('theme-disabled');
                railThemeBtn.disabled = false;
                railThemeBtn.title = 'Theme';
            }
        }
        
        // Handle theme drawer body disable state
        if (themeDrawerBody) {
            themeDrawerBody.classList.toggle('theme-disabled', desktopLocked);
        }

        // Force light when locked, but do not overwrite the saved preference.
        if (desktopLocked && html.getAttribute('data-theme') === 'dark') {
            setTheme('light', { persist: false });
        }
    }

    // Apply initial theme respecting desktop non-fullscreen rule.
    if (isDesktopViewport() && !isMapFullscreen()) {
        setTheme('light', { persist: false });
    } else {
        setTheme(initialTheme);
    }
    updateDarkModeControlState();

    // Keep availability synced with viewport/fullscreen changes
    document.addEventListener('fullscreenchange', updateDarkModeControlState);
    document.addEventListener('webkitfullscreenchange', updateDarkModeControlState);
    window.addEventListener('resize', updateDarkModeControlState, { passive: true });

    // Handle toggle change (checkbox)
    if (toggle) {
        toggle.addEventListener('change', function() {
            if (!desktopDarkAllowed()) {
                toggle.checked = false;
                setTheme('light', { persist: false });
                return;
            }
            const newTheme = toggle.checked ? 'dark' : 'light';
            setTheme(newTheme);
        });
    }



// Handle fullscreen (mobile) dark mode button click
    if (btn) {
        btn.addEventListener('click', function() {
            if (!desktopDarkAllowed()) {
                setTheme('light', { persist: false });
                return;
            }
            const current = html.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
            setTheme(current === 'dark' ? 'light' : 'dark');
            updateDarkModeControlState();
        });
    }


// System theme changes are intentionally ignored.
// Default is Light (Dark mode OFF) unless the user explicitly toggles Dark.

    // Expose a minimal theme API for other parts of the app (e.g., fullscreen handlers)
    window.__WNATheme = {
        setTheme: setTheme,
        getPreferredTheme: getPreferredTheme,
        getTheme: function() {
            return html.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
        },
        updateDarkModeAvailability: function() {
            if (typeof updateDarkModeControlState === 'function') updateDarkModeControlState();
        },
        desktopDarkAllowed: function() {
            if (typeof desktopDarkAllowed === 'function') return desktopDarkAllowed();
            return true;
        }
    };
})();

// ===== Tour API Bridge (v5.7.121) =====
// Expose closure-scoped functions the tour needs for interactive demos
window.__tourAPI = {
    zoomToCountry: typeof zoomToCountry === 'function' ? zoomToCountry : null,
    zoomToPlant: typeof zoomToPlant === 'function' ? zoomToPlant : null,
    showCountryInfoOverlay: typeof showCountryInfoOverlay === 'function' ? showCountryInfoOverlay : null,
    hideCountryInfoOverlay: typeof hideCountryInfoOverlay === 'function' ? hideCountryInfoOverlay : null,
    showPlantInfoOverlay: typeof showPlantInfoOverlay === 'function' ? showPlantInfoOverlay : null,
    hidePlantInfoOverlay: typeof hidePlantInfoOverlay === 'function' ? hidePlantInfoOverlay : null,
    closePlantDetailModal: typeof closePlantDetailModal === 'function' ? closePlantDetailModal : null,
    updateMapForYear: typeof updateMapForYear === 'function' ? updateMapForYear : null,
    clearSearch: typeof clearSearch === 'function' ? clearSearch : null,
    clearSearchHighlight: typeof clearSearchHighlight === 'function' ? clearSearchHighlight : null,
    navClear: typeof navClear === 'function' ? navClear : null,
    map: typeof map !== 'undefined' ? map : null,
    goHome: typeof goHome === 'function' ? goHome : null,
    nuclearPlants: typeof nuclearPlants !== 'undefined' ? nuclearPlants : [],
    HOME_COORDS: typeof HOME_COORDS !== 'undefined' ? HOME_COORDS : [25, 0],
    HOME_ZOOM: typeof HOME_ZOOM !== 'undefined' ? HOME_ZOOM : 2,
    // v5.7.148: Filter state save/restore for tour
    getFilterState: function() {
        return {
            showOperable: viewOptions.showOperable,
            showConstruction: viewOptions.showConstruction,
            showPlanned: viewOptions.showPlanned,
            showShutdown: viewOptions.showShutdown,
            capacityMin: viewOptions.capacityMin,
            capacityMax: viewOptions.capacityMax,
            productionMin: viewOptions.productionMin,  // v5.7.150
            productionMax: viewOptions.productionMax,  // v5.7.150
            year: currentSelectedYear
        };
    },
    setFilterState: function(state) {
        if (!state) return;
        viewOptions.showOperable = !!state.showOperable;
        viewOptions.showConstruction = !!state.showConstruction;
        viewOptions.showPlanned = !!state.showPlanned;
        viewOptions.showShutdown = !!state.showShutdown;
        viewOptions.capacityMin = typeof state.capacityMin === 'number' ? state.capacityMin : CAPACITY_SLIDER_MIN;
        viewOptions.capacityMax = typeof state.capacityMax === 'number' ? state.capacityMax : CAPACITY_SLIDER_MAX;
        viewOptions.productionMin = typeof state.productionMin === 'number' ? state.productionMin : PRODUCTION_SLIDER_MIN; // v5.7.150
        viewOptions.productionMax = typeof state.productionMax === 'number' ? state.productionMax : PRODUCTION_SLIDER_MAX; // v5.7.150
        // Sync all 12 status checkboxes (4 statuses x 3 DOM locations)
        [['showOperable','showOperableMobile','filterShowOperable', state.showOperable],
         ['showConstruction','showConstructionMobile','filterShowConstruction', state.showConstruction],
         ['showPlanned','showPlannedMobile','filterShowPlanned', state.showPlanned],
         ['showShutdown','showShutdownMobile','filterShowShutdown', state.showShutdown]
        ].forEach(function(m) {
            for (var i = 0; i < 3; i++) { var cb = document.getElementById(m[i]); if (cb) cb.checked = !!m[3]; }
        });
        syncAllCapacitySliders();
        syncAllProductionSliders(); // v5.7.150
        if (typeof window.syncFilterPanelState === 'function') window.syncFilterPanelState();
        var yearVal = typeof state.year === 'number' ? state.year : MAX_YEAR;
        var slider = document.getElementById('yearSlider');
        if (slider) slider.value = yearVal;
        updateMapForYear(yearVal);
        updateStatusBarFilters();
    },
    // v5.7.149: Expanded chart open/close for tour
    openExpandedChart: typeof openExpandedChart === 'function' ? openExpandedChart : null,
    closeExpandedChart: typeof closeExpandedChart === 'function' ? closeExpandedChart : null
};

// ===== Tour Feature =====
(function initTour() {
    const TOUR_STORAGE_KEY = 'npp-tour-completed';
    const isMobile = window.matchMedia('(max-width: 600px)').matches;

    // Tour step icons (SVG paths)
    const icons = {
        search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>',
        legend: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>',
        filter: '<svg viewBox="0 0 24 24"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>',
        timeline: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>',
        fullscreen: '<svg viewBox="0 0 24 24"><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></svg>',
        done: '<svg viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>',
        info: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4M12 8h.01"></path></svg>',
        stats: '<svg viewBox="0 0 24 24"><rect x="3" y="12" width="4" height="9" rx="1"></rect><rect x="10" y="7" width="4" height="14" rx="1"></rect><rect x="17" y="3" width="4" height="18" rx="1"></rect></svg>'
    };

    // Desktop tour steps (v5.7.123: spotlight timing fixes, Global Statistics step; v5.7.124: two-phase spotlight, smooth step transitions, step reorder)
    const isFullscreen = function() {
        const mw = document.getElementById('map-wrapper');
        return mw && mw.classList.contains('fullscreen');
    };

    const desktopSteps = [
        {
            target: '#desktopSearchOverlay .search-wrapper',
            title: 'Search',
            desc: 'Search for nuclear power plants by name or country. Results appear as you type. Let\u2019s see it in action\u2026',
            icon: icons.search,
            position: 'right'
        },
        {
            // Step 2: Interactive search demo (v5.7.122: cursor, v5.7.124: two-phase spotlight expansion)
            target: '#desktopSearchOverlay .search-wrapper',
            retarget: '#countryInfoOverlay',
            title: 'Search in Action',
            desc: 'Watch as we search for France\u2026',
            retargetDesc: 'The country info panel shows reactor counts, capacity, plants, and \u2013 in fullscreen \u2013 electricity production and deployment charts for the selected country.',
            retargetTitle: 'Country Information',
            icon: icons.search,
            position: 'right',
            blockNext: true,
            onEnter: function(done) {
                var api = window.__tourAPI || {};
                var input = document.getElementById('searchInput');
                if (!input) { done(); return; }

                input.value = '';
                var text = 'France';
                var charIndex = 0;

                // v5.7.122: Cursor moves to search input first
                moveCursorTo(input, function() {
                    cursorClick(function() {
                        // Focus and add typing cursor effect
                        input.focus();
                        input.classList.add('tour-typing-cursor');

                        // Start typing after a short delay
                        demoTimers.push(setTimeout(function() {
                            demoTimers.push(setInterval(function() {
                                if (charIndex >= text.length) {
                                    clearInterval(demoTimers[demoTimers.length - 1]);
                                    input.classList.remove('tour-typing-cursor');

                                    // Wait for search results to render
                                    demoTimers.push(setTimeout(function() {
                                        var resultsBox = document.getElementById('searchResults');
                                        var firstResult = resultsBox ? resultsBox.querySelector('.result-item') : null;

                                        // v5.7.124: First expansion - spotlight grows to encompass search input + results dropdown
                                        var wrapperEl = document.querySelector('#desktopSearchOverlay .search-wrapper');
                                        if (wrapperEl && resultsBox && resultsBox.offsetHeight > 0) {
                                            var wr = wrapperEl.getBoundingClientRect();
                                            var rr = resultsBox.getBoundingClientRect();
                                            var unionRect = {
                                                top: Math.min(wr.top, rr.top),
                                                left: Math.min(wr.left, rr.left),
                                                width: Math.max(wr.right, rr.right) - Math.min(wr.left, rr.left),
                                                height: Math.max(wr.bottom, rr.bottom) - Math.min(wr.top, rr.top),
                                                right: Math.max(wr.right, rr.right),
                                                bottom: Math.max(wr.bottom, rr.bottom)
                                            };
                                            spotlight.classList.add('retarget');
                                            positionSpotlight(unionRect);
                                            positionCard(unionRect, 'right');
                                        }

                                        // v5.7.124: Wait for first expansion animation, then proceed with result interaction
                                        demoTimers.push(setTimeout(function() {
                                            spotlight.classList.remove('retarget');

                                            if (firstResult) {
                                                // v5.7.122: Cursor moves to first result then clicks
                                                moveCursorTo(firstResult, function() {
                                                    firstResult.classList.add('tour-result-flash');
                                                    cursorClick(function() {
                                                        hideCursor();
                                                        if (resultsBox) resultsBox.style.display = 'none';

                                                        if (api.zoomToCountry) {
                                                            api.zoomToCountry('France');
                                                        }

                                                        // v5.7.123: Poll for country info overlay instead of flat 2s wait
                                                        // v5.7.124: Second expansion - spotlight moves to country info overlay
                                                        pollForVisible('#countryInfoBox', 'visible', function() {
                                                            var step = steps[currentStep];
                                                            if (!step || !step.retarget) { done(); return; }

                                                            cardTitle.textContent = step.retargetTitle || step.title;
                                                            cardDesc.textContent = step.retargetDesc || step.desc;

                                                            spotlight.classList.add('retarget');
                                                            var newRect = getTargetRect(step.retarget);
                                                            positionSpotlight(newRect);
                                                            positionCard(newRect, step.position);

                                                            demoTimers.push(setTimeout(function() {
                                                                spotlight.classList.remove('retarget');
                                                                done();
                                                            }, 800));
                                                        });
                                                    });
                                                });
                                            } else {
                                                // No results found, proceed anyway
                                                hideCursor();
                                                if (resultsBox) resultsBox.style.display = 'none';
                                                if (api.zoomToCountry) api.zoomToCountry('France');
                                                // v5.7.123: Poll for country info overlay instead of flat 2s wait
                                                pollForVisible('#countryInfoBox', 'visible', function() {
                                                    var step = steps[currentStep];
                                                    if (!step || !step.retarget) { done(); return; }
                                                    cardTitle.textContent = step.retargetTitle || step.title;
                                                    cardDesc.textContent = step.retargetDesc || step.desc;
                                                    spotlight.classList.add('retarget');
                                                    var newRect = getTargetRect(step.retarget);
                                                    positionSpotlight(newRect);
                                                    positionCard(newRect, step.position);
                                                    demoTimers.push(setTimeout(function() {
                                                        spotlight.classList.remove('retarget');
                                                        done();
                                                    }, 800));
                                                });
                                            }
                                        }, 800));
                                    }, 500));
                                    return;
                                }
                                input.value += text[charIndex];
                                charIndex++;
                                input.dispatchEvent(new Event('input', { bubbles: true }));
                            }, 80));
                        }, 400));
                    });
                });
            },
            // v5.7.124: Conditional cleanup - leave country overlay when advancing to Explore Plants step
            onLeave: function(nextIdx) {
                var api = window.__tourAPI || {};
                hideCursor();
                var input = document.getElementById('searchInput');
                if (input) input.classList.remove('tour-typing-cursor');

                // Check if advancing to Explore Plants step for seamless transition
                var effective = getEffectiveSteps();
                var nextStep = nextIdx !== undefined ? effective[nextIdx] : null;
                var goingToExplore = nextStep && nextStep.title === 'Explore Plants';

                // Clear search state in all cases
                if (api.clearSearch) api.clearSearch();
                if (api.clearSearchHighlight) api.clearSearchHighlight();
                if (api.navClear) api.navClear();

                if (!goingToExplore) {
                    // Full cleanup when going backward or to any other step
                    if (api.hideCountryInfoOverlay) api.hideCountryInfoOverlay();
                    if (api.goHome) api.goHome(1200);
                }
                // When goingToExplore: leave country overlay and map position for step 3
            }
        },
        {
            // Step 3: Country to Plant Navigation (v5.7.123: pollForVisible, demoTargetOverride, toggle reposition; v5.7.124: initial target changed to countryInfoOverlay)
            target: '#countryInfoOverlay',
            retarget: '#plantDetailModal .plant-detail-dialog',
            title: 'Explore Plants',
            desc: 'Watch as we navigate from France\u2019s country overview to explore a specific plant\u2026',
            retargetTitle: 'Plant Detail',
            retargetDesc: 'The plant info panel shows reactor status, electricity production charts, reactor timelines, and links to the latest World Nuclear News stories.',
            icon: icons.info,
            position: 'right',
            blockNext: true,
            onEnter: function(done) {
                var api = window.__tourAPI || {};
                var fsWrapper = document.getElementById('map-wrapper');
                var isFsMode = fsWrapper && fsWrapper.classList.contains('fullscreen');

                // Zoom to France (opens country overlay and centers map)
                if (api.zoomToCountry) {
                    api.zoomToCountry('France');
                }

                // v5.7.123: Poll for country info overlay instead of flat 2s wait
                pollForVisible('#countryInfoBox', 'visible', function() {
                    // Reposition spotlight on country overlay
                    var coRect = getTargetRect('#countryInfoOverlay');
                    positionSpotlight(coRect);
                    positionCard(coRect, 'right');

                    // v5.7.123: Set override so scroll/resize handlers track the overlay
                    demoTargetOverride = '#countryInfoOverlay';

                    // v5.7.122: Cursor moves to plants toggle then clicks
                    demoTimers.push(setTimeout(function() {
                        var toggle = document.getElementById('countryInfoPlantsToggle');
                        if (!toggle) { demoTargetOverride = null; done(); return; }

                        moveCursorTo(toggle, function() {
                            cursorClick(function() {
                                if (!toggle.classList.contains('expanded')) {
                                    toggle.click();
                                }

                                // v5.7.123: Reposition spotlight after toggle expands the plants list
                                demoTimers.push(setTimeout(function() {
                                    var expandedRect = getTargetRect('#countryInfoOverlay');
                                    positionSpotlight(expandedRect);
                                    positionCard(expandedRect, 'right');
                                }, 350));

                                // After list animation, find and highlight Gravelines
                                demoTimers.push(setTimeout(function() {
                                    var plantsList = document.getElementById('countryInfoPlantsList');
                                    var gravelinesItem = null;
                                    if (plantsList) {
                                        var items = plantsList.querySelectorAll('.country-info-plant-item');
                                        for (var i = 0; i < items.length; i++) {
                                            if (items[i].dataset.plant === 'Gravelines') {
                                                gravelinesItem = items[i];
                                                break;
                                            }
                                        }
                                    }

                                    if (!gravelinesItem) { hideCursor(); demoTargetOverride = null; done(); return; }

                                    // Scroll Gravelines into view
                                    gravelinesItem.scrollIntoView({ behavior: 'smooth', block: 'center' });

                                    // Cursor moves to Gravelines then clicks
                                    demoTimers.push(setTimeout(function() {
                                        moveCursorTo(gravelinesItem, function() {
                                            gravelinesItem.classList.add('tour-result-flash');
                                            cursorClick(function() {
                                                gravelinesItem.classList.remove('tour-result-flash');
                                                hideCursor();

                                                // v5.7.123: Clear override before transitioning to plant detail
                                                demoTargetOverride = null;

                                                // Navigate to the plant
                                                var plant = null;
                                                if (api.nuclearPlants) {
                                                    for (var j = 0; j < api.nuclearPlants.length; j++) {
                                                        if (api.nuclearPlants[j].name === 'Gravelines') {
                                                            plant = api.nuclearPlants[j];
                                                            break;
                                                        }
                                                    }
                                                }
                                                if (plant && api.zoomToPlant) {
                                                    api.zoomToPlant(plant);
                                                }

                                                // Wait for zoom + modal/overlay to open
                                                demoTimers.push(setTimeout(function() {
                                                    var step = steps[currentStep];
                                                    if (!step) { done(); return; }

                                                    if (isFsMode) {
                                                        // Fullscreen: retarget to plant detail modal (no scroll)
                                                        cardTitle.textContent = step.retargetTitle || 'Plant Detail';
                                                        cardDesc.textContent = step.retargetDesc || step.desc;

                                                        // Ensure modal content is at the top
                                                        var modalContent = document.querySelector('#plantDetailModal .plant-detail-content');
                                                        if (modalContent) modalContent.scrollTop = 0;

                                                        spotlight.classList.add('retarget');
                                                        var newRect = getTargetRect('#plantDetailModal .plant-detail-dialog');
                                                        positionSpotlight(newRect);
                                                        positionCard(newRect, 'left');

                                                        demoTimers.push(setTimeout(function() {
                                                            spotlight.classList.remove('retarget');
                                                            done();
                                                        }, 800));
                                                    } else {
                                                        // Non-fullscreen: retarget to plant info overlay
                                                        cardTitle.textContent = step.retargetTitle || 'Plant Detail';
                                                        cardDesc.textContent = 'The plant info panel shows reactor status, capacity, and a list of all reactors at this site.';

                                                        spotlight.classList.add('retarget');
                                                        var piRect = getTargetRect('#plantInfoOverlay');
                                                        positionSpotlight(piRect);
                                                        positionCard(piRect, 'right');

                                                        demoTimers.push(setTimeout(function() {
                                                            spotlight.classList.remove('retarget');
                                                            done();
                                                        }, 800));
                                                    }
                                                }, 2500));
                                            });
                                        });
                                    }, 600));
                                }, 1000));
                            });
                        });
                    }, 1000));
                });
            },
            onLeave: function() {
                var api = window.__tourAPI || {};
                hideCursor();
                // Close plant detail modal and all overlays
                if (api.closePlantDetailModal) api.closePlantDetailModal();
                if (api.hidePlantInfoOverlay) api.hidePlantInfoOverlay();
                if (api.hideCountryInfoOverlay) api.hideCountryInfoOverlay();
                if (api.clearSearch) api.clearSearch();
                if (api.clearSearchHighlight) api.clearSearchHighlight();
                if (api.navClear) api.navClear();
                // Fly map back home
                if (api.goHome) api.goHome(1200);
            }
        },
        {
            // v5.7.122: Timeline with cursor, status bar highlight, updated text
            target: '#yearSliderPanel',
            title: 'Timeline',
            desc: 'The timeline slider controls which year\u2019s data is displayed on the map.',
            icon: icons.timeline,
            position: 'top',
            blockNext: true,
            onEnter: function(done) {
                var api = window.__tourAPI || {};
                var slider = document.getElementById('yearSlider');
                if (!slider || !api.updateMapForYear) { done(); return; }

                // v5.7.122: Highlight the status bar to show year connection
                var statusBar = document.getElementById('mapStatusBar');
                if (statusBar) statusBar.classList.add('tour-status-highlight');

                var MAX_YEAR = 2026;
                var TARGET_YEAR = 1975;
                var STEP_SIZE = 3;
                var TICK_MS = 120;
                var currentYear = MAX_YEAR;

                // Ensure we start at the latest year
                slider.value = MAX_YEAR;
                api.updateMapForYear(MAX_YEAR);

                // v5.7.122: Position cursor at the slider thumb
                var sliderRect = slider.getBoundingClientRect();
                var thumbX = sliderRect.right - 10;
                var thumbY = sliderRect.top + sliderRect.height / 2;
                moveCursorToXY(thumbX, thumbY, function() {
                    // After initial move completes, disable transition for smooth tracking
                    if (cursorEl) cursorEl.style.transition = 'opacity 0.3s ease';
                });

                // Helper to update cursor position along the slider track (no transition lag)
                function updateCursorOnSlider(year) {
                    var sRect = slider.getBoundingClientRect();
                    var pct = (year - parseInt(slider.min)) / (parseInt(slider.max) - parseInt(slider.min));
                    var cx = sRect.left + sRect.width * pct;
                    var cy = sRect.top + sRect.height / 2;
                    if (cursorEl) {
                        cursorEl.style.left = cx + 'px';
                        cursorEl.style.top = cy + 'px';
                    }
                }

                // Phase 1: Animate backward from 2026 to 1975
                demoTimers.push(setTimeout(function() {
                    var backwardInterval = setInterval(function() {
                        currentYear -= STEP_SIZE;
                        if (currentYear <= TARGET_YEAR) {
                            currentYear = TARGET_YEAR;
                            slider.value = currentYear;
                            api.updateMapForYear(currentYear);
                            updateCursorOnSlider(currentYear);
                            clearInterval(backwardInterval);

                            // Phase 2: Pause at 1975, then animate forward
                            demoTimers.push(setTimeout(function() {
                                var forwardInterval = setInterval(function() {
                                    currentYear += STEP_SIZE;
                                    if (currentYear >= MAX_YEAR) {
                                        currentYear = MAX_YEAR;
                                        slider.value = currentYear;
                                        api.updateMapForYear(currentYear);
                                        updateCursorOnSlider(currentYear);
                                        clearInterval(forwardInterval);

                                        demoTimers.push(setTimeout(function() {
                                            hideCursor();
                                            done();
                                        }, 500));
                                    } else {
                                        slider.value = currentYear;
                                        api.updateMapForYear(currentYear);
                                        updateCursorOnSlider(currentYear);
                                    }
                                }, TICK_MS);
                                demoTimers.push(forwardInterval);
                            }, 500));
                        } else {
                            slider.value = currentYear;
                            api.updateMapForYear(currentYear);
                            updateCursorOnSlider(currentYear);
                        }
                    }, TICK_MS);
                    demoTimers.push(backwardInterval);
                }, 500));
            },
            onLeave: function() {
                var api = window.__tourAPI || {};
                hideCursor();
                // Remove status bar highlight
                var statusBar = document.getElementById('mapStatusBar');
                if (statusBar) statusBar.classList.remove('tour-status-highlight');
                // Reset year slider to current year
                var slider = document.getElementById('yearSlider');
                if (slider) slider.value = 2026;
                if (api.updateMapForYear) api.updateMapForYear(2026);
            }
        },
        {
            // v5.7.123: Global Statistics step (fullscreen only); v5.7.124: moved before Filters & Settings
            target: '#timelineChartsSidebar',
            title: 'Global Statistics',
            desc: 'The statistics panel shows global nuclear electricity generation, reactor fleet size, construction starts, and annual reactor deployment.',
            icon: icons.stats,
            position: 'left',
            skipIf: function() { return !isFullscreen(); },
            onEnter: function(done) {
                // Ensure stats sidebar is visible (un-collapse if collapsed)
                var wrapper = document.getElementById('map-wrapper');
                if (wrapper && wrapper.classList.contains('fs-stats-collapsed')) {
                    var expandBtn = document.getElementById('fsStatsExpandBtn');
                    if (expandBtn) expandBtn.click();
                    demoTimers.push(setTimeout(function() { done(); }, 300));
                } else {
                    done();
                }
            }
        },
        {
            // v5.7.149: Explore Charts - Step 1: Highlight and click expand button (fullscreen only)
            target: '.timeline-chart-panel[data-chart="gridConnections"] .timeline-chart-expand',
            title: 'Explore Charts',
            desc: 'Each chart can be expanded for a detailed view.',
            icon: icons.stats,
            position: 'left',
            blockNext: true,
            skipIf: function() { return !isFullscreen(); },
            onEnter: function(done) {
                var api = window.__tourAPI || {};
                // Close chart if already open (handles Prev navigation)
                if (api.closeExpandedChart) api.closeExpandedChart();
                var tt = document.getElementById('expandedChartTooltip');
                if (tt) { tt.classList.remove('pinned'); tt.style.zIndex = ''; }

                var expandBtn = document.querySelector('.timeline-chart-panel[data-chart="gridConnections"] .timeline-chart-expand');
                if (!expandBtn) { done(); return; }

                moveCursorTo(expandBtn, function() {
                    cursorClick(function() {
                        if (api.openExpandedChart) api.openExpandedChart('gridConnections');
                        hideCursor();
                        done();
                    });
                });
            },
            onLeave: function(nextIndex) {
                hideCursor();
                // Going backward — close chart so previous step works cleanly
                if (typeof nextIndex === 'number' && nextIndex < currentStep) {
                    var api = window.__tourAPI || {};
                    if (api.closeExpandedChart) api.closeExpandedChart();
                }
            }
        },
        {
            // v5.7.149: Explore Charts - Step 2: Hover bar to show tooltip (fullscreen only)
            target: '#expandedChartModal .expanded-chart-dialog',
            title: 'Chart Details',
            desc: 'In detailed view, hovering over a year reveals individual reactor details.',
            icon: icons.stats,
            position: 'left',
            blockNext: true,
            skipIf: function() { return !isFullscreen(); },
            onEnter: function(done) {
                var api = window.__tourAPI || {};
                // Ensure chart is open (handles Prev navigation from step 3)
                var modal = document.getElementById('expandedChartModal');
                var chartOpen = modal && modal.classList.contains('open');
                if (!chartOpen && api.openExpandedChart) {
                    api.openExpandedChart('gridConnections');
                }
                var delay = chartOpen ? 100 : 2000;
                demoTimers.push(setTimeout(function() {
                    var customContainer = document.getElementById('expandedChartCustom');
                    var bar = null;
                    var tryYears = [1985, 1984, 1986, 1983, 1987];
                    for (var y = 0; y < tryYears.length; y++) {
                        bar = customContainer ? customContainer.querySelector('.reactor-deploy-bar.connections[data-year="' + tryYears[y] + '"]') : null;
                        if (bar) break;
                    }
                    if (!bar) { done(); return; }
                    var barRect = bar.getBoundingClientRect();
                    var cx = barRect.left + barRect.width / 2;
                    var cy = barRect.top + barRect.height / 2;
                    moveCursorTo(bar, function() {
                        bar.dispatchEvent(new MouseEvent('mouseenter', {
                            clientX: cx, clientY: cy, bubbles: true
                        }));
                        var tooltip = document.getElementById('expandedChartTooltip');
                        if (tooltip) {
                            tooltip.classList.add('pinned');
                            tooltip.style.zIndex = '10001';
                        }
                        hideCursor();
                        done();
                    });
                }, delay));
            },
            onLeave: function(nextIndex) {
                hideCursor();
                // Reset tooltip state
                var tooltip = document.getElementById('expandedChartTooltip');
                if (tooltip) { tooltip.classList.remove('pinned'); tooltip.style.zIndex = ''; }
                // Going backward — tooltip reset only, chart stays open for expanded chart step
                if (typeof nextIndex === 'number' && nextIndex < currentStep) {
                    return;
                }
                // Going forward — full cleanup
                var api = window.__tourAPI || {};
                if (api.closeExpandedChart) api.closeExpandedChart();
            }
        },
        {
            // v5.7.124: Moved to last position in fullscreen tour (after Global Statistics)
            target: '.map-side-rail',
            title: 'Filters & Settings',
            desc: 'Use these buttons to filter plants by status or size, change display options, and switch between map and globe views.',
            icon: icons.filter,
            position: 'right'
        },
        {
            target: '.map-controls-group',
            title: 'Fullscreen Mode',
            desc: 'Use these buttons to return to home, share current view, enter/exit fullscreen and to find more information.',
            icon: icons.fullscreen,
            position: 'left',
            skipIf: function() { return isFullscreen(); }
        },
        {
            target: '#railTourBtn',
            title: 'Revisit This Tour',
            desc: 'You can view this tour again at any time by clicking the this icon.',
            icon: icons.info,
            position: 'right',
            skipIf: function() { return !isFullscreen(); }
        }
    ];

    // Demo timer tracking for cleanup
    var demoTimers = [];
    // v5.7.123: Override target for scroll/resize handlers during interactive demos
    var demoTargetOverride = null;
    // v5.7.148: Saved filter/year state for restore on tour end
    var savedFilterState = null;

    // Mobile tour steps (different elements and positions)
    const mobileSteps = [
        {
            target: '.map-legend',
            title: 'Map Legend',
            desc: 'Tap on the legend to understand plant status colors: green = operable, yellow = under construction, grey = shutdown.',
            icon: icons.legend,
            position: 'top'
        },
        {
            target: '#mobileFilterBtn',
            title: 'Filters',
            desc: 'Tap here to filter plants by status (operable, under construction, shutdown) or by capacity size.',
            icon: icons.filter,
            position: 'top'
        },
        {
            target: '#mobileYearIndicator',
            title: 'Timeline',
            desc: 'This shows the current year. Tap to open the timeline and explore nuclear power history from 1954 to today.',
            icon: icons.timeline,
            position: 'top'
        }
    ];

    const steps = isMobile ? mobileSteps : desktopSteps;
    let currentStep = 0;
    let isActive = false;

    // DOM elements
    const overlay = document.getElementById('tourOverlay');
    const backdrop = document.getElementById('tourBackdrop');
    const spotlight = document.getElementById('tourSpotlight');
    const card = document.getElementById('tourCard');
    const cardIcon = document.getElementById('tourCardIcon');
    const cardStep = document.getElementById('tourCardStep');
    const cardTitle = document.getElementById('tourCardTitle');
    const cardDesc = document.getElementById('tourCardDesc');
    const nextBtn = document.getElementById('tourNextBtn');
    const skipBtn = document.getElementById('tourSkipBtn');
    const progress = document.getElementById('tourProgress');
    const welcomeModal = document.getElementById('tourWelcomeModal');
    const startBtn = document.getElementById('tourStartBtn');
    const skipWelcomeBtn = document.getElementById('tourSkipWelcomeBtn');
    const triggerBtn = document.getElementById('tourTriggerBtn');

    if (!overlay || !welcomeModal || !triggerBtn) return;

    // --- Tour Cursor Helpers (v5.7.122) ---
    var cursorEl = document.getElementById('tourCursor');
    function showCursor() {
        if (cursorEl) cursorEl.classList.add('visible');
    }
    function hideCursor() {
        if (cursorEl) {
            cursorEl.classList.remove('visible');
            cursorEl.classList.remove('clicking');
            // Restore default transition for next use
            cursorEl.style.transition = '';
        }
        // Remove any lingering ripple elements
        var ripples = document.querySelectorAll('.tour-click-ripple');
        for (var i = 0; i < ripples.length; i++) ripples[i].remove();
    }
    function moveCursorTo(el, callback) {
        if (!cursorEl || !el) { if (callback) callback(); return; }
        var rect = el.getBoundingClientRect();
        // Position cursor tip at the center of the element
        cursorEl.style.left = (rect.left + rect.width / 2) + 'px';
        cursorEl.style.top = (rect.top + rect.height / 2) + 'px';
        showCursor();
        // Wait for transition to complete
        var tid = setTimeout(function() { if (callback) callback(); }, 650);
        demoTimers.push(tid);
    }
    function moveCursorToXY(x, y, callback) {
        if (!cursorEl) { if (callback) callback(); return; }
        cursorEl.style.left = x + 'px';
        cursorEl.style.top = y + 'px';
        showCursor();
        var tid = setTimeout(function() { if (callback) callback(); }, 650);
        demoTimers.push(tid);
    }
    function cursorClick(callback) {
        if (!cursorEl) { if (callback) callback(); return; }
        cursorEl.classList.add('clicking');
        // Create ripple at cursor tip position
        var ripple = document.createElement('div');
        ripple.className = 'tour-click-ripple';
        ripple.style.left = cursorEl.style.left;
        ripple.style.top = cursorEl.style.top;
        document.body.appendChild(ripple);
        var tid1 = setTimeout(function() {
            cursorEl.classList.remove('clicking');
        }, 300);
        var tid2 = setTimeout(function() {
            ripple.remove();
            if (callback) callback();
        }, 500);
        demoTimers.push(tid1);
        demoTimers.push(tid2);
    }

    // v5.7.123: Poll until an element has a given class, then invoke callback
    function pollForVisible(selector, className, callback, maxAttempts) {
        var count = 0;
        var max = maxAttempts || 30; // 30 * 100ms = 3s max wait
        var id = setInterval(function() {
            count++;
            var el = document.querySelector(selector);
            if ((el && el.classList.contains(className)) || count >= max) {
                clearInterval(id);
                var tid = setTimeout(function() { if (callback) callback(); }, 100);
                demoTimers.push(tid);
            }
        }, 100);
        demoTimers.push(id);
    }

    // --- Tour Info Panel Management ---
    // Close all info panels/overlays when tour starts to prevent display issues
    function closeAllInfoPanels() {
        // Close desktop country info overlay
        const countryInfoOverlay = document.getElementById('countryInfoOverlay');
        const countryInfoBox = document.getElementById('countryInfoBox');
        if (countryInfoOverlay) countryInfoOverlay.style.display = 'none';
        if (countryInfoBox) countryInfoBox.classList.remove('visible');

        // Close desktop plant info overlay
        const plantInfoOverlay = document.getElementById('plantInfoOverlay');
        const plantInfoBox = document.getElementById('plantInfoBox');
        if (plantInfoOverlay) plantInfoOverlay.style.display = 'none';
        if (plantInfoBox) plantInfoBox.classList.remove('visible');

        // Close plant detail modal (fullscreen)
        const plantDetailModal = document.getElementById('plantDetailModal');
        if (plantDetailModal && plantDetailModal.classList.contains('open')) {
            plantDetailModal.classList.remove('open');
            plantDetailModal.setAttribute('aria-hidden', 'true');
        }

        // Close mobile country panel
        const countryPanel = document.getElementById('countryPanel');
        if (countryPanel) {
            countryPanel.classList.remove('open');
            countryPanel.classList.remove('expanded');
            countryPanel.classList.remove('collapsed'); // v5.7.172
        }

        // Close mobile plant panel (use window function if available)
        if (typeof window.closePlantPanel === 'function') {
            window.closePlantPanel();
        } else {
            const plantPanel = document.getElementById('plantPanel');
            if (plantPanel) {
                plantPanel.classList.remove('open');
                plantPanel.classList.remove('expanded');
                plantPanel.classList.remove('collapsed'); // v5.7.172
            }
        }

        // Close mobile filter panel
        if (typeof window.closeFilterPanel === 'function') {
            window.closeFilterPanel();
        } else {
            const filterPanel = document.getElementById('filterPanel');
            if (filterPanel) {
                filterPanel.classList.remove('open');
                filterPanel.classList.remove('expanded');
                filterPanel.classList.remove('collapsed'); // v5.7.172
            }
        }

        // Close desktop rail drawers (filters, settings, view mode, theme)
        if (typeof window.closeMapRailDrawers === 'function') {
            window.closeMapRailDrawers();
        }

        // Show the desktop search overlay (which was hidden by info overlays)
        const desktopSearchOverlay = document.getElementById('desktopSearchOverlay');
        if (desktopSearchOverlay) desktopSearchOverlay.style.display = '';
    }

    // Show welcome modal for first-time visitors
    function showWelcome() {
        // Close any open info panels before showing the tour
        closeAllInfoPanels();
        overlay.classList.add('active');
        welcomeModal.classList.add('visible');
    }

    function hideWelcome() {
        welcomeModal.classList.remove('visible');
        overlay.classList.remove('active');
    }

    // Calculate position for spotlight and card
    function getTargetRect(selector) {
        const el = document.querySelector(selector);
        if (!el) return null;
        const rect = el.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            bottom: rect.bottom,
            right: rect.right
        };
    }

    // Position the spotlight around target element
    function positionSpotlight(rect) {
        if (!rect) {
            spotlight.style.display = 'none';
            return;
        }
        const padding = 8;
        spotlight.style.display = 'block';
        spotlight.style.top = (rect.top - padding) + 'px';
        spotlight.style.left = (rect.left - padding) + 'px';
        spotlight.style.width = (rect.width + padding * 2) + 'px';
        spotlight.style.height = (rect.height + padding * 2) + 'px';
    }

    // Position the card near the target
    function positionCard(rect, position) {
        card.classList.remove('visible');

        setTimeout(() => {
            const cardRect = card.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const margin = 16;

            let top, left;

            if (isMobile) {
                // On mobile, card is fixed at bottom
                card.style.top = 'auto';
                card.style.left = '0';
                card.style.right = '0';
            } else if (rect) {
                switch (position) {
                    case 'right':
                        top = rect.top;
                        left = rect.right + margin;
                        if (left + cardRect.width > viewportWidth - margin) {
                            left = rect.left - cardRect.width - margin;
                        }
                        break;
                    case 'left':
                        top = rect.top;
                        left = rect.left - cardRect.width - margin;
                        if (left < margin) {
                            left = rect.right + margin;
                        }
                        break;
                    case 'top':
                        top = rect.top - cardRect.height - margin;
                        left = rect.left + (rect.width - cardRect.width) / 2;
                        if (top < margin) {
                            top = rect.bottom + margin;
                        }
                        break;
                    case 'bottom':
                    default:
                        top = rect.bottom + margin;
                        left = rect.left + (rect.width - cardRect.width) / 2;
                        if (top + cardRect.height > viewportHeight - margin) {
                            top = rect.top - cardRect.height - margin;
                        }
                        break;
                }

                // Keep within viewport
                left = Math.max(margin, Math.min(left, viewportWidth - cardRect.width - margin));
                top = Math.max(margin, Math.min(top, viewportHeight - cardRect.height - margin));

                card.style.top = top + 'px';
                card.style.left = left + 'px';
            }

            card.classList.add('visible');
        }, 50);
    }

    // Update progress dots (v5.7.121: uses effective steps, dot pop animation)
    var prevProgressStep = -1;
    function updateProgress() {
        var effective = getEffectiveSteps();
        progress.innerHTML = effective.map((_, i) => {
            let className = 'tour-progress-dot';
            if (i < currentStep) {
                className += ' completed';
                // Add pop animation for the dot that just completed
                if (i === currentStep - 1 && prevProgressStep < currentStep) {
                    className += ' just-completed';
                }
            }
            else if (i === currentStep) className += ' active';
            return '<div class="' + className + '"></div>';
        }).join('');
        prevProgressStep = currentStep;
    }

    // Helper: clear all demo timers (v5.7.123: also cleanup cursor + target override)
    function clearDemoTimers() {
        demoTimers.forEach(function(id) { clearTimeout(id); clearInterval(id); });
        demoTimers.length = 0;
        demoTargetOverride = null;
        hideCursor();
    }

    // Helper: resolve dynamic step properties (target, desc, position can be functions)
    function resolveStepProp(val) {
        return typeof val === 'function' ? val() : val;
    }

    // Track whether Next is currently blocked
    var nextBlocked = false;
    function setNextBlocked(blocked) {
        nextBlocked = blocked;
        if (blocked) {
            nextBtn.classList.add('tour-btn-blocked');
        } else {
            nextBtn.classList.remove('tour-btn-blocked');
        }
    }

    // Compute effective step list (filter out skipped steps)
    function getEffectiveSteps() {
        return steps.filter(function(s) { return !(s.skipIf && s.skipIf()); });
    }

    // Show current step (v5.7.121: lifecycle hooks, dynamic targets, blockNext; v5.7.124: pass target index to onLeave)
    function showStep(index) {
        var effective = getEffectiveSteps();
        if (index < 0 || index >= effective.length) return;

        // Call onLeave for previous step (v5.7.124: pass target index for directional cleanup)
        var prevStep = currentStep >= 0 && currentStep < effective.length ? effective[currentStep] : null;
        if (prevStep && prevStep.onLeave) {
            prevStep.onLeave(index);
        }
        // Clear demo timers from previous step
        clearDemoTimers();

        currentStep = index;
        var step = effective[index];
        var targetSelector = resolveStepProp(step.target);
        var rect = getTargetRect(targetSelector);
        var desc = resolveStepProp(step.desc);
        var position = resolveStepProp(step.position);

        // Update card content
        cardIcon.innerHTML = step.icon;
        cardStep.textContent = 'Step ' + (index + 1) + ' of ' + effective.length;
        cardTitle.textContent = step.title;
        cardDesc.textContent = desc;

        // Update buttons
        nextBtn.textContent = index === effective.length - 1 ? 'Finish' : 'Next';

        // Block next if step requires it
        if (step.blockNext) {
            setNextBlocked(true);
        } else {
            setNextBlocked(false);
        }

        // Position elements
        positionSpotlight(rect);
        positionCard(rect, position);
        updateProgress();

        // Add step entrance animation
        card.classList.remove('step-enter');
        void card.offsetWidth; // force reflow
        card.classList.add('step-enter');

        // Scroll target into view if needed
        if (rect && !isMobile) {
            var el = document.querySelector(targetSelector);
            if (el && (rect.top < 0 || rect.bottom > window.innerHeight)) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                setTimeout(function() {
                    var newRect = getTargetRect(targetSelector);
                    positionSpotlight(newRect);
                    positionCard(newRect, position);
                }, 300);
            }
        }

        // Call onEnter lifecycle hook
        if (step.onEnter) {
            step.onEnter(function() {
                // done() callback - unblock Next button
                setNextBlocked(false);
            });
        }
    }

    // Start the tour (v5.7.121: reset map to home view for consistent demo)
    function startTour() {
        // Close any open info panels to prevent display issues with tour spotlight
        closeAllInfoPanels();
        hideWelcome();

        // Reset map to home view so the search demo starts from a known state
        var api = window.__tourAPI || {};
        // v5.7.148: Save current filter/year state, reset to clean defaults for demo
        if (api.getFilterState) savedFilterState = api.getFilterState();
        if (api.setFilterState) api.setFilterState({
            showOperable: false, showConstruction: false,
            showPlanned: false, showShutdown: false,
            capacityMin: 0, capacityMax: 10,
            productionMin: 0, productionMax: 50, // v5.7.150
            year: 2026
        });
        if (api.goHome) api.goHome(0);

        isActive = true;
        currentStep = -1; // Will be set by showStep
        overlay.classList.add('active');
        showStep(0);
    }

    // End the tour (v5.7.122: cleanup cursor + status bar highlight)
    function endTour(completed) {
        // Call onLeave for current step
        var effective = getEffectiveSteps();
        var step = currentStep >= 0 && currentStep < effective.length ? effective[currentStep] : null;
        if (step && step.onLeave) {
            step.onLeave();
        }

        // Clear all demo timers
        clearDemoTimers();

        // Reset blocked state
        setNextBlocked(false);

        // v5.7.122: Clean up cursor and status bar highlight
        hideCursor();
        var statusBar = document.getElementById('mapStatusBar');
        if (statusBar) statusBar.classList.remove('tour-status-highlight');

        // Clean up any residual demo state
        var api = window.__tourAPI || {};
        var input = document.getElementById('searchInput');
        if (input) input.classList.remove('tour-typing-cursor');
        // v5.7.149: Close expanded chart and reset tooltip if tour abandoned mid-demo
        if (api.closeExpandedChart) api.closeExpandedChart();
        var tooltip = document.getElementById('expandedChartTooltip');
        if (tooltip) { tooltip.classList.remove('pinned'); tooltip.style.zIndex = ''; }
        if (api.closePlantDetailModal) api.closePlantDetailModal();
        if (api.hideCountryInfoOverlay) api.hideCountryInfoOverlay();
        if (api.hidePlantInfoOverlay) api.hidePlantInfoOverlay();
        if (api.clearSearch) api.clearSearch();
        if (api.clearSearchHighlight) api.clearSearchHighlight();
        if (api.navClear) api.navClear();
        // v5.7.148: Restore pre-tour filter/year state
        if (savedFilterState && api.setFilterState) {
            api.setFilterState(savedFilterState);
            savedFilterState = null;
        } else {
            var slider = document.getElementById('yearSlider');
            if (slider) slider.value = 2026;
            if (api.updateMapForYear) api.updateMapForYear(2026);
        }

        isActive = false;
        card.classList.remove('visible');
        card.classList.remove('step-enter');
        overlay.classList.remove('active');
        spotlight.style.display = 'none';
        spotlight.classList.remove('retarget');

        if (completed) {
            localStorage.setItem(TOUR_STORAGE_KEY, 'true');
        }
    }

    // Event listeners
    startBtn.addEventListener('click', startTour);
    skipWelcomeBtn.addEventListener('click', () => {
        hideWelcome();
        localStorage.setItem(TOUR_STORAGE_KEY, 'true');
    });

    triggerBtn.addEventListener('click', () => {
        if (isActive) return;
        startTour();
    });

    // Rail tour button now handled by initMapRailDrawers - opens tour drawer panel
    // Tour drawer panel buttons
    const tourDrawerStartBtn = document.getElementById('tourDrawerStartBtn');
    const tourDrawerSkipBtn = document.getElementById('tourDrawerSkipBtn');

    if (tourDrawerStartBtn) {
        tourDrawerStartBtn.addEventListener('click', () => {
            // Close the drawer panel first
            if (window.closeMapRailDrawers) window.closeMapRailDrawers();
            // Then start the tour
            startTour();
        });
    }

    if (tourDrawerSkipBtn) {
        tourDrawerSkipBtn.addEventListener('click', () => {
            // Close the drawer panel
            if (window.closeMapRailDrawers) window.closeMapRailDrawers();
            // Mark tour as completed so it doesn't auto-popup
            localStorage.setItem(TOUR_STORAGE_KEY, 'true');
        });
    }

    nextBtn.addEventListener('click', () => {
        if (nextBlocked) return; // Blocked until onEnter calls done()
        var effective = getEffectiveSteps();
        if (currentStep < effective.length - 1) {
            showStep(currentStep + 1);
        } else {
            endTour(true);
        }
    });

    skipBtn.addEventListener('click', () => endTour(false));

    backdrop.addEventListener('click', () => {
        if (welcomeModal.classList.contains('visible') && !isActive) {
            hideWelcome();
        }
        // Backdrop clicks during active tour are intentionally ignored.
        // Users exit via Skip button or Escape key.
    });

    // Handle keyboard navigation (v5.7.121: respects blockNext)
    document.addEventListener('keydown', (e) => {
        if (!isActive) return;
        if (e.key === 'Escape') { endTour(false); return; }
        if (nextBlocked) return; // Block keyboard nav during interactive steps
        var effective = getEffectiveSteps();
        if (e.key === 'ArrowRight' || e.key === 'Enter') {
            if (currentStep < effective.length - 1) showStep(currentStep + 1);
            else endTour(true);
        }
        if (e.key === 'ArrowLeft' && currentStep > 0) {
            showStep(currentStep - 1);
        }
    });

    // Reposition on resize (v5.7.123: supports demoTargetOverride)
    let resizeTimeout;
    window.addEventListener('resize', () => {
        if (!isActive) return;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            var effective = getEffectiveSteps();
            var step = effective[currentStep];
            if (!step) return;
            var targetSelector = demoTargetOverride || resolveStepProp(step.target);
            var position = resolveStepProp(step.position);
            var rect = getTargetRect(targetSelector);
            positionSpotlight(rect);
            positionCard(rect, position);
        }, 100);
    });

    // Reposition on scroll (v5.7.123: supports demoTargetOverride)
    let scrollTimeout;
    function handleTourScroll() {
        if (!isActive) return;
        // Check if we're in fullscreen mode - if so, no need to reposition on scroll
        const mapWrapper = document.getElementById('map-wrapper');
        if (mapWrapper && mapWrapper.classList.contains('fullscreen')) return;

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            var effective = getEffectiveSteps();
            var step = effective[currentStep];
            if (!step) return;
            var targetSelector = demoTargetOverride || resolveStepProp(step.target);
            var position = resolveStepProp(step.position);
            var rect = getTargetRect(targetSelector);
            positionSpotlight(rect);
            positionCard(rect, position);
        }, 16); // ~60fps for smooth tracking
    }
    // Use capture phase to catch scroll events on any element
    window.addEventListener('scroll', handleTourScroll, true);

    // Auto-popup disabled - tour is accessed via rail button in fullscreen
})();

})();
} // end __runMainInit (v5.7.156)
}, { once: true });
</script>
</body>
</html>
